

// import React, { useState, useEffect, useCallback } from 'react';
// import { createPortal } from 'react-dom';
// import api from '../services/api';
// import UploadField from '../components/UploadField';
// import SignaturePad from '../components/SignaturePad';
// import NotificationToast from '../components/NotificationToast';
// import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
// import { genesisPolicies } from '../constants/genesisPolicies';
// import { genesisPoliciesText } from '../constants/genesisPoliciesText';
// import Loader from '../components/Loader';

// // Helper to convert base64 (including data URIs) to a Uint8Array safely
// const base64ToUint8Array = (base64Str) => {
//   if (!base64Str || typeof base64Str !== 'string') return new Uint8Array(0);
//   try {
//     const commaIdx = base64Str.indexOf(',');
//     let clean = commaIdx !== -1 ? base64Str.substring(commaIdx + 1) : base64Str;
//     clean = clean.replace(/\s/g, '');

//     // Normalize URL-safe base64
//     clean = clean.replace(/-/g, '+').replace(/_/g, '/');

//     // Fix padding if needed
//     const mod = clean.length % 4;
//     if (mod === 2) {
//       clean += '==';
//     } else if (mod === 3) {
//       clean += '=';
//     }

//     const bin = atob(clean);
//     const len = bin.length;
//     const bytes = new Uint8Array(len);
//     for (let i = 0; i < len; i++) {
//       bytes[i] = bin.charCodeAt(i);
//     }
//     return bytes;
//   } catch (e) {
//     console.error("base64ToUint8Array decoding failed:", e);
//     return new Uint8Array(0);
//   }
// };

// // Helper to convert base64 to Blob URL
// const base64ToBlobUrl = (base64Data) => {
//   try {
//     if (!base64Data) return '';
//     const arr = base64ToUint8Array(base64Data);
//     if (arr.length === 0) return '';
//     const blob = new Blob([arr], { type: 'application/pdf' });
//     return URL.createObjectURL(blob);
//   } catch (err) {
//     console.error('Failed to convert base64 to Blob URL:', err);
//     return '';
//   }
// };

// // Helper to fetch local or remote PDF file and convert to base64
// const fetchLocalPdfAsBase64 = async (url) => {
//   if (!url) return '';
//   if (url.startsWith('data:application/pdf;base64,')) {
//     return url.replace('data:application/pdf;base64,', '');
//   }
//   if (url.startsWith('data:')) {
//     const commaIdx = url.indexOf(',');
//     if (commaIdx !== -1) return url.substring(commaIdx + 1);
//   }

//   const bufferToBase64 = (arrayBuffer) => {
//     let binary = '';
//     const bytes = new Uint8Array(arrayBuffer);
//     const len = bytes.byteLength;
//     const chunkSize = 8192;
//     for (let i = 0; i < len; i += chunkSize) {
//       const chunk = bytes.subarray(i, i + chunkSize);
//       binary += String.fromCharCode.apply(null, chunk);
//     }
//     return btoa(binary);
//   };

//   // 1. Direct fetch with CORS mode
//   try {
//     const response = await fetch(url, { mode: 'cors' });
//     if (response.ok) {
//       const arrayBuffer = await response.arrayBuffer();
//       if (arrayBuffer.byteLength > 0) {
//         return bufferToBase64(arrayBuffer);
//       }
//     }
//   } catch (directErr) {
//     console.warn("Direct PDF fetch failed for:", url, directErr);
//   }

//   // 2. Direct fetch default fallback
//   try {
//     const response = await fetch(url);
//     if (response.ok) {
//       const arrayBuffer = await response.arrayBuffer();
//       if (arrayBuffer.byteLength > 0) {
//         return bufferToBase64(arrayBuffer);
//       }
//     }
//   } catch (directErr2) {
//     console.warn("Direct fetch fallback failed:", directErr2);
//   }

//   // If local or blob URL, proxy won't work
//   if (url.startsWith('blob:') || url.startsWith('/') || url.includes('localhost')) {
//     return '';
//   }

//   // 3. CORS Proxies for remote host files (fast with 2s timeout per proxy)
//   const proxies = [
//     (u) => `https://api.allorigins.win/raw?url=${encodeURIComponent(u)}`,
//     (u) => `https://corsproxy.io/?${encodeURIComponent(u)}`,
//     (u) => `https://thingproxy.freeboard.io/fetch/${u}`,
//     (u) => `https://api.codetabs.com/v1/proxy?quest=${encodeURIComponent(u)}`
//   ];

//   for (const getProxyUrl of proxies) {
//     const controller = new AbortController();
//     const timeoutId = setTimeout(() => controller.abort(), 2500);
//     try {
//       const proxyUrl = getProxyUrl(url);
//       const res = await fetch(proxyUrl, { signal: controller.signal });
//       clearTimeout(timeoutId);
//       if (res.ok) {
//         const arrayBuffer = await res.arrayBuffer();
//         if (arrayBuffer.byteLength > 0) {
//           return bufferToBase64(arrayBuffer);
//         }
//       }
//     } catch (e) {
//       clearTimeout(timeoutId);
//       console.warn("Proxy attempt failed:", e);
//     }
//   }

//   return '';
// };

// // Helper to convert typed signature into a transparent PNG data URL on the fly
// const convertTypedToPng = (typedName) => {
//   const canvas = document.createElement('canvas');
//   canvas.width = 400;
//   canvas.height = 150;
//   const ctx = canvas.getContext('2d');

//   // Clear canvas
//   ctx.clearRect(0, 0, canvas.width, canvas.height);

//   // Font style matches type signature style in SignaturePad
//   ctx.font = 'italic 40px "Outfit", "Brush Script MT", cursive, sans-serif';
//   ctx.fillStyle = '#0f172a'; // dark slate/primary color
//   ctx.textAlign = 'center';
//   ctx.textBaseline = 'middle';

//   // Draw the text
//   ctx.fillText(typedName, canvas.width / 2, canvas.height / 2);

//   return canvas.toDataURL('image/png');
// };

// // Helper to draw signature PNG on the last page of a PDF
// const generateAgreementPdfData = async (templateBytes, formValues, signaturePng) => {
//   if (!templateBytes) return '';
//   const pdfDoc = await PDFDocument.load(templateBytes);
//   const pages = pdfDoc.getPages();
//   const firstPage = pages[0];

//   const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//   const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//   const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

//   // Draw values on Page 1
//   const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//   const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();
//   firstPage.drawText(dateStr, {
//     x: 320,
//     y: 695.86,
//     size: 10,
//     font: boldFont,
//     color: rgb(0, 0, 0)
//   });

//   if (formValues.employeeName) {
//     firstPage.drawText(formValues.employeeName, {
//       x: 120,
//       y: 671.50,
//       size: 10,
//       font: boldFont,
//       color: rgb(0, 0, 0)
//     });
//   }

//   if (formValues.position) {
//     firstPage.drawText(formValues.position, {
//       x: 85,
//       y: 598.06,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });
//   }

//   if (formValues.department) {
//     firstPage.drawText(formValues.department, {
//       x: 100,
//       y: 573.79,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });
//   }

//   if (formValues.primaryLocation) {
//     firstPage.drawText(formValues.primaryLocation, {
//       x: 145,
//       y: 549.43,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });
//   }

//   const drawTick = (x, y) => {
//     firstPage.drawText('\u2714', {
//       x: x + 1,
//       y: y + 1,
//       size: 10,
//       font: dingbatsFont,
//       color: rgb(0, 0, 0)
//     });
//   };

//   if (formValues.employmentClassification === 'Full-Time') {
//     drawTick(45, 511.51);
//   } else if (formValues.employmentClassification === 'Part-Time') {
//     drawTick(45, 498.07);
//   } else if (formValues.employmentClassification === 'Exempt') {
//     drawTick(45, 484.63);
//   } else if (formValues.employmentClassification === 'Non-Exempt') {
//     drawTick(45, 471.07);
//   }

//   // Draw signature block on Page 5
//   const page5 = pages[4];
//   if (page5) {
//     if (formValues.employeeName) {
//       page5.drawText(formValues.employeeName, {
//         x: 120,
//         y: 573.91,
//         size: 10,
//         font: boldFont,
//         color: rgb(0, 0, 0)
//       });
//     }

//     page5.drawText(dateStr, {
//       x: 70,
//       y: 525.07,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });

//     page5.drawText(dateStr, {
//       x: 70,
//       y: 368.69,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });

//     if (signaturePng) {
//       try {
//         const signatureBytes = base64ToUint8Array(signaturePng);
//         if (signatureBytes.length > 0) {
//           const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//           const signatureImage = isJpg
//             ? await pdfDoc.embedJpg(signatureBytes)
//             : await pdfDoc.embedPng(signatureBytes);

//           page5.drawImage(signatureImage, {
//             x: 90,
//             y: 539,
//             width: 120,
//             height: 30,
//           });

//           // Draw signature and audit text on every page in the empty space
//           const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//           pages.forEach((page) => {
//             page.drawImage(signatureImage, {
//               x: 310,
//               y: 30,
//               width: 85,
//               height: 25,
//             });
//             page.drawText(auditText, {
//               x: 310,
//               y: 25,
//               size: 6,
//               font: textFont,
//               color: rgb(0.3, 0.4, 0.5),
//             });
//           });
//         }
//       } catch (e) {
//         console.error('Error embedding signature in final PDF data:', e);
//       }
//     }
//   }

//   const pdfBytes = await pdfDoc.save();
//   let binary = '';
//   const bytes = new Uint8Array(pdfBytes);
//   const len = bytes.byteLength;
//   for (let i = 0; i < len; i++) {
//     binary += String.fromCharCode(bytes[i]);
//   }
//   return btoa(binary);
// };

// const generateNdaPdfData = async (templateBytes, formValues, signaturePng) => {
//   if (!templateBytes) return '';
//   const pdfDoc = await PDFDocument.load(templateBytes);
//   const pages = pdfDoc.getPages();
//   const firstPage = pages[0];

//   const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//   const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//   // Draw values on Page 1
//   const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//   const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();

//   if (formValues.employeeName) {
//     firstPage.drawText(formValues.employeeName, {
//       x: 120,
//       y: 636.10,
//       size: 10,
//       font: boldFont,
//       color: rgb(0, 0, 0)
//     });
//   }

//   if (formValues.position) {
//     firstPage.drawText(formValues.position, {
//       x: 90,
//       y: 622.18,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });
//   }

//   firstPage.drawText(dateStr, {
//     x: 110,
//     y: 608.02,
//     size: 10,
//     font: textFont,
//     color: rgb(0, 0, 0)
//   });

//   // Draw signature block on Page 5
//   const page5 = pages[4];
//   if (page5) {
//     if (formValues.employeeName) {
//       page5.drawText(formValues.employeeName, {
//         x: 120,
//         y: 622.18,
//         size: 10,
//         font: boldFont,
//         color: rgb(0, 0, 0)
//       });
//     }

//     page5.drawText(dateStr, {
//       x: 70,
//       y: 608.14,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });

//     page5.drawText(dateStr, {
//       x: 70,
//       y: 473.47,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });

//     if (signaturePng) {
//       try {
//         const signatureBytes = base64ToUint8Array(signaturePng);
//         if (signatureBytes.length > 0) {
//           const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//           const signatureImage = isJpg
//             ? await pdfDoc.embedJpg(signatureBytes)
//             : await pdfDoc.embedPng(signatureBytes);

//           page5.drawImage(signatureImage, {
//             x: 90,
//             y: 644,
//             width: 120,
//             height: 30,
//           });

//           // Draw signature and audit text on every page in the empty space
//           const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//           pages.forEach((page) => {
//             page.drawImage(signatureImage, {
//               x: 310,
//               y: 30,
//               width: 85,
//               height: 25,
//             });
//             page.drawText(auditText, {
//               x: 310,
//               y: 25,
//               size: 6,
//               font: textFont,
//               color: rgb(0.3, 0.4, 0.5),
//             });
//           });
//         }
//       } catch (e) {
//         console.error('Error embedding signature in final NDA PDF data:', e);
//       }
//     }
//   }

//   const pdfBytes = await pdfDoc.save();
//   let binary = '';
//   const bytes = new Uint8Array(pdfBytes);
//   const len = bytes.byteLength;
//   for (let i = 0; i < len; i++) {
//     binary += String.fromCharCode(bytes[i]);
//   }
//   return btoa(binary);
// };

// const generateConflictPdfData = async (templateBytes, formValues, signaturePng) => {
//   if (!templateBytes) return '';
//   const pdfDoc = await PDFDocument.load(templateBytes);
//   const pages = pdfDoc.getPages();
//   const firstPage = pages[0];
//   const page2 = pages[1];
//   const page3 = pages[2];

//   const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//   const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//   const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

//   // Draw values on Page 1
//   if (formValues.employeeName) {
//     firstPage.drawText(formValues.employeeName, {
//       x: 120,
//       y: 647.02,
//       size: 10,
//       font: boldFont,
//       color: rgb(0, 0, 0)
//     });
//   }

//   if (formValues.position) {
//     firstPage.drawText(formValues.position, {
//       x: 85,
//       y: 628.90,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });
//   }

//   const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//   const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();
//   firstPage.drawText(dateStr, {
//     x: 110,
//     y: 610.54,
//     size: 10,
//     font: textFont,
//     color: rgb(0, 0, 0)
//   });

//   // Draw values on Page 2 (Questions & Checkboxes)
//   if (page2) {
//     const drawTick = (x, y) => {
//       page2.drawText('\u2714', {
//         x: x + 1,
//         y: y + 1,
//         size: 9.5,
//         font: dingbatsFont,
//         color: rgb(0, 0, 0)
//       });
//     };

//     // A. Outside Employment
//     if (formValues.outsideEmploymentType === 'none') {
//       drawTick(43, 664.18);
//     } else if (formValues.outsideEmploymentType === 'has_employment') {
//       drawTick(43, 644.02);

//       if (formValues.outsideEmployer) {
//         page2.drawText(formValues.outsideEmployer, {
//           x: 135,
//           y: 625.90,
//           size: 9,
//           font: textFont,
//           color: rgb(0, 0, 0)
//         });
//       }
//       if (formValues.outsideNature) {
//         page2.drawText(formValues.outsideNature, {
//           x: 115,
//           y: 607.54,
//           size: 9,
//           font: textFont,
//           color: rgb(0, 0, 0)
//         });
//       }
//       if (formValues.outsideHours) {
//         page2.drawText(formValues.outsideHours, {
//           x: 110,
//           y: 589.03,
//           size: 9,
//           font: textFont,
//           color: rgb(0, 0, 0)
//         });
//       }
//     }

//     // B. Ownership of Other Businesses
//     if (formValues.ownershipType === 'no') {
//       drawTick(43, 532.87);
//     } else if (formValues.ownershipType === 'yes') {
//       drawTick(43, 512.71);
//       if (formValues.ownershipDescribe) {
//         page2.drawText(formValues.ownershipDescribe, {
//           x: 115,
//           y: 493.87,
//           size: 9,
//           font: textFont,
//           color: rgb(0, 0, 0)
//         });
//       }
//     }

//     // C. Competing Activities
//     if (formValues.competingType === 'no') {
//       drawTick(43, 437.59);
//     } else if (formValues.competingType === 'yes') {
//       drawTick(43, 417.53);
//       if (formValues.competingDescribe) {
//         page2.drawText(formValues.competingDescribe, {
//           x: 110,
//           y: 398.69,
//           size: 9,
//           font: textFont,
//           color: rgb(0, 0, 0)
//         });
//       }
//     }

//     // D. Other Potential Conflicts
//     if (formValues.otherConflicts) {
//       page2.drawText(formValues.otherConflicts, {
//         x: 45,
//         y: 348,
//         size: 8.5,
//         font: textFont,
//         color: rgb(0, 0, 0)
//       });
//     }
//   }

//   // Draw signature block on Page 3
//   if (page3) {
//     if (formValues.employeeName) {
//       page3.drawText(formValues.employeeName, {
//         x: 120,
//         y: 683.62,
//         size: 10,
//         font: boldFont,
//         color: rgb(0, 0, 0)
//       });
//     }

//     page3.drawText(dateStr, {
//       x: 70,
//       y: 665.50,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });

//     page3.drawText(dateStr, {
//       x: 70,
//       y: 545.23,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });

//     if (signaturePng) {
//       try {
//         const signatureBytes = base64ToUint8Array(signaturePng);
//         if (signatureBytes.length > 0) {
//           const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//           const signatureImage = isJpg
//             ? await pdfDoc.embedJpg(signatureBytes)
//             : await pdfDoc.embedPng(signatureBytes);

//           page3.drawImage(signatureImage, {
//             x: 90,
//             y: 714,
//             width: 120,
//             height: 30,
//           });

//           // Draw signature and audit text on every page in the empty space
//           const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//           pages.forEach((page) => {
//             page.drawImage(signatureImage, {
//               x: 310,
//               y: 30,
//               width: 85,
//               height: 25,
//             });
//             page.drawText(auditText, {
//               x: 310,
//               y: 25,
//               size: 6,
//               font: textFont,
//               color: rgb(0.3, 0.4, 0.5),
//             });
//           });
//         }
//       } catch (e) {
//         console.error('Error embedding signature in final Conflict PDF data:', e);
//       }
//     }
//   }

//   const pdfBytes = await pdfDoc.save();
//   let binary = '';
//   const bytes = new Uint8Array(pdfBytes);
//   const len = bytes.byteLength;
//   for (let i = 0; i < len; i++) {
//     binary += String.fromCharCode(bytes[i]);
//   }
//   return btoa(binary);
// };

// const generateBenefitsPdfData = async (templateBytes, formValues, signaturePng) => {
//   if (!templateBytes) return '';
//   const pdfDoc = await PDFDocument.load(templateBytes);
//   const pages = pdfDoc.getPages();
//   const firstPage = pages[0];
//   const page2 = pages[1];
//   const page3 = pages[2];

//   const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//   const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//   const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

//   const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//   const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();

//   // Helper to draw checkmarks
//   const drawTick = (page, x, y) => {
//     page.drawText('\u2714', {
//       x: x + 1,
//       y: y + 1,
//       size: 9.5,
//       font: dingbatsFont,
//       color: rgb(0, 0, 0)
//     });
//   };

//   // Draw values on Page 1
//   if (formValues.employeeName) {
//     firstPage.drawText(formValues.employeeName, {
//       x: 130,
//       y: 700.66,
//       size: 10,
//       font: boldFont,
//       color: rgb(0, 0, 0)
//     });
//   }
//   if (formValues.position) {
//     firstPage.drawText(formValues.position, {
//       x: 95,
//       y: 664.06,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });
//   }
//   if (formValues.department) {
//     firstPage.drawText(formValues.department, {
//       x: 110,
//       y: 645.70,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });
//   }
//   firstPage.drawText(dateStr, {
//     x: 135,
//     y: 609.10,
//     size: 10,
//     font: textFont,
//     color: rgb(0, 0, 0)
//   });

//   // Section 1 - Medical
//   if (formValues.medicalElection === 'enrol') {
//     drawTick(firstPage, 43, 461.23);
//   } else if (formValues.medicalElection === 'waive') {
//     drawTick(firstPage, 43, 441.19);
//     if (formValues.medicalWaiveReason === 'spouse_plan') {
//       drawTick(firstPage, 43, 402.65);
//     } else if (formValues.medicalWaiveReason === 'another_plan') {
//       drawTick(firstPage, 43, 382.61);
//     } else if (formValues.medicalWaiveReason === 'gov_program') {
//       drawTick(firstPage, 43, 362.45);
//     } else if (formValues.medicalWaiveReason === 'other') {
//       drawTick(firstPage, 43, 342.29);
//       if (formValues.medicalWaiveReasonOther) {
//         firstPage.drawText(formValues.medicalWaiveReasonOther, {
//           x: 95,
//           y: 342.29,
//           size: 9,
//           font: textFont,
//           color: rgb(0, 0, 0)
//         });
//       }
//     }
//   }

//   // Section 2 - Dental
//   if (formValues.dentalElection === 'enrol') {
//     drawTick(firstPage, 43, 285.53);
//   } else if (formValues.dentalElection === 'waive') {
//     drawTick(firstPage, 43, 265.49);
//   }

//   // Section 3 - Vision
//   if (formValues.visionElection === 'enrol') {
//     drawTick(firstPage, 43, 208.70);
//   } else if (formValues.visionElection === 'waive') {
//     drawTick(firstPage, 43, 188.54);
//   }

//   // Section 4 - 401(k) Retirement Participation
//   if (formValues.retirementElection === 'participate') {
//     drawTick(firstPage, 43, 131.78);

//     // Draw contributions on Page 2
//     if (page2) {
//       if (formValues.retirementContributionType === 'percentage') {
//         drawTick(page2, 43, 717.70);
//         if (formValues.retirementContributionPercent) {
//           page2.drawText(String(formValues.retirementContributionPercent), {
//             x: 58,
//             y: 717.70,
//             size: 9,
//             font: textFont,
//             color: rgb(0, 0, 0)
//           });
//         }
//       } else if (formValues.retirementContributionType === 'amount') {
//         drawTick(page2, 43, 679.18);
//         if (formValues.retirementContributionAmount) {
//           page2.drawText(String(formValues.retirementContributionAmount), {
//             x: 58,
//             y: 679.18,
//             size: 9,
//             font: textFont,
//             color: rgb(0, 0, 0)
//           });
//         }
//       }
//     }
//   } else if (formValues.retirementElection === 'decline') {
//     drawTick(firstPage, 43, 111.62);
//   }

//   // Section 5 - Beneficiary Designation on Page 2
//   if (page2) {
//     if (formValues.primaryBeneName) {
//       page2.drawText(formValues.primaryBeneName, {
//         x: 80,
//         y: 365.81,
//         size: 9,
//         font: textFont,
//         color: rgb(0, 0, 0)
//       });
//     }
//     if (formValues.primaryBeneRelationship) {
//       page2.drawText(formValues.primaryBeneRelationship, {
//         x: 105,
//         y: 347.45,
//         size: 9,
//         font: textFont,
//         color: rgb(0, 0, 0)
//       });
//     }
//     if (formValues.primaryBeneDob) {
//       page2.drawText(formValues.primaryBeneDob, {
//         x: 105,
//         y: 329.21,
//         size: 9,
//         font: textFont,
//         color: rgb(0, 0, 0)
//       });
//     }
//     if (formValues.primaryBenePercent) {
//       page2.drawText(String(formValues.primaryBenePercent), {
//         x: 55,
//         y: 292.61,
//         size: 9,
//         font: textFont,
//         color: rgb(0, 0, 0)
//       });
//     }

//     if (formValues.contingentBeneName) {
//       page2.drawText(formValues.contingentBeneName, {
//         x: 80,
//         y: 237.62,
//         size: 9,
//         font: textFont,
//         color: rgb(0, 0, 0)
//       });
//     }
//     if (formValues.contingentBeneRelationship) {
//       page2.drawText(formValues.contingentBeneRelationship, {
//         x: 105,
//         y: 219.26,
//         size: 9,
//         font: textFont,
//         color: rgb(0, 0, 0)
//       });
//     }
//     if (formValues.contingentBeneDob) {
//       page2.drawText(formValues.contingentBeneDob, {
//         x: 105,
//         y: 201.02,
//         size: 9,
//         font: textFont,
//         color: rgb(0, 0, 0)
//       });
//     }
//     if (formValues.contingentBenePercent) {
//       page2.drawText(String(formValues.contingentBenePercent), {
//         x: 55,
//         y: 164.30,
//         size: 9,
//         font: textFont,
//         color: rgb(0, 0, 0)
//       });
//     }
//   }

//   // Draw signature block on Page 3
//   if (page3) {
//     if (formValues.employeeName) {
//       page3.drawText(formValues.employeeName, {
//         x: 110,
//         y: 535.87,
//         size: 10,
//         font: boldFont,
//         color: rgb(0, 0, 0)
//       });
//     }
//     page3.drawText(dateStr, {
//       x: 75,
//       y: 517.51,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });

//     page3.drawText(dateStr, {
//       x: 75,
//       y: 232.22,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });

//     if (signaturePng) {
//       try {
//         const signatureBytes = base64ToUint8Array(signaturePng);
//         if (signatureBytes.length > 0) {
//           const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//           const signatureImage = isJpg
//             ? await pdfDoc.embedJpg(signatureBytes)
//             : await pdfDoc.embedPng(signatureBytes);

//           page3.drawImage(signatureImage, {
//             x: 90,
//             y: 548,
//             width: 120,
//             height: 30,
//           });

//           // Draw signature and audit text on every page in the empty space
//           const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//           pages.forEach((page) => {
//             page.drawImage(signatureImage, {
//               x: 310,
//               y: 30,
//               width: 85,
//               height: 25,
//             });
//             page.drawText(auditText, {
//               x: 310,
//               y: 25,
//               size: 6,
//               font: textFont,
//               color: rgb(0.3, 0.4, 0.5),
//             });
//           });
//         }
//       } catch (e) {
//         console.error('Error embedding signature in final Benefits PDF data:', e);
//       }
//     }
//   }

//   const pdfBytes = await pdfDoc.save();
//   let binary = '';
//   const bytes = new Uint8Array(pdfBytes);
//   const len = bytes.byteLength;
//   for (let i = 0; i < len; i++) {
//     binary += String.fromCharCode(bytes[i]);
//   }
//   return btoa(binary);
// };

// const generateNonSolicitationPdfData = async (templateBytes, formValues, signaturePng) => {
//   if (!templateBytes) return '';
//   const pdfDoc = await PDFDocument.load(templateBytes);
//   const pages = pdfDoc.getPages();
//   const firstPage = pages[0];
//   const lastPage = pages[pages.length - 1];

//   const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//   const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//   const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//   const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();

//   // Draw values on Page 1
//   if (formValues.employeeName) {
//     firstPage.drawText(formValues.employeeName, {
//       x: 119,
//       y: 665.14,
//       size: 10,
//       font: boldFont,
//       color: rgb(0, 0, 0)
//     });
//   }

//   if (formValues.position) {
//     firstPage.drawText(formValues.position, {
//       x: 83,
//       y: 647.02,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });
//   }

//   firstPage.drawText(dateStr, {
//     x: 107,
//     y: 628.90,
//     size: 10,
//     font: textFont,
//     color: rgb(0, 0, 0)
//   });

//   // Draw values on last page
//   if (lastPage) {
//     if (formValues.employeeName) {
//       lastPage.drawText(formValues.employeeName, {
//         x: 120,
//         y: 317.57,
//         size: 10,
//         font: boldFont,
//         color: rgb(0, 0, 0)
//       });
//     }

//     lastPage.drawText(dateStr, {
//       x: 75,
//       y: 299.21,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });

//     lastPage.drawText(dateStr, {
//       x: 75,
//       y: 130.34,
//       size: 10,
//       font: textFont,
//       color: rgb(0, 0, 0)
//     });

//     if (signaturePng) {
//       try {
//         const signatureBytes = base64ToUint8Array(signaturePng);
//         if (signatureBytes.length > 0) {
//           const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//           const signatureImage = isJpg
//             ? await pdfDoc.embedJpg(signatureBytes)
//             : await pdfDoc.embedPng(signatureBytes);

//           lastPage.drawImage(signatureImage, {
//             x: 90,
//             y: 348,
//             width: 120,
//             height: 30,
//           });

//           // Draw signature and audit text on every page footer in empty space
//           const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//           pages.forEach((page) => {
//             page.drawImage(signatureImage, {
//               x: 310,
//               y: 30,
//               width: 85,
//               height: 25,
//             });
//             page.drawText(auditText, {
//               x: 310,
//               y: 25,
//               size: 6,
//               font: textFont,
//               color: rgb(0.3, 0.4, 0.5),
//             });
//           });
//         }
//       } catch (e) {
//         console.error('Error embedding signature in final Non Solicitation PDF:', e);
//       }
//     }
//   }

//   const pdfBytes = await pdfDoc.save();
//   let binary = '';
//   const bytes = new Uint8Array(pdfBytes);
//   const len = bytes.byteLength;
//   for (let i = 0; i < len; i++) {
//     binary += String.fromCharCode(bytes[i]);
//   }
//   return btoa(binary);
// };

// // Helper to format date as MM/DD/YYYY
// const formatDateMMDDYYYY = (dateVal) => {
//   if (!dateVal) {
//     const now = new Date();
//     const m = String(now.getMonth() + 1).padStart(2, '0');
//     const day = String(now.getDate()).padStart(2, '0');
//     return `${m}/${day}/${now.getFullYear()}`;
//   }
//   let d = null;
//   if (dateVal instanceof Date) {
//     d = dateVal;
//   } else if (typeof dateVal === 'string') {
//     const trimmed = dateVal.trim();
//     // 1. Check YYYY-MM-DD or YYYY/MM/DD
//     const ymdMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
//     if (ymdMatch) {
//       const year = parseInt(ymdMatch[1], 10);
//       const month = parseInt(ymdMatch[2], 10) - 1;
//       const day = parseInt(ymdMatch[3], 10);
//       d = new Date(year, month, day);
//     } else {
//       // 2. Check MM/DD/YYYY or DD/MM/YYYY
//       const mdyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
//       if (mdyMatch) {
//         const p1 = parseInt(mdyMatch[1], 10);
//         const p2 = parseInt(mdyMatch[2], 10);
//         const year = parseInt(mdyMatch[3], 10);
//         let month, day;
//         if (p1 > 12) {
//           day = p1;
//           month = p2 - 1;
//         } else if (p2 > 12) {
//           month = p1 - 1;
//           day = p2;
//         } else {
//           month = p1 - 1;
//           day = p2;
//         }
//         d = new Date(year, month, day);
//       } else {
//         d = new Date(trimmed);
//       }
//     }
//   } else {
//     d = new Date(dateVal);
//   }

//   if (!d || isNaN(d.getTime())) {
//     const now = new Date();
//     const m = String(now.getMonth() + 1).padStart(2, '0');
//     const day = String(now.getDate()).padStart(2, '0');
//     return `${m}/${day}/${now.getFullYear()}`;
//   }

//   const month = String(d.getMonth() + 1).padStart(2, '0');
//   const day = String(d.getDate()).padStart(2, '0');
//   const year = d.getFullYear();
//   return `${month}/${day}/${year}`;
// };

// // Helper to format joining date for India Employment Agreement (e.g., "21st day of November 2025.")
// const formatAgreementJoiningDate = (dateInput) => {
//   if (!dateInput) return '21st day of November 2025.';
//   let dateObj = null;

//   if (dateInput instanceof Date) {
//     dateObj = dateInput;
//   } else if (typeof dateInput === 'string') {
//     const trimmed = dateInput.trim();

//     // 1. Check YYYY-MM-DD or YYYY/MM/DD (e.g. 2026-09-25, 2026-9-25)
//     const ymdMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
//     if (ymdMatch) {
//       const year = parseInt(ymdMatch[1], 10);
//       const month = parseInt(ymdMatch[2], 10) - 1;
//       const day = parseInt(ymdMatch[3], 10);
//       dateObj = new Date(year, month, day);
//     } else {
//       // 2. Check MM/DD/YYYY or DD/MM/YYYY (e.g. 09/25/2026 or 25/09/2026)
//       const mdyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
//       if (mdyMatch) {
//         const p1 = parseInt(mdyMatch[1], 10);
//         const p2 = parseInt(mdyMatch[2], 10);
//         const year = parseInt(mdyMatch[3], 10);

//         let month, day;
//         if (p1 > 12) {
//           // p1 is Day, p2 is Month (e.g., 25/09/2026)
//           day = p1;
//           month = p2 - 1;
//         } else if (p2 > 12) {
//           // p1 is Month, p2 is Day (e.g., 09/25/2026)
//           month = p1 - 1;
//           day = p2;
//         } else {
//           // Standard US format MM/DD/YYYY (e.g., 09/05/2026)
//           month = p1 - 1;
//           day = p2;
//         }
//         dateObj = new Date(year, month, day);
//       } else {
//         // 3. Fallback to standard JS Date parsing
//         dateObj = new Date(trimmed);
//       }
//     }
//   }

//   if (!dateObj || isNaN(dateObj.getTime())) {
//     return '21st day of November 2025.';
//   }

//   const day = dateObj.getDate();
//   const year = dateObj.getFullYear();
//   const monthNames = [
//     'January', 'February', 'March', 'April', 'May', 'June',
//     'July', 'August', 'September', 'October', 'November', 'December'
//   ];
//   const monthName = monthNames[dateObj.getMonth()];

//   let suffix = 'th';
//   if (day % 100 < 11 || day % 100 > 13) {
//     switch (day % 10) {
//       case 1: suffix = 'st'; break;
//       case 2: suffix = 'nd'; break;
//       case 3: suffix = 'rd'; break;
//       default: suffix = 'th'; break;
//     }
//   }

//   return `${day}${suffix} day of ${monthName} ${year}.`;
// };

// // Helper to format short joining date for India Employment Agreement (e.g., "25th September 2026")
// const formatJoiningDateShort = (dateInput) => {
//   if (!dateInput) return '21st November 2025';
//   let dateObj = null;

//   if (dateInput instanceof Date) {
//     dateObj = dateInput;
//   } else if (typeof dateInput === 'string') {
//     const trimmed = dateInput.trim();

//     // 1. Check YYYY-MM-DD or YYYY/MM/DD
//     const ymdMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
//     if (ymdMatch) {
//       const year = parseInt(ymdMatch[1], 10);
//       const month = parseInt(ymdMatch[2], 10) - 1;
//       const day = parseInt(ymdMatch[3], 10);
//       dateObj = new Date(year, month, day);
//     } else {
//       // 2. Check MM/DD/YYYY or DD/MM/YYYY
//       const mdyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
//       if (mdyMatch) {
//         const p1 = parseInt(mdyMatch[1], 10);
//         const p2 = parseInt(mdyMatch[2], 10);
//         const year = parseInt(mdyMatch[3], 10);

//         let month, day;
//         if (p1 > 12) {
//           day = p1;
//           month = p2 - 1;
//         } else if (p2 > 12) {
//           month = p1 - 1;
//           day = p2;
//         } else {
//           month = p1 - 1;
//           day = p2;
//         }
//         dateObj = new Date(year, month, day);
//       } else {
//         dateObj = new Date(trimmed);
//       }
//     }
//   }

//   if (!dateObj || isNaN(dateObj.getTime())) {
//     return '21st November 2025';
//   }

//   const day = dateObj.getDate();
//   const year = dateObj.getFullYear();
//   const monthNames = [
//     'January', 'February', 'March', 'April', 'May', 'June',
//     'July', 'August', 'September', 'October', 'November', 'December'
//   ];
//   const monthName = monthNames[dateObj.getMonth()];

//   let suffix = 'th';
//   if (day % 100 < 11 || day % 100 > 13) {
//     switch (day % 10) {
//       case 1: suffix = 'st'; break;
//       case 2: suffix = 'nd'; break;
//       case 3: suffix = 'rd'; break;
//       default: suffix = 'th'; break;
//     }
//   }

//   return `${day}${suffix} ${monthName} ${year}`;
// };

// // Helper to draw signature PNG on the last page of a PDF and footers of all pages
// const applySignatureToPdf = async (originalPdfBase64, signaturePngDataUrl, employeeName, docType, isIndia = false, extraDetails = {}) => {
//   try {
//     let pdfDoc;
//     if (originalPdfBase64) {
//       // Convert base64 PDF to bytes safely
//       const pdfBytes = base64ToUint8Array(originalPdfBase64);
//       if (pdfBytes.length === 0) {
//         throw new Error("Invalid original PDF base64 data");
//       }
//       // Load the PDF document
//       pdfDoc = await PDFDocument.load(pdfBytes);
//     } else {
//       if (docType === 'Offer Letter') {
//         throw new Error("Unable to retrieve original Offer Letter document bytes for digital signing. Please check network connection.");
//       }
//       // Fallback for other documents: If original PDF is empty, create a simple PDF document
//       pdfDoc = await PDFDocument.create();
//       const page = pdfDoc.addPage([595, 842]); // A4

//       page.drawText(`${docType} Confirmation`, {
//         x: 50,
//         y: 750,
//         size: 20,
//         color: rgb(0.1, 0.1, 0.1),
//       });

//       page.drawText(`This document serves as confirmation that the employee has electronically signed the ${docType}.`, {
//         x: 50,
//         y: 700,
//         size: 11,
//         color: rgb(0.2, 0.2, 0.2),
//       });

//       page.drawText(`Employee Name: ${employeeName}`, {
//         x: 50,
//         y: 650,
//         size: 11,
//       });
//     }

//     // Embed signature image if provided
//     let signatureImage = null;
//     if (signaturePngDataUrl) {
//       try {
//         const isJpg = signaturePngDataUrl.startsWith('data:image/jpeg') || signaturePngDataUrl.startsWith('data:image/jpg');
//         const signatureBytes = base64ToUint8Array(signaturePngDataUrl);
//         if (signatureBytes.length > 0) {
//           if (isJpg) {
//             signatureImage = await pdfDoc.embedJpg(signatureBytes);
//           } else {
//             signatureImage = await pdfDoc.embedPng(signatureBytes);
//           }
//         }
//       } catch (imgErr) {
//         console.warn("Failed to embed signature PNG into PDF:", imgErr);
//       }
//     }

//     // Get all pages
//     const pages = pdfDoc.getPages();
//     if (pages.length === 0) {
//       throw new Error("PDF document has no pages");
//     }
//     const lastPage = pages[pages.length - 1];

//     const currentDate = extraDetails?.date || formatDateMMDDYYYY();
//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//     // Draw signature image and audit text on every page at the footer in the empty space (skip for Offer Letter)
//     if (signatureImage && docType !== 'Offer Letter') {
//       const auditText = `Signed by ${employeeName} on ${currentDate}`;
//       pages.forEach((page) => {
//         page.drawImage(signatureImage, {
//           x: 310,
//           y: 25,
//           width: 85,
//           height: 25,
//         });
//         page.drawText(auditText, {
//           x: 310,
//           y: 20,
//           size: 5,
//           font,
//           color: rgb(0.3, 0.4, 0.5),
//         });
//       });
//     }

//     // Draw main signature image and texts on the last page
//     if (docType === 'Employee Agreement') {
//       // 1. Draw dynamic Joining Date on Page 1
//       const rawJoiningDate = extraDetails?.joiningDate || extraDetails?.joining_date || extraDetails?.JoiningDate || extraDetails?.hireDate;
//       if (pages.length > 0) {
//         const firstPage = pages[0];
//         const formattedJoiningDate = formatAgreementJoiningDate(rawJoiningDate);
//         // Cover blank underline area starting precisely after "this "
//         firstPage.drawRectangle({
//           x: 388.8,
//           y: 555,
//           width: 135,
//           height: 14,
//           color: rgb(1, 1, 1),
//         });
//         // Draw joining date text starting precisely at x: 389.11
//         firstPage.drawText(formattedJoiningDate, {
//           x: 389.11,
//           y: 559.54,
//           size: 8.8,
//           font,
//           color: rgb(0, 0, 0),
//         });
//       }

//       // Draw Employee Name text
//       lastPage.drawText(employeeName, {
//         x: 145,
//         y: 488.83,
//         size: 9,
//         font: fontBold,
//         color: rgb(0, 0, 0),
//       });

//       // Draw Date text on last page (in front of Date: lines at y: 470.95 and y: 320.21)
//       const formattedDateForLastPage = rawJoiningDate ? formatJoiningDateShort(rawJoiningDate) : currentDate;

//       // Employee Date: line
//       lastPage.drawText(formattedDateForLastPage, {
//         x: 105,
//         y: 470.95,
//         size: 9,
//         font: fontBold,
//         color: rgb(0, 0, 0),
//       });

//       // Director HR Date: line
//       lastPage.drawText(formattedDateForLastPage, {
//         x: 95,
//         y: 320.21,
//         size: 9,
//         font: fontBold,
//         color: rgb(0, 0, 0),
//       });

//       if (signatureImage) {
//         lastPage.drawImage(signatureImage, {
//           x: 145,
//           y: 498,
//           width: 120,
//           height: 35,
//         });

//         // Draw audit text below the signature on the last page
//         lastPage.drawText(`Digitally signed by ${employeeName} on ${new Date().toLocaleString()}`, {
//           x: 70.82,
//           y: 450,
//           size: 8,
//           font,
//           color: rgb(0.3, 0.4, 0.5), // Slate-gray
//         });
//       }
//     } else if (docType === 'Offer Letter') {
//       if (isIndia) {
//         const fullNameToDraw = extraDetails?.fullName || employeeName || '';
//         const aadhaarToDraw = extraDetails?.aadhaarNumber || extraDetails?.aadhaar || extraDetails?.ssn || '';
//         const dateToDraw = (extraDetails && typeof extraDetails.date === 'string') ? extraDetails.date : currentDate;

//         // 1. Draw signature image on Signature: line (only after candidate signs)
//         if (signatureImage) {
//           lastPage.drawImage(signatureImage, {
//             x: 105,
//             y: 335,
//             width: 110,
//             height: 28,
//           });
//         }

//         // 2. Draw Full Name (First + Middle + Last) on Full Name (as per Identity Card / Passport): line (pre-filled)
//         if (fullNameToDraw) {
//           lastPage.drawText(fullNameToDraw, {
//             x: 225,
//             y: 320,
//             size: 10,
//             font,
//             color: rgb(0, 0, 0),
//           });
//         }

//         // 3. Draw Aadhaar Number on Aadhaar Number: line (pre-filled)
//         if (aadhaarToDraw) {
//           lastPage.drawText(aadhaarToDraw, {
//             x: 150,
//             y: 297,
//             size: 10,
//             font,
//             color: rgb(0, 0, 0),
//           });
//         }

//         // 4. Draw Date on Date: line (only after candidate signs)
//         if (dateToDraw) {
//           lastPage.drawText(dateToDraw, {
//             x: 80,
//             y: 275,
//             size: 10,
//             font,
//             color: rgb(0, 0, 0),
//           });
//         }

//         // USA & India Offer Letter: Draw bottom signature + digital audit text in clean space
//         if (signatureImage) {
//           lastPage.drawImage(signatureImage, {
//             x: 80,
//             y: 150,
//             width: 130,
//             height: 38,
//           });

//           lastPage.drawText(`Digitally signed by ${fullNameToDraw} on ${new Date().toLocaleString()}`, {
//             x: 80,
//             y: 136,
//             size: 8,
//             font,
//             color: rgb(0.1, 0.3, 0.6), // Slate-blue
//           });
//         }
//       } else {
//         if (signatureImage) {
//           lastPage.drawImage(signatureImage, {
//             x: 80,
//             y: 150,
//             width: 130,
//             height: 38,
//           });

//           lastPage.drawText(`Digitally signed by ${employeeName} on ${new Date().toLocaleString()}`, {
//             x: 80,
//             y: 136,
//             size: 8,
//             font,
//             color: rgb(0.1, 0.3, 0.6), // Slate-blue
//           });
//         }
//       }
//     } else {
//       if (signatureImage) {
//         lastPage.drawImage(signatureImage, {
//           x: 75,
//           y: 120,
//           width: 150,
//           height: 55,
//         });

//         // Draw audit text below the signature on the last page
//         lastPage.drawText(`Digitally signed by ${employeeName} on ${new Date().toLocaleString()}`, {
//           x: 75,
//           y: 100,
//           size: 8,
//           font,
//           color: rgb(0.3, 0.4, 0.5), // Slate-gray
//         });
//       }
//     }

//     // Save and return base64
//     const signedPdfBase64 = await pdfDoc.saveAsBase64();
//     return signedPdfBase64;
//   } catch (error) {
//     console.error("Error signing PDF:", error);
//     throw error;
//   }
// };

// const createPoliciesPdf = async (employeeName, signatureDataUrl) => {
//   const pdfDoc = await PDFDocument.create();

//   let page = null;
//   let height = 0;
//   let y = 0;

//   const startNewPage = () => {
//     page = pdfDoc.addPage([600, 850]);
//     height = page.getSize().height;
//     y = height - 50;
//   };

//   startNewPage();

//   // Title
//   page.drawText('GENESIS TECH ENGINEERS PVT. LTD. - COMPANY POLICIES', {
//     x: 50,
//     y,
//     size: 13,
//     color: rgb(0, 0, 0)
//   });
//   y -= 30;

//   // Subtitle
//   page.drawText(`Signed Employee: ${employeeName}`, { x: 50, y, size: 10, color: rgb(0.2, 0.2, 0.2) });
//   page.drawText(`Date: ${new Date().toLocaleDateString()}`, { x: 450, y, size: 10, color: rgb(0.2, 0.2, 0.2) });
//   y -= 25;

//   page.drawText('This document certifies acceptance of the following company policies:', {
//     x: 50,
//     y,
//     size: 10,
//     color: rgb(0.3, 0.3, 0.3)
//   });
//   y -= 20;

//   // Loop over each policy in genesisPoliciesText
//   for (const pol of genesisPoliciesText) {
//     if (y < 80) startNewPage();

//     // Draw Policy Title
//     page.drawText(`${pol.id}. ${pol.title.toUpperCase()}`, {
//       x: 50,
//       y,
//       size: 11,
//       color: rgb(0.05, 0.2, 0.4)
//     });
//     y -= 18;

//     // Draw description lines with word wrapping
//     const textLines = pol.text.split('\n');
//     for (const rawLine of textLines) {
//       const maxLineWidth = 500;
//       const fontSize = 8.5;

//       const words = rawLine.split(' ');
//       let currentLine = '';

//       for (const word of words) {
//         const testLine = currentLine ? `${currentLine} ${word}` : word;
//         const approxWidth = testLine.length * 4.5;
//         if (approxWidth > maxLineWidth) {
//           if (y < 50) startNewPage();
//           page.drawText(currentLine, { x: 55, y, size: fontSize, color: rgb(0.15, 0.15, 0.15) });
//           y -= 13;
//           currentLine = word;
//         } else {
//           currentLine = testLine;
//         }
//       }

//       if (currentLine) {
//         if (y < 50) startNewPage();
//         page.drawText(currentLine, { x: 55, y, size: fontSize, color: rgb(0.15, 0.15, 0.15) });
//         y -= 13;
//       }
//     }
//     y -= 10;
//   }

//   // Draw signature section at the end
//   if (y < 150) startNewPage();
//   y -= 30;
//   page.drawText('EMPLOYEE SIGN-OFF & ACCEPTANCE', { x: 50, y, size: 10, color: rgb(0, 0, 0) });
//   y -= 20;
//   page.drawText(`I, ${employeeName}, hereby acknowledge that I have read, understood, and accept all 11 company policies detailed in this document.`, {
//     x: 50,
//     y,
//     size: 8.5,
//     color: rgb(0.2, 0.2, 0.2)
//   });
//   y -= 40;

//   if (signatureDataUrl && signatureDataUrl.startsWith('data:image')) {
//     try {
//       const isJpg = signatureDataUrl.startsWith('data:image/jpeg') || signatureDataUrl.startsWith('data:image/jpg');
//       const signatureBytes = base64ToUint8Array(signatureDataUrl);
//       if (signatureBytes.length > 0) {
//         let pngImage;
//         if (isJpg) {
//           pngImage = await pdfDoc.embedJpg(signatureBytes);
//         } else {
//           pngImage = await pdfDoc.embedPng(signatureBytes);
//         }
//         const pngDims = pngImage.scale(0.35);
//         if (y - pngDims.height < 50) startNewPage();
//         page.drawImage(pngImage, {
//           x: 50,
//           y: y - pngDims.height,
//           width: pngDims.width,
//           height: pngDims.height
//         });
//         y -= (pngDims.height + 15);
//         page.drawText('--------------------------------------', { x: 50, y, size: 10, color: rgb(0.4, 0.4, 0.4) });
//         y -= 15;
//         page.drawText(`Employee Signature: ${employeeName}`, { x: 50, y, size: 9, color: rgb(0.1, 0.1, 0.1) });
//       }
//     } catch (e) {
//       console.error("Failed to embed signature in policies PDF:", e);
//     }
//   }

//   const pdfBytes = await pdfDoc.save();

//   // Convert binary to base64 safely
//   let binary = '';
//   const bytes = new Uint8Array(pdfBytes);
//   const len = bytes.byteLength;
//   for (let i = 0; i < len; i++) {
//     binary += String.fromCharCode(bytes[i]);
//   }
//   const base64 = btoa(binary);
//   return base64;
// };

// const EmployeeDashboard = ({ activeTab, setActiveTab, onStartTour, onStartVideoTour }) => {
//   const [loading, setLoading] = useState(true);
//   const [uploadingPhoto, setUploadingPhoto] = useState(false);
//   const [data, setData] = useState(null);
//   const [dashboardStats, setDashboardStats] = useState(null);
//   const [toast, setToast] = useState(null);
//   const [showSubmitConfirm, setShowSubmitConfirm] = useState(false);
//   const [showRequestedDocsModal, setShowRequestedDocsModal] = useState(false);
//   const [hasSeenRequestedDocsModal, setHasSeenRequestedDocsModal] = useState(false);
//   const [requestedDocsSubmitted, setRequestedDocsSubmitted] = useState(false);
//   const [submitStatus, setSubmitStatus] = useState('idle'); // 'idle', 'submitting', 'success', 'error'
//   const [submitErrorMessage, setSubmitErrorMessage] = useState('');
//   const [offerLetterBlobUrl, setOfferLetterBlobUrl] = useState('');
//   const [employeeAgreementBlobUrl, setEmployeeAgreementBlobUrl] = useState('');
//   const [selectedAgreementKey, setSelectedAgreementKey] = useState('');
//   const [agreementBlobUrls, setAgreementBlobUrls] = useState({});

//   // Forms state
//   const [personalForm, setPersonalForm] = useState({
//     first_name: '', middle_name: '', last_name: '', preferred_name: '', dob: '', gender: '', pronouns: '',
//     marital_status: '', citizenship: '', phone: '', personal_email: '', address: '',
//     city: '', state: '', zip: '', country: ''
//   });

//   const [emergencyContacts, setEmergencyContacts] = useState([]);
//   const [bankForm, setBankForm] = useState({ bank_name: '', routing_number: '', account_number: '', account_type: 'CHECKING', bank_branch_address: '' });
//   const [taxForm, setTaxForm] = useState({
//     federal_tax_status: 'SINGLE',
//     federal_allowances: 0,
//     state_tax_status: 'SINGLE',
//     state_allowances: 0,
//     name: '',
//     ssn: '',
//     address: '',
//     city: '',
//     state: '',
//     zip: '',
//     arizona_box_selection: 1,
//     arizona_percentage: 2.0,
//     arizona_extra_amount_checked: false,
//     arizona_extra_amount: '',
//     signature: ''
//   });
//   const [expandedPolicyId, setExpandedPolicyId] = useState(null);
//   const [selectedPolicyId, setSelectedPolicyId] = useState(1);
//   const [viewedPolicyIds, setViewedPolicyIds] = useState([1]);

//   // US Form I-9 States
//   const [i9Attestation, setI9Attestation] = useState('US_Citizen');
//   const [uscisNumber, setUscisNumber] = useState('');
//   const [i9Method, setI9Method] = useState('list_a');
//   const [listADocType, setListADocType] = useState('Passport');
//   const [listBDocType, setListBDocType] = useState('Driver License');
//   const [listCDocType, setListCDocType] = useState('Social Security Card');
//   const [selectedState, setSelectedState] = useState('');
//   const [selectedIdOption, setSelectedIdOption] = useState('');
//   const [agreementTemplateBytes, setAgreementTemplateBytes] = useState(null);
//   const [indiaAgreementTemplateBytes, setIndiaAgreementTemplateBytes] = useState(null);
//   const [ndaTemplateBytes, setNdaTemplateBytes] = useState(null);
//   const [conflictTemplateBytes, setConflictTemplateBytes] = useState(null);
//   const [benefitsTemplateBytes, setBenefitsTemplateBytes] = useState(null);
//   const [nonSolicitationTemplateBytes, setNonSolicitationTemplateBytes] = useState(null);
//   const [employmentForm, setEmploymentForm] = useState({
//     employeeName: '',
//     position: '',
//     department: '',
//     primaryLocation: '',
//     employmentClassification: '',
//     effectiveDate: new Date().toLocaleDateString('en-US'),
//     outsideEmploymentType: 'none',
//     outsideEmployer: '',
//     outsideNature: '',
//     outsideHours: '',
//     ownershipType: 'no',
//     ownershipDescribe: '',
//     competingType: 'no',
//     competingDescribe: '',
//     otherConflicts: '',
//     employeeId: '',
//     hireDate: '',
//     medicalElection: 'enrol',
//     medicalWaiveReason: 'spouse_plan',
//     medicalWaiveReasonOther: '',
//     dentalElection: 'enrol',
//     visionElection: 'enrol',
//     retirementElection: 'participate',
//     retirementContributionType: 'percentage',
//     retirementContributionPercent: '',
//     retirementContributionAmount: '',
//     primaryBeneName: '',
//     primaryBeneRelationship: '',
//     primaryBeneDob: '',
//     primaryBenePercent: '',
//     contingentBeneName: '',
//     contingentBeneRelationship: '',
//     contingentBeneDob: '',
//     contingentBenePercent: ''
//   });

//   const fetchOnboardingData = useCallback(async () => {
//     try {
//       const res = await api.get('/onboarding');
//       setData(res.data);

//       // Bind states
//       if (res.data.profile) {
//         setPersonalForm(prev => ({
//           first_name: prev.first_name || res.data.profile.first_name || res.data.employee?.FirstName || '',
//           middle_name: prev.middle_name || res.data.profile.middle_name || '',
//           last_name: prev.last_name || res.data.profile.last_name || res.data.employee?.LastName || '',
//           preferred_name: prev.preferred_name || res.data.profile.preferred_name || '',
//           dob: prev.dob || res.data.profile.dob || '',
//           gender: prev.gender || res.data.profile.gender || '',
//           pronouns: prev.pronouns || res.data.profile.pronouns || '',
//           marital_status: prev.marital_status || res.data.profile.marital_status || '',
//           citizenship: prev.citizenship || res.data.profile.citizenship || '',
//           ssn: prev.ssn || res.data.profile.ssn || '',
//           phone: prev.phone || res.data.profile.phone || '',
//           personal_email: prev.personal_email || res.data.profile.personal_email || '',
//           address: prev.address || res.data.profile.address || '',
//           city: prev.city || res.data.profile.city || '',
//           state: prev.state || res.data.profile.state || '',
//           zip: prev.zip || res.data.profile.zip || '',
//           country: prev.country || res.data.profile.country || ''
//         }));

//         // Initialize I-9 attestation options if saved
//         if (res.data.profile.citizenship) {
//           if (res.data.profile.citizenship.includes('US_National')) {
//             setI9Attestation('US_National');
//           } else if (res.data.profile.citizenship.includes('LPR')) {
//             setI9Attestation('LPR');
//             const match = res.data.profile.citizenship.match(/\(([^)]+)\)/);
//             if (match) setUscisNumber(match[1]);
//           } else if (res.data.profile.citizenship.includes('Authorized_Alien')) {
//             setI9Attestation('Authorized_Alien');
//             const match = res.data.profile.citizenship.match(/\(([^)]+)\)/);
//             if (match) setUscisNumber(match[1]);
//           } else {
//             setI9Attestation('US_Citizen');
//           }
//         }
//       } else {
//         setPersonalForm(prev => ({
//           ...prev,
//           first_name: prev.first_name || res.data.employee?.FirstName || '',
//           last_name: prev.last_name || res.data.employee?.LastName || ''
//         }));
//       }

//       if (res.data.contacts && res.data.contacts.length > 0) setEmergencyContacts(res.data.contacts);
//       if (res.data.bank) {
//         const isIndiaCandidate = ((res.data.employee?.country || res.data.profile?.country || '').toUpperCase()) === 'INDIA';
//         setBankForm(prev => ({
//           bank_name: prev.bank_name || res.data.bank.bank_name || '',
//           routing_number: prev.routing_number || res.data.bank.routing_number || '',
//           account_number: prev.account_number || res.data.bank.account_number || '',
//           account_type: (prev.account_type && prev.account_type !== 'CHECKING') ? prev.account_type : ((isIndiaCandidate && (!res.data.bank.account_type || res.data.bank.account_type === 'CHECKING')) ? 'SAVINGS' : (res.data.bank.account_type || 'CHECKING')),
//           bank_branch_address: prev.bank_branch_address || res.data.bank.bank_branch_address || ''
//         }));
//       }
//       if (res.data.tax) {
//         let sigPath = res.data.tax.signature_path || '';
//         if (sigPath && sigPath.startsWith('uploads/')) {
//           try {
//             const imgRes = await api.get('/onboarding/tax-signature', { responseType: 'arraybuffer' });
//             const base64 = btoa(
//               new Uint8Array(imgRes.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
//             );
//             sigPath = `data:image/png;base64,${base64}`;
//           } catch (e) {
//             console.error('Failed to load saved signature image:', e);
//             let errMsg = e.message;
//             if (e.response?.data instanceof ArrayBuffer) {
//               try {
//                 const decoded = new TextDecoder('utf-8').decode(e.response.data);
//                 const parsed = JSON.parse(decoded);
//                 if (parsed.error) errMsg = parsed.error;
//               } catch (parseErr) { }
//             }
//             setToast({ message: 'Signature load error: ' + errMsg, type: 'error' });
//           }
//         } else if (sigPath && sigPath.startsWith('typed:')) {
//           sigPath = sigPath.substring(6);
//         }

//         setTaxForm({
//           federal_tax_status: res.data.tax.federal_tax_status || 'SINGLE',
//           federal_allowances: res.data.tax.federal_allowances || 0,
//           state_tax_status: res.data.tax.state_tax_status || 'SINGLE',
//           state_allowances: res.data.tax.state_allowances || 0,
//           name: res.data.tax.name || (res.data.profile ? `${res.data.profile.first_name || ''} ${res.data.profile.last_name || ''}`.trim() : ''),
//           ssn: res.data.tax.ssn || res.data.profile?.ssn || '',
//           address: res.data.tax.address || res.data.profile?.address || '',
//           city: res.data.tax.city || res.data.profile?.city || '',
//           state: res.data.tax.state || res.data.profile?.state || '',
//           zip: res.data.tax.zip || res.data.profile?.zip || '',
//           arizona_box_selection: res.data.tax.arizona_box_selection !== null && res.data.tax.arizona_box_selection !== undefined ? parseInt(res.data.tax.arizona_box_selection) : 1,
//           arizona_percentage: res.data.tax.arizona_percentage !== null && res.data.tax.arizona_percentage !== undefined ? parseFloat(res.data.tax.arizona_percentage) : 2.0,
//           arizona_extra_amount_checked: !!parseInt(res.data.tax.arizona_extra_amount_checked || 0),
//           arizona_extra_amount: res.data.tax.arizona_extra_amount !== null && res.data.tax.arizona_extra_amount !== undefined ? res.data.tax.arizona_extra_amount.toString() : '',
//           signature: sigPath
//         });
//       } else {
//         setTaxForm(prev => ({
//           ...prev,
//           name: res.data.profile ? `${res.data.profile.first_name || ''} ${res.data.profile.last_name || ''}`.trim() : '',
//           ssn: res.data.profile?.ssn || '',
//           address: res.data.profile?.address || '',
//           city: res.data.profile?.city || '',
//           state: res.data.profile?.state || '',
//           zip: res.data.profile?.zip || '',
//         }));
//       }

//       // Fetch dashboard metrics
//       const statsRes = await api.get('/dashboard/employee');
//       setDashboardStats(statsRes.data);

//       // Convert base64 fields to Blob URLs to avoid data URI issues in iframes
//       if (res.data.employee) {
//         setEmploymentForm(prev => ({
//           employeeName: prev.employeeName || `${res.data.employee.FirstName || ''} ${res.data.employee.LastName || ''}`.trim(),
//           position: prev.position || res.data.employee.Designation || res.data.employee.position || '',
//           department: prev.department || res.data.employee.Department || res.data.employee.department || '',
//           primaryLocation: '',
//           employmentClassification: '',
//           effectiveDate: prev.effectiveDate || new Date().toLocaleDateString('en-US'),
//           outsideEmploymentType: prev.outsideEmploymentType || 'none',
//           outsideEmployer: prev.outsideEmployer || '',
//           outsideNature: prev.outsideNature || '',
//           outsideHours: prev.outsideHours || '',
//           ownershipType: prev.ownershipType || 'no',
//           ownershipDescribe: prev.ownershipDescribe || '',
//           competingType: prev.competingType || 'no',
//           competingDescribe: prev.competingDescribe || '',
//           otherConflicts: prev.otherConflicts || '',
//           employeeId: prev.employeeId || res.data.employee.id || '',
//           hireDate: res.data.employee.joining_date || res.data.employee.JoiningDate || res.data.employee.joining_Date || res.data.employee.joiningDate || res.data.employee.joining || res.data.employee.hire_date || res.data.employee.HireDate || prev.hireDate || '',
//           medicalElection: prev.medicalElection || 'enrol',
//           medicalWaiveReason: prev.medicalWaiveReason || 'spouse_plan',
//           medicalWaiveReasonOther: prev.medicalWaiveReasonOther || '',
//           dentalElection: prev.dentalElection || 'enrol',
//           visionElection: prev.visionElection || 'enrol',
//           retirementElection: prev.retirementElection || 'participate',
//           retirementContributionType: prev.retirementContributionType || 'percentage',
//           retirementContributionPercent: prev.retirementContributionPercent || '',
//           retirementContributionAmount: prev.retirementContributionAmount || '',
//           primaryBeneName: prev.primaryBeneName || '',
//           primaryBeneRelationship: prev.primaryBeneRelationship || '',
//           primaryBeneDob: prev.primaryBeneDob || '',
//           primaryBenePercent: prev.primaryBenePercent || '',
//           contingentBeneName: prev.contingentBeneName || '',
//           contingentBeneRelationship: prev.contingentBeneRelationship || '',
//           contingentBeneDob: prev.contingentBeneDob || '',
//           contingentBenePercent: prev.contingentBenePercent || ''
//         }));
//         // Offer Letter
//         const isOfferSigned = res.data.signature_history?.some(
//           h => h.document_type === 'Offer Letter' && h.action === 'SIGN'
//         );
//         const signedOfferBase64 = res.data.signed_agreements?.['Offer Letter'];
//         const rawPath = res.data.employee?.offer_letter || res.data.employee?.offer_letter_path;
//         let realOfferUrl = '';
//         if (rawPath) {
//           let cleanPath = rawPath.replace(/^\//, '');
//           if (!cleanPath.startsWith('http://') && !cleanPath.startsWith('https://')) {
//             cleanPath = cleanPath.startsWith('offer_letters/')
//               ? `https://hiring.gtelinq.com/hiring-backend/${cleanPath}`
//               : `/EOP_api/${cleanPath}`;
//           }
//           realOfferUrl = cleanPath;
//         }

//         const fName = personalForm.first_name || res.data.profile?.first_name || res.data.employee?.FirstName || res.data.employee?.first_name || '';
//         const mName = personalForm.middle_name || res.data.profile?.middle_name || res.data.employee?.MiddleName || res.data.employee?.middle_name || '';
//         const lName = personalForm.last_name || res.data.profile?.last_name || res.data.employee?.LastName || res.data.employee?.last_name || '';
//         const fullName = [fName, mName, lName].filter(Boolean).join(' ').trim() || 'Employee';
//         const aadhaarNumber = personalForm.ssn || res.data.profile?.ssn || res.data.employee?.ssn || res.data.employee?.AadhaarNumber || res.data.employee?.aadhaar_number || '';
//         const isIndiaCandidate = ((res.data.employee?.country || res.data.profile?.country || '').toUpperCase()) === 'INDIA';

//         let offerUrlToSet = '';
//         if (isOfferSigned) {
//           if (signedOfferBase64) {
//             offerUrlToSet = base64ToBlobUrl(signedOfferBase64);
//           } else {
//             const sigObj = res.data.signature_history?.find(h => h.document_type === 'Offer Letter' && h.action === 'SIGN');
//             const sigData = sigObj?.signature_path || '';
//             let sigPng = sigData;
//             if (sigData && !sigData.startsWith('data:image')) {
//               sigPng = convertTypedToPng(sigData);
//             }
//             const signedDate = sigObj?.signed_at || sigObj?.created_at;
//             const formattedDate = formatDateMMDDYYYY(signedDate);

//             let baseToSign = res.data.employee?.offer_letter_base64 || '';
//             if (!baseToSign && realOfferUrl) {
//               try {
//                 baseToSign = await fetchLocalPdfAsBase64(realOfferUrl);
//               } catch (e) {
//                 console.error("Failed to fetch real offer letter PDF for overlay:", e);
//               }
//             }

//             if (baseToSign && (sigPng || isIndiaCandidate)) {
//               try {
//                 const signedPdfBase64 = await applySignatureToPdf(baseToSign, sigPng, fullName, 'Offer Letter', isIndiaCandidate, {
//                   fullName,
//                   aadhaarNumber,
//                   date: formattedDate
//                 });
//                 offerUrlToSet = base64ToBlobUrl(signedPdfBase64);
//               } catch (err) {
//                 console.error("Failed to generate signed PDF:", err);
//                 offerUrlToSet = realOfferUrl;
//               }
//             } else {
//               offerUrlToSet = realOfferUrl;
//             }
//           }
//         } else {
//           // Pre-sign preview: For India candidates, pre-fill Full Name and Aadhaar Number on the PDF template
//           let baseToSign = res.data.employee?.offer_letter_base64 || '';
//           if (!baseToSign && realOfferUrl) {
//             try {
//               baseToSign = await fetchLocalPdfAsBase64(realOfferUrl);
//             } catch (e) {
//               console.error("Failed to fetch real offer letter PDF for preview:", e);
//             }
//           }

//           if (baseToSign && isIndiaCandidate) {
//             try {
//               const prefilledPdfBase64 = await applySignatureToPdf(baseToSign, null, fullName, 'Offer Letter', true, {
//                 fullName,
//                 aadhaarNumber,
//                 date: ''
//               });
//               offerUrlToSet = base64ToBlobUrl(prefilledPdfBase64);
//             } catch (err) {
//               console.error("Failed to generate pre-filled offer letter preview:", err);
//               offerUrlToSet = realOfferUrl;
//             }
//           } else if (res.data.employee?.offer_letter_base64) {
//             offerUrlToSet = base64ToBlobUrl(res.data.employee.offer_letter_base64);
//           } else if (realOfferUrl) {
//             offerUrlToSet = realOfferUrl;
//           }
//         }

//         setOfferLetterBlobUrl(prev => {
//           if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//           return offerUrlToSet;
//         });

//         // Employee Agreement
//         const isAgreementSigned = res.data.signature_history?.some(
//           h => h.document_type === 'Employee Agreement' && h.action === 'SIGN'
//         );
//         if (isAgreementSigned && res.data.employee.employee_agreement_base64) {
//           const agreementUrl = base64ToBlobUrl(res.data.employee.employee_agreement_base64);
//           setEmployeeAgreementBlobUrl(prev => {
//             if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//             return agreementUrl;
//           });
//         } else {
//           // Unsigned fallback: load appropriate template directly from public folder based on country
//           const country = res.data.employee?.country || '';
//           const templatePath = country.toUpperCase() === 'USA' ? '/employee_agreement_usa.pdf' : '/3-Employment Agreement.pdf';
//           setEmployeeAgreementBlobUrl(prev => {
//             if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//             return templatePath;
//           });
//         }

//         // Multiple agreements resolution for US candidates
//         const country = res.data.employee?.country || '';
//         const isUsa = country.toUpperCase() === 'USA';
//         const list = isUsa ? [
//           { key: 'employment_agreement', title: 'Employment Agreement 1', displayName: 'Employment Agreement', path: '/Employment Agreement 1.pdf' },
//           { key: 'confidentiality_nda', title: 'Employee Confidentiality & NDA (1)', displayName: 'Employee Confidentiality & NDA', path: '/Employee Confidentiality & NDA (1).pdf' },
//           { key: 'conflict_of_interest', title: 'Conflict of interest agreement', path: '/Conflict of interest agreement.pdf' },
//           { key: '401k_dental_vision_medical', title: '401K Dental Vision Medical', path: '/401K Dental Vision Medical.pdf' },
//           { key: 'non_solicitation', title: 'Non Solicitation', path: '/Non Solicitation.pdf' }
//         ] : [
//           { key: 'employee_agreement', title: 'Employee Agreement', path: '/3-Employment Agreement.pdf' }
//         ];

//         const urls = {};
//         for (const item of list) {
//           const signedBase64 = res.data.signed_agreements?.[item.title];
//           const legacyBase64 = (item.title === 'Employee Agreement' && isAgreementSigned && res.data.employee?.employee_agreement_base64) ? res.data.employee.employee_agreement_base64 : null;
//           const base64Data = signedBase64 || legacyBase64;
//           if (base64Data) {
//             urls[item.key] = base64ToBlobUrl(base64Data);
//           } else if (item.key === 'employee_agreement') {
//             try {
//               let tBytes = indiaAgreementTemplateBytes;
//               if (!tBytes) {
//                 const resp = await fetch('/3-Employment Agreement.pdf');
//                 const ab = await resp.arrayBuffer();
//                 tBytes = new Uint8Array(ab);
//                 setIndiaAgreementTemplateBytes(tBytes);
//               }
//               let binary = '';
//               const len = tBytes.byteLength;
//               for (let i = 0; i < len; i++) {
//                 binary += String.fromCharCode(tBytes[i]);
//               }
//               const templateBase64 = btoa(binary);
//               const emp = res.data.employee || {};
//               const jDateStr = emp.joining_date || emp.JoiningDate || emp.joining_Date || emp.joiningDate || emp.joining || emp.hire_date || emp.HireDate || '2025-11-21';
//               const fName = [
//                 res.data.profile?.first_name || emp.FirstName || emp.first_name || '',
//                 res.data.profile?.middle_name || emp.MiddleName || emp.middle_name || '',
//                 res.data.profile?.last_name || emp.LastName || emp.last_name || ''
//               ].filter(Boolean).join(' ').trim() || 'Employee';

//               const prefilledBase64 = await applySignatureToPdf(
//                 templateBase64,
//                 null,
//                 fName,
//                 'Employee Agreement',
//                 true,
//                 {
//                   joiningDate: jDateStr,
//                   date: formatDateMMDDYYYY()
//                 }
//               );
//               urls[item.key] = base64ToBlobUrl(prefilledBase64);
//             } catch (prefilledErr) {
//               console.error("Failed to generate prefilled agreement Blob URL in fetchOnboardingData:", prefilledErr);
//               urls[item.key] = item.path;
//             }
//           } else {
//             urls[item.key] = item.path;
//           }
//         }
//         setAgreementBlobUrls(prev => {
//           Object.entries(prev).forEach(([key, url]) => {
//             if (url && url.startsWith('blob:') && url !== urls[key]) {
//               URL.revokeObjectURL(url);
//             }
//           });
//           return urls;
//         });
//         setSelectedAgreementKey(prev => {
//           const keys = list.map(item => item.key);
//           if (prev && keys.includes(prev)) return prev;
//           return keys[0] || '';
//         });
//       }

//       // Automatically select state in dropdown if a state tax form is already uploaded
//       if (res.data.documents) {
//         const existing = res.data.documents.find(doc =>
//           doc.document_type === 'Oregon State Tax Form' ||
//           doc.document_type === 'Arizona State Tax Form' ||
//           doc.document_type === 'Colorado State Tax Form'
//         );
//         if (existing) {
//           if (existing.document_type === 'Oregon State Tax Form') setSelectedState('oregon');
//           else if (existing.document_type === 'Arizona State Tax Form') setSelectedState('arizona');
//           else if (existing.document_type === 'Colorado State Tax Form') setSelectedState('colorado');
//         }
//       }

//       // Check for pending requested documents to show popup alert
//       const reqList = res.data?.requested_documents || res.data?.requested_employee_documents || [];
//       const pendingReqs = reqList.filter(req => {
//         const rStatus = (req.status || '').toUpperCase();
//         const rName = (req.document_name || req.document_type || req.title || req.name || '').trim();
//         const isUploadedInEmpDocs = res.data?.documents?.some(d => d.document_type === rName);
//         return rStatus !== 'UPLOADED' && !isUploadedInEmpDocs;
//       });

//       if (pendingReqs.length > 0 && !hasSeenRequestedDocsModal) {
//         setShowRequestedDocsModal(true);
//       }
//       window.dispatchEvent(new Event('onboarding_updated'));
//     } catch (err) {
//       setToast({ message: 'Failed to load onboarding profile details.', type: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   }, [hasSeenRequestedDocsModal]);

//   useEffect(() => {
//     fetchOnboardingData();
//   }, [fetchOnboardingData, activeTab]);

//   // Cleanup Blob URLs on unmount
//   useEffect(() => {
//     return () => {
//       setOfferLetterBlobUrl(prev => {
//         if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//         return '';
//       });
//       setEmployeeAgreementBlobUrl(prev => {
//         if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//         return '';
//       });
//       setAgreementBlobUrls(prev => {
//         Object.values(prev).forEach(url => {
//           if (url && url.startsWith('blob:')) URL.revokeObjectURL(url);
//         });
//         return {};
//       });
//     };
//   }, []);

//   const isLocked = dashboardStats?.status === 'PENDING_HR_REVIEW' || dashboardStats?.status === 'COMPLETED';

//   // Save Personal Info (with SSN & I-9 validation)
//   const handleSavePersonal = async (e) => {
//     e.preventDefault();
//     if (isLocked) return;
//     try {
//       await api.post('/onboarding/personal', personalForm);
//       setToast({ message: 'Personal Information saved successfully!', type: 'success' });
//       window.dispatchEvent(new Event('onboarding_updated'));
//       fetchOnboardingData();
//     } catch (err) {
//       setToast({ message: err.response?.data?.error || 'Failed to save personal info.', type: 'error' });
//     }
//   };

//   const handleSaveI9Attestation = async () => {
//     if (isLocked) return;
//     try {
//       const citizenVal = `${i9Attestation}${uscisNumber ? ' (' + uscisNumber + ')' : ''}`;
//       await api.post('/onboarding/personal', {
//         ...personalForm,
//         citizenship: citizenVal
//       });
//       setToast({ message: 'Form I-9 Eligibility attestation recorded successfully!', type: 'success' });
//       window.dispatchEvent(new Event('onboarding_updated'));
//       fetchOnboardingData();
//     } catch (err) {
//       setToast({ message: 'Failed to save Form I-9 attestation.', type: 'error' });
//     }
//   };

//   // Save Emergency Contacts
//   const handleSaveContacts = async (e) => {
//     e.preventDefault();
//     if (isLocked) return;
//     try {
//       await api.post('/onboarding/contacts', emergencyContacts);
//       setToast({ message: 'Emergency Contacts saved successfully!', type: 'success' });
//       window.dispatchEvent(new Event('onboarding_updated'));
//       fetchOnboardingData();
//     } catch (err) {
//       setToast({ message: err.response?.data?.error || 'Failed to save emergency contacts.', type: 'error' });
//     }
//   };

//   const handleAddContact = () => {
//     if (isLocked) return;
//     setEmergencyContacts([...emergencyContacts, { name: '', relationship: '', phone: '', email: '', address: '' }]);
//   };

//   const handleRemoveContact = (index) => {
//     if (isLocked) return;
//     const updated = emergencyContacts.filter((_, idx) => idx !== index);
//     setEmergencyContacts(updated);
//   };

//   const handleContactChange = (index, field, value) => {
//     if (isLocked) return;
//     const updated = emergencyContacts.map((c, idx) => {
//       if (idx === index) return { ...c, [field]: value };
//       return c;
//     });
//     setEmergencyContacts(updated);
//   };

//   // Save Bank Info
//   const handleSaveBank = async (e) => {
//     if (e && e.preventDefault) e.preventDefault();
//     if (isLocked) return;
//     if (!bankForm.bank_name || !bankForm.routing_number || !bankForm.account_number || !bankForm.bank_branch_address) {
//       setToast({ message: 'Please fill in all required bank detail fields.', type: 'error' });
//       return;
//     }
//     const hasVoidCheque = data?.documents?.some(doc => doc.document_type === 'Void Cheque' && doc.file_path && doc.file_path !== 'NOT_AVAILABLE');
//     if (!hasVoidCheque) {
//       setToast({ message: 'Please upload Cancelled Cheque / Bank Account Proof.', type: 'error' });
//       return;
//     }
//     try {
//       await api.post('/onboarding/bank', bankForm);
//       setToast({ message: 'Bank Details saved successfully!', type: 'success' });
//       window.dispatchEvent(new Event('onboarding_updated'));
//       fetchOnboardingData();
//     } catch (err) {
//       setToast({ message: err.response?.data?.error || 'Failed to save bank setup.', type: 'error' });
//     }
//   };

//   // PDF state variables
//   const [templateBytes, setTemplateBytes] = useState(null);
//   const [pdfPreviewUrl, setPdfPreviewUrl] = useState('');
//   const [pdfBase64, setPdfBase64] = useState('');

//   // Load Arizona A-4 template once when activeTab is 'tax'
//   useEffect(() => {
//     if (activeTab === 'tax' && !templateBytes) {
//       const loadTemplate = async () => {
//         try {
//           const res = await api.get('/onboarding/tax-template', { responseType: 'arraybuffer' });
//           setTemplateBytes(res.data);
//         } catch (err) {
//           console.error('Failed to load PDF template:', err);
//         }
//       };
//       loadTemplate();
//     }
//   }, [activeTab, templateBytes]);

//   const generatePdfPreview = useCallback(async (formValues) => {
//     if (!templateBytes) return;
//     try {
//       const pdfDoc = await PDFDocument.load(templateBytes);
//       const form = pdfDoc.getForm();
//       const pages = pdfDoc.getPages();
//       const firstPage = pages[0];

//       // Fill text fields
//       const setFieldText = (name, val) => {
//         try {
//           const field = form.getTextField(name);
//           let textVal = val || '';
//           try {
//             const maxLen = field.getMaxLength();
//             if (maxLen && textVal.length > maxLen) {
//               textVal = textVal.substring(0, maxLen);
//             }
//           } catch (e) { }
//           field.setText(textVal);
//         } catch (e) {
//           console.warn(`Could not set text field ${name}:`, e);
//         }
//       };

//       setFieldText('Name', formValues.name);
//       setFieldText('SSN', formValues.ssn);
//       setFieldText('Address', formValues.address);
//       setFieldText('City', formValues.city);
//       setFieldText('State', formValues.state);
//       setFieldText('Zip', formValues.zip);

//       // Embed ZapfDingbats for drawing checkmark symbols
//       const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);
//       const drawTick = (x, y) => {
//         try {
//           firstPage.drawText('\u2714', {
//             x: x + 1,
//             y: y + 1,
//             size: 9.5,
//             font: dingbatsFont,
//             color: rgb(0, 0, 0)
//           });
//         } catch (e) {
//           console.error('Failed to draw checkmark:', e);
//         }
//       };

//       // We explicitly uncheck all interactive fields so PDF viewers do not overlay a cross (X)
//       const clearCheckbox = (name) => {
//         try {
//           form.getCheckBox(name).uncheck();
//         } catch (e) { }
//       };

//       ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'j', 'chkExtraWH'].forEach(clearCheckbox);

//       if (formValues.arizona_box_selection === 1) {
//         drawTick(35.6678, 585.824); // a (Line 1 check)
//         const rate = formValues.arizona_percentage;
//         if (rate === 0.5) drawTick(64.4593, 573.772); // b
//         else if (rate === 1.0) drawTick(136.469, 573.865); // c
//         else if (rate === 1.5) drawTick(208.415, 573.865); // d
//         else if (rate === 2.0) drawTick(280.506, 573.865); // e
//         else if (rate === 2.5) drawTick(351.469, 573.865); // f
//         else if (rate === 3.0) drawTick(423.415, 573.865); // g
//         else if (rate === 3.5) drawTick(495.524, 573.865); // h
//       } else if (formValues.arizona_box_selection === 2) {
//         drawTick(35.6678, 525.79); // j (Line 2 check)
//       }

//       if (formValues.arizona_extra_amount_checked) {
//         drawTick(63.1453, 549.593); // chkExtraWH
//         const amt = parseFloat(formValues.arizona_extra_amount) || 0.0;
//         const dollarsStr = Math.floor(amt).toString();
//         const centsVal = Math.round((amt % 1) * 100);
//         const centsStr = centsVal < 10 ? '0' + centsVal : centsVal.toString();
//         setFieldText('i', dollarsStr);
//         setFieldText('i1', centsStr);
//       } else {
//         setFieldText('i', '');
//         setFieldText('i1', '');
//       }

//       if (formValues.signature) {
//         let sigUrl = formValues.signature;
//         if (!sigUrl.startsWith('data:image')) {
//           sigUrl = convertTypedToPng(sigUrl);
//         }

//         try {
//           const sigImage = await pdfDoc.embedPng(sigUrl);
//           firstPage.drawImage(sigImage, {
//             x: 40,
//             y: 450,
//             width: 180,
//             height: 30
//           });

//           const dateFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//           const dateStr = new Date().toLocaleDateString('en-US');
//           firstPage.drawText(dateStr, {
//             x: 435,
//             y: 455,
//             size: 10,
//             font: dateFont,
//             color: rgb(0, 0, 0)
//           });
//         } catch (sigErr) {
//           console.error('Error embedding signature into PDF:', sigErr);
//         }
//       }

//       const pdfBytes = await pdfDoc.save();
//       const binaryString = new Uint8Array(pdfBytes).reduce(
//         (data, byte) => data + String.fromCharCode(byte),
//         ''
//       );
//       const base64Str = btoa(binaryString);
//       setPdfBase64(base64Str);
//       const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//       const newUrl = URL.createObjectURL(blob);

//       setPdfPreviewUrl(prevUrl => {
//         if (prevUrl) URL.revokeObjectURL(prevUrl);
//         return newUrl;
//       });
//     } catch (err) {
//       console.error('Error generating PDF preview:', err);
//     }
//   }, [templateBytes]);

//   // Debounced PDF preview generation
//   useEffect(() => {
//     if (!templateBytes) return;
//     const timer = setTimeout(() => {
//       generatePdfPreview(taxForm);
//     }, 250);
//     return () => clearTimeout(timer);
//   }, [taxForm, templateBytes, generatePdfPreview]);

//   // Revoke Blob URL on unmount
//   useEffect(() => {
//     return () => {
//       setPdfPreviewUrl(prevUrl => {
//         if (prevUrl) URL.revokeObjectURL(prevUrl);
//         return '';
//       });
//     };
//   }, []);

//   // Load Employment Agreement 1 template once when activeTab is 'agreement' and selectedAgreementKey is 'employment_agreement'
//   useEffect(() => {
//     if (activeTab === 'agreement' && selectedAgreementKey === 'employment_agreement' && !agreementTemplateBytes) {
//       const loadTemplate = async () => {
//         try {
//           const response = await fetch('/Employment Agreement 1.pdf');
//           const arrayBuffer = await response.arrayBuffer();
//           setAgreementTemplateBytes(new Uint8Array(arrayBuffer));
//         } catch (e) {
//           console.error("Failed to load agreement template:", e);
//         }
//       };
//       loadTemplate();
//     }
//   }, [activeTab, selectedAgreementKey, agreementTemplateBytes]);

//   // Load India Employment Agreement template once when needed
//   useEffect(() => {
//     if (!indiaAgreementTemplateBytes) {
//       const loadTemplate = async () => {
//         try {
//           const response = await fetch('/3-Employment Agreement.pdf');
//           const arrayBuffer = await response.arrayBuffer();
//           setIndiaAgreementTemplateBytes(new Uint8Array(arrayBuffer));
//         } catch (e) {
//           console.error("Failed to load India agreement template:", e);
//         }
//       };
//       loadTemplate();
//     }
//   }, [indiaAgreementTemplateBytes]);

//   // Debounced PDF preview generation for India Employment Agreement
//   useEffect(() => {
//     if (selectedAgreementKey === 'employee_agreement' && indiaAgreementTemplateBytes && data?.employee) {
//       if (data?.signature_history?.some(h => h.document_type === 'Employee Agreement' && h.action === 'SIGN')) {
//         return;
//       }
//       const timer = setTimeout(async () => {
//         try {
//           const emp = data.employee;
//           const fullName = `${emp.FirstName || ''} ${emp.LastName || ''}`.trim() || 'Employee';
//           // Convert template bytes to binary base64
//           let binary = '';
//           const len = indiaAgreementTemplateBytes.byteLength;
//           for (let i = 0; i < len; i++) {
//             binary += String.fromCharCode(indiaAgreementTemplateBytes[i]);
//           }
//           const templateBase64 = btoa(binary);

//           // Generate pre-sign PDF with Name, Date, and dynamic joining date on Page 1
//           const joiningDateStr = emp.joining_date || emp.JoiningDate || emp.joining_Date || emp.joiningDate || emp.joining || emp.hire_date || emp.HireDate || employmentForm.hireDate;
//           const base64 = await applySignatureToPdf(
//             templateBase64,
//             null, // no signature yet
//             fullName,
//             'Employee Agreement',
//             true,
//             {
//               joiningDate: joiningDateStr,
//               date: formatDateMMDDYYYY()
//             }
//           );
//           const pdfBytes = base64ToUint8Array(base64);
//           const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//           const newUrl = URL.createObjectURL(blob);

//           setAgreementBlobUrls(prev => {
//             const oldUrl = prev['employee_agreement'];
//             if (oldUrl && oldUrl.startsWith('blob:')) {
//               URL.revokeObjectURL(oldUrl);
//             }
//             return {
//               ...prev,
//               'employee_agreement': newUrl
//             };
//           });
//         } catch (err) {
//           console.error("Failed to generate India agreement preview:", err);
//         }
//       }, 250);
//       return () => clearTimeout(timer);
//     }
//   }, [indiaAgreementTemplateBytes, selectedAgreementKey, data, employmentForm.hireDate]);

//   // Debounced PDF preview generation for Employment Agreement 1
//   useEffect(() => {
//     if (activeTab === 'agreement' && selectedAgreementKey === 'employment_agreement' && agreementTemplateBytes) {
//       if (data?.signature_history?.some(h => (h.document_type === 'Employment Agreement 1' || h.document_type === 'Employment Agreement') && h.action === 'SIGN')) {
//         return;
//       }
//       const timer = setTimeout(async () => {
//         const base64 = await generateAgreementPdfData(agreementTemplateBytes, employmentForm, null);
//         const pdfBytes = base64ToUint8Array(base64);
//         const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//         const newUrl = URL.createObjectURL(blob);

//         setAgreementBlobUrls(prev => {
//           const oldUrl = prev['employment_agreement'];
//           if (oldUrl && oldUrl.startsWith('blob:')) {
//             URL.revokeObjectURL(oldUrl);
//           }
//           return {
//             ...prev,
//             'employment_agreement': newUrl
//           };
//         });
//       }, 250);
//       return () => clearTimeout(timer);
//     }
//   }, [employmentForm, agreementTemplateBytes, activeTab, selectedAgreementKey, data]);

//   // Load NDA template once when activeTab is 'agreement' and selectedAgreementKey is 'confidentiality_nda'
//   useEffect(() => {
//     if (activeTab === 'agreement' && selectedAgreementKey === 'confidentiality_nda' && !ndaTemplateBytes) {
//       const loadTemplate = async () => {
//         try {
//           const response = await fetch('/Employee Confidentiality & NDA (1).pdf');
//           const arrayBuffer = await response.arrayBuffer();
//           setNdaTemplateBytes(new Uint8Array(arrayBuffer));
//         } catch (e) {
//           console.error("Failed to load NDA template:", e);
//         }
//       };
//       loadTemplate();
//     }
//   }, [activeTab, selectedAgreementKey, ndaTemplateBytes]);

//   // Debounced PDF preview generation for Confidentiality & NDA
//   useEffect(() => {
//     if (activeTab === 'agreement' && selectedAgreementKey === 'confidentiality_nda' && ndaTemplateBytes) {
//       if (data?.signature_history?.some(h => (h.document_type === 'Employee Confidentiality & NDA (1)' || h.document_type === 'Employee Confidentiality & NDA') && h.action === 'SIGN')) {
//         return;
//       }
//       const timer = setTimeout(async () => {
//         const base64 = await generateNdaPdfData(ndaTemplateBytes, employmentForm, null);
//         const pdfBytes = base64ToUint8Array(base64);
//         const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//         const newUrl = URL.createObjectURL(blob);

//         setAgreementBlobUrls(prev => {
//           const oldUrl = prev['confidentiality_nda'];
//           if (oldUrl && oldUrl.startsWith('blob:')) {
//             URL.revokeObjectURL(oldUrl);
//           }
//           return {
//             ...prev,
//             'confidentiality_nda': newUrl
//           };
//         });
//       }, 250);
//       return () => clearTimeout(timer);
//     }
//   }, [employmentForm, ndaTemplateBytes, activeTab, selectedAgreementKey, data]);

//   // Load Conflict of Interest template once when activeTab is 'agreement' and selectedAgreementKey is 'conflict_of_interest'
//   useEffect(() => {
//     if (activeTab === 'agreement' && selectedAgreementKey === 'conflict_of_interest' && !conflictTemplateBytes) {
//       const loadTemplate = async () => {
//         try {
//           const response = await fetch('/Conflict of interest agreement.pdf');
//           const arrayBuffer = await response.arrayBuffer();
//           setConflictTemplateBytes(new Uint8Array(arrayBuffer));
//         } catch (e) {
//           console.error("Failed to load Conflict of Interest template:", e);
//         }
//       };
//       loadTemplate();
//     }
//   }, [activeTab, selectedAgreementKey, conflictTemplateBytes]);

//   // Debounced PDF preview generation for Conflict of Interest
//   useEffect(() => {
//     if (activeTab === 'agreement' && selectedAgreementKey === 'conflict_of_interest' && conflictTemplateBytes) {
//       if (data?.signature_history?.some(h => h.document_type === 'Conflict of interest agreement' && h.action === 'SIGN')) {
//         return;
//       }
//       const timer = setTimeout(async () => {
//         const base64 = await generateConflictPdfData(conflictTemplateBytes, employmentForm, null);
//         const pdfBytes = base64ToUint8Array(base64);
//         const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//         const newUrl = URL.createObjectURL(blob);

//         setAgreementBlobUrls(prev => {
//           const oldUrl = prev['conflict_of_interest'];
//           if (oldUrl && oldUrl.startsWith('blob:')) {
//             URL.revokeObjectURL(oldUrl);
//           }
//           return {
//             ...prev,
//             'conflict_of_interest': newUrl
//           };
//         });
//       }, 250);
//       return () => clearTimeout(timer);
//     }
//   }, [employmentForm, conflictTemplateBytes, activeTab, selectedAgreementKey, data]);

//   // Load Benefits Enrollment template once when activeTab is 'agreement' and selectedAgreementKey is '401k_dental_vision_medical'
//   useEffect(() => {
//     if (activeTab === 'agreement' && selectedAgreementKey === '401k_dental_vision_medical' && !benefitsTemplateBytes) {
//       const loadTemplate = async () => {
//         try {
//           const response = await fetch('/401K Dental Vision Medical.pdf');
//           const arrayBuffer = await response.arrayBuffer();
//           setBenefitsTemplateBytes(new Uint8Array(arrayBuffer));
//         } catch (e) {
//           console.error("Failed to load Benefits template:", e);
//         }
//       };
//       loadTemplate();
//     }
//   }, [activeTab, selectedAgreementKey, benefitsTemplateBytes]);

//   // Debounced PDF preview generation for Benefits Enrollment
//   useEffect(() => {
//     if (activeTab === 'agreement' && selectedAgreementKey === '401k_dental_vision_medical' && benefitsTemplateBytes) {
//       if (data?.signature_history?.some(h => h.document_type === '401K Dental Vision Medical' && h.action === 'SIGN')) {
//         return;
//       }
//       const timer = setTimeout(async () => {
//         const base64 = await generateBenefitsPdfData(benefitsTemplateBytes, employmentForm, null);
//         const pdfBytes = base64ToUint8Array(base64);
//         const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//         const newUrl = URL.createObjectURL(blob);

//         setAgreementBlobUrls(prev => {
//           const oldUrl = prev['401k_dental_vision_medical'];
//           if (oldUrl && oldUrl.startsWith('blob:')) {
//             URL.revokeObjectURL(oldUrl);
//           }
//           return {
//             ...prev,
//             '401k_dental_vision_medical': newUrl
//           };
//         });
//       }, 250);
//       return () => clearTimeout(timer);
//     }
//   }, [employmentForm, benefitsTemplateBytes, activeTab, selectedAgreementKey, data]);

//   // Load Non Solicitation template once when activeTab is 'agreement' and selectedAgreementKey is 'non_solicitation'
//   useEffect(() => {
//     if (activeTab === 'agreement' && selectedAgreementKey === 'non_solicitation' && !nonSolicitationTemplateBytes) {
//       const loadTemplate = async () => {
//         try {
//           const response = await fetch('/Non Solicitation.pdf');
//           const arrayBuffer = await response.arrayBuffer();
//           setNonSolicitationTemplateBytes(new Uint8Array(arrayBuffer));
//         } catch (e) {
//           console.error("Failed to load Non Solicitation template:", e);
//         }
//       };
//       loadTemplate();
//     }
//   }, [activeTab, selectedAgreementKey, nonSolicitationTemplateBytes]);

//   // Debounced PDF preview generation for Non Solicitation
//   useEffect(() => {
//     if (activeTab === 'agreement' && selectedAgreementKey === 'non_solicitation' && nonSolicitationTemplateBytes) {
//       if (data?.signature_history?.some(h => h.document_type === 'Non Solicitation' && h.action === 'SIGN')) {
//         return;
//       }
//       const timer = setTimeout(async () => {
//         const base64 = await generateNonSolicitationPdfData(nonSolicitationTemplateBytes, employmentForm, null);
//         const pdfBytes = base64ToUint8Array(base64);
//         const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//         const newUrl = URL.createObjectURL(blob);

//         setAgreementBlobUrls(prev => {
//           const oldUrl = prev['non_solicitation'];
//           if (oldUrl && oldUrl.startsWith('blob:')) {
//             URL.revokeObjectURL(oldUrl);
//           }
//           return {
//             ...prev,
//             'non_solicitation': newUrl
//           };
//         });
//       }, 250);
//       return () => clearTimeout(timer);
//     }
//   }, [employmentForm, nonSolicitationTemplateBytes, activeTab, selectedAgreementKey, data]);

//   const handleApplySignature = (sigValue, sigType) => {
//     setTaxForm(prev => ({ ...prev, signature: sigValue }));
//     if (sigValue) {
//       setToast({ message: 'Signature applied to PDF preview!', type: 'success' });
//     }
//   };

//   const handleSaveTaxSubmit = async () => {
//     if (isLocked) return;
//     if (!taxForm.signature) {
//       setToast({ message: 'Please sign the form first.', type: 'error' });
//       return;
//     }
//     try {
//       await api.post('/onboarding/tax', {
//         federal_tax_status: taxForm.federal_tax_status,
//         federal_allowances: taxForm.federal_allowances,
//         state_tax_status: taxForm.state_tax_status,
//         state_allowances: taxForm.state_allowances,
//         signature: taxForm.signature,
//         arizona_box_selection: taxForm.arizona_box_selection,
//         arizona_percentage: taxForm.arizona_percentage,
//         arizona_extra_amount_checked: taxForm.arizona_extra_amount_checked ? 1 : 0,
//         arizona_extra_amount: taxForm.arizona_extra_amount || 0.00,
//         signed_pdf: pdfBase64
//       });
//       setToast({ message: 'Tax elections signed and saved successfully!', type: 'success' });
//       fetchOnboardingData();
//     } catch (err) {
//       setToast({ message: err.response?.data?.error || 'Failed to save tax elections.', type: 'error' });
//     }
//   };

//   const downloadPdf = () => {
//     if (!pdfPreviewUrl) return;
//     const link = document.createElement('a');
//     link.href = pdfPreviewUrl;
//     link.download = `Arizona_Form_A4_${(taxForm.name || 'Employee').replace(/\s+/g, '_')}.pdf`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // Accept Corporate Policy
//   const handlePolicyAccept = async (sigData) => {
//     if (isLocked) return;
//     try {
//       setLoading(true);
//       let signaturePng = sigData;
//       if (sigData && !sigData.startsWith('data:image')) {
//         signaturePng = convertTypedToPng(sigData);
//       }

//       const fullName = `${employee?.FirstName || ''} ${employee?.LastName || ''}`.trim() || 'Employee';
//       const signedPdfBase64 = await createPoliciesPdf(fullName, signaturePng);

//       await api.post('/onboarding/policies', {
//         signature: sigData,
//         signed_pdf: signedPdfBase64
//       });
//       setToast({ message: 'All company policies accepted successfully and PDF generated!', type: 'success' });
//       window.dispatchEvent(new Event('onboarding_updated'));
//       fetchOnboardingData();
//     } catch (err) {
//       setToast({ message: err.response?.data?.error || 'Failed to record policies signature.', type: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Sign Hiring Hub Document (Offer Letter / Employee Agreement)
//   const handleDocumentSign = async (docType, sigData) => {
//     if (isLocked) return;
//     try {
//       setLoading(true);
//       // 1. Process signature image: if it is a typed signature, convert it to a canvas image URL
//       let signaturePng = sigData;
//       if (sigData && !sigData.startsWith('data:image')) {
//         signaturePng = convertTypedToPng(sigData);
//       }

//       // 2. Resolve original PDF base64
//       let originalBase64 = '';
//       if (docType === 'Offer Letter') {
//         originalBase64 = employee?.offer_letter_base64 || data?.employee?.offer_letter_base64;
//         if (!originalBase64) {
//           const rawPath = employee?.offer_letter || employee?.offer_letter_path || data?.employee?.offer_letter || data?.employee?.offer_letter_path;
//           let targetUrl = '';
//           if (rawPath) {
//             let cleanPath = rawPath.replace(/^\//, '');
//             if (!cleanPath.startsWith('http://') && !cleanPath.startsWith('https://')) {
//               cleanPath = cleanPath.startsWith('offer_letters/')
//                 ? `https://hiring.gtelinq.com/hiring-backend/${cleanPath}`
//                 : `/EOP_api/${cleanPath}`;
//             }
//             targetUrl = cleanPath;
//           }
//           if (targetUrl) {
//             try {
//               originalBase64 = await fetchLocalPdfAsBase64(targetUrl);
//             } catch (e) {
//               console.error("Failed to fetch offer letter URL as base64:", e);
//             }
//           }
//           if (!originalBase64 && offerLetterBlobUrl) {
//             try {
//               originalBase64 = await fetchLocalPdfAsBase64(offerLetterBlobUrl);
//             } catch (e) {
//               console.error("Failed to fetch offerLetterBlobUrl as base64:", e);
//             }
//           }
//         }
//       } else {
//         try {
//           const country = employee?.country || '';
//           const isUsa = country.toUpperCase() === 'USA';
//           let templatePath = '';
//           if (isUsa) {
//             const list = [
//               { title: 'Employment Agreement 1', displayName: 'Employment Agreement', path: '/Employment Agreement 1.pdf' },
//               { title: 'Employee Confidentiality & NDA (1)', displayName: 'Employee Confidentiality & NDA', path: '/Employee Confidentiality & NDA (1).pdf' },
//               { title: 'Conflict of interest agreement', path: '/Conflict of interest agreement.pdf' },
//               { title: '401K Dental Vision Medical', path: '/401K Dental Vision Medical.pdf' },
//               { title: 'Non Solicitation', path: '/Non Solicitation.pdf' }
//             ];
//             const found = list.find(item => item.title === docType);
//             templatePath = found ? found.path : '/employee_agreement_usa.pdf';
//           } else {
//             templatePath = '/3-Employment Agreement.pdf';
//           }
//           originalBase64 = await fetchLocalPdfAsBase64(templatePath);
//         } catch (fetchErr) {
//           console.error("Failed to fetch local agreement PDF template:", fetchErr);
//           originalBase64 = employee.employee_agreement_base64;
//         }
//       }

//       // 3. Draw signature on the PDF
//       let signedPdfBase64 = '';
//       if (docType === 'Employment Agreement 1' || docType === 'Employment Agreement') {
//         let templateBytes = agreementTemplateBytes;
//         if (!templateBytes) {
//           const response = await fetch('/Employment Agreement 1.pdf');
//           const arrayBuffer = await response.arrayBuffer();
//           templateBytes = new Uint8Array(arrayBuffer);
//         }
//         signedPdfBase64 = await generateAgreementPdfData(templateBytes, employmentForm, signaturePng);
//       } else if (docType === 'Employee Confidentiality & NDA (1)' || docType === 'Employee Confidentiality & NDA') {
//         let templateBytes = ndaTemplateBytes;
//         if (!templateBytes) {
//           const response = await fetch('/Employee Confidentiality & NDA (1).pdf');
//           const arrayBuffer = await response.arrayBuffer();
//           templateBytes = new Uint8Array(arrayBuffer);
//         }
//         signedPdfBase64 = await generateNdaPdfData(templateBytes, employmentForm, signaturePng);
//       } else if (docType === 'Conflict of interest agreement') {
//         let templateBytes = conflictTemplateBytes;
//         if (!templateBytes) {
//           const response = await fetch('/Conflict of interest agreement.pdf');
//           const arrayBuffer = await response.arrayBuffer();
//           templateBytes = new Uint8Array(arrayBuffer);
//         }
//         signedPdfBase64 = await generateConflictPdfData(templateBytes, employmentForm, signaturePng);
//       } else if (docType === '401K Dental Vision Medical') {
//         let templateBytes = benefitsTemplateBytes;
//         if (!templateBytes) {
//           const response = await fetch('/401K Dental Vision Medical.pdf');
//           const arrayBuffer = await response.arrayBuffer();
//           templateBytes = new Uint8Array(arrayBuffer);
//         }
//         signedPdfBase64 = await generateBenefitsPdfData(templateBytes, employmentForm, signaturePng);
//       } else if (docType === 'Non Solicitation') {
//         let templateBytes = nonSolicitationTemplateBytes;
//         if (!templateBytes) {
//           const response = await fetch('/Non Solicitation.pdf');
//           const arrayBuffer = await response.arrayBuffer();
//           templateBytes = new Uint8Array(arrayBuffer);
//         }
//         signedPdfBase64 = await generateNonSolicitationPdfData(templateBytes, employmentForm, signaturePng);
//       } else {
//         const fName = personalForm.first_name || data?.profile?.first_name || employee?.FirstName || employee?.first_name || '';
//         const mName = personalForm.middle_name || data?.profile?.middle_name || employee?.MiddleName || employee?.middle_name || '';
//         const lName = personalForm.last_name || data?.profile?.last_name || employee?.LastName || employee?.last_name || '';
//         const fullName = [fName, mName, lName].filter(Boolean).join(' ').trim() || 'Employee';
//         const aadhaarNumber = personalForm.ssn || data?.profile?.ssn || employee?.ssn || employee?.AadhaarNumber || employee?.aadhaar_number || '';
//         const formattedDate = formatDateMMDDYYYY(new Date());

//         const isIndiaCandidate = ((employee?.country || data?.employee?.country || personalForm?.country || '').toUpperCase()) === 'INDIA';
//         const joiningDateStr = employee?.joining_date || employee?.JoiningDate || data?.employee?.joining_date || data?.employee?.JoiningDate || employmentForm?.hireDate || personalForm?.hireDate;
//         signedPdfBase64 = await applySignatureToPdf(originalBase64, signaturePng, fullName, docType, isIndiaCandidate, {
//           fullName,
//           aadhaarNumber,
//           date: formattedDate,
//           joiningDate: joiningDateStr
//         });
//       }

//       // 4. Send to backend
//       await api.post('/onboarding/agreements', {
//         document_type: docType,
//         signature: sigData,
//         signed_pdf: signedPdfBase64
//       });

//       // Auto-upload signed offer letter to employee_documents table for checklist storage
//       if (docType === 'Offer Letter' && signedPdfBase64) {
//         try {
//           await api.post('/onboarding/upload', {
//             document_type: 'Signed Offer Letter',
//             file: signedPdfBase64.startsWith('data:') ? signedPdfBase64 : `data:application/pdf;base64,${signedPdfBase64}`
//           });
//         } catch (uploadErr) {
//           console.warn("Auto upload of Signed Offer Letter to documents table failed:", uploadErr);
//         }

//         // Set live blob URL preview of signed offer letter
//         const signedUrl = base64ToBlobUrl(signedPdfBase64);
//         setOfferLetterBlobUrl(prev => {
//           if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//           return signedUrl;
//         });
//       }

//       setToast({ message: `${docType} signed successfully!`, type: 'success' });
//       window.dispatchEvent(new Event('onboarding_updated'));
//       await fetchOnboardingData();
//     } catch (err) {
//       console.error(err);
//       setToast({ message: err.response?.data?.error || err.message || 'Failed to apply document signature.', type: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Save Photo Badge headshot
//   const handlePhotoUpload = (e) => {
//     if (isLocked) return;
//     const file = e.target.files[0];
//     if (file) {
//       if (file.size > 5 * 1024 * 1024) {
//         setToast({ message: 'This file is not accepted. File size exceeds maximum limit of 5MB.', type: 'error' });
//         e.target.value = '';
//         return;
//       }
//       if (!file.type.match(/^image\/(jpeg|png|jpg|webp)$/i)) {
//         setToast({ message: 'This file is not accepted. Only image files (JPG, PNG, WEBP) are allowed.', type: 'error' });
//         e.target.value = '';
//         return;
//       }

//       setUploadingPhoto(true);
//       const reader = new FileReader();
//       reader.onload = async (event) => {
//         try {
//           await api.post('/onboarding/photo', { photo: event.target.result });
//           setToast({ message: 'Profile badge photo uploaded successfully!', type: 'success' });
//           window.dispatchEvent(new Event('onboarding_updated'));
//           await fetchOnboardingData();
//         } catch (err) {
//           setToast({ message: err.response?.data?.error || 'Failed to upload photo.', type: 'error' });
//         } finally {
//           setUploadingPhoto(false);
//           e.target.value = '';
//         }
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Delete Photo Badge headshot
//   const handleDeletePhoto = async () => {
//     if (isLocked) return;
//     if (!window.confirm('Are you sure you want to delete your badge profile photo?')) return;
//     try {
//       setUploadingPhoto(true);
//       await api.delete('/onboarding/photo');
//       setToast({ message: 'Profile photo deleted successfully!', type: 'success' });
//       window.dispatchEvent(new Event('onboarding_updated'));
//       await fetchOnboardingData();
//     } catch (err) {
//       setToast({ message: err.response?.data?.error || 'Failed to delete photo.', type: 'error' });
//     } finally {
//       setUploadingPhoto(false);
//     }
//   };

//   // Submit Onboarding
//   const handleSubmitOnboarding = async () => {
//     const requestedDocsList = data?.requested_documents || data?.requested_employee_documents || [];
//     const pendingOrUploadedReqs = requestedDocsList.filter(r => {
//       const s = (r.status || '').toUpperCase();
//       return s !== 'SUBMITTED' && s !== 'COMPLETED' && s !== 'APPROVED';
//     });
//     if (isLocked && pendingOrUploadedReqs.length === 0) return;
//     setSubmitStatus('submitting');
//     setSubmitErrorMessage('');
//     try {
//       // Artificial delay to allow user to see the loading progress
//       await new Promise((resolve) => setTimeout(resolve, 1800));
//       await api.post('/onboarding/submit');
//       setSubmitStatus('success');
//       setRequestedDocsSubmitted(true);
//       fetchOnboardingData();
//     } catch (err) {
//       setSubmitStatus('error');
//       setSubmitErrorMessage(err.response?.data?.error || 'Failed to submit onboarding.');
//     }
//   };

//   // Helper to open PDF in a new tab natively using Blob URL
//   const handleViewPdf = (base64Data, fileName = 'document.pdf') => {
//     try {
//       if (!base64Data) {
//         setToast({ message: 'No PDF data available.', type: 'error' });
//         return;
//       }
//       if (base64Data.startsWith('/') || base64Data.startsWith('blob:') || base64Data.startsWith('http')) {
//         const newWindow = window.open();
//         if (newWindow) {
//           newWindow.document.title = fileName;
//           newWindow.location.href = base64Data;
//         } else {
//           // Fallback: download if blocked
//           const a = document.createElement('a');
//           a.href = base64Data;
//           a.download = fileName;
//           document.body.appendChild(a);
//           a.click();
//           document.body.removeChild(a);
//         }
//         return;
//       }
//       const arr = base64ToUint8Array(base64Data);
//       if (arr.length === 0) {
//         setToast({ message: 'Failed to decode PDF data.', type: 'error' });
//         return;
//       }
//       const blob = new Blob([arr], { type: 'application/pdf' });
//       const url = URL.createObjectURL(blob);

//       const newWindow = window.open();
//       if (newWindow) {
//         newWindow.document.title = fileName;
//         newWindow.location.href = url;
//       } else {
//         // Fallback: download if blocked
//         const a = document.createElement('a');
//         a.href = url;
//         a.download = fileName;
//         document.body.appendChild(a);
//         a.click();
//         document.body.removeChild(a);
//       }
//     } catch (err) {
//       setToast({ message: 'Failed to load PDF. Please try downloading it.', type: 'error' });
//     }
//   };

//   const handleDownloadPdf = (base64Data, fileName = 'document.pdf') => {
//     try {
//       if (!base64Data) {
//         setToast({ message: 'No PDF data available.', type: 'error' });
//         return;
//       }
//       if (base64Data.startsWith('/') || base64Data.startsWith('blob:') || base64Data.startsWith('http')) {
//         const a = document.createElement('a');
//         a.href = base64Data;
//         a.download = fileName;
//         document.body.appendChild(a);
//         a.click();
//         document.body.removeChild(a);
//         return;
//       }
//       const arr = base64ToUint8Array(base64Data);
//       if (arr.length === 0) {
//         setToast({ message: 'Failed to decode PDF data.', type: 'error' });
//         return;
//       }
//       const blob = new Blob([arr], { type: 'application/pdf' });
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = fileName;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       URL.revokeObjectURL(url);
//     } catch (err) {
//       setToast({ message: 'Failed to download PDF.', type: 'error' });
//     }
//   };

//   const handleDownloadPolicies = async () => {
//     try {
//       setLoading(true);
//       const fullName = `${employee?.FirstName || ''} ${employee?.LastName || ''}`.trim() || 'Employee';
//       let signatureDataUrl = employee?.policy_signature || '';

//       if (signatureDataUrl.startsWith('typed:')) {
//         const typedName = signatureDataUrl.replace('typed:', '');
//         signatureDataUrl = convertTypedToPng(typedName);
//       }

//       const newPdfBase64 = await createPoliciesPdf(fullName, signatureDataUrl);
//       handleDownloadPdf(newPdfBase64, `company_policies_${(employee?.FirstName || 'employee').toLowerCase()}_${(employee?.LastName || 'signed').toLowerCase()}_signed.pdf`);
//     } catch (err) {
//       console.error(err);
//       setToast({ message: 'Failed to generate policies PDF for download.', type: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return <Loader message="Loading onboarding workspace..." />;
//   }

//   const employee = data?.employee || {};
//   const profile = data?.profile || {};

//   // Find if a Passport Size Photo document was uploaded in India documents section
//   const passportSizePhotoDoc = (data?.documents || []).find(
//     doc => doc.document_type === 'Passport Size Photo'
//   );
//   const rawProfilePhotoPath = profile?.profile_photo_path;

//   // Ensure Passport Size Photo document is separate from Badge Profile Photo
//   const isPassportDocMatch = (
//     (passportSizePhotoDoc?.file_path && rawProfilePhotoPath === passportSizePhotoDoc.file_path) ||
//     (rawProfilePhotoPath && (data?.documents || []).some(doc => doc.document_type === 'Passport Size Photo' && doc.file_path === rawProfilePhotoPath))
//   );

//   const badgePhotoPath = (rawProfilePhotoPath && !isPassportDocMatch) ? rawProfilePhotoPath : null;

//   const effectiveChecklist = dashboardStats?.checklist ? {
//     ...dashboardStats.checklist,
//     profile_photo: !!badgePhotoPath
//   } : {};

//   const effectiveCompletedSteps = Object.values(effectiveChecklist).filter(Boolean).length;

//   const effectiveDashboardStats = dashboardStats ? {
//     ...dashboardStats,
//     checklist: effectiveChecklist,
//     completed_steps: effectiveCompletedSteps
//   } : null;

//   return (
//     <div style={{ animation: 'fadeIn var(--transition-normal) forwards' }}>
//       {uploadingPhoto && <Loader fullScreen message="Uploading profile badge photo..." />}

//       {/* Lock banner warning */}
//       {isLocked && (
//         <div
//           style={{
//             backgroundColor: 'var(--info-light)',
//             borderLeft: '4px solid var(--info)',
//             padding: '1rem',
//             borderRadius: '4px',
//             marginBottom: '1.5rem',
//             fontSize: '0.875rem',
//             color: 'var(--text-primary)',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '0.5rem'
//           }}
//         >
//           <span>ℹ️</span>
//           <div>
//             You have submitted your onboarding details successfully.
//           </div>
//         </div>
//       )}

//       {/* DASHBOARD TAB */}
//       {activeTab === 'dashboard' && (() => {
//         const completedSteps = effectiveDashboardStats?.completed_steps || 0;
//         const totalSteps = effectiveDashboardStats?.total_steps || 8;
//         const onboardingPercent = Math.round((completedSteps / totalSteps) * 100);

//         const radius = 60;
//         const stroke = 7;
//         const normRadius = radius - stroke * 2;
//         const circ = normRadius * 2 * Math.PI;
//         const offset = circ - (onboardingPercent / 100) * circ;

//         return (
//           <div className="fade-in" style={{ display: 'flex', flexDirection: 'column', gap: '2.5rem' }}>

//             {/* Split Top section: Greeting + Radial Indicator */}
//             <div className="dashboard-top-grid">

//               {/* Left Column: Greeting & Status */}
//               <div
//                 style={{
//                   background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.07) 0%, rgba(244, 63, 94, 0.04) 100%)',
//                   border: '1px solid var(--border-color)',
//                   borderRadius: 'var(--border-radius-lg)',
//                   padding: '2.5rem 2rem',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   justifyContent: 'center',
//                   boxShadow: 'var(--shadow-md)'
//                 }}
//               >
//                 <div
//                   style={{
//                     display: 'inline-flex',
//                     padding: '0.25rem 0.75rem',
//                     backgroundColor: 'var(--primary-light)',
//                     color: 'var(--primary)',
//                     fontSize: '0.75rem',
//                     fontWeight: 700,
//                     borderRadius: '50px',
//                     textTransform: 'uppercase',
//                     marginBottom: '1rem',
//                     alignSelf: 'flex-start',
//                     letterSpacing: '0.05em'
//                   }}
//                 >
//                   Onboarding Phase
//                 </div>

//                 <h2 style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--text-primary)', marginBottom: '0.5rem', letterSpacing: '-0.02em' }}>
//                   Welcome, {employee.FirstName || 'Team Member'}!
//                 </h2>
//                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '1rem' }}>
//                   We are thrilled to welcome you to the Genesis Tech Engineers family. All accounts have been securely synchronized. Complete your documentation pipeline below.
//                 </p>
//                 <div style={{ marginBottom: '1.5rem' }}>
//                   <button
//                     type="button"
//                     onClick={onStartVideoTour}
//                     className="btn btn-secondary"
//                     style={{ padding: '0.45rem 1rem', fontSize: '0.75rem', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
//                   >
//                     🎥 Watch Onboarding Video Tour
//                   </button>
//                 </div>

//                 {/* Progress bar line */}
//                 <div style={{ width: '100%' }}>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>
//                     <span>Onboarding Progress</span>
//                     <span>{onboardingPercent}% Complete</span>
//                   </div>
//                   <div style={{ width: '100%', height: '8px', backgroundColor: 'var(--bg-tertiary)', borderRadius: '50px', overflow: 'hidden' }}>
//                     <div
//                       style={{
//                         width: `${onboardingPercent}%`,
//                         height: '100%',
//                         background: 'linear-gradient(90deg, var(--primary) 0%, var(--accent) 100%)',
//                         borderRadius: '50px',
//                         transition: 'width 0.4s ease-out'
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* Right Column: Visual Radial Meter */}
//               <div
//                 className="glass-card"
//                 style={{
//                   padding: '2rem',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   textAlign: 'center'
//                 }}
//               >
//                 <div style={{ position: 'relative', width: radius * 2, height: radius * 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                   {/* SVG Circle meter */}
//                   <svg height={radius * 2} width={radius * 2} style={{ transform: 'rotate(-90deg)', position: 'absolute', top: 0, left: 0 }}>
//                     <circle
//                       stroke="var(--bg-tertiary)"
//                       fill="transparent"
//                       strokeWidth={stroke}
//                       r={normRadius}
//                       cx={radius}
//                       cy={radius}
//                     />
//                     <circle
//                       stroke="url(#progressGrad)"
//                       fill="transparent"
//                       strokeWidth={stroke}
//                       strokeDasharray={circ + ' ' + circ}
//                       style={{ strokeDashoffset: offset, transition: 'stroke-dashoffset 0.6s ease' }}
//                       r={normRadius}
//                       cx={radius}
//                       cy={radius}
//                       strokeLinecap="round"
//                     />
//                     <defs>
//                       <linearGradient id="progressGrad" x1="0%" y1="0%" x2="100%" y2="100%">
//                         <stop offset="0%" stopColor="#22d3ee" />
//                         <stop offset="50%" stopColor="#6366f1" />
//                         <stop offset="100%" stopColor="#ec4899" />
//                       </linearGradient>
//                     </defs>
//                   </svg>

//                   {/* Inside dial text */}
//                   <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 2 }}>
//                     <span style={{ fontSize: '1.75rem', fontWeight: 800, color: 'var(--text-primary)', lineHeight: 1 }}>{completedSteps}</span>
//                     <span style={{ fontSize: '0.7rem', color: 'var(--text-tertiary)', textTransform: 'uppercase', fontWeight: 700, marginTop: '0.15rem' }}>of {totalSteps} Tasks</span>
//                   </div>
//                 </div>

//                 <div style={{ marginTop: '1.25rem' }}>
//                   <div style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--text-primary)' }}>Completeness Ratio</div>
//                   <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '0.15rem' }}>
//                     {onboardingPercent === 100 ? 'Ready to submit onboarding profile!' : `${totalSteps - completedSteps} steps remaining`}
//                   </div>
//                 </div>
//               </div>

//             </div>

//             {/* Visual Roadmap Path */}
//             {(() => {
//               const roadmapSteps = [
//                 { key: 'personal_info', tab: 'personal', title: 'Profile', icon: '👤' },
//                 { key: 'emergency_contacts', tab: 'contacts', title: 'Contacts', icon: '📞' },
//                 { key: 'documents', tab: 'documents', title: 'ID Docs', icon: '📁' },
//                 { key: 'offer', tab: 'offer', title: 'Offer Letter', icon: '✉️' },
//                 { key: 'agreement', tab: 'agreement', title: 'Agreement', icon: '🖋️' },
//                 { key: 'policies', tab: 'policies', title: 'Policies', icon: '🛡️' },
//                 { key: 'bank_details', tab: 'bank', title: 'Bank', icon: '🏦' },
//                 { key: 'profile_photo', tab: 'photo', title: 'Photo', icon: '📷' },
//                 { key: 'submit', tab: 'submit', title: 'Submit', icon: '🚀' }
//               ];

//               const firstPendingStep = roadmapSteps.find(s => {
//                 if (s.key === 'submit') {
//                   return roadmapSteps.slice(0, 8).every(other => effectiveDashboardStats?.checklist?.[other.key]);
//                 }
//                 return !effectiveDashboardStats?.checklist?.[s.key];
//               }) || roadmapSteps[8];

//               return (
//                 <div className="card fade-in" style={{ padding: '1.75rem 1.5rem', margin: 0, boxShadow: 'var(--shadow-sm)' }}>
//                   <div className="roadmap-header">
//                     <div>
//                       <h3 style={{ fontSize: '1.1rem', fontWeight: 800, margin: 0, color: 'var(--text-primary)' }}>
//                         🗺️ Onboarding Guided Path Roadmap
//                       </h3>
//                       <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
//                         Your onboarding steps pipeline. Click any step circle to jump directly to its screen.
//                       </p>
//                     </div>
//                     <div style={{ display: 'flex', gap: '0.5rem' }}>
//                       <button
//                         type="button"
//                         onClick={onStartVideoTour}
//                         className="btn btn-secondary"
//                         style={{ padding: '0.4rem 0.8rem', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
//                       >
//                         🎥 Play Video Tour
//                       </button>
//                       <button
//                         type="button"
//                         onClick={onStartTour}
//                         className="btn btn-secondary"
//                         style={{ padding: '0.4rem 0.8rem', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
//                       >
//                         🗺️ Replay Guided Tour
//                       </button>
//                     </div>
//                   </div>

//                   <div className="roadmap-trail">
//                     {roadmapSteps.map((step, idx) => {
//                       const isComplete = step.key === 'submit'
//                         ? (effectiveDashboardStats?.status === 'PENDING_HR_REVIEW' || effectiveDashboardStats?.status === 'COMPLETED')
//                         : effectiveDashboardStats?.checklist?.[step.key];
//                       const isActive = firstPendingStep.key === step.key;

//                       return (
//                         <React.Fragment key={step.key}>
//                           <div
//                             className={`roadmap-step ${isActive ? 'active' : ''} ${isComplete ? 'complete' : ''}`}
//                             onClick={() => setActiveTab(step.tab)}
//                             title={step.title}
//                           >
//                             {isActive && (
//                               <span style={{
//                                 position: 'absolute',
//                                 top: '-22px',
//                                 fontSize: '0.85rem',
//                                 animation: 'bounceDown 1.2s infinite',
//                                 color: 'var(--primary)',
//                                 fontWeight: 800
//                               }}>
//                                 👇
//                               </span>
//                             )}
//                             <div className={`roadmap-step-circle ${isActive ? 'next-step-glowing' : ''}`}>
//                               {isComplete ? '✓' : step.icon}
//                             </div>
//                             <div className="roadmap-step-title">{step.title}</div>
//                           </div>

//                           {idx < roadmapSteps.length - 1 && (
//                             <div className="roadmap-arrow">➔</div>
//                           )}
//                         </React.Fragment>
//                       );
//                     })}
//                   </div>
//                 </div>
//               );
//             })()}

//             {/* Middle section: Colorful Info Badges Grid */}
//             <div className="dashboard-middle-grid">
//               <div style={{ padding: '1.25rem', backgroundColor: 'rgba(59, 130, 246, 0.03)', border: '1px solid var(--border-color)', borderLeft: '4px solid #3b82f6', borderRadius: 'var(--border-radius-md)', display: 'flex', flexDirection: 'column', gap: '0.25rem', boxShadow: 'var(--shadow-sm)' }}>
//                 <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#2563eb', fontWeight: 700, letterSpacing: '0.05em' }}>Designation Unit</span>
//                 <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)' }}>{employee.Designation || 'N/A'}</span>
//               </div>
//               <div style={{ padding: '1.25rem', backgroundColor: 'rgba(168, 85, 247, 0.03)', border: '1px solid var(--border-color)', borderLeft: '4px solid #a855f7', borderRadius: 'var(--border-radius-md)', display: 'flex', flexDirection: 'column', gap: '0.25rem', boxShadow: 'var(--shadow-sm)' }}>
//                 <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#9333ea', fontWeight: 700, letterSpacing: '0.05em' }}>Department Branch</span>
//                 <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)' }}>{employee.Department || 'N/A'}</span>
//               </div>
//               <div style={{ padding: '1.25rem', backgroundColor: 'rgba(16, 185, 129, 0.03)', border: '1px solid var(--border-color)', borderLeft: '4px solid #10b981', borderRadius: 'var(--border-radius-md)', display: 'flex', flexDirection: 'column', gap: '0.25rem', boxShadow: 'var(--shadow-sm)' }}>
//                 <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#059669', fontWeight: 700, letterSpacing: '0.05em' }}>Official Start Date</span>
//                 <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)' }}>{employee.JoiningDate || 'N/A'}</span>
//               </div>
//             </div>

//             {/* Launcher Grid */}
//             <div className="card" style={{ padding: '2.5rem 2rem', margin: 0 }}>
//               <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '0.5rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '0.75rem' }}>
//                 🚀 Onboarding Launchpad Checklist
//               </h3>
//               <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '2rem' }}>
//                 Each card below represents a required onboarding step. Click any card to load its details.
//               </p>

//               <div
//                 style={{
//                   display: 'grid',
//                   gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
//                   gap: '1.25rem'
//                 }}
//               >
//                 {[
//                   { key: 'personal_info', tab: 'personal', icon: '👤', title: 'Personal Profile', desc: ((data?.employee?.country || employee?.country || '').toUpperCase() === 'INDIA') ? 'Verify personal details, addresses, and Aadhaar.' : 'Verify personal details, addresses, and SSN.', color: 'rgba(59, 130, 246, 0.03)', hoverBorder: '#3b82f6', badgeBg: 'rgba(59, 130, 246, 0.12)', badgeText: '#2563eb' },
//                   { key: 'emergency_contacts', tab: 'contacts', icon: '📞', title: 'Emergency Contacts', desc: 'Add primary and secondary contact details.', color: 'rgba(16, 185, 129, 0.03)', hoverBorder: '#10b981', badgeBg: 'rgba(16, 185, 129, 0.12)', badgeText: '#059669' },
//                   { key: 'documents', tab: 'documents', icon: '📁', title: 'US Identification', desc: 'Upload standard identity documents.', color: 'rgba(99, 102, 241, 0.03)', hoverBorder: '#6366f1', badgeBg: 'rgba(99, 102, 241, 0.12)', badgeText: '#4f46e5' },
//                   { key: 'offer', tab: 'offer', icon: '✉️', title: 'Offer Sheet Review', desc: 'Review terms and sign your hiring offer letter.', color: 'rgba(245, 158, 11, 0.03)', hoverBorder: '#f59e0b', badgeBg: 'rgba(245, 158, 11, 0.12)', badgeText: '#d97706' },
//                   { key: 'agreement', tab: 'agreement', icon: '🖋️', title: 'Employee Agreement', desc: 'E-sign the corporate NDAs & contracts.', color: 'rgba(236, 72, 153, 0.03)', hoverBorder: '#ec4899', badgeBg: 'rgba(236, 72, 153, 0.12)', badgeText: '#db2777' },
//                   { key: 'policies', tab: 'policies', icon: '🛡️', title: 'Company Policies', desc: 'Read and accept the 5 policy handbooks.', color: 'rgba(6, 182, 212, 0.03)', hoverBorder: '#06b6d4', badgeBg: 'rgba(6, 182, 212, 0.12)', badgeText: '#0891b2' },
//                   { key: 'bank_details', tab: 'bank', icon: '🏦', title: 'Direct Deposit', desc: 'Setup payroll accounts and voided cheques.', color: 'rgba(168, 85, 247, 0.03)', hoverBorder: '#a855f7', badgeBg: 'rgba(168, 85, 247, 0.12)', badgeText: '#9333ea' },
//                   { key: 'profile_photo', tab: 'photo', icon: '📷', title: 'Badge Headshot', desc: 'Upload and crop your official badge headshot.', color: 'rgba(239, 68, 68, 0.03)', hoverBorder: '#ef4444', badgeBg: 'rgba(239, 68, 68, 0.12)', badgeText: '#dc2626' }
//                 ].map(step => {
//                   const complete = effectiveDashboardStats?.checklist?.[step.key];
//                   return (
//                     <div
//                       key={step.key}
//                       onClick={() => setActiveTab(step.tab)}
//                       style={{
//                         border: '1px solid var(--border-color)',
//                         borderRadius: 'var(--border-radius-md)',
//                         padding: '1.25rem',
//                         cursor: 'pointer',
//                         backgroundColor: step.color,
//                         transition: 'all var(--transition-normal)',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         justifyContent: 'space-between',
//                         minHeight: '140px',
//                         boxShadow: 'var(--shadow-sm)',
//                         position: 'relative',
//                         overflow: 'hidden'
//                       }}
//                       onMouseEnter={(e) => {
//                         e.currentTarget.style.transform = 'translateY(-3px)';
//                         e.currentTarget.style.boxShadow = 'var(--shadow-md)';
//                         e.currentTarget.style.borderColor = step.hoverBorder;
//                         e.currentTarget.style.background = step.color.replace('0.03', '0.07');
//                       }}
//                       onMouseLeave={(e) => {
//                         e.currentTarget.style.transform = 'translateY(0)';
//                         e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
//                         e.currentTarget.style.borderColor = 'var(--border-color)';
//                         e.currentTarget.style.background = step.color;
//                       }}
//                     >
//                       <div style={{ position: 'relative', zIndex: 2 }}>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
//                           <span style={{ fontSize: '1.5rem' }}>{step.icon}</span>
//                           <span
//                             style={{
//                               fontSize: '0.7rem',
//                               fontWeight: '700',
//                               padding: '0.15rem 0.5rem',
//                               borderRadius: '50px',
//                               textTransform: 'uppercase',
//                               backgroundColor: complete ? 'var(--success-light)' : step.badgeBg,
//                               color: complete ? 'var(--success)' : step.badgeText
//                             }}
//                           >
//                             {complete ? '✓ Done' : 'Pending'}
//                           </span>
//                         </div>
//                         <h4 style={{ fontSize: '0.95rem', fontWeight: '700', marginBottom: '0.25rem', color: 'var(--text-primary)' }}>
//                           {step.title}
//                         </h4>
//                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', lineHeight: '1.3' }}>
//                           {step.desc}
//                         </p>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>
//         );
//       })()}

//       {/* PERSONAL INFO TAB */}
//       {activeTab === 'personal' && (() => {
//         const country = data?.employee?.country || personalForm.country || employee?.country || '';
//         const isIndia = country.toUpperCase() === 'INDIA';
//         return (
//           <div className="card fade-in">
//             <div className="card-title">Personal Information</div>
//             <form onSubmit={handleSavePersonal}>
//               <div className="grid-2">
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="first-name">Given Name(first+middle)</label>
//                   <input type="text" id="first-name" className="form-control" value={personalForm.first_name} onChange={(e) => setPersonalForm({ ...personalForm, first_name: e.target.value })} required disabled={isLocked} />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="last-name">Last Name</label>
//                   <input type="text" id="last-name" className="form-control" value={personalForm.last_name} onChange={(e) => setPersonalForm({ ...personalForm, last_name: e.target.value })} required disabled={isLocked} />
//                 </div>
//               </div>

//               <div className="grid-3">
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="pref-name">Preferred Name</label>
//                   <input type="text" id="pref-name" className="form-control" value={personalForm.preferred_name} onChange={(e) => setPersonalForm({ ...personalForm, preferred_name: e.target.value })} disabled={isLocked} />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="dob-input">Date of Birth</label>
//                   <input type="date" id="dob-input" className="form-control" value={personalForm.dob} onChange={(e) => setPersonalForm({ ...personalForm, dob: e.target.value })} disabled={isLocked} />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="gender-select">Gender</label>
//                   <select id="gender-select" className="form-control" value={personalForm.gender} onChange={(e) => setPersonalForm({ ...personalForm, gender: e.target.value })} disabled={isLocked}>
//                     <option value="">Select</option>
//                     <option value="Male">Male</option>
//                     <option value="Female">Female</option>

//                     <option value="Other">Other</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="grid-3">
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="marital-select">Marital Status</label>
//                   <select id="marital-select" className="form-control" value={personalForm.marital_status} onChange={(e) => setPersonalForm({ ...personalForm, marital_status: e.target.value })} disabled={isLocked}>
//                     <option value="">Select</option>
//                     <option value="Single">Single</option>
//                     <option value="Married">Married</option>
//                     <option value="Divorced">Divorced</option>
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="cit-input">Citizenship</label>
//                   <input type="text" id="cit-input" className="form-control" value={personalForm.citizenship} onChange={(e) => setPersonalForm({ ...personalForm, citizenship: e.target.value })} disabled={isLocked} />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="ssn-input">
//                     {isIndia ? 'Aadhaar Number' : 'Social Security Number (SSN)'}
//                   </label>
//                   <input
//                     type="text"
//                     id="ssn-input"
//                     className="form-control"
//                     placeholder={isIndia ? '12-digit Aadhaar Number (e.g. 1234 5678 9012)' : '000-00-0000'}
//                     maxLength={isIndia ? 14 : 11}
//                     value={personalForm.ssn}
//                     onChange={(e) => setPersonalForm({ ...personalForm, ssn: e.target.value })}
//                     disabled={isLocked}
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="grid-2">
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="phone-input">Phone Number</label>
//                   <input type="tel" id="phone-input" className="form-control" value={personalForm.phone} onChange={(e) => setPersonalForm({ ...personalForm, phone: e.target.value })} required disabled={isLocked} />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="email-display">Personal Email</label>
//                   <input type="email" id="email-display" className="form-control" value={personalForm.personal_email} onChange={(e) => setPersonalForm({ ...personalForm, personal_email: e.target.value })} required disabled={isLocked} />
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label className="form-label" htmlFor="addr-input">Address Line</label>
//                 <input type="text" id="addr-input" className="form-control" value={personalForm.address} onChange={(e) => setPersonalForm({ ...personalForm, address: e.target.value })} required disabled={isLocked} />
//               </div>

//               <div className="grid-4">
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="city-input">City</label>
//                   <input type="text" id="city-input" className="form-control" value={personalForm.city} onChange={(e) => setPersonalForm({ ...personalForm, city: e.target.value })} required disabled={isLocked} />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="state-input">State</label>
//                   <input type="text" id="state-input" className="form-control" value={personalForm.state} onChange={(e) => setPersonalForm({ ...personalForm, state: e.target.value })} required disabled={isLocked} />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="zip-input">ZIP Code</label>
//                   <input type="text" id="zip-input" className="form-control" value={personalForm.zip} onChange={(e) => setPersonalForm({ ...personalForm, zip: e.target.value })} required disabled={isLocked} />
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="country-input">Country</label>
//                   <input type="text" id="country-input" className="form-control" value={personalForm.country} onChange={(e) => setPersonalForm({ ...personalForm, country: e.target.value })} required disabled={isLocked} />
//                 </div>
//               </div>

//               {!isLocked && <button type="submit" className="btn btn-primary">Save Personal Info</button>}
//             </form>
//           </div>
//         );
//       })()}

//       {/* EMERGENCY CONTACTS TAB */}
//       {activeTab === 'contacts' && (
//         <div className="card fade-in">
//           <div className="card-title">Emergency Contacts</div>
//           <form onSubmit={handleSaveContacts}>
//             {emergencyContacts.map((contact, idx) => (
//               <div key={idx} style={{ padding: '1rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)', marginBottom: '1rem', backgroundColor: 'var(--bg-secondary)' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
//                   <span style={{ fontSize: '0.85rem', fontWeight: 600 }}>Contact #{idx + 1}</span>
//                   {!isLocked && emergencyContacts.length > 1 && (
//                     <button type="button" className="btn btn-danger" style={{ padding: '0.2rem 0.5rem', fontSize: '0.7rem' }} onClick={() => handleRemoveContact(idx)}>
//                       Remove
//                     </button>
//                   )}
//                 </div>
//                 <div className="grid-2">
//                   <div className="form-group">
//                     <label className="form-label">Full Name</label>
//                     <input type="text" className="form-control" value={contact.name} onChange={(e) => handleContactChange(idx, 'name', e.target.value)} required disabled={isLocked} />
//                   </div>
//                   <div className="form-group">
//                     <label className="form-label">Relationship</label>
//                     <input type="text" className="form-control" value={contact.relationship} onChange={(e) => handleContactChange(idx, 'relationship', e.target.value)} required disabled={isLocked} />
//                   </div>
//                 </div>
//                 <div className="grid-2">
//                   <div className="form-group">
//                     <label className="form-label">Phone Number</label>
//                     <input type="tel" className="form-control" value={contact.phone} onChange={(e) => handleContactChange(idx, 'phone', e.target.value)} required disabled={isLocked} />
//                   </div>
//                   <div className="form-group">
//                     <label className="form-label">Email</label>
//                     <input type="email" className="form-control" value={contact.email} onChange={(e) => handleContactChange(idx, 'email', e.target.value)} required disabled={isLocked} />
//                   </div>
//                 </div>
//                 <div className="form-group" style={{ marginTop: '1rem' }}>
//                   <label className="form-label">Address</label>
//                   <input type="text" className="form-control" value={contact.address || ''} onChange={(e) => handleContactChange(idx, 'address', e.target.value)} required disabled={isLocked} />
//                 </div>
//               </div>
//             ))}

//             {!isLocked && (
//               <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
//                 <button type="button" className="btn btn-secondary" onClick={handleAddContact}>+ Add Contact</button>
//                 <button type="submit" className="btn btn-primary">Save Contacts</button>
//               </div>
//             )}
//           </form>
//         </div>
//       )}

//       {/* DOCUMENTS UPLOADS TAB (Form I-9 & Onboarding Documents Checklist) */}
//       {activeTab === 'documents' && (() => {
//         const country = data?.employee?.country || '';
//         const isIndia = country.toUpperCase() === 'INDIA';
//         const documents = data?.documents || [];
//         const requestedDocs = data?.requested_documents || data?.requested_employee_documents || [];
//         const hasStateID = documents.some(doc => doc.document_type === 'State ID');
//         const hasSSC = documents.some(doc => doc.document_type === 'Social Security Card (SSC)');
//         const hasOldCombined = documents.some(doc => doc.document_type === 'Driving License / State ID / SSC');
//         const activeOption = selectedIdOption || ((hasStateID || hasSSC) ? 'state_id_ssc' : 'driving_license');
//         return (
//           <div className="card fade-in">
//             <div className="card-title">Employee Document Checklists</div>

//             {/* DYNAMIC MANAGEMENT REQUESTED DOCUMENTS (N ITEMS) */}
//             {requestedDocs.length > 0 && (
//               <div
//                 style={{
//                   marginBottom: '2rem',
//                   padding: '1.25rem',
//                   backgroundColor: 'rgba(59, 130, 246, 0.04)',
//                   border: '1px solid var(--primary-light, #93c5fd)',
//                   borderLeft: '4px solid var(--primary, #3b82f6)',
//                   borderRadius: 'var(--border-radius-md)',
//                   boxShadow: 'var(--shadow-sm)'
//                 }}
//               >
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
//                   <span style={{ fontSize: '1.25rem' }}>📋</span>
//                   <h3 style={{ fontSize: '1.05rem', fontWeight: 700, margin: 0, color: 'var(--text-primary)' }}>
//                     Management Requested Documents ({requestedDocs.length})
//                   </h3>
//                 </div>
//                 <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '1.25rem' }}>
//                   HR or Management has requested the following additional document(s) specifically for your onboarding profile. Please review the instructions and upload each file below.
//                 </p>

//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                   {requestedDocs.map((req, idx) => {
//                     const docTitle = req.document_name || req.document_type || req.title || req.name || `Requested Document #${idx + 1}`;
//                     const docInstruction = req.instructions || req.comments || req.description || req.note || req.reason || '';
//                     return (
//                       <div key={req.id || idx} style={{ backgroundColor: 'var(--bg-primary)', borderRadius: 'var(--border-radius-sm)', padding: '0.5rem' }}>
//                         <UploadField
//                           documentType={docTitle}
//                           instruction={docInstruction}
//                           documentsList={data?.documents || []}
//                           onUploadSuccess={() => {
//                             setRequestedDocsSubmitted(false);
//                             fetchOnboardingData();
//                           }}
//                           mandatory={true}
//                           isLocked={isLocked}
//                           allowDeleteWhenLocked={true}
//                         />
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             )}

//             {isIndia ? (
//               <>
//                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '2rem' }}>
//                   Please upload the required verification files according to Indian HR compliance guidelines.
//                 </p>

//                 {/* 1. Academic Qualification */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>1. Academic Qualification</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your highest academic degree certificate or transcript.</p>
//                   </div>
//                   <UploadField
//                     documentType="Highest Education Qualification (Degree Certificate/Transcript)"
//                     documentsList={data?.documents}
//                     onUploadSuccess={fetchOnboardingData}
//                     mandatory={true}
//                   />
//                 </div>

//                 {/* 2. Aadhar Card */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>2. Aadhar Card</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload front and back side copy of your Aadhar Card.</p>
//                   </div>
//                   <UploadField
//                     documentType="Aadhar Card"
//                     documentsList={data?.documents}
//                     onUploadSuccess={fetchOnboardingData}
//                     mandatory={true}
//                   />
//                 </div>

//                 {/* 3. PAN Card */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>3. PAN Card</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload a clear scanned copy of your PAN Card.</p>
//                   </div>
//                   <UploadField
//                     documentType="PAN Card"
//                     documentsList={data?.documents}
//                     onUploadSuccess={fetchOnboardingData}
//                     mandatory={true}
//                   />
//                 </div>

//                 {/* 4. Passport Size Photo */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>4. Passport Size Photo</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload a recent color passport-size photograph with a clear background.</p>
//                   </div>
//                   <UploadField
//                     documentType="Passport Size Photo"
//                     documentsList={data?.documents}
//                     onUploadSuccess={fetchOnboardingData}
//                     mandatory={true}
//                   />
//                 </div>

//                 {/* 5. Police Verification */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>5. Police Verification</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your Police Clearance Certificate (PCC) or Character Certificate from local authorities.</p>
//                   </div>
//                   <UploadField
//                     documentType="Police Verification"
//                     documentsList={data?.documents}
//                     onUploadSuccess={fetchOnboardingData}
//                     mandatory={true}
//                     showNotAvailable={true}
//                     notAvailableLabel="I do not have a Police Verification certificate right now"
//                     consentText="I hereby consent and declare that I do not possess a Police Verification certificate at this moment. I agree and commit to submitting the certificate to HR within one month from my joining date."
//                   />
//                 </div>

//                 {/* 6. Salary Slip of last 3 month */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>6. Salary Slip of last 3 month</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload salary slips from your previous employer for the last three months.</p>
//                   </div>
//                   <UploadField
//                     documentType="Salary Slip of last 3 month"
//                     documentsList={data?.documents}
//                     onUploadSuccess={fetchOnboardingData}
//                     mandatory={true}
//                     showNotAvailable={true}
//                     notAvailableLabel="Not Applicable (Fresh graduate / no previous employment)"
//                   />
//                 </div>

//                 {/* 7. Medical Checkup Documents */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>7. Medical Checkup Documents</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your fitness certificate or medical checkup documents from a registered medical practitioner.</p>
//                   </div>
//                   <UploadField
//                     documentType="Medical Checkup Documents"
//                     documentsList={data?.documents}
//                     onUploadSuccess={fetchOnboardingData}
//                     mandatory={true}
//                     showNotAvailable={true}
//                     notAvailableLabel="I do not have a Medical Checkup report right now"
//                     consentText="I hereby consent and declare that I do not possess a Medical Checkup report at this moment. I agree and commit to submitting the report to HR within one month from my joining date."
//                   />
//                 </div>

//                 {/* 8. Signed Offer Letter */}
//                 <div>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>8. Signed Offer Letter</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Automatically saved when you electronically sign your offer letter in the Offer Letter tab.</p>
//                   </div>
//                   <UploadField
//                     documentType="Signed Offer Letter"
//                     documentsList={data?.documents}
//                     onUploadSuccess={fetchOnboardingData}
//                     mandatory={false}
//                   />
//                 </div>
//               </>
//             ) : (
//               <>
//                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '2rem' }}>
//                   Please upload the required verification files according to US enterprise HR compliance guidelines.
//                 </p>

//                 {/* 1. Form I-9 */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '1rem' }}>
//                     <div>
//                       <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>1. Form I-9</h4>
//                       <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Employment Eligibility Verification. Download, complete, and upload.</p>
//                     </div>
//                     <a href="/Form_I-9.pdf" download className="btn btn-secondary" style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', textDecoration: 'none', fontWeight: 600 }}>
//                       📥 Download Form I-9
//                     </a>
//                   </div>
//                   <UploadField documentType="Form I-9" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                 </div>

//                 {/* 2. Form W-4 */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '1rem' }}>
//                     <div>
//                       <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>2. Form W-4</h4>
//                       <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Employee's Withholding Certificate. Download, complete, and upload.</p>
//                     </div>
//                     <a href="/Form_W-4.pdf" download className="btn btn-secondary" style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', textDecoration: 'none', fontWeight: 600 }}>
//                       📥 Download Form W-4
//                     </a>
//                   </div>
//                   <UploadField documentType="Form W-4" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                 </div>

//                 {/* 3. Select State */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem', padding: '1rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)', backgroundColor: 'var(--bg-secondary)' }}>
//                   <div style={{ marginBottom: '1rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.25rem 0', color: 'var(--text-primary)' }}>3. Select State</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: '0 0 0.75rem 0' }}>Select your state to download and submit the corresponding state tax withholding form.</p>
//                     <select
//                       value={selectedState}
//                       onChange={(e) => setSelectedState(e.target.value)}
//                       className="form-control"
//                       style={{ maxWidth: '300px', padding: '0.5rem', borderRadius: 'var(--border-radius-sm)' }}
//                       disabled={isLocked}
//                     >
//                       <option value="">-- Choose Your State --</option>
//                       <option value="oregon">Oregon</option>
//                       <option value="arizona">Arizona</option>
//                       <option value="colorado">Colorado</option>
//                     </select>
//                   </div>

//                   {selectedState && (
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1rem', marginTop: '1rem' }}>
//                       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '1rem' }}>
//                         <div>
//                           <h5 style={{ fontSize: '0.9rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>
//                             {selectedState === 'oregon' && 'Oregon Form OR-W-4'}
//                             {selectedState === 'arizona' && 'Arizona Form A-4'}
//                             {selectedState === 'colorado' && 'Colorado Form DR 0004'}
//                           </h5>
//                           <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>
//                             {selectedState === 'oregon' && 'Oregon State withholding allowance certificate.'}
//                             {selectedState === 'arizona' && 'Arizona State withholding election form.'}
//                             {selectedState === 'colorado' && 'Colorado State employee withholding certificate.'}
//                           </p>
//                         </div>
//                         <a
//                           href={
//                             selectedState === 'oregon' ? '/Oregon_Form_W-4.pdf' :
//                               selectedState === 'arizona' ? '/Arizona_Form_A4.pdf' :
//                                 '/Colorado_Form_DR0004.pdf'
//                           }
//                           download
//                           className="btn btn-secondary"
//                           style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', textDecoration: 'none', fontWeight: 600 }}
//                         >
//                           📥 Download {selectedState.toUpperCase()} Form
//                         </a>
//                       </div>
//                       <UploadField
//                         documentType={
//                           selectedState === 'oregon' ? 'Oregon State Tax Form' :
//                             selectedState === 'arizona' ? 'Arizona State Tax Form' :
//                               'Colorado State Tax Form'
//                         }
//                         documentsList={data?.documents}
//                         onUploadSuccess={fetchOnboardingData}
//                         mandatory={true}
//                       />
//                     </div>
//                   )}
//                 </div>

//                 {/* 4. Passport */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>4. Passport</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your valid Passport (bio page & back page).</p>
//                   </div>
//                   <UploadField documentType="Passport" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                 </div>

//                 {/* 5. Visa & EAD */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>5. Visa & EAD</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your valid Visa or Employment Authorization Document (EAD).</p>
//                   </div>
//                   <UploadField documentType="Visa & EAD" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                 </div>

//                 {/* 6. US Identification * */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.75rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>6. US Identification *</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: '0.25rem 0 0.75rem 0' }}>
//                       Choose your identification submission method: either submit a valid Driving License, or submit a State ID along with your Social Security Card (SSC).
//                     </p>
//                   </div>

//                   <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap', padding: '0 0.5rem' }}>
//                     <label style={{
//                       flex: '1 1 200px',
//                       padding: '0.85rem 1rem',
//                       border: activeOption === 'driving_license' ? '2px solid var(--primary)' : '1px solid var(--border-color)',
//                       borderRadius: 'var(--border-radius-md)',
//                       cursor: 'pointer',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '0.75rem',
//                       backgroundColor: activeOption === 'driving_license' ? 'rgba(59, 130, 246, 0.04)' : 'var(--bg-secondary)',
//                       transition: 'all 0.2s ease'
//                     }}>
//                       <input
//                         type="radio"
//                         name="id_option"
//                         checked={activeOption === 'driving_license'}
//                         onChange={() => setSelectedIdOption('driving_license')}
//                         style={{ accentColor: 'var(--primary)' }}
//                         disabled={isLocked}
//                       />
//                       <div>
//                         <strong style={{ display: 'block', fontSize: '0.85rem', color: 'var(--text-primary)' }}>Driving License</strong>
//                         <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Upload your valid US Driving License.</span>
//                       </div>
//                     </label>

//                     <label style={{
//                       flex: '1 1 200px',
//                       padding: '0.85rem 1rem',
//                       border: activeOption === 'state_id_ssc' ? '2px solid var(--primary)' : '1px solid var(--border-color)',
//                       borderRadius: 'var(--border-radius-md)',
//                       cursor: 'pointer',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '0.75rem',
//                       backgroundColor: activeOption === 'state_id_ssc' ? 'rgba(59, 130, 246, 0.04)' : 'var(--bg-secondary)',
//                       transition: 'all 0.2s ease'
//                     }}>
//                       <input
//                         type="radio"
//                         name="id_option"
//                         checked={activeOption === 'state_id_ssc'}
//                         onChange={() => setSelectedIdOption('state_id_ssc')}
//                         style={{ accentColor: 'var(--primary)' }}
//                         disabled={isLocked}
//                       />
//                       <div>
//                         <strong style={{ display: 'block', fontSize: '0.85rem', color: 'var(--text-primary)' }}>State ID & Social Security Card (SSC)</strong>
//                         <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Upload both your State ID and Social Security Card.</span>
//                       </div>
//                     </label>
//                   </div>

//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                     {activeOption === 'driving_license' ? (
//                       <UploadField
//                         documentType="Driving License"
//                         documentsList={data?.documents}
//                         onUploadSuccess={fetchOnboardingData}
//                         mandatory={true}
//                       />
//                     ) : (
//                       <>
//                         <UploadField
//                           documentType="State ID"
//                           documentsList={data?.documents}
//                           onUploadSuccess={fetchOnboardingData}
//                           mandatory={true}
//                         />
//                         <UploadField
//                           documentType="Social Security Card (SSC)"
//                           documentsList={data?.documents}
//                           onUploadSuccess={fetchOnboardingData}
//                           mandatory={true}
//                         />
//                       </>
//                     )}

//                     {hasOldCombined && (
//                       <div style={{ marginTop: '1rem', borderTop: '1px dashed var(--border-color)', paddingTop: '1rem' }}>
//                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginBottom: '0.5rem', fontWeight: 600 }}>
//                           Previously uploaded combined identification document:
//                         </p>
//                         <UploadField
//                           documentType="Driving License / State ID / SSC"
//                           documentsList={data?.documents}
//                           onUploadSuccess={fetchOnboardingData}
//                           mandatory={false}
//                         />
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* 7. Highest Education Qualification (Degree Certification / Transcript) */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>7. Highest Education Qualification (Degree Certification / Transcript)</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your highest education qualification degree certificate or transcript.</p>
//                   </div>
//                   <UploadField documentType="Highest Education Qualification (Degree Certificate/Transcript)" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                 </div>

//                 {/* 8. Professional Certificate / Licenses */}
//                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>8. Professional Certificate / Licenses</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your professional certification or licenses (optional).</p>
//                   </div>
//                   <UploadField documentType="Professional Certificate / Licenses" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={false} />
//                 </div>

//                 {/* 9. Other */}
//                 <div>
//                   <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                     <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>9. Other</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload any additional supporting documents or records.</p>
//                   </div>
//                   <UploadField documentType="Other Documents" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} />
//                 </div>
//               </>
//             )}
//           </div>
//         );
//       })()}


//       {/* OFFER LETTER TAB */}
//       {activeTab === 'offer' && (
//         <div className="card fade-in">
//           <div className="card-title">Offer Letter Acceptance</div>
//           <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
//             Verify and electronically sign your hiring offer letter.
//           </p>

//           <div className="agreements-document-grid">
//             {/* Left side: Pre-signed badge & signature drawer */}
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
//               <div
//                 style={{
//                   border: '1px solid var(--border-color)',
//                   borderRadius: 'var(--border-radius-md)',
//                   padding: '1.5rem',
//                   backgroundColor: 'var(--bg-secondary)',
//                   boxShadow: 'var(--shadow-sm)',
//                   fontSize: '0.825rem'
//                 }}
//               >
//                 <h4 style={{ fontWeight: 'bold', marginBottom: '0.75rem', color: 'var(--primary)' }}>Authorized Representative Signature</h4>
//                 <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', marginBottom: '0.5rem' }}>
//                   <span style={{ fontSize: '1.5rem' }}>✍️</span>
//                   <div>
//                     <strong>Neeta Shrikant Sangvikar</strong>
//                     <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>Director HR, Genesis Tech Engineers</div>
//                   </div>
//                 </div>
//                 <div style={{ fontSize: '0.75rem', color: 'var(--success)', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.25rem', marginTop: '0.5rem' }}>
//                   <span>✓</span> Document pre-signed by Employer
//                 </div>
//               </div>

//               {data?.signature_history?.some(h => h.document_type === 'Offer Letter' && h.action === 'SIGN') ? (
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                   <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1.25rem', borderRadius: 'var(--border-radius-sm)', fontSize: '0.85rem' }}>
//                     🚀 <strong>Offer Letter Signed</strong>: You accepted and electronically signed this Offer Letter on {new Date(data.signature_history.find(h => h.document_type === 'Offer Letter' && h.action === 'SIGN').signed_at).toLocaleString()}.
//                   </div>
//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                     <button
//                       type="button"
//                       className="btn btn-primary"
//                       style={{ width: '100%', padding: '0.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                       onClick={() => handleDownloadPdf(offerLetterBlobUrl, `offer_letter_${(employee?.FirstName || 'employee').toLowerCase()}_${(employee?.LastName || 'signed').toLowerCase()}_signed.pdf`)}
//                     >
//                       📥 Download Signed Offer Letter
//                     </button>
//                     {/* {!isLocked && (
//                       <button
//                         type="button"
//                         className="btn btn-secondary"
//                         style={{ width: '100%', padding: '0.5rem', fontSize: '0.8rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                         onClick={() => {
//                           const rawPath = data?.employee?.offer_letter || data?.employee?.offer_letter_path || employee?.offer_letter || employee?.offer_letter_path;
//                           let realUrl = '';
//                           if (rawPath) {
//                             let cleanPath = rawPath.replace(/^\//, '');
//                             if (!cleanPath.startsWith('http://') && !cleanPath.startsWith('https://')) {
//                               cleanPath = cleanPath.startsWith('offer_letters/')
//                                 ? `https://hiring.gtelinq.com/hiring-backend/${cleanPath}`
//                                 : `/EOP_api/${cleanPath}`;
//                             }
//                             realUrl = cleanPath;
//                           }
//                           if (realUrl) {
//                             setOfferLetterBlobUrl(realUrl);
//                           }
//                           setData(prev => ({
//                             ...prev,
//                             signature_history: (prev.signature_history || []).filter(h => h.document_type !== 'Offer Letter'),
//                             signed_agreements: {
//                               ...(prev.signed_agreements || {}),
//                               'Offer Letter': null
//                             }
//                           }));
//                         }}
//                       >
//                         ✏️ Re-sign Offer Letter
//                       </button>
//                     )} */}
//                   </div>
//                 </div>
//               ) : (
//                 !isLocked && <SignaturePad onSave={(sig) => handleDocumentSign('Offer Letter', sig)} />
//               )}
//             </div>

//             {/* Right side: The PDF/Base64 Preview from Database */}
//             <div>
//               {offerLetterBlobUrl ? (
//                 <div style={{ border: '2px solid #334155', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow-md)', backgroundColor: 'var(--bg-secondary)' }}>
//                   <div className="mobile-helper-banner" style={{
//                     padding: '0.75rem 1rem',
//                     backgroundColor: 'var(--bg-tertiary)',
//                     borderBottom: '1px solid var(--border-color)',
//                     flexWrap: 'wrap',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     gap: '0.5rem'
//                   }}>
//                     <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
//                       📱 Reading on Mobile?
//                     </span>
//                     <div style={{ display: 'flex', gap: '0.5rem' }}>
//                       <button
//                         type="button"
//                         className="btn btn-secondary"
//                         style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
//                         onClick={() => handleViewPdf(offerLetterBlobUrl, 'offer_letter.pdf')}
//                       >
//                         📂 Open Fullscreen & Zoom
//                       </button>
//                       <button
//                         type="button"
//                         className="btn btn-primary"
//                         style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
//                         onClick={() => handleDownloadPdf(offerLetterBlobUrl, 'offer_letter.pdf')}
//                       >
//                         📥 Download PDF
//                       </button>
//                     </div>
//                   </div>
//                   <iframe
//                     src={`${offerLetterBlobUrl}#toolbar=0&navpanes=0&view=FitH`}
//                     className="document-iframe"
//                     style={{ height: "750px" }}
//                     title="Offer Letter PDF Viewer"
//                   />
//                 </div>
//               ) : (
//                 <div className="document-text-preview">
//                   {/* Header */}
//                   <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', borderBottom: '2px solid #000000', paddingBottom: '0.75rem', marginBottom: '1.5rem' }}>
//                     {/* Green Logo SVG */}
//                     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', minWidth: '95px' }}>
//                       <svg width="45" height="45" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <circle cx="50" cy="50" r="38" stroke="#16a34a" strokeWidth="6" strokeDasharray="10 5" />
//                         <circle cx="50" cy="50" r="22" fill="#16a34a" opacity="0.8" />
//                         <path d="M50 10 L56 26 L44 26 Z" fill="#16a34a" />
//                         <path d="M50 90 L56 74 L44 74 Z" fill="#16a34a" />
//                         <path d="M10 50 L26 56 L26 44 Z" fill="#16a34a" />
//                         <path d="M90 50 L74 56 L74 44 Z" fill="#16a34a" />
//                       </svg>
//                       <span style={{ fontSize: '0.6rem', fontWeight: '800', color: '#16a34a', lineHeight: 1.1, marginTop: '0.25rem' }}>GENESIS TECH</span>
//                       <span style={{ fontSize: '0.6rem', fontWeight: '800', color: '#16a34a', lineHeight: 1.0 }}>ENGINEERS</span>
//                       <span style={{ fontSize: '0.35rem', fontWeight: '600', color: '#16a34a', marginTop: '0.1rem', letterSpacing: '0.02em', textTransform: 'uppercase' }}>Making Engineering Sustainable</span>
//                     </div>

//                     {/* Header details */}
//                     <div style={{ flex: 1, textAlign: 'center' }}>
//                       <h2 style={{ fontSize: '1.25rem', fontWeight: '800', color: '#000000', margin: '0 0 0.25rem 0', letterSpacing: '0.02em' }}>GENESIS TECH ENGINEERS PVT. LTD.</h2>
//                       <p style={{ fontSize: '0.55rem', color: '#334155', margin: '0 0 0.25rem 0', fontWeight: '700', lineHeight: 1.3 }}>
//                         REGISTERED ADDRESS : PLOT NO 5, GOKUL SOCIETY, DATTAWADI, SADASHIV PETH, PUNE CITY, PUNE - 411030. MH, INDIA.
//                       </p>
//                       <p style={{ fontSize: '0.55rem', color: '#334155', margin: 0, fontWeight: '700' }}>
//                         GST #: <span style={{ color: '#000000' }}>27AAKCG7985R1ZB</span> &nbsp;|&nbsp; PAN #: <span style={{ color: '#000000' }}>AAKCG7985R</span> &nbsp;|&nbsp; Contact: <span style={{ color: '#000000' }}>+91-8983260210</span>
//                       </p>
//                       <p style={{ fontSize: '0.55rem', color: '#334155', margin: '0.15rem 0 0 0', fontWeight: '700' }}>
//                         Website: <a href="http://www.genesistech.co.in" target="_blank" rel="noreferrer" style={{ color: '#2563eb', textDecoration: 'none' }}>www.genesistech.co.in</a> &nbsp; E-mail: <a href="mailto:contact@genesistech.co.in" style={{ color: '#2563eb', textDecoration: 'none' }}>contact@genesistech.co.in</a>
//                       </p>
//                     </div>
//                   </div>

//                   <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', fontSize: '0.8rem', color: '#475569' }}>
//                     <span>Document ID: GTE-OL-{1000 + (employee.id || 1)}</span>
//                     <span>Date: {employee.JoiningDate || '28/7/2026'}</span>
//                   </div>

//                   <h3 style={{ fontSize: '1rem', fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase', marginBottom: '1.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.5rem' }}>
//                     JOB OFFER LETTER
//                   </h3>

//                   <p style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
//                     Dear {employee.FirstName} {employee.LastName},
//                   </p>

//                   <p style={{ marginBottom: '1.25rem' }}>
//                     We are delighted to offer you the role at Genesis Tech Engineers Pvt. Ltd. You are an outstanding applicant, and we believe that your skills and experience make you an excellent addition to the team. Below, you will find more information about the role, compensation, and some of the amazing benefits available to you when you join Genesis Tech Engineers Pvt. Ltd. Please also refer to the enclosed General Terms & Conditions of Employment where you will find further information on your employment, including information on your right to work in India and pre-employment checks.
//                   </p>

//                   <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.25rem', marginBottom: '0.5rem' }}>1. Your Job:</h4>
//                   <ul style={{ listStyleType: 'none', paddingLeft: 0, marginBottom: '1.25rem', display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                     <li><strong>Role:</strong> {employee.Designation || 'Software Development Engineer'}</li>
//                     <li><strong>Office Location:</strong> DNK SQUARE, 14th Floor, Office 1401, 1406, Airport Road, Sakore Nagar, Viman Nagar, Pune, Maharashtra - 411014</li>
//                     <li><strong>Start Date:</strong> {employee.JoiningDate || '2026-08-08'}</li>
//                     <li><strong>Work Model:</strong> Work from Office</li>
//                     <li><strong>Office timing:</strong> 9.30am - 12.30am</li>
//                     <li><strong>Employee ID:</strong> -</li>
//                   </ul>

//                   <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.25rem', marginBottom: '0.5rem' }}>2. Pay:</h4>
//                   <p style={{ marginBottom: '1.25rem' }}>
//                     Your annual CTC is <strong>{employee.OfferedCTC || 'As agreed'}</strong> which shall be payable monthly in arrears on or about the payroll cut-off of each month directly into your nominated bank account. If your employment commencement date is on or before the payroll cutoff of the month, you will receive your first month's pay on the month's payday of when your employment commences.
//                   </p>

//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', borderTop: '1px dashed #cbd5e1', paddingTop: '1.5rem', marginTop: '2rem' }}>
//                     <p><strong>Employee Sign:</strong> ___________________________</p>
//                     <p><strong>Employee Name:</strong> {employee.FirstName} {employee.LastName}</p>
//                     <p><strong>Date:</strong> ___________________________</p>
//                   </div>

//                   <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                     <p><strong>For: Genesis Tech Engineers Pvt. Ltd.</strong></p>
//                     <div style={{ fontSize: '1rem', fontStyle: 'italic', color: 'var(--primary)', margin: '0.25rem 0' }}>Neeta</div>
//                     <p><strong>Name:</strong> NEETA SHRIKANT SANGVIKAR</p>
//                     <p><strong>Designation:</strong> DIRECTOR HR</p>
//                   </div>

//                   <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', marginTop: '2rem', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                     [Page 1 of 1]
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* EMPLOYEE AGREEMENT TAB */}
//       {activeTab === 'agreement' && (() => {
//         const country = employee?.country || '';
//         const isUsa = country.toUpperCase() === 'USA';
//         const agreementsList = isUsa ? [
//           { key: 'employment_agreement', title: 'Employment Agreement 1', displayName: 'Employment Agreement', path: '/Employment Agreement 1.pdf', desc: 'Verify and electronically sign your formal Employment Agreement.' },
//           { key: 'confidentiality_nda', title: 'Employee Confidentiality & NDA (1)', displayName: 'Employee Confidentiality & NDA', path: '/Employee Confidentiality & NDA (1).pdf', desc: 'Electronically sign the Corporate Non-Disclosure Agreement.' },
//           { key: 'conflict_of_interest', title: 'Conflict of interest agreement', path: '/Conflict of interest agreement.pdf', desc: 'Sign the Conflict of Interest policy compliance statement.' },
//           { key: '401k_dental_vision_medical', title: '401K Dental Vision Medical', path: '/401K Dental Vision Medical.pdf', desc: 'Acknowledge details of the 401K and healthcare benefit details.' },
//           { key: 'non_solicitation', title: 'Non Solicitation', path: '/Non Solicitation.pdf', desc: 'Sign the Non-Solicitation Agreement.' }
//         ] : [
//           { key: 'employee_agreement', title: 'Employee Agreement', path: '/3-Employment Agreement.pdf', desc: 'Verify and electronically sign your formal Employment Agreement.' }
//         ];

//         const isAgreementSigned = (title) => {
//           return data?.signature_history?.some(h => h.document_type === title && h.action === 'SIGN');
//         };

//         const getSignatureDate = (title) => {
//           const sig = data?.signature_history?.find(h => h.document_type === title && h.action === 'SIGN');
//           return sig ? new Date(sig.signed_at).toLocaleString() : '';
//         };

//         const activeAgreement = agreementsList.find(a => a.key === selectedAgreementKey) || agreementsList[0];
//         const activeBlobUrl = agreementBlobUrls[activeAgreement?.key] || activeAgreement?.path;

//         const signedCount = agreementsList.filter(item => isAgreementSigned(item.title)).length;
//         const totalCount = agreementsList.length;
//         const progressPercentage = Math.round((signedCount / totalCount) * 100);

//         return (
//           <div className="card fade-in">
//             <div className="card-title">Employee Agreement Acceptance</div>
//             <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
//               {isUsa
//                 ? "Please review and electronically sign all 5 required agreements to complete your onboarding."
//                 : "Verify and electronically sign your formal Employment Agreement."}
//             </p>

//             {/* SLEEK PROGRESS CARD FOR USA */}
//             {isUsa && (
//               <div style={{
//                 marginBottom: '1.5rem',
//                 padding: '1rem 1.25rem',
//                 borderRadius: '8px',
//                 background: 'linear-gradient(135deg, rgba(79, 70, 229, 0.04) 0%, rgba(99, 102, 241, 0.04) 100%)',
//                 border: '1px solid rgba(79, 70, 229, 0.1)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between',
//                 flexWrap: 'wrap',
//                 gap: '1rem'
//               }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
//                   <span style={{ fontSize: '1.5rem' }}>📋</span>
//                   <div>
//                     <div style={{ fontSize: '0.875rem', fontWeight: 'bold', color: 'var(--text-primary)' }}>
//                       Employee Agreement Packages Signature Status
//                     </div>
//                     <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '0.15rem' }}>
//                       {signedCount} of {totalCount} signed
//                     </div>
//                   </div>
//                 </div>
//                 <div style={{ flex: '1 1 200px', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                   <div style={{ flex: 1, height: '8px', backgroundColor: 'rgba(79, 70, 229, 0.1)', borderRadius: '4px', overflow: 'hidden' }}>
//                     <div style={{ width: `${progressPercentage}%`, height: '100%', backgroundColor: 'var(--primary)', transition: 'width 0.4s ease' }} />
//                   </div>
//                   <span style={{ fontSize: '0.875rem', fontWeight: 'bold', color: 'var(--primary)' }}>
//                     {progressPercentage}%
//                   </span>
//                 </div>
//               </div>
//             )}

//             {/* HORIZONTAL SELECTOR TABS */}
//             <div className="agreements-horizontal-tabs">
//               {agreementsList.map((item) => {
//                 const signed = isAgreementSigned(item.title);
//                 const active = selectedAgreementKey === item.key;
//                 return (
//                   <div
//                     key={item.key}
//                     onClick={() => setSelectedAgreementKey(item.key)}
//                     className={`agreement-tab-item ${active ? 'active' : ''}`}
//                   >
//                     <div className="agreement-tab-title">{item.displayName || item.title}</div>
//                     <div className="agreement-tab-status">
//                       {signed ? (
//                         <span style={{ color: 'var(--success)', fontWeight: 600 }}>✓ Signed</span>
//                       ) : (
//                         <span style={{ color: '#d97706', fontWeight: 600 }}>⏳ Pending</span>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>

//             {/* CORE VIEW / SIGN FLOW - DUAL COLUMN GRID: INPUTS LEFT, PDF RIGHT */}
//             <div className="agreements-document-grid">
//               {/* Right Column: Signature Signoff area */}
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
//                 <div
//                   style={{
//                     border: '1px solid var(--border-color)',
//                     borderRadius: 'var(--border-radius-md)',
//                     padding: '1.5rem',
//                     backgroundColor: 'var(--bg-secondary)',
//                     boxShadow: 'var(--shadow-sm)',
//                     fontSize: '0.825rem'
//                   }}
//                 >
//                   <h4 style={{ fontWeight: 'bold', marginBottom: '0.75rem', color: 'var(--primary)' }}>Authorized Representative Signature</h4>
//                   <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', marginBottom: '0.5rem' }}>
//                     <span style={{ fontSize: '1.5rem' }}>✍️</span>
//                     <div>
//                       <strong>Neeta Shrikant Sangvikar</strong>
//                       <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>Director HR, Genesis Tech Engineers</div>
//                     </div>
//                   </div>
//                   <div style={{ fontSize: '0.75rem', color: 'var(--success)', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.25rem', marginTop: '0.5rem' }}>
//                     <span>✓</span> Document pre-signed by Employer
//                   </div>
//                 </div>





//                 {selectedAgreementKey === 'conflict_of_interest' && !isAgreementSigned(activeAgreement?.title) && (
//                   <div
//                     style={{
//                       border: '1px solid var(--border-color)',
//                       borderRadius: 'var(--border-radius-md)',
//                       padding: '1.5rem',
//                       backgroundColor: 'var(--bg-secondary)',
//                       boxShadow: 'var(--shadow-sm)',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       gap: '1rem'
//                     }}
//                   >
//                     <h4 style={{ fontWeight: 'bold', color: 'var(--primary)', margin: 0, fontSize: '0.95rem' }}>Conflict of Interest Info</h4>
//                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>
//                       Please fill out the details below. They will be dynamically updated in your Conflict of Interest PDF.
//                     </p>




//                     {/* A. Outside Employment */}
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem', marginTop: '0.25rem' }}>
//                       <label style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>A. Outside Employment</label>
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="outsideEmploymentType"
//                             value="none"
//                             checked={employmentForm.outsideEmploymentType === 'none'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, outsideEmploymentType: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           I am not employed by any other employer.
//                         </label>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="outsideEmploymentType"
//                             value="has_employment"
//                             checked={employmentForm.outsideEmploymentType === 'has_employment'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, outsideEmploymentType: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           I currently have outside employment.
//                         </label>
//                       </div>
//                     </div>

//                     {employmentForm.outsideEmploymentType === 'has_employment' && (
//                       <div style={{ paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem', borderLeft: '2px solid var(--primary-light)' }}>
//                         <div className="form-group" style={{ margin: 0 }}>
//                           <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Employer / Business</label>
//                           <input
//                             type="text"
//                             className="form-control"
//                             value={employmentForm.outsideEmployer}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, outsideEmployer: e.target.value })}
//                             disabled={isLocked}
//                             style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                           />
//                         </div>
//                         <div className="form-group" style={{ margin: 0 }}>
//                           <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Nature of Work</label>
//                           <input
//                             type="text"
//                             className="form-control"
//                             value={employmentForm.outsideNature}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, outsideNature: e.target.value })}
//                             disabled={isLocked}
//                             style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                           />
//                         </div>
//                         <div className="form-group" style={{ margin: 0 }}>
//                           <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Hours Worked</label>
//                           <input
//                             type="text"
//                             className="form-control"
//                             value={employmentForm.outsideHours}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, outsideHours: e.target.value })}
//                             disabled={isLocked}
//                             style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                           />
//                         </div>
//                       </div>
//                     )}

//                     {/* B. Ownership of Other Businesses */}
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                       <label style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>B. Ownership of Other Businesses</label>
//                       <span style={{ fontSize: '0.7rem', display: 'block', marginBottom: '0.4rem', color: 'var(--text-secondary)' }}>Do you own or have an interest in any business?</span>
//                       <div style={{ display: 'flex', gap: '1rem' }}>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="ownershipType"
//                             value="no"
//                             checked={employmentForm.ownershipType === 'no'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, ownershipType: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           No
//                         </label>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="ownershipType"
//                             value="yes"
//                             checked={employmentForm.ownershipType === 'yes'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, ownershipType: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           Yes
//                         </label>
//                       </div>
//                     </div>

//                     {employmentForm.ownershipType === 'yes' && (
//                       <div className="form-group" style={{ margin: 0, paddingLeft: '1rem', borderLeft: '2px solid var(--primary-light)' }}>
//                         <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>If yes, describe:</label>
//                         <input
//                           type="text"
//                           className="form-control"
//                           value={employmentForm.ownershipDescribe}
//                           onChange={(e) => setEmploymentForm({ ...employmentForm, ownershipDescribe: e.target.value })}
//                           disabled={isLocked}
//                           style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                         />
//                       </div>
//                     )}

//                     {/* C. Competing Activities */}
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                       <label style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>C. Competing Activities</label>
//                       <span style={{ fontSize: '0.7rem', display: 'block', marginBottom: '0.4rem', color: 'var(--text-secondary)' }}>Are you involved in any competing activities?</span>
//                       <div style={{ display: 'flex', gap: '1rem' }}>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="competingType"
//                             value="no"
//                             checked={employmentForm.competingType === 'no'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, competingType: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           No
//                         </label>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="competingType"
//                             value="yes"
//                             checked={employmentForm.competingType === 'yes'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, competingType: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           Yes
//                         </label>
//                       </div>
//                     </div>

//                     {employmentForm.competingType === 'yes' && (
//                       <div className="form-group" style={{ margin: 0, paddingLeft: '1rem', borderLeft: '2px solid var(--primary-light)' }}>
//                         <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>If yes, explain:</label>
//                         <input
//                           type="text"
//                           className="form-control"
//                           value={employmentForm.competingDescribe}
//                           onChange={(e) => setEmploymentForm({ ...employmentForm, competingDescribe: e.target.value })}
//                           disabled={isLocked}
//                           style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                         />
//                       </div>
//                     )}

//                     {/* D. Other Potential Conflicts */}
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                       <label className="form-label" style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>D. Other Potential Conflicts</label>
//                       <span style={{ fontSize: '0.7rem', display: 'block', marginBottom: '0.4rem', color: 'var(--text-secondary)' }}>Describe any actual or potential conflict circumstances:</span>
//                       <textarea
//                         className="form-control"
//                         rows="2"
//                         value={employmentForm.otherConflicts}
//                         onChange={(e) => setEmploymentForm({ ...employmentForm, otherConflicts: e.target.value })}
//                         disabled={isLocked}
//                         style={{ padding: '0.4rem 0.65rem', fontSize: '0.85rem', resize: 'vertical' }}
//                         placeholder="None (or details here)"
//                       />
//                     </div>
//                   </div>
//                 )}

//                 {selectedAgreementKey === '401k_dental_vision_medical' && !isAgreementSigned(activeAgreement?.title) && (
//                   <div
//                     style={{
//                       border: '1px solid var(--border-color)',
//                       borderRadius: 'var(--border-radius-md)',
//                       padding: '1.75rem',
//                       backgroundColor: 'var(--bg-secondary)',
//                       boxShadow: 'var(--shadow-sm)',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       gap: '1.25rem'
//                     }}
//                   >
//                     <h4 style={{ fontWeight: 'bold', color: 'var(--primary)', margin: 0, fontSize: '1rem', borderBottom: '2px solid var(--primary)', paddingBottom: '0.5rem' }}>
//                       401K Dental Vision Medical Enrollment Form
//                     </h4>

//                     <div style={{ backgroundColor: 'var(--bg-primary)', padding: '0.75rem 1rem', borderRadius: 'var(--border-radius-sm)', borderLeft: '3px solid var(--primary)' }}>
//                       <h5 style={{ fontWeight: 'bold', fontSize: '0.8rem', margin: '0 0 0.25rem 0', color: 'var(--text-primary)' }}>Instructions</h5>
//                       <p style={{ fontSize: '0.72rem', color: 'var(--text-secondary)', margin: 0, lineHeight: 1.4 }}>
//                         Please complete this form to enroll in the Company's employee benefit programs. Enrollment is subject to eligibility requirements, applicable plan documents, insurance carrier rules, and Company policies.
//                       </p>
//                     </div>



//                     {/* Section 1 – Medical Insurance */}
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                       <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                         Section 1 – Medical Insurance
//                       </label>
//                       <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                         Enrolment Election
//                       </span>
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginBottom: '0.5rem' }}>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="medicalElection"
//                             value="enrol"
//                             checked={employmentForm.medicalElection === 'enrol'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, medicalElection: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           Enrol
//                         </label>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="medicalElection"
//                             value="waive"
//                             checked={employmentForm.medicalElection === 'waive'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, medicalElection: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           Waive Coverage
//                         </label>
//                       </div>
//                     </div>

//                     {employmentForm.medicalElection === 'waive' && (
//                       <div style={{ paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.4rem', borderLeft: '2px solid var(--primary-light)' }}>
//                         <span style={{ fontSize: '0.72rem', color: 'var(--text-secondary)' }}>If waiving medical coverage, reason:</span>
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                           <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                             <input
//                               type="radio"
//                               name="medicalWaiveReason"
//                               value="spouse_plan"
//                               checked={employmentForm.medicalWaiveReason === 'spouse_plan'}
//                               onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
//                               disabled={isLocked}
//                             />
//                             Covered under spouse's employer plan
//                           </label>
//                           <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                             <input
//                               type="radio"
//                               name="medicalWaiveReason"
//                               value="another_plan"
//                               checked={employmentForm.medicalWaiveReason === 'another_plan'}
//                               onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
//                               disabled={isLocked}
//                             />
//                             Covered under another employer plan
//                           </label>
//                           <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                             <input
//                               type="radio"
//                               name="medicalWaiveReason"
//                               value="gov_program"
//                               checked={employmentForm.medicalWaiveReason === 'gov_program'}
//                               onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
//                               disabled={isLocked}
//                             />
//                             Covered under government program
//                           </label>
//                           <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                             <input
//                               type="radio"
//                               name="medicalWaiveReason"
//                               value="other"
//                               checked={employmentForm.medicalWaiveReason === 'other'}
//                               onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
//                               disabled={isLocked}
//                             />
//                             Other:
//                           </label>
//                         </div>
//                         {employmentForm.medicalWaiveReason === 'other' && (
//                           <input
//                             type="text"
//                             className="form-control"
//                             value={employmentForm.medicalWaiveReasonOther}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReasonOther: e.target.value })}
//                             disabled={isLocked}
//                             placeholder="Specify other reason..."
//                             style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem', marginTop: '0.2rem' }}
//                           />
//                         )}
//                       </div>
//                     )}

//                     {/* Section 2 – Dental Insurance */}
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                       <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                         Section 2 – Dental Insurance
//                       </label>
//                       <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                         Enrolment Election
//                       </span>
//                       <div style={{ display: 'flex', gap: '1rem' }}>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="dentalElection"
//                             value="enrol"
//                             checked={employmentForm.dentalElection === 'enrol'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, dentalElection: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           Enrol
//                         </label>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="dentalElection"
//                             value="waive"
//                             checked={employmentForm.dentalElection === 'waive'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, dentalElection: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           Waive Coverage
//                         </label>
//                       </div>
//                     </div>

//                     {/* Section 3 – Vision Insurance */}
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                       <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                         Section 3 – Vision Insurance
//                       </label>
//                       <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                         Enrolment Election
//                       </span>
//                       <div style={{ display: 'flex', gap: '1rem' }}>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="visionElection"
//                             value="enrol"
//                             checked={employmentForm.visionElection === 'enrol'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, visionElection: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           Enrol
//                         </label>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="visionElection"
//                             value="waive"
//                             checked={employmentForm.visionElection === 'waive'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, visionElection: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           Waive Coverage
//                         </label>
//                       </div>
//                     </div>

//                     {/* Section 4 – 401(k) Retirement Plan Enrolment */}
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                       <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                         Section 4 – 401(k) Retirement Plan Enrolment
//                       </label>
//                       <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                         Participation Election
//                       </span>
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginBottom: '0.65rem' }}>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="retirementElection"
//                             value="participate"
//                             checked={employmentForm.retirementElection === 'participate'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, retirementElection: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           I elect to participate in the Company's 401(k) Retirement Plan.
//                         </label>
//                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                           <input
//                             type="radio"
//                             name="retirementElection"
//                             value="decline"
//                             checked={employmentForm.retirementElection === 'decline'}
//                             onChange={(e) => setEmploymentForm({ ...employmentForm, retirementElection: e.target.value })}
//                             disabled={isLocked}
//                           />
//                           I decline participation at this time.
//                         </label>
//                       </div>

//                       {employmentForm.retirementElection === 'participate' && (
//                         <div style={{ paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.65rem', borderLeft: '2px solid var(--primary-light)', marginBottom: '0.75rem' }}>
//                           <span style={{ fontSize: '0.72rem', fontWeight: 600, color: 'var(--text-primary)' }}>Employee Contribution</span>
//                           <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Please deduct the following amount from each eligible pay check:</span>
//                           <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                             <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                               <input
//                                 type="radio"
//                                 name="retirementContributionType"
//                                 value="percentage"
//                                 checked={employmentForm.retirementContributionType === 'percentage'}
//                                 onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionType: e.target.value })}
//                                 disabled={isLocked}
//                               />
//                               % of Eligible Compensation
//                             </label>
//                             {employmentForm.retirementContributionType === 'percentage' && (
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 value={employmentForm.retirementContributionPercent}
//                                 onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionPercent: e.target.value })}
//                                 disabled={isLocked}
//                                 placeholder="%"
//                                 style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem', width: '80px', marginLeft: '1.25rem' }}
//                               />
//                             )}
//                             <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                               <input
//                                 type="radio"
//                                 name="retirementContributionType"
//                                 value="amount"
//                                 checked={employmentForm.retirementContributionType === 'amount'}
//                                 onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionType: e.target.value })}
//                                 disabled={isLocked}
//                               />
//                               $ per pay period (if permitted under the Plan)
//                             </label>
//                             {employmentForm.retirementContributionType === 'amount' && (
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 value={employmentForm.retirementContributionAmount}
//                                 onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionAmount: e.target.value })}
//                                 disabled={isLocked}
//                                 placeholder="$"
//                                 style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem', width: '120px', marginLeft: '1.25rem' }}
//                               />
//                             )}
//                           </div>
//                         </div>
//                       )}

//                       <div style={{ backgroundColor: 'var(--bg-primary)', padding: '0.75rem', borderRadius: 'var(--border-radius-sm)', border: '1px dashed var(--border-color)', fontSize: '0.7rem', color: 'var(--text-secondary)', lineHeight: 1.4 }}>
//                         <strong style={{ color: 'var(--text-primary)', display: 'block', marginBottom: '0.2rem' }}>Company Matching Contribution</strong>
//                         Genesis Tech Engineers Inc. currently provides a matching contribution of 100% of the Employee's elective deferrals up to a maximum of 2% of the Employee's eligible compensation, subject to the terms of the Company's 401(k) Plan and applicable law.
//                         <div style={{ margin: '0.4rem 0', paddingLeft: '0.5rem', borderLeft: '2px solid var(--primary-light)' }}>
//                           • Employee contributes 1% → Company contributes 1%<br />
//                           • Employee contributes 2% → Company contributes 2%<br />
//                           • Employee contributes 5% → Company contributes 2% (maximum Company match)
//                         </div>
//                         Employee contributions above 2% are permitted (subject to the Plan), but will not receive additional Company matching contributions beyond the 2% maximum.<br />
//                         Company matching contributions are subject to the official Plan Document and may be modified, suspended, or terminated by the Company in accordance with applicable law and the Plan.
//                       </div>
//                     </div>

//                     {/* Section 5 – Beneficiary Designation */}
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                       <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                         Section 5 – Beneficiary Designation
//                       </label>

//                       {/* Primary Beneficiary */}
//                       <div style={{ marginBottom: '0.75rem', border: '1px solid var(--border-color)', padding: '0.75rem', borderRadius: 'var(--border-radius-sm)', backgroundColor: 'var(--bg-primary)' }}>
//                         <span style={{ fontSize: '0.75rem', fontWeight: 600, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>Primary Beneficiary</span>
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                           <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                             <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Name:</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               value={employmentForm.primaryBeneName}
//                               onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBeneName: e.target.value })}
//                               disabled={isLocked}
//                               style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                             />
//                           </div>
//                           <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                             <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Relationship:</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               value={employmentForm.primaryBeneRelationship}
//                               onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBeneRelationship: e.target.value })}
//                               disabled={isLocked}
//                               style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                             />
//                           </div>
//                           <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                             <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Date of Birth:</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               value={employmentForm.primaryBeneDob}
//                               onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBeneDob: e.target.value })}
//                               disabled={isLocked}
//                               style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                             />
//                           </div>
//                           <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                             <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Percentage:</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               value={employmentForm.primaryBenePercent}
//                               onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBenePercent: e.target.value })}
//                               disabled={isLocked}
//                               style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                             />
//                           </div>
//                         </div>
//                       </div>

//                       {/* Contingent Beneficiary */}
//                       <div style={{ border: '1px solid var(--border-color)', padding: '0.75rem', borderRadius: 'var(--border-radius-sm)', backgroundColor: 'var(--bg-primary)' }}>
//                         <span style={{ fontSize: '0.75rem', fontWeight: 600, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>Contingent Beneficiary</span>
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                           <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                             <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Name:</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               value={employmentForm.contingentBeneName}
//                               onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBeneName: e.target.value })}
//                               disabled={isLocked}
//                               style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                             />
//                           </div>
//                           <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                             <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Relationship:</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               value={employmentForm.contingentBeneRelationship}
//                               onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBeneRelationship: e.target.value })}
//                               disabled={isLocked}
//                               style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                             />
//                           </div>
//                           <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                             <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Date of Birth:</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               value={employmentForm.contingentBeneDob}
//                               onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBeneDob: e.target.value })}
//                               disabled={isLocked}
//                               style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                             />
//                           </div>
//                           <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                             <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Percentage:</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               value={employmentForm.contingentBenePercent}
//                               onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBenePercent: e.target.value })}
//                               disabled={isLocked}
//                               style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Section 6 – Employee Acknowledgments */}
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                       <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                         Section 6 – Employee Acknowledgments
//                       </label>
//                       <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                         I acknowledge that:
//                       </span>
//                       <ol style={{ paddingLeft: '1.25rem', margin: 0, fontSize: '0.7rem', color: 'var(--text-secondary)', display: 'flex', flexDirection: 'column', gap: '0.35rem', lineHeight: 1.4 }}>
//                         <li>My eligibility for benefits is subject to the applicable benefit plan documents and Company policies.</li>
//                         <li>Insurance coverage becomes effective only after all eligibility requirements are satisfied and enrollment is approved.</li>
//                         <li>I authorize Genesis Tech Engineers Inc. to deduct any required employee premiums or retirement contributions from my pay check as permitted by law.</li>
//                         <li>I understand that the Company reserves the right to amend, modify, replace, or discontinue any employee benefit plan at any time, subject to applicable law.</li>
//                         <li>I understand that the Company's current 401(k) matching contribution is limited to a maximum of 2% of eligible compensation and that contributions above 2% are not matched by the Company.</li>
//                         <li>I certify that all information provided on this form is accurate and complete.</li>
//                       </ol>
//                     </div>
//                   </div>
//                 )}

//                 {isAgreementSigned(activeAgreement?.title) ? (
//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                     <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1.25rem', borderRadius: 'var(--border-radius-sm)', fontSize: '0.85rem' }}>
//                       🚀 <strong>Agreement Signed</strong>: You accepted and electronically signed this agreement on {getSignatureDate(activeAgreement?.title)}.
//                     </div>
//                     <button
//                       type="button"
//                       className="btn btn-primary"
//                       style={{ width: '100%', padding: '0.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                       onClick={() => handleDownloadPdf(activeBlobUrl, `${activeAgreement?.title.toLowerCase().replace(/\s+/g, '_')}_signed.pdf`)}
//                     >
//                       📥 Download Signed {activeAgreement?.displayName || activeAgreement?.title}
//                     </button>
//                   </div>
//                 ) : (
//                   !isLocked && <SignaturePad onSave={(sig) => handleDocumentSign(activeAgreement?.title, sig)} />
//                 )}
//               </div>

//               <div>
//                 {activeBlobUrl ? (
//                   <div style={{ border: '2px solid #334155', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow-md)', backgroundColor: 'var(--bg-secondary)' }}>
//                     <div className="mobile-helper-banner" style={{
//                       padding: '0.75rem 1rem',
//                       backgroundColor: 'var(--bg-tertiary)',
//                       borderBottom: '1px solid var(--border-color)',
//                       display: 'flex',
//                       flexWrap: 'wrap',
//                       alignItems: 'center',
//                       justifyContent: 'space-between',
//                       gap: '0.5rem'
//                     }}>
//                       <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
//                         📱 Reading on Mobile?
//                       </span>
//                       <div style={{ display: 'flex', gap: '0.5rem' }}>
//                         <button
//                           type="button"
//                           className="btn btn-secondary"
//                           style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
//                           onClick={() => handleViewPdf(activeBlobUrl, `${activeAgreement?.title.toLowerCase().replace(/\s+/g, '_')}.pdf`)}
//                         >
//                           📂 Open Fullscreen & Zoom
//                         </button>
//                         <button
//                           type="button"
//                           className="btn btn-primary"
//                           style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
//                           onClick={() => handleDownloadPdf(activeBlobUrl, `${activeAgreement?.title.toLowerCase().replace(/\s+/g, '_')}.pdf`)}
//                         >
//                           📥 Download PDF
//                         </button>
//                       </div>
//                     </div>
//                     <iframe
//                       src={`${activeBlobUrl}#toolbar=0&navpanes=0&view=FitH`}
//                       className="document-iframe"
//                       style={{ height: "750px" }}
//                       title={`${activeAgreement?.displayName || activeAgreement?.title} PDF Viewer`}
//                     />
//                   </div>
//                 ) : (
//                   selectedAgreementKey !== 'employment_agreement' && selectedAgreementKey !== 'employee_agreement' ? (
//                     <div className="document-text-preview" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '3rem' }}>
//                       <span style={{ fontSize: '3rem', marginBottom: '1.25rem' }}>📄</span>
//                       <h4 style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>{activeAgreement?.displayName || activeAgreement?.title}</h4>
//                       <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', maxWidth: '320px' }}>
//                         This onboarding agreement is available. Please view or download the template PDF using the controls above.
//                       </p>
//                     </div>
//                   ) : (
//                     <div className="document-text-preview">

//                       {/* PAGE 1 HEADER */}
//                       <div style={{ textAlign: 'center', borderBottom: '2px solid #0f172a', paddingBottom: '1rem', marginBottom: '1.5rem' }}>
//                         <h2 style={{ fontSize: '1.3rem', fontWeight: 'bold', margin: '0 0 0.5rem 0' }}>GENESIS TECH ENGINEERS PVT. LTD.</h2>
//                         <p style={{ fontSize: '0.7rem', color: '#475569', margin: 0, lineHeight: 1.4 }}>
//                           REGISTERED ADDRESS : PLOT NO 5, GOKUL SOCIETY, DATTAWADI, SADASHIV PETH, PUNE CITY, PUNE - 411030. MH, INDIA.<br />
//                           GST #: 27AAKCG7985R1ZB | PAN # : AAKCG7985R | Contact: +91-8983260210<br />
//                           Website: www.genesistech.co.in | E-mail: contact@genesistech.co.in
//                         </p>
//                       </div>

//                       <h3 style={{ fontSize: '1rem', fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase', marginBottom: '1.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.5rem' }}>
//                         EMPLOYMENT AGREEMENT TERMS & CONDITIONS
//                       </h3>

//                       <p style={{ fontStyle: 'italic', marginBottom: '1.25rem' }}>
//                         This agreement lays down the terms of employment agreed upon by the employer and employee. Whether stated explicitly in the agreement or not, both the employee and the employer have the duty of mutual confidence and trust, and to make only lawful and reasonable demands on each other.
//                       </p>

//                       <p style={{ marginBottom: '1.5rem' }}>
//                         This EMPLOYMENT AGREEMENT (Hereinafter, the “Agreement”) is entered into on this {formatAgreementJoiningDate(employee?.joining_date || employee?.JoiningDate || employee?.joining_Date || employee?.joiningDate || employee?.joining || employee?.hire_date || employee?.HireDate || employmentForm?.hireDate)}
//                       </p>

//                       <p style={{ fontWeight: 'bold', textAlign: 'center', margin: '1rem 0' }}>BY AND BETWEEN</p>

//                       <p style={{ marginBottom: '1rem' }}>
//                         <strong>Genesis Tech Engineers Pvt. Ltd.</strong>, a private limited company incorporated under the Companies Act, 1956, having its registered office at Plot No 5, Shri Gokul Society, Navi Peth, Sadashiv Peth, Pune, 411030. (hereinafter referred to as the “Company” or “Employer”, which expression shall, unless repugnant to the meaning or context hereof, be deemed to include all permitted successors and assigns),
//                       </p>

//                       <p style={{ fontWeight: 'bold', textAlign: 'center', margin: '1rem 0' }}>AND</p>

//                       <p style={{ marginBottom: '1.5rem' }}>
//                         <strong>{employee.FirstName} {employee.LastName}</strong> (hereinafter referred to as the "Employee", which expression shall, unless repugnant to the meaning or context hereof, be deemed to include all permitted successors and assigns).
//                       </p>

//                       <p style={{ marginBottom: '1rem' }}>
//                         <strong>WHEREAS</strong>, the parties hereto desire to enter into this Agreement to define and set forth the terms and conditions of the employment of the Employee by the Company;
//                       </p>

//                       <p style={{ marginBottom: '1.5rem' }}>
//                         <strong>NOW, THEREFORE</strong>, in consideration of the mutual covenants and agreements set forth below, it is hereby covenanted and agreed by the Company and the Employee as follows:
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>1. Interpretation</h4>
//                       <p style={{ marginBottom: '1rem' }}>In this agreement the following terms shall have the following meanings:</p>
//                       <div style={{ marginLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//                         <p>
//                           <strong>a) “Confidential Information”</strong>: any trade secret or other information which is confidential or commercially sensitive and which is not in the public domain (other than through the wrongful disclosure by the Employee) and which belongs to any Clientele Company (whether stored or recorded in documentary or electronic form) and which (without limitation) relates to the business methods, management systems, marketing plans, strategic plans, finances, new or maturing business opportunities, marketing activities, processes, inventions, designs or similar of any Clientele Company, or to which any Clientele Company owes a duty of confidentiality to any third party and including in particular [Trade Secrets, Intellectual Property, Business Strategies & Plans, Customer and Supplier Information, Employee Information, Technological Information, Financial Information, Contracts and Agreements, Research and Development like experimental data and innovative concepts.];
//                         </p>
//                         <p>
//                           <strong>b) “The Employment”</strong>: the employment of the Employee by the Company in accordance with the terms of this agreement;
//                         </p>
//                         <p>
//                           <strong>c) “Clientele Company”</strong>: Clientele Company means the consumer or client of the Genesis Tech Engineers Pvt. Ltd.
//                         </p>
//                         <p>
//                           <strong>d) “Termination Date”</strong>: the date on which the Employment ceases.
//                         </p>
//                       </div>

//                       <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                         [Page 1 of 7]
//                       </div>

//                       {/* PAGE 2 */}
//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>2. Pre-Employment Checks:</h4>
//                       <p style={{ marginBottom: '1rem' }}>
//                         As part of our commitment to maintaining a professional and secure work environment, Genesis Tech Engineers Pvt Ltd conducts pre-employment checks on all prospective employees. These checks are designed to verify the accuracy of information provided during the hiring process and to ensure compliance with company policies and legal requirements. These may include all or any of the following:
//                       </p>
//                       <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                         <li>
//                           <strong>Background Verification</strong>: This will include the verification of the identity (Adhar Card, PAN Card, Passport, Driving License, etc.), educational qualifications required for the role, professional certifications and the reference provided by the candidates if any.
//                         </li>
//                         <li>
//                           <strong>Criminal Conviction Check</strong>: Candidate is required to provide character certificate obtained by the nearest police station where the candidate resides.
//                         </li>
//                         <li>
//                           <strong>Health Declaration or Health Assessment</strong>: Candidate is required to obtain basic full body checkup and candidate is required to submit the reports to at the time of joining the company.
//                         </li>
//                         <li>
//                           <strong>Employment History</strong>: Proof of employment history via relieving letter provided by your previous employers if any.
//                         </li>
//                       </ul>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>3. Freedom to work:</h4>
//                       <p style={{ marginBottom: '1rem' }}>
//                         As an employee of Genesis Tech Engineers Pvt. Ltd., you are expected to uphold the values and standards of our organization. If at any time during your employment, it is discovered that you are under any court order, contractual agreement, or other legal obligation that may interfere with or inhibit your ability to perform your duties or fulfill your obligations to the company, Genesis Tech Engineers Pvt. Ltd. reserves the right to immediately terminate your employment without further notice or liability.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>4. Term and Bond Period</h4>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>a.</strong> In consideration of the opportunities provided by Genesis Tech Engineers Pvt. Ltd., the employee agrees to a binding commitment to remain in the employment of the company for a period of 2 years from the date of commencement.
//                       </p>

//                       <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                         [Page 2 of 7]
//                       </div>

//                       {/* PAGE 3 */}
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>b.</strong> During this period, the employee acknowledges and agrees that they shall not voluntarily terminate their employment or engage in employment with any other entity without explicit prior consent from Genesis Tech Engineers Pvt. Ltd. Any attempt to do so shall be considered a breach of this agreement.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>c.</strong> This commitment is made with the understanding that specialized training, valuable experience, and confidential information will be provided by the company during this period. In the event of a breach, the employee shall be liable for any damage incurred by the company due to their premature departure. Failure to complete the bond duration will result in compensating the amount equal to the remaining duration of the bond period back to the employer.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                         <strong>d.</strong> This clause is binding and enforceable under the applicable laws governing employment agreements.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>5. Performance of Duties</h4>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>a.</strong> The Employee agrees that during the Employment Period, he/she shall devote his/her full business time to the business affairs of the Company and shall perform the duties assigned to him/her faithfully and efficiently, and shall endeavor, to the best of his/her abilities to achieve the goals and adhere to the parameters set by the Company.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>b.</strong> The Employee shall be responsible for:
//                       </p>
//                       <ul style={{ marginLeft: '2.5rem', marginBottom: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                         <li>You must devote the whole time and attention and abilities to the business of Genesis Tech Engineers unless prevented by illness.</li>
//                         <li>Diligently perform such duties as may from time to time be assigned to you.</li>
//                         <li>Comply with all reasonable and lawful directions given to you by Genesis Tech Engineers and your managers.</li>
//                         <li>Act in good faith and in the best interest of Genesis Tech Engineers and its customers and staff always, including reporting your own wrongdoing and any wrongdoing of any other employee immediately on becoming aware of it.</li>
//                         <li>Promote, Protect, Develop, and extend the business of Genesis Tech Engineers.</li>
//                         <li>Take all reasonable steps in respect of the help and safety of yourself, colleagues and third party.</li>
//                       </ul>
//                       <p style={{ marginBottom: '1rem' }}>
//                         A failure to maintain a professional and responsible standard of conduct / behavior, attendance and performance may result in disciplinary action taken against you under the appropriate employment guidelines.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>6. Compensation</h4>
//                       <p style={{ marginBottom: '1rem' }}>Subject to the following provisions of this Agreement, during the Employment Period, the Employee shall be compensated for his services as follows:</p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>a.</strong> The Employee shall receive an annual salary, payable monthly by the Employer. Subject to such increases from time to time, as determined by the Employer. Such payments shall be subject to such normal statutory deductions by the Employer.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>b.</strong> During the term of this Agreement, the Employee's salary shall be paid by means of bank transfer, cheque, or any other method convenient to the Employer, and consented to by the Employee.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                         <strong>c.</strong> All reasonable expenses arising out of employment shall be reimbursed assuming that the same have been authorized prior to being incurred and with the provision of appropriate receipts.
//                       </p>

//                       <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                         [Page 3 of 7]
//                       </div>

//                       {/* PAGE 4 */}
//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>7. Obligations of the Employee</h4>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>a.</strong> Upon execution of agreement, the Employee shall not engage in any sort of theft, fraud, misrepresentation, or any other illegal act neither in the employment space nor outside the premise of employment. If he/she shall do so, the Company shall not be liable for such an act done at his/her own risk.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>b.</strong> The Employee further promises to never engage in any theft of the Employer’s property or attempt to defraud the Employer in any manner.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>c.</strong> The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations and policies of the Company as notified from time to time.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>d.</strong> The Employee shall not take up part-time or full-time employment or consultation with any other party or be involved in any other business during the term of his/her employment with the Company.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>e.</strong> On termination employee shall immediately return to employer all documents, books, material, records, correspondence, papers and information (on whatever media and wherever located) relating to employer business or affairs or relating to employer business contacts, any keys, credit cards, access cards and any other property of employer, which is in your possession or under employee’s control.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>f.</strong> The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations and policies of the Company as notified from time to time, including but not limited to Leave Policy and Sexual Harassment Policy.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                         <strong>g.</strong> The Employer hereby prohibits the Employee from engaging in any sexual harassment and the Employee promises to refrain from any form of sexual harassment during employment in and around the premise of employment. If the Employee violates this term in the agreement, he/she shall be fully responsible for his/her actions and the Employer shall not be held responsible for any illegal acts committed at the discretion of the Employee.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>8. Leave Policy</h4>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>a.</strong> The employee is not entitled to any leave during the probation period with an exception to unforeseen conditions/condition out of control. Refer to the employee internal portal GTELinq for guidelines on leaves during probation period.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>b.</strong> The Employee is entitled to 12 days of paid sick leave (SL) in a year, 11 days of earned leave (EL). In addition, the Employee will be entitled to 10 public holidays mentioned under the Leave Policy of the Employer.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>c.</strong> The leaves earned can be carried forward to a maximum of 45 days over the service period.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>d.</strong> Other than the earned leave the Employee may not carry forward or en-cash any holiday to the next holiday year.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>e.</strong> In the event that the Employee is absent from work due to sickness or injury, he/she will follow the Leave Policy and inform the designated person as soon as possible and will provide regular updates as to his/her recovery and as far as practicable will inform the designated person of the Employer of his/her expected date of return to work.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                         <strong>f.</strong> If the Employee is absent from work due to sickness or injury for more than three consecutive days, he/she must submit to the Employer a self-certification form. If such absence lasts for more than three consecutive days the Employee must obtain a medical certificate from his/her doctor and submit it to the employer.
//                       </p>

//                       <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                         [Page 4 of 7]
//                       </div>

//                       {/* PAGE 5 */}
//                       <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                         <strong>g.</strong> For any period of absence due to sickness or injury the Employee will be paid statutory sick pay only, if he/she satisfies the relevant requirements.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>9. Assignment</h4>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>a.</strong> The Employee acknowledges that any work including without limitation inventions, designs, ideas, concepts, drawings, working notes, artistic works that the Employee may individually or jointly conceive or develop during the term of Employment are “works made for hire” and to the fullest extent permitted by law, Employee shall assign, and does hereby assign, to the Employer all of Employee's right, title and interest in and to all Intellectual Property improved, developed, discovered or written in such works.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                         <strong>b.</strong> Employee shall, upon request of the Employer, execute, acknowledge, deliver, and file any and all documents necessary or useful to vest in the Employer all of Employee's right, title and interest in and to all such matters.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>10. Confidentiality</h4>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>a.</strong> The Employee acknowledges that, while performing and fulfilling his/her duties here under, he/she may have access to and be entrusted with confidential information concerning the present and contemplated financial status and activities of the Employer, the disclosure of any of which confidential information to the competitors of the Employer would be highly detrimental to the interests of the Employer.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>b.</strong> The Employee further acknowledges and agrees that the right to maintain the confidentiality of trade secrets, source code, website information, business plans or client information or other confidential or proprietary information, for the purpose of enabling the other party such information constitutes a proprietary right which the Employer is entitled to protect.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>c.</strong> Accordingly, the Employee covenants and agrees with the Employer that he/she will not, under any circumstance during the continuance of this agreement, disclose any such confidential information to any person, firm or corporation, nor shall he/she use the same, except as required in the normal course of his/her engagement hereunder, and even after the termination of employment, he/she shall not disclose or make use of the same or cause any of confidential information to be disclosed in any manner.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                         <strong>d.</strong> The Employer owns any intellectual property created by the Employee during employment, or in relation to a certain field, and he/she shall thereon have all the necessary rights to retain it. After termination of employment, Employee shall not impose any rights on the intellectual property created. Any source code, software or other intellectual property developed, including but not limited to website design or functionality that was created by the employee, during employment under this Agreement, shall belong to the Employer.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>11. Amendment and Termination</h4>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>a.</strong> Employer may terminate your employment without any notice.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                         <strong>b.</strong> The Employee may terminate his/her employment by providing the Employer with at least 2-month(s) advance notice of his/her intention to resign.
//                       </p>
//                       <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                         <strong>c.</strong> The Employee may terminate on the last day of the month in which the date of the Employee’s death occurs; or the date on which the Company gives notice to the Employee if such termination is for Cause or Disability.
//                       </p>

//                       <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                         [Page 5 of 7]
//                       </div>

//                       {/* PAGE 6 */}
//                       <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                         <strong>d.</strong> For purposes of this Agreement, "Cause" means the Employee's gross misconduct resulting in material damage to the Company, willful insubordination or disobedience, theft, fraud or dishonesty, willful damage or loss of Employer’s property, bribery and habitual lateness or absence, or any other willful and material breach of this Agreement.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>12. Restrictive Covenant</h4>
//                       <p style={{ marginBottom: '1rem' }}>
//                         Following the termination of employment of the Employee by the Employer, with or without cause, or the voluntary withdrawal by the Employee from the Employer, the Employee shall, for a period of three years following the said termination or voluntary withdrawal, refrain from either directly or indirectly soliciting or attempting to solicit the business of any client or customer of the Employer for his own benefit or that of any third person or organization, and shall refrain from either directly or indirectly attempting to obtain the withdrawal from the employment by the Employer of any other Employee of the Employer having regard to the same geographic and temporal restrictions. The Employee shall not directly or indirectly divulge any financial information relating to the Employer or any of its affiliates or clients to any person whatsoever.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>13. Indemnification</h4>
//                       <p style={{ marginBottom: '1rem' }}>
//                         The Employee shall indemnify the employer against any and all expenses, including amounts paid upon judgments, counsel fees, environmental penalties and fines, and amounts paid in settlement (before or after suit is commenced), incurred by the employer in connection with his/her defense or settlement of any claim, action, suit or proceeding in which he/she is made a party or which may be asserted against his/her by reason of his/her employment or the performance of duties in this Agreement. Such indemnification shall be in addition to any other rights to which those indemnified may be entitled under any law, by-law, agreement, or otherwise.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>14. Modification</h4>
//                       <p style={{ marginBottom: '1rem' }}>
//                         Any modification of this Agreement or additional obligation assumed by either party in connection with this Agreement shall be binding only if evidenced in writing signed by each party or an authorized representative of each party.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>15. Severability</h4>
//                       <p style={{ marginBottom: '1rem' }}>
//                         Each paragraph of this agreement shall be and remain separate from and independent of and severable from all and any other paragraphs herein except where otherwise indicated by the context of the agreement. The decision or declaration that one or more of the paragraphs are null and void shall have no effect on the remaining paragraphs of this agreement.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>16. Paragraph headings</h4>
//                       <p style={{ marginBottom: '1rem' }}>
//                         The titles to the paragraphs of this Agreement are solely for the convenience of the parties and shall not be used to explain, modify, simplify, or aid in the interpretation of the provisions of this Agreement.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>17. Applicable Law and Jurisdiction</h4>
//                       <p style={{ marginBottom: '1rem' }}>
//                         This Agreement shall be governed by and construed in accordance with the laws of India. Each party hereby irrevocably submits to the exclusive jurisdiction of the courts of Pune. For the adjudication of any dispute hereunder or in connection herewith.
//                       </p>

//                       <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                         [Page 6 of 7]
//                       </div>

//                       {/* PAGE 7 */}
//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>18. Counterparts</h4>
//                       <p style={{ marginBottom: '1.5rem' }}>
//                         The Agreement may be executed in two or more counterparts, any one of which shall be deemed the original without reference to the others.
//                       </p>

//                       <p style={{ marginBottom: '1.5rem' }}>
//                         <strong>IN WITNESS WHEREOF</strong>, the Employee has hereunto set his hand, and the Company has caused these presents to be executed in its name and on its behalf, all as of the day and year first above written.
//                       </p>

//                       <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>Acceptance</h4>
//                       <p style={{ marginBottom: '2rem' }}>
//                         I have carefully read and accepted all the provisions of this Employment agreement terms and conditions of employment.
//                       </p>

//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', borderTop: '1px dashed #cbd5e1', paddingTop: '1.5rem' }}>
//                         <p><strong>Employee Sign:</strong> ___________________________</p>
//                         <p><strong>Employee Name:</strong> {employee.FirstName} {employee.LastName}</p>
//                         <p><strong>Date:</strong> {formatJoiningDateShort(employee?.joining_date || employee?.JoiningDate || employee?.joining_Date || employee?.joiningDate || employee?.joining || employee?.hire_date || employee?.HireDate || employmentForm?.hireDate)}</p>
//                       </div>

//                       <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                         <p><strong>For: Genesis Tech Engineers Pvt. Ltd.</strong></p>
//                         <div style={{ fontSize: '1rem', fontStyle: 'italic', color: 'var(--primary)', margin: '0.25rem 0' }}>Neeta</div>
//                         <p><strong>Name:</strong> NEETA SHRIKANT SANGVIKAR</p>
//                         <p><strong>Designation:</strong> DIRECTOR HR</p>
//                         <p><strong>Date:</strong> {formatJoiningDateShort(employee?.joining_date || employee?.JoiningDate || employee?.joining_Date || employee?.joiningDate || employee?.joining || employee?.hire_date || employee?.HireDate || employmentForm?.hireDate)}</p>
//                       </div>

//                       <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0 0 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                         [Page 7 of 7]
//                       </div>

//                     </div>
//                   ))}
//               </div>
//             </div>
//           </div>
//         );
//       })()}

//       {/* COMPANY POLICIES TAB */}
//       {activeTab === 'policies' && (() => {
//         const allPoliciesAccepted = genesisPolicies.every(policy => data?.policies?.some(p => p.policy_name === policy.title));
//         const activePolicy = genesisPolicies.find(p => p.id === selectedPolicyId);

//         // Handle selecting a policy
//         const handleSelect = (id) => {
//           setSelectedPolicyId(id);
//           if (id !== 'sign' && !viewedPolicyIds.includes(id)) {
//             setViewedPolicyIds(prev => [...prev, id]);
//           }
//         };

//         const sidebarItems = [
//           ...genesisPolicies,
//           { id: 'sign', title: 'Acceptance & Sign-off', icon: '✍️' }
//         ];

//         return (
//           <div className="card fade-in">
//             <div className="card-title" style={{ marginBottom: '1.5rem' }}>Company Policies Review</div>

//             <div className="policies-layout">
//               {/* Left Column: Sidebar List */}
//               <div className="policies-sidebar">
//                 {sidebarItems.map((item) => {
//                   const isSelected = selectedPolicyId === item.id;
//                   const isSignTab = item.id === 'sign';
//                   const isChecked = isSignTab
//                     ? allPoliciesAccepted
//                     : (viewedPolicyIds.includes(item.id) || allPoliciesAccepted);

//                   return (
//                     <div
//                       key={item.id}
//                       onClick={() => handleSelect(item.id)}
//                       style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'space-between',
//                         padding: '0.85rem 1rem',
//                         borderRadius: '8px',
//                         border: '1px solid var(--border-color)',
//                         backgroundColor: isSelected ? '#0f172a' : 'var(--bg-secondary)',
//                         color: isSelected ? '#ffffff' : 'var(--text-primary)',
//                         cursor: 'pointer',
//                         transition: 'all 0.2s ease',
//                         boxShadow: isSelected ? 'var(--shadow-sm)' : 'none'
//                       }}
//                       className={isSelected ? '' : 'policy-sidebar-item-hover'}
//                     >
//                       <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
//                         <span style={{ fontSize: '1.2rem' }}>{item.icon}</span>
//                         <span style={{ fontSize: '0.85rem', fontWeight: isSelected ? '600' : '500' }}>{item.title}</span>
//                       </div>

//                       {/* Checkbox badge */}
//                       <span style={{
//                         display: 'inline-flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         width: '18px',
//                         height: '18px',
//                         borderRadius: '4px',
//                         backgroundColor: isChecked ? '#10b981' : '#e2e8f0',
//                         color: '#ffffff',
//                         fontSize: '10px',
//                         fontWeight: 'bold',
//                         transition: 'background-color 0.2s'
//                       }}>
//                         {isChecked ? '✓' : ''}
//                       </span>
//                     </div>
//                   );
//                 })}
//               </div>

//               {/* Right Column: Description Panel */}
//               <div className="policies-content">
//                 {selectedPolicyId === 'sign' ? (
//                   <div>
//                     <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.5rem', color: 'var(--text-primary)' }}>Acceptance & Sign-off</h3>
//                     <div style={{ borderBottom: '1px solid var(--border-color)', marginBottom: '1.5rem' }}></div>

//                     <p style={{ fontSize: '0.9rem', color: 'var(--text-primary)', marginBottom: '1rem', lineHeight: '1.5' }}>
//                       By drawing or typing your signature below, you certify and confirm that you have read, understood, and agree to abide by all 11 company policies listed on the left:
//                     </p>

//                     <ul style={{ paddingLeft: '1.5rem', fontSize: '0.85rem', color: 'var(--text-secondary)', lineHeight: '1.6', marginBottom: '2rem' }}>
//                       {genesisPolicies.map(p => (
//                         <li key={p.id}>{p.title}</li>
//                       ))}
//                     </ul>

//                     {allPoliciesAccepted ? (
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                         <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1.25rem', borderRadius: 'var(--border-radius-sm)', fontSize: '0.85rem' }}>
//                           🚀 <strong>Policies Signed & Accepted</strong>: You have read and accepted all company policies. A signed PDF copy has been saved.
//                         </div>
//                         <button
//                           type="button"
//                           className="btn btn-primary"
//                           style={{ width: '100%', padding: '0.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                           onClick={handleDownloadPolicies}
//                         >
//                           📥 Download Signed Policies
//                         </button>
//                       </div>
//                     ) : (
//                       !isLocked && (
//                         <div>
//                           {viewedPolicyIds.length < genesisPolicies.length ? (
//                             <div style={{ backgroundColor: 'var(--bg-tertiary)', borderLeft: '4px solid var(--warning)', padding: '1rem', borderRadius: '4px', fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
//                               ⚠️ <strong>Please read all policies</strong>: You must click and review all 11 policies on the left before you can sign. (Currently reviewed: {viewedPolicyIds.length}/11)
//                             </div>
//                           ) : (
//                             <div>
//                               <div style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginBottom: '0.75rem' }}>
//                                 Please draw or type your electronic signature below:
//                               </div>
//                               <SignaturePad onSave={handlePolicyAccept} />
//                             </div>
//                           )}
//                         </div>
//                       )
//                     )}
//                   </div>
//                 ) : (
//                   activePolicy && (
//                     <div>
//                       <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.5rem', color: 'var(--text-primary)' }}>{activePolicy.title}</h3>
//                       <div style={{ borderBottom: '1px solid var(--border-color)', marginBottom: '1.5rem' }}></div>
//                       <div style={{ color: 'var(--text-primary)', fontSize: '0.9rem', lineHeight: '1.6' }}>
//                         {activePolicy.content}
//                       </div>
//                     </div>
//                   )
//                 )}
//               </div>
//             </div>
//           </div>
//         );
//       })()}

//       {/* TAX INFORMATION TAB */}
//       {activeTab === 'tax' && (
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '1.5rem', alignItems: 'start' }} className="fade-in">
//           {/* LEFT SIDE: INPUTS & ACTIONS */}
//           <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
//             <div className="card-title">Arizona A-4 Tax Withholdings</div>

//             <form onSubmit={(e) => e.preventDefault()} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//               <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 0: Federal & General State Elections</h4>
//               <div className="grid-2">
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="fedTaxSelect">Federal Tax Filing Status</label>
//                   <select id="fedTaxSelect" className="form-control" value={taxForm.federal_tax_status} onChange={(e) => setTaxForm({ ...taxForm, federal_tax_status: e.target.value })} disabled={isLocked}>
//                     <option value="SINGLE">Single or Married Filing Separately</option>
//                     <option value="MARRIED">Married Filing Jointly</option>
//                     <option value="HEAD_OF_HOUSEHOLD">Head of Household</option>
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="fedAllowancesInput">Federal Allowances / Dependents</label>
//                   <input type="number" id="fedAllowancesInput" className="form-control" value={taxForm.federal_allowances} onChange={(e) => setTaxForm({ ...taxForm, federal_allowances: parseInt(e.target.value) || 0 })} min={0} disabled={isLocked} />
//                 </div>
//               </div>

//               <div className="grid-2">
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="stateTaxSelect">State Filing Status (General)</label>
//                   <select id="stateTaxSelect" className="form-control" value={taxForm.state_tax_status} onChange={(e) => setTaxForm({ ...taxForm, state_tax_status: e.target.value })} disabled={isLocked}>
//                     <option value="SINGLE">Single</option>
//                     <option value="MARRIED">Married</option>
//                     <option value="EXEMPT">Exempt</option>
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="stateAllowancesInput">State Allowances (General)</label>
//                   <input type="number" id="stateAllowancesInput" className="form-control" value={taxForm.state_allowances} onChange={(e) => setTaxForm({ ...taxForm, state_allowances: parseInt(e.target.value) || 0 })} min={0} disabled={isLocked} />
//                 </div>
//               </div>

//               <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

//               <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 1: Arizona Form A-4 Personal Information</h4>

//               <div className="form-group">
//                 <label className="form-label" htmlFor="taxName">Full Name</label>
//                 <input
//                   type="text"
//                   id="taxName"
//                   className="form-control"
//                   value={taxForm.name}
//                   onChange={(e) => setTaxForm({ ...taxForm, name: e.target.value })}
//                   disabled={isLocked}
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label" htmlFor="taxSSN">Social Security Number</label>
//                 <input
//                   type="text"
//                   id="taxSSN"
//                   className="form-control"
//                   value={taxForm.ssn}
//                   onChange={(e) => setTaxForm({ ...taxForm, ssn: e.target.value })}
//                   disabled={isLocked}
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label" htmlFor="taxAddress">Home Address</label>
//                 <input
//                   type="text"
//                   id="taxAddress"
//                   className="form-control"
//                   value={taxForm.address}
//                   onChange={(e) => setTaxForm({ ...taxForm, address: e.target.value })}
//                   disabled={isLocked}
//                 />
//               </div>

//               <div className="grid-2">
//                 <div className="form-group">
//                   <label className="form-label" htmlFor="taxCity">City or Town</label>
//                   <input
//                     type="text"
//                     id="taxCity"
//                     className="form-control"
//                     value={taxForm.city}
//                     onChange={(e) => setTaxForm({ ...taxForm, city: e.target.value })}
//                     disabled={isLocked}
//                   />
//                 </div>
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '0.5rem' }}>
//                   <div className="form-group">
//                     <label className="form-label" htmlFor="taxState">State</label>
//                     <input
//                       type="text"
//                       id="taxState"
//                       className="form-control"
//                       value={taxForm.state}
//                       onChange={(e) => setTaxForm({ ...taxForm, state: e.target.value })}
//                       maxLength={2}
//                       disabled={isLocked}
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label className="form-label" htmlFor="taxZip">ZIP Code</label>
//                     <input
//                       type="text"
//                       id="taxZip"
//                       className="form-control"
//                       value={taxForm.zip}
//                       onChange={(e) => setTaxForm({ ...taxForm, zip: e.target.value })}
//                       disabled={isLocked}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

//               <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 2: Withholding Election</h4>

//               <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                 <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem', cursor: 'pointer' }} onClick={() => !isLocked && setTaxForm({ ...taxForm, arizona_box_selection: 1 })}>
//                   <input
//                     type="radio"
//                     id="box1"
//                     name="arizona_box_selection"
//                     checked={taxForm.arizona_box_selection === 1}
//                     onChange={() => { }}
//                     disabled={isLocked}
//                     style={{ marginTop: '0.25rem' }}
//                   />
//                   <label htmlFor="box1" style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer' }}>
//                     <strong>Box 1</strong>: Withhold from gross taxable wages at the percentage checked below (check only one percentage):
//                   </label>
//                 </div>

//                 {taxForm.arizona_box_selection === 1 && (
//                   <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem', paddingLeft: '1.5rem', marginTop: '0.25rem' }}>
//                     {[0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5].map((pct) => (
//                       <label key={pct} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.8rem', cursor: 'pointer' }}>
//                         <input
//                           type="radio"
//                           name="arizona_percentage"
//                           checked={taxForm.arizona_percentage === pct}
//                           onChange={() => !isLocked && setTaxForm({ ...taxForm, arizona_percentage: pct })}
//                           disabled={isLocked}
//                         />
//                         {pct}%
//                       </label>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                 <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem', cursor: 'pointer' }} onClick={() => !isLocked && setTaxForm({ ...taxForm, arizona_box_selection: 2 })}>
//                   <input
//                     type="radio"
//                     id="box2"
//                     name="arizona_box_selection"
//                     checked={taxForm.arizona_box_selection === 2}
//                     onChange={() => { }}
//                     disabled={isLocked}
//                     style={{ marginTop: '0.25rem' }}
//                   />
//                   <label htmlFor="box2" style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer' }}>
//                     <strong>Box 2</strong>: I elect an Arizona withholding percentage of zero, and I certify that I expect to have no Arizona tax liability for the current taxable year.
//                   </label>
//                 </div>
//               </div>

//               <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

//               <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 3: Additional Withholding</h4>

//               <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                 <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem', cursor: 'pointer' }} onClick={() => !isLocked && setTaxForm({ ...taxForm, arizona_extra_amount_checked: !taxForm.arizona_extra_amount_checked })}>
//                   <input
//                     type="checkbox"
//                     id="chkExtraWH"
//                     checked={taxForm.arizona_extra_amount_checked}
//                     onChange={() => { }}
//                     disabled={isLocked}
//                     style={{ marginTop: '0.25rem' }}
//                   />
//                   <label htmlFor="chkExtraWH" style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer' }}>
//                     Check this box and enter an extra amount to be withheld from each paycheck
//                   </label>
//                 </div>

//                 {taxForm.arizona_extra_amount_checked && (
//                   <div className="form-group" style={{ paddingLeft: '1.5rem', marginTop: '0.25rem' }}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                       <span style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>$</span>
//                       <input
//                         type="number"
//                         className="form-control"
//                         placeholder="0.00"
//                         value={taxForm.arizona_extra_amount}
//                         onChange={(e) => setTaxForm({ ...taxForm, arizona_extra_amount: e.target.value })}
//                         min={0}
//                         step="0.01"
//                         disabled={isLocked}
//                       />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </form>

//             <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

//             {/* Signature Area */}
//             {data?.tax?.signed_at ? (
//               <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1rem', borderRadius: '4px', fontSize: '0.85rem' }}>
//                 ✓ <strong>Arizona Form A-4 Electronically Signed</strong>: Signed on {new Date(data.tax.signed_at).toLocaleString()} from IP {data.tax.ip_address}.
//               </div>
//             ) : (
//               !isLocked && (
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//                   <SignaturePad onSave={handleApplySignature} onChange={handleApplySignature} />
//                 </div>
//               )
//             )}

//             {/* Actions Panel */}
//             <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
//               {pdfPreviewUrl && (
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={downloadPdf}
//                   style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                 >
//                   📥 Download Form
//                 </button>
//               )}
//               {!isLocked && !data?.tax?.signed_at && (
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   onClick={handleSaveTaxSubmit}
//                   style={{ flex: 1 }}
//                   disabled={!taxForm.signature}
//                 >
//                   ✍️ Save & Sign
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* RIGHT SIDE: PDF PREVIEW */}
//           <div className="card" style={{ height: 'calc(100vh - 180px)', minHeight: '600px', display: 'flex', flexDirection: 'column', padding: '0.75rem' }}>
//             <div className="card-title" style={{ padding: '0.5rem 0.5rem 1rem 0.5rem', margin: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <span>Live Form Preview</span>
//               <span style={{ fontSize: '0.75rem', fontWeight: 'normal', color: 'var(--text-tertiary)' }}>Updates automatically as you type</span>
//             </div>

//             <div style={{ flex: 1, backgroundColor: 'var(--bg-tertiary)', borderRadius: 'var(--border-radius-sm)', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
//               {pdfPreviewUrl ? (
//                 <iframe
//                   src={`${pdfPreviewUrl}#toolbar=0&navpanes=0`}
//                   title="Arizona A-4 Preview"
//                   width="100%"
//                   height="100%"
//                   style={{ border: 'none', display: 'block' }}
//                 />
//               ) : (
//                 <div style={{ textAlign: 'center', padding: '2rem' }}>
//                   <Loader message="Loading Arizona A-4 Form template..." size="md" />
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* BANK DETAILS TAB */}
//       {activeTab === 'bank' && (
//         <div className="card fade-in">
//           <div className="card-title">Direct Deposit Bank Details</div>

//           {/* Top Information Fields */}
//           <div style={{ marginBottom: '1.5rem' }}>
//             <div className="grid-2">
//               <div className="form-group">
//                 <label className="form-label" htmlFor="bankNameSelect">Bank Name</label>
//                 <input type="text" id="bankNameSelect" className="form-control" value={bankForm.bank_name} onChange={(e) => setBankForm({ ...bankForm, bank_name: e.target.value })} required disabled={isLocked} />
//               </div>
//               <div className="form-group">
//                 <label className="form-label" htmlFor="routingNumberInput">Routing Number / IFSC Code</label>
//                 <input type="text" id="routingNumberInput" className="form-control" maxLength={20} value={bankForm.routing_number} onChange={(e) => setBankForm({ ...bankForm, routing_number: e.target.value })} required disabled={isLocked} />
//               </div>
//             </div>
//             <div className="grid-2">
//               <div className="form-group">
//                 <label className="form-label" htmlFor="accountNumberInput">Account Number</label>
//                 <input type="text" id="accountNumberInput" className="form-control" value={bankForm.account_number} onChange={(e) => setBankForm({ ...bankForm, account_number: e.target.value })} required disabled={isLocked} />
//               </div>
//               <div className="form-group">
//                 <label className="form-label" htmlFor="accountTypeSelect">Account Type</label>
//                 <select
//                   id="accountTypeSelect"
//                   className="form-control"
//                   value={((employee?.country || data?.employee?.country || personalForm?.country || '').toUpperCase()) === 'INDIA' && bankForm.account_type === 'CHECKING' ? 'SAVINGS' : bankForm.account_type}
//                   onChange={(e) => setBankForm({ ...bankForm, account_type: e.target.value })}
//                   disabled={isLocked}
//                 >
//                   {((employee?.country || data?.employee?.country || personalForm?.country || '').toUpperCase()) === 'INDIA' ? (
//                     <>
//                       <option value="SAVINGS">Savings</option>
//                       <option value="CURRENT">Current</option>
//                     </>
//                   ) : (
//                     <>
//                       <option value="CHECKING">Checking</option>
//                       <option value="SAVINGS">Savings</option>
//                     </>
//                   )}
//                 </select>
//               </div>
//             </div>
//             <div className="form-group">
//               <label className="form-label" htmlFor="bankBranchAddressInput">Bank Branch Address</label>
//               <input type="text" id="bankBranchAddressInput" className="form-control" value={bankForm.bank_branch_address} onChange={(e) => setBankForm({ ...bankForm, bank_branch_address: e.target.value })} required disabled={isLocked} />
//             </div>
//           </div>

//           {/* Upload Cancelled Cheque / Bank Proof Section */}
//           <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1.5rem', marginBottom: '1.5rem' }}>
//             <h4 style={{ fontSize: '0.9rem', marginBottom: '0.25rem', fontWeight: 'bold', color: 'var(--text-primary)' }}>
//               Upload Cancelled Cheque / Bank Account Proof <span style={{ color: 'var(--danger)', marginLeft: '4px' }}>*</span>
//             </h4>
//             <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '0.75rem' }}>
//               Attach one of the following: Last month Statement, voided check with A/C number stated
//             </p>
//             <UploadField documentType="Void Cheque" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//           </div>

//           {/* Single Save Details Button at the Bottom */}
//           {!isLocked && (
//             <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1.25rem' }}>
//               <button type="button" onClick={handleSaveBank} className="btn btn-primary" style={{ padding: '0.65rem 1.5rem', fontWeight: 600 }}>
//                 Save Bank Details
//               </button>
//             </div>
//           )}
//         </div>
//       )}

//       {/* PROFILE PHOTO TAB */}
//       {activeTab === 'photo' && (
//         <div className="card fade-in">
//           <div className="card-title">Badge Profile Photo</div>
//           <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
//             Upload a high-quality professional Photo.
//           </p>

//           <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap', position: 'relative' }}>
//             <div
//               style={{
//                 width: '150px',
//                 height: '150px',
//                 borderRadius: '50%',
//                 border: '3px solid var(--border-color)',
//                 background: badgePhotoPath ? `url(/EOP_api/${badgePhotoPath}) center/cover no-repeat` : 'var(--bg-tertiary)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 color: 'var(--text-tertiary)',
//                 fontSize: '0.85rem',
//                 position: 'relative',
//                 overflow: 'hidden'
//               }}
//             >
//               {!badgePhotoPath && 'No Picture'}
//             </div>

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', flex: '1 1 300px' }}>
//               {badgePhotoPath ? (
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//                   <p style={{ fontSize: '0.825rem', color: 'var(--text-secondary)', margin: 0 }}>
//                     Profile photo is uploaded. To upload a different photo, please delete the current photo first.
//                   </p>
//                   <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
//                     <a
//                       href={`/EOP_api/${badgePhotoPath}`}
//                       target="_blank"
//                       rel="noreferrer"
//                       className="btn btn-secondary"
//                       style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', fontWeight: 600 }}
//                     >
//                       👁️ View Photo
//                     </a>
//                     {!isLocked && (
//                       <button
//                         type="button"
//                         className="btn btn-danger"
//                         style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', fontWeight: 600 }}
//                         onClick={handleDeletePhoto}
//                         disabled={uploadingPhoto}
//                       >
//                         🗑️ Delete Photo
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               ) : (
//                 !isLocked && (
//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                     <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-primary)' }}>
//                       Upload Profile Photo:
//                     </label>
//                     <input type="file" className="form-control" accept="image/*" onChange={handlePhotoUpload} disabled={uploadingPhoto} />
//                     <p style={{ color: 'var(--text-tertiary)', fontSize: '0.7rem', margin: 0 }}>JPG, PNG, WEBP (Max 1MB limit)</p>
//                   </div>
//                 )
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* REVIEW & SUBMIT TAB */}
//       {activeTab === 'submit' && (
//         <div className="card fade-in">
//           <div className="card-title">Review & Submit Onboarding Profile</div>
//           <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
//             Before submitting, verify that all sections are complete. Submitting locks your profile and moves it to **Pending HR Review** status.
//           </p>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '2rem' }}>
//             {effectiveDashboardStats?.checklist && Object.entries(effectiveDashboardStats.checklist).map(([key, complete]) => {
//               const label = key.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase());
//               return (
//                 <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.5rem 1rem', border: '1px solid var(--border-color)', borderRadius: '4px' }}>
//                   <span>{label}</span>
//                   <strong style={{ color: complete ? 'var(--success)' : 'var(--danger)' }}>
//                     {complete ? '✓ Ready' : '✗ Required'}
//                   </strong>
//                 </div>
//               );
//             })}
//           </div>

//           {(() => {
//             const reqDocsList = data?.requested_documents || data?.requested_employee_documents || [];
//             const pendingOrUploadedReqs = reqDocsList.filter(r => {
//               const s = (r.status || '').toUpperCase();
//               return s !== 'SUBMITTED' && s !== 'COMPLETED' && s !== 'APPROVED';
//             });

//             if (isLocked && (pendingOrUploadedReqs.length === 0 || requestedDocsSubmitted)) {
//               return (
//                 <div style={{ textAlign: 'center', padding: '1.5rem', backgroundColor: 'var(--bg-tertiary)', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)' }}>
//                   <span style={{ fontSize: '2rem' }}>🔒</span>
//                   <h4 style={{ margin: '0.5rem 0' }}>Profile Locked</h4>
//                   <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>This profile and all requested documents have been submitted to HR.</p>
//                 </div>
//               );
//             }

//             return (
//               <button
//                 type="button"
//                 className="btn btn-primary"
//                 style={{ width: '100%', padding: '0.875rem', fontSize: '1rem', display: 'flex', justifyContent: 'center' }}
//                 onClick={() => setShowSubmitConfirm(true)}
//                 disabled={effectiveDashboardStats?.completed_steps < effectiveDashboardStats?.total_steps}
//               >
//                 {isLocked ? 'Submit Updated Requested Documents' : 'Submit Onboarding Profile'}
//               </button>
//             );
//           })()}
//         </div>
//       )}

//       {showSubmitConfirm && createPortal(
//         <div style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           width: '100vw',
//           height: '100vh',
//           backgroundColor: 'rgba(15, 23, 42, 0.4)',
//           backdropFilter: 'blur(8px)',
//           WebkitBackdropFilter: 'blur(8px)',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           zIndex: 9999,
//           animation: 'fadeIn var(--transition-fast) forwards'
//         }}>
//           <div className="glass-card" style={{
//             width: '460px',
//             maxWidth: '90%',
//             padding: '2.5rem 2rem',
//             borderRadius: 'var(--border-radius-lg)',
//             boxShadow: 'var(--shadow-lg)',
//             backgroundColor: 'var(--bg-secondary)',
//             textAlign: 'center',
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center'
//           }}>
//             <div style={{
//               width: '64px',
//               height: '64px',
//               borderRadius: '50%',
//               backgroundColor: 'var(--primary-light)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontSize: '2rem',
//               marginBottom: '1.25rem',
//               color: 'var(--primary)'
//             }}>
//               🚀
//             </div>
//             <h3 style={{
//               fontSize: '1.5rem',
//               fontWeight: '700',
//               marginBottom: '0.75rem',
//               fontFamily: 'var(--font-heading)',
//               color: 'var(--text-primary)'
//             }}>
//               Submit Onboarding Profile?
//             </h3>
//             <p style={{
//               color: 'var(--text-secondary)',
//               fontSize: '0.9rem',
//               marginBottom: '2rem',
//               lineHeight: '1.6'
//             }}>
//               Are you sure you want to submit your onboarding profile? This will lock all details for HR review and finalize your submission.
//             </p>
//             <div style={{ display: 'flex', gap: '1rem', width: '100%' }}>
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 style={{ flex: 1, padding: '0.75rem 1.25rem', fontSize: '0.9rem' }}
//                 onClick={() => setShowSubmitConfirm(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className="btn btn-primary"
//                 style={{ flex: 1, padding: '0.75rem 1.25rem', fontSize: '0.9rem' }}
//                 onClick={() => {
//                   setShowSubmitConfirm(false);
//                   handleSubmitOnboarding();
//                 }}
//               >
//                 Yes, Submit
//               </button>
//             </div>
//           </div>
//         </div>,
//         document.body
//       )}

//       {submitStatus !== 'idle' && createPortal(
//         <div style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           width: '100vw',
//           height: '100vh',
//           backgroundColor: 'rgba(15, 23, 42, 0.4)',
//           backdropFilter: 'blur(8px)',
//           WebkitBackdropFilter: 'blur(8px)',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           zIndex: 9999,
//           animation: 'fadeIn var(--transition-fast) forwards'
//         }}>
//           <div className="glass-card" style={{
//             width: '460px',
//             maxWidth: '90%',
//             padding: '2.5rem 2rem',
//             borderRadius: 'var(--border-radius-lg)',
//             boxShadow: 'var(--shadow-lg)',
//             backgroundColor: 'var(--bg-secondary)',
//             textAlign: 'center',
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center'
//           }}>
//             {submitStatus === 'submitting' && (
//               <>
//                 <div className="submit-spinner" />
//                 <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.5rem', color: 'var(--text-primary)', fontFamily: 'var(--font-heading)' }}>
//                   Submitting Onboarding
//                 </h3>
//                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: '0 0 1rem 0' }}>
//                   Locking your profile and submitting documents to HR...
//                 </p>
//                 <div className="submit-loader-progress" style={{ width: '100%' }}>
//                   <div className="submit-loader-progress-bar" />
//                 </div>
//               </>
//             )}

//             {submitStatus === 'success' && (
//               <>
//                 <div className="submit-success-icon">✓</div>
//                 <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.75rem', color: 'var(--success)', fontFamily: 'var(--font-heading)' }}>
//                   Successfully Submitted!
//                 </h3>
//                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '2rem', lineHeight: '1.6' }}>
//                   Your onboarding documents and details have been successfully submitted and locked for HR review.
//                 </p>
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   style={{ width: '100%', padding: '0.75rem 1.25rem', fontSize: '0.9rem' }}
//                   onClick={() => {
//                     setSubmitStatus('idle');
//                     setActiveTab('dashboard');
//                   }}
//                 >
//                   Go to Dashboard
//                 </button>
//               </>
//             )}

//             {submitStatus === 'error' && (
//               <>
//                 <div className="submit-error-icon">✗</div>
//                 <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.75rem', color: 'var(--danger)', fontFamily: 'var(--font-heading)' }}>
//                   Submission Failed
//                 </h3>
//                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '2rem', lineHeight: '1.6' }}>
//                   {submitErrorMessage || 'An unexpected error occurred during submission. Please try again.'}
//                 </p>
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   style={{ width: '100%', padding: '0.75rem 1.25rem', fontSize: '0.9rem', backgroundColor: 'var(--danger)', borderColor: 'var(--danger)' }}
//                   onClick={() => setSubmitStatus('idle')}
//                 >
//                   Dismiss & Retry
//                 </button>
//               </>
//             )}
//           </div>
//         </div>,
//         document.body
//       )}

//       {/* POPUP MODAL FOR HR-REQUESTED DOCUMENTS */}
//       {showRequestedDocsModal && (() => {
//         const reqList = data?.requested_documents || data?.requested_employee_documents || [];
//         const pendingList = reqList.filter(req => {
//           const rStatus = (req.status || '').toUpperCase();
//           const rName = (req.document_name || req.document_type || req.title || req.name || '').trim();
//           const isUploadedInEmpDocs = data?.documents?.some(d => d.document_type === rName);
//           return rStatus !== 'UPLOADED' && !isUploadedInEmpDocs;
//         });

//         if (pendingList.length === 0) return null;

//         return createPortal(
//           <div style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100vw',
//             height: '100vh',
//             backgroundColor: 'rgba(15, 23, 42, 0.55)',
//             backdropFilter: 'blur(8px)',
//             WebkitBackdropFilter: 'blur(8px)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             zIndex: 99999,
//             animation: 'fadeIn var(--transition-fast) forwards'
//           }}>
//             <div className="glass-card" style={{
//               width: '520px',
//               maxWidth: '92%',
//               padding: '2.5rem 2rem',
//               borderRadius: 'var(--border-radius-lg)',
//               boxShadow: 'var(--shadow-lg)',
//               backgroundColor: 'var(--bg-secondary)',
//               textAlign: 'center',
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center'
//             }}>
//               <div style={{
//                 width: '64px',
//                 height: '64px',
//                 borderRadius: '50%',
//                 backgroundColor: 'rgba(59, 130, 246, 0.12)',
//                 border: '2px solid rgba(59, 130, 246, 0.3)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 fontSize: '2rem',
//                 marginBottom: '1.25rem',
//                 color: 'var(--primary)'
//               }}>
//                 📋
//               </div>

//               <h3 style={{
//                 fontSize: '1.4rem',
//                 fontWeight: '700',
//                 marginBottom: '0.5rem',
//                 color: 'var(--text-primary)',
//                 fontFamily: 'var(--font-heading)'
//               }}>
//                 Action Required: Additional Documents Requested
//               </h3>

//               <p style={{
//                 color: 'var(--text-secondary)',
//                 fontSize: '0.875rem',
//                 marginBottom: '1.5rem',
//                 lineHeight: '1.5'
//               }}>
//                 Management or HR has specifically requested <strong>{pendingList.length}</strong> additional document(s) for your onboarding profile:
//               </p>

//               <div style={{
//                 width: '100%',
//                 maxHeight: '190px',
//                 overflowY: 'auto',
//                 backgroundColor: 'var(--bg-tertiary)',
//                 borderRadius: 'var(--border-radius-sm)',
//                 border: '1px solid var(--border-color)',
//                 padding: '1rem',
//                 marginBottom: '1.75rem',
//                 textAlign: 'left',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 gap: '0.75rem'
//               }}>
//                 {pendingList.map((req, idx) => {
//                   const name = req.document_name || req.document_type || req.title || req.name || `Requested Document #${idx + 1}`;
//                   const inst = req.instructions || req.comments || req.description || req.note || req.reason || '';
//                   return (
//                     <div key={req.id || idx} style={{ borderBottom: idx < pendingList.length - 1 ? '1px solid var(--border-color)' : 'none', paddingBottom: '0.5rem' }}>
//                       <div style={{ fontWeight: 700, fontSize: '0.9rem', color: 'var(--primary)' }}>
//                         {idx + 1}. {name}
//                       </div>
//                       {inst && (
//                         <div style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', marginTop: '0.2rem' }}>
//                           Instructions: {inst}
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>

//               <button
//                 type="button"
//                 className="btn btn-primary"
//                 style={{ width: '100%', padding: '0.85rem 1.5rem', fontSize: '0.95rem', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                 onClick={() => {
//                   setShowRequestedDocsModal(false);
//                   setHasSeenRequestedDocsModal(true);
//                   setActiveTab('documents');
//                 }}
//               >
//                 Proceed to Documents Page →
//               </button>
//             </div>
//           </div>,
//           document.body
//         );
//       })()}

//       {toast && (
//         <div className="toast-container">
//           <NotificationToast
//             message={toast.message}
//             type={toast.type}
//             onClose={() => setToast(null)}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default EmployeeDashboard;

























// import React, { useState, useEffect, useCallback } from 'react';
// import { createPortal } from 'react-dom';
// import api from '../services/api';
// import UploadField from '../components/UploadField';
// import SignaturePad from '../components/SignaturePad';
// import NotificationToast from '../components/NotificationToast';
// import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
// import { genesisPolicies } from '../constants/genesisPolicies';
// import { genesisPoliciesText } from '../constants/genesisPoliciesText';
// import Loader from '../components/Loader';

// // Helper to convert base64 (including data URIs) to a Uint8Array safely
// const base64ToUint8Array = (base64Str) => {
//     if (!base64Str || typeof base64Str !== 'string') return new Uint8Array(0);
//     try {
//         const commaIdx = base64Str.indexOf(',');
//         let clean = commaIdx !== -1 ? base64Str.substring(commaIdx + 1) : base64Str;
//         clean = clean.replace(/\s/g, '');

//         // Normalize URL-safe base64
//         clean = clean.replace(/-/g, '+').replace(/_/g, '/');

//         // Fix padding if needed
//         const mod = clean.length % 4;
//         if (mod === 2) {
//             clean += '==';
//         } else if (mod === 3) {
//             clean += '=';
//         }

//         const bin = atob(clean);
//         const len = bin.length;
//         const bytes = new Uint8Array(len);
//         for (let i = 0; i < len; i++) {
//             bytes[i] = bin.charCodeAt(i);
//         }
//         return bytes;
//     } catch (e) {
//         console.error("base64ToUint8Array decoding failed:", e);
//         return new Uint8Array(0);
//     }
// };

// // Helper to convert base64 to Blob URL
// const base64ToBlobUrl = (base64Data) => {
//     try {
//         if (!base64Data) return '';
//         const arr = base64ToUint8Array(base64Data);
//         if (arr.length === 0) return '';
//         const blob = new Blob([arr], { type: 'application/pdf' });
//         return URL.createObjectURL(blob);
//     } catch (err) {
//         console.error('Failed to convert base64 to Blob URL:', err);
//         return '';
//     }
// };

// // Helper to fetch local or remote PDF file and convert to base64
// const fetchLocalPdfAsBase64 = async (url) => {
//     if (!url) return '';
//     if (url.startsWith('data:application/pdf;base64,')) {
//         return url.replace('data:application/pdf;base64,', '');
//     }
//     if (url.startsWith('data:')) {
//         const commaIdx = url.indexOf(',');
//         if (commaIdx !== -1) return url.substring(commaIdx + 1);
//     }

//     const bufferToBase64 = (arrayBuffer) => {
//         let binary = '';
//         const bytes = new Uint8Array(arrayBuffer);
//         const len = bytes.byteLength;
//         const chunkSize = 8192;
//         for (let i = 0; i < len; i += chunkSize) {
//             const chunk = bytes.subarray(i, i + chunkSize);
//             binary += String.fromCharCode.apply(null, chunk);
//         }
//         return btoa(binary);
//     };

//     // 1. Direct fetch with CORS mode
//     try {
//         const response = await fetch(url, { mode: 'cors' });
//         if (response.ok) {
//             const arrayBuffer = await response.arrayBuffer();
//             if (arrayBuffer.byteLength > 0) {
//                 return bufferToBase64(arrayBuffer);
//             }
//         }
//     } catch (directErr) {
//         console.warn("Direct PDF fetch failed for:", url, directErr);
//     }

//     // 2. Direct fetch default fallback
//     try {
//         const response = await fetch(url);
//         if (response.ok) {
//             const arrayBuffer = await response.arrayBuffer();
//             if (arrayBuffer.byteLength > 0) {
//                 return bufferToBase64(arrayBuffer);
//             }
//         }
//     } catch (directErr2) {
//         console.warn("Direct fetch fallback failed:", directErr2);
//     }

//     // If local or blob URL, proxy won't work
//     if (url.startsWith('blob:') || url.startsWith('/') || url.includes('localhost')) {
//         return '';
//     }

//     // 3. CORS Proxies for remote host files (fast with 2s timeout per proxy)
//     const proxies = [
//         (u) => `https://api.allorigins.win/raw?url=${encodeURIComponent(u)}`,
//         (u) => `https://corsproxy.io/?${encodeURIComponent(u)}`,
//         (u) => `https://thingproxy.freeboard.io/fetch/${u}`,
//         (u) => `https://api.codetabs.com/v1/proxy?quest=${encodeURIComponent(u)}`
//     ];

//     for (const getProxyUrl of proxies) {
//         const controller = new AbortController();
//         const timeoutId = setTimeout(() => controller.abort(), 2500);
//         try {
//             const proxyUrl = getProxyUrl(url);
//             const res = await fetch(proxyUrl, { signal: controller.signal });
//             clearTimeout(timeoutId);
//             if (res.ok) {
//                 const arrayBuffer = await res.arrayBuffer();
//                 if (arrayBuffer.byteLength > 0) {
//                     return bufferToBase64(arrayBuffer);
//                 }
//             }
//         } catch (e) {
//             clearTimeout(timeoutId);
//             console.warn("Proxy attempt failed:", e);
//         }
//     }

//     return '';
// };

// // Helper to convert typed signature into a transparent PNG data URL on the fly
// const convertTypedToPng = (typedName) => {
//     const canvas = document.createElement('canvas');
//     canvas.width = 400;
//     canvas.height = 150;
//     const ctx = canvas.getContext('2d');

//     // Clear canvas
//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     // Font style matches type signature style in SignaturePad
//     ctx.font = 'italic 40px "Outfit", "Brush Script MT", cursive, sans-serif';
//     ctx.fillStyle = '#0f172a'; // dark slate/primary color
//     ctx.textAlign = 'center';
//     ctx.textBaseline = 'middle';

//     // Draw the text
//     ctx.fillText(typedName, canvas.width / 2, canvas.height / 2);

//     return canvas.toDataURL('image/png');
// };

// // Helper to draw signature PNG on the last page of a PDF
// const generateAgreementPdfData = async (templateBytes, formValues, signaturePng) => {
//     if (!templateBytes) return '';
//     const pdfDoc = await PDFDocument.load(templateBytes);
//     const pages = pdfDoc.getPages();
//     const firstPage = pages[0];

//     const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

//     // Draw values on Page 1
//     const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//     const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();
//     firstPage.drawText(dateStr, {
//         x: 320,
//         y: 695.86,
//         size: 10,
//         font: boldFont,
//         color: rgb(0, 0, 0)
//     });

//     if (formValues.employeeName) {
//         firstPage.drawText(formValues.employeeName, {
//             x: 120,
//             y: 671.50,
//             size: 10,
//             font: boldFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     if (formValues.position) {
//         firstPage.drawText(formValues.position, {
//             x: 85,
//             y: 598.06,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     if (formValues.department) {
//         firstPage.drawText(formValues.department, {
//             x: 100,
//             y: 573.79,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     if (formValues.primaryLocation) {
//         firstPage.drawText(formValues.primaryLocation, {
//             x: 145,
//             y: 549.43,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     const drawTick = (x, y) => {
//         firstPage.drawText('\u2714', {
//             x: x + 1,
//             y: y + 1,
//             size: 10,
//             font: dingbatsFont,
//             color: rgb(0, 0, 0)
//         });
//     };

//     if (formValues.employmentClassification === 'Full-Time') {
//         drawTick(45, 511.51);
//     } else if (formValues.employmentClassification === 'Part-Time') {
//         drawTick(45, 498.07);
//     } else if (formValues.employmentClassification === 'Exempt') {
//         drawTick(45, 484.63);
//     } else if (formValues.employmentClassification === 'Non-Exempt') {
//         drawTick(45, 471.07);
//     }

//     // Draw signature block on Page 5
//     const page5 = pages[4];
//     if (page5) {
//         if (formValues.employeeName) {
//             page5.drawText(formValues.employeeName, {
//                 x: 120,
//                 y: 573.91,
//                 size: 10,
//                 font: boldFont,
//                 color: rgb(0, 0, 0)
//             });
//         }

//         page5.drawText(dateStr, {
//             x: 70,
//             y: 525.07,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         page5.drawText(dateStr, {
//             x: 70,
//             y: 368.69,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         if (signaturePng) {
//             try {
//                 const signatureBytes = base64ToUint8Array(signaturePng);
//                 if (signatureBytes.length > 0) {
//                     const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//                     const signatureImage = isJpg
//                         ? await pdfDoc.embedJpg(signatureBytes)
//                         : await pdfDoc.embedPng(signatureBytes);

//                     page5.drawImage(signatureImage, {
//                         x: 100,
//                         y: 539,
//                         width: 140,
//                         height: 28,
//                     });

//                     // Draw signature and audit text on every page in the empty space
//                     const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//                     pages.forEach((page) => {
//                         page.drawImage(signatureImage, {
//                             x: 195,
//                             y: 20,
//                             width: 100,
//                             height: 35,
//                         });
//                         page.drawText(auditText, {
//                             x: 195,
//                             y: 12,
//                             size: 7,
//                             font: textFont,
//                             color: rgb(0.2, 0.3, 0.4),
//                         });
//                     });
//                 }
//             } catch (e) {
//                 console.error('Error embedding signature in final PDF data:', e);
//             }
//         }
//     }

//     const pdfBytes = await pdfDoc.save();
//     let binary = '';
//     const bytes = new Uint8Array(pdfBytes);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     return btoa(binary);
// };

// const generateNdaPdfData = async (templateBytes, formValues, signaturePng) => {
//     if (!templateBytes) return '';
//     const pdfDoc = await PDFDocument.load(templateBytes);
//     const pages = pdfDoc.getPages();
//     const firstPage = pages[0];

//     const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//     // Draw values on Page 1
//     const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//     const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();

//     if (formValues.employeeName) {
//         firstPage.drawText(formValues.employeeName, {
//             x: 120,
//             y: 636.10,
//             size: 10,
//             font: boldFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     if (formValues.position) {
//         firstPage.drawText(formValues.position, {
//             x: 90,
//             y: 622.18,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     firstPage.drawText(dateStr, {
//         x: 110,
//         y: 608.02,
//         size: 10,
//         font: textFont,
//         color: rgb(0, 0, 0)
//     });

//     // Draw signature block on Page 5
//     const page5 = pages[4];
//     if (page5) {
//         if (formValues.employeeName) {
//             page5.drawText(formValues.employeeName, {
//                 x: 120,
//                 y: 622.18,
//                 size: 10,
//                 font: boldFont,
//                 color: rgb(0, 0, 0)
//             });
//         }

//         page5.drawText(dateStr, {
//             x: 70,
//             y: 608.14,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         page5.drawText(dateStr, {
//             x: 70,
//             y: 473.47,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         if (signaturePng) {
//             try {
//                 const signatureBytes = base64ToUint8Array(signaturePng);
//                 if (signatureBytes.length > 0) {
//                     const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//                     const signatureImage = isJpg
//                         ? await pdfDoc.embedJpg(signatureBytes)
//                         : await pdfDoc.embedPng(signatureBytes);

//                     page5.drawImage(signatureImage, {
//                         x: 140,
//                         y: 640,
//                         width: 140,
//                         height: 28,
//                     });

//                     // Draw signature and audit text on every page in the empty space
//                     const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//                     pages.forEach((page) => {
//                         page.drawImage(signatureImage, {
//                             x: 195,
//                             y: 20,
//                             width: 100,
//                             height: 35,
//                         });
//                         page.drawText(auditText, {
//                             x: 195,
//                             y: 12,
//                             size: 7,
//                             font: textFont,
//                             color: rgb(0.2, 0.3, 0.4),
//                         });
//                     });
//                 }
//             } catch (e) {
//                 console.error('Error embedding signature in final NDA PDF data:', e);
//             }
//         }
//     }

//     const pdfBytes = await pdfDoc.save();
//     let binary = '';
//     const bytes = new Uint8Array(pdfBytes);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     return btoa(binary);
// };

// const generateConflictPdfData = async (templateBytes, formValues, signaturePng) => {
//     if (!templateBytes) return '';
//     const pdfDoc = await PDFDocument.load(templateBytes);
//     const pages = pdfDoc.getPages();
//     const firstPage = pages[0];
//     const page2 = pages[1];
//     const page3 = pages[2];

//     const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

//     // Draw values on Page 1
//     if (formValues.employeeName) {
//         firstPage.drawText(formValues.employeeName, {
//             x: 120,
//             y: 647.02,
//             size: 10,
//             font: boldFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     if (formValues.position) {
//         firstPage.drawText(formValues.position, {
//             x: 85,
//             y: 628.90,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//     const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();
//     firstPage.drawText(dateStr, {
//         x: 110,
//         y: 610.54,
//         size: 10,
//         font: textFont,
//         color: rgb(0, 0, 0)
//     });

//     // Draw values on Page 2 (Questions & Checkboxes)
//     if (page2) {
//         const drawTick = (x, y) => {
//             page2.drawText('\u2714', {
//                 x: x + 1,
//                 y: y + 1,
//                 size: 9.5,
//                 font: dingbatsFont,
//                 color: rgb(0, 0, 0)
//             });
//         };

//         // A. Outside Employment
//         if (formValues.outsideEmploymentType === 'none') {
//             drawTick(43, 664.18);
//         } else if (formValues.outsideEmploymentType === 'has_employment') {
//             drawTick(43, 644.02);

//             if (formValues.outsideEmployer) {
//                 page2.drawText(formValues.outsideEmployer, {
//                     x: 135,
//                     y: 625.90,
//                     size: 9,
//                     font: textFont,
//                     color: rgb(0, 0, 0)
//                 });
//             }
//             if (formValues.outsideNature) {
//                 page2.drawText(formValues.outsideNature, {
//                     x: 115,
//                     y: 607.54,
//                     size: 9,
//                     font: textFont,
//                     color: rgb(0, 0, 0)
//                 });
//             }
//             if (formValues.outsideHours) {
//                 page2.drawText(formValues.outsideHours, {
//                     x: 110,
//                     y: 589.03,
//                     size: 9,
//                     font: textFont,
//                     color: rgb(0, 0, 0)
//                 });
//             }
//         }

//         // B. Ownership of Other Businesses
//         if (formValues.ownershipType === 'no') {
//             drawTick(43, 532.87);
//         } else if (formValues.ownershipType === 'yes') {
//             drawTick(43, 512.71);
//             if (formValues.ownershipDescribe) {
//                 page2.drawText(formValues.ownershipDescribe, {
//                     x: 115,
//                     y: 493.87,
//                     size: 9,
//                     font: textFont,
//                     color: rgb(0, 0, 0)
//                 });
//             }
//         }

//         // C. Competing Activities
//         if (formValues.competingType === 'no') {
//             drawTick(43, 437.59);
//         } else if (formValues.competingType === 'yes') {
//             drawTick(43, 417.53);
//             if (formValues.competingDescribe) {
//                 page2.drawText(formValues.competingDescribe, {
//                     x: 110,
//                     y: 398.69,
//                     size: 9,
//                     font: textFont,
//                     color: rgb(0, 0, 0)
//                 });
//             }
//         }

//         // D. Other Potential Conflicts
//         if (formValues.otherConflicts) {
//             page2.drawText(formValues.otherConflicts, {
//                 x: 45,
//                 y: 348,
//                 size: 8.5,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//     }

//     // Draw signature block on Page 3
//     if (page3) {
//         if (formValues.employeeName) {
//             page3.drawText(formValues.employeeName, {
//                 x: 120,
//                 y: 683.62,
//                 size: 10,
//                 font: boldFont,
//                 color: rgb(0, 0, 0)
//             });
//         }

//         page3.drawText(dateStr, {
//             x: 70,
//             y: 665.50,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         page3.drawText(dateStr, {
//             x: 70,
//             y: 545.23,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         if (signaturePng) {
//             try {
//                 const signatureBytes = base64ToUint8Array(signaturePng);
//                 if (signatureBytes.length > 0) {
//                     const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//                     const signatureImage = isJpg
//                         ? await pdfDoc.embedJpg(signatureBytes)
//                         : await pdfDoc.embedPng(signatureBytes);

//                     page3.drawImage(signatureImage, {
//                         x: 160,
//                         y: 709,
//                         width: 140,
//                         height: 28,
//                     });

//                     // Draw signature and audit text on every page in the empty space
//                     const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//                     pages.forEach((page) => {
//                         page.drawImage(signatureImage, {
//                             x: 195,
//                             y: 20,
//                             width: 100,
//                             height: 35,
//                         });
//                         page.drawText(auditText, {
//                             x: 195,
//                             y: 12,
//                             size: 7,
//                             font: textFont,
//                             color: rgb(0.2, 0.3, 0.4),
//                         });
//                     });
//                 }
//             } catch (e) {
//                 console.error('Error embedding signature in final Conflict PDF data:', e);
//             }
//         }
//     }

//     const pdfBytes = await pdfDoc.save();
//     let binary = '';
//     const bytes = new Uint8Array(pdfBytes);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     return btoa(binary);
// };

// const generateBenefitsPdfData = async (templateBytes, formValues, signaturePng) => {
//     if (!templateBytes) return '';
//     const pdfDoc = await PDFDocument.load(templateBytes);
//     const pages = pdfDoc.getPages();
//     const firstPage = pages[0];
//     const page2 = pages[1];
//     const page3 = pages[2];

//     const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

//     const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//     const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();

//     // Helper to draw checkmarks
//     const drawTick = (page, x, y) => {
//         page.drawText('\u2714', {
//             x: x + 1,
//             y: y + 1,
//             size: 9.5,
//             font: dingbatsFont,
//             color: rgb(0, 0, 0)
//         });
//     };

//     // Draw values on Page 1
//     if (formValues.employeeName) {
//         firstPage.drawText(formValues.employeeName, {
//             x: 130,
//             y: 700.66,
//             size: 10,
//             font: boldFont,
//             color: rgb(0, 0, 0)
//         });
//     }
//     if (formValues.position) {
//         firstPage.drawText(formValues.position, {
//             x: 95,
//             y: 664.06,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }
//     if (formValues.department) {
//         firstPage.drawText(formValues.department, {
//             x: 110,
//             y: 645.70,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }
//     firstPage.drawText(dateStr, {
//         x: 135,
//         y: 609.10,
//         size: 10,
//         font: textFont,
//         color: rgb(0, 0, 0)
//     });

//     // Section 1 - Medical
//     if (formValues.medicalElection === 'enrol') {
//         drawTick(firstPage, 43, 461.23);
//     } else if (formValues.medicalElection === 'waive') {
//         drawTick(firstPage, 43, 441.19);
//         if (formValues.medicalWaiveReason === 'spouse_plan') {
//             drawTick(firstPage, 43, 402.65);
//         } else if (formValues.medicalWaiveReason === 'another_plan') {
//             drawTick(firstPage, 43, 382.61);
//         } else if (formValues.medicalWaiveReason === 'gov_program') {
//             drawTick(firstPage, 43, 362.45);
//         } else if (formValues.medicalWaiveReason === 'other') {
//             drawTick(firstPage, 43, 342.29);
//             if (formValues.medicalWaiveReasonOther) {
//                 firstPage.drawText(formValues.medicalWaiveReasonOther, {
//                     x: 95,
//                     y: 342.29,
//                     size: 9,
//                     font: textFont,
//                     color: rgb(0, 0, 0)
//                 });
//             }
//         }
//     }

//     // Section 2 - Dental
//     if (formValues.dentalElection === 'enrol') {
//         drawTick(firstPage, 43, 285.53);
//     } else if (formValues.dentalElection === 'waive') {
//         drawTick(firstPage, 43, 265.49);
//     }

//     // Section 3 - Vision
//     if (formValues.visionElection === 'enrol') {
//         drawTick(firstPage, 43, 208.70);
//     } else if (formValues.visionElection === 'waive') {
//         drawTick(firstPage, 43, 188.54);
//     }

//     // Section 4 - 401(k) Retirement Participation
//     if (formValues.retirementElection === 'participate') {
//         drawTick(firstPage, 43, 131.78);

//         // Draw contributions on Page 2
//         if (page2) {
//             if (formValues.retirementContributionType === 'percentage') {
//                 drawTick(page2, 43, 717.70);
//                 if (formValues.retirementContributionPercent) {
//                     page2.drawText(String(formValues.retirementContributionPercent), {
//                         x: 58,
//                         y: 717.70,
//                         size: 9,
//                         font: textFont,
//                         color: rgb(0, 0, 0)
//                     });
//                 }
//             } else if (formValues.retirementContributionType === 'amount') {
//                 drawTick(page2, 43, 679.18);
//                 if (formValues.retirementContributionAmount) {
//                     page2.drawText(String(formValues.retirementContributionAmount), {
//                         x: 58,
//                         y: 679.18,
//                         size: 9,
//                         font: textFont,
//                         color: rgb(0, 0, 0)
//                     });
//                 }
//             }
//         }
//     } else if (formValues.retirementElection === 'decline') {
//         drawTick(firstPage, 43, 111.62);
//     }

//     // Section 5 - Beneficiary Designation on Page 2
//     if (page2) {
//         if (formValues.primaryBeneName) {
//             page2.drawText(formValues.primaryBeneName, {
//                 x: 80,
//                 y: 365.81,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         if (formValues.primaryBeneRelationship) {
//             page2.drawText(formValues.primaryBeneRelationship, {
//                 x: 105,
//                 y: 347.45,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         if (formValues.primaryBeneDob) {
//             page2.drawText(formValues.primaryBeneDob, {
//                 x: 105,
//                 y: 329.21,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         if (formValues.primaryBenePercent) {
//             page2.drawText(String(formValues.primaryBenePercent), {
//                 x: 55,
//                 y: 292.61,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }

//         if (formValues.contingentBeneName) {
//             page2.drawText(formValues.contingentBeneName, {
//                 x: 80,
//                 y: 237.62,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         if (formValues.contingentBeneRelationship) {
//             page2.drawText(formValues.contingentBeneRelationship, {
//                 x: 105,
//                 y: 219.26,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         if (formValues.contingentBeneDob) {
//             page2.drawText(formValues.contingentBeneDob, {
//                 x: 105,
//                 y: 201.02,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         if (formValues.contingentBenePercent) {
//             page2.drawText(String(formValues.contingentBenePercent), {
//                 x: 55,
//                 y: 164.30,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//     }

//     // Draw signature block on Page 3
//     if (page3) {
//         if (formValues.employeeName) {
//             page3.drawText(formValues.employeeName, {
//                 x: 110,
//                 y: 535.87,
//                 size: 10,
//                 font: boldFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         page3.drawText(dateStr, {
//             x: 75,
//             y: 517.51,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         page3.drawText(dateStr, {
//             x: 75,
//             y: 232.22,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         if (signaturePng) {
//             try {
//                 const signatureBytes = base64ToUint8Array(signaturePng);
//                 if (signatureBytes.length > 0) {
//                     const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//                     const signatureImage = isJpg
//                         ? await pdfDoc.embedJpg(signatureBytes)
//                         : await pdfDoc.embedPng(signatureBytes);

//                     page3.drawImage(signatureImage, {
//                         x: 160,
//                         y: 544,
//                         width: 140,
//                         height: 28,
//                     });

//                     // Draw signature and audit text on every page in the empty space
//                     const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//                     pages.forEach((page) => {
//                         page.drawImage(signatureImage, {
//                             x: 195,
//                             y: 20,
//                             width: 100,
//                             height: 35,
//                         });
//                         page.drawText(auditText, {
//                             x: 195,
//                             y: 12,
//                             size: 7,
//                             font: textFont,
//                             color: rgb(0.2, 0.3, 0.4),
//                         });
//                     });
//                 }
//             } catch (e) {
//                 console.error('Error embedding signature in final Benefits PDF data:', e);
//             }
//         }
//     }

//     const pdfBytes = await pdfDoc.save();
//     let binary = '';
//     const bytes = new Uint8Array(pdfBytes);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     return btoa(binary);
// };

// const generateNonSolicitationPdfData = async (templateBytes, formValues, signaturePng) => {
//     if (!templateBytes) return '';
//     const pdfDoc = await PDFDocument.load(templateBytes);
//     const pages = pdfDoc.getPages();
//     const firstPage = pages[0];
//     const lastPage = pages[pages.length - 1];

//     const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//     const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//     const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();

//     // Draw values on Page 1
//     if (formValues.employeeName) {
//         firstPage.drawText(formValues.employeeName, {
//             x: 119,
//             y: 665.14,
//             size: 10,
//             font: boldFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     if (formValues.position) {
//         firstPage.drawText(formValues.position, {
//             x: 83,
//             y: 647.02,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     firstPage.drawText(dateStr, {
//         x: 107,
//         y: 628.90,
//         size: 10,
//         font: textFont,
//         color: rgb(0, 0, 0)
//     });

//     // Draw values on last page
//     if (lastPage) {
//         if (formValues.employeeName) {
//             lastPage.drawText(formValues.employeeName, {
//                 x: 120,
//                 y: 317.57,
//                 size: 10,
//                 font: boldFont,
//                 color: rgb(0, 0, 0)
//             });
//         }

//         lastPage.drawText(dateStr, {
//             x: 75,
//             y: 299.21,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         lastPage.drawText(dateStr, {
//             x: 75,
//             y: 130.34,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         if (signaturePng) {
//             try {
//                 const signatureBytes = base64ToUint8Array(signaturePng);
//                 if (signatureBytes.length > 0) {
//                     const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//                     const signatureImage = isJpg
//                         ? await pdfDoc.embedJpg(signatureBytes)
//                         : await pdfDoc.embedPng(signatureBytes);

//                     lastPage.drawImage(signatureImage, {
//                         x: 150,
//                         y: 343,
//                         width: 140,
//                         height: 28,
//                     });

//                     // Draw signature and audit text on every page footer in empty space
//                     const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//                     pages.forEach((page) => {
//                         page.drawImage(signatureImage, {
//                             x: 195,
//                             y: 20,
//                             width: 100,
//                             height: 35,
//                         });
//                         page.drawText(auditText, {
//                             x: 195,
//                             y: 12,
//                             size: 7,
//                             font: textFont,
//                             color: rgb(0.2, 0.3, 0.4),
//                         });
//                     });
//                 }
//             } catch (e) {
//                 console.error('Error embedding signature in final Non Solicitation PDF:', e);
//             }
//         }
//     }

//     const pdfBytes = await pdfDoc.save();
//     let binary = '';
//     const bytes = new Uint8Array(pdfBytes);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     return btoa(binary);
// };

// // Helper to format date as MM/DD/YYYY
// const formatDateMMDDYYYY = (dateVal) => {
//     if (!dateVal) {
//         const now = new Date();
//         const m = String(now.getMonth() + 1).padStart(2, '0');
//         const day = String(now.getDate()).padStart(2, '0');
//         return `${m}/${day}/${now.getFullYear()}`;
//     }
//     let d = null;
//     if (dateVal instanceof Date) {
//         d = dateVal;
//     } else if (typeof dateVal === 'string') {
//         const trimmed = dateVal.trim();
//         // 1. Check YYYY-MM-DD or YYYY/MM/DD
//         const ymdMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
//         if (ymdMatch) {
//             const year = parseInt(ymdMatch[1], 10);
//             const month = parseInt(ymdMatch[2], 10) - 1;
//             const day = parseInt(ymdMatch[3], 10);
//             d = new Date(year, month, day);
//         } else {
//             // 2. Check MM/DD/YYYY or DD/MM/YYYY
//             const mdyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
//             if (mdyMatch) {
//                 const p1 = parseInt(mdyMatch[1], 10);
//                 const p2 = parseInt(mdyMatch[2], 10);
//                 const year = parseInt(mdyMatch[3], 10);
//                 let month, day;
//                 if (p1 > 12) {
//                     day = p1;
//                     month = p2 - 1;
//                 } else if (p2 > 12) {
//                     month = p1 - 1;
//                     day = p2;
//                 } else {
//                     month = p1 - 1;
//                     day = p2;
//                 }
//                 d = new Date(year, month, day);
//             } else {
//                 d = new Date(trimmed);
//             }
//         }
//     } else {
//         d = new Date(dateVal);
//     }

//     if (!d || isNaN(d.getTime())) {
//         const now = new Date();
//         const m = String(now.getMonth() + 1).padStart(2, '0');
//         const day = String(now.getDate()).padStart(2, '0');
//         return `${m}/${day}/${now.getFullYear()}`;
//     }

//     const month = String(d.getMonth() + 1).padStart(2, '0');
//     const day = String(d.getDate()).padStart(2, '0');
//     const year = d.getFullYear();
//     return `${month}/${day}/${year}`;
// };

// // Helper to format joining date for India Employment Agreement (e.g., "21st day of November 2025.")
// const formatAgreementJoiningDate = (dateInput) => {
//     if (!dateInput) return '21st day of November 2025.';
//     let dateObj = null;

//     if (dateInput instanceof Date) {
//         dateObj = dateInput;
//     } else if (typeof dateInput === 'string') {
//         const trimmed = dateInput.trim();

//         // 1. Check YYYY-MM-DD or YYYY/MM/DD (e.g. 2026-09-25, 2026-9-25)
//         const ymdMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
//         if (ymdMatch) {
//             const year = parseInt(ymdMatch[1], 10);
//             const month = parseInt(ymdMatch[2], 10) - 1;
//             const day = parseInt(ymdMatch[3], 10);
//             dateObj = new Date(year, month, day);
//         } else {
//             // 2. Check MM/DD/YYYY or DD/MM/YYYY (e.g. 09/25/2026 or 25/09/2026)
//             const mdyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
//             if (mdyMatch) {
//                 const p1 = parseInt(mdyMatch[1], 10);
//                 const p2 = parseInt(mdyMatch[2], 10);
//                 const year = parseInt(mdyMatch[3], 10);

//                 let month, day;
//                 if (p1 > 12) {
//                     // p1 is Day, p2 is Month (e.g., 25/09/2026)
//                     day = p1;
//                     month = p2 - 1;
//                 } else if (p2 > 12) {
//                     // p1 is Month, p2 is Day (e.g., 09/25/2026)
//                     month = p1 - 1;
//                     day = p2;
//                 } else {
//                     // Standard US format MM/DD/YYYY (e.g., 09/05/2026)
//                     month = p1 - 1;
//                     day = p2;
//                 }
//                 dateObj = new Date(year, month, day);
//             } else {
//                 // 3. Fallback to standard JS Date parsing
//                 dateObj = new Date(trimmed);
//             }
//         }
//     }

//     if (!dateObj || isNaN(dateObj.getTime())) {
//         return '21st day of November 2025.';
//     }

//     const day = dateObj.getDate();
//     const year = dateObj.getFullYear();
//     const monthNames = [
//         'January', 'February', 'March', 'April', 'May', 'June',
//         'July', 'August', 'September', 'October', 'November', 'December'
//     ];
//     const monthName = monthNames[dateObj.getMonth()];

//     let suffix = 'th';
//     if (day % 100 < 11 || day % 100 > 13) {
//         switch (day % 10) {
//             case 1: suffix = 'st'; break;
//             case 2: suffix = 'nd'; break;
//             case 3: suffix = 'rd'; break;
//             default: suffix = 'th'; break;
//         }
//     }

//     return `${day}${suffix} day of ${monthName} ${year}.`;
// };

// // Helper to format short joining date for India Employment Agreement (e.g., "25th September 2026")
// const formatJoiningDateShort = (dateInput) => {
//     if (!dateInput) return '21st November 2025';
//     let dateObj = null;

//     if (dateInput instanceof Date) {
//         dateObj = dateInput;
//     } else if (typeof dateInput === 'string') {
//         const trimmed = dateInput.trim();

//         // 1. Check YYYY-MM-DD or YYYY/MM/DD
//         const ymdMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
//         if (ymdMatch) {
//             const year = parseInt(ymdMatch[1], 10);
//             const month = parseInt(ymdMatch[2], 10) - 1;
//             const day = parseInt(ymdMatch[3], 10);
//             dateObj = new Date(year, month, day);
//         } else {
//             // 2. Check MM/DD/YYYY or DD/MM/YYYY
//             const mdyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
//             if (mdyMatch) {
//                 const p1 = parseInt(mdyMatch[1], 10);
//                 const p2 = parseInt(mdyMatch[2], 10);
//                 const year = parseInt(mdyMatch[3], 10);

//                 let month, day;
//                 if (p1 > 12) {
//                     day = p1;
//                     month = p2 - 1;
//                 } else if (p2 > 12) {
//                     month = p1 - 1;
//                     day = p2;
//                 } else {
//                     month = p1 - 1;
//                     day = p2;
//                 }
//                 dateObj = new Date(year, month, day);
//             } else {
//                 dateObj = new Date(trimmed);
//             }
//         }
//     }

//     if (!dateObj || isNaN(dateObj.getTime())) {
//         return '21st November 2025';
//     }

//     const day = dateObj.getDate();
//     const year = dateObj.getFullYear();
//     const monthNames = [
//         'January', 'February', 'March', 'April', 'May', 'June',
//         'July', 'August', 'September', 'October', 'November', 'December'
//     ];
//     const monthName = monthNames[dateObj.getMonth()];

//     let suffix = 'th';
//     if (day % 100 < 11 || day % 100 > 13) {
//         switch (day % 10) {
//             case 1: suffix = 'st'; break;
//             case 2: suffix = 'nd'; break;
//             case 3: suffix = 'rd'; break;
//             default: suffix = 'th'; break;
//         }
//     }

//     return `${day}${suffix} ${monthName} ${year}`;
// };

// // Helper to draw signature PNG on the last page of a PDF and footers of all pages
// const applySignatureToPdf = async (originalPdfBase64, signaturePngDataUrl, employeeName, docType, isIndia = false, extraDetails = {}) => {
//     try {
//         let pdfDoc;
//         if (originalPdfBase64) {
//             // Convert base64 PDF to bytes safely
//             const pdfBytes = base64ToUint8Array(originalPdfBase64);
//             if (pdfBytes.length === 0) {
//                 throw new Error("Invalid original PDF base64 data");
//             }
//             // Load the PDF document
//             pdfDoc = await PDFDocument.load(pdfBytes);
//         } else {
//             if (docType === 'Offer Letter') {
//                 throw new Error("Unable to retrieve original Offer Letter document bytes for digital signing. Please check network connection.");
//             }
//             // Fallback for other documents: If original PDF is empty, create a simple PDF document
//             pdfDoc = await PDFDocument.create();
//             const page = pdfDoc.addPage([595, 842]); // A4

//             page.drawText(`${docType} Confirmation`, {
//                 x: 50,
//                 y: 750,
//                 size: 20,
//                 color: rgb(0.1, 0.1, 0.1),
//             });

//             page.drawText(`This document serves as confirmation that the employee has electronically signed the ${docType}.`, {
//                 x: 50,
//                 y: 700,
//                 size: 11,
//                 color: rgb(0.2, 0.2, 0.2),
//             });

//             page.drawText(`Employee Name: ${employeeName}`, {
//                 x: 50,
//                 y: 650,
//                 size: 11,
//             });
//         }

//         // Embed signature image if provided
//         let signatureImage = null;
//         if (signaturePngDataUrl) {
//             try {
//                 const isJpg = signaturePngDataUrl.startsWith('data:image/jpeg') || signaturePngDataUrl.startsWith('data:image/jpg');
//                 const signatureBytes = base64ToUint8Array(signaturePngDataUrl);
//                 if (signatureBytes.length > 0) {
//                     if (isJpg) {
//                         signatureImage = await pdfDoc.embedJpg(signatureBytes);
//                     } else {
//                         signatureImage = await pdfDoc.embedPng(signatureBytes);
//                     }
//                 }
//             } catch (imgErr) {
//                 console.warn("Failed to embed signature PNG into PDF:", imgErr);
//             }
//         }

//         // Get all pages
//         const pages = pdfDoc.getPages();
//         if (pages.length === 0) {
//             throw new Error("PDF document has no pages");
//         }
//         const lastPage = pages[pages.length - 1];

//         const currentDate = extraDetails?.date || formatDateMMDDYYYY();
//         const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//         const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//         // Draw signature image and audit text on every page at the footer in the empty space (skip for Offer Letter)
//         if (signatureImage && docType !== 'Offer Letter') {
//             const auditText = `Signed by ${employeeName} on ${currentDate}`;
//             pages.forEach((page) => {
//                 page.drawImage(signatureImage, {
//                     x: 195,
//                     y: 20,
//                     width: 100,
//                     height: 35,
//                 });
//                 page.drawText(auditText, {
//                     x: 195,
//                     y: 12,
//                     size: 7,
//                     font,
//                     color: rgb(0.2, 0.3, 0.4),
//                 });
//             });
//         }

//         // Draw main signature image and texts on the last page
//         if (docType === 'Employee Agreement') {
//             // 1. Draw dynamic Joining Date on Page 1
//             const rawJoiningDate = extraDetails?.joiningDate || extraDetails?.joining_date || extraDetails?.JoiningDate || extraDetails?.hireDate;
//             if (pages.length > 0) {
//                 const firstPage = pages[0];
//                 const formattedJoiningDate = formatAgreementJoiningDate(rawJoiningDate);
//                 // Cover blank underline area starting precisely after "this "
//                 firstPage.drawRectangle({
//                     x: 388.8,
//                     y: 555,
//                     width: 135,
//                     height: 14,
//                     color: rgb(1, 1, 1),
//                 });
//                 // Draw joining date text starting precisely at x: 389.11
//                 firstPage.drawText(formattedJoiningDate, {
//                     x: 389.11,
//                     y: 559.54,
//                     size: 8.8,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });
//             }

//             // Draw Employee Name text
//             lastPage.drawText(employeeName, {
//                 x: 145,
//                 y: 493,
//                 size: 9,
//                 font: fontBold,
//                 color: rgb(0, 0, 0),
//             });

//             // Draw Date text on last page (in front of Date: lines at y: 470.95 and y: 320.21)
//             const formattedDateForLastPage = rawJoiningDate ? formatJoiningDateShort(rawJoiningDate) : currentDate;

//             // Employee Date: line
//             lastPage.drawText(formattedDateForLastPage, {
//                 x: 105,
//                 y: 475,
//                 size: 9,
//                 font: fontBold,
//                 color: rgb(0, 0, 0),
//             });

//             // Director HR Date: line
//             lastPage.drawText(formattedDateForLastPage, {
//                 x: 95,
//                 y: 320.21,
//                 size: 9,
//                 font: fontBold,
//                 color: rgb(0, 0, 0),
//             });

//             if (signatureImage) {
//                 lastPage.drawImage(signatureImage, {
//                     x: 160,
//                     y: 500,
//                     width: 140,
//                     height: 28,
//                 });

//                 // Draw audit text below the signature on the last page
//                 lastPage.drawText(`Digitally signed by ${employeeName} on ${new Date().toLocaleString()}`, {
//                     x: 70.82,
//                     y: 455,
//                     size: 8,
//                     font,
//                     color: rgb(0.3, 0.4, 0.5), // Slate-gray
//                 });
//             }
//         } else if (docType === 'Offer Letter') {
//             if (isIndia) {
//                 const fullNameToDraw = extraDetails?.fullName || employeeName || '';
//                 const aadhaarToDraw = extraDetails?.aadhaarNumber || extraDetails?.aadhaar || extraDetails?.ssn || '';
//                 const dateToDraw = (extraDetails && typeof extraDetails.date === 'string') ? extraDetails.date : currentDate;

//                 // 1. Draw signature image on Signature: line (only after candidate signs)
//                 if (signatureImage) {
//                     lastPage.drawImage(signatureImage, {
//                         x: 105,
//                         y: 335,
//                         width: 110,
//                         height: 28,
//                     });
//                 }

//                 // 2. Draw Full Name (First + Middle + Last) on Full Name (as per Identity Card / Passport): line (pre-filled)
//                 if (fullNameToDraw) {
//                     lastPage.drawText(fullNameToDraw, {
//                         x: 225,
//                         y: 320,
//                         size: 10,
//                         font,
//                         color: rgb(0, 0, 0),
//                     });
//                 }

//                 // 3. Draw Aadhaar Number on Aadhaar Number: line (pre-filled)
//                 if (aadhaarToDraw) {
//                     lastPage.drawText(aadhaarToDraw, {
//                         x: 150,
//                         y: 297,
//                         size: 10,
//                         font,
//                         color: rgb(0, 0, 0),
//                     });
//                 }

//                 // 4. Draw Date on Date: line (only after candidate signs)
//                 if (dateToDraw) {
//                     lastPage.drawText(dateToDraw, {
//                         x: 80,
//                         y: 275,
//                         size: 10,
//                         font,
//                         color: rgb(0, 0, 0),
//                     });
//                 }

//                 // USA & India Offer Letter: Draw bottom signature + digital audit text in clean space
//                 if (signatureImage) {
//                     lastPage.drawImage(signatureImage, {
//                         x: 80,
//                         y: 150,
//                         width: 130,
//                         height: 38,
//                     });

//                     lastPage.drawText(`Digitally signed by ${fullNameToDraw} on ${new Date().toLocaleString()}`, {
//                         x: 80,
//                         y: 136,
//                         size: 8,
//                         font,
//                         color: rgb(0.1, 0.3, 0.6), // Slate-blue
//                     });
//                 }
//             } else {
//                 if (signatureImage) {
//                     lastPage.drawImage(signatureImage, {
//                         x: 80,
//                         y: 150,
//                         width: 130,
//                         height: 38,
//                     });

//                     lastPage.drawText(`Digitally signed by ${employeeName} on ${new Date().toLocaleString()}`, {
//                         x: 80,
//                         y: 136,
//                         size: 8,
//                         font,
//                         color: rgb(0.1, 0.3, 0.6), // Slate-blue
//                     });
//                 }
//             }
//         } else {
//             if (signatureImage) {
//                 lastPage.drawImage(signatureImage, {
//                     x: 75,
//                     y: 120,
//                     width: 150,
//                     height: 55,
//                 });

//                 // Draw audit text below the signature on the last page
//                 lastPage.drawText(`Digitally signed by ${employeeName} on ${new Date().toLocaleString()}`, {
//                     x: 75,
//                     y: 100,
//                     size: 8,
//                     font,
//                     color: rgb(0.3, 0.4, 0.5), // Slate-gray
//                 });
//             }
//         }

//         // Save and return base64
//         const signedPdfBase64 = await pdfDoc.saveAsBase64();
//         return signedPdfBase64;
//     } catch (error) {
//         console.error("Error signing PDF:", error);
//         throw error;
//     }
// };

// const createPoliciesPdf = async (employeeName, signatureDataUrl) => {
//     const pdfDoc = await PDFDocument.create();

//     let page = null;
//     let height = 0;
//     let y = 0;

//     const startNewPage = () => {
//         page = pdfDoc.addPage([600, 850]);
//         height = page.getSize().height;
//         y = height - 50;
//     };

//     startNewPage();

//     // Title
//     page.drawText('GENESIS TECH ENGINEERS PVT. LTD. - COMPANY POLICIES', {
//         x: 50,
//         y,
//         size: 13,
//         color: rgb(0, 0, 0)
//     });
//     y -= 30;

//     // Subtitle
//     page.drawText(`Signed Employee: ${employeeName}`, { x: 50, y, size: 10, color: rgb(0.2, 0.2, 0.2) });
//     page.drawText(`Date: ${new Date().toLocaleDateString()}`, { x: 450, y, size: 10, color: rgb(0.2, 0.2, 0.2) });
//     y -= 25;

//     page.drawText('This document certifies acceptance of the following company policies:', {
//         x: 50,
//         y,
//         size: 10,
//         color: rgb(0.3, 0.3, 0.3)
//     });
//     y -= 20;

//     // Loop over each policy in genesisPoliciesText
//     for (const pol of genesisPoliciesText) {
//         if (y < 80) startNewPage();

//         // Draw Policy Title
//         page.drawText(`${pol.id}. ${pol.title.toUpperCase()}`, {
//             x: 50,
//             y,
//             size: 11,
//             color: rgb(0.05, 0.2, 0.4)
//         });
//         y -= 18;

//         // Draw description lines with word wrapping
//         const textLines = pol.text.split('\n');
//         for (const rawLine of textLines) {
//             const maxLineWidth = 500;
//             const fontSize = 8.5;

//             const words = rawLine.split(' ');
//             let currentLine = '';

//             for (const word of words) {
//                 const testLine = currentLine ? `${currentLine} ${word}` : word;
//                 const approxWidth = testLine.length * 4.5;
//                 if (approxWidth > maxLineWidth) {
//                     if (y < 50) startNewPage();
//                     page.drawText(currentLine, { x: 55, y, size: fontSize, color: rgb(0.15, 0.15, 0.15) });
//                     y -= 13;
//                     currentLine = word;
//                 } else {
//                     currentLine = testLine;
//                 }
//             }

//             if (currentLine) {
//                 if (y < 50) startNewPage();
//                 page.drawText(currentLine, { x: 55, y, size: fontSize, color: rgb(0.15, 0.15, 0.15) });
//                 y -= 13;
//             }
//         }
//         y -= 10;
//     }

//     // Draw signature section at the end
//     if (y < 150) startNewPage();
//     y -= 30;
//     page.drawText('EMPLOYEE SIGN-OFF & ACCEPTANCE', { x: 50, y, size: 10, color: rgb(0, 0, 0) });
//     y -= 20;
//     page.drawText(`I, ${employeeName}, hereby acknowledge that I have read, understood, and accept all 11 company policies detailed in this document.`, {
//         x: 50,
//         y,
//         size: 8.5,
//         color: rgb(0.2, 0.2, 0.2)
//     });
//     y -= 40;

//     if (signatureDataUrl && signatureDataUrl.startsWith('data:image')) {
//         try {
//             const isJpg = signatureDataUrl.startsWith('data:image/jpeg') || signatureDataUrl.startsWith('data:image/jpg');
//             const signatureBytes = base64ToUint8Array(signatureDataUrl);
//             if (signatureBytes.length > 0) {
//                 let pngImage;
//                 if (isJpg) {
//                     pngImage = await pdfDoc.embedJpg(signatureBytes);
//                 } else {
//                     pngImage = await pdfDoc.embedPng(signatureBytes);
//                 }
//                 const pngDims = pngImage.scale(0.35);
//                 if (y - pngDims.height < 50) startNewPage();
//                 page.drawImage(pngImage, {
//                     x: 50,
//                     y: y - pngDims.height,
//                     width: pngDims.width,
//                     height: pngDims.height
//                 });
//                 y -= (pngDims.height + 15);
//                 page.drawText('--------------------------------------', { x: 50, y, size: 10, color: rgb(0.4, 0.4, 0.4) });
//                 y -= 15;
//                 page.drawText(`Employee Signature: ${employeeName}`, { x: 50, y, size: 9, color: rgb(0.1, 0.1, 0.1) });
//             }
//         } catch (e) {
//             console.error("Failed to embed signature in policies PDF:", e);
//         }
//     }

//     const pdfBytes = await pdfDoc.save();

//     // Convert binary to base64 safely
//     let binary = '';
//     const bytes = new Uint8Array(pdfBytes);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     const base64 = btoa(binary);
//     return base64;
// };

// const EmployeeDashboard = ({ activeTab, setActiveTab, onStartTour, onStartVideoTour }) => {
//     const [loading, setLoading] = useState(true);
//     const [uploadingPhoto, setUploadingPhoto] = useState(false);
//     const [data, setData] = useState(null);
//     const [dashboardStats, setDashboardStats] = useState(null);
//     const [toast, setToast] = useState(null);
//     const [showSubmitConfirm, setShowSubmitConfirm] = useState(false);
//     const [showRequestedDocsModal, setShowRequestedDocsModal] = useState(false);
//     const [hasSeenRequestedDocsModal, setHasSeenRequestedDocsModal] = useState(false);
//     const [requestedDocsSubmitted, setRequestedDocsSubmitted] = useState(false);
//     const [submitStatus, setSubmitStatus] = useState('idle'); // 'idle', 'submitting', 'success', 'error'
//     const [submitErrorMessage, setSubmitErrorMessage] = useState('');
//     const [offerLetterBlobUrl, setOfferLetterBlobUrl] = useState('');
//     const [employeeAgreementBlobUrl, setEmployeeAgreementBlobUrl] = useState('');
//     const [selectedAgreementKey, setSelectedAgreementKey] = useState('');
//     const [agreementBlobUrls, setAgreementBlobUrls] = useState({});

//     // Forms state
//     const [personalForm, setPersonalForm] = useState({
//         first_name: '', middle_name: '', last_name: '', preferred_name: '', dob: '', gender: '', pronouns: '',
//         marital_status: '', citizenship: '', phone: '', personal_email: '', address: '',
//         city: '', state: '', zip: '', country: ''
//     });

//     const [emergencyContacts, setEmergencyContacts] = useState([]);
//     const [bankForm, setBankForm] = useState({ bank_name: '', routing_number: '', account_number: '', account_type: 'CHECKING', bank_branch_address: '' });
//     const [taxForm, setTaxForm] = useState({
//         federal_tax_status: 'SINGLE',
//         federal_allowances: 0,
//         state_tax_status: 'SINGLE',
//         state_allowances: 0,
//         name: '',
//         ssn: '',
//         address: '',
//         city: '',
//         state: '',
//         zip: '',
//         arizona_box_selection: 1,
//         arizona_percentage: 2.0,
//         arizona_extra_amount_checked: false,
//         arizona_extra_amount: '',
//         signature: ''
//     });
//     const [expandedPolicyId, setExpandedPolicyId] = useState(null);
//     const [selectedPolicyId, setSelectedPolicyId] = useState(1);
//     const [viewedPolicyIds, setViewedPolicyIds] = useState([1]);

//     // US Form I-9 States
//     const [i9Attestation, setI9Attestation] = useState('US_Citizen');
//     const [uscisNumber, setUscisNumber] = useState('');
//     const [i9Method, setI9Method] = useState('list_a');
//     const [listADocType, setListADocType] = useState('Passport');
//     const [listBDocType, setListBDocType] = useState('Driver License');
//     const [listCDocType, setListCDocType] = useState('Social Security Card');
//     const [selectedState, setSelectedState] = useState('');
//     const [selectedIdOption, setSelectedIdOption] = useState('');
//     const [agreementTemplateBytes, setAgreementTemplateBytes] = useState(null);
//     const [indiaAgreementTemplateBytes, setIndiaAgreementTemplateBytes] = useState(null);
//     const [ndaTemplateBytes, setNdaTemplateBytes] = useState(null);
//     const [conflictTemplateBytes, setConflictTemplateBytes] = useState(null);
//     const [benefitsTemplateBytes, setBenefitsTemplateBytes] = useState(null);
//     const [nonSolicitationTemplateBytes, setNonSolicitationTemplateBytes] = useState(null);
//     const [employmentForm, setEmploymentForm] = useState({
//         employeeName: '',
//         position: '',
//         department: '',
//         primaryLocation: '',
//         employmentClassification: '',
//         effectiveDate: new Date().toLocaleDateString('en-US'),
//         outsideEmploymentType: 'none',
//         outsideEmployer: '',
//         outsideNature: '',
//         outsideHours: '',
//         ownershipType: 'no',
//         ownershipDescribe: '',
//         competingType: 'no',
//         competingDescribe: '',
//         otherConflicts: '',
//         employeeId: '',
//         hireDate: '',
//         medicalElection: 'enrol',
//         medicalWaiveReason: 'spouse_plan',
//         medicalWaiveReasonOther: '',
//         dentalElection: 'enrol',
//         visionElection: 'enrol',
//         retirementElection: 'participate',
//         retirementContributionType: 'percentage',
//         retirementContributionPercent: '',
//         retirementContributionAmount: '',
//         primaryBeneName: '',
//         primaryBeneRelationship: '',
//         primaryBeneDob: '',
//         primaryBenePercent: '',
//         contingentBeneName: '',
//         contingentBeneRelationship: '',
//         contingentBeneDob: '',
//         contingentBenePercent: ''
//     });

//     const fetchOnboardingData = useCallback(async () => {
//         try {
//             const res = await api.get('/onboarding');
//             setData(res.data);

//             // Bind states
//             if (res.data.profile) {
//                 setPersonalForm(prev => ({
//                     first_name: prev.first_name || res.data.profile.first_name || res.data.employee?.FirstName || '',
//                     middle_name: prev.middle_name || res.data.profile.middle_name || '',
//                     last_name: prev.last_name || res.data.profile.last_name || res.data.employee?.LastName || '',
//                     preferred_name: prev.preferred_name || res.data.profile.preferred_name || '',
//                     dob: prev.dob || res.data.profile.dob || '',
//                     gender: prev.gender || res.data.profile.gender || '',
//                     pronouns: prev.pronouns || res.data.profile.pronouns || '',
//                     marital_status: prev.marital_status || res.data.profile.marital_status || '',
//                     citizenship: prev.citizenship || res.data.profile.citizenship || '',
//                     ssn: prev.ssn || res.data.profile.ssn || '',
//                     phone: prev.phone || res.data.profile.phone || '',
//                     personal_email: prev.personal_email || res.data.profile.personal_email || '',
//                     address: prev.address || res.data.profile.address || '',
//                     city: prev.city || res.data.profile.city || '',
//                     state: prev.state || res.data.profile.state || '',
//                     zip: prev.zip || res.data.profile.zip || '',
//                     country: prev.country || res.data.profile.country || ''
//                 }));

//                 // Initialize I-9 attestation options if saved
//                 if (res.data.profile.citizenship) {
//                     if (res.data.profile.citizenship.includes('US_National')) {
//                         setI9Attestation('US_National');
//                     } else if (res.data.profile.citizenship.includes('LPR')) {
//                         setI9Attestation('LPR');
//                         const match = res.data.profile.citizenship.match(/\(([^)]+)\)/);
//                         if (match) setUscisNumber(match[1]);
//                     } else if (res.data.profile.citizenship.includes('Authorized_Alien')) {
//                         setI9Attestation('Authorized_Alien');
//                         const match = res.data.profile.citizenship.match(/\(([^)]+)\)/);
//                         if (match) setUscisNumber(match[1]);
//                     } else {
//                         setI9Attestation('US_Citizen');
//                     }
//                 }
//             } else {
//                 setPersonalForm(prev => ({
//                     ...prev,
//                     first_name: prev.first_name || res.data.employee?.FirstName || '',
//                     last_name: prev.last_name || res.data.employee?.LastName || ''
//                 }));
//             }

//             if (res.data.contacts && res.data.contacts.length > 0) setEmergencyContacts(res.data.contacts);
//             if (res.data.bank) {
//                 const isIndiaCandidate = ((res.data.employee?.country || res.data.profile?.country || '').toUpperCase()) === 'INDIA';
//                 setBankForm(prev => ({
//                     bank_name: prev.bank_name || res.data.bank.bank_name || '',
//                     routing_number: prev.routing_number || res.data.bank.routing_number || '',
//                     account_number: prev.account_number || res.data.bank.account_number || '',
//                     account_type: (prev.account_type && prev.account_type !== 'CHECKING') ? prev.account_type : ((isIndiaCandidate && (!res.data.bank.account_type || res.data.bank.account_type === 'CHECKING')) ? 'SAVINGS' : (res.data.bank.account_type || 'CHECKING')),
//                     bank_branch_address: prev.bank_branch_address || res.data.bank.bank_branch_address || ''
//                 }));
//             }
//             if (res.data.tax) {
//                 let sigPath = res.data.tax.signature_path || '';
//                 if (sigPath && sigPath.startsWith('uploads/')) {
//                     try {
//                         const imgRes = await api.get('/onboarding/tax-signature', { responseType: 'arraybuffer' });
//                         const base64 = btoa(
//                             new Uint8Array(imgRes.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
//                         );
//                         sigPath = `data:image/png;base64,${base64}`;
//                     } catch (e) {
//                         console.error('Failed to load saved signature image:', e);
//                         let errMsg = e.message;
//                         if (e.response?.data instanceof ArrayBuffer) {
//                             try {
//                                 const decoded = new TextDecoder('utf-8').decode(e.response.data);
//                                 const parsed = JSON.parse(decoded);
//                                 if (parsed.error) errMsg = parsed.error;
//                             } catch (parseErr) { }
//                         }
//                         setToast({ message: 'Signature load error: ' + errMsg, type: 'error' });
//                     }
//                 } else if (sigPath && sigPath.startsWith('typed:')) {
//                     sigPath = sigPath.substring(6);
//                 }

//                 setTaxForm({
//                     federal_tax_status: res.data.tax.federal_tax_status || 'SINGLE',
//                     federal_allowances: res.data.tax.federal_allowances || 0,
//                     state_tax_status: res.data.tax.state_tax_status || 'SINGLE',
//                     state_allowances: res.data.tax.state_allowances || 0,
//                     name: res.data.tax.name || (res.data.profile ? `${res.data.profile.first_name || ''} ${res.data.profile.last_name || ''}`.trim() : ''),
//                     ssn: res.data.tax.ssn || res.data.profile?.ssn || '',
//                     address: res.data.tax.address || res.data.profile?.address || '',
//                     city: res.data.tax.city || res.data.profile?.city || '',
//                     state: res.data.tax.state || res.data.profile?.state || '',
//                     zip: res.data.tax.zip || res.data.profile?.zip || '',
//                     arizona_box_selection: res.data.tax.arizona_box_selection !== null && res.data.tax.arizona_box_selection !== undefined ? parseInt(res.data.tax.arizona_box_selection) : 1,
//                     arizona_percentage: res.data.tax.arizona_percentage !== null && res.data.tax.arizona_percentage !== undefined ? parseFloat(res.data.tax.arizona_percentage) : 2.0,
//                     arizona_extra_amount_checked: !!parseInt(res.data.tax.arizona_extra_amount_checked || 0),
//                     arizona_extra_amount: res.data.tax.arizona_extra_amount !== null && res.data.tax.arizona_extra_amount !== undefined ? res.data.tax.arizona_extra_amount.toString() : '',
//                     signature: sigPath
//                 });
//             } else {
//                 setTaxForm(prev => ({
//                     ...prev,
//                     name: res.data.profile ? `${res.data.profile.first_name || ''} ${res.data.profile.last_name || ''}`.trim() : '',
//                     ssn: res.data.profile?.ssn || '',
//                     address: res.data.profile?.address || '',
//                     city: res.data.profile?.city || '',
//                     state: res.data.profile?.state || '',
//                     zip: res.data.profile?.zip || '',
//                 }));
//             }

//             // Fetch dashboard metrics
//             const statsRes = await api.get('/dashboard/employee');
//             setDashboardStats(statsRes.data);

//             // Convert base64 fields to Blob URLs to avoid data URI issues in iframes
//             if (res.data.employee) {
//                 setEmploymentForm(prev => ({
//                     employeeName: prev.employeeName || `${res.data.employee.FirstName || ''} ${res.data.employee.LastName || ''}`.trim(),
//                     position: prev.position || res.data.employee.Designation || res.data.employee.position || '',
//                     department: prev.department || res.data.employee.Department || res.data.employee.department || '',
//                     primaryLocation: '',
//                     employmentClassification: '',
//                     effectiveDate: prev.effectiveDate || new Date().toLocaleDateString('en-US'),
//                     outsideEmploymentType: prev.outsideEmploymentType || 'none',
//                     outsideEmployer: prev.outsideEmployer || '',
//                     outsideNature: prev.outsideNature || '',
//                     outsideHours: prev.outsideHours || '',
//                     ownershipType: prev.ownershipType || 'no',
//                     ownershipDescribe: prev.ownershipDescribe || '',
//                     competingType: prev.competingType || 'no',
//                     competingDescribe: prev.competingDescribe || '',
//                     otherConflicts: prev.otherConflicts || '',
//                     employeeId: prev.employeeId || res.data.employee.id || '',
//                     hireDate: res.data.employee.joining_date || res.data.employee.JoiningDate || res.data.employee.joining_Date || res.data.employee.joiningDate || res.data.employee.joining || res.data.employee.hire_date || res.data.employee.HireDate || prev.hireDate || '',
//                     medicalElection: prev.medicalElection || 'enrol',
//                     medicalWaiveReason: prev.medicalWaiveReason || 'spouse_plan',
//                     medicalWaiveReasonOther: prev.medicalWaiveReasonOther || '',
//                     dentalElection: prev.dentalElection || 'enrol',
//                     visionElection: prev.visionElection || 'enrol',
//                     retirementElection: prev.retirementElection || 'participate',
//                     retirementContributionType: prev.retirementContributionType || 'percentage',
//                     retirementContributionPercent: prev.retirementContributionPercent || '',
//                     retirementContributionAmount: prev.retirementContributionAmount || '',
//                     primaryBeneName: prev.primaryBeneName || '',
//                     primaryBeneRelationship: prev.primaryBeneRelationship || '',
//                     primaryBeneDob: prev.primaryBeneDob || '',
//                     primaryBenePercent: prev.primaryBenePercent || '',
//                     contingentBeneName: prev.contingentBeneName || '',
//                     contingentBeneRelationship: prev.contingentBeneRelationship || '',
//                     contingentBeneDob: prev.contingentBeneDob || '',
//                     contingentBenePercent: prev.contingentBenePercent || ''
//                 }));
//                 // Offer Letter
//                 const isOfferSigned = res.data.signature_history?.some(
//                     h => h.document_type === 'Offer Letter' && h.action === 'SIGN'
//                 );
//                 const signedOfferBase64 = res.data.signed_agreements?.['Offer Letter'];
//                 const rawPath = res.data.employee?.offer_letter || res.data.employee?.offer_letter_path;
//                 let realOfferUrl = '';
//                 if (rawPath) {
//                     let cleanPath = rawPath.replace(/^\//, '');
//                     if (!cleanPath.startsWith('http://') && !cleanPath.startsWith('https://')) {
//                         cleanPath = cleanPath.startsWith('offer_letters/')
//                             ? `https://hiring.gtelinq.com/hiring-backend/${cleanPath}`
//                             : `/EOP_api/${cleanPath}`;
//                     }
//                     realOfferUrl = cleanPath;
//                 }

//                 const fName = personalForm.first_name || res.data.profile?.first_name || res.data.employee?.FirstName || res.data.employee?.first_name || '';
//                 const mName = personalForm.middle_name || res.data.profile?.middle_name || res.data.employee?.MiddleName || res.data.employee?.middle_name || '';
//                 const lName = personalForm.last_name || res.data.profile?.last_name || res.data.employee?.LastName || res.data.employee?.last_name || '';
//                 const fullName = [fName, mName, lName].filter(Boolean).join(' ').trim() || 'Employee';
//                 const aadhaarNumber = personalForm.ssn || res.data.profile?.ssn || res.data.employee?.ssn || res.data.employee?.AadhaarNumber || res.data.employee?.aadhaar_number || '';
//                 const isIndiaCandidate = ((res.data.employee?.country || res.data.profile?.country || '').toUpperCase()) === 'INDIA';

//                 let offerUrlToSet = '';
//                 if (isOfferSigned) {
//                     if (signedOfferBase64) {
//                         offerUrlToSet = base64ToBlobUrl(signedOfferBase64);
//                     } else {
//                         const sigObj = res.data.signature_history?.find(h => h.document_type === 'Offer Letter' && h.action === 'SIGN');
//                         const sigData = sigObj?.signature_path || '';
//                         let sigPng = sigData;
//                         if (sigData && !sigData.startsWith('data:image')) {
//                             sigPng = convertTypedToPng(sigData);
//                         }
//                         const signedDate = sigObj?.signed_at || sigObj?.created_at;
//                         const formattedDate = formatDateMMDDYYYY(signedDate);

//                         let baseToSign = res.data.employee?.offer_letter_base64 || '';
//                         if (!baseToSign && realOfferUrl) {
//                             try {
//                                 baseToSign = await fetchLocalPdfAsBase64(realOfferUrl);
//                             } catch (e) {
//                                 console.error("Failed to fetch real offer letter PDF for overlay:", e);
//                             }
//                         }

//                         if (baseToSign && (sigPng || isIndiaCandidate)) {
//                             try {
//                                 const signedPdfBase64 = await applySignatureToPdf(baseToSign, sigPng, fullName, 'Offer Letter', isIndiaCandidate, {
//                                     fullName,
//                                     aadhaarNumber,
//                                     date: formattedDate
//                                 });
//                                 offerUrlToSet = base64ToBlobUrl(signedPdfBase64);
//                             } catch (err) {
//                                 console.error("Failed to generate signed PDF:", err);
//                                 offerUrlToSet = realOfferUrl;
//                             }
//                         } else {
//                             offerUrlToSet = realOfferUrl;
//                         }
//                     }
//                 } else {
//                     // Pre-sign preview: For India candidates, pre-fill Full Name and Aadhaar Number on the PDF template
//                     let baseToSign = res.data.employee?.offer_letter_base64 || '';
//                     if (!baseToSign && realOfferUrl) {
//                         try {
//                             baseToSign = await fetchLocalPdfAsBase64(realOfferUrl);
//                         } catch (e) {
//                             console.error("Failed to fetch real offer letter PDF for preview:", e);
//                         }
//                     }

//                     if (baseToSign && isIndiaCandidate) {
//                         try {
//                             const prefilledPdfBase64 = await applySignatureToPdf(baseToSign, null, fullName, 'Offer Letter', true, {
//                                 fullName,
//                                 aadhaarNumber,
//                                 date: ''
//                             });
//                             offerUrlToSet = base64ToBlobUrl(prefilledPdfBase64);
//                         } catch (err) {
//                             console.error("Failed to generate pre-filled offer letter preview:", err);
//                             offerUrlToSet = realOfferUrl;
//                         }
//                     } else if (res.data.employee?.offer_letter_base64) {
//                         offerUrlToSet = base64ToBlobUrl(res.data.employee.offer_letter_base64);
//                     } else if (realOfferUrl) {
//                         offerUrlToSet = realOfferUrl;
//                     }
//                 }

//                 setOfferLetterBlobUrl(prev => {
//                     if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//                     return offerUrlToSet;
//                 });

//                 // Employee Agreement
//                 const isAgreementSigned = res.data.signature_history?.some(
//                     h => h.document_type === 'Employee Agreement' && h.action === 'SIGN'
//                 );
//                 if (isAgreementSigned && res.data.employee.employee_agreement_base64) {
//                     const agreementUrl = base64ToBlobUrl(res.data.employee.employee_agreement_base64);
//                     setEmployeeAgreementBlobUrl(prev => {
//                         if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//                         return agreementUrl;
//                     });
//                 } else {
//                     // Unsigned fallback: load appropriate template directly from public folder based on country
//                     const country = res.data.employee?.country || '';
//                     const templatePath = country.toUpperCase() === 'USA' ? '/employee_agreement_usa.pdf' : '/3-Employment Agreement.pdf';
//                     setEmployeeAgreementBlobUrl(prev => {
//                         if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//                         return templatePath;
//                     });
//                 }

//                 // Multiple agreements resolution for US candidates
//                 const country = res.data.employee?.country || '';
//                 const isUsa = country.toUpperCase() === 'USA';
//                 const list = isUsa ? [
//                     { key: 'employment_agreement', title: 'Employment Agreement 1', displayName: 'Employment Agreement', path: '/Employment Agreement 1.pdf' },
//                     { key: 'confidentiality_nda', title: 'Employee Confidentiality & NDA (1)', displayName: 'Employee Confidentiality & NDA', path: '/Employee Confidentiality & NDA (1).pdf' },
//                     { key: 'conflict_of_interest', title: 'Conflict of interest agreement', path: '/Conflict of interest agreement.pdf' },
//                     { key: '401k_dental_vision_medical', title: '401K Dental Vision Medical', path: '/401K Dental Vision Medical.pdf' },
//                     { key: 'non_solicitation', title: 'Non Solicitation', path: '/Non Solicitation.pdf' }
//                 ] : [
//                     { key: 'employee_agreement', title: 'Employee Agreement', path: '/3-Employment Agreement.pdf' }
//                 ];

//                 const urls = {};
//                 for (const item of list) {
//                     const signedBase64 = res.data.signed_agreements?.[item.title];
//                     const legacyBase64 = (item.title === 'Employee Agreement' && isAgreementSigned && res.data.employee?.employee_agreement_base64) ? res.data.employee.employee_agreement_base64 : null;
//                     const base64Data = signedBase64 || legacyBase64;
//                     if (base64Data) {
//                         urls[item.key] = base64ToBlobUrl(base64Data);
//                     } else if (item.key === 'employee_agreement') {
//                         try {
//                             let tBytes = indiaAgreementTemplateBytes;
//                             if (!tBytes) {
//                                 const resp = await fetch('/3-Employment Agreement.pdf');
//                                 const ab = await resp.arrayBuffer();
//                                 tBytes = new Uint8Array(ab);
//                                 setIndiaAgreementTemplateBytes(tBytes);
//                             }
//                             let binary = '';
//                             const len = tBytes.byteLength;
//                             for (let i = 0; i < len; i++) {
//                                 binary += String.fromCharCode(tBytes[i]);
//                             }
//                             const templateBase64 = btoa(binary);
//                             const emp = res.data.employee || {};
//                             const jDateStr = emp.joining_date || emp.JoiningDate || emp.joining_Date || emp.joiningDate || emp.joining || emp.hire_date || emp.HireDate || '2025-11-21';
//                             const fName = [
//                                 res.data.profile?.first_name || emp.FirstName || emp.first_name || '',
//                                 res.data.profile?.middle_name || emp.MiddleName || emp.middle_name || '',
//                                 res.data.profile?.last_name || emp.LastName || emp.last_name || ''
//                             ].filter(Boolean).join(' ').trim() || 'Employee';

//                             const prefilledBase64 = await applySignatureToPdf(
//                                 templateBase64,
//                                 null,
//                                 fName,
//                                 'Employee Agreement',
//                                 true,
//                                 {
//                                     joiningDate: jDateStr,
//                                     date: formatDateMMDDYYYY()
//                                 }
//                             );
//                             urls[item.key] = base64ToBlobUrl(prefilledBase64);
//                         } catch (prefilledErr) {
//                             console.error("Failed to generate prefilled agreement Blob URL in fetchOnboardingData:", prefilledErr);
//                             urls[item.key] = item.path;
//                         }
//                     } else {
//                         urls[item.key] = item.path;
//                     }
//                 }
//                 setAgreementBlobUrls(prev => {
//                     Object.entries(prev).forEach(([key, url]) => {
//                         if (url && url.startsWith('blob:') && url !== urls[key]) {
//                             URL.revokeObjectURL(url);
//                         }
//                     });
//                     return urls;
//                 });
//                 setSelectedAgreementKey(prev => {
//                     const keys = list.map(item => item.key);
//                     if (prev && keys.includes(prev)) return prev;
//                     return keys[0] || '';
//                 });
//             }

//             // Automatically select state in dropdown if a state tax form is already uploaded
//             if (res.data.documents) {
//                 const existing = res.data.documents.find(doc =>
//                     doc.document_type === 'Oregon State Tax Form' ||
//                     doc.document_type === 'Arizona State Tax Form' ||
//                     doc.document_type === 'Colorado State Tax Form'
//                 );
//                 if (existing) {
//                     if (existing.document_type === 'Oregon State Tax Form') setSelectedState('oregon');
//                     else if (existing.document_type === 'Arizona State Tax Form') setSelectedState('arizona');
//                     else if (existing.document_type === 'Colorado State Tax Form') setSelectedState('colorado');
//                 }
//             }

//             // Check for pending requested documents to show popup alert
//             const reqList = res.data?.requested_documents || res.data?.requested_employee_documents || [];
//             const pendingReqs = reqList.filter(req => {
//                 const rStatus = (req.status || '').toUpperCase();
//                 const rName = (req.document_name || req.document_type || req.title || req.name || '').trim();
//                 const isUploadedInEmpDocs = res.data?.documents?.some(d => d.document_type === rName);
//                 return rStatus !== 'UPLOADED' && !isUploadedInEmpDocs;
//             });

//             if (pendingReqs.length > 0 && !hasSeenRequestedDocsModal) {
//                 setShowRequestedDocsModal(true);
//             }
//             window.dispatchEvent(new Event('onboarding_updated'));
//         } catch (err) {
//             setToast({ message: 'Failed to load onboarding profile details.', type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     }, [hasSeenRequestedDocsModal]);

//     useEffect(() => {
//         fetchOnboardingData();
//     }, [fetchOnboardingData, activeTab]);

//     // Cleanup Blob URLs on unmount
//     useEffect(() => {
//         return () => {
//             setOfferLetterBlobUrl(prev => {
//                 if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//                 return '';
//             });
//             setEmployeeAgreementBlobUrl(prev => {
//                 if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//                 return '';
//             });
//             setAgreementBlobUrls(prev => {
//                 Object.values(prev).forEach(url => {
//                     if (url && url.startsWith('blob:')) URL.revokeObjectURL(url);
//                 });
//                 return {};
//             });
//         };
//     }, []);

//     const isLocked = dashboardStats?.status === 'PENDING_HR_REVIEW' || dashboardStats?.status === 'COMPLETED';

//     // Save Personal Info (with SSN & I-9 validation)
//     const handleSavePersonal = async (e) => {
//         e.preventDefault();
//         if (isLocked) return;
//         try {
//             await api.post('/onboarding/personal', personalForm);
//             setToast({ message: 'Personal Information saved successfully!', type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: err.response?.data?.error || 'Failed to save personal info.', type: 'error' });
//         }
//     };

//     const handleSaveI9Attestation = async () => {
//         if (isLocked) return;
//         try {
//             const citizenVal = `${i9Attestation}${uscisNumber ? ' (' + uscisNumber + ')' : ''}`;
//             await api.post('/onboarding/personal', {
//                 ...personalForm,
//                 citizenship: citizenVal
//             });
//             setToast({ message: 'Form I-9 Eligibility attestation recorded successfully!', type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: 'Failed to save Form I-9 attestation.', type: 'error' });
//         }
//     };

//     // Save Emergency Contacts
//     const handleSaveContacts = async (e) => {
//         e.preventDefault();
//         if (isLocked) return;
//         try {
//             await api.post('/onboarding/contacts', emergencyContacts);
//             setToast({ message: 'Emergency Contacts saved successfully!', type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: err.response?.data?.error || 'Failed to save emergency contacts.', type: 'error' });
//         }
//     };

//     const handleAddContact = () => {
//         if (isLocked) return;
//         setEmergencyContacts([...emergencyContacts, { name: '', relationship: '', phone: '', email: '', address: '' }]);
//     };

//     const handleRemoveContact = (index) => {
//         if (isLocked) return;
//         const updated = emergencyContacts.filter((_, idx) => idx !== index);
//         setEmergencyContacts(updated);
//     };

//     const handleContactChange = (index, field, value) => {
//         if (isLocked) return;
//         const updated = emergencyContacts.map((c, idx) => {
//             if (idx === index) return { ...c, [field]: value };
//             return c;
//         });
//         setEmergencyContacts(updated);
//     };

//     // Save Bank Info
//     const handleSaveBank = async (e) => {
//         if (e && e.preventDefault) e.preventDefault();
//         if (isLocked) return;
//         if (!bankForm.bank_name || !bankForm.routing_number || !bankForm.account_number || !bankForm.bank_branch_address) {
//             setToast({ message: 'Please fill in all required bank detail fields.', type: 'error' });
//             return;
//         }
//         const hasVoidCheque = data?.documents?.some(doc => doc.document_type === 'Void Cheque' && doc.file_path && doc.file_path !== 'NOT_AVAILABLE');
//         if (!hasVoidCheque) {
//             setToast({ message: 'Please upload Cancelled Cheque / Bank Account Proof.', type: 'error' });
//             return;
//         }
//         try {
//             await api.post('/onboarding/bank', bankForm);
//             setToast({ message: 'Bank Details saved successfully!', type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: err.response?.data?.error || 'Failed to save bank setup.', type: 'error' });
//         }
//     };

//     // PDF state variables
//     const [templateBytes, setTemplateBytes] = useState(null);
//     const [pdfPreviewUrl, setPdfPreviewUrl] = useState('');
//     const [pdfBase64, setPdfBase64] = useState('');

//     // Load Arizona A-4 template once when activeTab is 'tax'
//     useEffect(() => {
//         if (activeTab === 'tax' && !templateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const res = await api.get('/onboarding/tax-template', { responseType: 'arraybuffer' });
//                     setTemplateBytes(res.data);
//                 } catch (err) {
//                     console.error('Failed to load PDF template:', err);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [activeTab, templateBytes]);

//     const generatePdfPreview = useCallback(async (formValues) => {
//         if (!templateBytes) return;
//         try {
//             const pdfDoc = await PDFDocument.load(templateBytes);
//             const form = pdfDoc.getForm();
//             const pages = pdfDoc.getPages();
//             const firstPage = pages[0];

//             // Fill text fields
//             const setFieldText = (name, val) => {
//                 try {
//                     const field = form.getTextField(name);
//                     let textVal = val || '';
//                     try {
//                         const maxLen = field.getMaxLength();
//                         if (maxLen && textVal.length > maxLen) {
//                             textVal = textVal.substring(0, maxLen);
//                         }
//                     } catch (e) { }
//                     field.setText(textVal);
//                 } catch (e) {
//                     console.warn(`Could not set text field ${name}:`, e);
//                 }
//             };

//             setFieldText('Name', formValues.name);
//             setFieldText('SSN', formValues.ssn);
//             setFieldText('Address', formValues.address);
//             setFieldText('City', formValues.city);
//             setFieldText('State', formValues.state);
//             setFieldText('Zip', formValues.zip);

//             // Embed ZapfDingbats for drawing checkmark symbols
//             const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);
//             const drawTick = (x, y) => {
//                 try {
//                     firstPage.drawText('\u2714', {
//                         x: x + 1,
//                         y: y + 1,
//                         size: 9.5,
//                         font: dingbatsFont,
//                         color: rgb(0, 0, 0)
//                     });
//                 } catch (e) {
//                     console.error('Failed to draw checkmark:', e);
//                 }
//             };

//             // We explicitly uncheck all interactive fields so PDF viewers do not overlay a cross (X)
//             const clearCheckbox = (name) => {
//                 try {
//                     form.getCheckBox(name).uncheck();
//                 } catch (e) { }
//             };

//             ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'j', 'chkExtraWH'].forEach(clearCheckbox);

//             if (formValues.arizona_box_selection === 1) {
//                 drawTick(35.6678, 585.824); // a (Line 1 check)
//                 const rate = formValues.arizona_percentage;
//                 if (rate === 0.5) drawTick(64.4593, 573.772); // b
//                 else if (rate === 1.0) drawTick(136.469, 573.865); // c
//                 else if (rate === 1.5) drawTick(208.415, 573.865); // d
//                 else if (rate === 2.0) drawTick(280.506, 573.865); // e
//                 else if (rate === 2.5) drawTick(351.469, 573.865); // f
//                 else if (rate === 3.0) drawTick(423.415, 573.865); // g
//                 else if (rate === 3.5) drawTick(495.524, 573.865); // h
//             } else if (formValues.arizona_box_selection === 2) {
//                 drawTick(35.6678, 525.79); // j (Line 2 check)
//             }

//             if (formValues.arizona_extra_amount_checked) {
//                 drawTick(63.1453, 549.593); // chkExtraWH
//                 const amt = parseFloat(formValues.arizona_extra_amount) || 0.0;
//                 const dollarsStr = Math.floor(amt).toString();
//                 const centsVal = Math.round((amt % 1) * 100);
//                 const centsStr = centsVal < 10 ? '0' + centsVal : centsVal.toString();
//                 setFieldText('i', dollarsStr);
//                 setFieldText('i1', centsStr);
//             } else {
//                 setFieldText('i', '');
//                 setFieldText('i1', '');
//             }

//             if (formValues.signature) {
//                 let sigUrl = formValues.signature;
//                 if (!sigUrl.startsWith('data:image')) {
//                     sigUrl = convertTypedToPng(sigUrl);
//                 }

//                 try {
//                     const sigImage = await pdfDoc.embedPng(sigUrl);
//                     firstPage.drawImage(sigImage, {
//                         x: 40,
//                         y: 450,
//                         width: 180,
//                         height: 30
//                     });

//                     const dateFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//                     const dateStr = new Date().toLocaleDateString('en-US');
//                     firstPage.drawText(dateStr, {
//                         x: 435,
//                         y: 455,
//                         size: 10,
//                         font: dateFont,
//                         color: rgb(0, 0, 0)
//                     });
//                 } catch (sigErr) {
//                     console.error('Error embedding signature into PDF:', sigErr);
//                 }
//             }

//             const pdfBytes = await pdfDoc.save();
//             const binaryString = new Uint8Array(pdfBytes).reduce(
//                 (data, byte) => data + String.fromCharCode(byte),
//                 ''
//             );
//             const base64Str = btoa(binaryString);
//             setPdfBase64(base64Str);
//             const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//             const newUrl = URL.createObjectURL(blob);

//             setPdfPreviewUrl(prevUrl => {
//                 if (prevUrl) URL.revokeObjectURL(prevUrl);
//                 return newUrl;
//             });
//         } catch (err) {
//             console.error('Error generating PDF preview:', err);
//         }
//     }, [templateBytes]);

//     // Debounced PDF preview generation
//     useEffect(() => {
//         if (!templateBytes) return;
//         const timer = setTimeout(() => {
//             generatePdfPreview(taxForm);
//         }, 250);
//         return () => clearTimeout(timer);
//     }, [taxForm, templateBytes, generatePdfPreview]);

//     // Revoke Blob URL on unmount
//     useEffect(() => {
//         return () => {
//             setPdfPreviewUrl(prevUrl => {
//                 if (prevUrl) URL.revokeObjectURL(prevUrl);
//                 return '';
//             });
//         };
//     }, []);

//     // Load Employment Agreement 1 template once when activeTab is 'agreement' and selectedAgreementKey is 'employment_agreement'
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'employment_agreement' && !agreementTemplateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const response = await fetch('/Employment Agreement 1.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     setAgreementTemplateBytes(new Uint8Array(arrayBuffer));
//                 } catch (e) {
//                     console.error("Failed to load agreement template:", e);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [activeTab, selectedAgreementKey, agreementTemplateBytes]);

//     // Load India Employment Agreement template once when needed
//     useEffect(() => {
//         if (!indiaAgreementTemplateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const response = await fetch('/3-Employment Agreement.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     setIndiaAgreementTemplateBytes(new Uint8Array(arrayBuffer));
//                 } catch (e) {
//                     console.error("Failed to load India agreement template:", e);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [indiaAgreementTemplateBytes]);

//     // Debounced PDF preview generation for India Employment Agreement
//     useEffect(() => {
//         if (selectedAgreementKey === 'employee_agreement' && indiaAgreementTemplateBytes && data?.employee) {
//             if (data?.signature_history?.some(h => h.document_type === 'Employee Agreement' && h.action === 'SIGN')) {
//                 return;
//             }
//             const timer = setTimeout(async () => {
//                 try {
//                     const emp = data.employee;
//                     const fullName = `${emp.FirstName || ''} ${emp.LastName || ''}`.trim() || 'Employee';
//                     // Convert template bytes to binary base64
//                     let binary = '';
//                     const len = indiaAgreementTemplateBytes.byteLength;
//                     for (let i = 0; i < len; i++) {
//                         binary += String.fromCharCode(indiaAgreementTemplateBytes[i]);
//                     }
//                     const templateBase64 = btoa(binary);

//                     // Generate pre-sign PDF with Name, Date, and dynamic joining date on Page 1
//                     const joiningDateStr = emp.joining_date || emp.JoiningDate || emp.joining_Date || emp.joiningDate || emp.joining || emp.hire_date || emp.HireDate || employmentForm.hireDate;
//                     const base64 = await applySignatureToPdf(
//                         templateBase64,
//                         null, // no signature yet
//                         fullName,
//                         'Employee Agreement',
//                         true,
//                         {
//                             joiningDate: joiningDateStr,
//                             date: formatDateMMDDYYYY()
//                         }
//                     );
//                     const pdfBytes = base64ToUint8Array(base64);
//                     const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//                     const newUrl = URL.createObjectURL(blob);

//                     setAgreementBlobUrls(prev => {
//                         const oldUrl = prev['employee_agreement'];
//                         if (oldUrl && oldUrl.startsWith('blob:')) {
//                             URL.revokeObjectURL(oldUrl);
//                         }
//                         return {
//                             ...prev,
//                             'employee_agreement': newUrl
//                         };
//                     });
//                 } catch (err) {
//                     console.error("Failed to generate India agreement preview:", err);
//                 }
//             }, 250);
//             return () => clearTimeout(timer);
//         }
//     }, [indiaAgreementTemplateBytes, selectedAgreementKey, data, employmentForm.hireDate]);

//     // Debounced PDF preview generation for Employment Agreement 1
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'employment_agreement' && agreementTemplateBytes) {
//             if (data?.signature_history?.some(h => (h.document_type === 'Employment Agreement 1' || h.document_type === 'Employment Agreement') && h.action === 'SIGN')) {
//                 return;
//             }
//             const timer = setTimeout(async () => {
//                 const base64 = await generateAgreementPdfData(agreementTemplateBytes, employmentForm, null);
//                 const pdfBytes = base64ToUint8Array(base64);
//                 const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//                 const newUrl = URL.createObjectURL(blob);

//                 setAgreementBlobUrls(prev => {
//                     const oldUrl = prev['employment_agreement'];
//                     if (oldUrl && oldUrl.startsWith('blob:')) {
//                         URL.revokeObjectURL(oldUrl);
//                     }
//                     return {
//                         ...prev,
//                         'employment_agreement': newUrl
//                     };
//                 });
//             }, 250);
//             return () => clearTimeout(timer);
//         }
//     }, [employmentForm, agreementTemplateBytes, activeTab, selectedAgreementKey, data]);

//     // Load NDA template once when activeTab is 'agreement' and selectedAgreementKey is 'confidentiality_nda'
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'confidentiality_nda' && !ndaTemplateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const response = await fetch('/Employee Confidentiality & NDA (1).pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     setNdaTemplateBytes(new Uint8Array(arrayBuffer));
//                 } catch (e) {
//                     console.error("Failed to load NDA template:", e);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [activeTab, selectedAgreementKey, ndaTemplateBytes]);

//     // Debounced PDF preview generation for Confidentiality & NDA
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'confidentiality_nda' && ndaTemplateBytes) {
//             if (data?.signature_history?.some(h => (h.document_type === 'Employee Confidentiality & NDA (1)' || h.document_type === 'Employee Confidentiality & NDA') && h.action === 'SIGN')) {
//                 return;
//             }
//             const timer = setTimeout(async () => {
//                 const base64 = await generateNdaPdfData(ndaTemplateBytes, employmentForm, null);
//                 const pdfBytes = base64ToUint8Array(base64);
//                 const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//                 const newUrl = URL.createObjectURL(blob);

//                 setAgreementBlobUrls(prev => {
//                     const oldUrl = prev['confidentiality_nda'];
//                     if (oldUrl && oldUrl.startsWith('blob:')) {
//                         URL.revokeObjectURL(oldUrl);
//                     }
//                     return {
//                         ...prev,
//                         'confidentiality_nda': newUrl
//                     };
//                 });
//             }, 250);
//             return () => clearTimeout(timer);
//         }
//     }, [employmentForm, ndaTemplateBytes, activeTab, selectedAgreementKey, data]);

//     // Load Conflict of Interest template once when activeTab is 'agreement' and selectedAgreementKey is 'conflict_of_interest'
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'conflict_of_interest' && !conflictTemplateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const response = await fetch('/Conflict of interest agreement.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     setConflictTemplateBytes(new Uint8Array(arrayBuffer));
//                 } catch (e) {
//                     console.error("Failed to load Conflict of Interest template:", e);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [activeTab, selectedAgreementKey, conflictTemplateBytes]);

//     // Debounced PDF preview generation for Conflict of Interest
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'conflict_of_interest' && conflictTemplateBytes) {
//             if (data?.signature_history?.some(h => h.document_type === 'Conflict of interest agreement' && h.action === 'SIGN')) {
//                 return;
//             }
//             const timer = setTimeout(async () => {
//                 const base64 = await generateConflictPdfData(conflictTemplateBytes, employmentForm, null);
//                 const pdfBytes = base64ToUint8Array(base64);
//                 const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//                 const newUrl = URL.createObjectURL(blob);

//                 setAgreementBlobUrls(prev => {
//                     const oldUrl = prev['conflict_of_interest'];
//                     if (oldUrl && oldUrl.startsWith('blob:')) {
//                         URL.revokeObjectURL(oldUrl);
//                     }
//                     return {
//                         ...prev,
//                         'conflict_of_interest': newUrl
//                     };
//                 });
//             }, 250);
//             return () => clearTimeout(timer);
//         }
//     }, [employmentForm, conflictTemplateBytes, activeTab, selectedAgreementKey, data]);

//     // Load Benefits Enrollment template once when activeTab is 'agreement' and selectedAgreementKey is '401k_dental_vision_medical'
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === '401k_dental_vision_medical' && !benefitsTemplateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const response = await fetch('/401K Dental Vision Medical.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     setBenefitsTemplateBytes(new Uint8Array(arrayBuffer));
//                 } catch (e) {
//                     console.error("Failed to load Benefits template:", e);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [activeTab, selectedAgreementKey, benefitsTemplateBytes]);

//     // Debounced PDF preview generation for Benefits Enrollment
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === '401k_dental_vision_medical' && benefitsTemplateBytes) {
//             if (data?.signature_history?.some(h => h.document_type === '401K Dental Vision Medical' && h.action === 'SIGN')) {
//                 return;
//             }
//             const timer = setTimeout(async () => {
//                 const base64 = await generateBenefitsPdfData(benefitsTemplateBytes, employmentForm, null);
//                 const pdfBytes = base64ToUint8Array(base64);
//                 const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//                 const newUrl = URL.createObjectURL(blob);

//                 setAgreementBlobUrls(prev => {
//                     const oldUrl = prev['401k_dental_vision_medical'];
//                     if (oldUrl && oldUrl.startsWith('blob:')) {
//                         URL.revokeObjectURL(oldUrl);
//                     }
//                     return {
//                         ...prev,
//                         '401k_dental_vision_medical': newUrl
//                     };
//                 });
//             }, 250);
//             return () => clearTimeout(timer);
//         }
//     }, [employmentForm, benefitsTemplateBytes, activeTab, selectedAgreementKey, data]);

//     // Load Non Solicitation template once when activeTab is 'agreement' and selectedAgreementKey is 'non_solicitation'
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'non_solicitation' && !nonSolicitationTemplateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const response = await fetch('/Non Solicitation.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     setNonSolicitationTemplateBytes(new Uint8Array(arrayBuffer));
//                 } catch (e) {
//                     console.error("Failed to load Non Solicitation template:", e);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [activeTab, selectedAgreementKey, nonSolicitationTemplateBytes]);

//     // Debounced PDF preview generation for Non Solicitation
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'non_solicitation' && nonSolicitationTemplateBytes) {
//             if (data?.signature_history?.some(h => h.document_type === 'Non Solicitation' && h.action === 'SIGN')) {
//                 return;
//             }
//             const timer = setTimeout(async () => {
//                 const base64 = await generateNonSolicitationPdfData(nonSolicitationTemplateBytes, employmentForm, null);
//                 const pdfBytes = base64ToUint8Array(base64);
//                 const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//                 const newUrl = URL.createObjectURL(blob);

//                 setAgreementBlobUrls(prev => {
//                     const oldUrl = prev['non_solicitation'];
//                     if (oldUrl && oldUrl.startsWith('blob:')) {
//                         URL.revokeObjectURL(oldUrl);
//                     }
//                     return {
//                         ...prev,
//                         'non_solicitation': newUrl
//                     };
//                 });
//             }, 250);
//             return () => clearTimeout(timer);
//         }
//     }, [employmentForm, nonSolicitationTemplateBytes, activeTab, selectedAgreementKey, data]);

//     const handleApplySignature = (sigValue, sigType) => {
//         setTaxForm(prev => ({ ...prev, signature: sigValue }));
//         if (sigValue) {
//             setToast({ message: 'Signature applied to PDF preview!', type: 'success' });
//         }
//     };

//     const handleSaveTaxSubmit = async () => {
//         if (isLocked) return;
//         if (!taxForm.signature) {
//             setToast({ message: 'Please sign the form first.', type: 'error' });
//             return;
//         }
//         try {
//             await api.post('/onboarding/tax', {
//                 federal_tax_status: taxForm.federal_tax_status,
//                 federal_allowances: taxForm.federal_allowances,
//                 state_tax_status: taxForm.state_tax_status,
//                 state_allowances: taxForm.state_allowances,
//                 signature: taxForm.signature,
//                 arizona_box_selection: taxForm.arizona_box_selection,
//                 arizona_percentage: taxForm.arizona_percentage,
//                 arizona_extra_amount_checked: taxForm.arizona_extra_amount_checked ? 1 : 0,
//                 arizona_extra_amount: taxForm.arizona_extra_amount || 0.00,
//                 signed_pdf: pdfBase64
//             });
//             setToast({ message: 'Tax elections signed and saved successfully!', type: 'success' });
//             fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: err.response?.data?.error || 'Failed to save tax elections.', type: 'error' });
//         }
//     };

//     const downloadPdf = () => {
//         if (!pdfPreviewUrl) return;
//         const link = document.createElement('a');
//         link.href = pdfPreviewUrl;
//         link.download = `Arizona_Form_A4_${(taxForm.name || 'Employee').replace(/\s+/g, '_')}.pdf`;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     // Accept Corporate Policy
//     const handlePolicyAccept = async (sigData) => {
//         if (isLocked) return;
//         try {
//             setLoading(true);
//             let signaturePng = sigData;
//             if (sigData && !sigData.startsWith('data:image')) {
//                 signaturePng = convertTypedToPng(sigData);
//             }

//             const fullName = `${employee?.FirstName || ''} ${employee?.LastName || ''}`.trim() || 'Employee';
//             const signedPdfBase64 = await createPoliciesPdf(fullName, signaturePng);

//             await api.post('/onboarding/policies', {
//                 signature: sigData,
//                 signed_pdf: signedPdfBase64
//             });
//             setToast({ message: 'All company policies accepted successfully and PDF generated!', type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: err.response?.data?.error || 'Failed to record policies signature.', type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Sign Hiring Hub Document (Offer Letter / Employee Agreement)
//     const handleDocumentSign = async (docType, sigData) => {
//         if (isLocked) return;
//         try {
//             setLoading(true);
//             // 1. Process signature image: if it is a typed signature, convert it to a canvas image URL
//             let signaturePng = sigData;
//             if (sigData && !sigData.startsWith('data:image')) {
//                 signaturePng = convertTypedToPng(sigData);
//             }

//             // 2. Resolve original PDF base64
//             let originalBase64 = '';
//             if (docType === 'Offer Letter') {
//                 originalBase64 = employee?.offer_letter_base64 || data?.employee?.offer_letter_base64;
//                 if (!originalBase64) {
//                     const rawPath = employee?.offer_letter || employee?.offer_letter_path || data?.employee?.offer_letter || data?.employee?.offer_letter_path;
//                     let targetUrl = '';
//                     if (rawPath) {
//                         let cleanPath = rawPath.replace(/^\//, '');
//                         if (!cleanPath.startsWith('http://') && !cleanPath.startsWith('https://')) {
//                             cleanPath = cleanPath.startsWith('offer_letters/')
//                                 ? `https://hiring.gtelinq.com/hiring-backend/${cleanPath}`
//                                 : `/EOP_api/${cleanPath}`;
//                         }
//                         targetUrl = cleanPath;
//                     }
//                     if (targetUrl) {
//                         try {
//                             originalBase64 = await fetchLocalPdfAsBase64(targetUrl);
//                         } catch (e) {
//                             console.error("Failed to fetch offer letter URL as base64:", e);
//                         }
//                     }
//                     if (!originalBase64 && offerLetterBlobUrl) {
//                         try {
//                             originalBase64 = await fetchLocalPdfAsBase64(offerLetterBlobUrl);
//                         } catch (e) {
//                             console.error("Failed to fetch offerLetterBlobUrl as base64:", e);
//                         }
//                     }
//                 }
//             } else {
//                 try {
//                     const country = employee?.country || '';
//                     const isUsa = country.toUpperCase() === 'USA';
//                     let templatePath = '';
//                     if (isUsa) {
//                         const list = [
//                             { title: 'Employment Agreement 1', displayName: 'Employment Agreement', path: '/Employment Agreement 1.pdf' },
//                             { title: 'Employee Confidentiality & NDA (1)', displayName: 'Employee Confidentiality & NDA', path: '/Employee Confidentiality & NDA (1).pdf' },
//                             { title: 'Conflict of interest agreement', path: '/Conflict of interest agreement.pdf' },
//                             { title: '401K Dental Vision Medical', path: '/401K Dental Vision Medical.pdf' },
//                             { title: 'Non Solicitation', path: '/Non Solicitation.pdf' }
//                         ];
//                         const found = list.find(item => item.title === docType);
//                         templatePath = found ? found.path : '/employee_agreement_usa.pdf';
//                     } else {
//                         templatePath = '/3-Employment Agreement.pdf';
//                     }
//                     originalBase64 = await fetchLocalPdfAsBase64(templatePath);
//                 } catch (fetchErr) {
//                     console.error("Failed to fetch local agreement PDF template:", fetchErr);
//                     originalBase64 = employee.employee_agreement_base64;
//                 }
//             }

//             // 3. Draw signature on the PDF
//             let signedPdfBase64 = '';
//             if (docType === 'Employment Agreement 1' || docType === 'Employment Agreement') {
//                 let templateBytes = agreementTemplateBytes;
//                 if (!templateBytes) {
//                     const response = await fetch('/Employment Agreement 1.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     templateBytes = new Uint8Array(arrayBuffer);
//                 }
//                 signedPdfBase64 = await generateAgreementPdfData(templateBytes, employmentForm, signaturePng);
//             } else if (docType === 'Employee Confidentiality & NDA (1)' || docType === 'Employee Confidentiality & NDA') {
//                 let templateBytes = ndaTemplateBytes;
//                 if (!templateBytes) {
//                     const response = await fetch('/Employee Confidentiality & NDA (1).pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     templateBytes = new Uint8Array(arrayBuffer);
//                 }
//                 signedPdfBase64 = await generateNdaPdfData(templateBytes, employmentForm, signaturePng);
//             } else if (docType === 'Conflict of interest agreement') {
//                 let templateBytes = conflictTemplateBytes;
//                 if (!templateBytes) {
//                     const response = await fetch('/Conflict of interest agreement.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     templateBytes = new Uint8Array(arrayBuffer);
//                 }
//                 signedPdfBase64 = await generateConflictPdfData(templateBytes, employmentForm, signaturePng);
//             } else if (docType === '401K Dental Vision Medical') {
//                 let templateBytes = benefitsTemplateBytes;
//                 if (!templateBytes) {
//                     const response = await fetch('/401K Dental Vision Medical.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     templateBytes = new Uint8Array(arrayBuffer);
//                 }
//                 signedPdfBase64 = await generateBenefitsPdfData(templateBytes, employmentForm, signaturePng);
//             } else if (docType === 'Non Solicitation') {
//                 let templateBytes = nonSolicitationTemplateBytes;
//                 if (!templateBytes) {
//                     const response = await fetch('/Non Solicitation.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     templateBytes = new Uint8Array(arrayBuffer);
//                 }
//                 signedPdfBase64 = await generateNonSolicitationPdfData(templateBytes, employmentForm, signaturePng);
//             } else {
//                 const fName = personalForm.first_name || data?.profile?.first_name || employee?.FirstName || employee?.first_name || '';
//                 const mName = personalForm.middle_name || data?.profile?.middle_name || employee?.MiddleName || employee?.middle_name || '';
//                 const lName = personalForm.last_name || data?.profile?.last_name || employee?.LastName || employee?.last_name || '';
//                 const fullName = [fName, mName, lName].filter(Boolean).join(' ').trim() || 'Employee';
//                 const aadhaarNumber = personalForm.ssn || data?.profile?.ssn || employee?.ssn || employee?.AadhaarNumber || employee?.aadhaar_number || '';
//                 const formattedDate = formatDateMMDDYYYY(new Date());

//                 const isIndiaCandidate = ((employee?.country || data?.employee?.country || personalForm?.country || '').toUpperCase()) === 'INDIA';
//                 const joiningDateStr = employee?.joining_date || employee?.JoiningDate || data?.employee?.joining_date || data?.employee?.JoiningDate || employmentForm?.hireDate || personalForm?.hireDate;
//                 signedPdfBase64 = await applySignatureToPdf(originalBase64, signaturePng, fullName, docType, isIndiaCandidate, {
//                     fullName,
//                     aadhaarNumber,
//                     date: formattedDate,
//                     joiningDate: joiningDateStr
//                 });
//             }

//             // 4. Send to backend
//             await api.post('/onboarding/agreements', {
//                 document_type: docType,
//                 signature: sigData,
//                 signed_pdf: signedPdfBase64
//             });

//             // Auto-upload signed offer letter to employee_documents table for checklist storage
//             if (docType === 'Offer Letter' && signedPdfBase64) {
//                 try {
//                     await api.post('/onboarding/upload', {
//                         document_type: 'Signed Offer Letter',
//                         file: signedPdfBase64.startsWith('data:') ? signedPdfBase64 : `data:application/pdf;base64,${signedPdfBase64}`
//                     });
//                 } catch (uploadErr) {
//                     console.warn("Auto upload of Signed Offer Letter to documents table failed:", uploadErr);
//                 }

//                 // Set live blob URL preview of signed offer letter
//                 const signedUrl = base64ToBlobUrl(signedPdfBase64);
//                 setOfferLetterBlobUrl(prev => {
//                     if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//                     return signedUrl;
//                 });
//             }

//             setToast({ message: `${docType} signed successfully!`, type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             await fetchOnboardingData();
//         } catch (err) {
//             console.error(err);
//             setToast({ message: err.response?.data?.error || err.message || 'Failed to apply document signature.', type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Save Photo Badge headshot
//     const handlePhotoUpload = (e) => {
//         if (isLocked) return;
//         const file = e.target.files[0];
//         if (file) {
//             if (file.size > 5 * 1024 * 1024) {
//                 setToast({ message: 'This file is not accepted. File size exceeds maximum limit of 5MB.', type: 'error' });
//                 e.target.value = '';
//                 return;
//             }
//             if (!file.type.match(/^image\/(jpeg|png|jpg|webp)$/i)) {
//                 setToast({ message: 'This file is not accepted. Only image files (JPG, PNG, WEBP) are allowed.', type: 'error' });
//                 e.target.value = '';
//                 return;
//             }

//             setUploadingPhoto(true);
//             const reader = new FileReader();
//             reader.onload = async (event) => {
//                 try {
//                     await api.post('/onboarding/photo', { photo: event.target.result });
//                     setToast({ message: 'Profile badge photo uploaded successfully!', type: 'success' });
//                     window.dispatchEvent(new Event('onboarding_updated'));
//                     await fetchOnboardingData();
//                 } catch (err) {
//                     setToast({ message: err.response?.data?.error || 'Failed to upload photo.', type: 'error' });
//                 } finally {
//                     setUploadingPhoto(false);
//                     e.target.value = '';
//                 }
//             };
//             reader.readAsDataURL(file);
//         }
//     };

//     // Delete Photo Badge headshot
//     const handleDeletePhoto = async () => {
//         if (isLocked) return;
//         if (!window.confirm('Are you sure you want to delete your badge profile photo?')) return;
//         try {
//             setUploadingPhoto(true);
//             await api.delete('/onboarding/photo');
//             setToast({ message: 'Profile photo deleted successfully!', type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             await fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: err.response?.data?.error || 'Failed to delete photo.', type: 'error' });
//         } finally {
//             setUploadingPhoto(false);
//         }
//     };

//     // Submit Onboarding
//     const handleSubmitOnboarding = async () => {
//         const requestedDocsList = data?.requested_documents || data?.requested_employee_documents || [];
//         const pendingOrUploadedReqs = requestedDocsList.filter(r => {
//             const s = (r.status || '').toUpperCase();
//             return s !== 'SUBMITTED' && s !== 'COMPLETED' && s !== 'APPROVED';
//         });
//         if (isLocked && pendingOrUploadedReqs.length === 0) return;
//         setSubmitStatus('submitting');
//         setSubmitErrorMessage('');
//         try {
//             // Artificial delay to allow user to see the loading progress
//             await new Promise((resolve) => setTimeout(resolve, 1800));
//             await api.post('/onboarding/submit');
//             setSubmitStatus('success');
//             setRequestedDocsSubmitted(true);
//             fetchOnboardingData();
//         } catch (err) {
//             setSubmitStatus('error');
//             setSubmitErrorMessage(err.response?.data?.error || 'Failed to submit onboarding.');
//         }
//     };

//     // Helper to open PDF in a new tab natively using Blob URL
//     const handleViewPdf = (base64Data, fileName = 'document.pdf') => {
//         try {
//             if (!base64Data) {
//                 setToast({ message: 'No PDF data available.', type: 'error' });
//                 return;
//             }
//             if (base64Data.startsWith('/') || base64Data.startsWith('blob:') || base64Data.startsWith('http')) {
//                 const newWindow = window.open();
//                 if (newWindow) {
//                     newWindow.document.title = fileName;
//                     newWindow.location.href = base64Data;
//                 } else {
//                     // Fallback: download if blocked
//                     const a = document.createElement('a');
//                     a.href = base64Data;
//                     a.download = fileName;
//                     document.body.appendChild(a);
//                     a.click();
//                     document.body.removeChild(a);
//                 }
//                 return;
//             }
//             const arr = base64ToUint8Array(base64Data);
//             if (arr.length === 0) {
//                 setToast({ message: 'Failed to decode PDF data.', type: 'error' });
//                 return;
//             }
//             const blob = new Blob([arr], { type: 'application/pdf' });
//             const url = URL.createObjectURL(blob);

//             const newWindow = window.open();
//             if (newWindow) {
//                 newWindow.document.title = fileName;
//                 newWindow.location.href = url;
//             } else {
//                 // Fallback: download if blocked
//                 const a = document.createElement('a');
//                 a.href = url;
//                 a.download = fileName;
//                 document.body.appendChild(a);
//                 a.click();
//                 document.body.removeChild(a);
//             }
//         } catch (err) {
//             setToast({ message: 'Failed to load PDF. Please try downloading it.', type: 'error' });
//         }
//     };

//     const handleDownloadPdf = (base64Data, fileName = 'document.pdf') => {
//         try {
//             if (!base64Data) {
//                 setToast({ message: 'No PDF data available.', type: 'error' });
//                 return;
//             }
//             if (base64Data.startsWith('/') || base64Data.startsWith('blob:') || base64Data.startsWith('http')) {
//                 const a = document.createElement('a');
//                 a.href = base64Data;
//                 a.download = fileName;
//                 document.body.appendChild(a);
//                 a.click();
//                 document.body.removeChild(a);
//                 return;
//             }
//             const arr = base64ToUint8Array(base64Data);
//             if (arr.length === 0) {
//                 setToast({ message: 'Failed to decode PDF data.', type: 'error' });
//                 return;
//             }
//             const blob = new Blob([arr], { type: 'application/pdf' });
//             const url = URL.createObjectURL(blob);
//             const a = document.createElement('a');
//             a.href = url;
//             a.download = fileName;
//             document.body.appendChild(a);
//             a.click();
//             document.body.removeChild(a);
//             URL.revokeObjectURL(url);
//         } catch (err) {
//             setToast({ message: 'Failed to download PDF.', type: 'error' });
//         }
//     };

//     const handleDownloadPolicies = async () => {
//         try {
//             setLoading(true);
//             const fullName = `${employee?.FirstName || ''} ${employee?.LastName || ''}`.trim() || 'Employee';
//             let signatureDataUrl = employee?.policy_signature || '';

//             if (signatureDataUrl.startsWith('typed:')) {
//                 const typedName = signatureDataUrl.replace('typed:', '');
//                 signatureDataUrl = convertTypedToPng(typedName);
//             }

//             const newPdfBase64 = await createPoliciesPdf(fullName, signatureDataUrl);
//             handleDownloadPdf(newPdfBase64, `company_policies_${(employee?.FirstName || 'employee').toLowerCase()}_${(employee?.LastName || 'signed').toLowerCase()}_signed.pdf`);
//         } catch (err) {
//             console.error(err);
//             setToast({ message: 'Failed to generate policies PDF for download.', type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     if (loading) {
//         return <Loader message="Loading onboarding workspace..." />;
//     }

//     const employee = data?.employee || {};
//     const profile = data?.profile || {};

//     // Find if a Passport Size Photo document was uploaded in India documents section
//     const passportSizePhotoDoc = (data?.documents || []).find(
//         doc => doc.document_type === 'Passport Size Photo'
//     );
//     const rawProfilePhotoPath = profile?.profile_photo_path;

//     // Ensure Passport Size Photo document is separate from Badge Profile Photo
//     const isPassportDocMatch = (
//         (passportSizePhotoDoc?.file_path && rawProfilePhotoPath === passportSizePhotoDoc.file_path) ||
//         (rawProfilePhotoPath && (data?.documents || []).some(doc => doc.document_type === 'Passport Size Photo' && doc.file_path === rawProfilePhotoPath))
//     );

//     const badgePhotoPath = (rawProfilePhotoPath && !isPassportDocMatch) ? rawProfilePhotoPath : null;

//     const effectiveChecklist = dashboardStats?.checklist ? {
//         ...dashboardStats.checklist,
//         profile_photo: !!badgePhotoPath
//     } : {};

//     const effectiveCompletedSteps = Object.values(effectiveChecklist).filter(Boolean).length;

//     const effectiveDashboardStats = dashboardStats ? {
//         ...dashboardStats,
//         checklist: effectiveChecklist,
//         completed_steps: effectiveCompletedSteps
//     } : null;

//     return (
//         <div style={{ animation: 'fadeIn var(--transition-normal) forwards' }}>
//             {uploadingPhoto && <Loader fullScreen message="Uploading profile badge photo..." />}

//             {/* Lock banner warning */}
//             {isLocked && (
//                 <div
//                     style={{
//                         backgroundColor: 'var(--info-light)',
//                         borderLeft: '4px solid var(--info)',
//                         padding: '1rem',
//                         borderRadius: '4px',
//                         marginBottom: '1.5rem',
//                         fontSize: '0.875rem',
//                         color: 'var(--text-primary)',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '0.5rem'
//                     }}
//                 >
//                     <span>ℹ️</span>
//                     <div>
//                         You have submitted your onboarding details successfully.
//                     </div>
//                 </div>
//             )}

//             {/* DASHBOARD TAB */}
//             {activeTab === 'dashboard' && (() => {
//                 const completedSteps = effectiveDashboardStats?.completed_steps || 0;
//                 const totalSteps = effectiveDashboardStats?.total_steps || 8;
//                 const onboardingPercent = Math.round((completedSteps / totalSteps) * 100);

//                 const radius = 60;
//                 const stroke = 7;
//                 const normRadius = radius - stroke * 2;
//                 const circ = normRadius * 2 * Math.PI;
//                 const offset = circ - (onboardingPercent / 100) * circ;

//                 return (
//                     <div className="fade-in" style={{ display: 'flex', flexDirection: 'column', gap: '2.5rem' }}>

//                         {/* Split Top section: Greeting + Radial Indicator */}
//                         <div className="dashboard-top-grid">

//                             {/* Left Column: Greeting & Status */}
//                             <div
//                                 style={{
//                                     background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.07) 0%, rgba(244, 63, 94, 0.04) 100%)',
//                                     border: '1px solid var(--border-color)',
//                                     borderRadius: 'var(--border-radius-lg)',
//                                     padding: '2.5rem 2rem',
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     justifyContent: 'center',
//                                     boxShadow: 'var(--shadow-md)'
//                                 }}
//                             >
//                                 <div
//                                     style={{
//                                         display: 'inline-flex',
//                                         padding: '0.25rem 0.75rem',
//                                         backgroundColor: 'var(--primary-light)',
//                                         color: 'var(--primary)',
//                                         fontSize: '0.75rem',
//                                         fontWeight: 700,
//                                         borderRadius: '50px',
//                                         textTransform: 'uppercase',
//                                         marginBottom: '1rem',
//                                         alignSelf: 'flex-start',
//                                         letterSpacing: '0.05em'
//                                     }}
//                                 >
//                                     Onboarding Phase
//                                 </div>

//                                 <h2 style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--text-primary)', marginBottom: '0.5rem', letterSpacing: '-0.02em' }}>
//                                     Welcome, {employee.FirstName || 'Team Member'}!
//                                 </h2>
//                                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '1rem' }}>
//                                     We are thrilled to welcome you to the Genesis Tech Engineers family. All accounts have been securely synchronized. Complete your documentation pipeline below.
//                                 </p>
//                                 <div style={{ marginBottom: '1.5rem' }}>
//                                     <button
//                                         type="button"
//                                         onClick={onStartVideoTour}
//                                         className="btn btn-secondary"
//                                         style={{ padding: '0.45rem 1rem', fontSize: '0.75rem', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
//                                     >
//                                         🎥 Watch Onboarding Video Tour
//                                     </button>
//                                 </div>

//                                 {/* Progress bar line */}
//                                 <div style={{ width: '100%' }}>
//                                     <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>
//                                         <span>Onboarding Progress</span>
//                                         <span>{onboardingPercent}% Complete</span>
//                                     </div>
//                                     <div style={{ width: '100%', height: '8px', backgroundColor: 'var(--bg-tertiary)', borderRadius: '50px', overflow: 'hidden' }}>
//                                         <div
//                                             style={{
//                                                 width: `${onboardingPercent}%`,
//                                                 height: '100%',
//                                                 background: 'linear-gradient(90deg, var(--primary) 0%, var(--accent) 100%)',
//                                                 borderRadius: '50px',
//                                                 transition: 'width 0.4s ease-out'
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Right Column: Visual Radial Meter */}
//                             <div
//                                 className="glass-card"
//                                 style={{
//                                     padding: '2rem',
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     textAlign: 'center'
//                                 }}
//                             >
//                                 <div style={{ position: 'relative', width: radius * 2, height: radius * 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                                     {/* SVG Circle meter */}
//                                     <svg height={radius * 2} width={radius * 2} style={{ transform: 'rotate(-90deg)', position: 'absolute', top: 0, left: 0 }}>
//                                         <circle
//                                             stroke="var(--bg-tertiary)"
//                                             fill="transparent"
//                                             strokeWidth={stroke}
//                                             r={normRadius}
//                                             cx={radius}
//                                             cy={radius}
//                                         />
//                                         <circle
//                                             stroke="url(#progressGrad)"
//                                             fill="transparent"
//                                             strokeWidth={stroke}
//                                             strokeDasharray={circ + ' ' + circ}
//                                             style={{ strokeDashoffset: offset, transition: 'stroke-dashoffset 0.6s ease' }}
//                                             r={normRadius}
//                                             cx={radius}
//                                             cy={radius}
//                                             strokeLinecap="round"
//                                         />
//                                         <defs>
//                                             <linearGradient id="progressGrad" x1="0%" y1="0%" x2="100%" y2="100%">
//                                                 <stop offset="0%" stopColor="#22d3ee" />
//                                                 <stop offset="50%" stopColor="#6366f1" />
//                                                 <stop offset="100%" stopColor="#ec4899" />
//                                             </linearGradient>
//                                         </defs>
//                                     </svg>

//                                     {/* Inside dial text */}
//                                     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 2 }}>
//                                         <span style={{ fontSize: '1.75rem', fontWeight: 800, color: 'var(--text-primary)', lineHeight: 1 }}>{completedSteps}</span>
//                                         <span style={{ fontSize: '0.7rem', color: 'var(--text-tertiary)', textTransform: 'uppercase', fontWeight: 700, marginTop: '0.15rem' }}>of {totalSteps} Tasks</span>
//                                     </div>
//                                 </div>

//                                 <div style={{ marginTop: '1.25rem' }}>
//                                     <div style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--text-primary)' }}>Completeness Ratio</div>
//                                     <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '0.15rem' }}>
//                                         {onboardingPercent === 100 ? 'Ready to submit onboarding profile!' : `${totalSteps - completedSteps} steps remaining`}
//                                     </div>
//                                 </div>
//                             </div>

//                         </div>

//                         {/* Visual Roadmap Path */}
//                         {(() => {
//                             const roadmapSteps = [
//                                 { key: 'personal_info', tab: 'personal', title: 'Profile', icon: '👤' },
//                                 { key: 'emergency_contacts', tab: 'contacts', title: 'Contacts', icon: '📞' },
//                                 { key: 'documents', tab: 'documents', title: 'ID Docs', icon: '📁' },
//                                 { key: 'offer', tab: 'offer', title: 'Offer Letter', icon: '✉️' },
//                                 { key: 'agreement', tab: 'agreement', title: 'Agreement', icon: '🖋️' },
//                                 { key: 'policies', tab: 'policies', title: 'Policies', icon: '🛡️' },
//                                 { key: 'bank_details', tab: 'bank', title: 'Bank', icon: '🏦' },
//                                 { key: 'profile_photo', tab: 'photo', title: 'Photo', icon: '📷' },
//                                 { key: 'submit', tab: 'submit', title: 'Submit', icon: '🚀' }
//                             ];

//                             const firstPendingStep = roadmapSteps.find(s => {
//                                 if (s.key === 'submit') {
//                                     return roadmapSteps.slice(0, 8).every(other => effectiveDashboardStats?.checklist?.[other.key]);
//                                 }
//                                 return !effectiveDashboardStats?.checklist?.[s.key];
//                             }) || roadmapSteps[8];

//                             return (
//                                 <div className="card fade-in" style={{ padding: '1.75rem 1.5rem', margin: 0, boxShadow: 'var(--shadow-sm)' }}>
//                                     <div className="roadmap-header">
//                                         <div>
//                                             <h3 style={{ fontSize: '1.1rem', fontWeight: 800, margin: 0, color: 'var(--text-primary)' }}>
//                                                 🗺️ Onboarding Guided Path Roadmap
//                                             </h3>
//                                             <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
//                                                 Your onboarding steps pipeline. Click any step circle to jump directly to its screen.
//                                             </p>
//                                         </div>
//                                         <div style={{ display: 'flex', gap: '0.5rem' }}>
//                                             <button
//                                                 type="button"
//                                                 onClick={onStartVideoTour}
//                                                 className="btn btn-secondary"
//                                                 style={{ padding: '0.4rem 0.8rem', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
//                                             >
//                                                 🎥 Play Video Tour
//                                             </button>
//                                             <button
//                                                 type="button"
//                                                 onClick={onStartTour}
//                                                 className="btn btn-secondary"
//                                                 style={{ padding: '0.4rem 0.8rem', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
//                                             >
//                                                 🗺️ Replay Guided Tour
//                                             </button>
//                                         </div>
//                                     </div>

//                                     <div className="roadmap-trail">
//                                         {roadmapSteps.map((step, idx) => {
//                                             const isComplete = step.key === 'submit'
//                                                 ? (effectiveDashboardStats?.status === 'PENDING_HR_REVIEW' || effectiveDashboardStats?.status === 'COMPLETED')
//                                                 : effectiveDashboardStats?.checklist?.[step.key];
//                                             const isActive = firstPendingStep.key === step.key;

//                                             return (
//                                                 <React.Fragment key={step.key}>
//                                                     <div
//                                                         className={`roadmap-step ${isActive ? 'active' : ''} ${isComplete ? 'complete' : ''}`}
//                                                         onClick={() => setActiveTab(step.tab)}
//                                                         title={step.title}
//                                                     >
//                                                         {isActive && (
//                                                             <span style={{
//                                                                 position: 'absolute',
//                                                                 top: '-22px',
//                                                                 fontSize: '0.85rem',
//                                                                 animation: 'bounceDown 1.2s infinite',
//                                                                 color: 'var(--primary)',
//                                                                 fontWeight: 800
//                                                             }}>
//                                                                 👇
//                                                             </span>
//                                                         )}
//                                                         <div className={`roadmap-step-circle ${isActive ? 'next-step-glowing' : ''}`}>
//                                                             {isComplete ? '✓' : step.icon}
//                                                         </div>
//                                                         <div className="roadmap-step-title">{step.title}</div>
//                                                     </div>

//                                                     {idx < roadmapSteps.length - 1 && (
//                                                         <div className="roadmap-arrow">➔</div>
//                                                     )}
//                                                 </React.Fragment>
//                                             );
//                                         })}
//                                     </div>
//                                 </div>
//                             );
//                         })()}

//                         {/* Middle section: Colorful Info Badges Grid */}
//                         <div className="dashboard-middle-grid">
//                             <div style={{ padding: '1.25rem', backgroundColor: 'rgba(59, 130, 246, 0.03)', border: '1px solid var(--border-color)', borderLeft: '4px solid #3b82f6', borderRadius: 'var(--border-radius-md)', display: 'flex', flexDirection: 'column', gap: '0.25rem', boxShadow: 'var(--shadow-sm)' }}>
//                                 <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#2563eb', fontWeight: 700, letterSpacing: '0.05em' }}>Designation Unit</span>
//                                 <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)' }}>{employee.Designation || 'N/A'}</span>
//                             </div>
//                             <div style={{ padding: '1.25rem', backgroundColor: 'rgba(168, 85, 247, 0.03)', border: '1px solid var(--border-color)', borderLeft: '4px solid #a855f7', borderRadius: 'var(--border-radius-md)', display: 'flex', flexDirection: 'column', gap: '0.25rem', boxShadow: 'var(--shadow-sm)' }}>
//                                 <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#9333ea', fontWeight: 700, letterSpacing: '0.05em' }}>Department Branch</span>
//                                 <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)' }}>{employee.Department || 'N/A'}</span>
//                             </div>
//                             <div style={{ padding: '1.25rem', backgroundColor: 'rgba(16, 185, 129, 0.03)', border: '1px solid var(--border-color)', borderLeft: '4px solid #10b981', borderRadius: 'var(--border-radius-md)', display: 'flex', flexDirection: 'column', gap: '0.25rem', boxShadow: 'var(--shadow-sm)' }}>
//                                 <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#059669', fontWeight: 700, letterSpacing: '0.05em' }}>Official Start Date</span>
//                                 <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)' }}>{employee.JoiningDate || 'N/A'}</span>
//                             </div>
//                         </div>

//                         {/* Launcher Grid */}
//                         <div className="card" style={{ padding: '2.5rem 2rem', margin: 0 }}>
//                             <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '0.5rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '0.75rem' }}>
//                                 🚀 Onboarding Launchpad Checklist
//                             </h3>
//                             <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '2rem' }}>
//                                 Each card below represents a required onboarding step. Click any card to load its details.
//                             </p>

//                             <div
//                                 style={{
//                                     display: 'grid',
//                                     gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
//                                     gap: '1.25rem'
//                                 }}
//                             >
//                                 {[
//                                     { key: 'personal_info', tab: 'personal', icon: '👤', title: 'Personal Profile', desc: ((data?.employee?.country || employee?.country || '').toUpperCase() === 'INDIA') ? 'Verify personal details, addresses, and Aadhaar.' : 'Verify personal details, addresses, and SSN.', color: 'rgba(59, 130, 246, 0.03)', hoverBorder: '#3b82f6', badgeBg: 'rgba(59, 130, 246, 0.12)', badgeText: '#2563eb' },
//                                     { key: 'emergency_contacts', tab: 'contacts', icon: '📞', title: 'Emergency Contacts', desc: 'Add primary and secondary contact details.', color: 'rgba(16, 185, 129, 0.03)', hoverBorder: '#10b981', badgeBg: 'rgba(16, 185, 129, 0.12)', badgeText: '#059669' },
//                                     { key: 'documents', tab: 'documents', icon: '📁', title: 'US Identification', desc: 'Upload standard identity documents.', color: 'rgba(99, 102, 241, 0.03)', hoverBorder: '#6366f1', badgeBg: 'rgba(99, 102, 241, 0.12)', badgeText: '#4f46e5' },
//                                     { key: 'offer', tab: 'offer', icon: '✉️', title: 'Offer Sheet Review', desc: 'Review terms and sign your hiring offer letter.', color: 'rgba(245, 158, 11, 0.03)', hoverBorder: '#f59e0b', badgeBg: 'rgba(245, 158, 11, 0.12)', badgeText: '#d97706' },
//                                     { key: 'agreement', tab: 'agreement', icon: '🖋️', title: 'Employee Agreement', desc: 'E-sign the corporate NDAs & contracts.', color: 'rgba(236, 72, 153, 0.03)', hoverBorder: '#ec4899', badgeBg: 'rgba(236, 72, 153, 0.12)', badgeText: '#db2777' },
//                                     { key: 'policies', tab: 'policies', icon: '🛡️', title: 'Company Policies', desc: 'Read and accept the 5 policy handbooks.', color: 'rgba(6, 182, 212, 0.03)', hoverBorder: '#06b6d4', badgeBg: 'rgba(6, 182, 212, 0.12)', badgeText: '#0891b2' },
//                                     { key: 'bank_details', tab: 'bank', icon: '🏦', title: 'Direct Deposit', desc: 'Setup payroll accounts and voided cheques.', color: 'rgba(168, 85, 247, 0.03)', hoverBorder: '#a855f7', badgeBg: 'rgba(168, 85, 247, 0.12)', badgeText: '#9333ea' },
//                                     { key: 'profile_photo', tab: 'photo', icon: '📷', title: 'Badge Headshot', desc: 'Upload and crop your official badge headshot.', color: 'rgba(239, 68, 68, 0.03)', hoverBorder: '#ef4444', badgeBg: 'rgba(239, 68, 68, 0.12)', badgeText: '#dc2626' }
//                                 ].map(step => {
//                                     const complete = effectiveDashboardStats?.checklist?.[step.key];
//                                     return (
//                                         <div
//                                             key={step.key}
//                                             onClick={() => setActiveTab(step.tab)}
//                                             style={{
//                                                 border: '1px solid var(--border-color)',
//                                                 borderRadius: 'var(--border-radius-md)',
//                                                 padding: '1.25rem',
//                                                 cursor: 'pointer',
//                                                 backgroundColor: step.color,
//                                                 transition: 'all var(--transition-normal)',
//                                                 display: 'flex',
//                                                 flexDirection: 'column',
//                                                 justifyContent: 'space-between',
//                                                 minHeight: '140px',
//                                                 boxShadow: 'var(--shadow-sm)',
//                                                 position: 'relative',
//                                                 overflow: 'hidden'
//                                             }}
//                                             onMouseEnter={(e) => {
//                                                 e.currentTarget.style.transform = 'translateY(-3px)';
//                                                 e.currentTarget.style.boxShadow = 'var(--shadow-md)';
//                                                 e.currentTarget.style.borderColor = step.hoverBorder;
//                                                 e.currentTarget.style.background = step.color.replace('0.03', '0.07');
//                                             }}
//                                             onMouseLeave={(e) => {
//                                                 e.currentTarget.style.transform = 'translateY(0)';
//                                                 e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
//                                                 e.currentTarget.style.borderColor = 'var(--border-color)';
//                                                 e.currentTarget.style.background = step.color;
//                                             }}
//                                         >
//                                             <div style={{ position: 'relative', zIndex: 2 }}>
//                                                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
//                                                     <span style={{ fontSize: '1.5rem' }}>{step.icon}</span>
//                                                     <span
//                                                         style={{
//                                                             fontSize: '0.7rem',
//                                                             fontWeight: '700',
//                                                             padding: '0.15rem 0.5rem',
//                                                             borderRadius: '50px',
//                                                             textTransform: 'uppercase',
//                                                             backgroundColor: complete ? 'var(--success-light)' : step.badgeBg,
//                                                             color: complete ? 'var(--success)' : step.badgeText
//                                                         }}
//                                                     >
//                                                         {complete ? '✓ Done' : 'Pending'}
//                                                     </span>
//                                                 </div>
//                                                 <h4 style={{ fontSize: '0.95rem', fontWeight: '700', marginBottom: '0.25rem', color: 'var(--text-primary)' }}>
//                                                     {step.title}
//                                                 </h4>
//                                                 <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', lineHeight: '1.3' }}>
//                                                     {step.desc}
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         </div>
//                     </div>
//                 );
//             })()}

//             {/* PERSONAL INFO TAB */}
//             {activeTab === 'personal' && (() => {
//                 const country = data?.employee?.country || personalForm.country || employee?.country || '';
//                 const isIndia = country.toUpperCase() === 'INDIA';
//                 return (
//                     <div className="card fade-in">
//                         <div className="card-title">Personal Information</div>
//                         <form onSubmit={handleSavePersonal}>
//                             <div className="grid-2">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="first-name">Given Name(first+middle)</label>
//                                     <input type="text" id="first-name" className="form-control" value={personalForm.first_name} onChange={(e) => setPersonalForm({ ...personalForm, first_name: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="last-name">Last Name</label>
//                                     <input type="text" id="last-name" className="form-control" value={personalForm.last_name} onChange={(e) => setPersonalForm({ ...personalForm, last_name: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                             </div>

//                             <div className="grid-3">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="pref-name">Preferred Name</label>
//                                     <input type="text" id="pref-name" className="form-control" value={personalForm.preferred_name} onChange={(e) => setPersonalForm({ ...personalForm, preferred_name: e.target.value })} disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="dob-input">Date of Birth</label>
//                                     <input type="date" id="dob-input" className="form-control" value={personalForm.dob} onChange={(e) => setPersonalForm({ ...personalForm, dob: e.target.value })} disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="gender-select">Gender</label>
//                                     <select id="gender-select" className="form-control" value={personalForm.gender} onChange={(e) => setPersonalForm({ ...personalForm, gender: e.target.value })} disabled={isLocked}>
//                                         <option value="">Select</option>
//                                         <option value="Male">Male</option>
//                                         <option value="Female">Female</option>

//                                         <option value="Other">Other</option>
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className="grid-3">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="marital-select">Marital Status</label>
//                                     <select id="marital-select" className="form-control" value={personalForm.marital_status} onChange={(e) => setPersonalForm({ ...personalForm, marital_status: e.target.value })} disabled={isLocked}>
//                                         <option value="">Select</option>
//                                         <option value="Single">Single</option>
//                                         <option value="Married">Married</option>
//                                         <option value="Divorced">Divorced</option>
//                                     </select>
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="cit-input">Citizenship</label>
//                                     <input type="text" id="cit-input" className="form-control" value={personalForm.citizenship} onChange={(e) => setPersonalForm({ ...personalForm, citizenship: e.target.value })} disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="ssn-input">
//                                         {isIndia ? 'Aadhaar Number' : 'Social Security Number (SSN)'}
//                                     </label>
//                                     <input
//                                         type="text"
//                                         id="ssn-input"
//                                         className="form-control"
//                                         placeholder={isIndia ? '12-digit Aadhaar Number (e.g. 1234 5678 9012)' : '000-00-0000'}
//                                         maxLength={isIndia ? 14 : 11}
//                                         value={personalForm.ssn}
//                                         onChange={(e) => setPersonalForm({ ...personalForm, ssn: e.target.value })}
//                                         disabled={isLocked}
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             <div className="grid-2">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="phone-input">Phone Number</label>
//                                     <input type="tel" id="phone-input" className="form-control" value={personalForm.phone} onChange={(e) => setPersonalForm({ ...personalForm, phone: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="email-display">Personal Email</label>
//                                     <input type="email" id="email-display" className="form-control" value={personalForm.personal_email} onChange={(e) => setPersonalForm({ ...personalForm, personal_email: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                             </div>

//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="addr-input">Address Line</label>
//                                 <input type="text" id="addr-input" className="form-control" value={personalForm.address} onChange={(e) => setPersonalForm({ ...personalForm, address: e.target.value })} required disabled={isLocked} />
//                             </div>

//                             <div className="grid-4">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="city-input">City</label>
//                                     <input type="text" id="city-input" className="form-control" value={personalForm.city} onChange={(e) => setPersonalForm({ ...personalForm, city: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="state-input">State</label>
//                                     <input type="text" id="state-input" className="form-control" value={personalForm.state} onChange={(e) => setPersonalForm({ ...personalForm, state: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="zip-input">ZIP Code</label>
//                                     <input type="text" id="zip-input" className="form-control" value={personalForm.zip} onChange={(e) => setPersonalForm({ ...personalForm, zip: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="country-input">Country</label>
//                                     <input type="text" id="country-input" className="form-control" value={personalForm.country} onChange={(e) => setPersonalForm({ ...personalForm, country: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                             </div>

//                             {!isLocked && <button type="submit" className="btn btn-primary">Save Personal Info</button>}
//                         </form>
//                     </div>
//                 );
//             })()}

//             {/* EMERGENCY CONTACTS TAB */}
//             {activeTab === 'contacts' && (
//                 <div className="card fade-in">
//                     <div className="card-title">Emergency Contacts</div>
//                     <form onSubmit={handleSaveContacts}>
//                         {emergencyContacts.map((contact, idx) => (
//                             <div key={idx} style={{ padding: '1rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)', marginBottom: '1rem', backgroundColor: 'var(--bg-secondary)' }}>
//                                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
//                                     <span style={{ fontSize: '0.85rem', fontWeight: 600 }}>Contact #{idx + 1}</span>
//                                     {!isLocked && emergencyContacts.length > 1 && (
//                                         <button type="button" className="btn btn-danger" style={{ padding: '0.2rem 0.5rem', fontSize: '0.7rem' }} onClick={() => handleRemoveContact(idx)}>
//                                             Remove
//                                         </button>
//                                     )}
//                                 </div>
//                                 <div className="grid-2">
//                                     <div className="form-group">
//                                         <label className="form-label">Full Name</label>
//                                         <input type="text" className="form-control" value={contact.name} onChange={(e) => handleContactChange(idx, 'name', e.target.value)} required disabled={isLocked} />
//                                     </div>
//                                     <div className="form-group">
//                                         <label className="form-label">Relationship</label>
//                                         <input type="text" className="form-control" value={contact.relationship} onChange={(e) => handleContactChange(idx, 'relationship', e.target.value)} required disabled={isLocked} />
//                                     </div>
//                                 </div>
//                                 <div className="grid-2">
//                                     <div className="form-group">
//                                         <label className="form-label">Phone Number</label>
//                                         <input type="tel" className="form-control" value={contact.phone} onChange={(e) => handleContactChange(idx, 'phone', e.target.value)} required disabled={isLocked} />
//                                     </div>
//                                     <div className="form-group">
//                                         <label className="form-label">Email</label>
//                                         <input type="email" className="form-control" value={contact.email} onChange={(e) => handleContactChange(idx, 'email', e.target.value)} required disabled={isLocked} />
//                                     </div>
//                                 </div>
//                                 <div className="form-group" style={{ marginTop: '1rem' }}>
//                                     <label className="form-label">Address</label>
//                                     <input type="text" className="form-control" value={contact.address || ''} onChange={(e) => handleContactChange(idx, 'address', e.target.value)} required disabled={isLocked} />
//                                 </div>
//                             </div>
//                         ))}

//                         {!isLocked && (
//                             <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
//                                 <button type="button" className="btn btn-secondary" onClick={handleAddContact}>+ Add Contact</button>
//                                 <button type="submit" className="btn btn-primary">Save Contacts</button>
//                             </div>
//                         )}
//                     </form>
//                 </div>
//             )}

//             {/* DOCUMENTS UPLOADS TAB (Form I-9 & Onboarding Documents Checklist) */}
//             {activeTab === 'documents' && (() => {
//                 const country = data?.employee?.country || '';
//                 const isIndia = country.toUpperCase() === 'INDIA';
//                 const documents = data?.documents || [];
//                 const requestedDocs = data?.requested_documents || data?.requested_employee_documents || [];
//                 const hasStateID = documents.some(doc => doc.document_type === 'State ID');
//                 const hasSSC = documents.some(doc => doc.document_type === 'Social Security Card (SSC)');
//                 const hasOldCombined = documents.some(doc => doc.document_type === 'Driving License / State ID / SSC');
//                 const activeOption = selectedIdOption || ((hasStateID || hasSSC) ? 'state_id_ssc' : 'driving_license');
//                 return (
//                     <div className="card fade-in">
//                         <div className="card-title">Employee Document Checklists</div>

//                         {/* DYNAMIC MANAGEMENT REQUESTED DOCUMENTS (N ITEMS) */}
//                         {requestedDocs.length > 0 && (
//                             <div
//                                 style={{
//                                     marginBottom: '2rem',
//                                     padding: '1.25rem',
//                                     backgroundColor: 'rgba(59, 130, 246, 0.04)',
//                                     border: '1px solid var(--primary-light, #93c5fd)',
//                                     borderLeft: '4px solid var(--primary, #3b82f6)',
//                                     borderRadius: 'var(--border-radius-md)',
//                                     boxShadow: 'var(--shadow-sm)'
//                                 }}
//                             >
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
//                                     <span style={{ fontSize: '1.25rem' }}>📋</span>
//                                     <h3 style={{ fontSize: '1.05rem', fontWeight: 700, margin: 0, color: 'var(--text-primary)' }}>
//                                         Management Requested Documents ({requestedDocs.length})
//                                     </h3>
//                                 </div>
//                                 <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '1.25rem' }}>
//                                     HR or Management has requested the following additional document(s) specifically for your onboarding profile. Please review the instructions and upload each file below.
//                                 </p>

//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                                     {requestedDocs.map((req, idx) => {
//                                         const docTitle = req.document_name || req.document_type || req.title || req.name || `Requested Document #${idx + 1}`;
//                                         const docInstruction = req.instructions || req.comments || req.description || req.note || req.reason || '';
//                                         return (
//                                             <div key={req.id || idx} style={{ backgroundColor: 'var(--bg-primary)', borderRadius: 'var(--border-radius-sm)', padding: '0.5rem' }}>
//                                                 <UploadField
//                                                     documentType={docTitle}
//                                                     instruction={docInstruction}
//                                                     documentsList={data?.documents || []}
//                                                     onUploadSuccess={() => {
//                                                         setRequestedDocsSubmitted(false);
//                                                         fetchOnboardingData();
//                                                     }}
//                                                     mandatory={true}
//                                                     isLocked={isLocked}
//                                                     allowDeleteWhenLocked={true}
//                                                 />
//                                             </div>
//                                         );
//                                     })}
//                                 </div>
//                             </div>
//                         )}

//                         {isIndia ? (
//                             <>
//                                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '2rem' }}>
//                                     Please upload the required verification files according to Indian HR compliance guidelines.
//                                 </p>

//                                 {/* 1. Academic Qualification */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>1. Academic Qualification</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your highest academic degree certificate or transcript.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Highest Education Qualification (Degree Certificate/Transcript)"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                     />
//                                 </div>

//                                 {/* 2. Aadhar Card */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>2. Aadhar Card</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload front and back side copy of your Aadhar Card.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Aadhar Card"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                     />
//                                 </div>

//                                 {/* 3. PAN Card */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>3. PAN Card</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload a clear scanned copy of your PAN Card.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="PAN Card"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                     />
//                                 </div>

//                                 {/* 4. Passport Size Photo */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>4. Passport Size Photo</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload a recent color passport-size photograph with a clear background.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Passport Size Photo"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                     />
//                                 </div>

//                                 {/* 5. Police Verification */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>5. Police Verification</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your Police Clearance Certificate (PCC) or Character Certificate from local authorities.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Police Verification"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                         showNotAvailable={true}
//                                         notAvailableLabel="I do not have a Police Verification certificate right now"
//                                         consentText="I hereby consent and declare that I do not possess a Police Verification certificate at this moment. I agree and commit to submitting the certificate to HR within one month from my joining date."
//                                     />
//                                 </div>

//                                 {/* 6. Salary Slip of last 3 month */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>6. Salary Slip of last 3 month</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload salary slips from your previous employer for the last three months.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Salary Slip of last 3 month"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                         showNotAvailable={true}
//                                         notAvailableLabel="Not Applicable (Fresh graduate / no previous employment)"
//                                     />
//                                 </div>

//                                 {/* 7. Medical Checkup Documents */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>7. Medical Checkup Documents</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your fitness certificate or medical checkup documents from a registered medical practitioner.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Medical Checkup Documents"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                         showNotAvailable={true}
//                                         notAvailableLabel="I do not have a Medical Checkup report right now"
//                                         consentText="I hereby consent and declare that I do not possess a Medical Checkup report at this moment. I agree and commit to submitting the report to HR within one month from my joining date."
//                                     />
//                                 </div>

//                                 {/* 8. Signed Offer Letter */}
//                                 <div>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>8. Signed Offer Letter</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Automatically saved when you electronically sign your offer letter in the Offer Letter tab.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Signed Offer Letter"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={false}
//                                     />
//                                 </div>
//                             </>
//                         ) : (
//                             <>
//                                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '2rem' }}>
//                                     Please upload the required verification files according to US enterprise HR compliance guidelines.
//                                 </p>

//                                 {/* 1. Form I-9 */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '1rem' }}>
//                                         <div>
//                                             <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>1. Form I-9</h4>
//                                             <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Employment Eligibility Verification. Download, complete, and upload.</p>
//                                         </div>
//                                         <a href="/Form_I-9.pdf" download className="btn btn-secondary" style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', textDecoration: 'none', fontWeight: 600 }}>
//                                             📥 Download Form I-9
//                                         </a>
//                                     </div>
//                                     <UploadField documentType="Form I-9" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                                 </div>

//                                 {/* 2. Form W-4 */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '1rem' }}>
//                                         <div>
//                                             <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>2. Form W-4</h4>
//                                             <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Employee's Withholding Certificate. Download, complete, and upload.</p>
//                                         </div>
//                                         <a href="/Form_W-4.pdf" download className="btn btn-secondary" style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', textDecoration: 'none', fontWeight: 600 }}>
//                                             📥 Download Form W-4
//                                         </a>
//                                     </div>
//                                     <UploadField documentType="Form W-4" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                                 </div>

//                                 {/* 3. Select State */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem', padding: '1rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)', backgroundColor: 'var(--bg-secondary)' }}>
//                                     <div style={{ marginBottom: '1rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.25rem 0', color: 'var(--text-primary)' }}>3. Select State</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: '0 0 0.75rem 0' }}>Select your state to download and submit the corresponding state tax withholding form.</p>
//                                         <select
//                                             value={selectedState}
//                                             onChange={(e) => setSelectedState(e.target.value)}
//                                             className="form-control"
//                                             style={{ maxWidth: '300px', padding: '0.5rem', borderRadius: 'var(--border-radius-sm)' }}
//                                             disabled={isLocked}
//                                         >
//                                             <option value="">-- Choose Your State --</option>
//                                             <option value="oregon">Oregon</option>
//                                             <option value="arizona">Arizona</option>
//                                             <option value="colorado">Colorado</option>
//                                         </select>
//                                     </div>

//                                     {selectedState && (
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1rem', marginTop: '1rem' }}>
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '1rem' }}>
//                                                 <div>
//                                                     <h5 style={{ fontSize: '0.9rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>
//                                                         {selectedState === 'oregon' && 'Oregon Form OR-W-4'}
//                                                         {selectedState === 'arizona' && 'Arizona Form A-4'}
//                                                         {selectedState === 'colorado' && 'Colorado Form DR 0004'}
//                                                     </h5>
//                                                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>
//                                                         {selectedState === 'oregon' && 'Oregon State withholding allowance certificate.'}
//                                                         {selectedState === 'arizona' && 'Arizona State withholding election form.'}
//                                                         {selectedState === 'colorado' && 'Colorado State employee withholding certificate.'}
//                                                     </p>
//                                                 </div>
//                                                 <a
//                                                     href={
//                                                         selectedState === 'oregon' ? '/Oregon_Form_W-4.pdf' :
//                                                             selectedState === 'arizona' ? '/Arizona_Form_A4.pdf' :
//                                                                 '/Colorado_Form_DR0004.pdf'
//                                                     }
//                                                     download
//                                                     className="btn btn-secondary"
//                                                     style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', textDecoration: 'none', fontWeight: 600 }}
//                                                 >
//                                                     📥 Download {selectedState.toUpperCase()} Form
//                                                 </a>
//                                             </div>
//                                             <UploadField
//                                                 documentType={
//                                                     selectedState === 'oregon' ? 'Oregon State Tax Form' :
//                                                         selectedState === 'arizona' ? 'Arizona State Tax Form' :
//                                                             'Colorado State Tax Form'
//                                                 }
//                                                 documentsList={data?.documents}
//                                                 onUploadSuccess={fetchOnboardingData}
//                                                 mandatory={true}
//                                             />
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* 4. Passport */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>4. Passport</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your valid Passport (bio page & back page).</p>
//                                     </div>
//                                     <UploadField documentType="Passport" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                                 </div>

//                                 {/* 5. Visa & EAD */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>5. Visa & EAD</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your valid Visa or Employment Authorization Document (EAD).</p>
//                                     </div>
//                                     <UploadField documentType="Visa & EAD" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                                 </div>

//                                 {/* 6. US Identification * */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.75rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>6. US Identification *</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: '0.25rem 0 0.75rem 0' }}>
//                                             Choose your identification submission method: either submit a valid Driving License, or submit a State ID along with your Social Security Card (SSC).
//                                         </p>
//                                     </div>

//                                     <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap', padding: '0 0.5rem' }}>
//                                         <label style={{
//                                             flex: '1 1 200px',
//                                             padding: '0.85rem 1rem',
//                                             border: activeOption === 'driving_license' ? '2px solid var(--primary)' : '1px solid var(--border-color)',
//                                             borderRadius: 'var(--border-radius-md)',
//                                             cursor: 'pointer',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             gap: '0.75rem',
//                                             backgroundColor: activeOption === 'driving_license' ? 'rgba(59, 130, 246, 0.04)' : 'var(--bg-secondary)',
//                                             transition: 'all 0.2s ease'
//                                         }}>
//                                             <input
//                                                 type="radio"
//                                                 name="id_option"
//                                                 checked={activeOption === 'driving_license'}
//                                                 onChange={() => setSelectedIdOption('driving_license')}
//                                                 style={{ accentColor: 'var(--primary)' }}
//                                                 disabled={isLocked}
//                                             />
//                                             <div>
//                                                 <strong style={{ display: 'block', fontSize: '0.85rem', color: 'var(--text-primary)' }}>Driving License</strong>
//                                                 <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Upload your valid US Driving License.</span>
//                                             </div>
//                                         </label>

//                                         <label style={{
//                                             flex: '1 1 200px',
//                                             padding: '0.85rem 1rem',
//                                             border: activeOption === 'state_id_ssc' ? '2px solid var(--primary)' : '1px solid var(--border-color)',
//                                             borderRadius: 'var(--border-radius-md)',
//                                             cursor: 'pointer',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             gap: '0.75rem',
//                                             backgroundColor: activeOption === 'state_id_ssc' ? 'rgba(59, 130, 246, 0.04)' : 'var(--bg-secondary)',
//                                             transition: 'all 0.2s ease'
//                                         }}>
//                                             <input
//                                                 type="radio"
//                                                 name="id_option"
//                                                 checked={activeOption === 'state_id_ssc'}
//                                                 onChange={() => setSelectedIdOption('state_id_ssc')}
//                                                 style={{ accentColor: 'var(--primary)' }}
//                                                 disabled={isLocked}
//                                             />
//                                             <div>
//                                                 <strong style={{ display: 'block', fontSize: '0.85rem', color: 'var(--text-primary)' }}>State ID & Social Security Card (SSC)</strong>
//                                                 <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Upload both your State ID and Social Security Card.</span>
//                                             </div>
//                                         </label>
//                                     </div>

//                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                         {activeOption === 'driving_license' ? (
//                                             <UploadField
//                                                 documentType="Driving License"
//                                                 documentsList={data?.documents}
//                                                 onUploadSuccess={fetchOnboardingData}
//                                                 mandatory={true}
//                                             />
//                                         ) : (
//                                             <>
//                                                 <UploadField
//                                                     documentType="State ID"
//                                                     documentsList={data?.documents}
//                                                     onUploadSuccess={fetchOnboardingData}
//                                                     mandatory={true}
//                                                 />
//                                                 <UploadField
//                                                     documentType="Social Security Card (SSC)"
//                                                     documentsList={data?.documents}
//                                                     onUploadSuccess={fetchOnboardingData}
//                                                     mandatory={true}
//                                                 />
//                                             </>
//                                         )}

//                                         {hasOldCombined && (
//                                             <div style={{ marginTop: '1rem', borderTop: '1px dashed var(--border-color)', paddingTop: '1rem' }}>
//                                                 <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginBottom: '0.5rem', fontWeight: 600 }}>
//                                                     Previously uploaded combined identification document:
//                                                 </p>
//                                                 <UploadField
//                                                     documentType="Driving License / State ID / SSC"
//                                                     documentsList={data?.documents}
//                                                     onUploadSuccess={fetchOnboardingData}
//                                                     mandatory={false}
//                                                 />
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>

//                                 {/* 7. Highest Education Qualification (Degree Certification / Transcript) */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>7. Highest Education Qualification (Degree Certification / Transcript)</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your highest education qualification degree certificate or transcript.</p>
//                                     </div>
//                                     <UploadField documentType="Highest Education Qualification (Degree Certificate/Transcript)" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                                 </div>

//                                 {/* 8. Professional Certificate / Licenses */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>8. Professional Certificate / Licenses</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your professional certification or licenses (optional).</p>
//                                     </div>
//                                     <UploadField documentType="Professional Certificate / Licenses" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={false} />
//                                 </div>

//                                 {/* 9. Other */}
//                                 <div>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>9. Other</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload any additional supporting documents or records.</p>
//                                     </div>
//                                     <UploadField documentType="Other Documents" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} />
//                                 </div>
//                             </>
//                         )}
//                     </div>
//                 );
//             })()}


//             {/* OFFER LETTER TAB */}
//             {activeTab === 'offer' && (
//                 <div className="card fade-in">
//                     <div className="card-title">Offer Letter Acceptance</div>
//                     <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
//                         Verify and electronically sign your hiring offer letter.
//                     </p>

//                     <div className="agreements-document-grid">
//                         {/* Left side: Pre-signed badge & signature drawer */}
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
//                             <div
//                                 style={{
//                                     border: '1px solid var(--border-color)',
//                                     borderRadius: 'var(--border-radius-md)',
//                                     padding: '1.5rem',
//                                     backgroundColor: 'var(--bg-secondary)',
//                                     boxShadow: 'var(--shadow-sm)',
//                                     fontSize: '0.825rem'
//                                 }}
//                             >
//                                 <h4 style={{ fontWeight: 'bold', marginBottom: '0.75rem', color: 'var(--primary)' }}>Authorized Representative Signature</h4>
//                                 <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', marginBottom: '0.5rem' }}>
//                                     <span style={{ fontSize: '1.5rem' }}>✍️</span>
//                                     <div>
//                                         <strong>Neeta Shrikant Sangvikar</strong>
//                                         <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>Director HR, Genesis Tech Engineers</div>
//                                     </div>
//                                 </div>
//                                 <div style={{ fontSize: '0.75rem', color: 'var(--success)', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.25rem', marginTop: '0.5rem' }}>
//                                     <span>✓</span> Document pre-signed by Employer
//                                 </div>
//                             </div>

//                             {data?.signature_history?.some(h => h.document_type === 'Offer Letter' && h.action === 'SIGN') ? (
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                                     <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1.25rem', borderRadius: 'var(--border-radius-sm)', fontSize: '0.85rem' }}>
//                                         🚀 <strong>Offer Letter Signed</strong>: You accepted and electronically signed this Offer Letter on {new Date(data.signature_history.find(h => h.document_type === 'Offer Letter' && h.action === 'SIGN').signed_at).toLocaleString()}.
//                                     </div>
//                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                         <button
//                                             type="button"
//                                             className="btn btn-primary"
//                                             style={{ width: '100%', padding: '0.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                                             onClick={() => handleDownloadPdf(offerLetterBlobUrl, `offer_letter_${(employee?.FirstName || 'employee').toLowerCase()}_${(employee?.LastName || 'signed').toLowerCase()}_signed.pdf`)}
//                                         >
//                                             📥 Download Signed Offer Letter
//                                         </button>

//                                     </div>
//                                 </div>
//                             ) : (
//                                 !isLocked && <SignaturePad onSave={(sig) => handleDocumentSign('Offer Letter', sig)} />
//                             )}
//                         </div>

//                         {/* Right side: The PDF/Base64 Preview from Database */}
//                         <div>
//                             {offerLetterBlobUrl ? (
//                                 <div style={{ border: '2px solid #334155', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow-md)', backgroundColor: 'var(--bg-secondary)' }}>
//                                     <div className="mobile-helper-banner" style={{
//                                         padding: '0.75rem 1rem',
//                                         backgroundColor: 'var(--bg-tertiary)',
//                                         borderBottom: '1px solid var(--border-color)',
//                                         flexWrap: 'wrap',
//                                         alignItems: 'center',
//                                         justifyContent: 'space-between',
//                                         gap: '0.5rem'
//                                     }}>
//                                         <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
//                                             📱 Reading on Mobile?
//                                         </span>
//                                         <div style={{ display: 'flex', gap: '0.5rem' }}>
//                                             <button
//                                                 type="button"
//                                                 className="btn btn-secondary"
//                                                 style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
//                                                 onClick={() => handleViewPdf(offerLetterBlobUrl, 'offer_letter.pdf')}
//                                             >
//                                                 📂 Open Fullscreen & Zoom
//                                             </button>
//                                             <button
//                                                 type="button"
//                                                 className="btn btn-primary"
//                                                 style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
//                                                 onClick={() => handleDownloadPdf(offerLetterBlobUrl, 'offer_letter.pdf')}
//                                             >
//                                                 📥 Download PDF
//                                             </button>
//                                         </div>
//                                     </div>
//                                     <iframe
//                                         src={`${offerLetterBlobUrl}#toolbar=0&navpanes=0&view=FitH`}
//                                         className="document-iframe"
//                                         style={{ height: "750px" }}
//                                         title="Offer Letter PDF Viewer"
//                                     />
//                                 </div>
//                             ) : (
//                                 <div className="document-text-preview">
//                                     {/* Header */}
//                                     <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', borderBottom: '2px solid #000000', paddingBottom: '0.75rem', marginBottom: '1.5rem' }}>
//                                         {/* Green Logo SVG */}
//                                         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', minWidth: '95px' }}>
//                                             <svg width="45" height="45" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                 <circle cx="50" cy="50" r="38" stroke="#16a34a" strokeWidth="6" strokeDasharray="10 5" />
//                                                 <circle cx="50" cy="50" r="22" fill="#16a34a" opacity="0.8" />
//                                                 <path d="M50 10 L56 26 L44 26 Z" fill="#16a34a" />
//                                                 <path d="M50 90 L56 74 L44 74 Z" fill="#16a34a" />
//                                                 <path d="M10 50 L26 56 L26 44 Z" fill="#16a34a" />
//                                                 <path d="M90 50 L74 56 L74 44 Z" fill="#16a34a" />
//                                             </svg>
//                                             <span style={{ fontSize: '0.6rem', fontWeight: '800', color: '#16a34a', lineHeight: 1.1, marginTop: '0.25rem' }}>GENESIS TECH</span>
//                                             <span style={{ fontSize: '0.6rem', fontWeight: '800', color: '#16a34a', lineHeight: 1.0 }}>ENGINEERS</span>
//                                             <span style={{ fontSize: '0.35rem', fontWeight: '600', color: '#16a34a', marginTop: '0.1rem', letterSpacing: '0.02em', textTransform: 'uppercase' }}>Making Engineering Sustainable</span>
//                                         </div>

//                                         {/* Header details */}
//                                         <div style={{ flex: 1, textAlign: 'center' }}>
//                                             <h2 style={{ fontSize: '1.25rem', fontWeight: '800', color: '#000000', margin: '0 0 0.25rem 0', letterSpacing: '0.02em' }}>GENESIS TECH ENGINEERS PVT. LTD.</h2>
//                                             <p style={{ fontSize: '0.55rem', color: '#334155', margin: '0 0 0.25rem 0', fontWeight: '700', lineHeight: 1.3 }}>
//                                                 REGISTERED ADDRESS : PLOT NO 5, GOKUL SOCIETY, DATTAWADI, SADASHIV PETH, PUNE CITY, PUNE - 411030. MH, INDIA.
//                                             </p>
//                                             <p style={{ fontSize: '0.55rem', color: '#334155', margin: 0, fontWeight: '700' }}>
//                                                 GST #: <span style={{ color: '#000000' }}>27AAKCG7985R1ZB</span> &nbsp;|&nbsp; PAN #: <span style={{ color: '#000000' }}>AAKCG7985R</span> &nbsp;|&nbsp; Contact: <span style={{ color: '#000000' }}>+91-8983260210</span>
//                                             </p>
//                                             <p style={{ fontSize: '0.55rem', color: '#334155', margin: '0.15rem 0 0 0', fontWeight: '700' }}>
//                                                 Website: <a href="http://www.genesistech.co.in" target="_blank" rel="noreferrer" style={{ color: '#2563eb', textDecoration: 'none' }}>www.genesistech.co.in</a> &nbsp; E-mail: <a href="mailto:contact@genesistech.co.in" style={{ color: '#2563eb', textDecoration: 'none' }}>contact@genesistech.co.in</a>
//                                             </p>
//                                         </div>
//                                     </div>

//                                     <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', fontSize: '0.8rem', color: '#475569' }}>
//                                         <span>Document ID: GTE-OL-{1000 + (employee.id || 1)}</span>
//                                         <span>Date: {employee.JoiningDate || '28/7/2026'}</span>
//                                     </div>

//                                     <h3 style={{ fontSize: '1rem', fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase', marginBottom: '1.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.5rem' }}>
//                                         JOB OFFER LETTER
//                                     </h3>

//                                     <p style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
//                                         Dear {employee.FirstName} {employee.LastName},
//                                     </p>

//                                     <p style={{ marginBottom: '1.25rem' }}>
//                                         We are delighted to offer you the role at Genesis Tech Engineers Pvt. Ltd. You are an outstanding applicant, and we believe that your skills and experience make you an excellent addition to the team. Below, you will find more information about the role, compensation, and some of the amazing benefits available to you when you join Genesis Tech Engineers Pvt. Ltd. Please also refer to the enclosed General Terms & Conditions of Employment where you will find further information on your employment, including information on your right to work in India and pre-employment checks.
//                                     </p>

//                                     <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.25rem', marginBottom: '0.5rem' }}>1. Your Job:</h4>
//                                     <ul style={{ listStyleType: 'none', paddingLeft: 0, marginBottom: '1.25rem', display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                                         <li><strong>Role:</strong> {employee.Designation || 'Software Development Engineer'}</li>
//                                         <li><strong>Office Location:</strong> DNK SQUARE, 14th Floor, Office 1401, 1406, Airport Road, Sakore Nagar, Viman Nagar, Pune, Maharashtra - 411014</li>
//                                         <li><strong>Start Date:</strong> {employee.JoiningDate || '2026-08-08'}</li>
//                                         <li><strong>Work Model:</strong> Work from Office</li>
//                                         <li><strong>Office timing:</strong> 9.30am - 12.30am</li>
//                                         <li><strong>Employee ID:</strong> -</li>
//                                     </ul>

//                                     <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.25rem', marginBottom: '0.5rem' }}>2. Pay:</h4>
//                                     <p style={{ marginBottom: '1.25rem' }}>
//                                         Your annual CTC is <strong>{employee.OfferedCTC || 'As agreed'}</strong> which shall be payable monthly in arrears on or about the payroll cut-off of each month directly into your nominated bank account. If your employment commencement date is on or before the payroll cutoff of the month, you will receive your first month's pay on the month's payday of when your employment commences.
//                                     </p>

//                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', borderTop: '1px dashed #cbd5e1', paddingTop: '1.5rem', marginTop: '2rem' }}>
//                                         <p><strong>Employee Sign:</strong> ___________________________</p>
//                                         <p><strong>Employee Name:</strong> {employee.FirstName} {employee.LastName}</p>
//                                         <p><strong>Date:</strong> ___________________________</p>
//                                     </div>

//                                     <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                         <p><strong>For: Genesis Tech Engineers Pvt. Ltd.</strong></p>
//                                         <div style={{ fontSize: '1rem', fontStyle: 'italic', color: 'var(--primary)', margin: '0.25rem 0' }}>Neeta</div>
//                                         <p><strong>Name:</strong> NEETA SHRIKANT SANGVIKAR</p>
//                                         <p><strong>Designation:</strong> DIRECTOR HR</p>
//                                     </div>

//                                     <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', marginTop: '2rem', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                         [Page 1 of 1]
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* EMPLOYEE AGREEMENT TAB */}
//             {activeTab === 'agreement' && (() => {
//                 const country = employee?.country || '';
//                 const isUsa = country.toUpperCase() === 'USA';
//                 const agreementsList = isUsa ? [
//                     { key: 'employment_agreement', title: 'Employment Agreement 1', displayName: 'Employment Agreement', path: '/Employment Agreement 1.pdf', desc: 'Verify and electronically sign your formal Employment Agreement.' },
//                     { key: 'confidentiality_nda', title: 'Employee Confidentiality & NDA (1)', displayName: 'Employee Confidentiality & NDA', path: '/Employee Confidentiality & NDA (1).pdf', desc: 'Electronically sign the Corporate Non-Disclosure Agreement.' },
//                     { key: 'conflict_of_interest', title: 'Conflict of interest agreement', path: '/Conflict of interest agreement.pdf', desc: 'Sign the Conflict of Interest policy compliance statement.' },
//                     { key: '401k_dental_vision_medical', title: '401K Dental Vision Medical', path: '/401K Dental Vision Medical.pdf', desc: 'Acknowledge details of the 401K and healthcare benefit details.' },
//                     { key: 'non_solicitation', title: 'Non Solicitation', path: '/Non Solicitation.pdf', desc: 'Sign the Non-Solicitation Agreement.' }
//                 ] : [
//                     { key: 'employee_agreement', title: 'Employee Agreement', path: '/3-Employment Agreement.pdf', desc: 'Verify and electronically sign your formal Employment Agreement.' }
//                 ];

//                 const isAgreementSigned = (title) => {
//                     return data?.signature_history?.some(h => h.document_type === title && h.action === 'SIGN');
//                 };

//                 const getSignatureDate = (title) => {
//                     const sig = data?.signature_history?.find(h => h.document_type === title && h.action === 'SIGN');
//                     return sig ? new Date(sig.signed_at).toLocaleString() : '';
//                 };

//                 const activeAgreement = agreementsList.find(a => a.key === selectedAgreementKey) || agreementsList[0];
//                 const activeBlobUrl = agreementBlobUrls[activeAgreement?.key] || activeAgreement?.path;

//                 const signedCount = agreementsList.filter(item => isAgreementSigned(item.title)).length;
//                 const totalCount = agreementsList.length;
//                 const progressPercentage = Math.round((signedCount / totalCount) * 100);

//                 return (
//                     <div className="card fade-in">
//                         <div className="card-title">Employee Agreement Acceptance</div>
//                         <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
//                             {isUsa
//                                 ? "Please review and electronically sign all 5 required agreements to complete your onboarding."
//                                 : "Verify and electronically sign your formal Employment Agreement."}
//                         </p>

//                         {/* SLEEK PROGRESS CARD FOR USA */}
//                         {isUsa && (
//                             <div style={{
//                                 marginBottom: '1.5rem',
//                                 padding: '1rem 1.25rem',
//                                 borderRadius: '8px',
//                                 background: 'linear-gradient(135deg, rgba(79, 70, 229, 0.04) 0%, rgba(99, 102, 241, 0.04) 100%)',
//                                 border: '1px solid rgba(79, 70, 229, 0.1)',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'space-between',
//                                 flexWrap: 'wrap',
//                                 gap: '1rem'
//                             }}>
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
//                                     <span style={{ fontSize: '1.5rem' }}>📋</span>
//                                     <div>
//                                         <div style={{ fontSize: '0.875rem', fontWeight: 'bold', color: 'var(--text-primary)' }}>
//                                             Employee Agreement Packages Signature Status
//                                         </div>
//                                         <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '0.15rem' }}>
//                                             {signedCount} of {totalCount} signed
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div style={{ flex: '1 1 200px', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                                     <div style={{ flex: 1, height: '8px', backgroundColor: 'rgba(79, 70, 229, 0.1)', borderRadius: '4px', overflow: 'hidden' }}>
//                                         <div style={{ width: `${progressPercentage}%`, height: '100%', backgroundColor: 'var(--primary)', transition: 'width 0.4s ease' }} />
//                                     </div>
//                                     <span style={{ fontSize: '0.875rem', fontWeight: 'bold', color: 'var(--primary)' }}>
//                                         {progressPercentage}%
//                                     </span>
//                                 </div>
//                             </div>
//                         )}

//                         {/* HORIZONTAL SELECTOR TABS */}
//                         <div className="agreements-horizontal-tabs">
//                             {agreementsList.map((item) => {
//                                 const signed = isAgreementSigned(item.title);
//                                 const active = selectedAgreementKey === item.key;
//                                 return (
//                                     <div
//                                         key={item.key}
//                                         onClick={() => setSelectedAgreementKey(item.key)}
//                                         className={`agreement-tab-item ${active ? 'active' : ''}`}
//                                     >
//                                         <div className="agreement-tab-title">{item.displayName || item.title}</div>
//                                         <div className="agreement-tab-status">
//                                             {signed ? (
//                                                 <span style={{ color: 'var(--success)', fontWeight: 600 }}>✓ Signed</span>
//                                             ) : (
//                                                 <span style={{ color: '#d97706', fontWeight: 600 }}>⏳ Pending</span>
//                                             )}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                         </div>

//                         {/* CORE VIEW / SIGN FLOW - DUAL COLUMN GRID: INPUTS LEFT, PDF RIGHT */}
//                         <div className="agreements-document-grid">
//                             {/* Right Column: Signature Signoff area */}
//                             <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
//                                 <div
//                                     style={{
//                                         border: '1px solid var(--border-color)',
//                                         borderRadius: 'var(--border-radius-md)',
//                                         padding: '1.5rem',
//                                         backgroundColor: 'var(--bg-secondary)',
//                                         boxShadow: 'var(--shadow-sm)',
//                                         fontSize: '0.825rem'
//                                     }}
//                                 >
//                                     <h4 style={{ fontWeight: 'bold', marginBottom: '0.75rem', color: 'var(--primary)' }}>Authorized Representative Signature</h4>
//                                     <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', marginBottom: '0.5rem' }}>
//                                         <span style={{ fontSize: '1.5rem' }}>✍️</span>
//                                         <div>
//                                             <strong>Neeta Shrikant Sangvikar</strong>
//                                             <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>Director HR, Genesis Tech Engineers</div>
//                                         </div>
//                                     </div>
//                                     <div style={{ fontSize: '0.75rem', color: 'var(--success)', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.25rem', marginTop: '0.5rem' }}>
//                                         <span>✓</span> Document pre-signed by Employer
//                                     </div>
//                                 </div>





//                                 {selectedAgreementKey === 'conflict_of_interest' && !isAgreementSigned(activeAgreement?.title) && (
//                                     <div
//                                         style={{
//                                             border: '1px solid var(--border-color)',
//                                             borderRadius: 'var(--border-radius-md)',
//                                             padding: '1.5rem',
//                                             backgroundColor: 'var(--bg-secondary)',
//                                             boxShadow: 'var(--shadow-sm)',
//                                             display: 'flex',
//                                             flexDirection: 'column',
//                                             gap: '1rem'
//                                         }}
//                                     >
//                                         <h4 style={{ fontWeight: 'bold', color: 'var(--primary)', margin: 0, fontSize: '0.95rem' }}>Conflict of Interest Info</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>
//                                             Please fill out the details below. They will be dynamically updated in your Conflict of Interest PDF.
//                                         </p>




//                                         {/* A. Outside Employment */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem', marginTop: '0.25rem' }}>
//                                             <label style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>A. Outside Employment</label>
//                                             <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="outsideEmploymentType"
//                                                         value="none"
//                                                         checked={employmentForm.outsideEmploymentType === 'none'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, outsideEmploymentType: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     I am not employed by any other employer.
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="outsideEmploymentType"
//                                                         value="has_employment"
//                                                         checked={employmentForm.outsideEmploymentType === 'has_employment'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, outsideEmploymentType: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     I currently have outside employment.
//                                                 </label>
//                                             </div>
//                                         </div>

//                                         {employmentForm.outsideEmploymentType === 'has_employment' && (
//                                             <div style={{ paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem', borderLeft: '2px solid var(--primary-light)' }}>
//                                                 <div className="form-group" style={{ margin: 0 }}>
//                                                     <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Employer / Business</label>
//                                                     <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         value={employmentForm.outsideEmployer}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, outsideEmployer: e.target.value })}
//                                                         disabled={isLocked}
//                                                         style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                                                     />
//                                                 </div>
//                                                 <div className="form-group" style={{ margin: 0 }}>
//                                                     <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Nature of Work</label>
//                                                     <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         value={employmentForm.outsideNature}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, outsideNature: e.target.value })}
//                                                         disabled={isLocked}
//                                                         style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                                                     />
//                                                 </div>
//                                                 <div className="form-group" style={{ margin: 0 }}>
//                                                     <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Hours Worked</label>
//                                                     <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         value={employmentForm.outsideHours}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, outsideHours: e.target.value })}
//                                                         disabled={isLocked}
//                                                         style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}

//                                         {/* B. Ownership of Other Businesses */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>B. Ownership of Other Businesses</label>
//                                             <span style={{ fontSize: '0.7rem', display: 'block', marginBottom: '0.4rem', color: 'var(--text-secondary)' }}>Do you own or have an interest in any business?</span>
//                                             <div style={{ display: 'flex', gap: '1rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="ownershipType"
//                                                         value="no"
//                                                         checked={employmentForm.ownershipType === 'no'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, ownershipType: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     No
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="ownershipType"
//                                                         value="yes"
//                                                         checked={employmentForm.ownershipType === 'yes'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, ownershipType: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Yes
//                                                 </label>
//                                             </div>
//                                         </div>

//                                         {employmentForm.ownershipType === 'yes' && (
//                                             <div className="form-group" style={{ margin: 0, paddingLeft: '1rem', borderLeft: '2px solid var(--primary-light)' }}>
//                                                 <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>If yes, describe:</label>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control"
//                                                     value={employmentForm.ownershipDescribe}
//                                                     onChange={(e) => setEmploymentForm({ ...employmentForm, ownershipDescribe: e.target.value })}
//                                                     disabled={isLocked}
//                                                     style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                                                 />
//                                             </div>
//                                         )}

//                                         {/* C. Competing Activities */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>C. Competing Activities</label>
//                                             <span style={{ fontSize: '0.7rem', display: 'block', marginBottom: '0.4rem', color: 'var(--text-secondary)' }}>Are you involved in any competing activities?</span>
//                                             <div style={{ display: 'flex', gap: '1rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="competingType"
//                                                         value="no"
//                                                         checked={employmentForm.competingType === 'no'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, competingType: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     No
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="competingType"
//                                                         value="yes"
//                                                         checked={employmentForm.competingType === 'yes'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, competingType: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Yes
//                                                 </label>
//                                             </div>
//                                         </div>

//                                         {employmentForm.competingType === 'yes' && (
//                                             <div className="form-group" style={{ margin: 0, paddingLeft: '1rem', borderLeft: '2px solid var(--primary-light)' }}>
//                                                 <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>If yes, explain:</label>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control"
//                                                     value={employmentForm.competingDescribe}
//                                                     onChange={(e) => setEmploymentForm({ ...employmentForm, competingDescribe: e.target.value })}
//                                                     disabled={isLocked}
//                                                     style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                                                 />
//                                             </div>
//                                         )}

//                                         {/* D. Other Potential Conflicts */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label className="form-label" style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>D. Other Potential Conflicts</label>
//                                             <span style={{ fontSize: '0.7rem', display: 'block', marginBottom: '0.4rem', color: 'var(--text-secondary)' }}>Describe any actual or potential conflict circumstances:</span>
//                                             <textarea
//                                                 className="form-control"
//                                                 rows="2"
//                                                 value={employmentForm.otherConflicts}
//                                                 onChange={(e) => setEmploymentForm({ ...employmentForm, otherConflicts: e.target.value })}
//                                                 disabled={isLocked}
//                                                 style={{ padding: '0.4rem 0.65rem', fontSize: '0.85rem', resize: 'vertical' }}
//                                                 placeholder="None (or details here)"
//                                             />
//                                         </div>
//                                     </div>
//                                 )}

//                                 {selectedAgreementKey === '401k_dental_vision_medical' && !isAgreementSigned(activeAgreement?.title) && (
//                                     <div
//                                         style={{
//                                             border: '1px solid var(--border-color)',
//                                             borderRadius: 'var(--border-radius-md)',
//                                             padding: '1.75rem',
//                                             backgroundColor: 'var(--bg-secondary)',
//                                             boxShadow: 'var(--shadow-sm)',
//                                             display: 'flex',
//                                             flexDirection: 'column',
//                                             gap: '1.25rem'
//                                         }}
//                                     >
//                                         <h4 style={{ fontWeight: 'bold', color: 'var(--primary)', margin: 0, fontSize: '1rem', borderBottom: '2px solid var(--primary)', paddingBottom: '0.5rem' }}>
//                                             401K Dental Vision Medical Enrollment Form
//                                         </h4>

//                                         <div style={{ backgroundColor: 'var(--bg-primary)', padding: '0.75rem 1rem', borderRadius: 'var(--border-radius-sm)', borderLeft: '3px solid var(--primary)' }}>
//                                             <h5 style={{ fontWeight: 'bold', fontSize: '0.8rem', margin: '0 0 0.25rem 0', color: 'var(--text-primary)' }}>Instructions</h5>
//                                             <p style={{ fontSize: '0.72rem', color: 'var(--text-secondary)', margin: 0, lineHeight: 1.4 }}>
//                                                 Please complete this form to enroll in the Company's employee benefit programs. Enrollment is subject to eligibility requirements, applicable plan documents, insurance carrier rules, and Company policies.
//                                             </p>
//                                         </div>



//                                         {/* Section 1 – Medical Insurance */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                                                 Section 1 – Medical Insurance
//                                             </label>
//                                             <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                                                 Enrolment Election
//                                             </span>
//                                             <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginBottom: '0.5rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="medicalElection"
//                                                         value="enrol"
//                                                         checked={employmentForm.medicalElection === 'enrol'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, medicalElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Enrol
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="medicalElection"
//                                                         value="waive"
//                                                         checked={employmentForm.medicalElection === 'waive'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, medicalElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Waive Coverage
//                                                 </label>
//                                             </div>
//                                         </div>

//                                         {employmentForm.medicalElection === 'waive' && (
//                                             <div style={{ paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.4rem', borderLeft: '2px solid var(--primary-light)' }}>
//                                                 <span style={{ fontSize: '0.72rem', color: 'var(--text-secondary)' }}>If waiving medical coverage, reason:</span>
//                                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                                                     <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                         <input
//                                                             type="radio"
//                                                             name="medicalWaiveReason"
//                                                             value="spouse_plan"
//                                                             checked={employmentForm.medicalWaiveReason === 'spouse_plan'}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
//                                                             disabled={isLocked}
//                                                         />
//                                                         Covered under spouse's employer plan
//                                                     </label>
//                                                     <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                         <input
//                                                             type="radio"
//                                                             name="medicalWaiveReason"
//                                                             value="another_plan"
//                                                             checked={employmentForm.medicalWaiveReason === 'another_plan'}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
//                                                             disabled={isLocked}
//                                                         />
//                                                         Covered under another employer plan
//                                                     </label>
//                                                     <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                         <input
//                                                             type="radio"
//                                                             name="medicalWaiveReason"
//                                                             value="gov_program"
//                                                             checked={employmentForm.medicalWaiveReason === 'gov_program'}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
//                                                             disabled={isLocked}
//                                                         />
//                                                         Covered under government program
//                                                     </label>
//                                                     <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                         <input
//                                                             type="radio"
//                                                             name="medicalWaiveReason"
//                                                             value="other"
//                                                             checked={employmentForm.medicalWaiveReason === 'other'}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
//                                                             disabled={isLocked}
//                                                         />
//                                                         Other:
//                                                     </label>
//                                                 </div>
//                                                 {employmentForm.medicalWaiveReason === 'other' && (
//                                                     <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         value={employmentForm.medicalWaiveReasonOther}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReasonOther: e.target.value })}
//                                                         disabled={isLocked}
//                                                         placeholder="Specify other reason..."
//                                                         style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem', marginTop: '0.2rem' }}
//                                                     />
//                                                 )}
//                                             </div>
//                                         )}

//                                         {/* Section 2 – Dental Insurance */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                                                 Section 2 – Dental Insurance
//                                             </label>
//                                             <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                                                 Enrolment Election
//                                             </span>
//                                             <div style={{ display: 'flex', gap: '1rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="dentalElection"
//                                                         value="enrol"
//                                                         checked={employmentForm.dentalElection === 'enrol'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, dentalElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Enrol
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="dentalElection"
//                                                         value="waive"
//                                                         checked={employmentForm.dentalElection === 'waive'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, dentalElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Waive Coverage
//                                                 </label>
//                                             </div>
//                                         </div>

//                                         {/* Section 3 – Vision Insurance */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                                                 Section 3 – Vision Insurance
//                                             </label>
//                                             <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                                                 Enrolment Election
//                                             </span>
//                                             <div style={{ display: 'flex', gap: '1rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="visionElection"
//                                                         value="enrol"
//                                                         checked={employmentForm.visionElection === 'enrol'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, visionElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Enrol
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="visionElection"
//                                                         value="waive"
//                                                         checked={employmentForm.visionElection === 'waive'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, visionElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Waive Coverage
//                                                 </label>
//                                             </div>
//                                         </div>

//                                         {/* Section 4 – 401(k) Retirement Plan Enrolment */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                                                 Section 4 – 401(k) Retirement Plan Enrolment
//                                             </label>
//                                             <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                                                 Participation Election
//                                             </span>
//                                             <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginBottom: '0.65rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="retirementElection"
//                                                         value="participate"
//                                                         checked={employmentForm.retirementElection === 'participate'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, retirementElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     I elect to participate in the Company's 401(k) Retirement Plan.
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="retirementElection"
//                                                         value="decline"
//                                                         checked={employmentForm.retirementElection === 'decline'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, retirementElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     I decline participation at this time.
//                                                 </label>
//                                             </div>

//                                             {employmentForm.retirementElection === 'participate' && (
//                                                 <div style={{ paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.65rem', borderLeft: '2px solid var(--primary-light)', marginBottom: '0.75rem' }}>
//                                                     <span style={{ fontSize: '0.72rem', fontWeight: 600, color: 'var(--text-primary)' }}>Employee Contribution</span>
//                                                     <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Please deduct the following amount from each eligible pay check:</span>
//                                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                                                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                             <input
//                                                                 type="radio"
//                                                                 name="retirementContributionType"
//                                                                 value="percentage"
//                                                                 checked={employmentForm.retirementContributionType === 'percentage'}
//                                                                 onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionType: e.target.value })}
//                                                                 disabled={isLocked}
//                                                             />
//                                                             % of Eligible Compensation
//                                                         </label>
//                                                         {employmentForm.retirementContributionType === 'percentage' && (
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 value={employmentForm.retirementContributionPercent}
//                                                                 onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionPercent: e.target.value })}
//                                                                 disabled={isLocked}
//                                                                 placeholder="%"
//                                                                 style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem', width: '80px', marginLeft: '1.25rem' }}
//                                                             />
//                                                         )}
//                                                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                             <input
//                                                                 type="radio"
//                                                                 name="retirementContributionType"
//                                                                 value="amount"
//                                                                 checked={employmentForm.retirementContributionType === 'amount'}
//                                                                 onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionType: e.target.value })}
//                                                                 disabled={isLocked}
//                                                             />
//                                                             $ per pay period (if permitted under the Plan)
//                                                         </label>
//                                                         {employmentForm.retirementContributionType === 'amount' && (
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 value={employmentForm.retirementContributionAmount}
//                                                                 onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionAmount: e.target.value })}
//                                                                 disabled={isLocked}
//                                                                 placeholder="$"
//                                                                 style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem', width: '120px', marginLeft: '1.25rem' }}
//                                                             />
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             )}

//                                             <div style={{ backgroundColor: 'var(--bg-primary)', padding: '0.75rem', borderRadius: 'var(--border-radius-sm)', border: '1px dashed var(--border-color)', fontSize: '0.7rem', color: 'var(--text-secondary)', lineHeight: 1.4 }}>
//                                                 <strong style={{ color: 'var(--text-primary)', display: 'block', marginBottom: '0.2rem' }}>Company Matching Contribution</strong>
//                                                 Genesis Tech Engineers Inc. currently provides a matching contribution of 100% of the Employee's elective deferrals up to a maximum of 2% of the Employee's eligible compensation, subject to the terms of the Company's 401(k) Plan and applicable law.
//                                                 <div style={{ margin: '0.4rem 0', paddingLeft: '0.5rem', borderLeft: '2px solid var(--primary-light)' }}>
//                                                     • Employee contributes 1% → Company contributes 1%<br />
//                                                     • Employee contributes 2% → Company contributes 2%<br />
//                                                     • Employee contributes 5% → Company contributes 2% (maximum Company match)
//                                                 </div>
//                                                 Employee contributions above 2% are permitted (subject to the Plan), but will not receive additional Company matching contributions beyond the 2% maximum.<br />
//                                                 Company matching contributions are subject to the official Plan Document and may be modified, suspended, or terminated by the Company in accordance with applicable law and the Plan.
//                                             </div>
//                                         </div>

//                                         {/* Section 5 – Beneficiary Designation */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                                                 Section 5 – Beneficiary Designation
//                                             </label>

//                                             {/* Primary Beneficiary */}
//                                             <div style={{ marginBottom: '0.75rem', border: '1px solid var(--border-color)', padding: '0.75rem', borderRadius: 'var(--border-radius-sm)', backgroundColor: 'var(--bg-primary)' }}>
//                                                 <span style={{ fontSize: '0.75rem', fontWeight: 600, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>Primary Beneficiary</span>
//                                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Name:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.primaryBeneName}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBeneName: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Relationship:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.primaryBeneRelationship}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBeneRelationship: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Date of Birth:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.primaryBeneDob}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBeneDob: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Percentage:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.primaryBenePercent}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBenePercent: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             {/* Contingent Beneficiary */}
//                                             <div style={{ border: '1px solid var(--border-color)', padding: '0.75rem', borderRadius: 'var(--border-radius-sm)', backgroundColor: 'var(--bg-primary)' }}>
//                                                 <span style={{ fontSize: '0.75rem', fontWeight: 600, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>Contingent Beneficiary</span>
//                                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Name:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.contingentBeneName}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBeneName: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Relationship:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.contingentBeneRelationship}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBeneRelationship: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Date of Birth:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.contingentBeneDob}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBeneDob: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Percentage:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.contingentBenePercent}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBenePercent: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* Section 6 – Employee Acknowledgments */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                                                 Section 6 – Employee Acknowledgments
//                                             </label>
//                                             <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                                                 I acknowledge that:
//                                             </span>
//                                             <ol style={{ paddingLeft: '1.25rem', margin: 0, fontSize: '0.7rem', color: 'var(--text-secondary)', display: 'flex', flexDirection: 'column', gap: '0.35rem', lineHeight: 1.4 }}>
//                                                 <li>My eligibility for benefits is subject to the applicable benefit plan documents and Company policies.</li>
//                                                 <li>Insurance coverage becomes effective only after all eligibility requirements are satisfied and enrollment is approved.</li>
//                                                 <li>I authorize Genesis Tech Engineers Inc. to deduct any required employee premiums or retirement contributions from my pay check as permitted by law.</li>
//                                                 <li>I understand that the Company reserves the right to amend, modify, replace, or discontinue any employee benefit plan at any time, subject to applicable law.</li>
//                                                 <li>I understand that the Company's current 401(k) matching contribution is limited to a maximum of 2% of eligible compensation and that contributions above 2% are not matched by the Company.</li>
//                                                 <li>I certify that all information provided on this form is accurate and complete.</li>
//                                             </ol>
//                                         </div>
//                                     </div>
//                                 )}

//                                 {isAgreementSigned(activeAgreement?.title) ? (
//                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                                         <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1.25rem', borderRadius: 'var(--border-radius-sm)', fontSize: '0.85rem' }}>
//                                             🚀 <strong>Agreement Signed</strong>: You accepted and electronically signed this agreement on {getSignatureDate(activeAgreement?.title)}.
//                                         </div>
//                                         <button
//                                             type="button"
//                                             className="btn btn-primary"
//                                             style={{ width: '100%', padding: '0.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                                             onClick={() => handleDownloadPdf(activeBlobUrl, `${activeAgreement?.title.toLowerCase().replace(/\s+/g, '_')}_signed.pdf`)}
//                                         >
//                                             📥 Download Signed {activeAgreement?.displayName || activeAgreement?.title}
//                                         </button>
//                                     </div>
//                                 ) : (
//                                     !isLocked && <SignaturePad onSave={(sig) => handleDocumentSign(activeAgreement?.title, sig)} />
//                                 )}
//                             </div>

//                             <div>
//                                 {activeBlobUrl ? (
//                                     <div style={{ border: '2px solid #334155', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow-md)', backgroundColor: 'var(--bg-secondary)' }}>
//                                         <div className="mobile-helper-banner" style={{
//                                             padding: '0.75rem 1rem',
//                                             backgroundColor: 'var(--bg-tertiary)',
//                                             borderBottom: '1px solid var(--border-color)',
//                                             display: 'flex',
//                                             flexWrap: 'wrap',
//                                             alignItems: 'center',
//                                             justifyContent: 'space-between',
//                                             gap: '0.5rem'
//                                         }}>
//                                             <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
//                                                 📱 Reading on Mobile?
//                                             </span>
//                                             <div style={{ display: 'flex', gap: '0.5rem' }}>
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-secondary"
//                                                     style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
//                                                     onClick={() => handleViewPdf(activeBlobUrl, `${activeAgreement?.title.toLowerCase().replace(/\s+/g, '_')}.pdf`)}
//                                                 >
//                                                     📂 Open Fullscreen & Zoom
//                                                 </button>
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-primary"
//                                                     style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
//                                                     onClick={() => handleDownloadPdf(activeBlobUrl, `${activeAgreement?.title.toLowerCase().replace(/\s+/g, '_')}.pdf`)}
//                                                 >
//                                                     📥 Download PDF
//                                                 </button>
//                                             </div>
//                                         </div>
//                                         <iframe
//                                             src={`${activeBlobUrl}#toolbar=0&navpanes=0&view=FitH`}
//                                             className="document-iframe"
//                                             style={{ height: "750px" }}
//                                             title={`${activeAgreement?.displayName || activeAgreement?.title} PDF Viewer`}
//                                         />
//                                     </div>
//                                 ) : (
//                                     selectedAgreementKey !== 'employment_agreement' && selectedAgreementKey !== 'employee_agreement' ? (
//                                         <div className="document-text-preview" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '3rem' }}>
//                                             <span style={{ fontSize: '3rem', marginBottom: '1.25rem' }}>📄</span>
//                                             <h4 style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>{activeAgreement?.displayName || activeAgreement?.title}</h4>
//                                             <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', maxWidth: '320px' }}>
//                                                 This onboarding agreement is available. Please view or download the template PDF using the controls above.
//                                             </p>
//                                         </div>
//                                     ) : (
//                                         <div className="document-text-preview">

//                                             {/* PAGE 1 HEADER */}
//                                             <div style={{ textAlign: 'center', borderBottom: '2px solid #0f172a', paddingBottom: '1rem', marginBottom: '1.5rem' }}>
//                                                 <h2 style={{ fontSize: '1.3rem', fontWeight: 'bold', margin: '0 0 0.5rem 0' }}>GENESIS TECH ENGINEERS PVT. LTD.</h2>
//                                                 <p style={{ fontSize: '0.7rem', color: '#475569', margin: 0, lineHeight: 1.4 }}>
//                                                     REGISTERED ADDRESS : PLOT NO 5, GOKUL SOCIETY, DATTAWADI, SADASHIV PETH, PUNE CITY, PUNE - 411030. MH, INDIA.<br />
//                                                     GST #: 27AAKCG7985R1ZB | PAN # : AAKCG7985R | Contact: +91-8983260210<br />
//                                                     Website: www.genesistech.co.in | E-mail: contact@genesistech.co.in
//                                                 </p>
//                                             </div>

//                                             <h3 style={{ fontSize: '1rem', fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase', marginBottom: '1.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.5rem' }}>
//                                                 EMPLOYMENT AGREEMENT TERMS & CONDITIONS
//                                             </h3>

//                                             <p style={{ fontStyle: 'italic', marginBottom: '1.25rem' }}>
//                                                 This agreement lays down the terms of employment agreed upon by the employer and employee. Whether stated explicitly in the agreement or not, both the employee and the employer have the duty of mutual confidence and trust, and to make only lawful and reasonable demands on each other.
//                                             </p>

//                                             <p style={{ marginBottom: '1.5rem' }}>
//                                                 This EMPLOYMENT AGREEMENT (Hereinafter, the “Agreement”) is entered into on this {formatAgreementJoiningDate(employee?.joining_date || employee?.JoiningDate || employee?.joining_Date || employee?.joiningDate || employee?.joining || employee?.hire_date || employee?.HireDate || employmentForm?.hireDate)}
//                                             </p>

//                                             <p style={{ fontWeight: 'bold', textAlign: 'center', margin: '1rem 0' }}>BY AND BETWEEN</p>

//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 <strong>Genesis Tech Engineers Pvt. Ltd.</strong>, a private limited company incorporated under the Companies Act, 1956, having its registered office at Plot No 5, Shri Gokul Society, Navi Peth, Sadashiv Peth, Pune, 411030. (hereinafter referred to as the “Company” or “Employer”, which expression shall, unless repugnant to the meaning or context hereof, be deemed to include all permitted successors and assigns),
//                                             </p>

//                                             <p style={{ fontWeight: 'bold', textAlign: 'center', margin: '1rem 0' }}>AND</p>

//                                             <p style={{ marginBottom: '1.5rem' }}>
//                                                 <strong>{employee.FirstName} {employee.LastName}</strong> (hereinafter referred to as the "Employee", which expression shall, unless repugnant to the meaning or context hereof, be deemed to include all permitted successors and assigns).
//                                             </p>

//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 <strong>WHEREAS</strong>, the parties hereto desire to enter into this Agreement to define and set forth the terms and conditions of the employment of the Employee by the Company;
//                                             </p>

//                                             <p style={{ marginBottom: '1.5rem' }}>
//                                                 <strong>NOW, THEREFORE</strong>, in consideration of the mutual covenants and agreements set forth below, it is hereby covenanted and agreed by the Company and the Employee as follows:
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>1. Interpretation</h4>
//                                             <p style={{ marginBottom: '1rem' }}>In this agreement the following terms shall have the following meanings:</p>
//                                             <div style={{ marginLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//                                                 <p>
//                                                     <strong>a) “Confidential Information”</strong>: any trade secret or other information which is confidential or commercially sensitive and which is not in the public domain (other than through the wrongful disclosure by the Employee) and which belongs to any Clientele Company (whether stored or recorded in documentary or electronic form) and which (without limitation) relates to the business methods, management systems, marketing plans, strategic plans, finances, new or maturing business opportunities, marketing activities, processes, inventions, designs or similar of any Clientele Company, or to which any Clientele Company owes a duty of confidentiality to any third party and including in particular [Trade Secrets, Intellectual Property, Business Strategies & Plans, Customer and Supplier Information, Employee Information, Technological Information, Financial Information, Contracts and Agreements, Research and Development like experimental data and innovative concepts.];
//                                                 </p>
//                                                 <p>
//                                                     <strong>b) “The Employment”</strong>: the employment of the Employee by the Company in accordance with the terms of this agreement;
//                                                 </p>
//                                                 <p>
//                                                     <strong>c) “Clientele Company”</strong>: Clientele Company means the consumer or client of the Genesis Tech Engineers Pvt. Ltd.
//                                                 </p>
//                                                 <p>
//                                                     <strong>d) “Termination Date”</strong>: the date on which the Employment ceases.
//                                                 </p>
//                                             </div>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 1 of 7]
//                                             </div>

//                                             {/* PAGE 2 */}
//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>2. Pre-Employment Checks:</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 As part of our commitment to maintaining a professional and secure work environment, Genesis Tech Engineers Pvt Ltd conducts pre-employment checks on all prospective employees. These checks are designed to verify the accuracy of information provided during the hiring process and to ensure compliance with company policies and legal requirements. These may include all or any of the following:
//                                             </p>
//                                             <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                                 <li>
//                                                     <strong>Background Verification</strong>: This will include the verification of the identity (Adhar Card, PAN Card, Passport, Driving License, etc.), educational qualifications required for the role, professional certifications and the reference provided by the candidates if any.
//                                                 </li>
//                                                 <li>
//                                                     <strong>Criminal Conviction Check</strong>: Candidate is required to provide character certificate obtained by the nearest police station where the candidate resides.
//                                                 </li>
//                                                 <li>
//                                                     <strong>Health Declaration or Health Assessment</strong>: Candidate is required to obtain basic full body checkup and candidate is required to submit the reports to at the time of joining the company.
//                                                 </li>
//                                                 <li>
//                                                     <strong>Employment History</strong>: Proof of employment history via relieving letter provided by your previous employers if any.
//                                                 </li>
//                                             </ul>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>3. Freedom to work:</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 As an employee of Genesis Tech Engineers Pvt. Ltd., you are expected to uphold the values and standards of our organization. If at any time during your employment, it is discovered that you are under any court order, contractual agreement, or other legal obligation that may interfere with or inhibit your ability to perform your duties or fulfill your obligations to the company, Genesis Tech Engineers Pvt. Ltd. reserves the right to immediately terminate your employment without further notice or liability.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>4. Term and Bond Period</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> In consideration of the opportunities provided by Genesis Tech Engineers Pvt. Ltd., the employee agrees to a binding commitment to remain in the employment of the company for a period of 2 years from the date of commencement.
//                                             </p>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 2 of 7]
//                                             </div>

//                                             {/* PAGE 3 */}
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> During this period, the employee acknowledges and agrees that they shall not voluntarily terminate their employment or engage in employment with any other entity without explicit prior consent from Genesis Tech Engineers Pvt. Ltd. Any attempt to do so shall be considered a breach of this agreement.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>c.</strong> This commitment is made with the understanding that specialized training, valuable experience, and confidential information will be provided by the company during this period. In the event of a breach, the employee shall be liable for any damage incurred by the company due to their premature departure. Failure to complete the bond duration will result in compensating the amount equal to the remaining duration of the bond period back to the employer.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>d.</strong> This clause is binding and enforceable under the applicable laws governing employment agreements.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>5. Performance of Duties</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> The Employee agrees that during the Employment Period, he/she shall devote his/her full business time to the business affairs of the Company and shall perform the duties assigned to him/her faithfully and efficiently, and shall endeavor, to the best of his/her abilities to achieve the goals and adhere to the parameters set by the Company.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> The Employee shall be responsible for:
//                                             </p>
//                                             <ul style={{ marginLeft: '2.5rem', marginBottom: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                                 <li>You must devote the whole time and attention and abilities to the business of Genesis Tech Engineers unless prevented by illness.</li>
//                                                 <li>Diligently perform such duties as may from time to time be assigned to you.</li>
//                                                 <li>Comply with all reasonable and lawful directions given to you by Genesis Tech Engineers and your managers.</li>
//                                                 <li>Act in good faith and in the best interest of Genesis Tech Engineers and its customers and staff always, including reporting your own wrongdoing and any wrongdoing of any other employee immediately on becoming aware of it.</li>
//                                                 <li>Promote, Protect, Develop, and extend the business of Genesis Tech Engineers.</li>
//                                                 <li>Take all reasonable steps in respect of the help and safety of yourself, colleagues and third party.</li>
//                                             </ul>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 A failure to maintain a professional and responsible standard of conduct / behavior, attendance and performance may result in disciplinary action taken against you under the appropriate employment guidelines.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>6. Compensation</h4>
//                                             <p style={{ marginBottom: '1rem' }}>Subject to the following provisions of this Agreement, during the Employment Period, the Employee shall be compensated for his services as follows:</p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> The Employee shall receive an annual salary, payable monthly by the Employer. Subject to such increases from time to time, as determined by the Employer. Such payments shall be subject to such normal statutory deductions by the Employer.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> During the term of this Agreement, the Employee's salary shall be paid by means of bank transfer, cheque, or any other method convenient to the Employer, and consented to by the Employee.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>c.</strong> All reasonable expenses arising out of employment shall be reimbursed assuming that the same have been authorized prior to being incurred and with the provision of appropriate receipts.
//                                             </p>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 3 of 7]
//                                             </div>

//                                             {/* PAGE 4 */}
//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>7. Obligations of the Employee</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> Upon execution of agreement, the Employee shall not engage in any sort of theft, fraud, misrepresentation, or any other illegal act neither in the employment space nor outside the premise of employment. If he/she shall do so, the Company shall not be liable for such an act done at his/her own risk.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> The Employee further promises to never engage in any theft of the Employer’s property or attempt to defraud the Employer in any manner.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>c.</strong> The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations and policies of the Company as notified from time to time.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>d.</strong> The Employee shall not take up part-time or full-time employment or consultation with any other party or be involved in any other business during the term of his/her employment with the Company.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>e.</strong> On termination employee shall immediately return to employer all documents, books, material, records, correspondence, papers and information (on whatever media and wherever located) relating to employer business or affairs or relating to employer business contacts, any keys, credit cards, access cards and any other property of employer, which is in your possession or under employee’s control.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>f.</strong> The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations and policies of the Company as notified from time to time, including but not limited to Leave Policy and Sexual Harassment Policy.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>g.</strong> The Employer hereby prohibits the Employee from engaging in any sexual harassment and the Employee promises to refrain from any form of sexual harassment during employment in and around the premise of employment. If the Employee violates this term in the agreement, he/she shall be fully responsible for his/her actions and the Employer shall not be held responsible for any illegal acts committed at the discretion of the Employee.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>8. Leave Policy</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> The employee is not entitled to any leave during the probation period with an exception to unforeseen conditions/condition out of control. Refer to the employee internal portal GTELinq for guidelines on leaves during probation period.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> The Employee is entitled to 12 days of paid sick leave (SL) in a year, 11 days of earned leave (EL). In addition, the Employee will be entitled to 10 public holidays mentioned under the Leave Policy of the Employer.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>c.</strong> The leaves earned can be carried forward to a maximum of 45 days over the service period.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>d.</strong> Other than the earned leave the Employee may not carry forward or en-cash any holiday to the next holiday year.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>e.</strong> In the event that the Employee is absent from work due to sickness or injury, he/she will follow the Leave Policy and inform the designated person as soon as possible and will provide regular updates as to his/her recovery and as far as practicable will inform the designated person of the Employer of his/her expected date of return to work.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>f.</strong> If the Employee is absent from work due to sickness or injury for more than three consecutive days, he/she must submit to the Employer a self-certification form. If such absence lasts for more than three consecutive days the Employee must obtain a medical certificate from his/her doctor and submit it to the employer.
//                                             </p>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 4 of 7]
//                                             </div>

//                                             {/* PAGE 5 */}
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>g.</strong> For any period of absence due to sickness or injury the Employee will be paid statutory sick pay only, if he/she satisfies the relevant requirements.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>9. Assignment</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> The Employee acknowledges that any work including without limitation inventions, designs, ideas, concepts, drawings, working notes, artistic works that the Employee may individually or jointly conceive or develop during the term of Employment are “works made for hire” and to the fullest extent permitted by law, Employee shall assign, and does hereby assign, to the Employer all of Employee's right, title and interest in and to all Intellectual Property improved, developed, discovered or written in such works.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>b.</strong> Employee shall, upon request of the Employer, execute, acknowledge, deliver, and file any and all documents necessary or useful to vest in the Employer all of Employee's right, title and interest in and to all such matters.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>10. Confidentiality</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> The Employee acknowledges that, while performing and fulfilling his/her duties here under, he/she may have access to and be entrusted with confidential information concerning the present and contemplated financial status and activities of the Employer, the disclosure of any of which confidential information to the competitors of the Employer would be highly detrimental to the interests of the Employer.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> The Employee further acknowledges and agrees that the right to maintain the confidentiality of trade secrets, source code, website information, business plans or client information or other confidential or proprietary information, for the purpose of enabling the other party such information constitutes a proprietary right which the Employer is entitled to protect.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>c.</strong> Accordingly, the Employee covenants and agrees with the Employer that he/she will not, under any circumstance during the continuance of this agreement, disclose any such confidential information to any person, firm or corporation, nor shall he/she use the same, except as required in the normal course of his/her engagement hereunder, and even after the termination of employment, he/she shall not disclose or make use of the same or cause any of confidential information to be disclosed in any manner.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>d.</strong> The Employer owns any intellectual property created by the Employee during employment, or in relation to a certain field, and he/she shall thereon have all the necessary rights to retain it. After termination of employment, Employee shall not impose any rights on the intellectual property created. Any source code, software or other intellectual property developed, including but not limited to website design or functionality that was created by the employee, during employment under this Agreement, shall belong to the Employer.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>11. Amendment and Termination</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> Employer may terminate your employment without any notice.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> The Employee may terminate his/her employment by providing the Employer with at least 2-month(s) advance notice of his/her intention to resign.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>c.</strong> The Employee may terminate on the last day of the month in which the date of the Employee’s death occurs; or the date on which the Company gives notice to the Employee if such termination is for Cause or Disability.
//                                             </p>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 5 of 7]
//                                             </div>

//                                             {/* PAGE 6 */}
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>d.</strong> For purposes of this Agreement, "Cause" means the Employee's gross misconduct resulting in material damage to the Company, willful insubordination or disobedience, theft, fraud or dishonesty, willful damage or loss of Employer’s property, bribery and habitual lateness or absence, or any other willful and material breach of this Agreement.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>12. Restrictive Covenant</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 Following the termination of employment of the Employee by the Employer, with or without cause, or the voluntary withdrawal by the Employee from the Employer, the Employee shall, for a period of three years following the said termination or voluntary withdrawal, refrain from either directly or indirectly soliciting or attempting to solicit the business of any client or customer of the Employer for his own benefit or that of any third person or organization, and shall refrain from either directly or indirectly attempting to obtain the withdrawal from the employment by the Employer of any other Employee of the Employer having regard to the same geographic and temporal restrictions. The Employee shall not directly or indirectly divulge any financial information relating to the Employer or any of its affiliates or clients to any person whatsoever.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>13. Indemnification</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 The Employee shall indemnify the employer against any and all expenses, including amounts paid upon judgments, counsel fees, environmental penalties and fines, and amounts paid in settlement (before or after suit is commenced), incurred by the employer in connection with his/her defense or settlement of any claim, action, suit or proceeding in which he/she is made a party or which may be asserted against his/her by reason of his/her employment or the performance of duties in this Agreement. Such indemnification shall be in addition to any other rights to which those indemnified may be entitled under any law, by-law, agreement, or otherwise.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>14. Modification</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 Any modification of this Agreement or additional obligation assumed by either party in connection with this Agreement shall be binding only if evidenced in writing signed by each party or an authorized representative of each party.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>15. Severability</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 Each paragraph of this agreement shall be and remain separate from and independent of and severable from all and any other paragraphs herein except where otherwise indicated by the context of the agreement. The decision or declaration that one or more of the paragraphs are null and void shall have no effect on the remaining paragraphs of this agreement.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>16. Paragraph headings</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 The titles to the paragraphs of this Agreement are solely for the convenience of the parties and shall not be used to explain, modify, simplify, or aid in the interpretation of the provisions of this Agreement.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>17. Applicable Law and Jurisdiction</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 This Agreement shall be governed by and construed in accordance with the laws of India. Each party hereby irrevocably submits to the exclusive jurisdiction of the courts of Pune. For the adjudication of any dispute hereunder or in connection herewith.
//                                             </p>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 6 of 7]
//                                             </div>

//                                             {/* PAGE 7 */}
//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>18. Counterparts</h4>
//                                             <p style={{ marginBottom: '1.5rem' }}>
//                                                 The Agreement may be executed in two or more counterparts, any one of which shall be deemed the original without reference to the others.
//                                             </p>

//                                             <p style={{ marginBottom: '1.5rem' }}>
//                                                 <strong>IN WITNESS WHEREOF</strong>, the Employee has hereunto set his hand, and the Company has caused these presents to be executed in its name and on its behalf, all as of the day and year first above written.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>Acceptance</h4>
//                                             <p style={{ marginBottom: '2rem' }}>
//                                                 I have carefully read and accepted all the provisions of this Employment agreement terms and conditions of employment.
//                                             </p>

//                                             <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', borderTop: '1px dashed #cbd5e1', paddingTop: '1.5rem' }}>
//                                                 <p><strong>Employee Sign:</strong> ___________________________</p>
//                                                 <p><strong>Employee Name:</strong> {employee.FirstName} {employee.LastName}</p>
//                                                 <p><strong>Date:</strong> {formatJoiningDateShort(employee?.joining_date || employee?.JoiningDate || employee?.joining_Date || employee?.joiningDate || employee?.joining || employee?.hire_date || employee?.HireDate || employmentForm?.hireDate)}</p>
//                                             </div>

//                                             <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                                 <p><strong>For: Genesis Tech Engineers Pvt. Ltd.</strong></p>
//                                                 <div style={{ fontSize: '1rem', fontStyle: 'italic', color: 'var(--primary)', margin: '0.25rem 0' }}>Neeta</div>
//                                                 <p><strong>Name:</strong> NEETA SHRIKANT SANGVIKAR</p>
//                                                 <p><strong>Designation:</strong> DIRECTOR HR</p>
//                                                 <p><strong>Date:</strong> {formatJoiningDateShort(employee?.joining_date || employee?.JoiningDate || employee?.joining_Date || employee?.joiningDate || employee?.joining || employee?.hire_date || employee?.HireDate || employmentForm?.hireDate)}</p>
//                                             </div>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0 0 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 7 of 7]
//                                             </div>

//                                         </div>
//                                     ))}
//                             </div>
//                         </div>
//                     </div>
//                 );
//             })()}

//             {/* COMPANY POLICIES TAB */}
//             {activeTab === 'policies' && (() => {
//                 const allPoliciesAccepted = genesisPolicies.every(policy => data?.policies?.some(p => p.policy_name === policy.title));
//                 const activePolicy = genesisPolicies.find(p => p.id === selectedPolicyId);

//                 // Handle selecting a policy
//                 const handleSelect = (id) => {
//                     setSelectedPolicyId(id);
//                     if (id !== 'sign' && !viewedPolicyIds.includes(id)) {
//                         setViewedPolicyIds(prev => [...prev, id]);
//                     }
//                 };

//                 const sidebarItems = [
//                     ...genesisPolicies,
//                     { id: 'sign', title: 'Acceptance & Sign-off', icon: '✍️' }
//                 ];

//                 return (
//                     <div className="card fade-in">
//                         <div className="card-title" style={{ marginBottom: '1.5rem' }}>Company Policies Review</div>

//                         <div className="policies-layout">
//                             {/* Left Column: Sidebar List */}
//                             <div className="policies-sidebar">
//                                 {sidebarItems.map((item) => {
//                                     const isSelected = selectedPolicyId === item.id;
//                                     const isSignTab = item.id === 'sign';
//                                     const isChecked = isSignTab
//                                         ? allPoliciesAccepted
//                                         : (viewedPolicyIds.includes(item.id) || allPoliciesAccepted);

//                                     return (
//                                         <div
//                                             key={item.id}
//                                             onClick={() => handleSelect(item.id)}
//                                             style={{
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'space-between',
//                                                 padding: '0.85rem 1rem',
//                                                 borderRadius: '8px',
//                                                 border: '1px solid var(--border-color)',
//                                                 backgroundColor: isSelected ? '#0f172a' : 'var(--bg-secondary)',
//                                                 color: isSelected ? '#ffffff' : 'var(--text-primary)',
//                                                 cursor: 'pointer',
//                                                 transition: 'all 0.2s ease',
//                                                 boxShadow: isSelected ? 'var(--shadow-sm)' : 'none'
//                                             }}
//                                             className={isSelected ? '' : 'policy-sidebar-item-hover'}
//                                         >
//                                             <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
//                                                 <span style={{ fontSize: '1.2rem' }}>{item.icon}</span>
//                                                 <span style={{ fontSize: '0.85rem', fontWeight: isSelected ? '600' : '500' }}>{item.title}</span>
//                                             </div>

//                                             {/* Checkbox badge */}
//                                             <span style={{
//                                                 display: 'inline-flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                                 width: '18px',
//                                                 height: '18px',
//                                                 borderRadius: '4px',
//                                                 backgroundColor: isChecked ? '#10b981' : '#e2e8f0',
//                                                 color: '#ffffff',
//                                                 fontSize: '10px',
//                                                 fontWeight: 'bold',
//                                                 transition: 'background-color 0.2s'
//                                             }}>
//                                                 {isChecked ? '✓' : ''}
//                                             </span>
//                                         </div>
//                                     );
//                                 })}
//                             </div>

//                             {/* Right Column: Description Panel */}
//                             <div className="policies-content">
//                                 {selectedPolicyId === 'sign' ? (
//                                     <div>
//                                         <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.5rem', color: 'var(--text-primary)' }}>Acceptance & Sign-off</h3>
//                                         <div style={{ borderBottom: '1px solid var(--border-color)', marginBottom: '1.5rem' }}></div>

//                                         <p style={{ fontSize: '0.9rem', color: 'var(--text-primary)', marginBottom: '1rem', lineHeight: '1.5' }}>
//                                             By drawing or typing your signature below, you certify and confirm that you have read, understood, and agree to abide by all 11 company policies listed on the left:
//                                         </p>

//                                         <ul style={{ paddingLeft: '1.5rem', fontSize: '0.85rem', color: 'var(--text-secondary)', lineHeight: '1.6', marginBottom: '2rem' }}>
//                                             {genesisPolicies.map(p => (
//                                                 <li key={p.id}>{p.title}</li>
//                                             ))}
//                                         </ul>

//                                         {allPoliciesAccepted ? (
//                                             <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                                                 <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1.25rem', borderRadius: 'var(--border-radius-sm)', fontSize: '0.85rem' }}>
//                                                     🚀 <strong>Policies Signed & Accepted</strong>: You have read and accepted all company policies. A signed PDF copy has been saved.
//                                                 </div>
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-primary"
//                                                     style={{ width: '100%', padding: '0.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                                                     onClick={handleDownloadPolicies}
//                                                 >
//                                                     📥 Download Signed Policies
//                                                 </button>
//                                             </div>
//                                         ) : (
//                                             !isLocked && (
//                                                 <div>
//                                                     {viewedPolicyIds.length < genesisPolicies.length ? (
//                                                         <div style={{ backgroundColor: 'var(--bg-tertiary)', borderLeft: '4px solid var(--warning)', padding: '1rem', borderRadius: '4px', fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
//                                                             ⚠️ <strong>Please read all policies</strong>: You must click and review all 11 policies on the left before you can sign. (Currently reviewed: {viewedPolicyIds.length}/11)
//                                                         </div>
//                                                     ) : (
//                                                         <div>
//                                                             <div style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginBottom: '0.75rem' }}>
//                                                                 Please draw or type your electronic signature below:
//                                                             </div>
//                                                             <SignaturePad onSave={handlePolicyAccept} />
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             )
//                                         )}
//                                     </div>
//                                 ) : (
//                                     activePolicy && (
//                                         <div>
//                                             <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.5rem', color: 'var(--text-primary)' }}>{activePolicy.title}</h3>
//                                             <div style={{ borderBottom: '1px solid var(--border-color)', marginBottom: '1.5rem' }}></div>
//                                             <div style={{ color: 'var(--text-primary)', fontSize: '0.9rem', lineHeight: '1.6' }}>
//                                                 {activePolicy.content}
//                                             </div>
//                                         </div>
//                                     )
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 );
//             })()}

//             {/* TAX INFORMATION TAB */}
//             {activeTab === 'tax' && (
//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '1.5rem', alignItems: 'start' }} className="fade-in">
//                     {/* LEFT SIDE: INPUTS & ACTIONS */}
//                     <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
//                         <div className="card-title">Arizona A-4 Tax Withholdings</div>

//                         <form onSubmit={(e) => e.preventDefault()} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                             <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 0: Federal & General State Elections</h4>
//                             <div className="grid-2">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="fedTaxSelect">Federal Tax Filing Status</label>
//                                     <select id="fedTaxSelect" className="form-control" value={taxForm.federal_tax_status} onChange={(e) => setTaxForm({ ...taxForm, federal_tax_status: e.target.value })} disabled={isLocked}>
//                                         <option value="SINGLE">Single or Married Filing Separately</option>
//                                         <option value="MARRIED">Married Filing Jointly</option>
//                                         <option value="HEAD_OF_HOUSEHOLD">Head of Household</option>
//                                     </select>
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="fedAllowancesInput">Federal Allowances / Dependents</label>
//                                     <input type="number" id="fedAllowancesInput" className="form-control" value={taxForm.federal_allowances} onChange={(e) => setTaxForm({ ...taxForm, federal_allowances: parseInt(e.target.value) || 0 })} min={0} disabled={isLocked} />
//                                 </div>
//                             </div>

//                             <div className="grid-2">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="stateTaxSelect">State Filing Status (General)</label>
//                                     <select id="stateTaxSelect" className="form-control" value={taxForm.state_tax_status} onChange={(e) => setTaxForm({ ...taxForm, state_tax_status: e.target.value })} disabled={isLocked}>
//                                         <option value="SINGLE">Single</option>
//                                         <option value="MARRIED">Married</option>
//                                         <option value="EXEMPT">Exempt</option>
//                                     </select>
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="stateAllowancesInput">State Allowances (General)</label>
//                                     <input type="number" id="stateAllowancesInput" className="form-control" value={taxForm.state_allowances} onChange={(e) => setTaxForm({ ...taxForm, state_allowances: parseInt(e.target.value) || 0 })} min={0} disabled={isLocked} />
//                                 </div>
//                             </div>

//                             <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

//                             <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 1: Arizona Form A-4 Personal Information</h4>

//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="taxName">Full Name</label>
//                                 <input
//                                     type="text"
//                                     id="taxName"
//                                     className="form-control"
//                                     value={taxForm.name}
//                                     onChange={(e) => setTaxForm({ ...taxForm, name: e.target.value })}
//                                     disabled={isLocked}
//                                 />
//                             </div>

//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="taxSSN">Social Security Number</label>
//                                 <input
//                                     type="text"
//                                     id="taxSSN"
//                                     className="form-control"
//                                     value={taxForm.ssn}
//                                     onChange={(e) => setTaxForm({ ...taxForm, ssn: e.target.value })}
//                                     disabled={isLocked}
//                                 />
//                             </div>

//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="taxAddress">Home Address</label>
//                                 <input
//                                     type="text"
//                                     id="taxAddress"
//                                     className="form-control"
//                                     value={taxForm.address}
//                                     onChange={(e) => setTaxForm({ ...taxForm, address: e.target.value })}
//                                     disabled={isLocked}
//                                 />
//                             </div>

//                             <div className="grid-2">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="taxCity">City or Town</label>
//                                     <input
//                                         type="text"
//                                         id="taxCity"
//                                         className="form-control"
//                                         value={taxForm.city}
//                                         onChange={(e) => setTaxForm({ ...taxForm, city: e.target.value })}
//                                         disabled={isLocked}
//                                     />
//                                 </div>
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '0.5rem' }}>
//                                     <div className="form-group">
//                                         <label className="form-label" htmlFor="taxState">State</label>
//                                         <input
//                                             type="text"
//                                             id="taxState"
//                                             className="form-control"
//                                             value={taxForm.state}
//                                             onChange={(e) => setTaxForm({ ...taxForm, state: e.target.value })}
//                                             maxLength={2}
//                                             disabled={isLocked}
//                                         />
//                                     </div>
//                                     <div className="form-group">
//                                         <label className="form-label" htmlFor="taxZip">ZIP Code</label>
//                                         <input
//                                             type="text"
//                                             id="taxZip"
//                                             className="form-control"
//                                             value={taxForm.zip}
//                                             onChange={(e) => setTaxForm({ ...taxForm, zip: e.target.value })}
//                                             disabled={isLocked}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

//                             <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 2: Withholding Election</h4>

//                             <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                 <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem', cursor: 'pointer' }} onClick={() => !isLocked && setTaxForm({ ...taxForm, arizona_box_selection: 1 })}>
//                                     <input
//                                         type="radio"
//                                         id="box1"
//                                         name="arizona_box_selection"
//                                         checked={taxForm.arizona_box_selection === 1}
//                                         onChange={() => { }}
//                                         disabled={isLocked}
//                                         style={{ marginTop: '0.25rem' }}
//                                     />
//                                     <label htmlFor="box1" style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer' }}>
//                                         <strong>Box 1</strong>: Withhold from gross taxable wages at the percentage checked below (check only one percentage):
//                                     </label>
//                                 </div>

//                                 {taxForm.arizona_box_selection === 1 && (
//                                     <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem', paddingLeft: '1.5rem', marginTop: '0.25rem' }}>
//                                         {[0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5].map((pct) => (
//                                             <label key={pct} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.8rem', cursor: 'pointer' }}>
//                                                 <input
//                                                     type="radio"
//                                                     name="arizona_percentage"
//                                                     checked={taxForm.arizona_percentage === pct}
//                                                     onChange={() => !isLocked && setTaxForm({ ...taxForm, arizona_percentage: pct })}
//                                                     disabled={isLocked}
//                                                 />
//                                                 {pct}%
//                                             </label>
//                                         ))}
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                 <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem', cursor: 'pointer' }} onClick={() => !isLocked && setTaxForm({ ...taxForm, arizona_box_selection: 2 })}>
//                                     <input
//                                         type="radio"
//                                         id="box2"
//                                         name="arizona_box_selection"
//                                         checked={taxForm.arizona_box_selection === 2}
//                                         onChange={() => { }}
//                                         disabled={isLocked}
//                                         style={{ marginTop: '0.25rem' }}
//                                     />
//                                     <label htmlFor="box2" style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer' }}>
//                                         <strong>Box 2</strong>: I elect an Arizona withholding percentage of zero, and I certify that I expect to have no Arizona tax liability for the current taxable year.
//                                     </label>
//                                 </div>
//                             </div>

//                             <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

//                             <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 3: Additional Withholding</h4>

//                             <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                 <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem', cursor: 'pointer' }} onClick={() => !isLocked && setTaxForm({ ...taxForm, arizona_extra_amount_checked: !taxForm.arizona_extra_amount_checked })}>
//                                     <input
//                                         type="checkbox"
//                                         id="chkExtraWH"
//                                         checked={taxForm.arizona_extra_amount_checked}
//                                         onChange={() => { }}
//                                         disabled={isLocked}
//                                         style={{ marginTop: '0.25rem' }}
//                                     />
//                                     <label htmlFor="chkExtraWH" style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer' }}>
//                                         Check this box and enter an extra amount to be withheld from each paycheck
//                                     </label>
//                                 </div>

//                                 {taxForm.arizona_extra_amount_checked && (
//                                     <div className="form-group" style={{ paddingLeft: '1.5rem', marginTop: '0.25rem' }}>
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                                             <span style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>$</span>
//                                             <input
//                                                 type="number"
//                                                 className="form-control"
//                                                 placeholder="0.00"
//                                                 value={taxForm.arizona_extra_amount}
//                                                 onChange={(e) => setTaxForm({ ...taxForm, arizona_extra_amount: e.target.value })}
//                                                 min={0}
//                                                 step="0.01"
//                                                 disabled={isLocked}
//                                             />
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </form>

//                         <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

//                         {/* Signature Area */}
//                         {data?.tax?.signed_at ? (
//                             <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1rem', borderRadius: '4px', fontSize: '0.85rem' }}>
//                                 ✓ <strong>Arizona Form A-4 Electronically Signed</strong>: Signed on {new Date(data.tax.signed_at).toLocaleString()} from IP {data.tax.ip_address}.
//                             </div>
//                         ) : (
//                             !isLocked && (
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//                                     <SignaturePad onSave={handleApplySignature} onChange={handleApplySignature} />
//                                 </div>
//                             )
//                         )}

//                         {/* Actions Panel */}
//                         <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
//                             {pdfPreviewUrl && (
//                                 <button
//                                     type="button"
//                                     className="btn btn-secondary"
//                                     onClick={downloadPdf}
//                                     style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                                 >
//                                     📥 Download Form
//                                 </button>
//                             )}
//                             {!isLocked && !data?.tax?.signed_at && (
//                                 <button
//                                     type="button"
//                                     className="btn btn-primary"
//                                     onClick={handleSaveTaxSubmit}
//                                     style={{ flex: 1 }}
//                                     disabled={!taxForm.signature}
//                                 >
//                                     ✍️ Save & Sign
//                                 </button>
//                             )}
//                         </div>
//                     </div>

//                     {/* RIGHT SIDE: PDF PREVIEW */}
//                     <div className="card" style={{ height: 'calc(100vh - 180px)', minHeight: '600px', display: 'flex', flexDirection: 'column', padding: '0.75rem' }}>
//                         <div className="card-title" style={{ padding: '0.5rem 0.5rem 1rem 0.5rem', margin: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                             <span>Live Form Preview</span>
//                             <span style={{ fontSize: '0.75rem', fontWeight: 'normal', color: 'var(--text-tertiary)' }}>Updates automatically as you type</span>
//                         </div>

//                         <div style={{ flex: 1, backgroundColor: 'var(--bg-tertiary)', borderRadius: 'var(--border-radius-sm)', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
//                             {pdfPreviewUrl ? (
//                                 <iframe
//                                     src={`${pdfPreviewUrl}#toolbar=0&navpanes=0`}
//                                     title="Arizona A-4 Preview"
//                                     width="100%"
//                                     height="100%"
//                                     style={{ border: 'none', display: 'block' }}
//                                 />
//                             ) : (
//                                 <div style={{ textAlign: 'center', padding: '2rem' }}>
//                                     <Loader message="Loading Arizona A-4 Form template..." size="md" />
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* BANK DETAILS TAB */}
//             {activeTab === 'bank' && (
//                 <div className="card fade-in">
//                     <div className="card-title">Direct Deposit Bank Details</div>

//                     {/* Top Information Fields */}
//                     <div style={{ marginBottom: '1.5rem' }}>
//                         <div className="grid-2">
//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="bankNameSelect">Bank Name</label>
//                                 <input type="text" id="bankNameSelect" className="form-control" value={bankForm.bank_name} onChange={(e) => setBankForm({ ...bankForm, bank_name: e.target.value })} required disabled={isLocked} />
//                             </div>
//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="routingNumberInput">Routing Number / IFSC Code</label>
//                                 <input type="text" id="routingNumberInput" className="form-control" maxLength={20} value={bankForm.routing_number} onChange={(e) => setBankForm({ ...bankForm, routing_number: e.target.value })} required disabled={isLocked} />
//                             </div>
//                         </div>
//                         <div className="grid-2">
//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="accountNumberInput">Account Number</label>
//                                 <input type="text" id="accountNumberInput" className="form-control" value={bankForm.account_number} onChange={(e) => setBankForm({ ...bankForm, account_number: e.target.value })} required disabled={isLocked} />
//                             </div>
//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="accountTypeSelect">Account Type</label>
//                                 <select
//                                     id="accountTypeSelect"
//                                     className="form-control"
//                                     value={((employee?.country || data?.employee?.country || personalForm?.country || '').toUpperCase()) === 'INDIA' && bankForm.account_type === 'CHECKING' ? 'SAVINGS' : bankForm.account_type}
//                                     onChange={(e) => setBankForm({ ...bankForm, account_type: e.target.value })}
//                                     disabled={isLocked}
//                                 >
//                                     {((employee?.country || data?.employee?.country || personalForm?.country || '').toUpperCase()) === 'INDIA' ? (
//                                         <>
//                                             <option value="SAVINGS">Savings</option>
//                                             <option value="CURRENT">Current</option>
//                                         </>
//                                     ) : (
//                                         <>
//                                             <option value="CHECKING">Checking</option>
//                                             <option value="SAVINGS">Savings</option>
//                                         </>
//                                     )}
//                                 </select>
//                             </div>
//                         </div>
//                         <div className="form-group">
//                             <label className="form-label" htmlFor="bankBranchAddressInput">Bank Branch Address</label>
//                             <input type="text" id="bankBranchAddressInput" className="form-control" value={bankForm.bank_branch_address} onChange={(e) => setBankForm({ ...bankForm, bank_branch_address: e.target.value })} required disabled={isLocked} />
//                         </div>
//                     </div>

//                     {/* Upload Cancelled Cheque / Bank Proof Section */}
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1.5rem', marginBottom: '1.5rem' }}>
//                         <h4 style={{ fontSize: '0.9rem', marginBottom: '0.25rem', fontWeight: 'bold', color: 'var(--text-primary)' }}>
//                             Upload Cancelled Cheque / Bank Account Proof <span style={{ color: 'var(--danger)', marginLeft: '4px' }}>*</span>
//                         </h4>
//                         <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '0.75rem' }}>
//                             Attach one of the following: Last month Statement, voided check with A/C number stated
//                         </p>
//                         <UploadField documentType="Void Cheque" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                     </div>

//                     {/* Single Save Details Button at the Bottom */}
//                     {!isLocked && (
//                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1.25rem' }}>
//                             <button type="button" onClick={handleSaveBank} className="btn btn-primary" style={{ padding: '0.65rem 1.5rem', fontWeight: 600 }}>
//                                 Save Bank Details
//                             </button>
//                         </div>
//                     )}
//                 </div>
//             )}

//             {/* PROFILE PHOTO TAB */}
//             {activeTab === 'photo' && (
//                 <div className="card fade-in">
//                     <div className="card-title">Badge Profile Photo</div>
//                     <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
//                         Upload a high-quality professional Photo.
//                     </p>

//                     <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap', position: 'relative' }}>
//                         <div
//                             style={{
//                                 width: '150px',
//                                 height: '150px',
//                                 borderRadius: '50%',
//                                 border: '3px solid var(--border-color)',
//                                 background: badgePhotoPath ? `url(/EOP_api/${badgePhotoPath}) center/cover no-repeat` : 'var(--bg-tertiary)',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 color: 'var(--text-tertiary)',
//                                 fontSize: '0.85rem',
//                                 position: 'relative',
//                                 overflow: 'hidden'
//                             }}
//                         >
//                             {!badgePhotoPath && 'No Picture'}
//                         </div>

//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', flex: '1 1 300px' }}>
//                             {badgePhotoPath ? (
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//                                     <p style={{ fontSize: '0.825rem', color: 'var(--text-secondary)', margin: 0 }}>
//                                         Profile photo is uploaded. To upload a different photo, please delete the current photo first.
//                                     </p>
//                                     <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
//                                         <a
//                                             href={`/EOP_api/${badgePhotoPath}`}
//                                             target="_blank"
//                                             rel="noreferrer"
//                                             className="btn btn-secondary"
//                                             style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', fontWeight: 600 }}
//                                         >
//                                             👁️ View Photo
//                                         </a>
//                                         {!isLocked && (
//                                             <button
//                                                 type="button"
//                                                 className="btn btn-danger"
//                                                 style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', fontWeight: 600 }}
//                                                 onClick={handleDeletePhoto}
//                                                 disabled={uploadingPhoto}
//                                             >
//                                                 🗑️ Delete Photo
//                                             </button>
//                                         )}
//                                     </div>
//                                 </div>
//                             ) : (
//                                 !isLocked && (
//                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                         <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-primary)' }}>
//                                             Upload Profile Photo:
//                                         </label>
//                                         <input type="file" className="form-control" accept="image/*" onChange={handlePhotoUpload} disabled={uploadingPhoto} />
//                                         <p style={{ color: 'var(--text-tertiary)', fontSize: '0.7rem', margin: 0 }}>JPG, PNG, WEBP (Max 1MB limit)</p>
//                                     </div>
//                                 )
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* REVIEW & SUBMIT TAB */}
//             {activeTab === 'submit' && (
//                 <div className="card fade-in">
//                     <div className="card-title">Review & Submit Onboarding Profile</div>
//                     <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
//                         Before submitting, verify that all sections are complete. Submitting locks your profile and moves it to **Pending HR Review** status.
//                     </p>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '2rem' }}>
//                         {effectiveDashboardStats?.checklist && Object.entries(effectiveDashboardStats.checklist).map(([key, complete]) => {
//                             const label = key.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase());
//                             return (
//                                 <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.5rem 1rem', border: '1px solid var(--border-color)', borderRadius: '4px' }}>
//                                     <span>{label}</span>
//                                     <strong style={{ color: complete ? 'var(--success)' : 'var(--danger)' }}>
//                                         {complete ? '✓ Ready' : '✗ Required'}
//                                     </strong>
//                                 </div>
//                             );
//                         })}
//                     </div>

//                     {(() => {
//                         const reqDocsList = data?.requested_documents || data?.requested_employee_documents || [];
//                         const pendingOrUploadedReqs = reqDocsList.filter(r => {
//                             const s = (r.status || '').toUpperCase();
//                             return s !== 'SUBMITTED' && s !== 'COMPLETED' && s !== 'APPROVED';
//                         });

//                         if (isLocked && (pendingOrUploadedReqs.length === 0 || requestedDocsSubmitted)) {
//                             return (
//                                 <div style={{ textAlign: 'center', padding: '1.5rem', backgroundColor: 'var(--bg-tertiary)', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)' }}>
//                                     <span style={{ fontSize: '2rem' }}>🔒</span>
//                                     <h4 style={{ margin: '0.5rem 0' }}>Profile Locked</h4>
//                                     <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>This profile and all requested documents have been submitted to HR.</p>
//                                 </div>
//                             );
//                         }

//                         return (
//                             <button
//                                 type="button"
//                                 className="btn btn-primary"
//                                 style={{ width: '100%', padding: '0.875rem', fontSize: '1rem', display: 'flex', justifyContent: 'center' }}
//                                 onClick={() => setShowSubmitConfirm(true)}
//                                 disabled={effectiveDashboardStats?.completed_steps < effectiveDashboardStats?.total_steps}
//                             >
//                                 {isLocked ? 'Submit Updated Requested Documents' : 'Submit Onboarding Profile'}
//                             </button>
//                         );
//                     })()}
//                 </div>
//             )}

//             {showSubmitConfirm && createPortal(
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     width: '100vw',
//                     height: '100vh',
//                     backgroundColor: 'rgba(15, 23, 42, 0.4)',
//                     backdropFilter: 'blur(8px)',
//                     WebkitBackdropFilter: 'blur(8px)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     zIndex: 9999,
//                     animation: 'fadeIn var(--transition-fast) forwards'
//                 }}>
//                     <div className="glass-card" style={{
//                         width: '460px',
//                         maxWidth: '90%',
//                         padding: '2.5rem 2rem',
//                         borderRadius: 'var(--border-radius-lg)',
//                         boxShadow: 'var(--shadow-lg)',
//                         backgroundColor: 'var(--bg-secondary)',
//                         textAlign: 'center',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center'
//                     }}>
//                         <div style={{
//                             width: '64px',
//                             height: '64px',
//                             borderRadius: '50%',
//                             backgroundColor: 'var(--primary-light)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             fontSize: '2rem',
//                             marginBottom: '1.25rem',
//                             color: 'var(--primary)'
//                         }}>
//                             🚀
//                         </div>
//                         <h3 style={{
//                             fontSize: '1.5rem',
//                             fontWeight: '700',
//                             marginBottom: '0.75rem',
//                             fontFamily: 'var(--font-heading)',
//                             color: 'var(--text-primary)'
//                         }}>
//                             Submit Onboarding Profile?
//                         </h3>
//                         <p style={{
//                             color: 'var(--text-secondary)',
//                             fontSize: '0.9rem',
//                             marginBottom: '2rem',
//                             lineHeight: '1.6'
//                         }}>
//                             Are you sure you want to submit your onboarding profile? This will lock all details for HR review and finalize your submission.
//                         </p>
//                         <div style={{ display: 'flex', gap: '1rem', width: '100%' }}>
//                             <button
//                                 type="button"
//                                 className="btn btn-secondary"
//                                 style={{ flex: 1, padding: '0.75rem 1.25rem', fontSize: '0.9rem' }}
//                                 onClick={() => setShowSubmitConfirm(false)}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 type="button"
//                                 className="btn btn-primary"
//                                 style={{ flex: 1, padding: '0.75rem 1.25rem', fontSize: '0.9rem' }}
//                                 onClick={() => {
//                                     setShowSubmitConfirm(false);
//                                     handleSubmitOnboarding();
//                                 }}
//                             >
//                                 Yes, Submit
//                             </button>
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             {submitStatus !== 'idle' && createPortal(
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     width: '100vw',
//                     height: '100vh',
//                     backgroundColor: 'rgba(15, 23, 42, 0.4)',
//                     backdropFilter: 'blur(8px)',
//                     WebkitBackdropFilter: 'blur(8px)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     zIndex: 9999,
//                     animation: 'fadeIn var(--transition-fast) forwards'
//                 }}>
//                     <div className="glass-card" style={{
//                         width: '460px',
//                         maxWidth: '90%',
//                         padding: '2.5rem 2rem',
//                         borderRadius: 'var(--border-radius-lg)',
//                         boxShadow: 'var(--shadow-lg)',
//                         backgroundColor: 'var(--bg-secondary)',
//                         textAlign: 'center',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center'
//                     }}>
//                         {submitStatus === 'submitting' && (
//                             <>
//                                 <div className="submit-spinner" />
//                                 <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.5rem', color: 'var(--text-primary)', fontFamily: 'var(--font-heading)' }}>
//                                     Submitting Onboarding
//                                 </h3>
//                                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: '0 0 1rem 0' }}>
//                                     Locking your profile and submitting documents to HR...
//                                 </p>
//                                 <div className="submit-loader-progress" style={{ width: '100%' }}>
//                                     <div className="submit-loader-progress-bar" />
//                                 </div>
//                             </>
//                         )}

//                         {submitStatus === 'success' && (
//                             <>
//                                 <div className="submit-success-icon">✓</div>
//                                 <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.75rem', color: 'var(--success)', fontFamily: 'var(--font-heading)' }}>
//                                     Successfully Submitted!
//                                 </h3>
//                                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '2rem', lineHeight: '1.6' }}>
//                                     Your onboarding documents and details have been successfully submitted and locked for HR review.
//                                 </p>
//                                 <button
//                                     type="button"
//                                     className="btn btn-primary"
//                                     style={{ width: '100%', padding: '0.75rem 1.25rem', fontSize: '0.9rem' }}
//                                     onClick={() => {
//                                         setSubmitStatus('idle');
//                                         setActiveTab('dashboard');
//                                     }}
//                                 >
//                                     Go to Dashboard
//                                 </button>
//                             </>
//                         )}

//                         {submitStatus === 'error' && (
//                             <>
//                                 <div className="submit-error-icon">✗</div>
//                                 <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.75rem', color: 'var(--danger)', fontFamily: 'var(--font-heading)' }}>
//                                     Submission Failed
//                                 </h3>
//                                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '2rem', lineHeight: '1.6' }}>
//                                     {submitErrorMessage || 'An unexpected error occurred during submission. Please try again.'}
//                                 </p>
//                                 <button
//                                     type="button"
//                                     className="btn btn-primary"
//                                     style={{ width: '100%', padding: '0.75rem 1.25rem', fontSize: '0.9rem', backgroundColor: 'var(--danger)', borderColor: 'var(--danger)' }}
//                                     onClick={() => setSubmitStatus('idle')}
//                                 >
//                                     Dismiss & Retry
//                                 </button>
//                             </>
//                         )}
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             {/* POPUP MODAL FOR HR-REQUESTED DOCUMENTS */}
//             {showRequestedDocsModal && (() => {
//                 const reqList = data?.requested_documents || data?.requested_employee_documents || [];
//                 const pendingList = reqList.filter(req => {
//                     const rStatus = (req.status || '').toUpperCase();
//                     const rName = (req.document_name || req.document_type || req.title || req.name || '').trim();
//                     const isUploadedInEmpDocs = data?.documents?.some(d => d.document_type === rName);
//                     return rStatus !== 'UPLOADED' && !isUploadedInEmpDocs;
//                 });

//                 if (pendingList.length === 0) return null;

//                 return createPortal(
//                     <div style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: 0,
//                         width: '100vw',
//                         height: '100vh',
//                         backgroundColor: 'rgba(15, 23, 42, 0.55)',
//                         backdropFilter: 'blur(8px)',
//                         WebkitBackdropFilter: 'blur(8px)',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         zIndex: 99999,
//                         animation: 'fadeIn var(--transition-fast) forwards'
//                     }}>
//                         <div className="glass-card" style={{
//                             width: '520px',
//                             maxWidth: '92%',
//                             padding: '2.5rem 2rem',
//                             borderRadius: 'var(--border-radius-lg)',
//                             boxShadow: 'var(--shadow-lg)',
//                             backgroundColor: 'var(--bg-secondary)',
//                             textAlign: 'center',
//                             display: 'flex',
//                             flexDirection: 'column',
//                             alignItems: 'center'
//                         }}>
//                             <div style={{
//                                 width: '64px',
//                                 height: '64px',
//                                 borderRadius: '50%',
//                                 backgroundColor: 'rgba(59, 130, 246, 0.12)',
//                                 border: '2px solid rgba(59, 130, 246, 0.3)',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 fontSize: '2rem',
//                                 marginBottom: '1.25rem',
//                                 color: 'var(--primary)'
//                             }}>
//                                 📋
//                             </div>

//                             <h3 style={{
//                                 fontSize: '1.4rem',
//                                 fontWeight: '700',
//                                 marginBottom: '0.5rem',
//                                 color: 'var(--text-primary)',
//                                 fontFamily: 'var(--font-heading)'
//                             }}>
//                                 Action Required: Additional Documents Requested
//                             </h3>

//                             <p style={{
//                                 color: 'var(--text-secondary)',
//                                 fontSize: '0.875rem',
//                                 marginBottom: '1.5rem',
//                                 lineHeight: '1.5'
//                             }}>
//                                 Management or HR has specifically requested <strong>{pendingList.length}</strong> additional document(s) for your onboarding profile:
//                             </p>

//                             <div style={{
//                                 width: '100%',
//                                 maxHeight: '190px',
//                                 overflowY: 'auto',
//                                 backgroundColor: 'var(--bg-tertiary)',
//                                 borderRadius: 'var(--border-radius-sm)',
//                                 border: '1px solid var(--border-color)',
//                                 padding: '1rem',
//                                 marginBottom: '1.75rem',
//                                 textAlign: 'left',
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 gap: '0.75rem'
//                             }}>
//                                 {pendingList.map((req, idx) => {
//                                     const name = req.document_name || req.document_type || req.title || req.name || `Requested Document #${idx + 1}`;
//                                     const inst = req.instructions || req.comments || req.description || req.note || req.reason || '';
//                                     return (
//                                         <div key={req.id || idx} style={{ borderBottom: idx < pendingList.length - 1 ? '1px solid var(--border-color)' : 'none', paddingBottom: '0.5rem' }}>
//                                             <div style={{ fontWeight: 700, fontSize: '0.9rem', color: 'var(--primary)' }}>
//                                                 {idx + 1}. {name}
//                                             </div>
//                                             {inst && (
//                                                 <div style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', marginTop: '0.2rem' }}>
//                                                     Instructions: {inst}
//                                                 </div>
//                                             )}
//                                         </div>
//                                     );
//                                 })}
//                             </div>

//                             <button
//                                 type="button"
//                                 className="btn btn-primary"
//                                 style={{ width: '100%', padding: '0.85rem 1.5rem', fontSize: '0.95rem', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                                 onClick={() => {
//                                     setShowRequestedDocsModal(false);
//                                     setHasSeenRequestedDocsModal(true);
//                                     setActiveTab('documents');
//                                 }}
//                             >
//                                 Proceed to Documents Page →
//                             </button>
//                         </div>
//                     </div>,
//                     document.body
//                 );
//             })()}

//             {toast && (
//                 <div className="toast-container">
//                     <NotificationToast
//                         message={toast.message}
//                         type={toast.type}
//                         onClose={() => setToast(null)}
//                     />
//                 </div>
//             )}
//         </div>
//     );
// };

// export default EmployeeDashboard;















































// import React, { useState, useEffect, useCallback } from 'react';
// import { createPortal } from 'react-dom';
// import api from '../services/api';
// import UploadField from '../components/UploadField';
// import SignaturePad from '../components/SignaturePad';
// import NotificationToast from '../components/NotificationToast';
// import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
// import { genesisPolicies } from '../constants/genesisPolicies';
// import { genesisPoliciesText } from '../constants/genesisPoliciesText';
// import Loader from '../components/Loader';

// // Helper to convert base64 (including data URIs) to a Uint8Array safely
// const base64ToUint8Array = (base64Str) => {
//     if (!base64Str || typeof base64Str !== 'string') return new Uint8Array(0);
//     try {
//         const commaIdx = base64Str.indexOf(',');
//         let clean = commaIdx !== -1 ? base64Str.substring(commaIdx + 1) : base64Str;
//         clean = clean.replace(/\s/g, '');

//         // Normalize URL-safe base64
//         clean = clean.replace(/-/g, '+').replace(/_/g, '/');

//         // Fix padding if needed
//         const mod = clean.length % 4;
//         if (mod === 2) {
//             clean += '==';
//         } else if (mod === 3) {
//             clean += '=';
//         }

//         const bin = atob(clean);
//         const len = bin.length;
//         const bytes = new Uint8Array(len);
//         for (let i = 0; i < len; i++) {
//             bytes[i] = bin.charCodeAt(i);
//         }
//         return bytes;
//     } catch (e) {
//         console.error("base64ToUint8Array decoding failed:", e);
//         return new Uint8Array(0);
//     }
// };

// // Helper to convert base64 to Blob URL
// const base64ToBlobUrl = (base64Data) => {
//     try {
//         if (!base64Data) return '';
//         const arr = base64ToUint8Array(base64Data);
//         if (arr.length === 0) return '';
//         const blob = new Blob([arr], { type: 'application/pdf' });
//         return URL.createObjectURL(blob);
//     } catch (err) {
//         console.error('Failed to convert base64 to Blob URL:', err);
//         return '';
//     }
// };

// // Helper to fetch local or remote PDF file and convert to base64
// const fetchLocalPdfAsBase64 = async (url) => {
//     if (!url) return '';
//     if (url.startsWith('data:application/pdf;base64,')) {
//         return url.replace('data:application/pdf;base64,', '');
//     }
//     if (url.startsWith('data:')) {
//         const commaIdx = url.indexOf(',');
//         if (commaIdx !== -1) return url.substring(commaIdx + 1);
//     }

//     const bufferToBase64 = (arrayBuffer) => {
//         let binary = '';
//         const bytes = new Uint8Array(arrayBuffer);
//         const len = bytes.byteLength;
//         const chunkSize = 8192;
//         for (let i = 0; i < len; i += chunkSize) {
//             const chunk = bytes.subarray(i, i + chunkSize);
//             binary += String.fromCharCode.apply(null, chunk);
//         }
//         return btoa(binary);
//     };

//     // 1. Direct fetch with CORS mode
//     try {
//         const response = await fetch(url, { mode: 'cors' });
//         if (response.ok) {
//             const arrayBuffer = await response.arrayBuffer();
//             if (arrayBuffer.byteLength > 0) {
//                 return bufferToBase64(arrayBuffer);
//             }
//         }
//     } catch (directErr) {
//         console.warn("Direct PDF fetch failed for:", url, directErr);
//     }

//     // 2. Direct fetch default fallback
//     try {
//         const response = await fetch(url);
//         if (response.ok) {
//             const arrayBuffer = await response.arrayBuffer();
//             if (arrayBuffer.byteLength > 0) {
//                 return bufferToBase64(arrayBuffer);
//             }
//         }
//     } catch (directErr2) {
//         console.warn("Direct fetch fallback failed:", directErr2);
//     }

//     // If local or blob URL, proxy won't work
//     if (url.startsWith('blob:') || url.startsWith('/') || url.includes('localhost')) {
//         return '';
//     }

//     // 3. CORS Proxies for remote host files (fast with 2s timeout per proxy)
//     const proxies = [
//         (u) => `https://api.allorigins.win/raw?url=${encodeURIComponent(u)}`,
//         (u) => `https://corsproxy.io/?${encodeURIComponent(u)}`,
//         (u) => `https://thingproxy.freeboard.io/fetch/${u}`,
//         (u) => `https://api.codetabs.com/v1/proxy?quest=${encodeURIComponent(u)}`
//     ];

//     for (const getProxyUrl of proxies) {
//         const controller = new AbortController();
//         const timeoutId = setTimeout(() => controller.abort(), 2500);
//         try {
//             const proxyUrl = getProxyUrl(url);
//             const res = await fetch(proxyUrl, { signal: controller.signal });
//             clearTimeout(timeoutId);
//             if (res.ok) {
//                 const arrayBuffer = await res.arrayBuffer();
//                 if (arrayBuffer.byteLength > 0) {
//                     return bufferToBase64(arrayBuffer);
//                 }
//             }
//         } catch (e) {
//             clearTimeout(timeoutId);
//             console.warn("Proxy attempt failed:", e);
//         }
//     }

//     return '';
// };

// // Helper to convert typed signature into a transparent PNG data URL on the fly
// const convertTypedToPng = (typedName) => {
//     const canvas = document.createElement('canvas');
//     canvas.width = 400;
//     canvas.height = 150;
//     const ctx = canvas.getContext('2d');

//     // Clear canvas
//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     // Font style matches type signature style in SignaturePad
//     ctx.font = 'italic 40px "Outfit", "Brush Script MT", cursive, sans-serif';
//     ctx.fillStyle = '#0f172a'; // dark slate/primary color
//     ctx.textAlign = 'center';
//     ctx.textBaseline = 'middle';

//     // Draw the text
//     ctx.fillText(typedName, canvas.width / 2, canvas.height / 2);

//     return canvas.toDataURL('image/png');
// };

// // Helper to draw signature PNG on the last page of a PDF
// const generateAgreementPdfData = async (templateBytes, formValues, signaturePng) => {
//     if (!templateBytes) return '';
//     const pdfDoc = await PDFDocument.load(templateBytes);
//     const pages = pdfDoc.getPages();
//     const firstPage = pages[0];

//     const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

//     // Draw values on Page 1
//     const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//     const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();
//     firstPage.drawText(dateStr, {
//         x: 320,
//         y: 695.86,
//         size: 10,
//         font: boldFont,
//         color: rgb(0, 0, 0)
//     });

//     if (formValues.employeeName) {
//         firstPage.drawText(formValues.employeeName, {
//             x: 120,
//             y: 671.50,
//             size: 10,
//             font: boldFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     if (formValues.position) {
//         firstPage.drawText(formValues.position, {
//             x: 85,
//             y: 598.06,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     if (formValues.department) {
//         firstPage.drawText(formValues.department, {
//             x: 100,
//             y: 573.79,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     if (formValues.primaryLocation) {
//         firstPage.drawText(formValues.primaryLocation, {
//             x: 145,
//             y: 549.43,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     const drawTick = (x, y) => {
//         firstPage.drawText('\u2714', {
//             x: x + 1,
//             y: y + 1,
//             size: 10,
//             font: dingbatsFont,
//             color: rgb(0, 0, 0)
//         });
//     };

//     if (formValues.employmentClassification === 'Full-Time') {
//         drawTick(45, 511.51);
//     } else if (formValues.employmentClassification === 'Part-Time') {
//         drawTick(45, 498.07);
//     } else if (formValues.employmentClassification === 'Exempt') {
//         drawTick(45, 484.63);
//     } else if (formValues.employmentClassification === 'Non-Exempt') {
//         drawTick(45, 471.07);
//     }

//     // Draw signature block on Page 5
//     const page5 = pages[4];
//     if (page5) {
//         if (formValues.employeeName) {
//             page5.drawText(formValues.employeeName, {
//                 x: 120,
//                 y: 573.91,
//                 size: 10,
//                 font: boldFont,
//                 color: rgb(0, 0, 0)
//             });
//         }

//         page5.drawText(dateStr, {
//             x: 70,
//             y: 525.07,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         page5.drawText(dateStr, {
//             x: 70,
//             y: 368.69,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         if (signaturePng) {
//             try {
//                 const signatureBytes = base64ToUint8Array(signaturePng);
//                 if (signatureBytes.length > 0) {
//                     const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//                     const signatureImage = isJpg
//                         ? await pdfDoc.embedJpg(signatureBytes)
//                         : await pdfDoc.embedPng(signatureBytes);

//                     page5.drawImage(signatureImage, {
//                         x: 100,
//                         y: 539,
//                         width: 140,
//                         height: 28,
//                     });

//                     // Draw signature and audit text on every page in the empty space
//                     const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//                     pages.forEach((page) => {
//                         page.drawImage(signatureImage, {
//                             x: 195,
//                             y: 20,
//                             width: 100,
//                             height: 35,
//                         });
//                         page.drawText(auditText, {
//                             x: 195,
//                             y: 12,
//                             size: 7,
//                             font: textFont,
//                             color: rgb(0.2, 0.3, 0.4),
//                         });
//                     });
//                 }
//             } catch (e) {
//                 console.error('Error embedding signature in final PDF data:', e);
//             }
//         }
//     }

//     const pdfBytes = await pdfDoc.save();
//     let binary = '';
//     const bytes = new Uint8Array(pdfBytes);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     return btoa(binary);
// };

// const generateNdaPdfData = async (templateBytes, formValues, signaturePng) => {
//     if (!templateBytes) return '';
//     const pdfDoc = await PDFDocument.load(templateBytes);
//     const pages = pdfDoc.getPages();
//     const firstPage = pages[0];

//     const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//     // Draw values on Page 1
//     const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//     const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();

//     if (formValues.employeeName) {
//         firstPage.drawText(formValues.employeeName, {
//             x: 120,
//             y: 636.10,
//             size: 10,
//             font: boldFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     if (formValues.position) {
//         firstPage.drawText(formValues.position, {
//             x: 90,
//             y: 622.18,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     firstPage.drawText(dateStr, {
//         x: 110,
//         y: 608.02,
//         size: 10,
//         font: textFont,
//         color: rgb(0, 0, 0)
//     });

//     // Draw signature block on Page 5
//     const page5 = pages[4];
//     if (page5) {
//         if (formValues.employeeName) {
//             page5.drawText(formValues.employeeName, {
//                 x: 120,
//                 y: 622.18,
//                 size: 10,
//                 font: boldFont,
//                 color: rgb(0, 0, 0)
//             });
//         }

//         page5.drawText(dateStr, {
//             x: 70,
//             y: 608.14,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         page5.drawText(dateStr, {
//             x: 70,
//             y: 473.47,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         if (signaturePng) {
//             try {
//                 const signatureBytes = base64ToUint8Array(signaturePng);
//                 if (signatureBytes.length > 0) {
//                     const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//                     const signatureImage = isJpg
//                         ? await pdfDoc.embedJpg(signatureBytes)
//                         : await pdfDoc.embedPng(signatureBytes);

//                     page5.drawImage(signatureImage, {
//                         x: 140,
//                         y: 640,
//                         width: 140,
//                         height: 28,
//                     });

//                     // Draw signature and audit text on every page in the empty space
//                     const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//                     pages.forEach((page) => {
//                         page.drawImage(signatureImage, {
//                             x: 195,
//                             y: 20,
//                             width: 100,
//                             height: 35,
//                         });
//                         page.drawText(auditText, {
//                             x: 195,
//                             y: 12,
//                             size: 7,
//                             font: textFont,
//                             color: rgb(0.2, 0.3, 0.4),
//                         });
//                     });
//                 }
//             } catch (e) {
//                 console.error('Error embedding signature in final NDA PDF data:', e);
//             }
//         }
//     }

//     const pdfBytes = await pdfDoc.save();
//     let binary = '';
//     const bytes = new Uint8Array(pdfBytes);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     return btoa(binary);
// };

// const generateConflictPdfData = async (templateBytes, formValues, signaturePng) => {
//     if (!templateBytes) return '';
//     const pdfDoc = await PDFDocument.load(templateBytes);
//     const pages = pdfDoc.getPages();
//     const firstPage = pages[0];
//     const page2 = pages[1];
//     const page3 = pages[2];

//     const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

//     // Draw values on Page 1
//     if (formValues.employeeName) {
//         firstPage.drawText(formValues.employeeName, {
//             x: 120,
//             y: 647.02,
//             size: 10,
//             font: boldFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     if (formValues.position) {
//         firstPage.drawText(formValues.position, {
//             x: 85,
//             y: 628.90,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//     const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();
//     firstPage.drawText(dateStr, {
//         x: 110,
//         y: 610.54,
//         size: 10,
//         font: textFont,
//         color: rgb(0, 0, 0)
//     });

//     // Draw values on Page 2 (Questions & Checkboxes)
//     if (page2) {
//         const drawTick = (x, y) => {
//             page2.drawText('\u2714', {
//                 x: x + 1,
//                 y: y + 1,
//                 size: 9.5,
//                 font: dingbatsFont,
//                 color: rgb(0, 0, 0)
//             });
//         };

//         // A. Outside Employment
//         if (formValues.outsideEmploymentType === 'none') {
//             drawTick(43, 664.18);
//         } else if (formValues.outsideEmploymentType === 'has_employment') {
//             drawTick(43, 644.02);

//             if (formValues.outsideEmployer) {
//                 page2.drawText(formValues.outsideEmployer, {
//                     x: 135,
//                     y: 625.90,
//                     size: 9,
//                     font: textFont,
//                     color: rgb(0, 0, 0)
//                 });
//             }
//             if (formValues.outsideNature) {
//                 page2.drawText(formValues.outsideNature, {
//                     x: 115,
//                     y: 607.54,
//                     size: 9,
//                     font: textFont,
//                     color: rgb(0, 0, 0)
//                 });
//             }
//             if (formValues.outsideHours) {
//                 page2.drawText(formValues.outsideHours, {
//                     x: 110,
//                     y: 589.03,
//                     size: 9,
//                     font: textFont,
//                     color: rgb(0, 0, 0)
//                 });
//             }
//         }

//         // B. Ownership of Other Businesses
//         if (formValues.ownershipType === 'no') {
//             drawTick(43, 532.87);
//         } else if (formValues.ownershipType === 'yes') {
//             drawTick(43, 512.71);
//             if (formValues.ownershipDescribe) {
//                 page2.drawText(formValues.ownershipDescribe, {
//                     x: 115,
//                     y: 493.87,
//                     size: 9,
//                     font: textFont,
//                     color: rgb(0, 0, 0)
//                 });
//             }
//         }

//         // C. Competing Activities
//         if (formValues.competingType === 'no') {
//             drawTick(43, 437.59);
//         } else if (formValues.competingType === 'yes') {
//             drawTick(43, 417.53);
//             if (formValues.competingDescribe) {
//                 page2.drawText(formValues.competingDescribe, {
//                     x: 110,
//                     y: 398.69,
//                     size: 9,
//                     font: textFont,
//                     color: rgb(0, 0, 0)
//                 });
//             }
//         }

//         // D. Other Potential Conflicts
//         if (formValues.otherConflicts) {
//             page2.drawText(formValues.otherConflicts, {
//                 x: 45,
//                 y: 348,
//                 size: 8.5,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//     }

//     // Draw signature block on Page 3
//     if (page3) {
//         if (formValues.employeeName) {
//             page3.drawText(formValues.employeeName, {
//                 x: 120,
//                 y: 683.62,
//                 size: 10,
//                 font: boldFont,
//                 color: rgb(0, 0, 0)
//             });
//         }

//         page3.drawText(dateStr, {
//             x: 70,
//             y: 665.50,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         page3.drawText(dateStr, {
//             x: 70,
//             y: 545.23,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         if (signaturePng) {
//             try {
//                 const signatureBytes = base64ToUint8Array(signaturePng);
//                 if (signatureBytes.length > 0) {
//                     const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//                     const signatureImage = isJpg
//                         ? await pdfDoc.embedJpg(signatureBytes)
//                         : await pdfDoc.embedPng(signatureBytes);

//                     page3.drawImage(signatureImage, {
//                         x: 160,
//                         y: 709,
//                         width: 140,
//                         height: 28,
//                     });

//                     // Draw signature and audit text on every page in the empty space
//                     const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//                     pages.forEach((page) => {
//                         page.drawImage(signatureImage, {
//                             x: 195,
//                             y: 20,
//                             width: 100,
//                             height: 35,
//                         });
//                         page.drawText(auditText, {
//                             x: 195,
//                             y: 12,
//                             size: 7,
//                             font: textFont,
//                             color: rgb(0.2, 0.3, 0.4),
//                         });
//                     });
//                 }
//             } catch (e) {
//                 console.error('Error embedding signature in final Conflict PDF data:', e);
//             }
//         }
//     }

//     const pdfBytes = await pdfDoc.save();
//     let binary = '';
//     const bytes = new Uint8Array(pdfBytes);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     return btoa(binary);
// };

// const generateBenefitsPdfData = async (templateBytes, formValues, signaturePng) => {
//     if (!templateBytes) return '';
//     const pdfDoc = await PDFDocument.load(templateBytes);
//     const pages = pdfDoc.getPages();
//     const firstPage = pages[0];
//     const page2 = pages[1];
//     const page3 = pages[2];

//     const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

//     const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//     const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();

//     // Helper to draw checkmarks
//     const drawTick = (page, x, y) => {
//         page.drawText('\u2714', {
//             x: x + 1,
//             y: y + 1,
//             size: 9.5,
//             font: dingbatsFont,
//             color: rgb(0, 0, 0)
//         });
//     };

//     // Draw values on Page 1
//     if (formValues.employeeName) {
//         firstPage.drawText(formValues.employeeName, {
//             x: 130,
//             y: 700.66,
//             size: 10,
//             font: boldFont,
//             color: rgb(0, 0, 0)
//         });
//     }
//     if (formValues.position) {
//         firstPage.drawText(formValues.position, {
//             x: 95,
//             y: 664.06,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }
//     if (formValues.department) {
//         firstPage.drawText(formValues.department, {
//             x: 110,
//             y: 645.70,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }
//     firstPage.drawText(dateStr, {
//         x: 135,
//         y: 609.10,
//         size: 10,
//         font: textFont,
//         color: rgb(0, 0, 0)
//     });

//     // Section 1 - Medical
//     if (formValues.medicalElection === 'enrol') {
//         drawTick(firstPage, 43, 461.23);
//     } else if (formValues.medicalElection === 'waive') {
//         drawTick(firstPage, 43, 441.19);
//         if (formValues.medicalWaiveReason === 'spouse_plan') {
//             drawTick(firstPage, 43, 402.65);
//         } else if (formValues.medicalWaiveReason === 'another_plan') {
//             drawTick(firstPage, 43, 382.61);
//         } else if (formValues.medicalWaiveReason === 'gov_program') {
//             drawTick(firstPage, 43, 362.45);
//         } else if (formValues.medicalWaiveReason === 'other') {
//             drawTick(firstPage, 43, 342.29);
//             if (formValues.medicalWaiveReasonOther) {
//                 firstPage.drawText(formValues.medicalWaiveReasonOther, {
//                     x: 95,
//                     y: 342.29,
//                     size: 9,
//                     font: textFont,
//                     color: rgb(0, 0, 0)
//                 });
//             }
//         }
//     }

//     // Section 2 - Dental
//     if (formValues.dentalElection === 'enrol') {
//         drawTick(firstPage, 43, 285.53);
//     } else if (formValues.dentalElection === 'waive') {
//         drawTick(firstPage, 43, 265.49);
//     }

//     // Section 3 - Vision
//     if (formValues.visionElection === 'enrol') {
//         drawTick(firstPage, 43, 208.70);
//     } else if (formValues.visionElection === 'waive') {
//         drawTick(firstPage, 43, 188.54);
//     }

//     // Section 4 - 401(k) Retirement Participation
//     if (formValues.retirementElection === 'participate') {
//         drawTick(firstPage, 43, 131.78);

//         // Draw contributions on Page 2
//         if (page2) {
//             if (formValues.retirementContributionType === 'percentage') {
//                 drawTick(page2, 43, 717.70);
//                 if (formValues.retirementContributionPercent) {
//                     page2.drawText(String(formValues.retirementContributionPercent), {
//                         x: 58,
//                         y: 717.70,
//                         size: 9,
//                         font: textFont,
//                         color: rgb(0, 0, 0)
//                     });
//                 }
//             } else if (formValues.retirementContributionType === 'amount') {
//                 drawTick(page2, 43, 679.18);
//                 if (formValues.retirementContributionAmount) {
//                     page2.drawText(String(formValues.retirementContributionAmount), {
//                         x: 58,
//                         y: 679.18,
//                         size: 9,
//                         font: textFont,
//                         color: rgb(0, 0, 0)
//                     });
//                 }
//             }
//         }
//     } else if (formValues.retirementElection === 'decline') {
//         drawTick(firstPage, 43, 111.62);
//     }

//     // Section 5 - Beneficiary Designation on Page 2
//     if (page2) {
//         if (formValues.primaryBeneName) {
//             page2.drawText(formValues.primaryBeneName, {
//                 x: 80,
//                 y: 365.81,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         if (formValues.primaryBeneRelationship) {
//             page2.drawText(formValues.primaryBeneRelationship, {
//                 x: 105,
//                 y: 347.45,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         if (formValues.primaryBeneDob) {
//             page2.drawText(formValues.primaryBeneDob, {
//                 x: 105,
//                 y: 329.21,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         if (formValues.primaryBenePercent) {
//             page2.drawText(String(formValues.primaryBenePercent), {
//                 x: 55,
//                 y: 292.61,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }

//         if (formValues.contingentBeneName) {
//             page2.drawText(formValues.contingentBeneName, {
//                 x: 80,
//                 y: 237.62,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         if (formValues.contingentBeneRelationship) {
//             page2.drawText(formValues.contingentBeneRelationship, {
//                 x: 105,
//                 y: 219.26,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         if (formValues.contingentBeneDob) {
//             page2.drawText(formValues.contingentBeneDob, {
//                 x: 105,
//                 y: 201.02,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         if (formValues.contingentBenePercent) {
//             page2.drawText(String(formValues.contingentBenePercent), {
//                 x: 55,
//                 y: 164.30,
//                 size: 9,
//                 font: textFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//     }

//     // Draw signature block on Page 3
//     if (page3) {
//         if (formValues.employeeName) {
//             page3.drawText(formValues.employeeName, {
//                 x: 110,
//                 y: 535.87,
//                 size: 10,
//                 font: boldFont,
//                 color: rgb(0, 0, 0)
//             });
//         }
//         page3.drawText(dateStr, {
//             x: 75,
//             y: 517.51,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         page3.drawText(dateStr, {
//             x: 75,
//             y: 232.22,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         if (signaturePng) {
//             try {
//                 const signatureBytes = base64ToUint8Array(signaturePng);
//                 if (signatureBytes.length > 0) {
//                     const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//                     const signatureImage = isJpg
//                         ? await pdfDoc.embedJpg(signatureBytes)
//                         : await pdfDoc.embedPng(signatureBytes);

//                     page3.drawImage(signatureImage, {
//                         x: 160,
//                         y: 544,
//                         width: 140,
//                         height: 28,
//                     });

//                     // Draw signature and audit text on every page in the empty space
//                     const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//                     pages.forEach((page) => {
//                         page.drawImage(signatureImage, {
//                             x: 195,
//                             y: 20,
//                             width: 100,
//                             height: 35,
//                         });
//                         page.drawText(auditText, {
//                             x: 195,
//                             y: 12,
//                             size: 7,
//                             font: textFont,
//                             color: rgb(0.2, 0.3, 0.4),
//                         });
//                     });
//                 }
//             } catch (e) {
//                 console.error('Error embedding signature in final Benefits PDF data:', e);
//             }
//         }
//     }

//     const pdfBytes = await pdfDoc.save();
//     let binary = '';
//     const bytes = new Uint8Array(pdfBytes);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     return btoa(binary);
// };

// const generateNonSolicitationPdfData = async (templateBytes, formValues, signaturePng) => {
//     if (!templateBytes) return '';
//     const pdfDoc = await PDFDocument.load(templateBytes);
//     const pages = pdfDoc.getPages();
//     const firstPage = pages[0];
//     const lastPage = pages[pages.length - 1];

//     const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//     const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
//     const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();

//     // Draw values on Page 1
//     if (formValues.employeeName) {
//         firstPage.drawText(formValues.employeeName, {
//             x: 119,
//             y: 665.14,
//             size: 10,
//             font: boldFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     if (formValues.position) {
//         firstPage.drawText(formValues.position, {
//             x: 83,
//             y: 647.02,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });
//     }

//     firstPage.drawText(dateStr, {
//         x: 107,
//         y: 628.90,
//         size: 10,
//         font: textFont,
//         color: rgb(0, 0, 0)
//     });

//     // Draw values on last page
//     if (lastPage) {
//         if (formValues.employeeName) {
//             lastPage.drawText(formValues.employeeName, {
//                 x: 120,
//                 y: 317.57,
//                 size: 10,
//                 font: boldFont,
//                 color: rgb(0, 0, 0)
//             });
//         }

//         lastPage.drawText(dateStr, {
//             x: 75,
//             y: 299.21,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         lastPage.drawText(dateStr, {
//             x: 75,
//             y: 130.34,
//             size: 10,
//             font: textFont,
//             color: rgb(0, 0, 0)
//         });

//         if (signaturePng) {
//             try {
//                 const signatureBytes = base64ToUint8Array(signaturePng);
//                 if (signatureBytes.length > 0) {
//                     const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
//                     const signatureImage = isJpg
//                         ? await pdfDoc.embedJpg(signatureBytes)
//                         : await pdfDoc.embedPng(signatureBytes);

//                     lastPage.drawImage(signatureImage, {
//                         x: 150,
//                         y: 343,
//                         width: 140,
//                         height: 28,
//                     });

//                     // Draw signature and audit text on every page footer in empty space
//                     const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
//                     pages.forEach((page) => {
//                         page.drawImage(signatureImage, {
//                             x: 195,
//                             y: 20,
//                             width: 100,
//                             height: 35,
//                         });
//                         page.drawText(auditText, {
//                             x: 195,
//                             y: 12,
//                             size: 7,
//                             font: textFont,
//                             color: rgb(0.2, 0.3, 0.4),
//                         });
//                     });
//                 }
//             } catch (e) {
//                 console.error('Error embedding signature in final Non Solicitation PDF:', e);
//             }
//         }
//     }

//     const pdfBytes = await pdfDoc.save();
//     let binary = '';
//     const bytes = new Uint8Array(pdfBytes);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     return btoa(binary);
// };

// // Helper to format date as MM/DD/YYYY
// const formatDateMMDDYYYY = (dateVal) => {
//     if (!dateVal) {
//         const now = new Date();
//         const m = String(now.getMonth() + 1).padStart(2, '0');
//         const day = String(now.getDate()).padStart(2, '0');
//         return `${m}/${day}/${now.getFullYear()}`;
//     }
//     let d = null;
//     if (dateVal instanceof Date) {
//         d = dateVal;
//     } else if (typeof dateVal === 'string') {
//         const trimmed = dateVal.trim();
//         // 1. Check YYYY-MM-DD or YYYY/MM/DD
//         const ymdMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
//         if (ymdMatch) {
//             const year = parseInt(ymdMatch[1], 10);
//             const month = parseInt(ymdMatch[2], 10) - 1;
//             const day = parseInt(ymdMatch[3], 10);
//             d = new Date(year, month, day);
//         } else {
//             // 2. Check MM/DD/YYYY or DD/MM/YYYY
//             const mdyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
//             if (mdyMatch) {
//                 const p1 = parseInt(mdyMatch[1], 10);
//                 const p2 = parseInt(mdyMatch[2], 10);
//                 const year = parseInt(mdyMatch[3], 10);
//                 let month, day;
//                 if (p1 > 12) {
//                     day = p1;
//                     month = p2 - 1;
//                 } else if (p2 > 12) {
//                     month = p1 - 1;
//                     day = p2;
//                 } else {
//                     month = p1 - 1;
//                     day = p2;
//                 }
//                 d = new Date(year, month, day);
//             } else {
//                 d = new Date(trimmed);
//             }
//         }
//     } else {
//         d = new Date(dateVal);
//     }

//     if (!d || isNaN(d.getTime())) {
//         const now = new Date();
//         const m = String(now.getMonth() + 1).padStart(2, '0');
//         const day = String(now.getDate()).padStart(2, '0');
//         return `${m}/${day}/${now.getFullYear()}`;
//     }

//     const month = String(d.getMonth() + 1).padStart(2, '0');
//     const day = String(d.getDate()).padStart(2, '0');
//     const year = d.getFullYear();
//     return `${month}/${day}/${year}`;
// };

// // Helper to format joining date for India Employment Agreement (e.g., "21st day of November 2025.")
// const formatAgreementJoiningDate = (dateInput) => {
//     if (!dateInput) return '21st day of November 2025.';
//     let dateObj = null;

//     if (dateInput instanceof Date) {
//         dateObj = dateInput;
//     } else if (typeof dateInput === 'string') {
//         const trimmed = dateInput.trim();

//         // 1. Check YYYY-MM-DD or YYYY/MM/DD (e.g. 2026-09-25, 2026-9-25)
//         const ymdMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
//         if (ymdMatch) {
//             const year = parseInt(ymdMatch[1], 10);
//             const month = parseInt(ymdMatch[2], 10) - 1;
//             const day = parseInt(ymdMatch[3], 10);
//             dateObj = new Date(year, month, day);
//         } else {
//             // 2. Check MM/DD/YYYY or DD/MM/YYYY (e.g. 09/25/2026 or 25/09/2026)
//             const mdyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
//             if (mdyMatch) {
//                 const p1 = parseInt(mdyMatch[1], 10);
//                 const p2 = parseInt(mdyMatch[2], 10);
//                 const year = parseInt(mdyMatch[3], 10);

//                 let month, day;
//                 if (p1 > 12) {
//                     // p1 is Day, p2 is Month (e.g., 25/09/2026)
//                     day = p1;
//                     month = p2 - 1;
//                 } else if (p2 > 12) {
//                     // p1 is Month, p2 is Day (e.g., 09/25/2026)
//                     month = p1 - 1;
//                     day = p2;
//                 } else {
//                     // Standard US format MM/DD/YYYY (e.g., 09/05/2026)
//                     month = p1 - 1;
//                     day = p2;
//                 }
//                 dateObj = new Date(year, month, day);
//             } else {
//                 // 3. Fallback to standard JS Date parsing
//                 dateObj = new Date(trimmed);
//             }
//         }
//     }

//     if (!dateObj || isNaN(dateObj.getTime())) {
//         return '21st day of November 2025.';
//     }

//     const day = dateObj.getDate();
//     const year = dateObj.getFullYear();
//     const monthNames = [
//         'January', 'February', 'March', 'April', 'May', 'June',
//         'July', 'August', 'September', 'October', 'November', 'December'
//     ];
//     const monthName = monthNames[dateObj.getMonth()];

//     let suffix = 'th';
//     if (day % 100 < 11 || day % 100 > 13) {
//         switch (day % 10) {
//             case 1: suffix = 'st'; break;
//             case 2: suffix = 'nd'; break;
//             case 3: suffix = 'rd'; break;
//             default: suffix = 'th'; break;
//         }
//     }

//     return `${day}${suffix} day of ${monthName} ${year}.`;
// };

// // Helper to format short joining date for India Employment Agreement (e.g., "25th September 2026")
// const formatJoiningDateShort = (dateInput) => {
//     if (!dateInput) return '21st November 2025';
//     let dateObj = null;

//     if (dateInput instanceof Date) {
//         dateObj = dateInput;
//     } else if (typeof dateInput === 'string') {
//         const trimmed = dateInput.trim();

//         // 1. Check YYYY-MM-DD or YYYY/MM/DD
//         const ymdMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
//         if (ymdMatch) {
//             const year = parseInt(ymdMatch[1], 10);
//             const month = parseInt(ymdMatch[2], 10) - 1;
//             const day = parseInt(ymdMatch[3], 10);
//             dateObj = new Date(year, month, day);
//         } else {
//             // 2. Check MM/DD/YYYY or DD/MM/YYYY
//             const mdyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
//             if (mdyMatch) {
//                 const p1 = parseInt(mdyMatch[1], 10);
//                 const p2 = parseInt(mdyMatch[2], 10);
//                 const year = parseInt(mdyMatch[3], 10);

//                 let month, day;
//                 if (p1 > 12) {
//                     day = p1;
//                     month = p2 - 1;
//                 } else if (p2 > 12) {
//                     month = p1 - 1;
//                     day = p2;
//                 } else {
//                     month = p1 - 1;
//                     day = p2;
//                 }
//                 dateObj = new Date(year, month, day);
//             } else {
//                 dateObj = new Date(trimmed);
//             }
//         }
//     }

//     if (!dateObj || isNaN(dateObj.getTime())) {
//         return '21st November 2025';
//     }

//     const day = dateObj.getDate();
//     const year = dateObj.getFullYear();
//     const monthNames = [
//         'January', 'February', 'March', 'April', 'May', 'June',
//         'July', 'August', 'September', 'October', 'November', 'December'
//     ];
//     const monthName = monthNames[dateObj.getMonth()];

//     let suffix = 'th';
//     if (day % 100 < 11 || day % 100 > 13) {
//         switch (day % 10) {
//             case 1: suffix = 'st'; break;
//             case 2: suffix = 'nd'; break;
//             case 3: suffix = 'rd'; break;
//             default: suffix = 'th'; break;
//         }
//     }

//     return `${day}${suffix} ${monthName} ${year}`;
// };

// // Helper to draw signature PNG on the last page of a PDF and footers of all pages
// const applySignatureToPdf = async (originalPdfBase64, signaturePngDataUrl, employeeName, docType, isIndia = false, extraDetails = {}) => {
//     try {
//         let pdfDoc;
//         if (originalPdfBase64) {
//             // Convert base64 PDF to bytes safely
//             const pdfBytes = base64ToUint8Array(originalPdfBase64);
//             if (pdfBytes.length === 0) {
//                 throw new Error("Invalid original PDF base64 data");
//             }
//             // Load the PDF document
//             pdfDoc = await PDFDocument.load(pdfBytes);
//         } else {
//             if (docType === 'Offer Letter') {
//                 throw new Error("Unable to retrieve original Offer Letter document bytes for digital signing. Please check network connection.");
//             }
//             // Fallback for other documents: If original PDF is empty, create a simple PDF document
//             pdfDoc = await PDFDocument.create();
//             const page = pdfDoc.addPage([595, 842]); // A4

//             page.drawText(`${docType} Confirmation`, {
//                 x: 50,
//                 y: 750,
//                 size: 20,
//                 color: rgb(0.1, 0.1, 0.1),
//             });

//             page.drawText(`This document serves as confirmation that the employee has electronically signed the ${docType}.`, {
//                 x: 50,
//                 y: 700,
//                 size: 11,
//                 color: rgb(0.2, 0.2, 0.2),
//             });

//             page.drawText(`Employee Name: ${employeeName}`, {
//                 x: 50,
//                 y: 650,
//                 size: 11,
//             });
//         }

//         // Embed signature image if provided
//         let signatureImage = null;
//         if (signaturePngDataUrl) {
//             try {
//                 const isJpg = signaturePngDataUrl.startsWith('data:image/jpeg') || signaturePngDataUrl.startsWith('data:image/jpg');
//                 const signatureBytes = base64ToUint8Array(signaturePngDataUrl);
//                 if (signatureBytes.length > 0) {
//                     if (isJpg) {
//                         signatureImage = await pdfDoc.embedJpg(signatureBytes);
//                     } else {
//                         signatureImage = await pdfDoc.embedPng(signatureBytes);
//                     }
//                 }
//             } catch (imgErr) {
//                 console.warn("Failed to embed signature PNG into PDF:", imgErr);
//             }
//         }

//         // Get all pages
//         const pages = pdfDoc.getPages();
//         if (pages.length === 0) {
//             throw new Error("PDF document has no pages");
//         }
//         const lastPage = pages[pages.length - 1];

//         const currentDate = extraDetails?.date || formatDateMMDDYYYY();
//         const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//         const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//         // Draw signature image and audit text on every page at the footer in the empty space (skip for Offer Letter)
//         if (signatureImage && docType !== 'Offer Letter') {
//             const auditText = `Signed by ${employeeName} on ${currentDate}`;
//             pages.forEach((page) => {
//                 page.drawImage(signatureImage, {
//                     x: 195,
//                     y: 20,
//                     width: 100,
//                     height: 35,
//                 });
//                 page.drawText(auditText, {
//                     x: 195,
//                     y: 12,
//                     size: 7,
//                     font,
//                     color: rgb(0.2, 0.3, 0.4),
//                 });
//             });
//         }

//         // Draw main signature image and texts on the last page
//         if (docType === 'Employee Agreement') {
//             // 1. Draw dynamic Joining Date on Page 1
//             const rawJoiningDate = extraDetails?.joiningDate || extraDetails?.joining_date || extraDetails?.JoiningDate || extraDetails?.hireDate;
//             if (pages.length > 0) {
//                 const firstPage = pages[0];
//                 const formattedJoiningDate = formatAgreementJoiningDate(rawJoiningDate);
//                 // Cover blank underline area starting precisely after "this "
//                 firstPage.drawRectangle({
//                     x: 388.8,
//                     y: 555,
//                     width: 135,
//                     height: 14,
//                     color: rgb(1, 1, 1),
//                 });
//                 // Draw joining date text starting precisely at x: 389.11
//                 firstPage.drawText(formattedJoiningDate, {
//                     x: 389.11,
//                     y: 559.54,
//                     size: 8.8,
//                     font,
//                     color: rgb(0, 0, 0),
//                 });
//             }

//             // Draw Employee Name text
//             lastPage.drawText(employeeName, {
//                 x: 145,
//                 y: 493,
//                 size: 9,
//                 font: fontBold,
//                 color: rgb(0, 0, 0),
//             });

//             // Draw Date text on last page (in front of Date: lines at y: 470.95 and y: 320.21)
//             const formattedDateForLastPage = rawJoiningDate ? formatJoiningDateShort(rawJoiningDate) : currentDate;

//             // Employee Date: line
//             lastPage.drawText(formattedDateForLastPage, {
//                 x: 105,
//                 y: 475,
//                 size: 9,
//                 font: fontBold,
//                 color: rgb(0, 0, 0),
//             });

//             // Director HR Date: line
//             lastPage.drawText(formattedDateForLastPage, {
//                 x: 95,
//                 y: 320.21,
//                 size: 9,
//                 font: fontBold,
//                 color: rgb(0, 0, 0),
//             });

//             if (signatureImage) {
//                 lastPage.drawImage(signatureImage, {
//                     x: 160,
//                     y: 500,
//                     width: 140,
//                     height: 28,
//                 });

//                 // Draw audit text below the signature on the last page
//                 lastPage.drawText(`Digitally signed by ${employeeName} on ${new Date().toLocaleString()}`, {
//                     x: 70.82,
//                     y: 455,
//                     size: 8,
//                     font,
//                     color: rgb(0.3, 0.4, 0.5), // Slate-gray
//                 });
//             }
//         } else if (docType === 'Offer Letter') {
//             if (isIndia) {
//                 const fullNameToDraw = extraDetails?.fullName || employeeName || '';
//                 const aadhaarToDraw = extraDetails?.aadhaarNumber || extraDetails?.aadhaar || extraDetails?.ssn || '';
//                 const dateToDraw = (extraDetails && typeof extraDetails.date === 'string') ? extraDetails.date : currentDate;

//                 // 1. Draw signature image on Signature: line (only after candidate signs)
//                 if (signatureImage) {
//                     lastPage.drawImage(signatureImage, {
//                         x: 105,
//                         y: 335,
//                         width: 110,
//                         height: 28,
//                     });
//                 }

//                 // 2. Draw Full Name (First + Middle + Last) on Full Name (as per Identity Card / Passport): line (pre-filled)
//                 if (fullNameToDraw) {
//                     lastPage.drawText(fullNameToDraw, {
//                         x: 225,
//                         y: 320,
//                         size: 10,
//                         font,
//                         color: rgb(0, 0, 0),
//                     });
//                 }

//                 // 3. Draw Aadhaar Number on Aadhaar Number: line (pre-filled)
//                 if (aadhaarToDraw) {
//                     lastPage.drawText(aadhaarToDraw, {
//                         x: 150,
//                         y: 297,
//                         size: 10,
//                         font,
//                         color: rgb(0, 0, 0),
//                     });
//                 }

//                 // 4. Draw Date on Date: line (only after candidate signs)
//                 if (dateToDraw) {
//                     lastPage.drawText(dateToDraw, {
//                         x: 80,
//                         y: 275,
//                         size: 10,
//                         font,
//                         color: rgb(0, 0, 0),
//                     });
//                 }

//                 // USA & India Offer Letter: Draw bottom signature + digital audit text in clean space
//                 if (signatureImage) {
//                     lastPage.drawImage(signatureImage, {
//                         x: 80,
//                         y: 150,
//                         width: 130,
//                         height: 38,
//                     });

//                     lastPage.drawText(`Digitally signed by ${fullNameToDraw} on ${new Date().toLocaleString()}`, {
//                         x: 80,
//                         y: 136,
//                         size: 8,
//                         font,
//                         color: rgb(0.1, 0.3, 0.6), // Slate-blue
//                     });
//                 }
//             } else {
//                 if (signatureImage) {
//                     lastPage.drawImage(signatureImage, {
//                         x: 80,
//                         y: 150,
//                         width: 130,
//                         height: 38,
//                     });

//                     lastPage.drawText(`Digitally signed by ${employeeName} on ${new Date().toLocaleString()}`, {
//                         x: 80,
//                         y: 136,
//                         size: 8,
//                         font,
//                         color: rgb(0.1, 0.3, 0.6), // Slate-blue
//                     });
//                 }
//             }
//         } else {
//             if (signatureImage) {
//                 lastPage.drawImage(signatureImage, {
//                     x: 75,
//                     y: 120,
//                     width: 150,
//                     height: 55,
//                 });

//                 // Draw audit text below the signature on the last page
//                 lastPage.drawText(`Digitally signed by ${employeeName} on ${new Date().toLocaleString()}`, {
//                     x: 75,
//                     y: 100,
//                     size: 8,
//                     font,
//                     color: rgb(0.3, 0.4, 0.5), // Slate-gray
//                 });
//             }
//         }

//         // Save and return base64
//         const signedPdfBase64 = await pdfDoc.saveAsBase64();
//         return signedPdfBase64;
//     } catch (error) {
//         console.error("Error signing PDF:", error);
//         throw error;
//     }
// };

// const createPoliciesPdf = async (employeeName, signatureDataUrl) => {
//     const pdfDoc = await PDFDocument.create();

//     let page = null;
//     let height = 0;
//     let y = 0;

//     const startNewPage = () => {
//         page = pdfDoc.addPage([600, 850]);
//         height = page.getSize().height;
//         y = height - 50;
//     };

//     startNewPage();

//     // Title
//     page.drawText('GENESIS TECH ENGINEERS PVT. LTD. - COMPANY POLICIES', {
//         x: 50,
//         y,
//         size: 13,
//         color: rgb(0, 0, 0)
//     });
//     y -= 30;

//     // Subtitle
//     page.drawText(`Signed Employee: ${employeeName}`, { x: 50, y, size: 10, color: rgb(0.2, 0.2, 0.2) });
//     page.drawText(`Date: ${new Date().toLocaleDateString()}`, { x: 450, y, size: 10, color: rgb(0.2, 0.2, 0.2) });
//     y -= 25;

//     page.drawText('This document certifies acceptance of the following company policies:', {
//         x: 50,
//         y,
//         size: 10,
//         color: rgb(0.3, 0.3, 0.3)
//     });
//     y -= 20;

//     // Loop over each policy in genesisPoliciesText
//     for (const pol of genesisPoliciesText) {
//         if (y < 80) startNewPage();

//         // Draw Policy Title
//         page.drawText(`${pol.id}. ${pol.title.toUpperCase()}`, {
//             x: 50,
//             y,
//             size: 11,
//             color: rgb(0.05, 0.2, 0.4)
//         });
//         y -= 18;

//         // Draw description lines with word wrapping
//         const textLines = pol.text.split('\n');
//         for (const rawLine of textLines) {
//             const maxLineWidth = 500;
//             const fontSize = 8.5;

//             const words = rawLine.split(' ');
//             let currentLine = '';

//             for (const word of words) {
//                 const testLine = currentLine ? `${currentLine} ${word}` : word;
//                 const approxWidth = testLine.length * 4.5;
//                 if (approxWidth > maxLineWidth) {
//                     if (y < 50) startNewPage();
//                     page.drawText(currentLine, { x: 55, y, size: fontSize, color: rgb(0.15, 0.15, 0.15) });
//                     y -= 13;
//                     currentLine = word;
//                 } else {
//                     currentLine = testLine;
//                 }
//             }

//             if (currentLine) {
//                 if (y < 50) startNewPage();
//                 page.drawText(currentLine, { x: 55, y, size: fontSize, color: rgb(0.15, 0.15, 0.15) });
//                 y -= 13;
//             }
//         }
//         y -= 10;
//     }

//     // Draw signature section at the end
//     if (y < 150) startNewPage();
//     y -= 30;
//     page.drawText('EMPLOYEE SIGN-OFF & ACCEPTANCE', { x: 50, y, size: 10, color: rgb(0, 0, 0) });
//     y -= 20;
//     page.drawText(`I, ${employeeName}, hereby acknowledge that I have read, understood, and accept all 11 company policies detailed in this document.`, {
//         x: 50,
//         y,
//         size: 8.5,
//         color: rgb(0.2, 0.2, 0.2)
//     });
//     y -= 40;

//     if (signatureDataUrl && signatureDataUrl.startsWith('data:image')) {
//         try {
//             const isJpg = signatureDataUrl.startsWith('data:image/jpeg') || signatureDataUrl.startsWith('data:image/jpg');
//             const signatureBytes = base64ToUint8Array(signatureDataUrl);
//             if (signatureBytes.length > 0) {
//                 let pngImage;
//                 try {
//                     if (isJpg) {
//                         pngImage = await pdfDoc.embedJpg(signatureBytes);
//                     } else {
//                         pngImage = await pdfDoc.embedPng(signatureBytes);
//                     }
//                 } catch (embedErr) {
//                     console.warn("Primary image embedding failed, attempting embedPng fallback:", embedErr);
//                     pngImage = await pdfDoc.embedPng(signatureBytes);
//                 }

//                 // Scale image down to fit nicely within 160x50 signature bounds
//                 let sigWidth = pngImage.width;
//                 let sigHeight = pngImage.height;
//                 const maxW = 160;
//                 const maxH = 50;
//                 const scaleFactor = Math.min(maxW / sigWidth, maxH / sigHeight, 0.5);
//                 sigWidth = sigWidth * scaleFactor;
//                 sigHeight = sigHeight * scaleFactor;

//                 if (y - sigHeight < 50) startNewPage();
//                 page.drawImage(pngImage, {
//                     x: 50,
//                     y: y - sigHeight,
//                     width: sigWidth,
//                     height: sigHeight
//                 });
//                 y -= (sigHeight + 15);
//                 page.drawText('--------------------------------------', { x: 50, y, size: 10, color: rgb(0.4, 0.4, 0.4) });
//                 y -= 15;
//                 page.drawText(`Employee Signature: ${employeeName}`, { x: 50, y, size: 9, color: rgb(0.1, 0.1, 0.1) });
//             }
//         } catch (e) {
//             console.error("Failed to embed signature in policies PDF:", e);
//         }
//     }

//     const pdfBytes = await pdfDoc.save();

//     // Convert binary to base64 safely
//     let binary = '';
//     const bytes = new Uint8Array(pdfBytes);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     const base64 = btoa(binary);
//     return base64;
// };

// const EmployeeDashboard = ({ activeTab, setActiveTab, onStartTour, onStartVideoTour }) => {
//     const [loading, setLoading] = useState(true);
//     const [uploadingPhoto, setUploadingPhoto] = useState(false);
//     const [data, setData] = useState(null);
//     const [dashboardStats, setDashboardStats] = useState(null);
//     const [toast, setToast] = useState(null);
//     const [showSubmitConfirm, setShowSubmitConfirm] = useState(false);
//     const [showRequestedDocsModal, setShowRequestedDocsModal] = useState(false);
//     const [hasSeenRequestedDocsModal, setHasSeenRequestedDocsModal] = useState(false);
//     const [requestedDocsSubmitted, setRequestedDocsSubmitted] = useState(false);
//     const [submitStatus, setSubmitStatus] = useState('idle'); // 'idle', 'submitting', 'success', 'error'
//     const [submitErrorMessage, setSubmitErrorMessage] = useState('');
//     const [offerLetterBlobUrl, setOfferLetterBlobUrl] = useState('');
//     const [employeeAgreementBlobUrl, setEmployeeAgreementBlobUrl] = useState('');
//     const [selectedAgreementKey, setSelectedAgreementKey] = useState('');
//     const [agreementBlobUrls, setAgreementBlobUrls] = useState({});

//     // Forms state
//     const [personalForm, setPersonalForm] = useState({
//         first_name: '', middle_name: '', last_name: '', preferred_name: '', dob: '', gender: '', pronouns: '',
//         marital_status: '', citizenship: '', phone: '', personal_email: '', address: '',
//         city: '', state: '', zip: '', country: ''
//     });

//     const [emergencyContacts, setEmergencyContacts] = useState([]);
//     const [bankForm, setBankForm] = useState({ bank_name: '', routing_number: '', account_number: '', account_type: 'CHECKING', bank_branch_address: '' });
//     const [taxForm, setTaxForm] = useState({
//         federal_tax_status: 'SINGLE',
//         federal_allowances: 0,
//         state_tax_status: 'SINGLE',
//         state_allowances: 0,
//         name: '',
//         ssn: '',
//         address: '',
//         city: '',
//         state: '',
//         zip: '',
//         arizona_box_selection: 1,
//         arizona_percentage: 2.0,
//         arizona_extra_amount_checked: false,
//         arizona_extra_amount: '',
//         signature: ''
//     });
//     const [expandedPolicyId, setExpandedPolicyId] = useState(null);
//     const [selectedPolicyId, setSelectedPolicyId] = useState(1);
//     const [viewedPolicyIds, setViewedPolicyIds] = useState([1]);

//     // US Form I-9 States
//     const [i9Attestation, setI9Attestation] = useState('US_Citizen');
//     const [uscisNumber, setUscisNumber] = useState('');
//     const [i9Method, setI9Method] = useState('list_a');
//     const [listADocType, setListADocType] = useState('Passport');
//     const [listBDocType, setListBDocType] = useState('Driver License');
//     const [listCDocType, setListCDocType] = useState('Social Security Card');
//     const [selectedState, setSelectedState] = useState('');
//     const [selectedIdOption, setSelectedIdOption] = useState('');
//     const [agreementTemplateBytes, setAgreementTemplateBytes] = useState(null);
//     const [indiaAgreementTemplateBytes, setIndiaAgreementTemplateBytes] = useState(null);
//     const [ndaTemplateBytes, setNdaTemplateBytes] = useState(null);
//     const [conflictTemplateBytes, setConflictTemplateBytes] = useState(null);
//     const [benefitsTemplateBytes, setBenefitsTemplateBytes] = useState(null);
//     const [nonSolicitationTemplateBytes, setNonSolicitationTemplateBytes] = useState(null);
//     const [employmentForm, setEmploymentForm] = useState({
//         employeeName: '',
//         position: '',
//         department: '',
//         primaryLocation: '',
//         employmentClassification: '',
//         effectiveDate: new Date().toLocaleDateString('en-US'),
//         outsideEmploymentType: 'none',
//         outsideEmployer: '',
//         outsideNature: '',
//         outsideHours: '',
//         ownershipType: 'no',
//         ownershipDescribe: '',
//         competingType: 'no',
//         competingDescribe: '',
//         otherConflicts: '',
//         employeeId: '',
//         hireDate: '',
//         medicalElection: 'enrol',
//         medicalWaiveReason: 'spouse_plan',
//         medicalWaiveReasonOther: '',
//         dentalElection: 'enrol',
//         visionElection: 'enrol',
//         retirementElection: 'participate',
//         retirementContributionType: 'percentage',
//         retirementContributionPercent: '',
//         retirementContributionAmount: '',
//         primaryBeneName: '',
//         primaryBeneRelationship: '',
//         primaryBeneDob: '',
//         primaryBenePercent: '',
//         contingentBeneName: '',
//         contingentBeneRelationship: '',
//         contingentBeneDob: '',
//         contingentBenePercent: ''
//     });

//     const fetchOnboardingData = useCallback(async () => {
//         try {
//             const res = await api.get('/onboarding');
//             setData(res.data);

//             // Bind states
//             if (res.data.profile) {
//                 setPersonalForm(prev => ({
//                     first_name: prev.first_name || res.data.profile.first_name || res.data.employee?.FirstName || '',
//                     middle_name: prev.middle_name || res.data.profile.middle_name || '',
//                     last_name: prev.last_name || res.data.profile.last_name || res.data.employee?.LastName || '',
//                     preferred_name: prev.preferred_name || res.data.profile.preferred_name || '',
//                     dob: prev.dob || res.data.profile.dob || '',
//                     gender: prev.gender || res.data.profile.gender || '',
//                     pronouns: prev.pronouns || res.data.profile.pronouns || '',
//                     marital_status: prev.marital_status || res.data.profile.marital_status || '',
//                     citizenship: prev.citizenship || res.data.profile.citizenship || '',
//                     ssn: prev.ssn || res.data.profile.ssn || '',
//                     phone: prev.phone || res.data.profile.phone || '',
//                     personal_email: prev.personal_email || res.data.profile.personal_email || '',
//                     address: prev.address || res.data.profile.address || '',
//                     city: prev.city || res.data.profile.city || '',
//                     state: prev.state || res.data.profile.state || '',
//                     zip: prev.zip || res.data.profile.zip || '',
//                     country: prev.country || res.data.profile.country || ''
//                 }));

//                 // Initialize I-9 attestation options if saved
//                 if (res.data.profile.citizenship) {
//                     if (res.data.profile.citizenship.includes('US_National')) {
//                         setI9Attestation('US_National');
//                     } else if (res.data.profile.citizenship.includes('LPR')) {
//                         setI9Attestation('LPR');
//                         const match = res.data.profile.citizenship.match(/\(([^)]+)\)/);
//                         if (match) setUscisNumber(match[1]);
//                     } else if (res.data.profile.citizenship.includes('Authorized_Alien')) {
//                         setI9Attestation('Authorized_Alien');
//                         const match = res.data.profile.citizenship.match(/\(([^)]+)\)/);
//                         if (match) setUscisNumber(match[1]);
//                     } else {
//                         setI9Attestation('US_Citizen');
//                     }
//                 }
//             } else {
//                 setPersonalForm(prev => ({
//                     ...prev,
//                     first_name: prev.first_name || res.data.employee?.FirstName || '',
//                     last_name: prev.last_name || res.data.employee?.LastName || ''
//                 }));
//             }

//             if (res.data.contacts && res.data.contacts.length > 0) setEmergencyContacts(res.data.contacts);
//             if (res.data.bank) {
//                 const isIndiaCandidate = ((res.data.employee?.country || res.data.profile?.country || '').toUpperCase()) === 'INDIA';
//                 setBankForm(prev => ({
//                     bank_name: prev.bank_name || res.data.bank.bank_name || '',
//                     routing_number: prev.routing_number || res.data.bank.routing_number || '',
//                     account_number: prev.account_number || res.data.bank.account_number || '',
//                     account_type: (prev.account_type && prev.account_type !== 'CHECKING') ? prev.account_type : ((isIndiaCandidate && (!res.data.bank.account_type || res.data.bank.account_type === 'CHECKING')) ? 'SAVINGS' : (res.data.bank.account_type || 'CHECKING')),
//                     bank_branch_address: prev.bank_branch_address || res.data.bank.bank_branch_address || ''
//                 }));
//             }
//             if (res.data.tax) {
//                 let sigPath = res.data.tax.signature_path || '';
//                 if (sigPath && sigPath.startsWith('uploads/')) {
//                     try {
//                         const imgRes = await api.get('/onboarding/tax-signature', { responseType: 'arraybuffer' });
//                         const base64 = btoa(
//                             new Uint8Array(imgRes.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
//                         );
//                         sigPath = `data:image/png;base64,${base64}`;
//                     } catch (e) {
//                         console.error('Failed to load saved signature image:', e);
//                         let errMsg = e.message;
//                         if (e.response?.data instanceof ArrayBuffer) {
//                             try {
//                                 const decoded = new TextDecoder('utf-8').decode(e.response.data);
//                                 const parsed = JSON.parse(decoded);
//                                 if (parsed.error) errMsg = parsed.error;
//                             } catch (parseErr) { }
//                         }
//                         setToast({ message: 'Signature load error: ' + errMsg, type: 'error' });
//                     }
//                 } else if (sigPath && sigPath.startsWith('typed:')) {
//                     sigPath = sigPath.substring(6);
//                 }

//                 setTaxForm({
//                     federal_tax_status: res.data.tax.federal_tax_status || 'SINGLE',
//                     federal_allowances: res.data.tax.federal_allowances || 0,
//                     state_tax_status: res.data.tax.state_tax_status || 'SINGLE',
//                     state_allowances: res.data.tax.state_allowances || 0,
//                     name: res.data.tax.name || (res.data.profile ? `${res.data.profile.first_name || ''} ${res.data.profile.last_name || ''}`.trim() : ''),
//                     ssn: res.data.tax.ssn || res.data.profile?.ssn || '',
//                     address: res.data.tax.address || res.data.profile?.address || '',
//                     city: res.data.tax.city || res.data.profile?.city || '',
//                     state: res.data.tax.state || res.data.profile?.state || '',
//                     zip: res.data.tax.zip || res.data.profile?.zip || '',
//                     arizona_box_selection: res.data.tax.arizona_box_selection !== null && res.data.tax.arizona_box_selection !== undefined ? parseInt(res.data.tax.arizona_box_selection) : 1,
//                     arizona_percentage: res.data.tax.arizona_percentage !== null && res.data.tax.arizona_percentage !== undefined ? parseFloat(res.data.tax.arizona_percentage) : 2.0,
//                     arizona_extra_amount_checked: !!parseInt(res.data.tax.arizona_extra_amount_checked || 0),
//                     arizona_extra_amount: res.data.tax.arizona_extra_amount !== null && res.data.tax.arizona_extra_amount !== undefined ? res.data.tax.arizona_extra_amount.toString() : '',
//                     signature: sigPath
//                 });
//             } else {
//                 setTaxForm(prev => ({
//                     ...prev,
//                     name: res.data.profile ? `${res.data.profile.first_name || ''} ${res.data.profile.last_name || ''}`.trim() : '',
//                     ssn: res.data.profile?.ssn || '',
//                     address: res.data.profile?.address || '',
//                     city: res.data.profile?.city || '',
//                     state: res.data.profile?.state || '',
//                     zip: res.data.profile?.zip || '',
//                 }));
//             }

//             // Fetch dashboard metrics
//             const statsRes = await api.get('/dashboard/employee');
//             setDashboardStats(statsRes.data);

//             // Convert base64 fields to Blob URLs to avoid data URI issues in iframes
//             if (res.data.employee) {
//                 setEmploymentForm(prev => ({
//                     employeeName: prev.employeeName || `${res.data.employee.FirstName || ''} ${res.data.employee.LastName || ''}`.trim(),
//                     position: prev.position || res.data.employee.Designation || res.data.employee.position || '',
//                     department: prev.department || res.data.employee.Department || res.data.employee.department || '',
//                     primaryLocation: '',
//                     employmentClassification: '',
//                     effectiveDate: prev.effectiveDate || new Date().toLocaleDateString('en-US'),
//                     outsideEmploymentType: prev.outsideEmploymentType || 'none',
//                     outsideEmployer: prev.outsideEmployer || '',
//                     outsideNature: prev.outsideNature || '',
//                     outsideHours: prev.outsideHours || '',
//                     ownershipType: prev.ownershipType || 'no',
//                     ownershipDescribe: prev.ownershipDescribe || '',
//                     competingType: prev.competingType || 'no',
//                     competingDescribe: prev.competingDescribe || '',
//                     otherConflicts: prev.otherConflicts || '',
//                     employeeId: prev.employeeId || res.data.employee.id || '',
//                     hireDate: res.data.employee.joining_date || res.data.employee.JoiningDate || res.data.employee.joining_Date || res.data.employee.joiningDate || res.data.employee.joining || res.data.employee.hire_date || res.data.employee.HireDate || prev.hireDate || '',
//                     medicalElection: prev.medicalElection || 'enrol',
//                     medicalWaiveReason: prev.medicalWaiveReason || 'spouse_plan',
//                     medicalWaiveReasonOther: prev.medicalWaiveReasonOther || '',
//                     dentalElection: prev.dentalElection || 'enrol',
//                     visionElection: prev.visionElection || 'enrol',
//                     retirementElection: prev.retirementElection || 'participate',
//                     retirementContributionType: prev.retirementContributionType || 'percentage',
//                     retirementContributionPercent: prev.retirementContributionPercent || '',
//                     retirementContributionAmount: prev.retirementContributionAmount || '',
//                     primaryBeneName: prev.primaryBeneName || '',
//                     primaryBeneRelationship: prev.primaryBeneRelationship || '',
//                     primaryBeneDob: prev.primaryBeneDob || '',
//                     primaryBenePercent: prev.primaryBenePercent || '',
//                     contingentBeneName: prev.contingentBeneName || '',
//                     contingentBeneRelationship: prev.contingentBeneRelationship || '',
//                     contingentBeneDob: prev.contingentBeneDob || '',
//                     contingentBenePercent: prev.contingentBenePercent || ''
//                 }));
//                 // Offer Letter
//                 const isOfferSigned = res.data.signature_history?.some(
//                     h => h.document_type === 'Offer Letter' && h.action === 'SIGN'
//                 );
//                 const signedOfferBase64 = res.data.signed_agreements?.['Offer Letter'];
//                 const rawPath = res.data.employee?.offer_letter || res.data.employee?.offer_letter_path;
//                 let realOfferUrl = '';
//                 if (rawPath) {
//                     let cleanPath = rawPath.replace(/^\//, '');
//                     if (!cleanPath.startsWith('http://') && !cleanPath.startsWith('https://')) {
//                         cleanPath = cleanPath.startsWith('offer_letters/')
//                             ? `https://hiring.gtelinq.com/hiring-backend/${cleanPath}`
//                             : `/EOP_api/${cleanPath}`;
//                     }
//                     realOfferUrl = cleanPath;
//                 }

//                 const fName = personalForm.first_name || res.data.profile?.first_name || res.data.employee?.FirstName || res.data.employee?.first_name || '';
//                 const mName = personalForm.middle_name || res.data.profile?.middle_name || res.data.employee?.MiddleName || res.data.employee?.middle_name || '';
//                 const lName = personalForm.last_name || res.data.profile?.last_name || res.data.employee?.LastName || res.data.employee?.last_name || '';
//                 const fullName = [fName, mName, lName].filter(Boolean).join(' ').trim() || 'Employee';
//                 const aadhaarNumber = personalForm.ssn || res.data.profile?.ssn || res.data.employee?.ssn || res.data.employee?.AadhaarNumber || res.data.employee?.aadhaar_number || '';
//                 const isIndiaCandidate = ((res.data.employee?.country || res.data.profile?.country || '').toUpperCase()) === 'INDIA';

//                 let offerUrlToSet = '';
//                 if (isOfferSigned) {
//                     if (signedOfferBase64) {
//                         offerUrlToSet = base64ToBlobUrl(signedOfferBase64);
//                     } else {
//                         const sigObj = res.data.signature_history?.find(h => h.document_type === 'Offer Letter' && h.action === 'SIGN');
//                         const sigData = sigObj?.signature_path || '';
//                         let sigPng = sigData;
//                         if (sigData && !sigData.startsWith('data:image')) {
//                             sigPng = convertTypedToPng(sigData);
//                         }
//                         const signedDate = sigObj?.signed_at || sigObj?.created_at;
//                         const formattedDate = formatDateMMDDYYYY(signedDate);

//                         let baseToSign = res.data.employee?.offer_letter_base64 || '';
//                         if (!baseToSign && realOfferUrl) {
//                             try {
//                                 baseToSign = await fetchLocalPdfAsBase64(realOfferUrl);
//                             } catch (e) {
//                                 console.error("Failed to fetch real offer letter PDF for overlay:", e);
//                             }
//                         }

//                         if (baseToSign && (sigPng || isIndiaCandidate)) {
//                             try {
//                                 const signedPdfBase64 = await applySignatureToPdf(baseToSign, sigPng, fullName, 'Offer Letter', isIndiaCandidate, {
//                                     fullName,
//                                     aadhaarNumber,
//                                     date: formattedDate
//                                 });
//                                 offerUrlToSet = base64ToBlobUrl(signedPdfBase64);
//                             } catch (err) {
//                                 console.error("Failed to generate signed PDF:", err);
//                                 offerUrlToSet = realOfferUrl;
//                             }
//                         } else {
//                             offerUrlToSet = realOfferUrl;
//                         }
//                     }
//                 } else {
//                     // Pre-sign preview: For India candidates, pre-fill Full Name and Aadhaar Number on the PDF template
//                     let baseToSign = res.data.employee?.offer_letter_base64 || '';
//                     if (!baseToSign && realOfferUrl) {
//                         try {
//                             baseToSign = await fetchLocalPdfAsBase64(realOfferUrl);
//                         } catch (e) {
//                             console.error("Failed to fetch real offer letter PDF for preview:", e);
//                         }
//                     }

//                     if (baseToSign && isIndiaCandidate) {
//                         try {
//                             const prefilledPdfBase64 = await applySignatureToPdf(baseToSign, null, fullName, 'Offer Letter', true, {
//                                 fullName,
//                                 aadhaarNumber,
//                                 date: ''
//                             });
//                             offerUrlToSet = base64ToBlobUrl(prefilledPdfBase64);
//                         } catch (err) {
//                             console.error("Failed to generate pre-filled offer letter preview:", err);
//                             offerUrlToSet = realOfferUrl;
//                         }
//                     } else if (res.data.employee?.offer_letter_base64) {
//                         offerUrlToSet = base64ToBlobUrl(res.data.employee.offer_letter_base64);
//                     } else if (realOfferUrl) {
//                         offerUrlToSet = realOfferUrl;
//                     }
//                 }

//                 setOfferLetterBlobUrl(prev => {
//                     if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//                     return offerUrlToSet;
//                 });

//                 // Employee Agreement
//                 const isAgreementSigned = res.data.signature_history?.some(
//                     h => h.document_type === 'Employee Agreement' && h.action === 'SIGN'
//                 );
//                 if (isAgreementSigned && res.data.employee.employee_agreement_base64) {
//                     const agreementUrl = base64ToBlobUrl(res.data.employee.employee_agreement_base64);
//                     setEmployeeAgreementBlobUrl(prev => {
//                         if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//                         return agreementUrl;
//                     });
//                 } else {
//                     // Unsigned fallback: load appropriate template directly from public folder based on country
//                     const country = res.data.employee?.country || '';
//                     const templatePath = country.toUpperCase() === 'USA' ? '/employee_agreement_usa.pdf' : '/3-Employment Agreement.pdf';
//                     setEmployeeAgreementBlobUrl(prev => {
//                         if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//                         return templatePath;
//                     });
//                 }

//                 // Multiple agreements resolution for US candidates
//                 const country = res.data.employee?.country || '';
//                 const isUsa = country.toUpperCase() === 'USA';
//                 const list = isUsa ? [
//                     { key: 'employment_agreement', title: 'Employment Agreement 1', displayName: 'Employment Agreement', path: '/Employment Agreement 1.pdf' },
//                     { key: 'confidentiality_nda', title: 'Employee Confidentiality & NDA (1)', displayName: 'Employee Confidentiality & NDA', path: '/Employee Confidentiality & NDA (1).pdf' },
//                     { key: 'conflict_of_interest', title: 'Conflict of interest agreement', path: '/Conflict of interest agreement.pdf' },
//                     { key: '401k_dental_vision_medical', title: '401K Dental Vision Medical', path: '/401K Dental Vision Medical.pdf' },
//                     { key: 'non_solicitation', title: 'Non Solicitation', path: '/Non Solicitation.pdf' }
//                 ] : [
//                     { key: 'employee_agreement', title: 'Employee Agreement', path: '/3-Employment Agreement.pdf' }
//                 ];

//                 const urls = {};
//                 for (const item of list) {
//                     const signedBase64 = res.data.signed_agreements?.[item.title];
//                     const legacyBase64 = (item.title === 'Employee Agreement' && isAgreementSigned && res.data.employee?.employee_agreement_base64) ? res.data.employee.employee_agreement_base64 : null;
//                     const base64Data = signedBase64 || legacyBase64;
//                     if (base64Data) {
//                         urls[item.key] = base64ToBlobUrl(base64Data);
//                     } else if (item.key === 'employee_agreement') {
//                         try {
//                             let tBytes = indiaAgreementTemplateBytes;
//                             if (!tBytes) {
//                                 const resp = await fetch('/3-Employment Agreement.pdf');
//                                 const ab = await resp.arrayBuffer();
//                                 tBytes = new Uint8Array(ab);
//                                 setIndiaAgreementTemplateBytes(tBytes);
//                             }
//                             let binary = '';
//                             const len = tBytes.byteLength;
//                             for (let i = 0; i < len; i++) {
//                                 binary += String.fromCharCode(tBytes[i]);
//                             }
//                             const templateBase64 = btoa(binary);
//                             const emp = res.data.employee || {};
//                             const jDateStr = emp.joining_date || emp.JoiningDate || emp.joining_Date || emp.joiningDate || emp.joining || emp.hire_date || emp.HireDate || '2025-11-21';
//                             const fName = [
//                                 res.data.profile?.first_name || emp.FirstName || emp.first_name || '',
//                                 res.data.profile?.middle_name || emp.MiddleName || emp.middle_name || '',
//                                 res.data.profile?.last_name || emp.LastName || emp.last_name || ''
//                             ].filter(Boolean).join(' ').trim() || 'Employee';

//                             const prefilledBase64 = await applySignatureToPdf(
//                                 templateBase64,
//                                 null,
//                                 fName,
//                                 'Employee Agreement',
//                                 true,
//                                 {
//                                     joiningDate: jDateStr,
//                                     date: formatDateMMDDYYYY()
//                                 }
//                             );
//                             urls[item.key] = base64ToBlobUrl(prefilledBase64);
//                         } catch (prefilledErr) {
//                             console.error("Failed to generate prefilled agreement Blob URL in fetchOnboardingData:", prefilledErr);
//                             urls[item.key] = item.path;
//                         }
//                     } else {
//                         urls[item.key] = item.path;
//                     }
//                 }
//                 setAgreementBlobUrls(prev => {
//                     Object.entries(prev).forEach(([key, url]) => {
//                         if (url && url.startsWith('blob:') && url !== urls[key]) {
//                             URL.revokeObjectURL(url);
//                         }
//                     });
//                     return urls;
//                 });
//                 setSelectedAgreementKey(prev => {
//                     const keys = list.map(item => item.key);
//                     if (prev && keys.includes(prev)) return prev;
//                     return keys[0] || '';
//                 });
//             }

//             // Automatically select state in dropdown if a state tax form is already uploaded
//             if (res.data.documents) {
//                 const existing = res.data.documents.find(doc =>
//                     doc.document_type === 'Oregon State Tax Form' ||
//                     doc.document_type === 'Arizona State Tax Form' ||
//                     doc.document_type === 'Colorado State Tax Form'
//                 );
//                 if (existing) {
//                     if (existing.document_type === 'Oregon State Tax Form') setSelectedState('oregon');
//                     else if (existing.document_type === 'Arizona State Tax Form') setSelectedState('arizona');
//                     else if (existing.document_type === 'Colorado State Tax Form') setSelectedState('colorado');
//                 }
//             }

//             // Check for pending requested documents to show popup alert
//             const reqList = res.data?.requested_documents || res.data?.requested_employee_documents || [];
//             const pendingReqs = reqList.filter(req => {
//                 const rStatus = (req.status || '').toUpperCase();
//                 const rName = (req.document_name || req.document_type || req.title || req.name || '').trim();
//                 const isUploadedInEmpDocs = res.data?.documents?.some(d => d.document_type === rName);
//                 return rStatus !== 'UPLOADED' && !isUploadedInEmpDocs;
//             });

//             if (pendingReqs.length > 0 && !hasSeenRequestedDocsModal) {
//                 setShowRequestedDocsModal(true);
//             }
//             window.dispatchEvent(new Event('onboarding_updated'));
//         } catch (err) {
//             setToast({ message: 'Failed to load onboarding profile details.', type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     }, [hasSeenRequestedDocsModal]);

//     useEffect(() => {
//         fetchOnboardingData();
//     }, [fetchOnboardingData, activeTab]);

//     // Cleanup Blob URLs on unmount
//     useEffect(() => {
//         return () => {
//             setOfferLetterBlobUrl(prev => {
//                 if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//                 return '';
//             });
//             setEmployeeAgreementBlobUrl(prev => {
//                 if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//                 return '';
//             });
//             setAgreementBlobUrls(prev => {
//                 Object.values(prev).forEach(url => {
//                     if (url && url.startsWith('blob:')) URL.revokeObjectURL(url);
//                 });
//                 return {};
//             });
//         };
//     }, []);

//     const isLocked = dashboardStats?.status === 'PENDING_HR_REVIEW' || dashboardStats?.status === 'COMPLETED';

//     // Save Personal Info (with SSN & I-9 validation)
//     const handleSavePersonal = async (e) => {
//         e.preventDefault();
//         if (isLocked) return;
//         try {
//             await api.post('/onboarding/personal', personalForm);
//             setToast({ message: 'Personal Information saved successfully!', type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: err.response?.data?.error || 'Failed to save personal info.', type: 'error' });
//         }
//     };

//     const handleSaveI9Attestation = async () => {
//         if (isLocked) return;
//         try {
//             const citizenVal = `${i9Attestation}${uscisNumber ? ' (' + uscisNumber + ')' : ''}`;
//             await api.post('/onboarding/personal', {
//                 ...personalForm,
//                 citizenship: citizenVal
//             });
//             setToast({ message: 'Form I-9 Eligibility attestation recorded successfully!', type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: 'Failed to save Form I-9 attestation.', type: 'error' });
//         }
//     };

//     // Save Emergency Contacts
//     const handleSaveContacts = async (e) => {
//         e.preventDefault();
//         if (isLocked) return;
//         try {
//             await api.post('/onboarding/contacts', emergencyContacts);
//             setToast({ message: 'Emergency Contacts saved successfully!', type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: err.response?.data?.error || 'Failed to save emergency contacts.', type: 'error' });
//         }
//     };

//     const handleAddContact = () => {
//         if (isLocked) return;
//         setEmergencyContacts([...emergencyContacts, { name: '', relationship: '', phone: '', email: '', address: '' }]);
//     };

//     const handleRemoveContact = (index) => {
//         if (isLocked) return;
//         const updated = emergencyContacts.filter((_, idx) => idx !== index);
//         setEmergencyContacts(updated);
//     };

//     const handleContactChange = (index, field, value) => {
//         if (isLocked) return;
//         const updated = emergencyContacts.map((c, idx) => {
//             if (idx === index) return { ...c, [field]: value };
//             return c;
//         });
//         setEmergencyContacts(updated);
//     };

//     // Save Bank Info
//     const handleSaveBank = async (e) => {
//         if (e && e.preventDefault) e.preventDefault();
//         if (isLocked) return;
//         if (!bankForm.bank_name || !bankForm.routing_number || !bankForm.account_number || !bankForm.bank_branch_address) {
//             setToast({ message: 'Please fill in all required bank detail fields.', type: 'error' });
//             return;
//         }
//         const hasVoidCheque = data?.documents?.some(doc => doc.document_type === 'Void Cheque' && doc.file_path && doc.file_path !== 'NOT_AVAILABLE');
//         if (!hasVoidCheque) {
//             setToast({ message: 'Please upload Cancelled Cheque / Bank Account Proof.', type: 'error' });
//             return;
//         }
//         try {
//             await api.post('/onboarding/bank', bankForm);
//             setToast({ message: 'Bank Details saved successfully!', type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: err.response?.data?.error || 'Failed to save bank setup.', type: 'error' });
//         }
//     };

//     // PDF state variables
//     const [templateBytes, setTemplateBytes] = useState(null);
//     const [pdfPreviewUrl, setPdfPreviewUrl] = useState('');
//     const [pdfBase64, setPdfBase64] = useState('');

//     // Load Arizona A-4 template once when activeTab is 'tax'
//     useEffect(() => {
//         if (activeTab === 'tax' && !templateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const res = await api.get('/onboarding/tax-template', { responseType: 'arraybuffer' });
//                     setTemplateBytes(res.data);
//                 } catch (err) {
//                     console.error('Failed to load PDF template:', err);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [activeTab, templateBytes]);

//     const generatePdfPreview = useCallback(async (formValues) => {
//         if (!templateBytes) return;
//         try {
//             const pdfDoc = await PDFDocument.load(templateBytes);
//             const form = pdfDoc.getForm();
//             const pages = pdfDoc.getPages();
//             const firstPage = pages[0];

//             // Fill text fields
//             const setFieldText = (name, val) => {
//                 try {
//                     const field = form.getTextField(name);
//                     let textVal = val || '';
//                     try {
//                         const maxLen = field.getMaxLength();
//                         if (maxLen && textVal.length > maxLen) {
//                             textVal = textVal.substring(0, maxLen);
//                         }
//                     } catch (e) { }
//                     field.setText(textVal);
//                 } catch (e) {
//                     console.warn(`Could not set text field ${name}:`, e);
//                 }
//             };

//             setFieldText('Name', formValues.name);
//             setFieldText('SSN', formValues.ssn);
//             setFieldText('Address', formValues.address);
//             setFieldText('City', formValues.city);
//             setFieldText('State', formValues.state);
//             setFieldText('Zip', formValues.zip);

//             // Embed ZapfDingbats for drawing checkmark symbols
//             const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);
//             const drawTick = (x, y) => {
//                 try {
//                     firstPage.drawText('\u2714', {
//                         x: x + 1,
//                         y: y + 1,
//                         size: 9.5,
//                         font: dingbatsFont,
//                         color: rgb(0, 0, 0)
//                     });
//                 } catch (e) {
//                     console.error('Failed to draw checkmark:', e);
//                 }
//             };

//             // We explicitly uncheck all interactive fields so PDF viewers do not overlay a cross (X)
//             const clearCheckbox = (name) => {
//                 try {
//                     form.getCheckBox(name).uncheck();
//                 } catch (e) { }
//             };

//             ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'j', 'chkExtraWH'].forEach(clearCheckbox);

//             if (formValues.arizona_box_selection === 1) {
//                 drawTick(35.6678, 585.824); // a (Line 1 check)
//                 const rate = formValues.arizona_percentage;
//                 if (rate === 0.5) drawTick(64.4593, 573.772); // b
//                 else if (rate === 1.0) drawTick(136.469, 573.865); // c
//                 else if (rate === 1.5) drawTick(208.415, 573.865); // d
//                 else if (rate === 2.0) drawTick(280.506, 573.865); // e
//                 else if (rate === 2.5) drawTick(351.469, 573.865); // f
//                 else if (rate === 3.0) drawTick(423.415, 573.865); // g
//                 else if (rate === 3.5) drawTick(495.524, 573.865); // h
//             } else if (formValues.arizona_box_selection === 2) {
//                 drawTick(35.6678, 525.79); // j (Line 2 check)
//             }

//             if (formValues.arizona_extra_amount_checked) {
//                 drawTick(63.1453, 549.593); // chkExtraWH
//                 const amt = parseFloat(formValues.arizona_extra_amount) || 0.0;
//                 const dollarsStr = Math.floor(amt).toString();
//                 const centsVal = Math.round((amt % 1) * 100);
//                 const centsStr = centsVal < 10 ? '0' + centsVal : centsVal.toString();
//                 setFieldText('i', dollarsStr);
//                 setFieldText('i1', centsStr);
//             } else {
//                 setFieldText('i', '');
//                 setFieldText('i1', '');
//             }

//             if (formValues.signature) {
//                 let sigUrl = formValues.signature;
//                 if (!sigUrl.startsWith('data:image')) {
//                     sigUrl = convertTypedToPng(sigUrl);
//                 }

//                 try {
//                     const sigImage = await pdfDoc.embedPng(sigUrl);
//                     firstPage.drawImage(sigImage, {
//                         x: 40,
//                         y: 450,
//                         width: 180,
//                         height: 30
//                     });

//                     const dateFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//                     const dateStr = new Date().toLocaleDateString('en-US');
//                     firstPage.drawText(dateStr, {
//                         x: 435,
//                         y: 455,
//                         size: 10,
//                         font: dateFont,
//                         color: rgb(0, 0, 0)
//                     });
//                 } catch (sigErr) {
//                     console.error('Error embedding signature into PDF:', sigErr);
//                 }
//             }

//             const pdfBytes = await pdfDoc.save();
//             const binaryString = new Uint8Array(pdfBytes).reduce(
//                 (data, byte) => data + String.fromCharCode(byte),
//                 ''
//             );
//             const base64Str = btoa(binaryString);
//             setPdfBase64(base64Str);
//             const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//             const newUrl = URL.createObjectURL(blob);

//             setPdfPreviewUrl(prevUrl => {
//                 if (prevUrl) URL.revokeObjectURL(prevUrl);
//                 return newUrl;
//             });
//         } catch (err) {
//             console.error('Error generating PDF preview:', err);
//         }
//     }, [templateBytes]);

//     // Debounced PDF preview generation
//     useEffect(() => {
//         if (!templateBytes) return;
//         const timer = setTimeout(() => {
//             generatePdfPreview(taxForm);
//         }, 250);
//         return () => clearTimeout(timer);
//     }, [taxForm, templateBytes, generatePdfPreview]);

//     // Revoke Blob URL on unmount
//     useEffect(() => {
//         return () => {
//             setPdfPreviewUrl(prevUrl => {
//                 if (prevUrl) URL.revokeObjectURL(prevUrl);
//                 return '';
//             });
//         };
//     }, []);

//     // Load Employment Agreement 1 template once when activeTab is 'agreement' and selectedAgreementKey is 'employment_agreement'
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'employment_agreement' && !agreementTemplateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const response = await fetch('/Employment Agreement 1.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     setAgreementTemplateBytes(new Uint8Array(arrayBuffer));
//                 } catch (e) {
//                     console.error("Failed to load agreement template:", e);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [activeTab, selectedAgreementKey, agreementTemplateBytes]);

//     // Load India Employment Agreement template once when needed
//     useEffect(() => {
//         if (!indiaAgreementTemplateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const response = await fetch('/3-Employment Agreement.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     setIndiaAgreementTemplateBytes(new Uint8Array(arrayBuffer));
//                 } catch (e) {
//                     console.error("Failed to load India agreement template:", e);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [indiaAgreementTemplateBytes]);

//     // Debounced PDF preview generation for India Employment Agreement
//     useEffect(() => {
//         if (selectedAgreementKey === 'employee_agreement' && indiaAgreementTemplateBytes && data?.employee) {
//             if (data?.signature_history?.some(h => h.document_type === 'Employee Agreement' && h.action === 'SIGN')) {
//                 return;
//             }
//             const timer = setTimeout(async () => {
//                 try {
//                     const emp = data.employee;
//                     const fullName = `${emp.FirstName || ''} ${emp.LastName || ''}`.trim() || 'Employee';
//                     // Convert template bytes to binary base64
//                     let binary = '';
//                     const len = indiaAgreementTemplateBytes.byteLength;
//                     for (let i = 0; i < len; i++) {
//                         binary += String.fromCharCode(indiaAgreementTemplateBytes[i]);
//                     }
//                     const templateBase64 = btoa(binary);

//                     // Generate pre-sign PDF with Name, Date, and dynamic joining date on Page 1
//                     const joiningDateStr = emp.joining_date || emp.JoiningDate || emp.joining_Date || emp.joiningDate || emp.joining || emp.hire_date || emp.HireDate || employmentForm.hireDate;
//                     const base64 = await applySignatureToPdf(
//                         templateBase64,
//                         null, // no signature yet
//                         fullName,
//                         'Employee Agreement',
//                         true,
//                         {
//                             joiningDate: joiningDateStr,
//                             date: formatDateMMDDYYYY()
//                         }
//                     );
//                     const pdfBytes = base64ToUint8Array(base64);
//                     const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//                     const newUrl = URL.createObjectURL(blob);

//                     setAgreementBlobUrls(prev => {
//                         const oldUrl = prev['employee_agreement'];
//                         if (oldUrl && oldUrl.startsWith('blob:')) {
//                             URL.revokeObjectURL(oldUrl);
//                         }
//                         return {
//                             ...prev,
//                             'employee_agreement': newUrl
//                         };
//                     });
//                 } catch (err) {
//                     console.error("Failed to generate India agreement preview:", err);
//                 }
//             }, 250);
//             return () => clearTimeout(timer);
//         }
//     }, [indiaAgreementTemplateBytes, selectedAgreementKey, data, employmentForm.hireDate]);

//     // Debounced PDF preview generation for Employment Agreement 1
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'employment_agreement' && agreementTemplateBytes) {
//             if (data?.signature_history?.some(h => (h.document_type === 'Employment Agreement 1' || h.document_type === 'Employment Agreement') && h.action === 'SIGN')) {
//                 return;
//             }
//             const timer = setTimeout(async () => {
//                 const base64 = await generateAgreementPdfData(agreementTemplateBytes, employmentForm, null);
//                 const pdfBytes = base64ToUint8Array(base64);
//                 const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//                 const newUrl = URL.createObjectURL(blob);

//                 setAgreementBlobUrls(prev => {
//                     const oldUrl = prev['employment_agreement'];
//                     if (oldUrl && oldUrl.startsWith('blob:')) {
//                         URL.revokeObjectURL(oldUrl);
//                     }
//                     return {
//                         ...prev,
//                         'employment_agreement': newUrl
//                     };
//                 });
//             }, 250);
//             return () => clearTimeout(timer);
//         }
//     }, [employmentForm, agreementTemplateBytes, activeTab, selectedAgreementKey, data]);

//     // Load NDA template once when activeTab is 'agreement' and selectedAgreementKey is 'confidentiality_nda'
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'confidentiality_nda' && !ndaTemplateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const response = await fetch('/Employee Confidentiality & NDA (1).pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     setNdaTemplateBytes(new Uint8Array(arrayBuffer));
//                 } catch (e) {
//                     console.error("Failed to load NDA template:", e);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [activeTab, selectedAgreementKey, ndaTemplateBytes]);

//     // Debounced PDF preview generation for Confidentiality & NDA
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'confidentiality_nda' && ndaTemplateBytes) {
//             if (data?.signature_history?.some(h => (h.document_type === 'Employee Confidentiality & NDA (1)' || h.document_type === 'Employee Confidentiality & NDA') && h.action === 'SIGN')) {
//                 return;
//             }
//             const timer = setTimeout(async () => {
//                 const base64 = await generateNdaPdfData(ndaTemplateBytes, employmentForm, null);
//                 const pdfBytes = base64ToUint8Array(base64);
//                 const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//                 const newUrl = URL.createObjectURL(blob);

//                 setAgreementBlobUrls(prev => {
//                     const oldUrl = prev['confidentiality_nda'];
//                     if (oldUrl && oldUrl.startsWith('blob:')) {
//                         URL.revokeObjectURL(oldUrl);
//                     }
//                     return {
//                         ...prev,
//                         'confidentiality_nda': newUrl
//                     };
//                 });
//             }, 250);
//             return () => clearTimeout(timer);
//         }
//     }, [employmentForm, ndaTemplateBytes, activeTab, selectedAgreementKey, data]);

//     // Load Conflict of Interest template once when activeTab is 'agreement' and selectedAgreementKey is 'conflict_of_interest'
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'conflict_of_interest' && !conflictTemplateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const response = await fetch('/Conflict of interest agreement.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     setConflictTemplateBytes(new Uint8Array(arrayBuffer));
//                 } catch (e) {
//                     console.error("Failed to load Conflict of Interest template:", e);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [activeTab, selectedAgreementKey, conflictTemplateBytes]);

//     // Debounced PDF preview generation for Conflict of Interest
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'conflict_of_interest' && conflictTemplateBytes) {
//             if (data?.signature_history?.some(h => h.document_type === 'Conflict of interest agreement' && h.action === 'SIGN')) {
//                 return;
//             }
//             const timer = setTimeout(async () => {
//                 const base64 = await generateConflictPdfData(conflictTemplateBytes, employmentForm, null);
//                 const pdfBytes = base64ToUint8Array(base64);
//                 const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//                 const newUrl = URL.createObjectURL(blob);

//                 setAgreementBlobUrls(prev => {
//                     const oldUrl = prev['conflict_of_interest'];
//                     if (oldUrl && oldUrl.startsWith('blob:')) {
//                         URL.revokeObjectURL(oldUrl);
//                     }
//                     return {
//                         ...prev,
//                         'conflict_of_interest': newUrl
//                     };
//                 });
//             }, 250);
//             return () => clearTimeout(timer);
//         }
//     }, [employmentForm, conflictTemplateBytes, activeTab, selectedAgreementKey, data]);

//     // Load Benefits Enrollment template once when activeTab is 'agreement' and selectedAgreementKey is '401k_dental_vision_medical'
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === '401k_dental_vision_medical' && !benefitsTemplateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const response = await fetch('/401K Dental Vision Medical.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     setBenefitsTemplateBytes(new Uint8Array(arrayBuffer));
//                 } catch (e) {
//                     console.error("Failed to load Benefits template:", e);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [activeTab, selectedAgreementKey, benefitsTemplateBytes]);

//     // Debounced PDF preview generation for Benefits Enrollment
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === '401k_dental_vision_medical' && benefitsTemplateBytes) {
//             if (data?.signature_history?.some(h => h.document_type === '401K Dental Vision Medical' && h.action === 'SIGN')) {
//                 return;
//             }
//             const timer = setTimeout(async () => {
//                 const base64 = await generateBenefitsPdfData(benefitsTemplateBytes, employmentForm, null);
//                 const pdfBytes = base64ToUint8Array(base64);
//                 const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//                 const newUrl = URL.createObjectURL(blob);

//                 setAgreementBlobUrls(prev => {
//                     const oldUrl = prev['401k_dental_vision_medical'];
//                     if (oldUrl && oldUrl.startsWith('blob:')) {
//                         URL.revokeObjectURL(oldUrl);
//                     }
//                     return {
//                         ...prev,
//                         '401k_dental_vision_medical': newUrl
//                     };
//                 });
//             }, 250);
//             return () => clearTimeout(timer);
//         }
//     }, [employmentForm, benefitsTemplateBytes, activeTab, selectedAgreementKey, data]);

//     // Load Non Solicitation template once when activeTab is 'agreement' and selectedAgreementKey is 'non_solicitation'
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'non_solicitation' && !nonSolicitationTemplateBytes) {
//             const loadTemplate = async () => {
//                 try {
//                     const response = await fetch('/Non Solicitation.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     setNonSolicitationTemplateBytes(new Uint8Array(arrayBuffer));
//                 } catch (e) {
//                     console.error("Failed to load Non Solicitation template:", e);
//                 }
//             };
//             loadTemplate();
//         }
//     }, [activeTab, selectedAgreementKey, nonSolicitationTemplateBytes]);

//     // Debounced PDF preview generation for Non Solicitation
//     useEffect(() => {
//         if (activeTab === 'agreement' && selectedAgreementKey === 'non_solicitation' && nonSolicitationTemplateBytes) {
//             if (data?.signature_history?.some(h => h.document_type === 'Non Solicitation' && h.action === 'SIGN')) {
//                 return;
//             }
//             const timer = setTimeout(async () => {
//                 const base64 = await generateNonSolicitationPdfData(nonSolicitationTemplateBytes, employmentForm, null);
//                 const pdfBytes = base64ToUint8Array(base64);
//                 const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//                 const newUrl = URL.createObjectURL(blob);

//                 setAgreementBlobUrls(prev => {
//                     const oldUrl = prev['non_solicitation'];
//                     if (oldUrl && oldUrl.startsWith('blob:')) {
//                         URL.revokeObjectURL(oldUrl);
//                     }
//                     return {
//                         ...prev,
//                         'non_solicitation': newUrl
//                     };
//                 });
//             }, 250);
//             return () => clearTimeout(timer);
//         }
//     }, [employmentForm, nonSolicitationTemplateBytes, activeTab, selectedAgreementKey, data]);

//     const handleApplySignature = (sigValue, sigType) => {
//         setTaxForm(prev => ({ ...prev, signature: sigValue }));
//         if (sigValue) {
//             setToast({ message: 'Signature applied to PDF preview!', type: 'success' });
//         }
//     };

//     const handleSaveTaxSubmit = async () => {
//         if (isLocked) return;
//         if (!taxForm.signature) {
//             setToast({ message: 'Please sign the form first.', type: 'error' });
//             return;
//         }
//         try {
//             await api.post('/onboarding/tax', {
//                 federal_tax_status: taxForm.federal_tax_status,
//                 federal_allowances: taxForm.federal_allowances,
//                 state_tax_status: taxForm.state_tax_status,
//                 state_allowances: taxForm.state_allowances,
//                 signature: taxForm.signature,
//                 arizona_box_selection: taxForm.arizona_box_selection,
//                 arizona_percentage: taxForm.arizona_percentage,
//                 arizona_extra_amount_checked: taxForm.arizona_extra_amount_checked ? 1 : 0,
//                 arizona_extra_amount: taxForm.arizona_extra_amount || 0.00,
//                 signed_pdf: pdfBase64
//             });
//             setToast({ message: 'Tax elections signed and saved successfully!', type: 'success' });
//             fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: err.response?.data?.error || 'Failed to save tax elections.', type: 'error' });
//         }
//     };

//     const downloadPdf = () => {
//         if (!pdfPreviewUrl) return;
//         const link = document.createElement('a');
//         link.href = pdfPreviewUrl;
//         link.download = `Arizona_Form_A4_${(taxForm.name || 'Employee').replace(/\s+/g, '_')}.pdf`;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     // Accept Corporate Policy
//     const handlePolicyAccept = async (sigData) => {
//         if (isLocked) return;
//         try {
//             setLoading(true);
//             let signaturePng = sigData;
//             if (sigData && !sigData.startsWith('data:image')) {
//                 signaturePng = convertTypedToPng(sigData);
//             }

//             const fullName = `${employee?.FirstName || ''} ${employee?.LastName || ''}`.trim() || 'Employee';
//             const signedPdfBase64 = await createPoliciesPdf(fullName, signaturePng);

//             await api.post('/onboarding/policies', {
//                 signature: sigData,
//                 signed_pdf: signedPdfBase64
//             });
//             setToast({ message: 'All company policies accepted successfully and PDF generated!', type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: err.response?.data?.error || 'Failed to record policies signature.', type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Sign Hiring Hub Document (Offer Letter / Employee Agreement)
//     const handleDocumentSign = async (docType, sigData) => {
//         if (isLocked) return;
//         try {
//             setLoading(true);
//             // 1. Process signature image: if it is a typed signature, convert it to a canvas image URL
//             let signaturePng = sigData;
//             if (sigData && !sigData.startsWith('data:image')) {
//                 signaturePng = convertTypedToPng(sigData);
//             }

//             // 2. Resolve original PDF base64
//             let originalBase64 = '';
//             if (docType === 'Offer Letter') {
//                 originalBase64 = employee?.offer_letter_base64 || data?.employee?.offer_letter_base64;
//                 if (!originalBase64) {
//                     const rawPath = employee?.offer_letter || employee?.offer_letter_path || data?.employee?.offer_letter || data?.employee?.offer_letter_path;
//                     let targetUrl = '';
//                     if (rawPath) {
//                         let cleanPath = rawPath.replace(/^\//, '');
//                         if (!cleanPath.startsWith('http://') && !cleanPath.startsWith('https://')) {
//                             cleanPath = cleanPath.startsWith('offer_letters/')
//                                 ? `https://hiring.gtelinq.com/hiring-backend/${cleanPath}`
//                                 : `/EOP_api/${cleanPath}`;
//                         }
//                         targetUrl = cleanPath;
//                     }
//                     if (targetUrl) {
//                         try {
//                             originalBase64 = await fetchLocalPdfAsBase64(targetUrl);
//                         } catch (e) {
//                             console.error("Failed to fetch offer letter URL as base64:", e);
//                         }
//                     }
//                     if (!originalBase64 && offerLetterBlobUrl) {
//                         try {
//                             originalBase64 = await fetchLocalPdfAsBase64(offerLetterBlobUrl);
//                         } catch (e) {
//                             console.error("Failed to fetch offerLetterBlobUrl as base64:", e);
//                         }
//                     }
//                 }
//             } else {
//                 try {
//                     const country = employee?.country || '';
//                     const isUsa = country.toUpperCase() === 'USA';
//                     let templatePath = '';
//                     if (isUsa) {
//                         const list = [
//                             { title: 'Employment Agreement 1', displayName: 'Employment Agreement', path: '/Employment Agreement 1.pdf' },
//                             { title: 'Employee Confidentiality & NDA (1)', displayName: 'Employee Confidentiality & NDA', path: '/Employee Confidentiality & NDA (1).pdf' },
//                             { title: 'Conflict of interest agreement', path: '/Conflict of interest agreement.pdf' },
//                             { title: '401K Dental Vision Medical', path: '/401K Dental Vision Medical.pdf' },
//                             { title: 'Non Solicitation', path: '/Non Solicitation.pdf' }
//                         ];
//                         const found = list.find(item => item.title === docType);
//                         templatePath = found ? found.path : '/employee_agreement_usa.pdf';
//                     } else {
//                         templatePath = '/3-Employment Agreement.pdf';
//                     }
//                     originalBase64 = await fetchLocalPdfAsBase64(templatePath);
//                 } catch (fetchErr) {
//                     console.error("Failed to fetch local agreement PDF template:", fetchErr);
//                     originalBase64 = employee.employee_agreement_base64;
//                 }
//             }

//             // 3. Draw signature on the PDF
//             let signedPdfBase64 = '';
//             if (docType === 'Employment Agreement 1' || docType === 'Employment Agreement') {
//                 let templateBytes = agreementTemplateBytes;
//                 if (!templateBytes) {
//                     const response = await fetch('/Employment Agreement 1.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     templateBytes = new Uint8Array(arrayBuffer);
//                 }
//                 signedPdfBase64 = await generateAgreementPdfData(templateBytes, employmentForm, signaturePng);
//             } else if (docType === 'Employee Confidentiality & NDA (1)' || docType === 'Employee Confidentiality & NDA') {
//                 let templateBytes = ndaTemplateBytes;
//                 if (!templateBytes) {
//                     const response = await fetch('/Employee Confidentiality & NDA (1).pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     templateBytes = new Uint8Array(arrayBuffer);
//                 }
//                 signedPdfBase64 = await generateNdaPdfData(templateBytes, employmentForm, signaturePng);
//             } else if (docType === 'Conflict of interest agreement') {
//                 let templateBytes = conflictTemplateBytes;
//                 if (!templateBytes) {
//                     const response = await fetch('/Conflict of interest agreement.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     templateBytes = new Uint8Array(arrayBuffer);
//                 }
//                 signedPdfBase64 = await generateConflictPdfData(templateBytes, employmentForm, signaturePng);
//             } else if (docType === '401K Dental Vision Medical') {
//                 let templateBytes = benefitsTemplateBytes;
//                 if (!templateBytes) {
//                     const response = await fetch('/401K Dental Vision Medical.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     templateBytes = new Uint8Array(arrayBuffer);
//                 }
//                 signedPdfBase64 = await generateBenefitsPdfData(templateBytes, employmentForm, signaturePng);
//             } else if (docType === 'Non Solicitation') {
//                 let templateBytes = nonSolicitationTemplateBytes;
//                 if (!templateBytes) {
//                     const response = await fetch('/Non Solicitation.pdf');
//                     const arrayBuffer = await response.arrayBuffer();
//                     templateBytes = new Uint8Array(arrayBuffer);
//                 }
//                 signedPdfBase64 = await generateNonSolicitationPdfData(templateBytes, employmentForm, signaturePng);
//             } else {
//                 const fName = personalForm.first_name || data?.profile?.first_name || employee?.FirstName || employee?.first_name || '';
//                 const mName = personalForm.middle_name || data?.profile?.middle_name || employee?.MiddleName || employee?.middle_name || '';
//                 const lName = personalForm.last_name || data?.profile?.last_name || employee?.LastName || employee?.last_name || '';
//                 const fullName = [fName, mName, lName].filter(Boolean).join(' ').trim() || 'Employee';
//                 const aadhaarNumber = personalForm.ssn || data?.profile?.ssn || employee?.ssn || employee?.AadhaarNumber || employee?.aadhaar_number || '';
//                 const formattedDate = formatDateMMDDYYYY(new Date());

//                 const isIndiaCandidate = ((employee?.country || data?.employee?.country || personalForm?.country || '').toUpperCase()) === 'INDIA';
//                 const joiningDateStr = employee?.joining_date || employee?.JoiningDate || data?.employee?.joining_date || data?.employee?.JoiningDate || employmentForm?.hireDate || personalForm?.hireDate;
//                 signedPdfBase64 = await applySignatureToPdf(originalBase64, signaturePng, fullName, docType, isIndiaCandidate, {
//                     fullName,
//                     aadhaarNumber,
//                     date: formattedDate,
//                     joiningDate: joiningDateStr
//                 });
//             }

//             // 4. Send to backend
//             await api.post('/onboarding/agreements', {
//                 document_type: docType,
//                 signature: sigData,
//                 signed_pdf: signedPdfBase64
//             });

//             // Auto-upload signed offer letter to employee_documents table for checklist storage
//             if (docType === 'Offer Letter' && signedPdfBase64) {
//                 try {
//                     await api.post('/onboarding/upload', {
//                         document_type: 'Signed Offer Letter',
//                         file: signedPdfBase64.startsWith('data:') ? signedPdfBase64 : `data:application/pdf;base64,${signedPdfBase64}`
//                     });
//                 } catch (uploadErr) {
//                     console.warn("Auto upload of Signed Offer Letter to documents table failed:", uploadErr);
//                 }

//                 // Set live blob URL preview of signed offer letter
//                 const signedUrl = base64ToBlobUrl(signedPdfBase64);
//                 setOfferLetterBlobUrl(prev => {
//                     if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
//                     return signedUrl;
//                 });
//             }

//             setToast({ message: `${docType} signed successfully!`, type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             await fetchOnboardingData();
//         } catch (err) {
//             console.error(err);
//             setToast({ message: err.response?.data?.error || err.message || 'Failed to apply document signature.', type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Save Photo Badge headshot
//     const handlePhotoUpload = (e) => {
//         if (isLocked) return;
//         const file = e.target.files[0];
//         if (file) {
//             if (file.size > 5 * 1024 * 1024) {
//                 setToast({ message: 'This file is not accepted. File size exceeds maximum limit of 5MB.', type: 'error' });
//                 e.target.value = '';
//                 return;
//             }
//             if (!file.type.match(/^image\/(jpeg|png|jpg|webp)$/i)) {
//                 setToast({ message: 'This file is not accepted. Only image files (JPG, PNG, WEBP) are allowed.', type: 'error' });
//                 e.target.value = '';
//                 return;
//             }

//             setUploadingPhoto(true);
//             const reader = new FileReader();
//             reader.onload = async (event) => {
//                 try {
//                     await api.post('/onboarding/photo', { photo: event.target.result });
//                     setToast({ message: 'Profile badge photo uploaded successfully!', type: 'success' });
//                     window.dispatchEvent(new Event('onboarding_updated'));
//                     await fetchOnboardingData();
//                 } catch (err) {
//                     setToast({ message: err.response?.data?.error || 'Failed to upload photo.', type: 'error' });
//                 } finally {
//                     setUploadingPhoto(false);
//                     e.target.value = '';
//                 }
//             };
//             reader.readAsDataURL(file);
//         }
//     };

//     // Delete Photo Badge headshot
//     const handleDeletePhoto = async () => {
//         if (isLocked) return;
//         if (!window.confirm('Are you sure you want to delete your badge profile photo?')) return;
//         try {
//             setUploadingPhoto(true);
//             await api.delete('/onboarding/photo');
//             setToast({ message: 'Profile photo deleted successfully!', type: 'success' });
//             window.dispatchEvent(new Event('onboarding_updated'));
//             await fetchOnboardingData();
//         } catch (err) {
//             setToast({ message: err.response?.data?.error || 'Failed to delete photo.', type: 'error' });
//         } finally {
//             setUploadingPhoto(false);
//         }
//     };

//     // Submit Onboarding
//     const handleSubmitOnboarding = async () => {
//         const requestedDocsList = data?.requested_documents || data?.requested_employee_documents || [];
//         const pendingOrUploadedReqs = requestedDocsList.filter(r => {
//             const s = (r.status || '').toUpperCase();
//             return s !== 'SUBMITTED' && s !== 'COMPLETED' && s !== 'APPROVED';
//         });
//         if (isLocked && pendingOrUploadedReqs.length === 0) return;
//         setSubmitStatus('submitting');
//         setSubmitErrorMessage('');
//         try {
//             // Artificial delay to allow user to see the loading progress
//             await new Promise((resolve) => setTimeout(resolve, 1800));
//             await api.post('/onboarding/submit');
//             setSubmitStatus('success');
//             setRequestedDocsSubmitted(true);
//             fetchOnboardingData();
//         } catch (err) {
//             setSubmitStatus('error');
//             setSubmitErrorMessage(err.response?.data?.error || 'Failed to submit onboarding.');
//         }
//     };

//     // Helper to open PDF in a new tab natively using Blob URL
//     const handleViewPdf = (base64Data, fileName = 'document.pdf') => {
//         try {
//             if (!base64Data) {
//                 setToast({ message: 'No PDF data available.', type: 'error' });
//                 return;
//             }
//             if (base64Data.startsWith('/') || base64Data.startsWith('blob:') || base64Data.startsWith('http')) {
//                 const newWindow = window.open();
//                 if (newWindow) {
//                     newWindow.document.title = fileName;
//                     newWindow.location.href = base64Data;
//                 } else {
//                     // Fallback: download if blocked
//                     const a = document.createElement('a');
//                     a.href = base64Data;
//                     a.download = fileName;
//                     document.body.appendChild(a);
//                     a.click();
//                     document.body.removeChild(a);
//                 }
//                 return;
//             }
//             const arr = base64ToUint8Array(base64Data);
//             if (arr.length === 0) {
//                 setToast({ message: 'Failed to decode PDF data.', type: 'error' });
//                 return;
//             }
//             const blob = new Blob([arr], { type: 'application/pdf' });
//             const url = URL.createObjectURL(blob);

//             const newWindow = window.open();
//             if (newWindow) {
//                 newWindow.document.title = fileName;
//                 newWindow.location.href = url;
//             } else {
//                 // Fallback: download if blocked
//                 const a = document.createElement('a');
//                 a.href = url;
//                 a.download = fileName;
//                 document.body.appendChild(a);
//                 a.click();
//                 document.body.removeChild(a);
//             }
//         } catch (err) {
//             setToast({ message: 'Failed to load PDF. Please try downloading it.', type: 'error' });
//         }
//     };

//     const handleDownloadPdf = (base64Data, fileName = 'document.pdf') => {
//         try {
//             if (!base64Data) {
//                 setToast({ message: 'No PDF data available.', type: 'error' });
//                 return;
//             }
//             if (base64Data.startsWith('/') || base64Data.startsWith('blob:') || base64Data.startsWith('http')) {
//                 const a = document.createElement('a');
//                 a.href = base64Data;
//                 a.download = fileName;
//                 document.body.appendChild(a);
//                 a.click();
//                 document.body.removeChild(a);
//                 return;
//             }
//             const arr = base64ToUint8Array(base64Data);
//             if (arr.length === 0) {
//                 setToast({ message: 'Failed to decode PDF data.', type: 'error' });
//                 return;
//             }
//             const blob = new Blob([arr], { type: 'application/pdf' });
//             const url = URL.createObjectURL(blob);
//             const a = document.createElement('a');
//             a.href = url;
//             a.download = fileName;
//             document.body.appendChild(a);
//             a.click();
//             document.body.removeChild(a);
//             URL.revokeObjectURL(url);
//         } catch (err) {
//             setToast({ message: 'Failed to download PDF.', type: 'error' });
//         }
//     };

//     const handleDownloadPolicies = async () => {
//         try {
//             setLoading(true);
//             const fullName = `${employee?.FirstName || ''} ${employee?.LastName || ''}`.trim() || 'Employee';
//             let signatureDataUrl = employee?.policy_signature || '';

//             if (signatureDataUrl.startsWith('typed:')) {
//                 const typedName = signatureDataUrl.replace('typed:', '');
//                 signatureDataUrl = convertTypedToPng(typedName);
//             }

//             const newPdfBase64 = await createPoliciesPdf(fullName, signatureDataUrl);
//             handleDownloadPdf(newPdfBase64, `company_policies_${(employee?.FirstName || 'employee').toLowerCase()}_${(employee?.LastName || 'signed').toLowerCase()}_signed.pdf`);
//         } catch (err) {
//             console.error(err);
//             setToast({ message: 'Failed to generate policies PDF for download.', type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     if (loading) {
//         return <Loader message="Loading onboarding workspace..." />;
//     }

//     const employee = data?.employee || {};
//     const profile = data?.profile || {};

//     // Find if a Passport Size Photo document was uploaded in India documents section
//     const passportSizePhotoDoc = (data?.documents || []).find(
//         doc => doc.document_type === 'Passport Size Photo'
//     );
//     const rawProfilePhotoPath = profile?.profile_photo_path;

//     // Ensure Passport Size Photo document is separate from Badge Profile Photo
//     const isPassportDocMatch = (
//         (passportSizePhotoDoc?.file_path && rawProfilePhotoPath === passportSizePhotoDoc.file_path) ||
//         (rawProfilePhotoPath && (data?.documents || []).some(doc => doc.document_type === 'Passport Size Photo' && doc.file_path === rawProfilePhotoPath))
//     );

//     const badgePhotoPath = (rawProfilePhotoPath && !isPassportDocMatch) ? rawProfilePhotoPath : null;

//     const effectiveChecklist = dashboardStats?.checklist ? {
//         ...dashboardStats.checklist,
//         profile_photo: !!badgePhotoPath
//     } : {};

//     const effectiveCompletedSteps = Object.values(effectiveChecklist).filter(Boolean).length;

//     const effectiveDashboardStats = dashboardStats ? {
//         ...dashboardStats,
//         checklist: effectiveChecklist,
//         completed_steps: effectiveCompletedSteps
//     } : null;

//     return (
//         <div style={{ animation: 'fadeIn var(--transition-normal) forwards' }}>
//             {uploadingPhoto && <Loader fullScreen message="Uploading profile badge photo..." />}

//             {/* Lock banner warning */}
//             {isLocked && (
//                 <div
//                     style={{
//                         backgroundColor: 'var(--info-light)',
//                         borderLeft: '4px solid var(--info)',
//                         padding: '1rem',
//                         borderRadius: '4px',
//                         marginBottom: '1.5rem',
//                         fontSize: '0.875rem',
//                         color: 'var(--text-primary)',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '0.5rem'
//                     }}
//                 >
//                     <span>ℹ️</span>
//                     <div>
//                         You have submitted your onboarding details successfully.
//                     </div>
//                 </div>
//             )}

//             {/* DASHBOARD TAB */}
//             {activeTab === 'dashboard' && (() => {
//                 const completedSteps = effectiveDashboardStats?.completed_steps || 0;
//                 const totalSteps = effectiveDashboardStats?.total_steps || 8;
//                 const onboardingPercent = Math.round((completedSteps / totalSteps) * 100);

//                 const radius = 60;
//                 const stroke = 7;
//                 const normRadius = radius - stroke * 2;
//                 const circ = normRadius * 2 * Math.PI;
//                 const offset = circ - (onboardingPercent / 100) * circ;

//                 return (
//                     <div className="fade-in" style={{ display: 'flex', flexDirection: 'column', gap: '2.5rem' }}>

//                         {/* Split Top section: Greeting + Radial Indicator */}
//                         <div className="dashboard-top-grid">

//                             {/* Left Column: Greeting & Status */}
//                             <div
//                                 style={{
//                                     background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.07) 0%, rgba(244, 63, 94, 0.04) 100%)',
//                                     border: '1px solid var(--border-color)',
//                                     borderRadius: 'var(--border-radius-lg)',
//                                     padding: '2.5rem 2rem',
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     justifyContent: 'center',
//                                     boxShadow: 'var(--shadow-md)'
//                                 }}
//                             >
//                                 <div
//                                     style={{
//                                         display: 'inline-flex',
//                                         padding: '0.25rem 0.75rem',
//                                         backgroundColor: 'var(--primary-light)',
//                                         color: 'var(--primary)',
//                                         fontSize: '0.75rem',
//                                         fontWeight: 700,
//                                         borderRadius: '50px',
//                                         textTransform: 'uppercase',
//                                         marginBottom: '1rem',
//                                         alignSelf: 'flex-start',
//                                         letterSpacing: '0.05em'
//                                     }}
//                                 >
//                                     Onboarding Phase
//                                 </div>

//                                 <h2 style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--text-primary)', marginBottom: '0.5rem', letterSpacing: '-0.02em' }}>
//                                     Welcome, {employee.FirstName || 'Team Member'}!
//                                 </h2>
//                                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '1rem' }}>
//                                     We are thrilled to welcome you to the Genesis Tech Engineers family. All accounts have been securely synchronized. Complete your documentation pipeline below.
//                                 </p>
//                                 <div style={{ marginBottom: '1.5rem' }}>
//                                     <button
//                                         type="button"
//                                         onClick={onStartVideoTour}
//                                         className="btn btn-secondary"
//                                         style={{ padding: '0.45rem 1rem', fontSize: '0.75rem', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
//                                     >
//                                         🎥 Watch Onboarding Video Tour
//                                     </button>
//                                 </div>

//                                 {/* Progress bar line */}
//                                 <div style={{ width: '100%' }}>
//                                     <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>
//                                         <span>Onboarding Progress</span>
//                                         <span>{onboardingPercent}% Complete</span>
//                                     </div>
//                                     <div style={{ width: '100%', height: '8px', backgroundColor: 'var(--bg-tertiary)', borderRadius: '50px', overflow: 'hidden' }}>
//                                         <div
//                                             style={{
//                                                 width: `${onboardingPercent}%`,
//                                                 height: '100%',
//                                                 background: 'linear-gradient(90deg, var(--primary) 0%, var(--accent) 100%)',
//                                                 borderRadius: '50px',
//                                                 transition: 'width 0.4s ease-out'
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Right Column: Visual Radial Meter */}
//                             <div
//                                 className="glass-card"
//                                 style={{
//                                     padding: '2rem',
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     textAlign: 'center'
//                                 }}
//                             >
//                                 <div style={{ position: 'relative', width: radius * 2, height: radius * 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                                     {/* SVG Circle meter */}
//                                     <svg height={radius * 2} width={radius * 2} style={{ transform: 'rotate(-90deg)', position: 'absolute', top: 0, left: 0 }}>
//                                         <circle
//                                             stroke="var(--bg-tertiary)"
//                                             fill="transparent"
//                                             strokeWidth={stroke}
//                                             r={normRadius}
//                                             cx={radius}
//                                             cy={radius}
//                                         />
//                                         <circle
//                                             stroke="url(#progressGrad)"
//                                             fill="transparent"
//                                             strokeWidth={stroke}
//                                             strokeDasharray={circ + ' ' + circ}
//                                             style={{ strokeDashoffset: offset, transition: 'stroke-dashoffset 0.6s ease' }}
//                                             r={normRadius}
//                                             cx={radius}
//                                             cy={radius}
//                                             strokeLinecap="round"
//                                         />
//                                         <defs>
//                                             <linearGradient id="progressGrad" x1="0%" y1="0%" x2="100%" y2="100%">
//                                                 <stop offset="0%" stopColor="#22d3ee" />
//                                                 <stop offset="50%" stopColor="#6366f1" />
//                                                 <stop offset="100%" stopColor="#ec4899" />
//                                             </linearGradient>
//                                         </defs>
//                                     </svg>

//                                     {/* Inside dial text */}
//                                     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 2 }}>
//                                         <span style={{ fontSize: '1.75rem', fontWeight: 800, color: 'var(--text-primary)', lineHeight: 1 }}>{completedSteps}</span>
//                                         <span style={{ fontSize: '0.7rem', color: 'var(--text-tertiary)', textTransform: 'uppercase', fontWeight: 700, marginTop: '0.15rem' }}>of {totalSteps} Tasks</span>
//                                     </div>
//                                 </div>

//                                 <div style={{ marginTop: '1.25rem' }}>
//                                     <div style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--text-primary)' }}>Completeness Ratio</div>
//                                     <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '0.15rem' }}>
//                                         {onboardingPercent === 100 ? 'Ready to submit onboarding profile!' : `${totalSteps - completedSteps} steps remaining`}
//                                     </div>
//                                 </div>
//                             </div>

//                         </div>

//                         {/* Visual Roadmap Path */}
//                         {(() => {
//                             const roadmapSteps = [
//                                 { key: 'personal_info', tab: 'personal', title: 'Profile', icon: '👤' },
//                                 { key: 'emergency_contacts', tab: 'contacts', title: 'Contacts', icon: '📞' },
//                                 { key: 'documents', tab: 'documents', title: 'ID Docs', icon: '📁' },
//                                 { key: 'offer', tab: 'offer', title: 'Offer Letter', icon: '✉️' },
//                                 { key: 'agreement', tab: 'agreement', title: 'Agreement', icon: '🖋️' },
//                                 { key: 'policies', tab: 'policies', title: 'Policies', icon: '🛡️' },
//                                 { key: 'bank_details', tab: 'bank', title: 'Bank', icon: '🏦' },
//                                 { key: 'profile_photo', tab: 'photo', title: 'Photo', icon: '📷' },
//                                 { key: 'submit', tab: 'submit', title: 'Submit', icon: '🚀' }
//                             ];

//                             const firstPendingStep = roadmapSteps.find(s => {
//                                 if (s.key === 'submit') {
//                                     return roadmapSteps.slice(0, 8).every(other => effectiveDashboardStats?.checklist?.[other.key]);
//                                 }
//                                 return !effectiveDashboardStats?.checklist?.[s.key];
//                             }) || roadmapSteps[8];

//                             return (
//                                 <div className="card fade-in" style={{ padding: '1.75rem 1.5rem', margin: 0, boxShadow: 'var(--shadow-sm)' }}>
//                                     <div className="roadmap-header">
//                                         <div>
//                                             <h3 style={{ fontSize: '1.1rem', fontWeight: 800, margin: 0, color: 'var(--text-primary)' }}>
//                                                 🗺️ Onboarding Guided Path Roadmap
//                                             </h3>
//                                             <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
//                                                 Your onboarding steps pipeline. Click any step circle to jump directly to its screen.
//                                             </p>
//                                         </div>
//                                         <div style={{ display: 'flex', gap: '0.5rem' }}>
//                                             <button
//                                                 type="button"
//                                                 onClick={onStartVideoTour}
//                                                 className="btn btn-secondary"
//                                                 style={{ padding: '0.4rem 0.8rem', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
//                                             >
//                                                 🎥 Play Video Tour
//                                             </button>
//                                             <button
//                                                 type="button"
//                                                 onClick={onStartTour}
//                                                 className="btn btn-secondary"
//                                                 style={{ padding: '0.4rem 0.8rem', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
//                                             >
//                                                 🗺️ Replay Guided Tour
//                                             </button>
//                                         </div>
//                                     </div>

//                                     <div className="roadmap-trail">
//                                         {roadmapSteps.map((step, idx) => {
//                                             const isComplete = step.key === 'submit'
//                                                 ? (effectiveDashboardStats?.status === 'PENDING_HR_REVIEW' || effectiveDashboardStats?.status === 'COMPLETED')
//                                                 : effectiveDashboardStats?.checklist?.[step.key];
//                                             const isActive = firstPendingStep.key === step.key;

//                                             return (
//                                                 <React.Fragment key={step.key}>
//                                                     <div
//                                                         className={`roadmap-step ${isActive ? 'active' : ''} ${isComplete ? 'complete' : ''}`}
//                                                         onClick={() => setActiveTab(step.tab)}
//                                                         title={step.title}
//                                                     >
//                                                         {isActive && (
//                                                             <span style={{
//                                                                 position: 'absolute',
//                                                                 top: '-22px',
//                                                                 fontSize: '0.85rem',
//                                                                 animation: 'bounceDown 1.2s infinite',
//                                                                 color: 'var(--primary)',
//                                                                 fontWeight: 800
//                                                             }}>
//                                                                 👇
//                                                             </span>
//                                                         )}
//                                                         <div className={`roadmap-step-circle ${isActive ? 'next-step-glowing' : ''}`}>
//                                                             {isComplete ? '✓' : step.icon}
//                                                         </div>
//                                                         <div className="roadmap-step-title">{step.title}</div>
//                                                     </div>

//                                                     {idx < roadmapSteps.length - 1 && (
//                                                         <div className="roadmap-arrow">➔</div>
//                                                     )}
//                                                 </React.Fragment>
//                                             );
//                                         })}
//                                     </div>
//                                 </div>
//                             );
//                         })()}

//                         {/* Middle section: Colorful Info Badges Grid */}
//                         <div className="dashboard-middle-grid">
//                             <div style={{ padding: '1.25rem', backgroundColor: 'rgba(59, 130, 246, 0.03)', border: '1px solid var(--border-color)', borderLeft: '4px solid #3b82f6', borderRadius: 'var(--border-radius-md)', display: 'flex', flexDirection: 'column', gap: '0.25rem', boxShadow: 'var(--shadow-sm)' }}>
//                                 <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#2563eb', fontWeight: 700, letterSpacing: '0.05em' }}>Designation Unit</span>
//                                 <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)' }}>{employee.Designation || 'N/A'}</span>
//                             </div>
//                             <div style={{ padding: '1.25rem', backgroundColor: 'rgba(168, 85, 247, 0.03)', border: '1px solid var(--border-color)', borderLeft: '4px solid #a855f7', borderRadius: 'var(--border-radius-md)', display: 'flex', flexDirection: 'column', gap: '0.25rem', boxShadow: 'var(--shadow-sm)' }}>
//                                 <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#9333ea', fontWeight: 700, letterSpacing: '0.05em' }}>Department Branch</span>
//                                 <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)' }}>{employee.Department || 'N/A'}</span>
//                             </div>
//                             <div style={{ padding: '1.25rem', backgroundColor: 'rgba(16, 185, 129, 0.03)', border: '1px solid var(--border-color)', borderLeft: '4px solid #10b981', borderRadius: 'var(--border-radius-md)', display: 'flex', flexDirection: 'column', gap: '0.25rem', boxShadow: 'var(--shadow-sm)' }}>
//                                 <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#059669', fontWeight: 700, letterSpacing: '0.05em' }}>Official Start Date</span>
//                                 <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)' }}>{employee.JoiningDate || 'N/A'}</span>
//                             </div>
//                         </div>

//                         {/* Launcher Grid */}
//                         <div className="card" style={{ padding: '2.5rem 2rem', margin: 0 }}>
//                             <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '0.5rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '0.75rem' }}>
//                                 🚀 Onboarding Launchpad Checklist
//                             </h3>
//                             <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '2rem' }}>
//                                 Each card below represents a required onboarding step. Click any card to load its details.
//                             </p>

//                             <div
//                                 style={{
//                                     display: 'grid',
//                                     gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
//                                     gap: '1.25rem'
//                                 }}
//                             >
//                                 {[
//                                     { key: 'personal_info', tab: 'personal', icon: '👤', title: 'Personal Profile', desc: ((data?.employee?.country || employee?.country || '').toUpperCase() === 'INDIA') ? 'Verify personal details, addresses, and Aadhaar.' : 'Verify personal details, addresses, and SSN.', color: 'rgba(59, 130, 246, 0.03)', hoverBorder: '#3b82f6', badgeBg: 'rgba(59, 130, 246, 0.12)', badgeText: '#2563eb' },
//                                     { key: 'emergency_contacts', tab: 'contacts', icon: '📞', title: 'Emergency Contacts', desc: 'Add primary and secondary contact details.', color: 'rgba(16, 185, 129, 0.03)', hoverBorder: '#10b981', badgeBg: 'rgba(16, 185, 129, 0.12)', badgeText: '#059669' },
//                                     { key: 'documents', tab: 'documents', icon: '📁', title: 'US Identification', desc: 'Upload standard identity documents.', color: 'rgba(99, 102, 241, 0.03)', hoverBorder: '#6366f1', badgeBg: 'rgba(99, 102, 241, 0.12)', badgeText: '#4f46e5' },
//                                     { key: 'offer', tab: 'offer', icon: '✉️', title: 'Offer Sheet Review', desc: 'Review terms and sign your hiring offer letter.', color: 'rgba(245, 158, 11, 0.03)', hoverBorder: '#f59e0b', badgeBg: 'rgba(245, 158, 11, 0.12)', badgeText: '#d97706' },
//                                     { key: 'agreement', tab: 'agreement', icon: '🖋️', title: 'Employee Agreement', desc: 'E-sign the corporate NDAs & contracts.', color: 'rgba(236, 72, 153, 0.03)', hoverBorder: '#ec4899', badgeBg: 'rgba(236, 72, 153, 0.12)', badgeText: '#db2777' },
//                                     { key: 'policies', tab: 'policies', icon: '🛡️', title: 'Company Policies', desc: 'Read and accept the 5 policy handbooks.', color: 'rgba(6, 182, 212, 0.03)', hoverBorder: '#06b6d4', badgeBg: 'rgba(6, 182, 212, 0.12)', badgeText: '#0891b2' },
//                                     { key: 'bank_details', tab: 'bank', icon: '🏦', title: 'Direct Deposit', desc: 'Setup payroll accounts and voided cheques.', color: 'rgba(168, 85, 247, 0.03)', hoverBorder: '#a855f7', badgeBg: 'rgba(168, 85, 247, 0.12)', badgeText: '#9333ea' },
//                                     { key: 'profile_photo', tab: 'photo', icon: '📷', title: 'Badge Headshot', desc: 'Upload and crop your official badge headshot.', color: 'rgba(239, 68, 68, 0.03)', hoverBorder: '#ef4444', badgeBg: 'rgba(239, 68, 68, 0.12)', badgeText: '#dc2626' }
//                                 ].map(step => {
//                                     const complete = effectiveDashboardStats?.checklist?.[step.key];
//                                     return (
//                                         <div
//                                             key={step.key}
//                                             onClick={() => setActiveTab(step.tab)}
//                                             style={{
//                                                 border: '1px solid var(--border-color)',
//                                                 borderRadius: 'var(--border-radius-md)',
//                                                 padding: '1.25rem',
//                                                 cursor: 'pointer',
//                                                 backgroundColor: step.color,
//                                                 transition: 'all var(--transition-normal)',
//                                                 display: 'flex',
//                                                 flexDirection: 'column',
//                                                 justifyContent: 'space-between',
//                                                 minHeight: '140px',
//                                                 boxShadow: 'var(--shadow-sm)',
//                                                 position: 'relative',
//                                                 overflow: 'hidden'
//                                             }}
//                                             onMouseEnter={(e) => {
//                                                 e.currentTarget.style.transform = 'translateY(-3px)';
//                                                 e.currentTarget.style.boxShadow = 'var(--shadow-md)';
//                                                 e.currentTarget.style.borderColor = step.hoverBorder;
//                                                 e.currentTarget.style.background = step.color.replace('0.03', '0.07');
//                                             }}
//                                             onMouseLeave={(e) => {
//                                                 e.currentTarget.style.transform = 'translateY(0)';
//                                                 e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
//                                                 e.currentTarget.style.borderColor = 'var(--border-color)';
//                                                 e.currentTarget.style.background = step.color;
//                                             }}
//                                         >
//                                             <div style={{ position: 'relative', zIndex: 2 }}>
//                                                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
//                                                     <span style={{ fontSize: '1.5rem' }}>{step.icon}</span>
//                                                     <span
//                                                         style={{
//                                                             fontSize: '0.7rem',
//                                                             fontWeight: '700',
//                                                             padding: '0.15rem 0.5rem',
//                                                             borderRadius: '50px',
//                                                             textTransform: 'uppercase',
//                                                             backgroundColor: complete ? 'var(--success-light)' : step.badgeBg,
//                                                             color: complete ? 'var(--success)' : step.badgeText
//                                                         }}
//                                                     >
//                                                         {complete ? '✓ Done' : 'Pending'}
//                                                     </span>
//                                                 </div>
//                                                 <h4 style={{ fontSize: '0.95rem', fontWeight: '700', marginBottom: '0.25rem', color: 'var(--text-primary)' }}>
//                                                     {step.title}
//                                                 </h4>
//                                                 <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', lineHeight: '1.3' }}>
//                                                     {step.desc}
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         </div>
//                     </div>
//                 );
//             })()}

//             {/* PERSONAL INFO TAB */}
//             {activeTab === 'personal' && (() => {
//                 const country = data?.employee?.country || personalForm.country || employee?.country || '';
//                 const isIndia = country.toUpperCase() === 'INDIA';
//                 return (
//                     <div className="card fade-in">
//                         <div className="card-title">Personal Information</div>
//                         <form onSubmit={handleSavePersonal}>
//                             <div className="grid-2">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="first-name">Given Name(first+middle)</label>
//                                     <input type="text" id="first-name" className="form-control" value={personalForm.first_name} onChange={(e) => setPersonalForm({ ...personalForm, first_name: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="last-name">Last Name</label>
//                                     <input type="text" id="last-name" className="form-control" value={personalForm.last_name} onChange={(e) => setPersonalForm({ ...personalForm, last_name: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                             </div>

//                             <div className="grid-3">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="pref-name">Preferred Name</label>
//                                     <input type="text" id="pref-name" className="form-control" value={personalForm.preferred_name} onChange={(e) => setPersonalForm({ ...personalForm, preferred_name: e.target.value })} disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="dob-input">Date of Birth</label>
//                                     <input type="date" id="dob-input" className="form-control" value={personalForm.dob} onChange={(e) => setPersonalForm({ ...personalForm, dob: e.target.value })} disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="gender-select">Gender</label>
//                                     <select id="gender-select" className="form-control" value={personalForm.gender} onChange={(e) => setPersonalForm({ ...personalForm, gender: e.target.value })} disabled={isLocked}>
//                                         <option value="">Select</option>
//                                         <option value="Male">Male</option>
//                                         <option value="Female">Female</option>

//                                         <option value="Other">Other</option>
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className="grid-3">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="marital-select">Marital Status</label>
//                                     <select id="marital-select" className="form-control" value={personalForm.marital_status} onChange={(e) => setPersonalForm({ ...personalForm, marital_status: e.target.value })} disabled={isLocked}>
//                                         <option value="">Select</option>
//                                         <option value="Single">Single</option>
//                                         <option value="Married">Married</option>
//                                         <option value="Divorced">Divorced</option>
//                                     </select>
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="cit-input">Citizenship</label>
//                                     <input type="text" id="cit-input" className="form-control" value={personalForm.citizenship} onChange={(e) => setPersonalForm({ ...personalForm, citizenship: e.target.value })} disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="ssn-input">
//                                         {isIndia ? 'Aadhaar Number' : 'Social Security Number (SSN)'}
//                                     </label>
//                                     <input
//                                         type="text"
//                                         id="ssn-input"
//                                         className="form-control"
//                                         placeholder={isIndia ? '12-digit Aadhaar Number (e.g. 1234 5678 9012)' : '000-00-0000'}
//                                         maxLength={isIndia ? 14 : 11}
//                                         value={personalForm.ssn}
//                                         onChange={(e) => setPersonalForm({ ...personalForm, ssn: e.target.value })}
//                                         disabled={isLocked}
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             <div className="grid-2">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="phone-input">Phone Number</label>
//                                     <input type="tel" id="phone-input" className="form-control" value={personalForm.phone} onChange={(e) => setPersonalForm({ ...personalForm, phone: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="email-display">Personal Email</label>
//                                     <input type="email" id="email-display" className="form-control" value={personalForm.personal_email} onChange={(e) => setPersonalForm({ ...personalForm, personal_email: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                             </div>

//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="addr-input">Address Line</label>
//                                 <input type="text" id="addr-input" className="form-control" value={personalForm.address} onChange={(e) => setPersonalForm({ ...personalForm, address: e.target.value })} required disabled={isLocked} />
//                             </div>

//                             <div className="grid-4">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="city-input">City</label>
//                                     <input type="text" id="city-input" className="form-control" value={personalForm.city} onChange={(e) => setPersonalForm({ ...personalForm, city: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="state-input">State</label>
//                                     <input type="text" id="state-input" className="form-control" value={personalForm.state} onChange={(e) => setPersonalForm({ ...personalForm, state: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="zip-input">ZIP Code</label>
//                                     <input type="text" id="zip-input" className="form-control" value={personalForm.zip} onChange={(e) => setPersonalForm({ ...personalForm, zip: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="country-input">Country</label>
//                                     <input type="text" id="country-input" className="form-control" value={personalForm.country} onChange={(e) => setPersonalForm({ ...personalForm, country: e.target.value })} required disabled={isLocked} />
//                                 </div>
//                             </div>

//                             {!isLocked && <button type="submit" className="btn btn-primary">Save Personal Info</button>}
//                         </form>
//                     </div>
//                 );
//             })()}

//             {/* EMERGENCY CONTACTS TAB */}
//             {activeTab === 'contacts' && (
//                 <div className="card fade-in">
//                     <div className="card-title">Emergency Contacts</div>
//                     <form onSubmit={handleSaveContacts}>
//                         {emergencyContacts.map((contact, idx) => (
//                             <div key={idx} style={{ padding: '1rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)', marginBottom: '1rem', backgroundColor: 'var(--bg-secondary)' }}>
//                                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
//                                     <span style={{ fontSize: '0.85rem', fontWeight: 600 }}>Contact #{idx + 1}</span>
//                                     {!isLocked && emergencyContacts.length > 1 && (
//                                         <button type="button" className="btn btn-danger" style={{ padding: '0.2rem 0.5rem', fontSize: '0.7rem' }} onClick={() => handleRemoveContact(idx)}>
//                                             Remove
//                                         </button>
//                                     )}
//                                 </div>
//                                 <div className="grid-2">
//                                     <div className="form-group">
//                                         <label className="form-label">Full Name</label>
//                                         <input type="text" className="form-control" value={contact.name} onChange={(e) => handleContactChange(idx, 'name', e.target.value)} required disabled={isLocked} />
//                                     </div>
//                                     <div className="form-group">
//                                         <label className="form-label">Relationship</label>
//                                         <input type="text" className="form-control" value={contact.relationship} onChange={(e) => handleContactChange(idx, 'relationship', e.target.value)} required disabled={isLocked} />
//                                     </div>
//                                 </div>
//                                 <div className="grid-2">
//                                     <div className="form-group">
//                                         <label className="form-label">Phone Number</label>
//                                         <input type="tel" className="form-control" value={contact.phone} onChange={(e) => handleContactChange(idx, 'phone', e.target.value)} required disabled={isLocked} />
//                                     </div>
//                                     <div className="form-group">
//                                         <label className="form-label">Email</label>
//                                         <input type="email" className="form-control" value={contact.email} onChange={(e) => handleContactChange(idx, 'email', e.target.value)} required disabled={isLocked} />
//                                     </div>
//                                 </div>
//                                 <div className="form-group" style={{ marginTop: '1rem' }}>
//                                     <label className="form-label">Address</label>
//                                     <input type="text" className="form-control" value={contact.address || ''} onChange={(e) => handleContactChange(idx, 'address', e.target.value)} required disabled={isLocked} />
//                                 </div>
//                             </div>
//                         ))}

//                         {!isLocked && (
//                             <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
//                                 <button type="button" className="btn btn-secondary" onClick={handleAddContact}>+ Add Contact</button>
//                                 <button type="submit" className="btn btn-primary">Save Contacts</button>
//                             </div>
//                         )}
//                     </form>
//                 </div>
//             )}

//             {/* DOCUMENTS UPLOADS TAB (Form I-9 & Onboarding Documents Checklist) */}
//             {activeTab === 'documents' && (() => {
//                 const country = data?.employee?.country || '';
//                 const isIndia = country.toUpperCase() === 'INDIA';
//                 const documents = data?.documents || [];
//                 const requestedDocs = data?.requested_documents || data?.requested_employee_documents || [];
//                 const hasStateID = documents.some(doc => doc.document_type === 'State ID');
//                 const hasSSC = documents.some(doc => doc.document_type === 'Social Security Card (SSC)');
//                 const hasOldCombined = documents.some(doc => doc.document_type === 'Driving License / State ID / SSC');
//                 const activeOption = selectedIdOption || ((hasStateID || hasSSC) ? 'state_id_ssc' : 'driving_license');
//                 return (
//                     <div className="card fade-in">
//                         <div className="card-title">Employee Document Checklists</div>

//                         {/* DYNAMIC MANAGEMENT REQUESTED DOCUMENTS (N ITEMS) */}
//                         {requestedDocs.length > 0 && (
//                             <div
//                                 style={{
//                                     marginBottom: '2rem',
//                                     padding: '1.25rem',
//                                     backgroundColor: 'rgba(59, 130, 246, 0.04)',
//                                     border: '1px solid var(--primary-light, #93c5fd)',
//                                     borderLeft: '4px solid var(--primary, #3b82f6)',
//                                     borderRadius: 'var(--border-radius-md)',
//                                     boxShadow: 'var(--shadow-sm)'
//                                 }}
//                             >
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
//                                     <span style={{ fontSize: '1.25rem' }}>📋</span>
//                                     <h3 style={{ fontSize: '1.05rem', fontWeight: 700, margin: 0, color: 'var(--text-primary)' }}>
//                                         Management Requested Documents ({requestedDocs.length})
//                                     </h3>
//                                 </div>
//                                 <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '1.25rem' }}>
//                                     HR or Management has requested the following additional document(s) specifically for your onboarding profile. Please review the instructions and upload each file below.
//                                 </p>

//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                                     {requestedDocs.map((req, idx) => {
//                                         const docTitle = req.document_name || req.document_type || req.title || req.name || `Requested Document #${idx + 1}`;
//                                         const docInstruction = req.instructions || req.comments || req.description || req.note || req.reason || '';
//                                         return (
//                                             <div key={req.id || idx} style={{ backgroundColor: 'var(--bg-primary)', borderRadius: 'var(--border-radius-sm)', padding: '0.5rem' }}>
//                                                 <UploadField
//                                                     documentType={docTitle}
//                                                     instruction={docInstruction}
//                                                     documentsList={data?.documents || []}
//                                                     onUploadSuccess={() => {
//                                                         setRequestedDocsSubmitted(false);
//                                                         fetchOnboardingData();
//                                                     }}
//                                                     mandatory={true}
//                                                     isLocked={isLocked}
//                                                     allowDeleteWhenLocked={true}
//                                                 />
//                                             </div>
//                                         );
//                                     })}
//                                 </div>
//                             </div>
//                         )}

//                         {isIndia ? (
//                             <>
//                                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '2rem' }}>
//                                     Please upload the required verification files according to Indian HR compliance guidelines.
//                                 </p>

//                                 {/* 1. Academic Qualification */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>1. Academic Qualification</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your highest academic degree certificate or transcript.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Highest Education Qualification (Degree Certificate/Transcript)"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                     />
//                                 </div>

//                                 {/* 2. Aadhar Card */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>2. Aadhar Card</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload front and back side copy of your Aadhar Card.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Aadhar Card"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                     />
//                                 </div>

//                                 {/* 3. PAN Card */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>3. PAN Card</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload a clear scanned copy of your PAN Card.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="PAN Card"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                     />
//                                 </div>

//                                 {/* 4. Passport Size Photo */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>4. Passport Size Photo</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload a recent color passport-size photograph with a clear background.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Passport Size Photo"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                     />
//                                 </div>

//                                 {/* 5. Police Verification */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>5. Police Verification</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your Police Clearance Certificate (PCC) or Character Certificate from local authorities.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Police Verification"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                         showNotAvailable={true}
//                                         notAvailableLabel="I do not have a Police Verification certificate right now"
//                                         consentText="I hereby consent and declare that I do not possess a Police Verification certificate at this moment. I agree and commit to submitting the certificate to HR within one month from my joining date."
//                                     />
//                                 </div>

//                                 {/* 6. Salary Slip of last 3 month */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>6. Salary Slip of last 3 month</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload salary slips from your previous employer for the last three months.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Salary Slip of last 3 month"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                         showNotAvailable={true}
//                                         notAvailableLabel="Not Applicable (Fresh graduate / no previous employment)"
//                                     />
//                                 </div>

//                                 {/* 7. Medical Checkup Documents */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>7. Medical Checkup Documents</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your fitness certificate or medical checkup documents from a registered medical practitioner.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Medical Checkup Documents"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={true}
//                                         showNotAvailable={true}
//                                         notAvailableLabel="I do not have a Medical Checkup report right now"
//                                         consentText="I hereby consent and declare that I do not possess a Medical Checkup report at this moment. I agree and commit to submitting the report to HR within one month from my joining date."
//                                     />
//                                 </div>

//                                 {/* 8. Signed Offer Letter */}
//                                 <div>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>8. Signed Offer Letter</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Automatically saved when you electronically sign your offer letter in the Offer Letter tab.</p>
//                                     </div>
//                                     <UploadField
//                                         documentType="Signed Offer Letter"
//                                         documentsList={data?.documents}
//                                         onUploadSuccess={fetchOnboardingData}
//                                         mandatory={false}
//                                     />
//                                 </div>
//                             </>
//                         ) : (
//                             <>
//                                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '2rem' }}>
//                                     Please upload the required verification files according to US enterprise HR compliance guidelines.
//                                 </p>

//                                 {/* 1. Form I-9 */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '1rem' }}>
//                                         <div>
//                                             <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>1. Form I-9</h4>
//                                             <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Employment Eligibility Verification. Download, complete, and upload.</p>
//                                         </div>
//                                         <a href="/Form_I-9.pdf" download className="btn btn-secondary" style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', textDecoration: 'none', fontWeight: 600 }}>
//                                             📥 Download Form I-9
//                                         </a>
//                                     </div>
//                                     <UploadField documentType="Form I-9" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                                 </div>

//                                 {/* 2. Form W-4 */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '1rem' }}>
//                                         <div>
//                                             <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>2. Form W-4</h4>
//                                             <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Employee's Withholding Certificate. Download, complete, and upload.</p>
//                                         </div>
//                                         <a href="/Form_W-4.pdf" download className="btn btn-secondary" style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', textDecoration: 'none', fontWeight: 600 }}>
//                                             📥 Download Form W-4
//                                         </a>
//                                     </div>
//                                     <UploadField documentType="Form W-4" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                                 </div>

//                                 {/* 3. Select State */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem', padding: '1rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)', backgroundColor: 'var(--bg-secondary)' }}>
//                                     <div style={{ marginBottom: '1rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.25rem 0', color: 'var(--text-primary)' }}>3. Select State</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: '0 0 0.75rem 0' }}>Select your state to download and submit the corresponding state tax withholding form.</p>
//                                         <select
//                                             value={selectedState}
//                                             onChange={(e) => setSelectedState(e.target.value)}
//                                             className="form-control"
//                                             style={{ maxWidth: '300px', padding: '0.5rem', borderRadius: 'var(--border-radius-sm)' }}
//                                             disabled={isLocked}
//                                         >
//                                             <option value="">-- Choose Your State --</option>
//                                             <option value="oregon">Oregon</option>
//                                             <option value="arizona">Arizona</option>
//                                             <option value="colorado">Colorado</option>
//                                         </select>
//                                     </div>

//                                     {selectedState && (
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1rem', marginTop: '1rem' }}>
//                                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '1rem' }}>
//                                                 <div>
//                                                     <h5 style={{ fontSize: '0.9rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>
//                                                         {selectedState === 'oregon' && 'Oregon Form OR-W-4'}
//                                                         {selectedState === 'arizona' && 'Arizona Form A-4'}
//                                                         {selectedState === 'colorado' && 'Colorado Form DR 0004'}
//                                                     </h5>
//                                                     <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>
//                                                         {selectedState === 'oregon' && 'Oregon State withholding allowance certificate.'}
//                                                         {selectedState === 'arizona' && 'Arizona State withholding election form.'}
//                                                         {selectedState === 'colorado' && 'Colorado State employee withholding certificate.'}
//                                                     </p>
//                                                 </div>
//                                                 <a
//                                                     href={
//                                                         selectedState === 'oregon' ? '/Oregon_Form_W-4.pdf' :
//                                                             selectedState === 'arizona' ? '/Arizona_Form_A4.pdf' :
//                                                                 '/Colorado_Form_DR0004.pdf'
//                                                     }
//                                                     download
//                                                     className="btn btn-secondary"
//                                                     style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', textDecoration: 'none', fontWeight: 600 }}
//                                                 >
//                                                     📥 Download {selectedState.toUpperCase()} Form
//                                                 </a>
//                                             </div>
//                                             <UploadField
//                                                 documentType={
//                                                     selectedState === 'oregon' ? 'Oregon State Tax Form' :
//                                                         selectedState === 'arizona' ? 'Arizona State Tax Form' :
//                                                             'Colorado State Tax Form'
//                                                 }
//                                                 documentsList={data?.documents}
//                                                 onUploadSuccess={fetchOnboardingData}
//                                                 mandatory={true}
//                                             />
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* 4. Passport */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>4. Passport</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your valid Passport (bio page & back page).</p>
//                                     </div>
//                                     <UploadField documentType="Passport" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                                 </div>

//                                 {/* 5. Visa & EAD */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>5. Visa & EAD</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your valid Visa or Employment Authorization Document (EAD).</p>
//                                     </div>
//                                     <UploadField documentType="Visa & EAD" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                                 </div>

//                                 {/* 6. US Identification * */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.75rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>6. US Identification *</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: '0.25rem 0 0.75rem 0' }}>
//                                             Choose your identification submission method: either submit a valid Driving License, or submit a State ID along with your Social Security Card (SSC).
//                                         </p>
//                                     </div>

//                                     <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap', padding: '0 0.5rem' }}>
//                                         <label style={{
//                                             flex: '1 1 200px',
//                                             padding: '0.85rem 1rem',
//                                             border: activeOption === 'driving_license' ? '2px solid var(--primary)' : '1px solid var(--border-color)',
//                                             borderRadius: 'var(--border-radius-md)',
//                                             cursor: 'pointer',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             gap: '0.75rem',
//                                             backgroundColor: activeOption === 'driving_license' ? 'rgba(59, 130, 246, 0.04)' : 'var(--bg-secondary)',
//                                             transition: 'all 0.2s ease'
//                                         }}>
//                                             <input
//                                                 type="radio"
//                                                 name="id_option"
//                                                 checked={activeOption === 'driving_license'}
//                                                 onChange={() => setSelectedIdOption('driving_license')}
//                                                 style={{ accentColor: 'var(--primary)' }}
//                                                 disabled={isLocked}
//                                             />
//                                             <div>
//                                                 <strong style={{ display: 'block', fontSize: '0.85rem', color: 'var(--text-primary)' }}>Driving License</strong>
//                                                 <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Upload your valid US Driving License.</span>
//                                             </div>
//                                         </label>

//                                         <label style={{
//                                             flex: '1 1 200px',
//                                             padding: '0.85rem 1rem',
//                                             border: activeOption === 'state_id_ssc' ? '2px solid var(--primary)' : '1px solid var(--border-color)',
//                                             borderRadius: 'var(--border-radius-md)',
//                                             cursor: 'pointer',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             gap: '0.75rem',
//                                             backgroundColor: activeOption === 'state_id_ssc' ? 'rgba(59, 130, 246, 0.04)' : 'var(--bg-secondary)',
//                                             transition: 'all 0.2s ease'
//                                         }}>
//                                             <input
//                                                 type="radio"
//                                                 name="id_option"
//                                                 checked={activeOption === 'state_id_ssc'}
//                                                 onChange={() => setSelectedIdOption('state_id_ssc')}
//                                                 style={{ accentColor: 'var(--primary)' }}
//                                                 disabled={isLocked}
//                                             />
//                                             <div>
//                                                 <strong style={{ display: 'block', fontSize: '0.85rem', color: 'var(--text-primary)' }}>State ID & Social Security Card (SSC)</strong>
//                                                 <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Upload both your State ID and Social Security Card.</span>
//                                             </div>
//                                         </label>
//                                     </div>

//                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                         {activeOption === 'driving_license' ? (
//                                             <UploadField
//                                                 documentType="Driving License"
//                                                 documentsList={data?.documents}
//                                                 onUploadSuccess={fetchOnboardingData}
//                                                 mandatory={true}
//                                             />
//                                         ) : (
//                                             <>
//                                                 <UploadField
//                                                     documentType="State ID"
//                                                     documentsList={data?.documents}
//                                                     onUploadSuccess={fetchOnboardingData}
//                                                     mandatory={true}
//                                                 />
//                                                 <UploadField
//                                                     documentType="Social Security Card (SSC)"
//                                                     documentsList={data?.documents}
//                                                     onUploadSuccess={fetchOnboardingData}
//                                                     mandatory={true}
//                                                 />
//                                             </>
//                                         )}

//                                         {hasOldCombined && (
//                                             <div style={{ marginTop: '1rem', borderTop: '1px dashed var(--border-color)', paddingTop: '1rem' }}>
//                                                 <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginBottom: '0.5rem', fontWeight: 600 }}>
//                                                     Previously uploaded combined identification document:
//                                                 </p>
//                                                 <UploadField
//                                                     documentType="Driving License / State ID / SSC"
//                                                     documentsList={data?.documents}
//                                                     onUploadSuccess={fetchOnboardingData}
//                                                     mandatory={false}
//                                                 />
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>

//                                 {/* 7. Highest Education Qualification (Degree Certification / Transcript) */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>7. Highest Education Qualification (Degree Certification / Transcript)</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your highest education qualification degree certificate or transcript.</p>
//                                     </div>
//                                     <UploadField documentType="Highest Education Qualification (Degree Certificate/Transcript)" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                                 </div>

//                                 {/* 8. Professional Certificate / Licenses */}
//                                 <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>8. Professional Certificate / Licenses</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your professional certification or licenses (optional).</p>
//                                     </div>
//                                     <UploadField documentType="Professional Certificate / Licenses" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={false} />
//                                 </div>

//                                 {/* 9. Other */}
//                                 <div>
//                                     <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
//                                         <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>9. Other</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload any additional supporting documents or records.</p>
//                                     </div>
//                                     <UploadField documentType="Other Documents" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} />
//                                 </div>
//                             </>
//                         )}
//                     </div>
//                 );
//             })()}


//             {/* OFFER LETTER TAB */}
//             {activeTab === 'offer' && (
//                 <div className="card fade-in">
//                     <div className="card-title">Offer Letter Acceptance</div>
//                     <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
//                         Verify and electronically sign your hiring offer letter.
//                     </p>

//                     <div className="agreements-document-grid">
//                         {/* Left side: Pre-signed badge & signature drawer */}
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
//                             <div
//                                 style={{
//                                     border: '1px solid var(--border-color)',
//                                     borderRadius: 'var(--border-radius-md)',
//                                     padding: '1.5rem',
//                                     backgroundColor: 'var(--bg-secondary)',
//                                     boxShadow: 'var(--shadow-sm)',
//                                     fontSize: '0.825rem'
//                                 }}
//                             >
//                                 <h4 style={{ fontWeight: 'bold', marginBottom: '0.75rem', color: 'var(--primary)' }}>Authorized Representative Signature</h4>
//                                 <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', marginBottom: '0.5rem' }}>
//                                     <span style={{ fontSize: '1.5rem' }}>✍️</span>
//                                     <div>
//                                         <strong>Neeta Shrikant Sangvikar</strong>
//                                         <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>Director HR, Genesis Tech Engineers</div>
//                                     </div>
//                                 </div>
//                                 <div style={{ fontSize: '0.75rem', color: 'var(--success)', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.25rem', marginTop: '0.5rem' }}>
//                                     <span>✓</span> Document pre-signed by Employer
//                                 </div>
//                             </div>

//                             {data?.signature_history?.some(h => h.document_type === 'Offer Letter' && h.action === 'SIGN') ? (
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                                     <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1.25rem', borderRadius: 'var(--border-radius-sm)', fontSize: '0.85rem' }}>
//                                         🚀 <strong>Offer Letter Signed</strong>: You accepted and electronically signed this Offer Letter on {new Date(data.signature_history.find(h => h.document_type === 'Offer Letter' && h.action === 'SIGN').signed_at).toLocaleString()}.
//                                     </div>
//                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                         <button
//                                             type="button"
//                                             className="btn btn-primary"
//                                             style={{ width: '100%', padding: '0.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                                             onClick={() => handleDownloadPdf(offerLetterBlobUrl, `offer_letter_${(employee?.FirstName || 'employee').toLowerCase()}_${(employee?.LastName || 'signed').toLowerCase()}_signed.pdf`)}
//                                         >
//                                             📥 Download Signed Offer Letter
//                                         </button>

//                                     </div>
//                                 </div>
//                             ) : (
//                                 !isLocked && <SignaturePad onSave={(sig) => handleDocumentSign('Offer Letter', sig)} />
//                             )}
//                         </div>

//                         {/* Right side: The PDF/Base64 Preview from Database */}
//                         <div>
//                             {offerLetterBlobUrl ? (
//                                 <div style={{ border: '2px solid #334155', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow-md)', backgroundColor: 'var(--bg-secondary)' }}>
//                                     <div className="mobile-helper-banner" style={{
//                                         padding: '0.75rem 1rem',
//                                         backgroundColor: 'var(--bg-tertiary)',
//                                         borderBottom: '1px solid var(--border-color)',
//                                         flexWrap: 'wrap',
//                                         alignItems: 'center',
//                                         justifyContent: 'space-between',
//                                         gap: '0.5rem'
//                                     }}>
//                                         <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
//                                             📱 Reading on Mobile?
//                                         </span>
//                                         <div style={{ display: 'flex', gap: '0.5rem' }}>
//                                             <button
//                                                 type="button"
//                                                 className="btn btn-secondary"
//                                                 style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
//                                                 onClick={() => handleViewPdf(offerLetterBlobUrl, 'offer_letter.pdf')}
//                                             >
//                                                 📂 Open Fullscreen & Zoom
//                                             </button>
//                                             <button
//                                                 type="button"
//                                                 className="btn btn-primary"
//                                                 style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
//                                                 onClick={() => handleDownloadPdf(offerLetterBlobUrl, 'offer_letter.pdf')}
//                                             >
//                                                 📥 Download PDF
//                                             </button>
//                                         </div>
//                                     </div>
//                                     <iframe
//                                         src={`${offerLetterBlobUrl}#toolbar=0&navpanes=0&view=FitH`}
//                                         className="document-iframe"
//                                         style={{ height: "750px" }}
//                                         title="Offer Letter PDF Viewer"
//                                     />
//                                 </div>
//                             ) : (
//                                 <div className="document-text-preview">
//                                     {/* Header */}
//                                     <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', borderBottom: '2px solid #000000', paddingBottom: '0.75rem', marginBottom: '1.5rem' }}>
//                                         {/* Green Logo SVG */}
//                                         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', minWidth: '95px' }}>
//                                             <svg width="45" height="45" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                 <circle cx="50" cy="50" r="38" stroke="#16a34a" strokeWidth="6" strokeDasharray="10 5" />
//                                                 <circle cx="50" cy="50" r="22" fill="#16a34a" opacity="0.8" />
//                                                 <path d="M50 10 L56 26 L44 26 Z" fill="#16a34a" />
//                                                 <path d="M50 90 L56 74 L44 74 Z" fill="#16a34a" />
//                                                 <path d="M10 50 L26 56 L26 44 Z" fill="#16a34a" />
//                                                 <path d="M90 50 L74 56 L74 44 Z" fill="#16a34a" />
//                                             </svg>
//                                             <span style={{ fontSize: '0.6rem', fontWeight: '800', color: '#16a34a', lineHeight: 1.1, marginTop: '0.25rem' }}>GENESIS TECH</span>
//                                             <span style={{ fontSize: '0.6rem', fontWeight: '800', color: '#16a34a', lineHeight: 1.0 }}>ENGINEERS</span>
//                                             <span style={{ fontSize: '0.35rem', fontWeight: '600', color: '#16a34a', marginTop: '0.1rem', letterSpacing: '0.02em', textTransform: 'uppercase' }}>Making Engineering Sustainable</span>
//                                         </div>

//                                         {/* Header details */}
//                                         <div style={{ flex: 1, textAlign: 'center' }}>
//                                             <h2 style={{ fontSize: '1.25rem', fontWeight: '800', color: '#000000', margin: '0 0 0.25rem 0', letterSpacing: '0.02em' }}>GENESIS TECH ENGINEERS PVT. LTD.</h2>
//                                             <p style={{ fontSize: '0.55rem', color: '#334155', margin: '0 0 0.25rem 0', fontWeight: '700', lineHeight: 1.3 }}>
//                                                 REGISTERED ADDRESS : PLOT NO 5, GOKUL SOCIETY, DATTAWADI, SADASHIV PETH, PUNE CITY, PUNE - 411030. MH, INDIA.
//                                             </p>
//                                             <p style={{ fontSize: '0.55rem', color: '#334155', margin: 0, fontWeight: '700' }}>
//                                                 GST #: <span style={{ color: '#000000' }}>27AAKCG7985R1ZB</span> &nbsp;|&nbsp; PAN #: <span style={{ color: '#000000' }}>AAKCG7985R</span> &nbsp;|&nbsp; Contact: <span style={{ color: '#000000' }}>+91-8983260210</span>
//                                             </p>
//                                             <p style={{ fontSize: '0.55rem', color: '#334155', margin: '0.15rem 0 0 0', fontWeight: '700' }}>
//                                                 Website: <a href="http://www.genesistech.co.in" target="_blank" rel="noreferrer" style={{ color: '#2563eb', textDecoration: 'none' }}>www.genesistech.co.in</a> &nbsp; E-mail: <a href="mailto:contact@genesistech.co.in" style={{ color: '#2563eb', textDecoration: 'none' }}>contact@genesistech.co.in</a>
//                                             </p>
//                                         </div>
//                                     </div>

//                                     <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', fontSize: '0.8rem', color: '#475569' }}>
//                                         <span>Document ID: GTE-OL-{1000 + (employee.id || 1)}</span>
//                                         <span>Date: {employee.JoiningDate || '28/7/2026'}</span>
//                                     </div>

//                                     <h3 style={{ fontSize: '1rem', fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase', marginBottom: '1.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.5rem' }}>
//                                         JOB OFFER LETTER
//                                     </h3>

//                                     <p style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
//                                         Dear {employee.FirstName} {employee.LastName},
//                                     </p>

//                                     <p style={{ marginBottom: '1.25rem' }}>
//                                         We are delighted to offer you the role at Genesis Tech Engineers Pvt. Ltd. You are an outstanding applicant, and we believe that your skills and experience make you an excellent addition to the team. Below, you will find more information about the role, compensation, and some of the amazing benefits available to you when you join Genesis Tech Engineers Pvt. Ltd. Please also refer to the enclosed General Terms & Conditions of Employment where you will find further information on your employment, including information on your right to work in India and pre-employment checks.
//                                     </p>

//                                     <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.25rem', marginBottom: '0.5rem' }}>1. Your Job:</h4>
//                                     <ul style={{ listStyleType: 'none', paddingLeft: 0, marginBottom: '1.25rem', display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                                         <li><strong>Role:</strong> {employee.Designation || 'Software Development Engineer'}</li>
//                                         <li><strong>Office Location:</strong> DNK SQUARE, 14th Floor, Office 1401, 1406, Airport Road, Sakore Nagar, Viman Nagar, Pune, Maharashtra - 411014</li>
//                                         <li><strong>Start Date:</strong> {employee.JoiningDate || '2026-08-08'}</li>
//                                         <li><strong>Work Model:</strong> Work from Office</li>
//                                         <li><strong>Office timing:</strong> 9.30am - 12.30am</li>
//                                         <li><strong>Employee ID:</strong> -</li>
//                                     </ul>

//                                     <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.25rem', marginBottom: '0.5rem' }}>2. Pay:</h4>
//                                     <p style={{ marginBottom: '1.25rem' }}>
//                                         Your annual CTC is <strong>{employee.OfferedCTC || 'As agreed'}</strong> which shall be payable monthly in arrears on or about the payroll cut-off of each month directly into your nominated bank account. If your employment commencement date is on or before the payroll cutoff of the month, you will receive your first month's pay on the month's payday of when your employment commences.
//                                     </p>

//                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', borderTop: '1px dashed #cbd5e1', paddingTop: '1.5rem', marginTop: '2rem' }}>
//                                         <p><strong>Employee Sign:</strong> ___________________________</p>
//                                         <p><strong>Employee Name:</strong> {employee.FirstName} {employee.LastName}</p>
//                                         <p><strong>Date:</strong> ___________________________</p>
//                                     </div>

//                                     <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                         <p><strong>For: Genesis Tech Engineers Pvt. Ltd.</strong></p>
//                                         <div style={{ fontSize: '1rem', fontStyle: 'italic', color: 'var(--primary)', margin: '0.25rem 0' }}>Neeta</div>
//                                         <p><strong>Name:</strong> NEETA SHRIKANT SANGVIKAR</p>
//                                         <p><strong>Designation:</strong> DIRECTOR HR</p>
//                                     </div>

//                                     <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', marginTop: '2rem', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                         [Page 1 of 1]
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* EMPLOYEE AGREEMENT TAB */}
//             {activeTab === 'agreement' && (() => {
//                 const country = employee?.country || '';
//                 const isUsa = country.toUpperCase() === 'USA';
//                 const agreementsList = isUsa ? [
//                     { key: 'employment_agreement', title: 'Employment Agreement 1', displayName: 'Employment Agreement', path: '/Employment Agreement 1.pdf', desc: 'Verify and electronically sign your formal Employment Agreement.' },
//                     { key: 'confidentiality_nda', title: 'Employee Confidentiality & NDA (1)', displayName: 'Employee Confidentiality & NDA', path: '/Employee Confidentiality & NDA (1).pdf', desc: 'Electronically sign the Corporate Non-Disclosure Agreement.' },
//                     { key: 'conflict_of_interest', title: 'Conflict of interest agreement', path: '/Conflict of interest agreement.pdf', desc: 'Sign the Conflict of Interest policy compliance statement.' },
//                     { key: '401k_dental_vision_medical', title: '401K Dental Vision Medical', path: '/401K Dental Vision Medical.pdf', desc: 'Acknowledge details of the 401K and healthcare benefit details.' },
//                     { key: 'non_solicitation', title: 'Non Solicitation', path: '/Non Solicitation.pdf', desc: 'Sign the Non-Solicitation Agreement.' }
//                 ] : [
//                     { key: 'employee_agreement', title: 'Employee Agreement', path: '/3-Employment Agreement.pdf', desc: 'Verify and electronically sign your formal Employment Agreement.' }
//                 ];

//                 const isAgreementSigned = (title) => {
//                     return data?.signature_history?.some(h => h.document_type === title && h.action === 'SIGN');
//                 };

//                 const getSignatureDate = (title) => {
//                     const sig = data?.signature_history?.find(h => h.document_type === title && h.action === 'SIGN');
//                     return sig ? new Date(sig.signed_at).toLocaleString() : '';
//                 };

//                 const activeAgreement = agreementsList.find(a => a.key === selectedAgreementKey) || agreementsList[0];
//                 const activeBlobUrl = agreementBlobUrls[activeAgreement?.key] || activeAgreement?.path;

//                 const signedCount = agreementsList.filter(item => isAgreementSigned(item.title)).length;
//                 const totalCount = agreementsList.length;
//                 const progressPercentage = Math.round((signedCount / totalCount) * 100);

//                 return (
//                     <div className="card fade-in">
//                         <div className="card-title">Employee Agreement Acceptance</div>
//                         <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
//                             {isUsa
//                                 ? "Please review and electronically sign all 5 required agreements to complete your onboarding."
//                                 : "Verify and electronically sign your formal Employment Agreement."}
//                         </p>

//                         {/* SLEEK PROGRESS CARD FOR USA */}
//                         {isUsa && (
//                             <div style={{
//                                 marginBottom: '1.5rem',
//                                 padding: '1rem 1.25rem',
//                                 borderRadius: '8px',
//                                 background: 'linear-gradient(135deg, rgba(79, 70, 229, 0.04) 0%, rgba(99, 102, 241, 0.04) 100%)',
//                                 border: '1px solid rgba(79, 70, 229, 0.1)',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'space-between',
//                                 flexWrap: 'wrap',
//                                 gap: '1rem'
//                             }}>
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
//                                     <span style={{ fontSize: '1.5rem' }}>📋</span>
//                                     <div>
//                                         <div style={{ fontSize: '0.875rem', fontWeight: 'bold', color: 'var(--text-primary)' }}>
//                                             Employee Agreement Packages Signature Status
//                                         </div>
//                                         <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '0.15rem' }}>
//                                             {signedCount} of {totalCount} signed
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div style={{ flex: '1 1 200px', display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                                     <div style={{ flex: 1, height: '8px', backgroundColor: 'rgba(79, 70, 229, 0.1)', borderRadius: '4px', overflow: 'hidden' }}>
//                                         <div style={{ width: `${progressPercentage}%`, height: '100%', backgroundColor: 'var(--primary)', transition: 'width 0.4s ease' }} />
//                                     </div>
//                                     <span style={{ fontSize: '0.875rem', fontWeight: 'bold', color: 'var(--primary)' }}>
//                                         {progressPercentage}%
//                                     </span>
//                                 </div>
//                             </div>
//                         )}

//                         {/* HORIZONTAL SELECTOR TABS */}
//                         <div className="agreements-horizontal-tabs">
//                             {agreementsList.map((item) => {
//                                 const signed = isAgreementSigned(item.title);
//                                 const active = selectedAgreementKey === item.key;
//                                 return (
//                                     <div
//                                         key={item.key}
//                                         onClick={() => setSelectedAgreementKey(item.key)}
//                                         className={`agreement-tab-item ${active ? 'active' : ''}`}
//                                     >
//                                         <div className="agreement-tab-title">{item.displayName || item.title}</div>
//                                         <div className="agreement-tab-status">
//                                             {signed ? (
//                                                 <span style={{ color: 'var(--success)', fontWeight: 600 }}>✓ Signed</span>
//                                             ) : (
//                                                 <span style={{ color: '#d97706', fontWeight: 600 }}>⏳ Pending</span>
//                                             )}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                         </div>

//                         {/* CORE VIEW / SIGN FLOW - DUAL COLUMN GRID: INPUTS LEFT, PDF RIGHT */}
//                         <div className="agreements-document-grid">
//                             {/* Right Column: Signature Signoff area */}
//                             <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
//                                 <div
//                                     style={{
//                                         border: '1px solid var(--border-color)',
//                                         borderRadius: 'var(--border-radius-md)',
//                                         padding: '1.5rem',
//                                         backgroundColor: 'var(--bg-secondary)',
//                                         boxShadow: 'var(--shadow-sm)',
//                                         fontSize: '0.825rem'
//                                     }}
//                                 >
//                                     <h4 style={{ fontWeight: 'bold', marginBottom: '0.75rem', color: 'var(--primary)' }}>Authorized Representative Signature</h4>
//                                     <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', marginBottom: '0.5rem' }}>
//                                         <span style={{ fontSize: '1.5rem' }}>✍️</span>
//                                         <div>
//                                             <strong>Neeta Shrikant Sangvikar</strong>
//                                             <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>Director HR, Genesis Tech Engineers</div>
//                                         </div>
//                                     </div>
//                                     <div style={{ fontSize: '0.75rem', color: 'var(--success)', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.25rem', marginTop: '0.5rem' }}>
//                                         <span>✓</span> Document pre-signed by Employer
//                                     </div>
//                                 </div>





//                                 {selectedAgreementKey === 'conflict_of_interest' && !isAgreementSigned(activeAgreement?.title) && (
//                                     <div
//                                         style={{
//                                             border: '1px solid var(--border-color)',
//                                             borderRadius: 'var(--border-radius-md)',
//                                             padding: '1.5rem',
//                                             backgroundColor: 'var(--bg-secondary)',
//                                             boxShadow: 'var(--shadow-sm)',
//                                             display: 'flex',
//                                             flexDirection: 'column',
//                                             gap: '1rem'
//                                         }}
//                                     >
//                                         <h4 style={{ fontWeight: 'bold', color: 'var(--primary)', margin: 0, fontSize: '0.95rem' }}>Conflict of Interest Info</h4>
//                                         <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>
//                                             Please fill out the details below. They will be dynamically updated in your Conflict of Interest PDF.
//                                         </p>




//                                         {/* A. Outside Employment */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem', marginTop: '0.25rem' }}>
//                                             <label style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>A. Outside Employment</label>
//                                             <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="outsideEmploymentType"
//                                                         value="none"
//                                                         checked={employmentForm.outsideEmploymentType === 'none'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, outsideEmploymentType: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     I am not employed by any other employer.
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="outsideEmploymentType"
//                                                         value="has_employment"
//                                                         checked={employmentForm.outsideEmploymentType === 'has_employment'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, outsideEmploymentType: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     I currently have outside employment.
//                                                 </label>
//                                             </div>
//                                         </div>

//                                         {employmentForm.outsideEmploymentType === 'has_employment' && (
//                                             <div style={{ paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem', borderLeft: '2px solid var(--primary-light)' }}>
//                                                 <div className="form-group" style={{ margin: 0 }}>
//                                                     <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Employer / Business</label>
//                                                     <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         value={employmentForm.outsideEmployer}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, outsideEmployer: e.target.value })}
//                                                         disabled={isLocked}
//                                                         style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                                                     />
//                                                 </div>
//                                                 <div className="form-group" style={{ margin: 0 }}>
//                                                     <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Nature of Work</label>
//                                                     <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         value={employmentForm.outsideNature}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, outsideNature: e.target.value })}
//                                                         disabled={isLocked}
//                                                         style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                                                     />
//                                                 </div>
//                                                 <div className="form-group" style={{ margin: 0 }}>
//                                                     <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Hours Worked</label>
//                                                     <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         value={employmentForm.outsideHours}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, outsideHours: e.target.value })}
//                                                         disabled={isLocked}
//                                                         style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}

//                                         {/* B. Ownership of Other Businesses */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>B. Ownership of Other Businesses</label>
//                                             <span style={{ fontSize: '0.7rem', display: 'block', marginBottom: '0.4rem', color: 'var(--text-secondary)' }}>Do you own or have an interest in any business?</span>
//                                             <div style={{ display: 'flex', gap: '1rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="ownershipType"
//                                                         value="no"
//                                                         checked={employmentForm.ownershipType === 'no'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, ownershipType: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     No
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="ownershipType"
//                                                         value="yes"
//                                                         checked={employmentForm.ownershipType === 'yes'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, ownershipType: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Yes
//                                                 </label>
//                                             </div>
//                                         </div>

//                                         {employmentForm.ownershipType === 'yes' && (
//                                             <div className="form-group" style={{ margin: 0, paddingLeft: '1rem', borderLeft: '2px solid var(--primary-light)' }}>
//                                                 <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>If yes, describe:</label>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control"
//                                                     value={employmentForm.ownershipDescribe}
//                                                     onChange={(e) => setEmploymentForm({ ...employmentForm, ownershipDescribe: e.target.value })}
//                                                     disabled={isLocked}
//                                                     style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                                                 />
//                                             </div>
//                                         )}

//                                         {/* C. Competing Activities */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>C. Competing Activities</label>
//                                             <span style={{ fontSize: '0.7rem', display: 'block', marginBottom: '0.4rem', color: 'var(--text-secondary)' }}>Are you involved in any competing activities?</span>
//                                             <div style={{ display: 'flex', gap: '1rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="competingType"
//                                                         value="no"
//                                                         checked={employmentForm.competingType === 'no'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, competingType: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     No
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="competingType"
//                                                         value="yes"
//                                                         checked={employmentForm.competingType === 'yes'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, competingType: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Yes
//                                                 </label>
//                                             </div>
//                                         </div>

//                                         {employmentForm.competingType === 'yes' && (
//                                             <div className="form-group" style={{ margin: 0, paddingLeft: '1rem', borderLeft: '2px solid var(--primary-light)' }}>
//                                                 <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>If yes, explain:</label>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control"
//                                                     value={employmentForm.competingDescribe}
//                                                     onChange={(e) => setEmploymentForm({ ...employmentForm, competingDescribe: e.target.value })}
//                                                     disabled={isLocked}
//                                                     style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
//                                                 />
//                                             </div>
//                                         )}

//                                         {/* D. Other Potential Conflicts */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label className="form-label" style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>D. Other Potential Conflicts</label>
//                                             <span style={{ fontSize: '0.7rem', display: 'block', marginBottom: '0.4rem', color: 'var(--text-secondary)' }}>Describe any actual or potential conflict circumstances:</span>
//                                             <textarea
//                                                 className="form-control"
//                                                 rows="2"
//                                                 value={employmentForm.otherConflicts}
//                                                 onChange={(e) => setEmploymentForm({ ...employmentForm, otherConflicts: e.target.value })}
//                                                 disabled={isLocked}
//                                                 style={{ padding: '0.4rem 0.65rem', fontSize: '0.85rem', resize: 'vertical' }}
//                                                 placeholder="None (or details here)"
//                                             />
//                                         </div>
//                                     </div>
//                                 )}

//                                 {selectedAgreementKey === '401k_dental_vision_medical' && !isAgreementSigned(activeAgreement?.title) && (
//                                     <div
//                                         style={{
//                                             border: '1px solid var(--border-color)',
//                                             borderRadius: 'var(--border-radius-md)',
//                                             padding: '1.75rem',
//                                             backgroundColor: 'var(--bg-secondary)',
//                                             boxShadow: 'var(--shadow-sm)',
//                                             display: 'flex',
//                                             flexDirection: 'column',
//                                             gap: '1.25rem'
//                                         }}
//                                     >
//                                         <h4 style={{ fontWeight: 'bold', color: 'var(--primary)', margin: 0, fontSize: '1rem', borderBottom: '2px solid var(--primary)', paddingBottom: '0.5rem' }}>
//                                             401K Dental Vision Medical Enrollment Form
//                                         </h4>

//                                         <div style={{ backgroundColor: 'var(--bg-primary)', padding: '0.75rem 1rem', borderRadius: 'var(--border-radius-sm)', borderLeft: '3px solid var(--primary)' }}>
//                                             <h5 style={{ fontWeight: 'bold', fontSize: '0.8rem', margin: '0 0 0.25rem 0', color: 'var(--text-primary)' }}>Instructions</h5>
//                                             <p style={{ fontSize: '0.72rem', color: 'var(--text-secondary)', margin: 0, lineHeight: 1.4 }}>
//                                                 Please complete this form to enroll in the Company's employee benefit programs. Enrollment is subject to eligibility requirements, applicable plan documents, insurance carrier rules, and Company policies.
//                                             </p>
//                                         </div>



//                                         {/* Section 1 – Medical Insurance */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                                                 Section 1 – Medical Insurance
//                                             </label>
//                                             <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                                                 Enrolment Election
//                                             </span>
//                                             <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginBottom: '0.5rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="medicalElection"
//                                                         value="enrol"
//                                                         checked={employmentForm.medicalElection === 'enrol'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, medicalElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Enrol
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="medicalElection"
//                                                         value="waive"
//                                                         checked={employmentForm.medicalElection === 'waive'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, medicalElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Waive Coverage
//                                                 </label>
//                                             </div>
//                                         </div>

//                                         {employmentForm.medicalElection === 'waive' && (
//                                             <div style={{ paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.4rem', borderLeft: '2px solid var(--primary-light)' }}>
//                                                 <span style={{ fontSize: '0.72rem', color: 'var(--text-secondary)' }}>If waiving medical coverage, reason:</span>
//                                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                                                     <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                         <input
//                                                             type="radio"
//                                                             name="medicalWaiveReason"
//                                                             value="spouse_plan"
//                                                             checked={employmentForm.medicalWaiveReason === 'spouse_plan'}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
//                                                             disabled={isLocked}
//                                                         />
//                                                         Covered under spouse's employer plan
//                                                     </label>
//                                                     <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                         <input
//                                                             type="radio"
//                                                             name="medicalWaiveReason"
//                                                             value="another_plan"
//                                                             checked={employmentForm.medicalWaiveReason === 'another_plan'}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
//                                                             disabled={isLocked}
//                                                         />
//                                                         Covered under another employer plan
//                                                     </label>
//                                                     <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                         <input
//                                                             type="radio"
//                                                             name="medicalWaiveReason"
//                                                             value="gov_program"
//                                                             checked={employmentForm.medicalWaiveReason === 'gov_program'}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
//                                                             disabled={isLocked}
//                                                         />
//                                                         Covered under government program
//                                                     </label>
//                                                     <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                         <input
//                                                             type="radio"
//                                                             name="medicalWaiveReason"
//                                                             value="other"
//                                                             checked={employmentForm.medicalWaiveReason === 'other'}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
//                                                             disabled={isLocked}
//                                                         />
//                                                         Other:
//                                                     </label>
//                                                 </div>
//                                                 {employmentForm.medicalWaiveReason === 'other' && (
//                                                     <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         value={employmentForm.medicalWaiveReasonOther}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReasonOther: e.target.value })}
//                                                         disabled={isLocked}
//                                                         placeholder="Specify other reason..."
//                                                         style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem', marginTop: '0.2rem' }}
//                                                     />
//                                                 )}
//                                             </div>
//                                         )}

//                                         {/* Section 2 – Dental Insurance */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                                                 Section 2 – Dental Insurance
//                                             </label>
//                                             <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                                                 Enrolment Election
//                                             </span>
//                                             <div style={{ display: 'flex', gap: '1rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="dentalElection"
//                                                         value="enrol"
//                                                         checked={employmentForm.dentalElection === 'enrol'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, dentalElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Enrol
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="dentalElection"
//                                                         value="waive"
//                                                         checked={employmentForm.dentalElection === 'waive'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, dentalElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Waive Coverage
//                                                 </label>
//                                             </div>
//                                         </div>

//                                         {/* Section 3 – Vision Insurance */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                                                 Section 3 – Vision Insurance
//                                             </label>
//                                             <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                                                 Enrolment Election
//                                             </span>
//                                             <div style={{ display: 'flex', gap: '1rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="visionElection"
//                                                         value="enrol"
//                                                         checked={employmentForm.visionElection === 'enrol'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, visionElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Enrol
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="visionElection"
//                                                         value="waive"
//                                                         checked={employmentForm.visionElection === 'waive'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, visionElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     Waive Coverage
//                                                 </label>
//                                             </div>
//                                         </div>

//                                         {/* Section 4 – 401(k) Retirement Plan Enrolment */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                                                 Section 4 – 401(k) Retirement Plan Enrolment
//                                             </label>
//                                             <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                                                 Participation Election
//                                             </span>
//                                             <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginBottom: '0.65rem' }}>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="retirementElection"
//                                                         value="participate"
//                                                         checked={employmentForm.retirementElection === 'participate'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, retirementElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     I elect to participate in the Company's 401(k) Retirement Plan.
//                                                 </label>
//                                                 <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                     <input
//                                                         type="radio"
//                                                         name="retirementElection"
//                                                         value="decline"
//                                                         checked={employmentForm.retirementElection === 'decline'}
//                                                         onChange={(e) => setEmploymentForm({ ...employmentForm, retirementElection: e.target.value })}
//                                                         disabled={isLocked}
//                                                     />
//                                                     I decline participation at this time.
//                                                 </label>
//                                             </div>

//                                             {employmentForm.retirementElection === 'participate' && (
//                                                 <div style={{ paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.65rem', borderLeft: '2px solid var(--primary-light)', marginBottom: '0.75rem' }}>
//                                                     <span style={{ fontSize: '0.72rem', fontWeight: 600, color: 'var(--text-primary)' }}>Employee Contribution</span>
//                                                     <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Please deduct the following amount from each eligible pay check:</span>
//                                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                                                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                             <input
//                                                                 type="radio"
//                                                                 name="retirementContributionType"
//                                                                 value="percentage"
//                                                                 checked={employmentForm.retirementContributionType === 'percentage'}
//                                                                 onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionType: e.target.value })}
//                                                                 disabled={isLocked}
//                                                             />
//                                                             % of Eligible Compensation
//                                                         </label>
//                                                         {employmentForm.retirementContributionType === 'percentage' && (
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 value={employmentForm.retirementContributionPercent}
//                                                                 onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionPercent: e.target.value })}
//                                                                 disabled={isLocked}
//                                                                 placeholder="%"
//                                                                 style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem', width: '80px', marginLeft: '1.25rem' }}
//                                                             />
//                                                         )}
//                                                         <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
//                                                             <input
//                                                                 type="radio"
//                                                                 name="retirementContributionType"
//                                                                 value="amount"
//                                                                 checked={employmentForm.retirementContributionType === 'amount'}
//                                                                 onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionType: e.target.value })}
//                                                                 disabled={isLocked}
//                                                             />
//                                                             $ per pay period (if permitted under the Plan)
//                                                         </label>
//                                                         {employmentForm.retirementContributionType === 'amount' && (
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 value={employmentForm.retirementContributionAmount}
//                                                                 onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionAmount: e.target.value })}
//                                                                 disabled={isLocked}
//                                                                 placeholder="$"
//                                                                 style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem', width: '120px', marginLeft: '1.25rem' }}
//                                                             />
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             )}

//                                             <div style={{ backgroundColor: 'var(--bg-primary)', padding: '0.75rem', borderRadius: 'var(--border-radius-sm)', border: '1px dashed var(--border-color)', fontSize: '0.7rem', color: 'var(--text-secondary)', lineHeight: 1.4 }}>
//                                                 <strong style={{ color: 'var(--text-primary)', display: 'block', marginBottom: '0.2rem' }}>Company Matching Contribution</strong>
//                                                 Genesis Tech Engineers Inc. currently provides a matching contribution of 100% of the Employee's elective deferrals up to a maximum of 2% of the Employee's eligible compensation, subject to the terms of the Company's 401(k) Plan and applicable law.
//                                                 <div style={{ margin: '0.4rem 0', paddingLeft: '0.5rem', borderLeft: '2px solid var(--primary-light)' }}>
//                                                     • Employee contributes 1% → Company contributes 1%<br />
//                                                     • Employee contributes 2% → Company contributes 2%<br />
//                                                     • Employee contributes 5% → Company contributes 2% (maximum Company match)
//                                                 </div>
//                                                 Employee contributions above 2% are permitted (subject to the Plan), but will not receive additional Company matching contributions beyond the 2% maximum.<br />
//                                                 Company matching contributions are subject to the official Plan Document and may be modified, suspended, or terminated by the Company in accordance with applicable law and the Plan.
//                                             </div>
//                                         </div>

//                                         {/* Section 5 – Beneficiary Designation */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                                                 Section 5 – Beneficiary Designation
//                                             </label>

//                                             {/* Primary Beneficiary */}
//                                             <div style={{ marginBottom: '0.75rem', border: '1px solid var(--border-color)', padding: '0.75rem', borderRadius: 'var(--border-radius-sm)', backgroundColor: 'var(--bg-primary)' }}>
//                                                 <span style={{ fontSize: '0.75rem', fontWeight: 600, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>Primary Beneficiary</span>
//                                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Name:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.primaryBeneName}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBeneName: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Relationship:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.primaryBeneRelationship}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBeneRelationship: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Date of Birth:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.primaryBeneDob}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBeneDob: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Percentage:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.primaryBenePercent}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBenePercent: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             {/* Contingent Beneficiary */}
//                                             <div style={{ border: '1px solid var(--border-color)', padding: '0.75rem', borderRadius: 'var(--border-radius-sm)', backgroundColor: 'var(--bg-primary)' }}>
//                                                 <span style={{ fontSize: '0.75rem', fontWeight: 600, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>Contingent Beneficiary</span>
//                                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Name:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.contingentBeneName}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBeneName: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Relationship:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.contingentBeneRelationship}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBeneRelationship: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Date of Birth:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.contingentBeneDob}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBeneDob: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
//                                                         <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Percentage:</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={employmentForm.contingentBenePercent}
//                                                             onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBenePercent: e.target.value })}
//                                                             disabled={isLocked}
//                                                             style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* Section 6 – Employee Acknowledgments */}
//                                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
//                                             <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
//                                                 Section 6 – Employee Acknowledgments
//                                             </label>
//                                             <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
//                                                 I acknowledge that:
//                                             </span>
//                                             <ol style={{ paddingLeft: '1.25rem', margin: 0, fontSize: '0.7rem', color: 'var(--text-secondary)', display: 'flex', flexDirection: 'column', gap: '0.35rem', lineHeight: 1.4 }}>
//                                                 <li>My eligibility for benefits is subject to the applicable benefit plan documents and Company policies.</li>
//                                                 <li>Insurance coverage becomes effective only after all eligibility requirements are satisfied and enrollment is approved.</li>
//                                                 <li>I authorize Genesis Tech Engineers Inc. to deduct any required employee premiums or retirement contributions from my pay check as permitted by law.</li>
//                                                 <li>I understand that the Company reserves the right to amend, modify, replace, or discontinue any employee benefit plan at any time, subject to applicable law.</li>
//                                                 <li>I understand that the Company's current 401(k) matching contribution is limited to a maximum of 2% of eligible compensation and that contributions above 2% are not matched by the Company.</li>
//                                                 <li>I certify that all information provided on this form is accurate and complete.</li>
//                                             </ol>
//                                         </div>
//                                     </div>
//                                 )}

//                                 {isAgreementSigned(activeAgreement?.title) ? (
//                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                                         <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1.25rem', borderRadius: 'var(--border-radius-sm)', fontSize: '0.85rem' }}>
//                                             🚀 <strong>Agreement Signed</strong>: You accepted and electronically signed this agreement on {getSignatureDate(activeAgreement?.title)}.
//                                         </div>
//                                         <button
//                                             type="button"
//                                             className="btn btn-primary"
//                                             style={{ width: '100%', padding: '0.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                                             onClick={() => handleDownloadPdf(activeBlobUrl, `${activeAgreement?.title.toLowerCase().replace(/\s+/g, '_')}_signed.pdf`)}
//                                         >
//                                             📥 Download Signed {activeAgreement?.displayName || activeAgreement?.title}
//                                         </button>
//                                     </div>
//                                 ) : (
//                                     !isLocked && <SignaturePad onSave={(sig) => handleDocumentSign(activeAgreement?.title, sig)} />
//                                 )}
//                             </div>

//                             <div>
//                                 {activeBlobUrl ? (
//                                     <div style={{ border: '2px solid #334155', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow-md)', backgroundColor: 'var(--bg-secondary)' }}>
//                                         <div className="mobile-helper-banner" style={{
//                                             padding: '0.75rem 1rem',
//                                             backgroundColor: 'var(--bg-tertiary)',
//                                             borderBottom: '1px solid var(--border-color)',
//                                             display: 'flex',
//                                             flexWrap: 'wrap',
//                                             alignItems: 'center',
//                                             justifyContent: 'space-between',
//                                             gap: '0.5rem'
//                                         }}>
//                                             <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
//                                                 📱 Reading on Mobile?
//                                             </span>
//                                             <div style={{ display: 'flex', gap: '0.5rem' }}>
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-secondary"
//                                                     style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
//                                                     onClick={() => handleViewPdf(activeBlobUrl, `${activeAgreement?.title.toLowerCase().replace(/\s+/g, '_')}.pdf`)}
//                                                 >
//                                                     📂 Open Fullscreen & Zoom
//                                                 </button>
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-primary"
//                                                     style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
//                                                     onClick={() => handleDownloadPdf(activeBlobUrl, `${activeAgreement?.title.toLowerCase().replace(/\s+/g, '_')}.pdf`)}
//                                                 >
//                                                     📥 Download PDF
//                                                 </button>
//                                             </div>
//                                         </div>
//                                         <iframe
//                                             src={`${activeBlobUrl}#toolbar=0&navpanes=0&view=FitH`}
//                                             className="document-iframe"
//                                             style={{ height: "750px" }}
//                                             title={`${activeAgreement?.displayName || activeAgreement?.title} PDF Viewer`}
//                                         />
//                                     </div>
//                                 ) : (
//                                     selectedAgreementKey !== 'employment_agreement' && selectedAgreementKey !== 'employee_agreement' ? (
//                                         <div className="document-text-preview" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '3rem' }}>
//                                             <span style={{ fontSize: '3rem', marginBottom: '1.25rem' }}>📄</span>
//                                             <h4 style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>{activeAgreement?.displayName || activeAgreement?.title}</h4>
//                                             <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', maxWidth: '320px' }}>
//                                                 This onboarding agreement is available. Please view or download the template PDF using the controls above.
//                                             </p>
//                                         </div>
//                                     ) : (
//                                         <div className="document-text-preview">

//                                             {/* PAGE 1 HEADER */}
//                                             <div style={{ textAlign: 'center', borderBottom: '2px solid #0f172a', paddingBottom: '1rem', marginBottom: '1.5rem' }}>
//                                                 <h2 style={{ fontSize: '1.3rem', fontWeight: 'bold', margin: '0 0 0.5rem 0' }}>GENESIS TECH ENGINEERS PVT. LTD.</h2>
//                                                 <p style={{ fontSize: '0.7rem', color: '#475569', margin: 0, lineHeight: 1.4 }}>
//                                                     REGISTERED ADDRESS : PLOT NO 5, GOKUL SOCIETY, DATTAWADI, SADASHIV PETH, PUNE CITY, PUNE - 411030. MH, INDIA.<br />
//                                                     GST #: 27AAKCG7985R1ZB | PAN # : AAKCG7985R | Contact: +91-8983260210<br />
//                                                     Website: www.genesistech.co.in | E-mail: contact@genesistech.co.in
//                                                 </p>
//                                             </div>

//                                             <h3 style={{ fontSize: '1rem', fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase', marginBottom: '1.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.5rem' }}>
//                                                 EMPLOYMENT AGREEMENT TERMS & CONDITIONS
//                                             </h3>

//                                             <p style={{ fontStyle: 'italic', marginBottom: '1.25rem' }}>
//                                                 This agreement lays down the terms of employment agreed upon by the employer and employee. Whether stated explicitly in the agreement or not, both the employee and the employer have the duty of mutual confidence and trust, and to make only lawful and reasonable demands on each other.
//                                             </p>

//                                             <p style={{ marginBottom: '1.5rem' }}>
//                                                 This EMPLOYMENT AGREEMENT (Hereinafter, the “Agreement”) is entered into on this {formatAgreementJoiningDate(employee?.joining_date || employee?.JoiningDate || employee?.joining_Date || employee?.joiningDate || employee?.joining || employee?.hire_date || employee?.HireDate || employmentForm?.hireDate)}
//                                             </p>

//                                             <p style={{ fontWeight: 'bold', textAlign: 'center', margin: '1rem 0' }}>BY AND BETWEEN</p>

//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 <strong>Genesis Tech Engineers Pvt. Ltd.</strong>, a private limited company incorporated under the Companies Act, 1956, having its registered office at Plot No 5, Shri Gokul Society, Navi Peth, Sadashiv Peth, Pune, 411030. (hereinafter referred to as the “Company” or “Employer”, which expression shall, unless repugnant to the meaning or context hereof, be deemed to include all permitted successors and assigns),
//                                             </p>

//                                             <p style={{ fontWeight: 'bold', textAlign: 'center', margin: '1rem 0' }}>AND</p>

//                                             <p style={{ marginBottom: '1.5rem' }}>
//                                                 <strong>{employee.FirstName} {employee.LastName}</strong> (hereinafter referred to as the "Employee", which expression shall, unless repugnant to the meaning or context hereof, be deemed to include all permitted successors and assigns).
//                                             </p>

//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 <strong>WHEREAS</strong>, the parties hereto desire to enter into this Agreement to define and set forth the terms and conditions of the employment of the Employee by the Company;
//                                             </p>

//                                             <p style={{ marginBottom: '1.5rem' }}>
//                                                 <strong>NOW, THEREFORE</strong>, in consideration of the mutual covenants and agreements set forth below, it is hereby covenanted and agreed by the Company and the Employee as follows:
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>1. Interpretation</h4>
//                                             <p style={{ marginBottom: '1rem' }}>In this agreement the following terms shall have the following meanings:</p>
//                                             <div style={{ marginLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//                                                 <p>
//                                                     <strong>a) “Confidential Information”</strong>: any trade secret or other information which is confidential or commercially sensitive and which is not in the public domain (other than through the wrongful disclosure by the Employee) and which belongs to any Clientele Company (whether stored or recorded in documentary or electronic form) and which (without limitation) relates to the business methods, management systems, marketing plans, strategic plans, finances, new or maturing business opportunities, marketing activities, processes, inventions, designs or similar of any Clientele Company, or to which any Clientele Company owes a duty of confidentiality to any third party and including in particular [Trade Secrets, Intellectual Property, Business Strategies & Plans, Customer and Supplier Information, Employee Information, Technological Information, Financial Information, Contracts and Agreements, Research and Development like experimental data and innovative concepts.];
//                                                 </p>
//                                                 <p>
//                                                     <strong>b) “The Employment”</strong>: the employment of the Employee by the Company in accordance with the terms of this agreement;
//                                                 </p>
//                                                 <p>
//                                                     <strong>c) “Clientele Company”</strong>: Clientele Company means the consumer or client of the Genesis Tech Engineers Pvt. Ltd.
//                                                 </p>
//                                                 <p>
//                                                     <strong>d) “Termination Date”</strong>: the date on which the Employment ceases.
//                                                 </p>
//                                             </div>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 1 of 7]
//                                             </div>

//                                             {/* PAGE 2 */}
//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>2. Pre-Employment Checks:</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 As part of our commitment to maintaining a professional and secure work environment, Genesis Tech Engineers Pvt Ltd conducts pre-employment checks on all prospective employees. These checks are designed to verify the accuracy of information provided during the hiring process and to ensure compliance with company policies and legal requirements. These may include all or any of the following:
//                                             </p>
//                                             <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                                 <li>
//                                                     <strong>Background Verification</strong>: This will include the verification of the identity (Adhar Card, PAN Card, Passport, Driving License, etc.), educational qualifications required for the role, professional certifications and the reference provided by the candidates if any.
//                                                 </li>
//                                                 <li>
//                                                     <strong>Criminal Conviction Check</strong>: Candidate is required to provide character certificate obtained by the nearest police station where the candidate resides.
//                                                 </li>
//                                                 <li>
//                                                     <strong>Health Declaration or Health Assessment</strong>: Candidate is required to obtain basic full body checkup and candidate is required to submit the reports to at the time of joining the company.
//                                                 </li>
//                                                 <li>
//                                                     <strong>Employment History</strong>: Proof of employment history via relieving letter provided by your previous employers if any.
//                                                 </li>
//                                             </ul>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>3. Freedom to work:</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 As an employee of Genesis Tech Engineers Pvt. Ltd., you are expected to uphold the values and standards of our organization. If at any time during your employment, it is discovered that you are under any court order, contractual agreement, or other legal obligation that may interfere with or inhibit your ability to perform your duties or fulfill your obligations to the company, Genesis Tech Engineers Pvt. Ltd. reserves the right to immediately terminate your employment without further notice or liability.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>4. Term and Bond Period</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> In consideration of the opportunities provided by Genesis Tech Engineers Pvt. Ltd., the employee agrees to a binding commitment to remain in the employment of the company for a period of 2 years from the date of commencement.
//                                             </p>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 2 of 7]
//                                             </div>

//                                             {/* PAGE 3 */}
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> During this period, the employee acknowledges and agrees that they shall not voluntarily terminate their employment or engage in employment with any other entity without explicit prior consent from Genesis Tech Engineers Pvt. Ltd. Any attempt to do so shall be considered a breach of this agreement.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>c.</strong> This commitment is made with the understanding that specialized training, valuable experience, and confidential information will be provided by the company during this period. In the event of a breach, the employee shall be liable for any damage incurred by the company due to their premature departure. Failure to complete the bond duration will result in compensating the amount equal to the remaining duration of the bond period back to the employer.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>d.</strong> This clause is binding and enforceable under the applicable laws governing employment agreements.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>5. Performance of Duties</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> The Employee agrees that during the Employment Period, he/she shall devote his/her full business time to the business affairs of the Company and shall perform the duties assigned to him/her faithfully and efficiently, and shall endeavor, to the best of his/her abilities to achieve the goals and adhere to the parameters set by the Company.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> The Employee shall be responsible for:
//                                             </p>
//                                             <ul style={{ marginLeft: '2.5rem', marginBottom: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                                 <li>You must devote the whole time and attention and abilities to the business of Genesis Tech Engineers unless prevented by illness.</li>
//                                                 <li>Diligently perform such duties as may from time to time be assigned to you.</li>
//                                                 <li>Comply with all reasonable and lawful directions given to you by Genesis Tech Engineers and your managers.</li>
//                                                 <li>Act in good faith and in the best interest of Genesis Tech Engineers and its customers and staff always, including reporting your own wrongdoing and any wrongdoing of any other employee immediately on becoming aware of it.</li>
//                                                 <li>Promote, Protect, Develop, and extend the business of Genesis Tech Engineers.</li>
//                                                 <li>Take all reasonable steps in respect of the help and safety of yourself, colleagues and third party.</li>
//                                             </ul>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 A failure to maintain a professional and responsible standard of conduct / behavior, attendance and performance may result in disciplinary action taken against you under the appropriate employment guidelines.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>6. Compensation</h4>
//                                             <p style={{ marginBottom: '1rem' }}>Subject to the following provisions of this Agreement, during the Employment Period, the Employee shall be compensated for his services as follows:</p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> The Employee shall receive an annual salary, payable monthly by the Employer. Subject to such increases from time to time, as determined by the Employer. Such payments shall be subject to such normal statutory deductions by the Employer.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> During the term of this Agreement, the Employee's salary shall be paid by means of bank transfer, cheque, or any other method convenient to the Employer, and consented to by the Employee.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>c.</strong> All reasonable expenses arising out of employment shall be reimbursed assuming that the same have been authorized prior to being incurred and with the provision of appropriate receipts.
//                                             </p>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 3 of 7]
//                                             </div>

//                                             {/* PAGE 4 */}
//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>7. Obligations of the Employee</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> Upon execution of agreement, the Employee shall not engage in any sort of theft, fraud, misrepresentation, or any other illegal act neither in the employment space nor outside the premise of employment. If he/she shall do so, the Company shall not be liable for such an act done at his/her own risk.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> The Employee further promises to never engage in any theft of the Employer’s property or attempt to defraud the Employer in any manner.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>c.</strong> The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations and policies of the Company as notified from time to time.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>d.</strong> The Employee shall not take up part-time or full-time employment or consultation with any other party or be involved in any other business during the term of his/her employment with the Company.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>e.</strong> On termination employee shall immediately return to employer all documents, books, material, records, correspondence, papers and information (on whatever media and wherever located) relating to employer business or affairs or relating to employer business contacts, any keys, credit cards, access cards and any other property of employer, which is in your possession or under employee’s control.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>f.</strong> The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations and policies of the Company as notified from time to time, including but not limited to Leave Policy and Sexual Harassment Policy.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>g.</strong> The Employer hereby prohibits the Employee from engaging in any sexual harassment and the Employee promises to refrain from any form of sexual harassment during employment in and around the premise of employment. If the Employee violates this term in the agreement, he/she shall be fully responsible for his/her actions and the Employer shall not be held responsible for any illegal acts committed at the discretion of the Employee.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>8. Leave Policy</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> The employee is not entitled to any leave during the probation period with an exception to unforeseen conditions/condition out of control. Refer to the employee internal portal GTELinq for guidelines on leaves during probation period.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> The Employee is entitled to 12 days of paid sick leave (SL) in a year, 11 days of earned leave (EL). In addition, the Employee will be entitled to 10 public holidays mentioned under the Leave Policy of the Employer.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>c.</strong> The leaves earned can be carried forward to a maximum of 45 days over the service period.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>d.</strong> Other than the earned leave the Employee may not carry forward or en-cash any holiday to the next holiday year.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>e.</strong> In the event that the Employee is absent from work due to sickness or injury, he/she will follow the Leave Policy and inform the designated person as soon as possible and will provide regular updates as to his/her recovery and as far as practicable will inform the designated person of the Employer of his/her expected date of return to work.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>f.</strong> If the Employee is absent from work due to sickness or injury for more than three consecutive days, he/she must submit to the Employer a self-certification form. If such absence lasts for more than three consecutive days the Employee must obtain a medical certificate from his/her doctor and submit it to the employer.
//                                             </p>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 4 of 7]
//                                             </div>

//                                             {/* PAGE 5 */}
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>g.</strong> For any period of absence due to sickness or injury the Employee will be paid statutory sick pay only, if he/she satisfies the relevant requirements.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>9. Assignment</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> The Employee acknowledges that any work including without limitation inventions, designs, ideas, concepts, drawings, working notes, artistic works that the Employee may individually or jointly conceive or develop during the term of Employment are “works made for hire” and to the fullest extent permitted by law, Employee shall assign, and does hereby assign, to the Employer all of Employee's right, title and interest in and to all Intellectual Property improved, developed, discovered or written in such works.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>b.</strong> Employee shall, upon request of the Employer, execute, acknowledge, deliver, and file any and all documents necessary or useful to vest in the Employer all of Employee's right, title and interest in and to all such matters.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>10. Confidentiality</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> The Employee acknowledges that, while performing and fulfilling his/her duties here under, he/she may have access to and be entrusted with confidential information concerning the present and contemplated financial status and activities of the Employer, the disclosure of any of which confidential information to the competitors of the Employer would be highly detrimental to the interests of the Employer.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> The Employee further acknowledges and agrees that the right to maintain the confidentiality of trade secrets, source code, website information, business plans or client information or other confidential or proprietary information, for the purpose of enabling the other party such information constitutes a proprietary right which the Employer is entitled to protect.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>c.</strong> Accordingly, the Employee covenants and agrees with the Employer that he/she will not, under any circumstance during the continuance of this agreement, disclose any such confidential information to any person, firm or corporation, nor shall he/she use the same, except as required in the normal course of his/her engagement hereunder, and even after the termination of employment, he/she shall not disclose or make use of the same or cause any of confidential information to be disclosed in any manner.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>d.</strong> The Employer owns any intellectual property created by the Employee during employment, or in relation to a certain field, and he/she shall thereon have all the necessary rights to retain it. After termination of employment, Employee shall not impose any rights on the intellectual property created. Any source code, software or other intellectual property developed, including but not limited to website design or functionality that was created by the employee, during employment under this Agreement, shall belong to the Employer.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>11. Amendment and Termination</h4>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>a.</strong> Employer may terminate your employment without any notice.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
//                                                 <strong>b.</strong> The Employee may terminate his/her employment by providing the Employer with at least 2-month(s) advance notice of his/her intention to resign.
//                                             </p>
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>c.</strong> The Employee may terminate on the last day of the month in which the date of the Employee’s death occurs; or the date on which the Company gives notice to the Employee if such termination is for Cause or Disability.
//                                             </p>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 5 of 7]
//                                             </div>

//                                             {/* PAGE 6 */}
//                                             <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
//                                                 <strong>d.</strong> For purposes of this Agreement, "Cause" means the Employee's gross misconduct resulting in material damage to the Company, willful insubordination or disobedience, theft, fraud or dishonesty, willful damage or loss of Employer’s property, bribery and habitual lateness or absence, or any other willful and material breach of this Agreement.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>12. Restrictive Covenant</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 Following the termination of employment of the Employee by the Employer, with or without cause, or the voluntary withdrawal by the Employee from the Employer, the Employee shall, for a period of three years following the said termination or voluntary withdrawal, refrain from either directly or indirectly soliciting or attempting to solicit the business of any client or customer of the Employer for his own benefit or that of any third person or organization, and shall refrain from either directly or indirectly attempting to obtain the withdrawal from the employment by the Employer of any other Employee of the Employer having regard to the same geographic and temporal restrictions. The Employee shall not directly or indirectly divulge any financial information relating to the Employer or any of its affiliates or clients to any person whatsoever.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>13. Indemnification</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 The Employee shall indemnify the employer against any and all expenses, including amounts paid upon judgments, counsel fees, environmental penalties and fines, and amounts paid in settlement (before or after suit is commenced), incurred by the employer in connection with his/her defense or settlement of any claim, action, suit or proceeding in which he/she is made a party or which may be asserted against his/her by reason of his/her employment or the performance of duties in this Agreement. Such indemnification shall be in addition to any other rights to which those indemnified may be entitled under any law, by-law, agreement, or otherwise.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>14. Modification</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 Any modification of this Agreement or additional obligation assumed by either party in connection with this Agreement shall be binding only if evidenced in writing signed by each party or an authorized representative of each party.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>15. Severability</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 Each paragraph of this agreement shall be and remain separate from and independent of and severable from all and any other paragraphs herein except where otherwise indicated by the context of the agreement. The decision or declaration that one or more of the paragraphs are null and void shall have no effect on the remaining paragraphs of this agreement.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>16. Paragraph headings</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 The titles to the paragraphs of this Agreement are solely for the convenience of the parties and shall not be used to explain, modify, simplify, or aid in the interpretation of the provisions of this Agreement.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>17. Applicable Law and Jurisdiction</h4>
//                                             <p style={{ marginBottom: '1rem' }}>
//                                                 This Agreement shall be governed by and construed in accordance with the laws of India. Each party hereby irrevocably submits to the exclusive jurisdiction of the courts of Pune. For the adjudication of any dispute hereunder or in connection herewith.
//                                             </p>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 6 of 7]
//                                             </div>

//                                             {/* PAGE 7 */}
//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>18. Counterparts</h4>
//                                             <p style={{ marginBottom: '1.5rem' }}>
//                                                 The Agreement may be executed in two or more counterparts, any one of which shall be deemed the original without reference to the others.
//                                             </p>

//                                             <p style={{ marginBottom: '1.5rem' }}>
//                                                 <strong>IN WITNESS WHEREOF</strong>, the Employee has hereunto set his hand, and the Company has caused these presents to be executed in its name and on its behalf, all as of the day and year first above written.
//                                             </p>

//                                             <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>Acceptance</h4>
//                                             <p style={{ marginBottom: '2rem' }}>
//                                                 I have carefully read and accepted all the provisions of this Employment agreement terms and conditions of employment.
//                                             </p>

//                                             <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', borderTop: '1px dashed #cbd5e1', paddingTop: '1.5rem' }}>
//                                                 <p><strong>Employee Sign:</strong> ___________________________</p>
//                                                 <p><strong>Employee Name:</strong> {employee.FirstName} {employee.LastName}</p>
//                                                 <p><strong>Date:</strong> {formatJoiningDateShort(employee?.joining_date || employee?.JoiningDate || employee?.joining_Date || employee?.joiningDate || employee?.joining || employee?.hire_date || employee?.HireDate || employmentForm?.hireDate)}</p>
//                                             </div>

//                                             <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                                 <p><strong>For: Genesis Tech Engineers Pvt. Ltd.</strong></p>
//                                                 <div style={{ fontSize: '1rem', fontStyle: 'italic', color: 'var(--primary)', margin: '0.25rem 0' }}>Neeta</div>
//                                                 <p><strong>Name:</strong> NEETA SHRIKANT SANGVIKAR</p>
//                                                 <p><strong>Designation:</strong> DIRECTOR HR</p>
//                                                 <p><strong>Date:</strong> {formatJoiningDateShort(employee?.joining_date || employee?.JoiningDate || employee?.joining_Date || employee?.joiningDate || employee?.joining || employee?.hire_date || employee?.HireDate || employmentForm?.hireDate)}</p>
//                                             </div>

//                                             <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0 0 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
//                                                 [Page 7 of 7]
//                                             </div>

//                                         </div>
//                                     ))}
//                             </div>
//                         </div>
//                     </div>
//                 );
//             })()}

//             {/* COMPANY POLICIES TAB */}
//             {activeTab === 'policies' && (() => {
//                 const allPoliciesAccepted = genesisPolicies.every(policy => data?.policies?.some(p => p.policy_name === policy.title));
//                 const activePolicy = genesisPolicies.find(p => p.id === selectedPolicyId);

//                 // Handle selecting a policy
//                 const handleSelect = (id) => {
//                     setSelectedPolicyId(id);
//                     if (id !== 'sign' && !viewedPolicyIds.includes(id)) {
//                         setViewedPolicyIds(prev => [...prev, id]);
//                     }
//                 };

//                 const sidebarItems = [
//                     ...genesisPolicies,
//                     { id: 'sign', title: 'Acceptance & Sign-off', icon: '✍️' }
//                 ];

//                 return (
//                     <div className="card fade-in">
//                         <div className="card-title" style={{ marginBottom: '1.5rem' }}>Company Policies Review</div>

//                         <div className="policies-layout">
//                             {/* Left Column: Sidebar List */}
//                             <div className="policies-sidebar">
//                                 {sidebarItems.map((item) => {
//                                     const isSelected = selectedPolicyId === item.id;
//                                     const isSignTab = item.id === 'sign';
//                                     const isChecked = isSignTab
//                                         ? allPoliciesAccepted
//                                         : (viewedPolicyIds.includes(item.id) || allPoliciesAccepted);

//                                     return (
//                                         <div
//                                             key={item.id}
//                                             onClick={() => handleSelect(item.id)}
//                                             style={{
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'space-between',
//                                                 padding: '0.85rem 1rem',
//                                                 borderRadius: '8px',
//                                                 border: '1px solid var(--border-color)',
//                                                 backgroundColor: isSelected ? '#0f172a' : 'var(--bg-secondary)',
//                                                 color: isSelected ? '#ffffff' : 'var(--text-primary)',
//                                                 cursor: 'pointer',
//                                                 transition: 'all 0.2s ease',
//                                                 boxShadow: isSelected ? 'var(--shadow-sm)' : 'none'
//                                             }}
//                                             className={isSelected ? '' : 'policy-sidebar-item-hover'}
//                                         >
//                                             <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
//                                                 <span style={{ fontSize: '1.2rem' }}>{item.icon}</span>
//                                                 <span style={{ fontSize: '0.85rem', fontWeight: isSelected ? '600' : '500' }}>{item.title}</span>
//                                             </div>

//                                             {/* Checkbox badge */}
//                                             <span style={{
//                                                 display: 'inline-flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                                 width: '18px',
//                                                 height: '18px',
//                                                 borderRadius: '4px',
//                                                 backgroundColor: isChecked ? '#10b981' : '#e2e8f0',
//                                                 color: '#ffffff',
//                                                 fontSize: '10px',
//                                                 fontWeight: 'bold',
//                                                 transition: 'background-color 0.2s'
//                                             }}>
//                                                 {isChecked ? '✓' : ''}
//                                             </span>
//                                         </div>
//                                     );
//                                 })}
//                             </div>

//                             {/* Right Column: Description Panel */}
//                             <div className="policies-content">
//                                 {selectedPolicyId === 'sign' ? (
//                                     <div>
//                                         <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.5rem', color: 'var(--text-primary)' }}>Acceptance & Sign-off</h3>
//                                         <div style={{ borderBottom: '1px solid var(--border-color)', marginBottom: '1.5rem' }}></div>

//                                         <p style={{ fontSize: '0.9rem', color: 'var(--text-primary)', marginBottom: '1rem', lineHeight: '1.5' }}>
//                                             By drawing or typing your signature below, you certify and confirm that you have read, understood, and agree to abide by all 11 company policies listed on the left:
//                                         </p>

//                                         <ul style={{ paddingLeft: '1.5rem', fontSize: '0.85rem', color: 'var(--text-secondary)', lineHeight: '1.6', marginBottom: '2rem' }}>
//                                             {genesisPolicies.map(p => (
//                                                 <li key={p.id}>{p.title}</li>
//                                             ))}
//                                         </ul>

//                                         {allPoliciesAccepted ? (
//                                             <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                                                 <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1.25rem', borderRadius: 'var(--border-radius-sm)', fontSize: '0.85rem' }}>
//                                                     🚀 <strong>Policies Signed & Accepted</strong>: You have read and accepted all company policies. A signed PDF copy has been saved.
//                                                 </div>
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-primary"
//                                                     style={{ width: '100%', padding: '0.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                                                     onClick={handleDownloadPolicies}
//                                                 >
//                                                     📥 Download Signed Policies
//                                                 </button>
//                                             </div>
//                                         ) : (
//                                             !isLocked && (
//                                                 <div>
//                                                     {viewedPolicyIds.length < genesisPolicies.length ? (
//                                                         <div style={{ backgroundColor: 'var(--bg-tertiary)', borderLeft: '4px solid var(--warning)', padding: '1rem', borderRadius: '4px', fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
//                                                             ⚠️ <strong>Please read all policies</strong>: You must click and review all 11 policies on the left before you can sign. (Currently reviewed: {viewedPolicyIds.length}/11)
//                                                         </div>
//                                                     ) : (
//                                                         <div>
//                                                             <div style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginBottom: '0.75rem' }}>
//                                                                 Please draw or type your electronic signature below:
//                                                             </div>
//                                                             <SignaturePad onSave={handlePolicyAccept} />
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             )
//                                         )}
//                                     </div>
//                                 ) : (
//                                     activePolicy && (
//                                         <div>
//                                             <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.5rem', color: 'var(--text-primary)' }}>{activePolicy.title}</h3>
//                                             <div style={{ borderBottom: '1px solid var(--border-color)', marginBottom: '1.5rem' }}></div>
//                                             <div style={{ color: 'var(--text-primary)', fontSize: '0.9rem', lineHeight: '1.6' }}>
//                                                 {activePolicy.content}
//                                             </div>
//                                         </div>
//                                     )
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 );
//             })()}

//             {/* TAX INFORMATION TAB */}
//             {activeTab === 'tax' && (
//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '1.5rem', alignItems: 'start' }} className="fade-in">
//                     {/* LEFT SIDE: INPUTS & ACTIONS */}
//                     <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
//                         <div className="card-title">Arizona A-4 Tax Withholdings</div>

//                         <form onSubmit={(e) => e.preventDefault()} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//                             <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 0: Federal & General State Elections</h4>
//                             <div className="grid-2">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="fedTaxSelect">Federal Tax Filing Status</label>
//                                     <select id="fedTaxSelect" className="form-control" value={taxForm.federal_tax_status} onChange={(e) => setTaxForm({ ...taxForm, federal_tax_status: e.target.value })} disabled={isLocked}>
//                                         <option value="SINGLE">Single or Married Filing Separately</option>
//                                         <option value="MARRIED">Married Filing Jointly</option>
//                                         <option value="HEAD_OF_HOUSEHOLD">Head of Household</option>
//                                     </select>
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="fedAllowancesInput">Federal Allowances / Dependents</label>
//                                     <input type="number" id="fedAllowancesInput" className="form-control" value={taxForm.federal_allowances} onChange={(e) => setTaxForm({ ...taxForm, federal_allowances: parseInt(e.target.value) || 0 })} min={0} disabled={isLocked} />
//                                 </div>
//                             </div>

//                             <div className="grid-2">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="stateTaxSelect">State Filing Status (General)</label>
//                                     <select id="stateTaxSelect" className="form-control" value={taxForm.state_tax_status} onChange={(e) => setTaxForm({ ...taxForm, state_tax_status: e.target.value })} disabled={isLocked}>
//                                         <option value="SINGLE">Single</option>
//                                         <option value="MARRIED">Married</option>
//                                         <option value="EXEMPT">Exempt</option>
//                                     </select>
//                                 </div>
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="stateAllowancesInput">State Allowances (General)</label>
//                                     <input type="number" id="stateAllowancesInput" className="form-control" value={taxForm.state_allowances} onChange={(e) => setTaxForm({ ...taxForm, state_allowances: parseInt(e.target.value) || 0 })} min={0} disabled={isLocked} />
//                                 </div>
//                             </div>

//                             <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

//                             <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 1: Arizona Form A-4 Personal Information</h4>

//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="taxName">Full Name</label>
//                                 <input
//                                     type="text"
//                                     id="taxName"
//                                     className="form-control"
//                                     value={taxForm.name}
//                                     onChange={(e) => setTaxForm({ ...taxForm, name: e.target.value })}
//                                     disabled={isLocked}
//                                 />
//                             </div>

//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="taxSSN">Social Security Number</label>
//                                 <input
//                                     type="text"
//                                     id="taxSSN"
//                                     className="form-control"
//                                     value={taxForm.ssn}
//                                     onChange={(e) => setTaxForm({ ...taxForm, ssn: e.target.value })}
//                                     disabled={isLocked}
//                                 />
//                             </div>

//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="taxAddress">Home Address</label>
//                                 <input
//                                     type="text"
//                                     id="taxAddress"
//                                     className="form-control"
//                                     value={taxForm.address}
//                                     onChange={(e) => setTaxForm({ ...taxForm, address: e.target.value })}
//                                     disabled={isLocked}
//                                 />
//                             </div>

//                             <div className="grid-2">
//                                 <div className="form-group">
//                                     <label className="form-label" htmlFor="taxCity">City or Town</label>
//                                     <input
//                                         type="text"
//                                         id="taxCity"
//                                         className="form-control"
//                                         value={taxForm.city}
//                                         onChange={(e) => setTaxForm({ ...taxForm, city: e.target.value })}
//                                         disabled={isLocked}
//                                     />
//                                 </div>
//                                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '0.5rem' }}>
//                                     <div className="form-group">
//                                         <label className="form-label" htmlFor="taxState">State</label>
//                                         <input
//                                             type="text"
//                                             id="taxState"
//                                             className="form-control"
//                                             value={taxForm.state}
//                                             onChange={(e) => setTaxForm({ ...taxForm, state: e.target.value })}
//                                             maxLength={2}
//                                             disabled={isLocked}
//                                         />
//                                     </div>
//                                     <div className="form-group">
//                                         <label className="form-label" htmlFor="taxZip">ZIP Code</label>
//                                         <input
//                                             type="text"
//                                             id="taxZip"
//                                             className="form-control"
//                                             value={taxForm.zip}
//                                             onChange={(e) => setTaxForm({ ...taxForm, zip: e.target.value })}
//                                             disabled={isLocked}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

//                             <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 2: Withholding Election</h4>

//                             <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                 <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem', cursor: 'pointer' }} onClick={() => !isLocked && setTaxForm({ ...taxForm, arizona_box_selection: 1 })}>
//                                     <input
//                                         type="radio"
//                                         id="box1"
//                                         name="arizona_box_selection"
//                                         checked={taxForm.arizona_box_selection === 1}
//                                         onChange={() => { }}
//                                         disabled={isLocked}
//                                         style={{ marginTop: '0.25rem' }}
//                                     />
//                                     <label htmlFor="box1" style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer' }}>
//                                         <strong>Box 1</strong>: Withhold from gross taxable wages at the percentage checked below (check only one percentage):
//                                     </label>
//                                 </div>

//                                 {taxForm.arizona_box_selection === 1 && (
//                                     <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem', paddingLeft: '1.5rem', marginTop: '0.25rem' }}>
//                                         {[0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5].map((pct) => (
//                                             <label key={pct} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.8rem', cursor: 'pointer' }}>
//                                                 <input
//                                                     type="radio"
//                                                     name="arizona_percentage"
//                                                     checked={taxForm.arizona_percentage === pct}
//                                                     onChange={() => !isLocked && setTaxForm({ ...taxForm, arizona_percentage: pct })}
//                                                     disabled={isLocked}
//                                                 />
//                                                 {pct}%
//                                             </label>
//                                         ))}
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                 <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem', cursor: 'pointer' }} onClick={() => !isLocked && setTaxForm({ ...taxForm, arizona_box_selection: 2 })}>
//                                     <input
//                                         type="radio"
//                                         id="box2"
//                                         name="arizona_box_selection"
//                                         checked={taxForm.arizona_box_selection === 2}
//                                         onChange={() => { }}
//                                         disabled={isLocked}
//                                         style={{ marginTop: '0.25rem' }}
//                                     />
//                                     <label htmlFor="box2" style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer' }}>
//                                         <strong>Box 2</strong>: I elect an Arizona withholding percentage of zero, and I certify that I expect to have no Arizona tax liability for the current taxable year.
//                                     </label>
//                                 </div>
//                             </div>

//                             <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

//                             <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 3: Additional Withholding</h4>

//                             <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                 <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem', cursor: 'pointer' }} onClick={() => !isLocked && setTaxForm({ ...taxForm, arizona_extra_amount_checked: !taxForm.arizona_extra_amount_checked })}>
//                                     <input
//                                         type="checkbox"
//                                         id="chkExtraWH"
//                                         checked={taxForm.arizona_extra_amount_checked}
//                                         onChange={() => { }}
//                                         disabled={isLocked}
//                                         style={{ marginTop: '0.25rem' }}
//                                     />
//                                     <label htmlFor="chkExtraWH" style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer' }}>
//                                         Check this box and enter an extra amount to be withheld from each paycheck
//                                     </label>
//                                 </div>

//                                 {taxForm.arizona_extra_amount_checked && (
//                                     <div className="form-group" style={{ paddingLeft: '1.5rem', marginTop: '0.25rem' }}>
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                                             <span style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>$</span>
//                                             <input
//                                                 type="number"
//                                                 className="form-control"
//                                                 placeholder="0.00"
//                                                 value={taxForm.arizona_extra_amount}
//                                                 onChange={(e) => setTaxForm({ ...taxForm, arizona_extra_amount: e.target.value })}
//                                                 min={0}
//                                                 step="0.01"
//                                                 disabled={isLocked}
//                                             />
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </form>

//                         <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

//                         {/* Signature Area */}
//                         {data?.tax?.signed_at ? (
//                             <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1rem', borderRadius: '4px', fontSize: '0.85rem' }}>
//                                 ✓ <strong>Arizona Form A-4 Electronically Signed</strong>: Signed on {new Date(data.tax.signed_at).toLocaleString()} from IP {data.tax.ip_address}.
//                             </div>
//                         ) : (
//                             !isLocked && (
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//                                     <SignaturePad onSave={handleApplySignature} onChange={handleApplySignature} />
//                                 </div>
//                             )
//                         )}

//                         {/* Actions Panel */}
//                         <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
//                             {pdfPreviewUrl && (
//                                 <button
//                                     type="button"
//                                     className="btn btn-secondary"
//                                     onClick={downloadPdf}
//                                     style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                                 >
//                                     📥 Download Form
//                                 </button>
//                             )}
//                             {!isLocked && !data?.tax?.signed_at && (
//                                 <button
//                                     type="button"
//                                     className="btn btn-primary"
//                                     onClick={handleSaveTaxSubmit}
//                                     style={{ flex: 1 }}
//                                     disabled={!taxForm.signature}
//                                 >
//                                     ✍️ Save & Sign
//                                 </button>
//                             )}
//                         </div>
//                     </div>

//                     {/* RIGHT SIDE: PDF PREVIEW */}
//                     <div className="card" style={{ height: 'calc(100vh - 180px)', minHeight: '600px', display: 'flex', flexDirection: 'column', padding: '0.75rem' }}>
//                         <div className="card-title" style={{ padding: '0.5rem 0.5rem 1rem 0.5rem', margin: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                             <span>Live Form Preview</span>
//                             <span style={{ fontSize: '0.75rem', fontWeight: 'normal', color: 'var(--text-tertiary)' }}>Updates automatically as you type</span>
//                         </div>

//                         <div style={{ flex: 1, backgroundColor: 'var(--bg-tertiary)', borderRadius: 'var(--border-radius-sm)', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
//                             {pdfPreviewUrl ? (
//                                 <iframe
//                                     src={`${pdfPreviewUrl}#toolbar=0&navpanes=0`}
//                                     title="Arizona A-4 Preview"
//                                     width="100%"
//                                     height="100%"
//                                     style={{ border: 'none', display: 'block' }}
//                                 />
//                             ) : (
//                                 <div style={{ textAlign: 'center', padding: '2rem' }}>
//                                     <Loader message="Loading Arizona A-4 Form template..." size="md" />
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* BANK DETAILS TAB */}
//             {activeTab === 'bank' && (
//                 <div className="card fade-in">
//                     <div className="card-title">Direct Deposit Bank Details</div>

//                     {/* Top Information Fields */}
//                     <div style={{ marginBottom: '1.5rem' }}>
//                         <div className="grid-2">
//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="bankNameSelect">Bank Name</label>
//                                 <input type="text" id="bankNameSelect" className="form-control" value={bankForm.bank_name} onChange={(e) => setBankForm({ ...bankForm, bank_name: e.target.value })} required disabled={isLocked} />
//                             </div>
//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="routingNumberInput">Routing Number / IFSC Code</label>
//                                 <input type="text" id="routingNumberInput" className="form-control" maxLength={20} value={bankForm.routing_number} onChange={(e) => setBankForm({ ...bankForm, routing_number: e.target.value })} required disabled={isLocked} />
//                             </div>
//                         </div>
//                         <div className="grid-2">
//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="accountNumberInput">Account Number</label>
//                                 <input type="text" id="accountNumberInput" className="form-control" value={bankForm.account_number} onChange={(e) => setBankForm({ ...bankForm, account_number: e.target.value })} required disabled={isLocked} />
//                             </div>
//                             <div className="form-group">
//                                 <label className="form-label" htmlFor="accountTypeSelect">Account Type</label>
//                                 <select
//                                     id="accountTypeSelect"
//                                     className="form-control"
//                                     value={((employee?.country || data?.employee?.country || personalForm?.country || '').toUpperCase()) === 'INDIA' && bankForm.account_type === 'CHECKING' ? 'SAVINGS' : bankForm.account_type}
//                                     onChange={(e) => setBankForm({ ...bankForm, account_type: e.target.value })}
//                                     disabled={isLocked}
//                                 >
//                                     {((employee?.country || data?.employee?.country || personalForm?.country || '').toUpperCase()) === 'INDIA' ? (
//                                         <>
//                                             <option value="SAVINGS">Savings</option>
//                                             <option value="CURRENT">Current</option>
//                                         </>
//                                     ) : (
//                                         <>
//                                             <option value="CHECKING">Checking</option>
//                                             <option value="SAVINGS">Savings</option>
//                                         </>
//                                     )}
//                                 </select>
//                             </div>
//                         </div>
//                         <div className="form-group">
//                             <label className="form-label" htmlFor="bankBranchAddressInput">Bank Branch Address</label>
//                             <input type="text" id="bankBranchAddressInput" className="form-control" value={bankForm.bank_branch_address} onChange={(e) => setBankForm({ ...bankForm, bank_branch_address: e.target.value })} required disabled={isLocked} />
//                         </div>
//                     </div>

//                     {/* Upload Cancelled Cheque / Bank Proof Section */}
//                     <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1.5rem', marginBottom: '1.5rem' }}>
//                         <h4 style={{ fontSize: '0.9rem', marginBottom: '0.25rem', fontWeight: 'bold', color: 'var(--text-primary)' }}>
//                             Upload Cancelled Cheque / Bank Account Proof <span style={{ color: 'var(--danger)', marginLeft: '4px' }}>*</span>
//                         </h4>
//                         <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '0.75rem' }}>
//                             Attach one of the following: Last month Statement, voided check with A/C number stated
//                         </p>
//                         <UploadField documentType="Void Cheque" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
//                     </div>

//                     {/* Single Save Details Button at the Bottom */}
//                     {!isLocked && (
//                         <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1.25rem' }}>
//                             <button type="button" onClick={handleSaveBank} className="btn btn-primary" style={{ padding: '0.65rem 1.5rem', fontWeight: 600 }}>
//                                 Save Bank Details
//                             </button>
//                         </div>
//                     )}
//                 </div>
//             )}

//             {/* PROFILE PHOTO TAB */}
//             {activeTab === 'photo' && (
//                 <div className="card fade-in">
//                     <div className="card-title">Badge Profile Photo</div>
//                     <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
//                         Upload a high-quality professional Photo.
//                     </p>

//                     <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap', position: 'relative' }}>
//                         <div
//                             style={{
//                                 width: '150px',
//                                 height: '150px',
//                                 borderRadius: '50%',
//                                 border: '3px solid var(--border-color)',
//                                 background: badgePhotoPath ? `url(/EOP_api/${badgePhotoPath}) center/cover no-repeat` : 'var(--bg-tertiary)',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 color: 'var(--text-tertiary)',
//                                 fontSize: '0.85rem',
//                                 position: 'relative',
//                                 overflow: 'hidden'
//                             }}
//                         >
//                             {!badgePhotoPath && 'No Picture'}
//                         </div>

//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', flex: '1 1 300px' }}>
//                             {badgePhotoPath ? (
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//                                     <p style={{ fontSize: '0.825rem', color: 'var(--text-secondary)', margin: 0 }}>
//                                         Profile photo is uploaded. To upload a different photo, please delete the current photo first.
//                                     </p>
//                                     <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
//                                         <a
//                                             href={`/EOP_api/${badgePhotoPath}`}
//                                             target="_blank"
//                                             rel="noreferrer"
//                                             className="btn btn-secondary"
//                                             style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', fontWeight: 600 }}
//                                         >
//                                             👁️ View Photo
//                                         </a>
//                                         {!isLocked && (
//                                             <button
//                                                 type="button"
//                                                 className="btn btn-danger"
//                                                 style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', fontWeight: 600 }}
//                                                 onClick={handleDeletePhoto}
//                                                 disabled={uploadingPhoto}
//                                             >
//                                                 🗑️ Delete Photo
//                                             </button>
//                                         )}
//                                     </div>
//                                 </div>
//                             ) : (
//                                 !isLocked && (
//                                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                                         <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-primary)' }}>
//                                             Upload Profile Photo:
//                                         </label>
//                                         <input type="file" className="form-control" accept="image/*" onChange={handlePhotoUpload} disabled={uploadingPhoto} />
//                                         <p style={{ color: 'var(--text-tertiary)', fontSize: '0.7rem', margin: 0 }}>JPG, PNG, WEBP (Max 1MB limit)</p>
//                                     </div>
//                                 )
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* REVIEW & SUBMIT TAB */}
//             {activeTab === 'submit' && (
//                 <div className="card fade-in">
//                     <div className="card-title">Review & Submit Onboarding Profile</div>
//                     <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
//                         Before submitting, verify that all sections are complete. Submitting locks your profile and moves it to **Pending HR Review** status.
//                     </p>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '2rem' }}>
//                         {effectiveDashboardStats?.checklist && Object.entries(effectiveDashboardStats.checklist).map(([key, complete]) => {
//                             const label = key.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase());
//                             return (
//                                 <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.5rem 1rem', border: '1px solid var(--border-color)', borderRadius: '4px' }}>
//                                     <span>{label}</span>
//                                     <strong style={{ color: complete ? 'var(--success)' : 'var(--danger)' }}>
//                                         {complete ? '✓ Ready' : '✗ Required'}
//                                     </strong>
//                                 </div>
//                             );
//                         })}
//                     </div>

//                     {(() => {
//                         const reqDocsList = data?.requested_documents || data?.requested_employee_documents || [];
//                         const pendingOrUploadedReqs = reqDocsList.filter(r => {
//                             const s = (r.status || '').toUpperCase();
//                             return s !== 'SUBMITTED' && s !== 'COMPLETED' && s !== 'APPROVED';
//                         });

//                         if (isLocked && (pendingOrUploadedReqs.length === 0 || requestedDocsSubmitted)) {
//                             return (
//                                 <div style={{ textAlign: 'center', padding: '1.5rem', backgroundColor: 'var(--bg-tertiary)', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)' }}>
//                                     <span style={{ fontSize: '2rem' }}>🔒</span>
//                                     <h4 style={{ margin: '0.5rem 0' }}>Profile Locked</h4>
//                                     <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>This profile and all requested documents have been submitted to HR.</p>
//                                 </div>
//                             );
//                         }

//                         return (
//                             <button
//                                 type="button"
//                                 className="btn btn-primary"
//                                 style={{ width: '100%', padding: '0.875rem', fontSize: '1rem', display: 'flex', justifyContent: 'center' }}
//                                 onClick={() => setShowSubmitConfirm(true)}
//                                 disabled={effectiveDashboardStats?.completed_steps < effectiveDashboardStats?.total_steps}
//                             >
//                                 {isLocked ? 'Submit Updated Requested Documents' : 'Submit Onboarding Profile'}
//                             </button>
//                         );
//                     })()}
//                 </div>
//             )}

//             {showSubmitConfirm && createPortal(
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     width: '100vw',
//                     height: '100vh',
//                     backgroundColor: 'rgba(15, 23, 42, 0.4)',
//                     backdropFilter: 'blur(8px)',
//                     WebkitBackdropFilter: 'blur(8px)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     zIndex: 9999,
//                     animation: 'fadeIn var(--transition-fast) forwards'
//                 }}>
//                     <div className="glass-card" style={{
//                         width: '460px',
//                         maxWidth: '90%',
//                         padding: '2.5rem 2rem',
//                         borderRadius: 'var(--border-radius-lg)',
//                         boxShadow: 'var(--shadow-lg)',
//                         backgroundColor: 'var(--bg-secondary)',
//                         textAlign: 'center',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center'
//                     }}>
//                         <div style={{
//                             width: '64px',
//                             height: '64px',
//                             borderRadius: '50%',
//                             backgroundColor: 'var(--primary-light)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             fontSize: '2rem',
//                             marginBottom: '1.25rem',
//                             color: 'var(--primary)'
//                         }}>
//                             🚀
//                         </div>
//                         <h3 style={{
//                             fontSize: '1.5rem',
//                             fontWeight: '700',
//                             marginBottom: '0.75rem',
//                             fontFamily: 'var(--font-heading)',
//                             color: 'var(--text-primary)'
//                         }}>
//                             Submit Onboarding Profile?
//                         </h3>
//                         <p style={{
//                             color: 'var(--text-secondary)',
//                             fontSize: '0.9rem',
//                             marginBottom: '2rem',
//                             lineHeight: '1.6'
//                         }}>
//                             Are you sure you want to submit your onboarding profile? This will lock all details for HR review and finalize your submission.
//                         </p>
//                         <div style={{ display: 'flex', gap: '1rem', width: '100%' }}>
//                             <button
//                                 type="button"
//                                 className="btn btn-secondary"
//                                 style={{ flex: 1, padding: '0.75rem 1.25rem', fontSize: '0.9rem' }}
//                                 onClick={() => setShowSubmitConfirm(false)}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 type="button"
//                                 className="btn btn-primary"
//                                 style={{ flex: 1, padding: '0.75rem 1.25rem', fontSize: '0.9rem' }}
//                                 onClick={() => {
//                                     setShowSubmitConfirm(false);
//                                     handleSubmitOnboarding();
//                                 }}
//                             >
//                                 Yes, Submit
//                             </button>
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             {submitStatus !== 'idle' && createPortal(
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     width: '100vw',
//                     height: '100vh',
//                     backgroundColor: 'rgba(15, 23, 42, 0.4)',
//                     backdropFilter: 'blur(8px)',
//                     WebkitBackdropFilter: 'blur(8px)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     zIndex: 9999,
//                     animation: 'fadeIn var(--transition-fast) forwards'
//                 }}>
//                     <div className="glass-card" style={{
//                         width: '460px',
//                         maxWidth: '90%',
//                         padding: '2.5rem 2rem',
//                         borderRadius: 'var(--border-radius-lg)',
//                         boxShadow: 'var(--shadow-lg)',
//                         backgroundColor: 'var(--bg-secondary)',
//                         textAlign: 'center',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center'
//                     }}>
//                         {submitStatus === 'submitting' && (
//                             <>
//                                 <div className="submit-spinner" />
//                                 <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.5rem', color: 'var(--text-primary)', fontFamily: 'var(--font-heading)' }}>
//                                     Submitting Onboarding
//                                 </h3>
//                                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: '0 0 1rem 0' }}>
//                                     Locking your profile and submitting documents to HR...
//                                 </p>
//                                 <div className="submit-loader-progress" style={{ width: '100%' }}>
//                                     <div className="submit-loader-progress-bar" />
//                                 </div>
//                             </>
//                         )}

//                         {submitStatus === 'success' && (
//                             <>
//                                 <div className="submit-success-icon">✓</div>
//                                 <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.75rem', color: 'var(--success)', fontFamily: 'var(--font-heading)' }}>
//                                     Successfully Submitted!
//                                 </h3>
//                                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '2rem', lineHeight: '1.6' }}>
//                                     Your onboarding documents and details have been successfully submitted and locked for HR review.
//                                 </p>
//                                 <button
//                                     type="button"
//                                     className="btn btn-primary"
//                                     style={{ width: '100%', padding: '0.75rem 1.25rem', fontSize: '0.9rem' }}
//                                     onClick={() => {
//                                         setSubmitStatus('idle');
//                                         setActiveTab('dashboard');
//                                     }}
//                                 >
//                                     Go to Dashboard
//                                 </button>
//                             </>
//                         )}

//                         {submitStatus === 'error' && (
//                             <>
//                                 <div className="submit-error-icon">✗</div>
//                                 <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.75rem', color: 'var(--danger)', fontFamily: 'var(--font-heading)' }}>
//                                     Submission Failed
//                                 </h3>
//                                 <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '2rem', lineHeight: '1.6' }}>
//                                     {submitErrorMessage || 'An unexpected error occurred during submission. Please try again.'}
//                                 </p>
//                                 <button
//                                     type="button"
//                                     className="btn btn-primary"
//                                     style={{ width: '100%', padding: '0.75rem 1.25rem', fontSize: '0.9rem', backgroundColor: 'var(--danger)', borderColor: 'var(--danger)' }}
//                                     onClick={() => setSubmitStatus('idle')}
//                                 >
//                                     Dismiss & Retry
//                                 </button>
//                             </>
//                         )}
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             {/* POPUP MODAL FOR HR-REQUESTED DOCUMENTS */}
//             {showRequestedDocsModal && (() => {
//                 const reqList = data?.requested_documents || data?.requested_employee_documents || [];
//                 const pendingList = reqList.filter(req => {
//                     const rStatus = (req.status || '').toUpperCase();
//                     const rName = (req.document_name || req.document_type || req.title || req.name || '').trim();
//                     const isUploadedInEmpDocs = data?.documents?.some(d => d.document_type === rName);
//                     return rStatus !== 'UPLOADED' && !isUploadedInEmpDocs;
//                 });

//                 if (pendingList.length === 0) return null;

//                 return createPortal(
//                     <div style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: 0,
//                         width: '100vw',
//                         height: '100vh',
//                         backgroundColor: 'rgba(15, 23, 42, 0.55)',
//                         backdropFilter: 'blur(8px)',
//                         WebkitBackdropFilter: 'blur(8px)',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         zIndex: 99999,
//                         animation: 'fadeIn var(--transition-fast) forwards'
//                     }}>
//                         <div className="glass-card" style={{
//                             width: '520px',
//                             maxWidth: '92%',
//                             padding: '2.5rem 2rem',
//                             borderRadius: 'var(--border-radius-lg)',
//                             boxShadow: 'var(--shadow-lg)',
//                             backgroundColor: 'var(--bg-secondary)',
//                             textAlign: 'center',
//                             display: 'flex',
//                             flexDirection: 'column',
//                             alignItems: 'center'
//                         }}>
//                             <div style={{
//                                 width: '64px',
//                                 height: '64px',
//                                 borderRadius: '50%',
//                                 backgroundColor: 'rgba(59, 130, 246, 0.12)',
//                                 border: '2px solid rgba(59, 130, 246, 0.3)',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 fontSize: '2rem',
//                                 marginBottom: '1.25rem',
//                                 color: 'var(--primary)'
//                             }}>
//                                 📋
//                             </div>

//                             <h3 style={{
//                                 fontSize: '1.4rem',
//                                 fontWeight: '700',
//                                 marginBottom: '0.5rem',
//                                 color: 'var(--text-primary)',
//                                 fontFamily: 'var(--font-heading)'
//                             }}>
//                                 Action Required: Additional Documents Requested
//                             </h3>

//                             <p style={{
//                                 color: 'var(--text-secondary)',
//                                 fontSize: '0.875rem',
//                                 marginBottom: '1.5rem',
//                                 lineHeight: '1.5'
//                             }}>
//                                 Management or HR has specifically requested <strong>{pendingList.length}</strong> additional document(s) for your onboarding profile:
//                             </p>

//                             <div style={{
//                                 width: '100%',
//                                 maxHeight: '190px',
//                                 overflowY: 'auto',
//                                 backgroundColor: 'var(--bg-tertiary)',
//                                 borderRadius: 'var(--border-radius-sm)',
//                                 border: '1px solid var(--border-color)',
//                                 padding: '1rem',
//                                 marginBottom: '1.75rem',
//                                 textAlign: 'left',
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 gap: '0.75rem'
//                             }}>
//                                 {pendingList.map((req, idx) => {
//                                     const name = req.document_name || req.document_type || req.title || req.name || `Requested Document #${idx + 1}`;
//                                     const inst = req.instructions || req.comments || req.description || req.note || req.reason || '';
//                                     return (
//                                         <div key={req.id || idx} style={{ borderBottom: idx < pendingList.length - 1 ? '1px solid var(--border-color)' : 'none', paddingBottom: '0.5rem' }}>
//                                             <div style={{ fontWeight: 700, fontSize: '0.9rem', color: 'var(--primary)' }}>
//                                                 {idx + 1}. {name}
//                                             </div>
//                                             {inst && (
//                                                 <div style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', marginTop: '0.2rem' }}>
//                                                     Instructions: {inst}
//                                                 </div>
//                                             )}
//                                         </div>
//                                     );
//                                 })}
//                             </div>

//                             <button
//                                 type="button"
//                                 className="btn btn-primary"
//                                 style={{ width: '100%', padding: '0.85rem 1.5rem', fontSize: '0.95rem', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
//                                 onClick={() => {
//                                     setShowRequestedDocsModal(false);
//                                     setHasSeenRequestedDocsModal(true);
//                                     setActiveTab('documents');
//                                 }}
//                             >
//                                 Proceed to Documents Page →
//                             </button>
//                         </div>
//                     </div>,
//                     document.body
//                 );
//             })()}

//             {toast && (
//                 <div className="toast-container">
//                     <NotificationToast
//                         message={toast.message}
//                         type={toast.type}
//                         onClose={() => setToast(null)}
//                     />
//                 </div>
//             )}
//         </div>
//     );
// };

// export default EmployeeDashboard;








































import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import api from '../services/api';
import UploadField from '../components/UploadField';
import SignaturePad from '../components/SignaturePad';
import NotificationToast from '../components/NotificationToast';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { genesisPolicies } from '../constants/genesisPolicies';
import { genesisPoliciesText } from '../constants/genesisPoliciesText';
import Loader from '../components/Loader';

// Helper to convert base64 (including data URIs) to a Uint8Array safely
const base64ToUint8Array = (base64Str) => {
    if (!base64Str || typeof base64Str !== 'string') return new Uint8Array(0);
    try {
        const commaIdx = base64Str.indexOf(',');
        let clean = commaIdx !== -1 ? base64Str.substring(commaIdx + 1) : base64Str;
        clean = clean.replace(/\s/g, '');

        // Normalize URL-safe base64
        clean = clean.replace(/-/g, '+').replace(/_/g, '/');

        // Fix padding if needed
        const mod = clean.length % 4;
        if (mod === 2) {
            clean += '==';
        } else if (mod === 3) {
            clean += '=';
        }

        const bin = atob(clean);
        const len = bin.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = bin.charCodeAt(i);
        }
        return bytes;
    } catch (e) {
        console.error("base64ToUint8Array decoding failed:", e);
        return new Uint8Array(0);
    }
};

// Helper to convert base64 to Blob URL
const base64ToBlobUrl = (base64Data) => {
    try {
        if (!base64Data) return '';
        const arr = base64ToUint8Array(base64Data);
        if (arr.length === 0) return '';
        const blob = new Blob([arr], { type: 'application/pdf' });
        return URL.createObjectURL(blob);
    } catch (err) {
        console.error('Failed to convert base64 to Blob URL:', err);
        return '';
    }
};

// Helper to fetch local or remote PDF file and convert to base64 with in-memory caching
const pdfBase64Cache = new Map();

const fetchLocalPdfAsBase64 = async (url) => {
    if (!url) return '';
    if (pdfBase64Cache.has(url)) {
        return pdfBase64Cache.get(url);
    }

    if (url.startsWith('data:application/pdf;base64,')) {
        const res = url.replace('data:application/pdf;base64,', '');
        pdfBase64Cache.set(url, res);
        return res;
    }
    if (url.startsWith('data:')) {
        const commaIdx = url.indexOf(',');
        if (commaIdx !== -1) {
            const res = url.substring(commaIdx + 1);
            pdfBase64Cache.set(url, res);
            return res;
        }
    }

    const bufferToBase64 = (arrayBuffer) => {
        let binary = '';
        const bytes = new Uint8Array(arrayBuffer);
        const len = bytes.byteLength;
        const chunkSize = 8192;
        for (let i = 0; i < len; i += chunkSize) {
            const chunk = bytes.subarray(i, i + chunkSize);
            binary += String.fromCharCode.apply(null, chunk);
        }
        return btoa(binary);
    };

    // 1. Direct fetch with CORS mode
    try {
        const response = await fetch(url, { mode: 'cors' });
        if (response.ok) {
            const arrayBuffer = await response.arrayBuffer();
            if (arrayBuffer.byteLength > 0) {
                const res = bufferToBase64(arrayBuffer);
                pdfBase64Cache.set(url, res);
                return res;
            }
        }
    } catch (directErr) {
        console.warn("Direct PDF fetch failed for:", url, directErr);
    }

    // 2. Direct fetch default fallback
    try {
        const response = await fetch(url);
        if (response.ok) {
            const arrayBuffer = await response.arrayBuffer();
            if (arrayBuffer.byteLength > 0) {
                const res = bufferToBase64(arrayBuffer);
                pdfBase64Cache.set(url, res);
                return res;
            }
        }
    } catch (directErr2) {
        console.warn("Direct fetch fallback failed:", directErr2);
    }

    // If local or blob URL, proxy won't work
    if (url.startsWith('blob:') || url.startsWith('/') || url.includes('localhost')) {
        return '';
    }

    // 3. CORS Proxies for remote host files (fast with 2.5s timeout per proxy)
    const proxies = [
        (u) => `https://api.allorigins.win/raw?url=${encodeURIComponent(u)}`,
        (u) => `https://corsproxy.io/?${encodeURIComponent(u)}`,
        (u) => `https://thingproxy.freeboard.io/fetch/${u}`,
        (u) => `https://api.codetabs.com/v1/proxy?quest=${encodeURIComponent(u)}`
    ];

    for (const getProxyUrl of proxies) {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 2500);
        try {
            const proxyUrl = getProxyUrl(url);
            const res = await fetch(proxyUrl, { signal: controller.signal });
            clearTimeout(timeoutId);
            if (res.ok) {
                const arrayBuffer = await res.arrayBuffer();
                if (arrayBuffer.byteLength > 0) {
                    const result = bufferToBase64(arrayBuffer);
                    pdfBase64Cache.set(url, result);
                    return result;
                }
            }
        } catch (e) {
            clearTimeout(timeoutId);
            console.warn("Proxy attempt failed:", e);
        }
    }

    return '';
};

// Helper to convert typed signature into a transparent PNG data URL on the fly
const convertTypedToPng = (typedName) => {
    const text = (typedName || '').trim();
    if (!text) return '';

    // Create high-resolution canvas (800x200) to fit long names crisp and clear
    const canvas = document.createElement('canvas');
    canvas.width = 800;
    canvas.height = 200;
    const ctx = canvas.getContext('2d');

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const fontFamily = '"Outfit", "Brush Script MT", cursive, sans-serif';
    const padding = 60; // 30px padding on left & right
    const maxTextWidth = canvas.width - padding;

    // Start with a large font size (52px)
    let fontSize = 52;
    ctx.font = `italic ${fontSize}px ${fontFamily}`;

    // Measure text width and dynamically decrease font size until the full name fits inside canvas bounds
    let textWidth = ctx.measureText(text).width;
    while (textWidth > maxTextWidth && fontSize > 14) {
        fontSize -= 1;
        ctx.font = `italic ${fontSize}px ${fontFamily}`;
        textWidth = ctx.measureText(text).width;
    }

    ctx.fillStyle = '#0f172a'; // dark slate/primary color
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    // Draw the full text on a single line, perfectly centered
    ctx.fillText(text, canvas.width / 2, canvas.height / 2);

    return canvas.toDataURL('image/png');
};

// Helper to scale signature image proportionally for PDF embedding
const getSignatureDimensions = (signatureImage, maxW = 140, maxH = 32) => {
    if (!signatureImage || !signatureImage.width || !signatureImage.height) {
        return { width: maxW, height: maxH };
    }
    const imgAspect = signatureImage.width / signatureImage.height;
    let width = maxW;
    let height = width / imgAspect;
    if (height > maxH) {
        height = maxH;
        width = height * imgAspect;
    }
    return { width, height };
};

// Helper to draw signature PNG on the last page of a PDF
const generateAgreementPdfData = async (templateBytes, formValues, signaturePng) => {
    if (!templateBytes) return '';
    const pdfDoc = await PDFDocument.load(templateBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

    // Draw values on Page 1
    const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
    const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();
    firstPage.drawText(dateStr, {
        x: 320,
        y: 695.86,
        size: 10,
        font: boldFont,
        color: rgb(0, 0, 0)
    });

    if (formValues.employeeName) {
        firstPage.drawText(formValues.employeeName, {
            x: 120,
            y: 671.50,
            size: 10,
            font: boldFont,
            color: rgb(0, 0, 0)
        });
    }

    if (formValues.position) {
        firstPage.drawText(formValues.position, {
            x: 85,
            y: 598.06,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });
    }

    if (formValues.department) {
        firstPage.drawText(formValues.department, {
            x: 100,
            y: 573.79,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });
    }

    if (formValues.primaryLocation) {
        firstPage.drawText(formValues.primaryLocation, {
            x: 145,
            y: 549.43,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });
    }

    const drawTick = (x, y) => {
        firstPage.drawText('\u2714', {
            x: x + 1,
            y: y + 1,
            size: 10,
            font: dingbatsFont,
            color: rgb(0, 0, 0)
        });
    };

    if (formValues.employmentClassification === 'Full-Time') {
        drawTick(45, 511.51);
    } else if (formValues.employmentClassification === 'Part-Time') {
        drawTick(45, 498.07);
    } else if (formValues.employmentClassification === 'Exempt') {
        drawTick(45, 484.63);
    } else if (formValues.employmentClassification === 'Non-Exempt') {
        drawTick(45, 471.07);
    }

    // Draw signature block on Page 5
    const page5 = pages[4];
    if (page5) {
        if (formValues.employeeName) {
            page5.drawText(formValues.employeeName, {
                x: 120,
                y: 573.91,
                size: 10,
                font: boldFont,
                color: rgb(0, 0, 0)
            });
        }

        page5.drawText(dateStr, {
            x: 70,
            y: 525.07,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });

        page5.drawText(dateStr, {
            x: 70,
            y: 368.69,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });

        if (signaturePng) {
            try {
                const signatureBytes = base64ToUint8Array(signaturePng);
                if (signatureBytes.length > 0) {
                    const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
                    const signatureImage = isJpg
                        ? await pdfDoc.embedJpg(signatureBytes)
                        : await pdfDoc.embedPng(signatureBytes);

                    const sigDims = getSignatureDimensions(signatureImage, 140, 32);
                    page5.drawImage(signatureImage, {
                        x: 100,
                        y: 539,
                        width: sigDims.width,
                        height: sigDims.height,
                    });

                    // Draw signature and audit text on every page in the empty space
                    const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
                    const footDims = getSignatureDimensions(signatureImage, 100, 28);
                    pages.forEach((page) => {
                        page.drawImage(signatureImage, {
                            x: 195,
                            y: 20,
                            width: footDims.width,
                            height: footDims.height,
                        });
                        page.drawText(auditText, {
                            x: 195,
                            y: 12,
                            size: 7,
                            font: textFont,
                            color: rgb(0.2, 0.3, 0.4),
                        });
                    });
                }
            } catch (e) {
                console.error('Error embedding signature in final PDF data:', e);
            }
        }
    }

    const pdfBytes = await pdfDoc.save();
    let binary = '';
    const bytes = new Uint8Array(pdfBytes);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};

const generateNdaPdfData = async (templateBytes, formValues, signaturePng) => {
    if (!templateBytes) return '';
    const pdfDoc = await PDFDocument.load(templateBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

    // Draw values on Page 1
    const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
    const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();

    if (formValues.employeeName) {
        firstPage.drawText(formValues.employeeName, {
            x: 120,
            y: 636.10,
            size: 10,
            font: boldFont,
            color: rgb(0, 0, 0)
        });
    }

    if (formValues.position) {
        firstPage.drawText(formValues.position, {
            x: 90,
            y: 622.18,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });
    }

    firstPage.drawText(dateStr, {
        x: 110,
        y: 608.02,
        size: 10,
        font: textFont,
        color: rgb(0, 0, 0)
    });

    // Draw signature block on Page 5
    const page5 = pages[4];
    if (page5) {
        if (formValues.employeeName) {
            page5.drawText(formValues.employeeName, {
                x: 120,
                y: 622.18,
                size: 10,
                font: boldFont,
                color: rgb(0, 0, 0)
            });
        }

        page5.drawText(dateStr, {
            x: 70,
            y: 608.14,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });

        page5.drawText(dateStr, {
            x: 70,
            y: 473.47,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });

        if (signaturePng) {
            try {
                const signatureBytes = base64ToUint8Array(signaturePng);
                if (signatureBytes.length > 0) {
                    const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
                    const signatureImage = isJpg
                        ? await pdfDoc.embedJpg(signatureBytes)
                        : await pdfDoc.embedPng(signatureBytes);

                    const sigDims = getSignatureDimensions(signatureImage, 140, 32);
                    page5.drawImage(signatureImage, {
                        x: 140,
                        y: 640,
                        width: sigDims.width,
                        height: sigDims.height,
                    });

                    // Draw signature and audit text on every page in the empty space
                    const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
                    const footDims = getSignatureDimensions(signatureImage, 100, 28);
                    pages.forEach((page) => {
                        page.drawImage(signatureImage, {
                            x: 195,
                            y: 20,
                            width: footDims.width,
                            height: footDims.height,
                        });
                        page.drawText(auditText, {
                            x: 195,
                            y: 12,
                            size: 7,
                            font: textFont,
                            color: rgb(0.2, 0.3, 0.4),
                        });
                    });
                }
            } catch (e) {
                console.error('Error embedding signature in final NDA PDF data:', e);
            }
        }
    }

    const pdfBytes = await pdfDoc.save();
    let binary = '';
    const bytes = new Uint8Array(pdfBytes);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};

const generateConflictPdfData = async (templateBytes, formValues, signaturePng) => {
    if (!templateBytes) return '';
    const pdfDoc = await PDFDocument.load(templateBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    const page2 = pages[1];
    const page3 = pages[2];

    const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

    // Draw values on Page 1
    if (formValues.employeeName) {
        firstPage.drawText(formValues.employeeName, {
            x: 120,
            y: 647.02,
            size: 10,
            font: boldFont,
            color: rgb(0, 0, 0)
        });
    }

    if (formValues.position) {
        firstPage.drawText(formValues.position, {
            x: 85,
            y: 628.90,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });
    }

    const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
    const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();
    firstPage.drawText(dateStr, {
        x: 110,
        y: 610.54,
        size: 10,
        font: textFont,
        color: rgb(0, 0, 0)
    });

    // Draw values on Page 2 (Questions & Checkboxes)
    if (page2) {
        const drawTick = (x, y) => {
            page2.drawText('\u2714', {
                x: x + 1,
                y: y + 1,
                size: 9.5,
                font: dingbatsFont,
                color: rgb(0, 0, 0)
            });
        };

        // A. Outside Employment
        if (formValues.outsideEmploymentType === 'none') {
            drawTick(43, 664.18);
        } else if (formValues.outsideEmploymentType === 'has_employment') {
            drawTick(43, 644.02);

            if (formValues.outsideEmployer) {
                page2.drawText(formValues.outsideEmployer, {
                    x: 135,
                    y: 625.90,
                    size: 9,
                    font: textFont,
                    color: rgb(0, 0, 0)
                });
            }
            if (formValues.outsideNature) {
                page2.drawText(formValues.outsideNature, {
                    x: 115,
                    y: 607.54,
                    size: 9,
                    font: textFont,
                    color: rgb(0, 0, 0)
                });
            }
            if (formValues.outsideHours) {
                page2.drawText(formValues.outsideHours, {
                    x: 110,
                    y: 589.03,
                    size: 9,
                    font: textFont,
                    color: rgb(0, 0, 0)
                });
            }
        }

        // B. Ownership of Other Businesses
        if (formValues.ownershipType === 'no') {
            drawTick(43, 532.87);
        } else if (formValues.ownershipType === 'yes') {
            drawTick(43, 512.71);
            if (formValues.ownershipDescribe) {
                page2.drawText(formValues.ownershipDescribe, {
                    x: 115,
                    y: 493.87,
                    size: 9,
                    font: textFont,
                    color: rgb(0, 0, 0)
                });
            }
        }

        // C. Competing Activities
        if (formValues.competingType === 'no') {
            drawTick(43, 437.59);
        } else if (formValues.competingType === 'yes') {
            drawTick(43, 417.53);
            if (formValues.competingDescribe) {
                page2.drawText(formValues.competingDescribe, {
                    x: 110,
                    y: 398.69,
                    size: 9,
                    font: textFont,
                    color: rgb(0, 0, 0)
                });
            }
        }

        // D. Other Potential Conflicts
        if (formValues.otherConflicts) {
            page2.drawText(formValues.otherConflicts, {
                x: 45,
                y: 348,
                size: 8.5,
                font: textFont,
                color: rgb(0, 0, 0)
            });
        }
    }

    // Draw signature block on Page 3
    if (page3) {
        if (formValues.employeeName) {
            page3.drawText(formValues.employeeName, {
                x: 120,
                y: 683.62,
                size: 10,
                font: boldFont,
                color: rgb(0, 0, 0)
            });
        }

        page3.drawText(dateStr, {
            x: 70,
            y: 665.50,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });

        page3.drawText(dateStr, {
            x: 70,
            y: 545.23,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });

        if (signaturePng) {
            try {
                const signatureBytes = base64ToUint8Array(signaturePng);
                if (signatureBytes.length > 0) {
                    const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
                    const signatureImage = isJpg
                        ? await pdfDoc.embedJpg(signatureBytes)
                        : await pdfDoc.embedPng(signatureBytes);

                    const sigDims = getSignatureDimensions(signatureImage, 140, 32);
                    page3.drawImage(signatureImage, {
                        x: 160,
                        y: 709,
                        width: sigDims.width,
                        height: sigDims.height,
                    });

                    // Draw signature and audit text on every page in the empty space
                    const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
                    const footDims = getSignatureDimensions(signatureImage, 100, 28);
                    pages.forEach((page) => {
                        page.drawImage(signatureImage, {
                            x: 195,
                            y: 20,
                            width: footDims.width,
                            height: footDims.height,
                        });
                        page.drawText(auditText, {
                            x: 195,
                            y: 12,
                            size: 7,
                            font: textFont,
                            color: rgb(0.2, 0.3, 0.4),
                        });
                    });
                }
            } catch (e) {
                console.error('Error embedding signature in final Conflict PDF data:', e);
            }
        }
    }

    const pdfBytes = await pdfDoc.save();
    let binary = '';
    const bytes = new Uint8Array(pdfBytes);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};

const generateBenefitsPdfData = async (templateBytes, formValues, signaturePng) => {
    if (!templateBytes) return '';
    const pdfDoc = await PDFDocument.load(templateBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    const page2 = pages[1];
    const page3 = pages[2];

    const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

    const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
    const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();

    // Helper to draw checkmarks
    const drawTick = (page, x, y) => {
        page.drawText('\u2714', {
            x: x + 1,
            y: y + 1,
            size: 9.5,
            font: dingbatsFont,
            color: rgb(0, 0, 0)
        });
    };

    // Draw values on Page 1
    if (formValues.employeeName) {
        firstPage.drawText(formValues.employeeName, {
            x: 130,
            y: 700.66,
            size: 10,
            font: boldFont,
            color: rgb(0, 0, 0)
        });
    }
    if (formValues.position) {
        firstPage.drawText(formValues.position, {
            x: 95,
            y: 664.06,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });
    }
    if (formValues.department) {
        firstPage.drawText(formValues.department, {
            x: 110,
            y: 645.70,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });
    }
    firstPage.drawText(dateStr, {
        x: 135,
        y: 609.10,
        size: 10,
        font: textFont,
        color: rgb(0, 0, 0)
    });

    // Section 1 - Medical
    if (formValues.medicalElection === 'enrol') {
        drawTick(firstPage, 43, 461.23);
    } else if (formValues.medicalElection === 'waive') {
        drawTick(firstPage, 43, 441.19);
        if (formValues.medicalWaiveReason === 'spouse_plan') {
            drawTick(firstPage, 43, 402.65);
        } else if (formValues.medicalWaiveReason === 'another_plan') {
            drawTick(firstPage, 43, 382.61);
        } else if (formValues.medicalWaiveReason === 'gov_program') {
            drawTick(firstPage, 43, 362.45);
        } else if (formValues.medicalWaiveReason === 'other') {
            drawTick(firstPage, 43, 342.29);
            if (formValues.medicalWaiveReasonOther) {
                firstPage.drawText(formValues.medicalWaiveReasonOther, {
                    x: 95,
                    y: 342.29,
                    size: 9,
                    font: textFont,
                    color: rgb(0, 0, 0)
                });
            }
        }
    }

    // Section 2 - Dental
    if (formValues.dentalElection === 'enrol') {
        drawTick(firstPage, 43, 285.53);
    } else if (formValues.dentalElection === 'waive') {
        drawTick(firstPage, 43, 265.49);
    }

    // Section 3 - Vision
    if (formValues.visionElection === 'enrol') {
        drawTick(firstPage, 43, 208.70);
    } else if (formValues.visionElection === 'waive') {
        drawTick(firstPage, 43, 188.54);
    }

    // Section 4 - 401(k) Retirement Participation
    if (formValues.retirementElection === 'participate') {
        drawTick(firstPage, 43, 131.78);

        // Draw contributions on Page 2
        if (page2) {
            if (formValues.retirementContributionType === 'percentage') {
                drawTick(page2, 43, 717.70);
                if (formValues.retirementContributionPercent) {
                    page2.drawText(String(formValues.retirementContributionPercent), {
                        x: 58,
                        y: 717.70,
                        size: 9,
                        font: textFont,
                        color: rgb(0, 0, 0)
                    });
                }
            } else if (formValues.retirementContributionType === 'amount') {
                drawTick(page2, 43, 679.18);
                if (formValues.retirementContributionAmount) {
                    page2.drawText(String(formValues.retirementContributionAmount), {
                        x: 58,
                        y: 679.18,
                        size: 9,
                        font: textFont,
                        color: rgb(0, 0, 0)
                    });
                }
            }
        }
    } else if (formValues.retirementElection === 'decline') {
        drawTick(firstPage, 43, 111.62);
    }

    // Section 5 - Beneficiary Designation on Page 2
    if (page2) {
        if (formValues.primaryBeneName) {
            page2.drawText(formValues.primaryBeneName, {
                x: 80,
                y: 365.81,
                size: 9,
                font: textFont,
                color: rgb(0, 0, 0)
            });
        }
        if (formValues.primaryBeneRelationship) {
            page2.drawText(formValues.primaryBeneRelationship, {
                x: 105,
                y: 347.45,
                size: 9,
                font: textFont,
                color: rgb(0, 0, 0)
            });
        }
        if (formValues.primaryBeneDob) {
            page2.drawText(formValues.primaryBeneDob, {
                x: 105,
                y: 329.21,
                size: 9,
                font: textFont,
                color: rgb(0, 0, 0)
            });
        }
        if (formValues.primaryBenePercent) {
            page2.drawText(String(formValues.primaryBenePercent), {
                x: 55,
                y: 292.61,
                size: 9,
                font: textFont,
                color: rgb(0, 0, 0)
            });
        }

        if (formValues.contingentBeneName) {
            page2.drawText(formValues.contingentBeneName, {
                x: 80,
                y: 237.62,
                size: 9,
                font: textFont,
                color: rgb(0, 0, 0)
            });
        }
        if (formValues.contingentBeneRelationship) {
            page2.drawText(formValues.contingentBeneRelationship, {
                x: 105,
                y: 219.26,
                size: 9,
                font: textFont,
                color: rgb(0, 0, 0)
            });
        }
        if (formValues.contingentBeneDob) {
            page2.drawText(formValues.contingentBeneDob, {
                x: 105,
                y: 201.02,
                size: 9,
                font: textFont,
                color: rgb(0, 0, 0)
            });
        }
        if (formValues.contingentBenePercent) {
            page2.drawText(String(formValues.contingentBenePercent), {
                x: 55,
                y: 164.30,
                size: 9,
                font: textFont,
                color: rgb(0, 0, 0)
            });
        }
    }

    // Draw signature block on Page 3
    if (page3) {
        if (formValues.employeeName) {
            page3.drawText(formValues.employeeName, {
                x: 110,
                y: 535.87,
                size: 10,
                font: boldFont,
                color: rgb(0, 0, 0)
            });
        }
        page3.drawText(dateStr, {
            x: 75,
            y: 517.51,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });

        page3.drawText(dateStr, {
            x: 75,
            y: 232.22,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });

        if (signaturePng) {
            try {
                const signatureBytes = base64ToUint8Array(signaturePng);
                if (signatureBytes.length > 0) {
                    const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
                    const signatureImage = isJpg
                        ? await pdfDoc.embedJpg(signatureBytes)
                        : await pdfDoc.embedPng(signatureBytes);

                    page3.drawImage(signatureImage, {
                        x: 160,
                        y: 544,
                        width: 140,
                        height: 28,
                    });

                    // Draw signature and audit text on every page in the empty space
                    const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
                    pages.forEach((page) => {
                        page.drawImage(signatureImage, {
                            x: 195,
                            y: 20,
                            width: 100,
                            height: 35,
                        });
                        page.drawText(auditText, {
                            x: 195,
                            y: 12,
                            size: 7,
                            font: textFont,
                            color: rgb(0.2, 0.3, 0.4),
                        });
                    });
                }
            } catch (e) {
                console.error('Error embedding signature in final Benefits PDF data:', e);
            }
        }
    }

    const pdfBytes = await pdfDoc.save();
    let binary = '';
    const bytes = new Uint8Array(pdfBytes);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};

const generateNonSolicitationPdfData = async (templateBytes, formValues, signaturePng) => {
    if (!templateBytes) return '';
    const pdfDoc = await PDFDocument.load(templateBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    const lastPage = pages[pages.length - 1];

    const textFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

    const joiningDateRaw = formValues?.hireDate || formValues?.joiningDate || formValues?.joining_date || formValues?.JoiningDate;
    const dateStr = joiningDateRaw ? formatDateMMDDYYYY(joiningDateRaw) : formatDateMMDDYYYY();

    // Draw values on Page 1
    if (formValues.employeeName) {
        firstPage.drawText(formValues.employeeName, {
            x: 119,
            y: 665.14,
            size: 10,
            font: boldFont,
            color: rgb(0, 0, 0)
        });
    }

    if (formValues.position) {
        firstPage.drawText(formValues.position, {
            x: 83,
            y: 647.02,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });
    }

    firstPage.drawText(dateStr, {
        x: 107,
        y: 628.90,
        size: 10,
        font: textFont,
        color: rgb(0, 0, 0)
    });

    // Draw values on last page
    if (lastPage) {
        if (formValues.employeeName) {
            lastPage.drawText(formValues.employeeName, {
                x: 120,
                y: 317.57,
                size: 10,
                font: boldFont,
                color: rgb(0, 0, 0)
            });
        }

        lastPage.drawText(dateStr, {
            x: 75,
            y: 299.21,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });

        lastPage.drawText(dateStr, {
            x: 75,
            y: 130.34,
            size: 10,
            font: textFont,
            color: rgb(0, 0, 0)
        });

        if (signaturePng) {
            try {
                const signatureBytes = base64ToUint8Array(signaturePng);
                if (signatureBytes.length > 0) {
                    const isJpg = signaturePng.startsWith('data:image/jpeg') || signaturePng.startsWith('data:image/jpg');
                    const signatureImage = isJpg
                        ? await pdfDoc.embedJpg(signatureBytes)
                        : await pdfDoc.embedPng(signatureBytes);

                    const sigDims = getSignatureDimensions(signatureImage, 140, 32);
                    lastPage.drawImage(signatureImage, {
                        x: 150,
                        y: 343,
                        width: sigDims.width,
                        height: sigDims.height,
                    });

                    // Draw signature and audit text on every page footer in empty space
                    const auditText = `Signed by ${formValues.employeeName} on ${dateStr}`;
                    const footDims = getSignatureDimensions(signatureImage, 100, 28);
                    pages.forEach((page) => {
                        page.drawImage(signatureImage, {
                            x: 195,
                            y: 20,
                            width: footDims.width,
                            height: footDims.height,
                        });
                        page.drawText(auditText, {
                            x: 195,
                            y: 12,
                            size: 7,
                            font: textFont,
                            color: rgb(0.2, 0.3, 0.4),
                        });
                    });
                }
            } catch (e) {
                console.error('Error embedding signature in final Non Solicitation PDF:', e);
            }
        }
    }

    const pdfBytes = await pdfDoc.save();
    let binary = '';
    const bytes = new Uint8Array(pdfBytes);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};

// Helper to format date as MM/DD/YYYY
const formatDateMMDDYYYY = (dateVal) => {
    if (!dateVal) {
        const now = new Date();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${m}/${day}/${now.getFullYear()}`;
    }
    let d = null;
    if (dateVal instanceof Date) {
        d = dateVal;
    } else if (typeof dateVal === 'string') {
        const trimmed = dateVal.trim();
        // 1. Check YYYY-MM-DD or YYYY/MM/DD
        const ymdMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
        if (ymdMatch) {
            const year = parseInt(ymdMatch[1], 10);
            const month = parseInt(ymdMatch[2], 10) - 1;
            const day = parseInt(ymdMatch[3], 10);
            d = new Date(year, month, day);
        } else {
            // 2. Check MM/DD/YYYY or DD/MM/YYYY
            const mdyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
            if (mdyMatch) {
                const p1 = parseInt(mdyMatch[1], 10);
                const p2 = parseInt(mdyMatch[2], 10);
                const year = parseInt(mdyMatch[3], 10);
                let month, day;
                if (p1 > 12) {
                    day = p1;
                    month = p2 - 1;
                } else if (p2 > 12) {
                    month = p1 - 1;
                    day = p2;
                } else {
                    month = p1 - 1;
                    day = p2;
                }
                d = new Date(year, month, day);
            } else {
                d = new Date(trimmed);
            }
        }
    } else {
        d = new Date(dateVal);
    }

    if (!d || isNaN(d.getTime())) {
        const now = new Date();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${m}/${day}/${now.getFullYear()}`;
    }

    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
};

// Helper to format joining date for India Employment Agreement (e.g., "21st day of November 2025.")
const formatAgreementJoiningDate = (dateInput) => {
    if (!dateInput) return '21st day of November 2025.';
    let dateObj = null;

    if (dateInput instanceof Date) {
        dateObj = dateInput;
    } else if (typeof dateInput === 'string') {
        const trimmed = dateInput.trim();

        // 1. Check YYYY-MM-DD or YYYY/MM/DD (e.g. 2026-09-25, 2026-9-25)
        const ymdMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
        if (ymdMatch) {
            const year = parseInt(ymdMatch[1], 10);
            const month = parseInt(ymdMatch[2], 10) - 1;
            const day = parseInt(ymdMatch[3], 10);
            dateObj = new Date(year, month, day);
        } else {
            // 2. Check MM/DD/YYYY or DD/MM/YYYY (e.g. 09/25/2026 or 25/09/2026)
            const mdyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
            if (mdyMatch) {
                const p1 = parseInt(mdyMatch[1], 10);
                const p2 = parseInt(mdyMatch[2], 10);
                const year = parseInt(mdyMatch[3], 10);

                let month, day;
                if (p1 > 12) {
                    // p1 is Day, p2 is Month (e.g., 25/09/2026)
                    day = p1;
                    month = p2 - 1;
                } else if (p2 > 12) {
                    // p1 is Month, p2 is Day (e.g., 09/25/2026)
                    month = p1 - 1;
                    day = p2;
                } else {
                    // Standard US format MM/DD/YYYY (e.g., 09/05/2026)
                    month = p1 - 1;
                    day = p2;
                }
                dateObj = new Date(year, month, day);
            } else {
                // 3. Fallback to standard JS Date parsing
                dateObj = new Date(trimmed);
            }
        }
    }

    if (!dateObj || isNaN(dateObj.getTime())) {
        return '21st day of November 2025.';
    }

    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const monthName = monthNames[dateObj.getMonth()];

    let suffix = 'th';
    if (day % 100 < 11 || day % 100 > 13) {
        switch (day % 10) {
            case 1: suffix = 'st'; break;
            case 2: suffix = 'nd'; break;
            case 3: suffix = 'rd'; break;
            default: suffix = 'th'; break;
        }
    }

    return `${day}${suffix} day of ${monthName} ${year}.`;
};

// Helper to format short joining date for India Employment Agreement (e.g., "25th September 2026")
const formatJoiningDateShort = (dateInput) => {
    if (!dateInput) return '21st November 2025';
    let dateObj = null;

    if (dateInput instanceof Date) {
        dateObj = dateInput;
    } else if (typeof dateInput === 'string') {
        const trimmed = dateInput.trim();

        // 1. Check YYYY-MM-DD or YYYY/MM/DD
        const ymdMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
        if (ymdMatch) {
            const year = parseInt(ymdMatch[1], 10);
            const month = parseInt(ymdMatch[2], 10) - 1;
            const day = parseInt(ymdMatch[3], 10);
            dateObj = new Date(year, month, day);
        } else {
            // 2. Check MM/DD/YYYY or DD/MM/YYYY
            const mdyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
            if (mdyMatch) {
                const p1 = parseInt(mdyMatch[1], 10);
                const p2 = parseInt(mdyMatch[2], 10);
                const year = parseInt(mdyMatch[3], 10);

                let month, day;
                if (p1 > 12) {
                    day = p1;
                    month = p2 - 1;
                } else if (p2 > 12) {
                    month = p1 - 1;
                    day = p2;
                } else {
                    month = p1 - 1;
                    day = p2;
                }
                dateObj = new Date(year, month, day);
            } else {
                dateObj = new Date(trimmed);
            }
        }
    }

    if (!dateObj || isNaN(dateObj.getTime())) {
        return '21st November 2025';
    }

    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const monthName = monthNames[dateObj.getMonth()];

    let suffix = 'th';
    if (day % 100 < 11 || day % 100 > 13) {
        switch (day % 10) {
            case 1: suffix = 'st'; break;
            case 2: suffix = 'nd'; break;
            case 3: suffix = 'rd'; break;
            default: suffix = 'th'; break;
        }
    }

    return `${day}${suffix} ${monthName} ${year}`;
};

// Helper to draw signature PNG on the last page of a PDF and footers of all pages
const applySignatureToPdf = async (originalPdfBase64, signaturePngDataUrl, employeeName, docType, isIndia = false, extraDetails = {}) => {
    try {
        let pdfDoc;
        if (originalPdfBase64) {
            // Convert base64 PDF to bytes safely
            const pdfBytes = base64ToUint8Array(originalPdfBase64);
            if (pdfBytes.length === 0) {
                throw new Error("Invalid original PDF base64 data");
            }
            // Load the PDF document
            pdfDoc = await PDFDocument.load(pdfBytes);
        } else {
            if (docType === 'Offer Letter') {
                throw new Error("Unable to retrieve original Offer Letter document bytes for digital signing. Please check network connection.");
            }
            // Fallback for other documents: If original PDF is empty, create a simple PDF document
            pdfDoc = await PDFDocument.create();
            const page = pdfDoc.addPage([595, 842]); // A4

            page.drawText(`${docType} Confirmation`, {
                x: 50,
                y: 750,
                size: 20,
                color: rgb(0.1, 0.1, 0.1),
            });

            page.drawText(`This document serves as confirmation that the employee has electronically signed the ${docType}.`, {
                x: 50,
                y: 700,
                size: 11,
                color: rgb(0.2, 0.2, 0.2),
            });

            page.drawText(`Employee Name: ${employeeName}`, {
                x: 50,
                y: 650,
                size: 11,
            });
        }

        // Embed signature image if provided
        let signatureImage = null;
        if (signaturePngDataUrl) {
            try {
                const isJpg = signaturePngDataUrl.startsWith('data:image/jpeg') || signaturePngDataUrl.startsWith('data:image/jpg');
                const signatureBytes = base64ToUint8Array(signaturePngDataUrl);
                if (signatureBytes.length > 0) {
                    if (isJpg) {
                        signatureImage = await pdfDoc.embedJpg(signatureBytes);
                    } else {
                        signatureImage = await pdfDoc.embedPng(signatureBytes);
                    }
                }
            } catch (imgErr) {
                console.warn("Failed to embed signature PNG into PDF:", imgErr);
            }
        }

        // Get all pages
        const pages = pdfDoc.getPages();
        if (pages.length === 0) {
            throw new Error("PDF document has no pages");
        }
        const lastPage = pages[pages.length - 1];

        const currentDate = extraDetails?.date || formatDateMMDDYYYY();
        const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
        const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

        // Draw signature image and audit text on every page at the footer in the empty space (skip for Offer Letter)
        if (signatureImage && docType !== 'Offer Letter') {
            const auditText = `Signed by ${employeeName} on ${currentDate}`;
            const footDims = getSignatureDimensions(signatureImage, 100, 28);
            pages.forEach((page) => {
                page.drawImage(signatureImage, {
                    x: 195,
                    y: 20,
                    width: footDims.width,
                    height: footDims.height,
                });
                page.drawText(auditText, {
                    x: 195,
                    y: 12,
                    size: 7,
                    font,
                    color: rgb(0.2, 0.3, 0.4),
                });
            });
        }

        // Draw main signature image and texts on the last page
        if (docType === 'Employee Agreement') {
            // 1. Draw dynamic Joining Date on Page 1
            const rawJoiningDate = extraDetails?.joiningDate || extraDetails?.joining_date || extraDetails?.JoiningDate || extraDetails?.hireDate;
            if (pages.length > 0) {
                const firstPage = pages[0];
                const formattedJoiningDate = formatAgreementJoiningDate(rawJoiningDate);
                // Cover blank underline area starting precisely after "this "
                firstPage.drawRectangle({
                    x: 388.8,
                    y: 555,
                    width: 135,
                    height: 14,
                    color: rgb(1, 1, 1),
                });
                // Draw joining date text starting precisely at x: 389.11
                firstPage.drawText(formattedJoiningDate, {
                    x: 389.11,
                    y: 559.54,
                    size: 8.8,
                    font,
                    color: rgb(0, 0, 0),
                });
            }

            // Draw Employee Name text
            lastPage.drawText(employeeName, {
                x: 145,
                y: 493,
                size: 9,
                font: fontBold,
                color: rgb(0, 0, 0),
            });

            // Draw Date text on last page (in front of Date: lines at y: 470.95 and y: 320.21)
            const formattedDateForLastPage = rawJoiningDate ? formatJoiningDateShort(rawJoiningDate) : currentDate;

            // Employee Date: line
            lastPage.drawText(formattedDateForLastPage, {
                x: 105,
                y: 475,
                size: 9,
                font: fontBold,
                color: rgb(0, 0, 0),
            });

            // Director HR Date: line
            lastPage.drawText(formattedDateForLastPage, {
                x: 95,
                y: 320.21,
                size: 9,
                font: fontBold,
                color: rgb(0, 0, 0),
            });

            if (signatureImage) {
                const sigDims = getSignatureDimensions(signatureImage, 140, 32);
                lastPage.drawImage(signatureImage, {
                    x: 160,
                    y: 500,
                    width: sigDims.width,
                    height: sigDims.height,
                });

                // Draw audit text below the signature on the last page
                lastPage.drawText(`Digitally signed by ${employeeName} on ${new Date().toLocaleString()}`, {
                    x: 70.82,
                    y: 455,
                    size: 8,
                    font,
                    color: rgb(0.3, 0.4, 0.5), // Slate-gray
                });
            }
        } else if (docType === 'Offer Letter') {
            if (isIndia) {
                const fullNameToDraw = extraDetails?.fullName || employeeName || '';
                const aadhaarToDraw = extraDetails?.aadhaarNumber || extraDetails?.aadhaar || extraDetails?.ssn || '';
                const dateToDraw = (extraDetails && typeof extraDetails.date === 'string') ? extraDetails.date : currentDate;

                // 1. Draw signature image on Signature: line (only after candidate signs)
                if (signatureImage) {
                    const lineSigDims = getSignatureDimensions(signatureImage, 120, 28);
                    lastPage.drawImage(signatureImage, {
                        x: 105,
                        y: 335,
                        width: lineSigDims.width,
                        height: lineSigDims.height,
                    });
                }

                // 2. Draw Full Name (First + Middle + Last) on Full Name (as per Identity Card / Passport): line (pre-filled)
                if (fullNameToDraw) {
                    lastPage.drawText(fullNameToDraw, {
                        x: 225,
                        y: 320,
                        size: 10,
                        font,
                        color: rgb(0, 0, 0),
                    });
                }

                // 3. Draw Aadhaar Number on Aadhaar Number: line (pre-filled)
                if (aadhaarToDraw) {
                    lastPage.drawText(aadhaarToDraw, {
                        x: 150,
                        y: 297,
                        size: 10,
                        font,
                        color: rgb(0, 0, 0),
                    });
                }

                // 4. Draw Date on Date: line (only after candidate signs)
                if (dateToDraw) {
                    lastPage.drawText(dateToDraw, {
                        x: 80,
                        y: 275,
                        size: 10,
                        font,
                        color: rgb(0, 0, 0),
                    });
                }

                // USA & India Offer Letter: Draw bottom signature + digital audit text in clean space
                if (signatureImage) {
                    const bottomSigDims = getSignatureDimensions(signatureImage, 140, 36);
                    lastPage.drawImage(signatureImage, {
                        x: 80,
                        y: 150,
                        width: bottomSigDims.width,
                        height: bottomSigDims.height,
                    });

                    lastPage.drawText(`Digitally signed by ${fullNameToDraw} on ${new Date().toLocaleString()}`, {
                        x: 80,
                        y: 136,
                        size: 8,
                        font,
                        color: rgb(0.1, 0.3, 0.6), // Slate-blue
                    });
                }
            } else {
                if (signatureImage) {
                    const bottomSigDims = getSignatureDimensions(signatureImage, 140, 36);
                    lastPage.drawImage(signatureImage, {
                        x: 80,
                        y: 150,
                        width: bottomSigDims.width,
                        height: bottomSigDims.height,
                    });

                    lastPage.drawText(`Digitally signed by ${employeeName} on ${new Date().toLocaleString()}`, {
                        x: 80,
                        y: 136,
                        size: 8,
                        font,
                        color: rgb(0.1, 0.3, 0.6), // Slate-blue
                    });
                }
            }
        } else {
            if (signatureImage) {
                lastPage.drawImage(signatureImage, {
                    x: 75,
                    y: 120,
                    width: 150,
                    height: 55,
                });

                // Draw audit text below the signature on the last page
                lastPage.drawText(`Digitally signed by ${employeeName} on ${new Date().toLocaleString()}`, {
                    x: 75,
                    y: 100,
                    size: 8,
                    font,
                    color: rgb(0.3, 0.4, 0.5), // Slate-gray
                });
            }
        }

        // Save and return base64
        const signedPdfBase64 = await pdfDoc.saveAsBase64();
        return signedPdfBase64;
    } catch (error) {
        console.error("Error signing PDF:", error);
        throw error;
    }
};

const createPoliciesPdf = async (employeeName, signatureDataUrl) => {
    const pdfDoc = await PDFDocument.create();

    let page = null;
    let height = 0;
    let y = 0;

    const startNewPage = () => {
        page = pdfDoc.addPage([600, 850]);
        height = page.getSize().height;
        y = height - 50;
    };

    startNewPage();

    // Title
    page.drawText('GENESIS TECH ENGINEERS PVT. LTD. - COMPANY POLICIES', {
        x: 50,
        y,
        size: 13,
        color: rgb(0, 0, 0)
    });
    y -= 30;

    // Subtitle
    page.drawText(`Signed Employee: ${employeeName}`, { x: 50, y, size: 10, color: rgb(0.2, 0.2, 0.2) });
    page.drawText(`Date: ${new Date().toLocaleDateString()}`, { x: 450, y, size: 10, color: rgb(0.2, 0.2, 0.2) });
    y -= 25;

    page.drawText('This document certifies acceptance of the following company policies:', {
        x: 50,
        y,
        size: 10,
        color: rgb(0.3, 0.3, 0.3)
    });
    y -= 20;

    // Loop over each policy in genesisPoliciesText
    for (const pol of genesisPoliciesText) {
        if (y < 80) startNewPage();

        // Draw Policy Title
        page.drawText(`${pol.id}. ${pol.title.toUpperCase()}`, {
            x: 50,
            y,
            size: 11,
            color: rgb(0.05, 0.2, 0.4)
        });
        y -= 18;

        // Draw description lines with word wrapping
        const textLines = pol.text.split('\n');
        for (const rawLine of textLines) {
            const maxLineWidth = 500;
            const fontSize = 8.5;

            const words = rawLine.split(' ');
            let currentLine = '';

            for (const word of words) {
                const testLine = currentLine ? `${currentLine} ${word}` : word;
                const approxWidth = testLine.length * 4.5;
                if (approxWidth > maxLineWidth) {
                    if (y < 50) startNewPage();
                    page.drawText(currentLine, { x: 55, y, size: fontSize, color: rgb(0.15, 0.15, 0.15) });
                    y -= 13;
                    currentLine = word;
                } else {
                    currentLine = testLine;
                }
            }

            if (currentLine) {
                if (y < 50) startNewPage();
                page.drawText(currentLine, { x: 55, y, size: fontSize, color: rgb(0.15, 0.15, 0.15) });
                y -= 13;
            }
        }
        y -= 10;
    }

    // Draw signature section at the end
    if (y < 150) startNewPage();
    y -= 30;
    page.drawText('EMPLOYEE SIGN-OFF & ACCEPTANCE', { x: 50, y, size: 10, color: rgb(0, 0, 0) });
    y -= 20;
    page.drawText(`I, ${employeeName}, hereby acknowledge that I have read, understood, and accept all 11 company policies detailed in this document.`, {
        x: 50,
        y,
        size: 8.5,
        color: rgb(0.2, 0.2, 0.2)
    });
    y -= 40;

    if (signatureDataUrl && signatureDataUrl.startsWith('data:image')) {
        try {
            const isJpg = signatureDataUrl.startsWith('data:image/jpeg') || signatureDataUrl.startsWith('data:image/jpg');
            const signatureBytes = base64ToUint8Array(signatureDataUrl);
            if (signatureBytes.length > 0) {
                let pngImage;
                try {
                    if (isJpg) {
                        pngImage = await pdfDoc.embedJpg(signatureBytes);
                    } else {
                        pngImage = await pdfDoc.embedPng(signatureBytes);
                    }
                } catch (embedErr) {
                    console.warn("Primary image embedding failed, attempting embedPng fallback:", embedErr);
                    pngImage = await pdfDoc.embedPng(signatureBytes);
                }

                // Scale image down to fit nicely within 160x50 signature bounds
                let sigWidth = pngImage.width;
                let sigHeight = pngImage.height;
                const maxW = 160;
                const maxH = 50;
                const scaleFactor = Math.min(maxW / sigWidth, maxH / sigHeight, 0.5);
                sigWidth = sigWidth * scaleFactor;
                sigHeight = sigHeight * scaleFactor;

                if (y - sigHeight < 50) startNewPage();
                page.drawImage(pngImage, {
                    x: 50,
                    y: y - sigHeight,
                    width: sigWidth,
                    height: sigHeight
                });
                y -= (sigHeight + 15);
                page.drawText('--------------------------------------', { x: 50, y, size: 10, color: rgb(0.4, 0.4, 0.4) });
                y -= 15;
                page.drawText(`Employee Signature: ${employeeName}`, { x: 50, y, size: 9, color: rgb(0.1, 0.1, 0.1) });
            }
        } catch (e) {
            console.error("Failed to embed signature in policies PDF:", e);
        }
    }

    const pdfBytes = await pdfDoc.save();

    // Convert binary to base64 safely
    let binary = '';
    const bytes = new Uint8Array(pdfBytes);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    const base64 = btoa(binary);
    return base64;
};

const EmployeeDashboard = ({ activeTab, setActiveTab, onStartTour, onStartVideoTour }) => {
    const [loading, setLoading] = useState(true);
    const [uploadingPhoto, setUploadingPhoto] = useState(false);
    const [data, setData] = useState(null);
    const [dashboardStats, setDashboardStats] = useState(null);
    const [toast, setToast] = useState(null);
    const [showSubmitConfirm, setShowSubmitConfirm] = useState(false);
    const [showRequestedDocsModal, setShowRequestedDocsModal] = useState(false);
    const [hasSeenRequestedDocsModal, setHasSeenRequestedDocsModal] = useState(false);
    const [requestedDocsSubmitted, setRequestedDocsSubmitted] = useState(false);
    const [submitStatus, setSubmitStatus] = useState('idle'); // 'idle', 'submitting', 'success', 'error'
    const [submitErrorMessage, setSubmitErrorMessage] = useState('');
    const [offerLetterBlobUrl, setOfferLetterBlobUrl] = useState('');
    const [employeeAgreementBlobUrl, setEmployeeAgreementBlobUrl] = useState('');
    const [selectedAgreementKey, setSelectedAgreementKey] = useState('');
    const [agreementBlobUrls, setAgreementBlobUrls] = useState({});

    // Forms state
    const [personalForm, setPersonalForm] = useState({
        first_name: '', middle_name: '', last_name: '', preferred_name: '', dob: '', gender: '', pronouns: '',
        marital_status: '', citizenship: '', phone: '', personal_email: '', address: '',
        city: '', state: '', zip: '', country: ''
    });

    const [emergencyContacts, setEmergencyContacts] = useState([]);
    const [bankForm, setBankForm] = useState({ bank_name: '', routing_number: '', account_number: '', account_type: 'CHECKING', bank_branch_address: '' });
    const [taxForm, setTaxForm] = useState({
        federal_tax_status: 'SINGLE',
        federal_allowances: 0,
        state_tax_status: 'SINGLE',
        state_allowances: 0,
        name: '',
        ssn: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        arizona_box_selection: 1,
        arizona_percentage: 2.0,
        arizona_extra_amount_checked: false,
        arizona_extra_amount: '',
        signature: ''
    });
    const [expandedPolicyId, setExpandedPolicyId] = useState(null);
    const [selectedPolicyId, setSelectedPolicyId] = useState(1);
    const [viewedPolicyIds, setViewedPolicyIds] = useState([1]);

    // US Form I-9 States
    const [i9Attestation, setI9Attestation] = useState('US_Citizen');
    const [uscisNumber, setUscisNumber] = useState('');
    const [i9Method, setI9Method] = useState('list_a');
    const [listADocType, setListADocType] = useState('Passport');
    const [listBDocType, setListBDocType] = useState('Driver License');
    const [listCDocType, setListCDocType] = useState('Social Security Card');
    const [selectedState, setSelectedState] = useState('');
    const [selectedIdOption, setSelectedIdOption] = useState('');
    const [agreementTemplateBytes, setAgreementTemplateBytes] = useState(null);
    const [indiaAgreementTemplateBytes, setIndiaAgreementTemplateBytes] = useState(null);
    const [ndaTemplateBytes, setNdaTemplateBytes] = useState(null);
    const [conflictTemplateBytes, setConflictTemplateBytes] = useState(null);
    const [benefitsTemplateBytes, setBenefitsTemplateBytes] = useState(null);
    const [nonSolicitationTemplateBytes, setNonSolicitationTemplateBytes] = useState(null);
    const [employmentForm, setEmploymentForm] = useState({
        employeeName: '',
        position: '',
        department: '',
        primaryLocation: '',
        employmentClassification: '',
        effectiveDate: new Date().toLocaleDateString('en-US'),
        outsideEmploymentType: 'none',
        outsideEmployer: '',
        outsideNature: '',
        outsideHours: '',
        ownershipType: 'no',
        ownershipDescribe: '',
        competingType: 'no',
        competingDescribe: '',
        otherConflicts: '',
        employeeId: '',
        hireDate: '',
        medicalElection: 'enrol',
        medicalWaiveReason: 'spouse_plan',
        medicalWaiveReasonOther: '',
        dentalElection: 'enrol',
        visionElection: 'enrol',
        retirementElection: 'participate',
        retirementContributionType: 'percentage',
        retirementContributionPercent: '',
        retirementContributionAmount: '',
        primaryBeneName: '',
        primaryBeneRelationship: '',
        primaryBeneDob: '',
        primaryBenePercent: '',
        contingentBeneName: '',
        contingentBeneRelationship: '',
        contingentBeneDob: '',
        contingentBenePercent: ''
    });

    const fetchOnboardingData = useCallback(async () => {
        try {
            const res = await api.get('/onboarding');
            setData(res.data);

            // Bind states
            if (res.data.profile) {
                setPersonalForm(prev => ({
                    first_name: prev.first_name || res.data.profile.first_name || res.data.employee?.FirstName || '',
                    middle_name: prev.middle_name || res.data.profile.middle_name || '',
                    last_name: prev.last_name || res.data.profile.last_name || res.data.employee?.LastName || '',
                    preferred_name: prev.preferred_name || res.data.profile.preferred_name || '',
                    dob: prev.dob || res.data.profile.dob || '',
                    gender: prev.gender || res.data.profile.gender || '',
                    pronouns: prev.pronouns || res.data.profile.pronouns || '',
                    marital_status: prev.marital_status || res.data.profile.marital_status || '',
                    citizenship: prev.citizenship || res.data.profile.citizenship || '',
                    ssn: prev.ssn || res.data.profile.ssn || '',
                    phone: prev.phone || res.data.profile.phone || '',
                    personal_email: prev.personal_email || res.data.profile.personal_email || '',
                    address: prev.address || res.data.profile.address || '',
                    city: prev.city || res.data.profile.city || '',
                    state: prev.state || res.data.profile.state || '',
                    zip: prev.zip || res.data.profile.zip || '',
                    country: prev.country || res.data.profile.country || ''
                }));

                // Initialize I-9 attestation options if saved
                if (res.data.profile.citizenship) {
                    if (res.data.profile.citizenship.includes('US_National')) {
                        setI9Attestation('US_National');
                    } else if (res.data.profile.citizenship.includes('LPR')) {
                        setI9Attestation('LPR');
                        const match = res.data.profile.citizenship.match(/\(([^)]+)\)/);
                        if (match) setUscisNumber(match[1]);
                    } else if (res.data.profile.citizenship.includes('Authorized_Alien')) {
                        setI9Attestation('Authorized_Alien');
                        const match = res.data.profile.citizenship.match(/\(([^)]+)\)/);
                        if (match) setUscisNumber(match[1]);
                    } else {
                        setI9Attestation('US_Citizen');
                    }
                }
            } else {
                setPersonalForm(prev => ({
                    ...prev,
                    first_name: prev.first_name || res.data.employee?.FirstName || '',
                    last_name: prev.last_name || res.data.employee?.LastName || ''
                }));
            }

            if (res.data.contacts && res.data.contacts.length > 0) setEmergencyContacts(res.data.contacts);
            if (res.data.bank) {
                const isIndiaCandidate = ((res.data.employee?.country || res.data.profile?.country || '').toUpperCase()) === 'INDIA';
                setBankForm(prev => ({
                    bank_name: prev.bank_name || res.data.bank.bank_name || '',
                    routing_number: prev.routing_number || res.data.bank.routing_number || '',
                    account_number: prev.account_number || res.data.bank.account_number || '',
                    account_type: (prev.account_type && prev.account_type !== 'CHECKING') ? prev.account_type : ((isIndiaCandidate && (!res.data.bank.account_type || res.data.bank.account_type === 'CHECKING')) ? 'SAVINGS' : (res.data.bank.account_type || 'CHECKING')),
                    bank_branch_address: prev.bank_branch_address || res.data.bank.bank_branch_address || ''
                }));
            }
            if (res.data.tax) {
                let sigPath = res.data.tax.signature_path || '';
                if (sigPath && sigPath.startsWith('uploads/')) {
                    try {
                        const imgRes = await api.get('/onboarding/tax-signature', { responseType: 'arraybuffer' });
                        const base64 = btoa(
                            new Uint8Array(imgRes.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                        );
                        sigPath = `data:image/png;base64,${base64}`;
                    } catch (e) {
                        console.error('Failed to load saved signature image:', e);
                        let errMsg = e.message;
                        if (e.response?.data instanceof ArrayBuffer) {
                            try {
                                const decoded = new TextDecoder('utf-8').decode(e.response.data);
                                const parsed = JSON.parse(decoded);
                                if (parsed.error) errMsg = parsed.error;
                            } catch (parseErr) { }
                        }
                        setToast({ message: 'Signature load error: ' + errMsg, type: 'error' });
                    }
                } else if (sigPath && sigPath.startsWith('typed:')) {
                    sigPath = sigPath.substring(6);
                }

                setTaxForm({
                    federal_tax_status: res.data.tax.federal_tax_status || 'SINGLE',
                    federal_allowances: res.data.tax.federal_allowances || 0,
                    state_tax_status: res.data.tax.state_tax_status || 'SINGLE',
                    state_allowances: res.data.tax.state_allowances || 0,
                    name: res.data.tax.name || (res.data.profile ? `${res.data.profile.first_name || ''} ${res.data.profile.last_name || ''}`.trim() : ''),
                    ssn: res.data.tax.ssn || res.data.profile?.ssn || '',
                    address: res.data.tax.address || res.data.profile?.address || '',
                    city: res.data.tax.city || res.data.profile?.city || '',
                    state: res.data.tax.state || res.data.profile?.state || '',
                    zip: res.data.tax.zip || res.data.profile?.zip || '',
                    arizona_box_selection: res.data.tax.arizona_box_selection !== null && res.data.tax.arizona_box_selection !== undefined ? parseInt(res.data.tax.arizona_box_selection) : 1,
                    arizona_percentage: res.data.tax.arizona_percentage !== null && res.data.tax.arizona_percentage !== undefined ? parseFloat(res.data.tax.arizona_percentage) : 2.0,
                    arizona_extra_amount_checked: !!parseInt(res.data.tax.arizona_extra_amount_checked || 0),
                    arizona_extra_amount: res.data.tax.arizona_extra_amount !== null && res.data.tax.arizona_extra_amount !== undefined ? res.data.tax.arizona_extra_amount.toString() : '',
                    signature: sigPath
                });
            } else {
                setTaxForm(prev => ({
                    ...prev,
                    name: res.data.profile ? `${res.data.profile.first_name || ''} ${res.data.profile.last_name || ''}`.trim() : '',
                    ssn: res.data.profile?.ssn || '',
                    address: res.data.profile?.address || '',
                    city: res.data.profile?.city || '',
                    state: res.data.profile?.state || '',
                    zip: res.data.profile?.zip || '',
                }));
            }

            // Fetch dashboard metrics
            const statsRes = await api.get('/dashboard/employee');
            setDashboardStats(statsRes.data);

            // Convert base64 fields to Blob URLs to avoid data URI issues in iframes
            if (res.data.employee) {
                setEmploymentForm(prev => ({
                    employeeName: prev.employeeName || `${res.data.employee.FirstName || ''} ${res.data.employee.LastName || ''}`.trim(),
                    position: prev.position || res.data.employee.Designation || res.data.employee.position || '',
                    department: prev.department || res.data.employee.Department || res.data.employee.department || '',
                    primaryLocation: '',
                    employmentClassification: '',
                    effectiveDate: prev.effectiveDate || new Date().toLocaleDateString('en-US'),
                    outsideEmploymentType: prev.outsideEmploymentType || 'none',
                    outsideEmployer: prev.outsideEmployer || '',
                    outsideNature: prev.outsideNature || '',
                    outsideHours: prev.outsideHours || '',
                    ownershipType: prev.ownershipType || 'no',
                    ownershipDescribe: prev.ownershipDescribe || '',
                    competingType: prev.competingType || 'no',
                    competingDescribe: prev.competingDescribe || '',
                    otherConflicts: prev.otherConflicts || '',
                    employeeId: prev.employeeId || res.data.employee.id || '',
                    hireDate: res.data.employee.joining_date || res.data.employee.JoiningDate || res.data.employee.joining_Date || res.data.employee.joiningDate || res.data.employee.joining || res.data.employee.hire_date || res.data.employee.HireDate || prev.hireDate || '',
                    medicalElection: prev.medicalElection || 'enrol',
                    medicalWaiveReason: prev.medicalWaiveReason || 'spouse_plan',
                    medicalWaiveReasonOther: prev.medicalWaiveReasonOther || '',
                    dentalElection: prev.dentalElection || 'enrol',
                    visionElection: prev.visionElection || 'enrol',
                    retirementElection: prev.retirementElection || 'participate',
                    retirementContributionType: prev.retirementContributionType || 'percentage',
                    retirementContributionPercent: prev.retirementContributionPercent || '',
                    retirementContributionAmount: prev.retirementContributionAmount || '',
                    primaryBeneName: prev.primaryBeneName || '',
                    primaryBeneRelationship: prev.primaryBeneRelationship || '',
                    primaryBeneDob: prev.primaryBeneDob || '',
                    primaryBenePercent: prev.primaryBenePercent || '',
                    contingentBeneName: prev.contingentBeneName || '',
                    contingentBeneRelationship: prev.contingentBeneRelationship || '',
                    contingentBeneDob: prev.contingentBeneDob || '',
                    contingentBenePercent: prev.contingentBenePercent || ''
                }));
                // Offer Letter
                const isOfferSigned = res.data.signature_history?.some(
                    h => h.document_type === 'Offer Letter' && h.action === 'SIGN'
                );
                const signedOfferBase64 = res.data.signed_agreements?.['Offer Letter'];
                const rawPath = res.data.employee?.offer_letter || res.data.employee?.offer_letter_path;
                let realOfferUrl = '';
                if (rawPath) {
                    let cleanPath = rawPath.replace(/^\//, '');
                    if (!cleanPath.startsWith('http://') && !cleanPath.startsWith('https://')) {
                        cleanPath = cleanPath.startsWith('offer_letters/')
                            ? `https://hiring.gtelinq.com/hiring-backend/${cleanPath}`
                            : `/EOP_api/${cleanPath}`;
                    }
                    realOfferUrl = cleanPath;
                }

                const fName = personalForm.first_name || res.data.profile?.first_name || res.data.employee?.FirstName || res.data.employee?.first_name || '';
                const mName = personalForm.middle_name || res.data.profile?.middle_name || res.data.employee?.MiddleName || res.data.employee?.middle_name || '';
                const lName = personalForm.last_name || res.data.profile?.last_name || res.data.employee?.LastName || res.data.employee?.last_name || '';
                const fullName = [fName, mName, lName].filter(Boolean).join(' ').trim() || 'Employee';
                const aadhaarNumber = personalForm.ssn || res.data.profile?.ssn || res.data.employee?.ssn || res.data.employee?.AadhaarNumber || res.data.employee?.aadhaar_number || '';
                const isIndiaCandidate = ((res.data.employee?.country || res.data.profile?.country || '').toUpperCase()) === 'INDIA';

                let offerUrlToSet = '';
                if (isOfferSigned) {
                    if (signedOfferBase64) {
                        offerUrlToSet = base64ToBlobUrl(signedOfferBase64);
                    } else {
                        const sigObj = res.data.signature_history?.find(h => h.document_type === 'Offer Letter' && h.action === 'SIGN');
                        const sigData = sigObj?.signature_path || '';
                        let sigPng = sigData;
                        if (sigData && !sigData.startsWith('data:image')) {
                            sigPng = convertTypedToPng(sigData);
                        }
                        const signedDate = sigObj?.signed_at || sigObj?.created_at;
                        const formattedDate = formatDateMMDDYYYY(signedDate);

                        let baseToSign = res.data.employee?.offer_letter_base64 || '';
                        if (!baseToSign && realOfferUrl) {
                            try {
                                baseToSign = await fetchLocalPdfAsBase64(realOfferUrl);
                            } catch (e) {
                                console.error("Failed to fetch real offer letter PDF for overlay:", e);
                            }
                        }

                        if (baseToSign && (sigPng || isIndiaCandidate)) {
                            try {
                                const signedPdfBase64 = await applySignatureToPdf(baseToSign, sigPng, fullName, 'Offer Letter', isIndiaCandidate, {
                                    fullName,
                                    aadhaarNumber,
                                    date: formattedDate
                                });
                                offerUrlToSet = base64ToBlobUrl(signedPdfBase64);
                            } catch (err) {
                                console.error("Failed to generate signed PDF:", err);
                                offerUrlToSet = realOfferUrl;
                            }
                        } else {
                            offerUrlToSet = realOfferUrl;
                        }
                    }
                } else {
                    // Pre-sign preview: For India candidates, pre-fill Full Name and Aadhaar Number on the PDF template
                    let baseToSign = res.data.employee?.offer_letter_base64 || '';
                    if (!baseToSign && realOfferUrl) {
                        try {
                            baseToSign = await fetchLocalPdfAsBase64(realOfferUrl);
                        } catch (e) {
                            console.error("Failed to fetch real offer letter PDF for preview:", e);
                        }
                    }

                    if (baseToSign && isIndiaCandidate) {
                        try {
                            const prefilledPdfBase64 = await applySignatureToPdf(baseToSign, null, fullName, 'Offer Letter', true, {
                                fullName,
                                aadhaarNumber,
                                date: ''
                            });
                            offerUrlToSet = base64ToBlobUrl(prefilledPdfBase64);
                        } catch (err) {
                            console.error("Failed to generate pre-filled offer letter preview:", err);
                            offerUrlToSet = realOfferUrl;
                        }
                    } else if (res.data.employee?.offer_letter_base64) {
                        offerUrlToSet = base64ToBlobUrl(res.data.employee.offer_letter_base64);
                    } else if (realOfferUrl) {
                        offerUrlToSet = realOfferUrl;
                    }
                }

                setOfferLetterBlobUrl(prev => {
                    if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
                    return offerUrlToSet;
                });

                // Employee Agreement
                const isAgreementSigned = res.data.signature_history?.some(
                    h => h.document_type === 'Employee Agreement' && h.action === 'SIGN'
                );
                if (isAgreementSigned && res.data.employee.employee_agreement_base64) {
                    const agreementUrl = base64ToBlobUrl(res.data.employee.employee_agreement_base64);
                    setEmployeeAgreementBlobUrl(prev => {
                        if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
                        return agreementUrl;
                    });
                } else {
                    // Unsigned fallback: load appropriate template directly from public folder based on country
                    const country = res.data.employee?.country || '';
                    const templatePath = country.toUpperCase() === 'USA' ? '/employee_agreement_usa.pdf' : '/3-Employment Agreement.pdf';
                    setEmployeeAgreementBlobUrl(prev => {
                        if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
                        return templatePath;
                    });
                }

                // Multiple agreements resolution for US candidates
                const country = res.data.employee?.country || '';
                const isUsa = country.toUpperCase() === 'USA';
                const list = isUsa ? [
                    { key: 'employment_agreement', title: 'Employment Agreement 1', displayName: 'Employment Agreement', path: '/Employment Agreement 1.pdf' },
                    { key: 'confidentiality_nda', title: 'Employee Confidentiality & NDA (1)', displayName: 'Employee Confidentiality & NDA', path: '/Employee Confidentiality & NDA (1).pdf' },
                    { key: 'conflict_of_interest', title: 'Conflict of interest agreement', path: '/Conflict of interest agreement.pdf' },
                    { key: '401k_dental_vision_medical', title: '401K Dental Vision Medical', path: '/401K Dental Vision Medical.pdf' },
                    { key: 'non_solicitation', title: 'Non Solicitation', path: '/Non Solicitation.pdf' }
                ] : [
                    { key: 'employee_agreement', title: 'Employee Agreement', path: '/3-Employment Agreement.pdf' }
                ];

                const urls = {};
                for (const item of list) {
                    const signedBase64 = res.data.signed_agreements?.[item.title];
                    const legacyBase64 = (item.title === 'Employee Agreement' && isAgreementSigned && res.data.employee?.employee_agreement_base64) ? res.data.employee.employee_agreement_base64 : null;
                    const base64Data = signedBase64 || legacyBase64;
                    if (base64Data) {
                        urls[item.key] = base64ToBlobUrl(base64Data);
                    } else if (item.key === 'employee_agreement') {
                        try {
                            let tBytes = indiaAgreementTemplateBytes;
                            if (!tBytes) {
                                const resp = await fetch('/3-Employment Agreement.pdf');
                                const ab = await resp.arrayBuffer();
                                tBytes = new Uint8Array(ab);
                                setIndiaAgreementTemplateBytes(tBytes);
                            }
                            let binary = '';
                            const len = tBytes.byteLength;
                            for (let i = 0; i < len; i++) {
                                binary += String.fromCharCode(tBytes[i]);
                            }
                            const templateBase64 = btoa(binary);
                            const emp = res.data.employee || {};
                            const jDateStr = emp.joining_date || emp.JoiningDate || emp.joining_Date || emp.joiningDate || emp.joining || emp.hire_date || emp.HireDate || '2025-11-21';
                            const fName = [
                                res.data.profile?.first_name || emp.FirstName || emp.first_name || '',
                                res.data.profile?.middle_name || emp.MiddleName || emp.middle_name || '',
                                res.data.profile?.last_name || emp.LastName || emp.last_name || ''
                            ].filter(Boolean).join(' ').trim() || 'Employee';

                            const prefilledBase64 = await applySignatureToPdf(
                                templateBase64,
                                null,
                                fName,
                                'Employee Agreement',
                                true,
                                {
                                    joiningDate: jDateStr,
                                    date: formatDateMMDDYYYY()
                                }
                            );
                            urls[item.key] = base64ToBlobUrl(prefilledBase64);
                        } catch (prefilledErr) {
                            console.error("Failed to generate prefilled agreement Blob URL in fetchOnboardingData:", prefilledErr);
                            urls[item.key] = item.path;
                        }
                    } else {
                        urls[item.key] = item.path;
                    }
                }
                setAgreementBlobUrls(prev => {
                    Object.entries(prev).forEach(([key, url]) => {
                        if (url && url.startsWith('blob:') && url !== urls[key]) {
                            URL.revokeObjectURL(url);
                        }
                    });
                    return urls;
                });
                setSelectedAgreementKey(prev => {
                    const keys = list.map(item => item.key);
                    if (prev && keys.includes(prev)) return prev;
                    return keys[0] || '';
                });
            }

            // Automatically select state in dropdown if a state tax form is already uploaded
            if (res.data.documents) {
                const existing = res.data.documents.find(doc =>
                    doc.document_type === 'Oregon State Tax Form' ||
                    doc.document_type === 'Arizona State Tax Form' ||
                    doc.document_type === 'Colorado State Tax Form'
                );
                if (existing) {
                    if (existing.document_type === 'Oregon State Tax Form') setSelectedState('oregon');
                    else if (existing.document_type === 'Arizona State Tax Form') setSelectedState('arizona');
                    else if (existing.document_type === 'Colorado State Tax Form') setSelectedState('colorado');
                }
            }

            // Check for pending requested documents to show popup alert
            const reqList = res.data?.requested_documents || res.data?.requested_employee_documents || [];
            const pendingReqs = reqList.filter(req => {
                const rStatus = (req.status || '').toUpperCase();
                const rName = (req.document_name || req.document_type || req.title || req.name || '').trim();
                const isUploadedInEmpDocs = res.data?.documents?.some(d => d.document_type === rName);
                return rStatus !== 'UPLOADED' && !isUploadedInEmpDocs;
            });

            if (pendingReqs.length > 0 && !hasSeenRequestedDocsModal) {
                setShowRequestedDocsModal(true);
            }
            window.dispatchEvent(new Event('onboarding_updated'));
        } catch (err) {
            setToast({ message: 'Failed to load onboarding profile details.', type: 'error' });
        } finally {
            setLoading(false);
        }
    }, [hasSeenRequestedDocsModal]);

    useEffect(() => {
        fetchOnboardingData();
    }, [fetchOnboardingData]);

    // Cleanup Blob URLs on unmount
    useEffect(() => {
        return () => {
            setOfferLetterBlobUrl(prev => {
                if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
                return '';
            });
            setEmployeeAgreementBlobUrl(prev => {
                if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
                return '';
            });
            setAgreementBlobUrls(prev => {
                Object.values(prev).forEach(url => {
                    if (url && url.startsWith('blob:')) URL.revokeObjectURL(url);
                });
                return {};
            });
        };
    }, []);

    const isLocked = dashboardStats?.status === 'PENDING_HR_REVIEW' || dashboardStats?.status === 'COMPLETED';

    // Save Personal Info (with SSN & I-9 validation)
    const handleSavePersonal = async (e) => {
        e.preventDefault();
        if (isLocked) return;
        try {
            await api.post('/onboarding/personal', personalForm);
            setToast({ message: 'Personal Information saved successfully!', type: 'success' });
            window.dispatchEvent(new Event('onboarding_updated'));
            fetchOnboardingData();
        } catch (err) {
            setToast({ message: err.response?.data?.error || 'Failed to save personal info.', type: 'error' });
        }
    };

    const handleSaveI9Attestation = async () => {
        if (isLocked) return;
        try {
            const citizenVal = `${i9Attestation}${uscisNumber ? ' (' + uscisNumber + ')' : ''}`;
            await api.post('/onboarding/personal', {
                ...personalForm,
                citizenship: citizenVal
            });
            setToast({ message: 'Form I-9 Eligibility attestation recorded successfully!', type: 'success' });
            window.dispatchEvent(new Event('onboarding_updated'));
            fetchOnboardingData();
        } catch (err) {
            setToast({ message: 'Failed to save Form I-9 attestation.', type: 'error' });
        }
    };

    // Save Emergency Contacts
    const handleSaveContacts = async (e) => {
        e.preventDefault();
        if (isLocked) return;
        try {
            await api.post('/onboarding/contacts', emergencyContacts);
            setToast({ message: 'Emergency Contacts saved successfully!', type: 'success' });
            window.dispatchEvent(new Event('onboarding_updated'));
            fetchOnboardingData();
        } catch (err) {
            setToast({ message: err.response?.data?.error || 'Failed to save emergency contacts.', type: 'error' });
        }
    };

    const handleAddContact = () => {
        if (isLocked) return;
        setEmergencyContacts([...emergencyContacts, { name: '', relationship: '', phone: '', email: '', address: '' }]);
    };

    const handleRemoveContact = (index) => {
        if (isLocked) return;
        const updated = emergencyContacts.filter((_, idx) => idx !== index);
        setEmergencyContacts(updated);
    };

    const handleContactChange = (index, field, value) => {
        if (isLocked) return;
        const updated = emergencyContacts.map((c, idx) => {
            if (idx === index) return { ...c, [field]: value };
            return c;
        });
        setEmergencyContacts(updated);
    };

    // Save Bank Info
    const handleSaveBank = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (isLocked) return;
        if (!bankForm.bank_name || !bankForm.routing_number || !bankForm.account_number || !bankForm.bank_branch_address) {
            setToast({ message: 'Please fill in all required bank detail fields.', type: 'error' });
            return;
        }
        const hasVoidCheque = data?.documents?.some(doc => doc.document_type === 'Void Cheque' && doc.file_path && doc.file_path !== 'NOT_AVAILABLE');
        if (!hasVoidCheque) {
            setToast({ message: 'Please upload Cancelled Cheque / Bank Account Proof.', type: 'error' });
            return;
        }
        try {
            await api.post('/onboarding/bank', bankForm);
            setToast({ message: 'Bank Details saved successfully!', type: 'success' });
            window.dispatchEvent(new Event('onboarding_updated'));
            fetchOnboardingData();
        } catch (err) {
            setToast({ message: err.response?.data?.error || 'Failed to save bank setup.', type: 'error' });
        }
    };

    // PDF state variables
    const [templateBytes, setTemplateBytes] = useState(null);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState('');
    const [pdfBase64, setPdfBase64] = useState('');

    // Load Arizona A-4 template once when activeTab is 'tax'
    useEffect(() => {
        if (activeTab === 'tax' && !templateBytes) {
            const loadTemplate = async () => {
                try {
                    const res = await api.get('/onboarding/tax-template', { responseType: 'arraybuffer' });
                    setTemplateBytes(res.data);
                } catch (err) {
                    console.error('Failed to load PDF template:', err);
                }
            };
            loadTemplate();
        }
    }, [activeTab, templateBytes]);

    const generatePdfPreview = useCallback(async (formValues) => {
        if (!templateBytes) return;
        try {
            const pdfDoc = await PDFDocument.load(templateBytes);
            const form = pdfDoc.getForm();
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];

            // Fill text fields
            const setFieldText = (name, val) => {
                try {
                    const field = form.getTextField(name);
                    let textVal = val || '';
                    try {
                        const maxLen = field.getMaxLength();
                        if (maxLen && textVal.length > maxLen) {
                            textVal = textVal.substring(0, maxLen);
                        }
                    } catch (e) { }
                    field.setText(textVal);
                } catch (e) {
                    console.warn(`Could not set text field ${name}:`, e);
                }
            };

            setFieldText('Name', formValues.name);
            setFieldText('SSN', formValues.ssn);
            setFieldText('Address', formValues.address);
            setFieldText('City', formValues.city);
            setFieldText('State', formValues.state);
            setFieldText('Zip', formValues.zip);

            // Embed ZapfDingbats for drawing checkmark symbols
            const dingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);
            const drawTick = (x, y) => {
                try {
                    firstPage.drawText('\u2714', {
                        x: x + 1,
                        y: y + 1,
                        size: 9.5,
                        font: dingbatsFont,
                        color: rgb(0, 0, 0)
                    });
                } catch (e) {
                    console.error('Failed to draw checkmark:', e);
                }
            };

            // We explicitly uncheck all interactive fields so PDF viewers do not overlay a cross (X)
            const clearCheckbox = (name) => {
                try {
                    form.getCheckBox(name).uncheck();
                } catch (e) { }
            };

            ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'j', 'chkExtraWH'].forEach(clearCheckbox);

            if (formValues.arizona_box_selection === 1) {
                drawTick(35.6678, 585.824); // a (Line 1 check)
                const rate = formValues.arizona_percentage;
                if (rate === 0.5) drawTick(64.4593, 573.772); // b
                else if (rate === 1.0) drawTick(136.469, 573.865); // c
                else if (rate === 1.5) drawTick(208.415, 573.865); // d
                else if (rate === 2.0) drawTick(280.506, 573.865); // e
                else if (rate === 2.5) drawTick(351.469, 573.865); // f
                else if (rate === 3.0) drawTick(423.415, 573.865); // g
                else if (rate === 3.5) drawTick(495.524, 573.865); // h
            } else if (formValues.arizona_box_selection === 2) {
                drawTick(35.6678, 525.79); // j (Line 2 check)
            }

            if (formValues.arizona_extra_amount_checked) {
                drawTick(63.1453, 549.593); // chkExtraWH
                const amt = parseFloat(formValues.arizona_extra_amount) || 0.0;
                const dollarsStr = Math.floor(amt).toString();
                const centsVal = Math.round((amt % 1) * 100);
                const centsStr = centsVal < 10 ? '0' + centsVal : centsVal.toString();
                setFieldText('i', dollarsStr);
                setFieldText('i1', centsStr);
            } else {
                setFieldText('i', '');
                setFieldText('i1', '');
            }

            if (formValues.signature) {
                let sigUrl = formValues.signature;
                if (!sigUrl.startsWith('data:image')) {
                    sigUrl = convertTypedToPng(sigUrl);
                }

                try {
                    const sigImage = await pdfDoc.embedPng(sigUrl);
                    firstPage.drawImage(sigImage, {
                        x: 40,
                        y: 450,
                        width: 180,
                        height: 30
                    });

                    const dateFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
                    const dateStr = new Date().toLocaleDateString('en-US');
                    firstPage.drawText(dateStr, {
                        x: 435,
                        y: 455,
                        size: 10,
                        font: dateFont,
                        color: rgb(0, 0, 0)
                    });
                } catch (sigErr) {
                    console.error('Error embedding signature into PDF:', sigErr);
                }
            }

            const pdfBytes = await pdfDoc.save();
            const binaryString = new Uint8Array(pdfBytes).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ''
            );
            const base64Str = btoa(binaryString);
            setPdfBase64(base64Str);
            const blob = new Blob([pdfBytes], { type: 'application/pdf' });
            const newUrl = URL.createObjectURL(blob);

            setPdfPreviewUrl(prevUrl => {
                if (prevUrl) URL.revokeObjectURL(prevUrl);
                return newUrl;
            });
        } catch (err) {
            console.error('Error generating PDF preview:', err);
        }
    }, [templateBytes]);

    // Debounced PDF preview generation
    useEffect(() => {
        if (!templateBytes) return;
        const timer = setTimeout(() => {
            generatePdfPreview(taxForm);
        }, 250);
        return () => clearTimeout(timer);
    }, [taxForm, templateBytes, generatePdfPreview]);

    // Revoke Blob URL on unmount
    useEffect(() => {
        return () => {
            setPdfPreviewUrl(prevUrl => {
                if (prevUrl) URL.revokeObjectURL(prevUrl);
                return '';
            });
        };
    }, []);

    // Load Employment Agreement 1 template once when activeTab is 'agreement' and selectedAgreementKey is 'employment_agreement'
    useEffect(() => {
        if (activeTab === 'agreement' && selectedAgreementKey === 'employment_agreement' && !agreementTemplateBytes) {
            const loadTemplate = async () => {
                try {
                    const response = await fetch('/Employment Agreement 1.pdf');
                    const arrayBuffer = await response.arrayBuffer();
                    setAgreementTemplateBytes(new Uint8Array(arrayBuffer));
                } catch (e) {
                    console.error("Failed to load agreement template:", e);
                }
            };
            loadTemplate();
        }
    }, [activeTab, selectedAgreementKey, agreementTemplateBytes]);

    // Load India Employment Agreement template once when needed
    useEffect(() => {
        if (!indiaAgreementTemplateBytes) {
            const loadTemplate = async () => {
                try {
                    const response = await fetch('/3-Employment Agreement.pdf');
                    const arrayBuffer = await response.arrayBuffer();
                    setIndiaAgreementTemplateBytes(new Uint8Array(arrayBuffer));
                } catch (e) {
                    console.error("Failed to load India agreement template:", e);
                }
            };
            loadTemplate();
        }
    }, [indiaAgreementTemplateBytes]);

    // Debounced PDF preview generation for India Employment Agreement
    useEffect(() => {
        if (selectedAgreementKey === 'employee_agreement' && indiaAgreementTemplateBytes && data?.employee) {
            if (data?.signature_history?.some(h => h.document_type === 'Employee Agreement' && h.action === 'SIGN')) {
                return;
            }
            const timer = setTimeout(async () => {
                try {
                    const emp = data.employee;
                    const fullName = `${emp.FirstName || ''} ${emp.LastName || ''}`.trim() || 'Employee';
                    // Convert template bytes to binary base64
                    let binary = '';
                    const len = indiaAgreementTemplateBytes.byteLength;
                    for (let i = 0; i < len; i++) {
                        binary += String.fromCharCode(indiaAgreementTemplateBytes[i]);
                    }
                    const templateBase64 = btoa(binary);

                    // Generate pre-sign PDF with Name, Date, and dynamic joining date on Page 1
                    const joiningDateStr = emp.joining_date || emp.JoiningDate || emp.joining_Date || emp.joiningDate || emp.joining || emp.hire_date || emp.HireDate || employmentForm.hireDate;
                    const base64 = await applySignatureToPdf(
                        templateBase64,
                        null, // no signature yet
                        fullName,
                        'Employee Agreement',
                        true,
                        {
                            joiningDate: joiningDateStr,
                            date: formatDateMMDDYYYY()
                        }
                    );
                    const pdfBytes = base64ToUint8Array(base64);
                    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
                    const newUrl = URL.createObjectURL(blob);

                    setAgreementBlobUrls(prev => {
                        const oldUrl = prev['employee_agreement'];
                        if (oldUrl && oldUrl.startsWith('blob:')) {
                            URL.revokeObjectURL(oldUrl);
                        }
                        return {
                            ...prev,
                            'employee_agreement': newUrl
                        };
                    });
                } catch (err) {
                    console.error("Failed to generate India agreement preview:", err);
                }
            }, 250);
            return () => clearTimeout(timer);
        }
    }, [indiaAgreementTemplateBytes, selectedAgreementKey, data, employmentForm.hireDate]);

    // Debounced PDF preview generation for Employment Agreement 1
    useEffect(() => {
        if (activeTab === 'agreement' && selectedAgreementKey === 'employment_agreement' && agreementTemplateBytes) {
            if (data?.signature_history?.some(h => (h.document_type === 'Employment Agreement 1' || h.document_type === 'Employment Agreement') && h.action === 'SIGN')) {
                return;
            }
            const timer = setTimeout(async () => {
                const base64 = await generateAgreementPdfData(agreementTemplateBytes, employmentForm, null);
                const pdfBytes = base64ToUint8Array(base64);
                const blob = new Blob([pdfBytes], { type: 'application/pdf' });
                const newUrl = URL.createObjectURL(blob);

                setAgreementBlobUrls(prev => {
                    const oldUrl = prev['employment_agreement'];
                    if (oldUrl && oldUrl.startsWith('blob:')) {
                        URL.revokeObjectURL(oldUrl);
                    }
                    return {
                        ...prev,
                        'employment_agreement': newUrl
                    };
                });
            }, 250);
            return () => clearTimeout(timer);
        }
    }, [employmentForm, agreementTemplateBytes, activeTab, selectedAgreementKey, data]);

    // Load NDA template once when activeTab is 'agreement' and selectedAgreementKey is 'confidentiality_nda'
    useEffect(() => {
        if (activeTab === 'agreement' && selectedAgreementKey === 'confidentiality_nda' && !ndaTemplateBytes) {
            const loadTemplate = async () => {
                try {
                    const response = await fetch('/Employee Confidentiality & NDA (1).pdf');
                    const arrayBuffer = await response.arrayBuffer();
                    setNdaTemplateBytes(new Uint8Array(arrayBuffer));
                } catch (e) {
                    console.error("Failed to load NDA template:", e);
                }
            };
            loadTemplate();
        }
    }, [activeTab, selectedAgreementKey, ndaTemplateBytes]);

    // Debounced PDF preview generation for Confidentiality & NDA
    useEffect(() => {
        if (activeTab === 'agreement' && selectedAgreementKey === 'confidentiality_nda' && ndaTemplateBytes) {
            if (data?.signature_history?.some(h => (h.document_type === 'Employee Confidentiality & NDA (1)' || h.document_type === 'Employee Confidentiality & NDA') && h.action === 'SIGN')) {
                return;
            }
            const timer = setTimeout(async () => {
                const base64 = await generateNdaPdfData(ndaTemplateBytes, employmentForm, null);
                const pdfBytes = base64ToUint8Array(base64);
                const blob = new Blob([pdfBytes], { type: 'application/pdf' });
                const newUrl = URL.createObjectURL(blob);

                setAgreementBlobUrls(prev => {
                    const oldUrl = prev['confidentiality_nda'];
                    if (oldUrl && oldUrl.startsWith('blob:')) {
                        URL.revokeObjectURL(oldUrl);
                    }
                    return {
                        ...prev,
                        'confidentiality_nda': newUrl
                    };
                });
            }, 250);
            return () => clearTimeout(timer);
        }
    }, [employmentForm, ndaTemplateBytes, activeTab, selectedAgreementKey, data]);

    // Load Conflict of Interest template once when activeTab is 'agreement' and selectedAgreementKey is 'conflict_of_interest'
    useEffect(() => {
        if (activeTab === 'agreement' && selectedAgreementKey === 'conflict_of_interest' && !conflictTemplateBytes) {
            const loadTemplate = async () => {
                try {
                    const response = await fetch('/Conflict of interest agreement.pdf');
                    const arrayBuffer = await response.arrayBuffer();
                    setConflictTemplateBytes(new Uint8Array(arrayBuffer));
                } catch (e) {
                    console.error("Failed to load Conflict of Interest template:", e);
                }
            };
            loadTemplate();
        }
    }, [activeTab, selectedAgreementKey, conflictTemplateBytes]);

    // Debounced PDF preview generation for Conflict of Interest
    useEffect(() => {
        if (activeTab === 'agreement' && selectedAgreementKey === 'conflict_of_interest' && conflictTemplateBytes) {
            if (data?.signature_history?.some(h => h.document_type === 'Conflict of interest agreement' && h.action === 'SIGN')) {
                return;
            }
            const timer = setTimeout(async () => {
                const base64 = await generateConflictPdfData(conflictTemplateBytes, employmentForm, null);
                const pdfBytes = base64ToUint8Array(base64);
                const blob = new Blob([pdfBytes], { type: 'application/pdf' });
                const newUrl = URL.createObjectURL(blob);

                setAgreementBlobUrls(prev => {
                    const oldUrl = prev['conflict_of_interest'];
                    if (oldUrl && oldUrl.startsWith('blob:')) {
                        URL.revokeObjectURL(oldUrl);
                    }
                    return {
                        ...prev,
                        'conflict_of_interest': newUrl
                    };
                });
            }, 250);
            return () => clearTimeout(timer);
        }
    }, [employmentForm, conflictTemplateBytes, activeTab, selectedAgreementKey, data]);

    // Load Benefits Enrollment template once when activeTab is 'agreement' and selectedAgreementKey is '401k_dental_vision_medical'
    useEffect(() => {
        if (activeTab === 'agreement' && selectedAgreementKey === '401k_dental_vision_medical' && !benefitsTemplateBytes) {
            const loadTemplate = async () => {
                try {
                    const response = await fetch('/401K Dental Vision Medical.pdf');
                    const arrayBuffer = await response.arrayBuffer();
                    setBenefitsTemplateBytes(new Uint8Array(arrayBuffer));
                } catch (e) {
                    console.error("Failed to load Benefits template:", e);
                }
            };
            loadTemplate();
        }
    }, [activeTab, selectedAgreementKey, benefitsTemplateBytes]);

    // Debounced PDF preview generation for Benefits Enrollment
    useEffect(() => {
        if (activeTab === 'agreement' && selectedAgreementKey === '401k_dental_vision_medical' && benefitsTemplateBytes) {
            if (data?.signature_history?.some(h => h.document_type === '401K Dental Vision Medical' && h.action === 'SIGN')) {
                return;
            }
            const timer = setTimeout(async () => {
                const base64 = await generateBenefitsPdfData(benefitsTemplateBytes, employmentForm, null);
                const pdfBytes = base64ToUint8Array(base64);
                const blob = new Blob([pdfBytes], { type: 'application/pdf' });
                const newUrl = URL.createObjectURL(blob);

                setAgreementBlobUrls(prev => {
                    const oldUrl = prev['401k_dental_vision_medical'];
                    if (oldUrl && oldUrl.startsWith('blob:')) {
                        URL.revokeObjectURL(oldUrl);
                    }
                    return {
                        ...prev,
                        '401k_dental_vision_medical': newUrl
                    };
                });
            }, 250);
            return () => clearTimeout(timer);
        }
    }, [employmentForm, benefitsTemplateBytes, activeTab, selectedAgreementKey, data]);

    // Load Non Solicitation template once when activeTab is 'agreement' and selectedAgreementKey is 'non_solicitation'
    useEffect(() => {
        if (activeTab === 'agreement' && selectedAgreementKey === 'non_solicitation' && !nonSolicitationTemplateBytes) {
            const loadTemplate = async () => {
                try {
                    const response = await fetch('/Non Solicitation.pdf');
                    const arrayBuffer = await response.arrayBuffer();
                    setNonSolicitationTemplateBytes(new Uint8Array(arrayBuffer));
                } catch (e) {
                    console.error("Failed to load Non Solicitation template:", e);
                }
            };
            loadTemplate();
        }
    }, [activeTab, selectedAgreementKey, nonSolicitationTemplateBytes]);

    // Debounced PDF preview generation for Non Solicitation
    useEffect(() => {
        if (activeTab === 'agreement' && selectedAgreementKey === 'non_solicitation' && nonSolicitationTemplateBytes) {
            if (data?.signature_history?.some(h => h.document_type === 'Non Solicitation' && h.action === 'SIGN')) {
                return;
            }
            const timer = setTimeout(async () => {
                const base64 = await generateNonSolicitationPdfData(nonSolicitationTemplateBytes, employmentForm, null);
                const pdfBytes = base64ToUint8Array(base64);
                const blob = new Blob([pdfBytes], { type: 'application/pdf' });
                const newUrl = URL.createObjectURL(blob);

                setAgreementBlobUrls(prev => {
                    const oldUrl = prev['non_solicitation'];
                    if (oldUrl && oldUrl.startsWith('blob:')) {
                        URL.revokeObjectURL(oldUrl);
                    }
                    return {
                        ...prev,
                        'non_solicitation': newUrl
                    };
                });
            }, 250);
            return () => clearTimeout(timer);
        }
    }, [employmentForm, nonSolicitationTemplateBytes, activeTab, selectedAgreementKey, data]);

    const handleApplySignature = (sigValue, sigType) => {
        setTaxForm(prev => ({ ...prev, signature: sigValue }));
        if (sigValue) {
            setToast({ message: 'Signature applied to PDF preview!', type: 'success' });
        }
    };

    const handleSaveTaxSubmit = async () => {
        if (isLocked) return;
        if (!taxForm.signature) {
            setToast({ message: 'Please sign the form first.', type: 'error' });
            return;
        }
        try {
            await api.post('/onboarding/tax', {
                federal_tax_status: taxForm.federal_tax_status,
                federal_allowances: taxForm.federal_allowances,
                state_tax_status: taxForm.state_tax_status,
                state_allowances: taxForm.state_allowances,
                signature: taxForm.signature,
                arizona_box_selection: taxForm.arizona_box_selection,
                arizona_percentage: taxForm.arizona_percentage,
                arizona_extra_amount_checked: taxForm.arizona_extra_amount_checked ? 1 : 0,
                arizona_extra_amount: taxForm.arizona_extra_amount || 0.00,
                signed_pdf: pdfBase64
            });
            setToast({ message: 'Tax elections signed and saved successfully!', type: 'success' });
            fetchOnboardingData();
        } catch (err) {
            setToast({ message: err.response?.data?.error || 'Failed to save tax elections.', type: 'error' });
        }
    };

    const downloadPdf = () => {
        if (!pdfPreviewUrl) return;
        const link = document.createElement('a');
        link.href = pdfPreviewUrl;
        link.download = `Arizona_Form_A4_${(taxForm.name || 'Employee').replace(/\s+/g, '_')}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Accept Corporate Policy
    const handlePolicyAccept = async (sigData) => {
        if (isLocked) return;
        try {
            setLoading(true);
            let signaturePng = sigData;
            if (sigData && !sigData.startsWith('data:image')) {
                signaturePng = convertTypedToPng(sigData);
            }

            const fullName = `${employee?.FirstName || ''} ${employee?.LastName || ''}`.trim() || 'Employee';
            const signedPdfBase64 = await createPoliciesPdf(fullName, signaturePng);

            await api.post('/onboarding/policies', {
                signature: sigData,
                signed_pdf: signedPdfBase64
            });
            setToast({ message: 'All company policies accepted successfully and PDF generated!', type: 'success' });
            window.dispatchEvent(new Event('onboarding_updated'));
            fetchOnboardingData();
        } catch (err) {
            setToast({ message: err.response?.data?.error || 'Failed to record policies signature.', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    // Sign Hiring Hub Document (Offer Letter / Employee Agreement)
    const handleDocumentSign = async (docType, sigData) => {
        if (isLocked) return;
        try {
            setLoading(true);
            // 1. Process signature image: if it is a typed signature, convert it to a canvas image URL
            let signaturePng = sigData;
            if (sigData && !sigData.startsWith('data:image')) {
                signaturePng = convertTypedToPng(sigData);
            }

            // 2. Resolve original PDF base64
            let originalBase64 = '';
            if (docType === 'Offer Letter') {
                originalBase64 = employee?.offer_letter_base64 || data?.employee?.offer_letter_base64;
                if (!originalBase64) {
                    const rawPath = employee?.offer_letter || employee?.offer_letter_path || data?.employee?.offer_letter || data?.employee?.offer_letter_path;
                    let targetUrl = '';
                    if (rawPath) {
                        let cleanPath = rawPath.replace(/^\//, '');
                        if (!cleanPath.startsWith('http://') && !cleanPath.startsWith('https://')) {
                            cleanPath = cleanPath.startsWith('offer_letters/')
                                ? `https://hiring.gtelinq.com/hiring-backend/${cleanPath}`
                                : `/EOP_api/${cleanPath}`;
                        }
                        targetUrl = cleanPath;
                    }
                    if (targetUrl) {
                        try {
                            originalBase64 = await fetchLocalPdfAsBase64(targetUrl);
                        } catch (e) {
                            console.error("Failed to fetch offer letter URL as base64:", e);
                        }
                    }
                    if (!originalBase64 && offerLetterBlobUrl) {
                        try {
                            originalBase64 = await fetchLocalPdfAsBase64(offerLetterBlobUrl);
                        } catch (e) {
                            console.error("Failed to fetch offerLetterBlobUrl as base64:", e);
                        }
                    }
                }
            } else {
                try {
                    const country = employee?.country || '';
                    const isUsa = country.toUpperCase() === 'USA';
                    let templatePath = '';
                    if (isUsa) {
                        const list = [
                            { title: 'Employment Agreement 1', displayName: 'Employment Agreement', path: '/Employment Agreement 1.pdf' },
                            { title: 'Employee Confidentiality & NDA (1)', displayName: 'Employee Confidentiality & NDA', path: '/Employee Confidentiality & NDA (1).pdf' },
                            { title: 'Conflict of interest agreement', path: '/Conflict of interest agreement.pdf' },
                            { title: '401K Dental Vision Medical', path: '/401K Dental Vision Medical.pdf' },
                            { title: 'Non Solicitation', path: '/Non Solicitation.pdf' }
                        ];
                        const found = list.find(item => item.title === docType);
                        templatePath = found ? found.path : '/employee_agreement_usa.pdf';
                    } else {
                        templatePath = '/3-Employment Agreement.pdf';
                    }
                    originalBase64 = await fetchLocalPdfAsBase64(templatePath);
                } catch (fetchErr) {
                    console.error("Failed to fetch local agreement PDF template:", fetchErr);
                    originalBase64 = employee.employee_agreement_base64;
                }
            }

            // 3. Draw signature on the PDF
            let signedPdfBase64 = '';
            if (docType === 'Employment Agreement 1' || docType === 'Employment Agreement') {
                let templateBytes = agreementTemplateBytes;
                if (!templateBytes) {
                    const response = await fetch('/Employment Agreement 1.pdf');
                    const arrayBuffer = await response.arrayBuffer();
                    templateBytes = new Uint8Array(arrayBuffer);
                }
                signedPdfBase64 = await generateAgreementPdfData(templateBytes, employmentForm, signaturePng);
            } else if (docType === 'Employee Confidentiality & NDA (1)' || docType === 'Employee Confidentiality & NDA') {
                let templateBytes = ndaTemplateBytes;
                if (!templateBytes) {
                    const response = await fetch('/Employee Confidentiality & NDA (1).pdf');
                    const arrayBuffer = await response.arrayBuffer();
                    templateBytes = new Uint8Array(arrayBuffer);
                }
                signedPdfBase64 = await generateNdaPdfData(templateBytes, employmentForm, signaturePng);
            } else if (docType === 'Conflict of interest agreement') {
                let templateBytes = conflictTemplateBytes;
                if (!templateBytes) {
                    const response = await fetch('/Conflict of interest agreement.pdf');
                    const arrayBuffer = await response.arrayBuffer();
                    templateBytes = new Uint8Array(arrayBuffer);
                }
                signedPdfBase64 = await generateConflictPdfData(templateBytes, employmentForm, signaturePng);
            } else if (docType === '401K Dental Vision Medical') {
                let templateBytes = benefitsTemplateBytes;
                if (!templateBytes) {
                    const response = await fetch('/401K Dental Vision Medical.pdf');
                    const arrayBuffer = await response.arrayBuffer();
                    templateBytes = new Uint8Array(arrayBuffer);
                }
                signedPdfBase64 = await generateBenefitsPdfData(templateBytes, employmentForm, signaturePng);
            } else if (docType === 'Non Solicitation') {
                let templateBytes = nonSolicitationTemplateBytes;
                if (!templateBytes) {
                    const response = await fetch('/Non Solicitation.pdf');
                    const arrayBuffer = await response.arrayBuffer();
                    templateBytes = new Uint8Array(arrayBuffer);
                }
                signedPdfBase64 = await generateNonSolicitationPdfData(templateBytes, employmentForm, signaturePng);
            } else {
                const fName = personalForm.first_name || data?.profile?.first_name || employee?.FirstName || employee?.first_name || '';
                const mName = personalForm.middle_name || data?.profile?.middle_name || employee?.MiddleName || employee?.middle_name || '';
                const lName = personalForm.last_name || data?.profile?.last_name || employee?.LastName || employee?.last_name || '';
                const fullName = [fName, mName, lName].filter(Boolean).join(' ').trim() || 'Employee';
                const aadhaarNumber = personalForm.ssn || data?.profile?.ssn || employee?.ssn || employee?.AadhaarNumber || employee?.aadhaar_number || '';
                const formattedDate = formatDateMMDDYYYY(new Date());

                const isIndiaCandidate = ((employee?.country || data?.employee?.country || personalForm?.country || '').toUpperCase()) === 'INDIA';
                const joiningDateStr = employee?.joining_date || employee?.JoiningDate || data?.employee?.joining_date || data?.employee?.JoiningDate || employmentForm?.hireDate || personalForm?.hireDate;
                signedPdfBase64 = await applySignatureToPdf(originalBase64, signaturePng, fullName, docType, isIndiaCandidate, {
                    fullName,
                    aadhaarNumber,
                    date: formattedDate,
                    joiningDate: joiningDateStr
                });
            }

            // 4. Send to backend
            await api.post('/onboarding/agreements', {
                document_type: docType,
                signature: sigData,
                signed_pdf: signedPdfBase64
            });

            // Auto-upload signed offer letter to employee_documents table for checklist storage
            if (docType === 'Offer Letter' && signedPdfBase64) {
                try {
                    await api.post('/onboarding/upload', {
                        document_type: 'Signed Offer Letter',
                        file: signedPdfBase64.startsWith('data:') ? signedPdfBase64 : `data:application/pdf;base64,${signedPdfBase64}`
                    });
                } catch (uploadErr) {
                    console.warn("Auto upload of Signed Offer Letter to documents table failed:", uploadErr);
                }

                // Set live blob URL preview of signed offer letter
                const signedUrl = base64ToBlobUrl(signedPdfBase64);
                setOfferLetterBlobUrl(prev => {
                    if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
                    return signedUrl;
                });
            }

            setToast({ message: `${docType} signed successfully!`, type: 'success' });
            window.dispatchEvent(new Event('onboarding_updated'));
            await fetchOnboardingData();
        } catch (err) {
            console.error(err);
            setToast({ message: err.response?.data?.error || err.message || 'Failed to apply document signature.', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    // Save Photo Badge headshot
    const handlePhotoUpload = (e) => {
        if (isLocked) return;
        const file = e.target.files[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                setToast({ message: 'This file is not accepted. File size exceeds maximum limit of 5MB.', type: 'error' });
                e.target.value = '';
                return;
            }
            if (!file.type.match(/^image\/(jpeg|png|jpg|webp)$/i)) {
                setToast({ message: 'This file is not accepted. Only image files (JPG, PNG, WEBP) are allowed.', type: 'error' });
                e.target.value = '';
                return;
            }

            setUploadingPhoto(true);
            const reader = new FileReader();
            reader.onload = async (event) => {
                try {
                    await api.post('/onboarding/photo', { photo: event.target.result });
                    setToast({ message: 'Profile badge photo uploaded successfully!', type: 'success' });
                    window.dispatchEvent(new Event('onboarding_updated'));
                    await fetchOnboardingData();
                } catch (err) {
                    setToast({ message: err.response?.data?.error || 'Failed to upload photo.', type: 'error' });
                } finally {
                    setUploadingPhoto(false);
                    e.target.value = '';
                }
            };
            reader.readAsDataURL(file);
        }
    };

    // Delete Photo Badge headshot
    const handleDeletePhoto = async () => {
        if (isLocked) return;
        if (!window.confirm('Are you sure you want to delete your badge profile photo?')) return;
        try {
            setUploadingPhoto(true);
            await api.delete('/onboarding/photo');
            setToast({ message: 'Profile photo deleted successfully!', type: 'success' });
            window.dispatchEvent(new Event('onboarding_updated'));
            await fetchOnboardingData();
        } catch (err) {
            setToast({ message: err.response?.data?.error || 'Failed to delete photo.', type: 'error' });
        } finally {
            setUploadingPhoto(false);
        }
    };

    // Submit Onboarding
    const handleSubmitOnboarding = async () => {
        const requestedDocsList = data?.requested_documents || data?.requested_employee_documents || [];
        const pendingOrUploadedReqs = requestedDocsList.filter(r => {
            const s = (r.status || '').toUpperCase();
            return s !== 'SUBMITTED' && s !== 'COMPLETED' && s !== 'APPROVED';
        });
        if (isLocked && pendingOrUploadedReqs.length === 0) return;
        setSubmitStatus('submitting');
        setSubmitErrorMessage('');
        try {
            // Artificial delay to allow user to see the loading progress
            await new Promise((resolve) => setTimeout(resolve, 1800));
            await api.post('/onboarding/submit');
            setSubmitStatus('success');
            setRequestedDocsSubmitted(true);
            fetchOnboardingData();
        } catch (err) {
            setSubmitStatus('error');
            setSubmitErrorMessage(err.response?.data?.error || 'Failed to submit onboarding.');
        }
    };

    // Helper to open PDF in a new tab natively using Blob URL
    const handleViewPdf = (base64Data, fileName = 'document.pdf') => {
        try {
            if (!base64Data) {
                setToast({ message: 'No PDF data available.', type: 'error' });
                return;
            }
            if (base64Data.startsWith('/') || base64Data.startsWith('blob:') || base64Data.startsWith('http')) {
                const newWindow = window.open();
                if (newWindow) {
                    newWindow.document.title = fileName;
                    newWindow.location.href = base64Data;
                } else {
                    // Fallback: download if blocked
                    const a = document.createElement('a');
                    a.href = base64Data;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
                return;
            }
            const arr = base64ToUint8Array(base64Data);
            if (arr.length === 0) {
                setToast({ message: 'Failed to decode PDF data.', type: 'error' });
                return;
            }
            const blob = new Blob([arr], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            const newWindow = window.open();
            if (newWindow) {
                newWindow.document.title = fileName;
                newWindow.location.href = url;
            } else {
                // Fallback: download if blocked
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        } catch (err) {
            setToast({ message: 'Failed to load PDF. Please try downloading it.', type: 'error' });
        }
    };

    const handleDownloadPdf = (base64Data, fileName = 'document.pdf') => {
        try {
            if (!base64Data) {
                setToast({ message: 'No PDF data available.', type: 'error' });
                return;
            }
            if (base64Data.startsWith('/') || base64Data.startsWith('blob:') || base64Data.startsWith('http')) {
                const a = document.createElement('a');
                a.href = base64Data;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                return;
            }
            const arr = base64ToUint8Array(base64Data);
            if (arr.length === 0) {
                setToast({ message: 'Failed to decode PDF data.', type: 'error' });
                return;
            }
            const blob = new Blob([arr], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (err) {
            setToast({ message: 'Failed to download PDF.', type: 'error' });
        }
    };

    const handleDownloadPolicies = async () => {
        try {
            setLoading(true);
            const fullName = `${employee?.FirstName || ''} ${employee?.LastName || ''}`.trim() || 'Employee';
            let signatureDataUrl = employee?.policy_signature || '';

            if (signatureDataUrl.startsWith('typed:')) {
                const typedName = signatureDataUrl.replace('typed:', '');
                signatureDataUrl = convertTypedToPng(typedName);
            }

            const newPdfBase64 = await createPoliciesPdf(fullName, signatureDataUrl);
            handleDownloadPdf(newPdfBase64, `company_policies_${(employee?.FirstName || 'employee').toLowerCase()}_${(employee?.LastName || 'signed').toLowerCase()}_signed.pdf`);
        } catch (err) {
            console.error(err);
            setToast({ message: 'Failed to generate policies PDF for download.', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader message="Loading onboarding workspace..." />;
    }

    const employee = data?.employee || {};
    const profile = data?.profile || {};

    // Find if a Passport Size Photo document was uploaded in India documents section
    const passportSizePhotoDoc = (data?.documents || []).find(
        doc => doc.document_type === 'Passport Size Photo'
    );
    const rawProfilePhotoPath = profile?.profile_photo_path;

    // Ensure Passport Size Photo document is separate from Badge Profile Photo
    const isPassportDocMatch = (
        (passportSizePhotoDoc?.file_path && rawProfilePhotoPath === passportSizePhotoDoc.file_path) ||
        (rawProfilePhotoPath && (data?.documents || []).some(doc => doc.document_type === 'Passport Size Photo' && doc.file_path === rawProfilePhotoPath))
    );

    const badgePhotoPath = (rawProfilePhotoPath && !isPassportDocMatch) ? rawProfilePhotoPath : null;

    const effectiveChecklist = dashboardStats?.checklist ? {
        ...dashboardStats.checklist,
        profile_photo: !!badgePhotoPath
    } : {};

    const effectiveCompletedSteps = Object.values(effectiveChecklist).filter(Boolean).length;

    const effectiveDashboardStats = dashboardStats ? {
        ...dashboardStats,
        checklist: effectiveChecklist,
        completed_steps: effectiveCompletedSteps
    } : null;

    return (
        <div style={{ animation: 'fadeIn var(--transition-normal) forwards' }}>
            {uploadingPhoto && <Loader fullScreen message="Uploading profile badge photo..." />}

            {/* Lock banner warning */}
            {isLocked && (
                <div
                    style={{
                        backgroundColor: 'var(--info-light)',
                        borderLeft: '4px solid var(--info)',
                        padding: '1rem',
                        borderRadius: '4px',
                        marginBottom: '1.5rem',
                        fontSize: '0.875rem',
                        color: 'var(--text-primary)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                    }}
                >
                    <span>ℹ️</span>
                    <div>
                        You have submitted your onboarding details successfully.
                    </div>
                </div>
            )}

            {/* DASHBOARD TAB */}
            {activeTab === 'dashboard' && (() => {
                const completedSteps = effectiveDashboardStats?.completed_steps || 0;
                const totalSteps = effectiveDashboardStats?.total_steps || 8;
                const onboardingPercent = Math.round((completedSteps / totalSteps) * 100);

                const radius = 60;
                const stroke = 7;
                const normRadius = radius - stroke * 2;
                const circ = normRadius * 2 * Math.PI;
                const offset = circ - (onboardingPercent / 100) * circ;

                return (
                    <div className="fade-in" style={{ display: 'flex', flexDirection: 'column', gap: '2.5rem' }}>

                        {/* Split Top section: Greeting + Radial Indicator */}
                        <div className="dashboard-top-grid">

                            {/* Left Column: Greeting & Status */}
                            <div
                                style={{
                                    background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.07) 0%, rgba(244, 63, 94, 0.04) 100%)',
                                    border: '1px solid var(--border-color)',
                                    borderRadius: 'var(--border-radius-lg)',
                                    padding: '2.5rem 2rem',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    boxShadow: 'var(--shadow-md)'
                                }}
                            >
                                <div
                                    style={{
                                        display: 'inline-flex',
                                        padding: '0.25rem 0.75rem',
                                        backgroundColor: 'var(--primary-light)',
                                        color: 'var(--primary)',
                                        fontSize: '0.75rem',
                                        fontWeight: 700,
                                        borderRadius: '50px',
                                        textTransform: 'uppercase',
                                        marginBottom: '1rem',
                                        alignSelf: 'flex-start',
                                        letterSpacing: '0.05em'
                                    }}
                                >
                                    Onboarding Phase
                                </div>

                                <h2 style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--text-primary)', marginBottom: '0.5rem', letterSpacing: '-0.02em' }}>
                                    Welcome, {employee.FirstName || 'Team Member'}!
                                </h2>
                                <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '1rem' }}>
                                    We are thrilled to welcome you to the Genesis Tech Engineers family. All accounts have been securely synchronized. Complete your documentation pipeline below.
                                </p>
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <button
                                        type="button"
                                        onClick={onStartVideoTour}
                                        className="btn btn-secondary"
                                        style={{ padding: '0.45rem 1rem', fontSize: '0.75rem', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
                                    >
                                        🎥 Watch Onboarding Video Tour
                                    </button>
                                </div>

                                {/* Progress bar line */}
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>
                                        <span>Onboarding Progress</span>
                                        <span>{onboardingPercent}% Complete</span>
                                    </div>
                                    <div style={{ width: '100%', height: '8px', backgroundColor: 'var(--bg-tertiary)', borderRadius: '50px', overflow: 'hidden' }}>
                                        <div
                                            style={{
                                                width: `${onboardingPercent}%`,
                                                height: '100%',
                                                background: 'linear-gradient(90deg, var(--primary) 0%, var(--accent) 100%)',
                                                borderRadius: '50px',
                                                transition: 'width 0.4s ease-out'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Right Column: Visual Radial Meter */}
                            <div
                                className="glass-card"
                                style={{
                                    padding: '2rem',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center'
                                }}
                            >
                                <div style={{ position: 'relative', width: radius * 2, height: radius * 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {/* SVG Circle meter */}
                                    <svg height={radius * 2} width={radius * 2} style={{ transform: 'rotate(-90deg)', position: 'absolute', top: 0, left: 0 }}>
                                        <circle
                                            stroke="var(--bg-tertiary)"
                                            fill="transparent"
                                            strokeWidth={stroke}
                                            r={normRadius}
                                            cx={radius}
                                            cy={radius}
                                        />
                                        <circle
                                            stroke="url(#progressGrad)"
                                            fill="transparent"
                                            strokeWidth={stroke}
                                            strokeDasharray={circ + ' ' + circ}
                                            style={{ strokeDashoffset: offset, transition: 'stroke-dashoffset 0.6s ease' }}
                                            r={normRadius}
                                            cx={radius}
                                            cy={radius}
                                            strokeLinecap="round"
                                        />
                                        <defs>
                                            <linearGradient id="progressGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                                <stop offset="0%" stopColor="#22d3ee" />
                                                <stop offset="50%" stopColor="#6366f1" />
                                                <stop offset="100%" stopColor="#ec4899" />
                                            </linearGradient>
                                        </defs>
                                    </svg>

                                    {/* Inside dial text */}
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 2 }}>
                                        <span style={{ fontSize: '1.75rem', fontWeight: 800, color: 'var(--text-primary)', lineHeight: 1 }}>{completedSteps}</span>
                                        <span style={{ fontSize: '0.7rem', color: 'var(--text-tertiary)', textTransform: 'uppercase', fontWeight: 700, marginTop: '0.15rem' }}>of {totalSteps} Tasks</span>
                                    </div>
                                </div>

                                <div style={{ marginTop: '1.25rem' }}>
                                    <div style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--text-primary)' }}>Completeness Ratio</div>
                                    <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '0.15rem' }}>
                                        {onboardingPercent === 100 ? 'Ready to submit onboarding profile!' : `${totalSteps - completedSteps} steps remaining`}
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* Visual Roadmap Path */}
                        {(() => {
                            const roadmapSteps = [
                                { key: 'personal_info', tab: 'personal', title: 'Profile', icon: '👤' },
                                { key: 'emergency_contacts', tab: 'contacts', title: 'Contacts', icon: '📞' },
                                { key: 'documents', tab: 'documents', title: 'ID Docs', icon: '📁' },
                                { key: 'offer', tab: 'offer', title: 'Offer Letter', icon: '✉️' },
                                { key: 'agreement', tab: 'agreement', title: 'Agreement', icon: '🖋️' },
                                { key: 'policies', tab: 'policies', title: 'Policies', icon: '🛡️' },
                                { key: 'bank_details', tab: 'bank', title: 'Bank', icon: '🏦' },
                                { key: 'profile_photo', tab: 'photo', title: 'Photo', icon: '📷' },
                                { key: 'submit', tab: 'submit', title: 'Submit', icon: '🚀' }
                            ];

                            const firstPendingStep = roadmapSteps.find(s => {
                                if (s.key === 'submit') {
                                    return roadmapSteps.slice(0, 8).every(other => effectiveDashboardStats?.checklist?.[other.key]);
                                }
                                return !effectiveDashboardStats?.checklist?.[s.key];
                            }) || roadmapSteps[8];

                            return (
                                <div className="card fade-in" style={{ padding: '1.75rem 1.5rem', margin: 0, boxShadow: 'var(--shadow-sm)' }}>
                                    <div className="roadmap-header">
                                        <div>
                                            <h3 style={{ fontSize: '1.1rem', fontWeight: 800, margin: 0, color: 'var(--text-primary)' }}>
                                                🗺️ Onboarding Guided Path Roadmap
                                            </h3>
                                            <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
                                                Your onboarding steps pipeline. Click any step circle to jump directly to its screen.
                                            </p>
                                        </div>
                                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                                            <button
                                                type="button"
                                                onClick={onStartVideoTour}
                                                className="btn btn-secondary"
                                                style={{ padding: '0.4rem 0.8rem', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
                                            >
                                                🎥 Play Video Tour
                                            </button>
                                            <button
                                                type="button"
                                                onClick={onStartTour}
                                                className="btn btn-secondary"
                                                style={{ padding: '0.4rem 0.8rem', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
                                            >
                                                🗺️ Replay Guided Tour
                                            </button>
                                        </div>
                                    </div>

                                    <div className="roadmap-trail">
                                        {roadmapSteps.map((step, idx) => {
                                            const isComplete = step.key === 'submit'
                                                ? (effectiveDashboardStats?.status === 'PENDING_HR_REVIEW' || effectiveDashboardStats?.status === 'COMPLETED')
                                                : effectiveDashboardStats?.checklist?.[step.key];
                                            const isActive = firstPendingStep.key === step.key;

                                            return (
                                                <React.Fragment key={step.key}>
                                                    <div
                                                        className={`roadmap-step ${isActive ? 'active' : ''} ${isComplete ? 'complete' : ''}`}
                                                        onClick={() => setActiveTab(step.tab)}
                                                        title={step.title}
                                                    >
                                                        {isActive && (
                                                            <span style={{
                                                                position: 'absolute',
                                                                top: '-22px',
                                                                fontSize: '0.85rem',
                                                                animation: 'bounceDown 1.2s infinite',
                                                                color: 'var(--primary)',
                                                                fontWeight: 800
                                                            }}>
                                                                👇
                                                            </span>
                                                        )}
                                                        <div className={`roadmap-step-circle ${isActive ? 'next-step-glowing' : ''}`}>
                                                            {isComplete ? '✓' : step.icon}
                                                        </div>
                                                        <div className="roadmap-step-title">{step.title}</div>
                                                    </div>

                                                    {idx < roadmapSteps.length - 1 && (
                                                        <div className="roadmap-arrow">➔</div>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })()}

                        {/* Middle section: Colorful Info Badges Grid */}
                        <div className="dashboard-middle-grid">
                            <div style={{ padding: '1.25rem', backgroundColor: 'rgba(59, 130, 246, 0.03)', border: '1px solid var(--border-color)', borderLeft: '4px solid #3b82f6', borderRadius: 'var(--border-radius-md)', display: 'flex', flexDirection: 'column', gap: '0.25rem', boxShadow: 'var(--shadow-sm)' }}>
                                <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#2563eb', fontWeight: 700, letterSpacing: '0.05em' }}>Designation Unit</span>
                                <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)' }}>{employee.Designation || 'N/A'}</span>
                            </div>
                            <div style={{ padding: '1.25rem', backgroundColor: 'rgba(168, 85, 247, 0.03)', border: '1px solid var(--border-color)', borderLeft: '4px solid #a855f7', borderRadius: 'var(--border-radius-md)', display: 'flex', flexDirection: 'column', gap: '0.25rem', boxShadow: 'var(--shadow-sm)' }}>
                                <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#9333ea', fontWeight: 700, letterSpacing: '0.05em' }}>Department Branch</span>
                                <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)' }}>{employee.Department || 'N/A'}</span>
                            </div>
                            <div style={{ padding: '1.25rem', backgroundColor: 'rgba(16, 185, 129, 0.03)', border: '1px solid var(--border-color)', borderLeft: '4px solid #10b981', borderRadius: 'var(--border-radius-md)', display: 'flex', flexDirection: 'column', gap: '0.25rem', boxShadow: 'var(--shadow-sm)' }}>
                                <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#059669', fontWeight: 700, letterSpacing: '0.05em' }}>Official Start Date</span>
                                <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)' }}>{employee.JoiningDate || 'N/A'}</span>
                            </div>
                        </div>

                        {/* Launcher Grid */}
                        <div className="card" style={{ padding: '2.5rem 2rem', margin: 0 }}>
                            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '0.5rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '0.75rem' }}>
                                🚀 Onboarding Launchpad Checklist
                            </h3>
                            <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '2rem' }}>
                                Each card below represents a required onboarding step. Click any card to load its details.
                            </p>

                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                                    gap: '1.25rem'
                                }}
                            >
                                {[
                                    { key: 'personal_info', tab: 'personal', icon: '👤', title: 'Personal Profile', desc: ((data?.employee?.country || employee?.country || '').toUpperCase() === 'INDIA') ? 'Verify personal details, addresses, and Aadhaar.' : 'Verify personal details, addresses, and SSN.', color: 'rgba(59, 130, 246, 0.03)', hoverBorder: '#3b82f6', badgeBg: 'rgba(59, 130, 246, 0.12)', badgeText: '#2563eb' },
                                    { key: 'emergency_contacts', tab: 'contacts', icon: '📞', title: 'Emergency Contacts', desc: 'Add primary and secondary contact details.', color: 'rgba(16, 185, 129, 0.03)', hoverBorder: '#10b981', badgeBg: 'rgba(16, 185, 129, 0.12)', badgeText: '#059669' },
                                    { key: 'documents', tab: 'documents', icon: '📁', title: 'US Identification', desc: 'Upload standard identity documents.', color: 'rgba(99, 102, 241, 0.03)', hoverBorder: '#6366f1', badgeBg: 'rgba(99, 102, 241, 0.12)', badgeText: '#4f46e5' },
                                    { key: 'offer', tab: 'offer', icon: '✉️', title: 'Offer Sheet Review', desc: 'Review terms and sign your hiring offer letter.', color: 'rgba(245, 158, 11, 0.03)', hoverBorder: '#f59e0b', badgeBg: 'rgba(245, 158, 11, 0.12)', badgeText: '#d97706' },
                                    { key: 'agreement', tab: 'agreement', icon: '🖋️', title: 'Employee Agreement', desc: 'E-sign the corporate NDAs & contracts.', color: 'rgba(236, 72, 153, 0.03)', hoverBorder: '#ec4899', badgeBg: 'rgba(236, 72, 153, 0.12)', badgeText: '#db2777' },
                                    { key: 'policies', tab: 'policies', icon: '🛡️', title: 'Company Policies', desc: 'Read and accept the 5 policy handbooks.', color: 'rgba(6, 182, 212, 0.03)', hoverBorder: '#06b6d4', badgeBg: 'rgba(6, 182, 212, 0.12)', badgeText: '#0891b2' },
                                    { key: 'bank_details', tab: 'bank', icon: '🏦', title: 'Direct Deposit', desc: 'Setup payroll accounts and voided cheques.', color: 'rgba(168, 85, 247, 0.03)', hoverBorder: '#a855f7', badgeBg: 'rgba(168, 85, 247, 0.12)', badgeText: '#9333ea' },
                                    { key: 'profile_photo', tab: 'photo', icon: '📷', title: 'Badge Headshot', desc: 'Upload and crop your official badge headshot.', color: 'rgba(239, 68, 68, 0.03)', hoverBorder: '#ef4444', badgeBg: 'rgba(239, 68, 68, 0.12)', badgeText: '#dc2626' }
                                ].map(step => {
                                    const complete = effectiveDashboardStats?.checklist?.[step.key];
                                    return (
                                        <div
                                            key={step.key}
                                            onClick={() => setActiveTab(step.tab)}
                                            style={{
                                                border: '1px solid var(--border-color)',
                                                borderRadius: 'var(--border-radius-md)',
                                                padding: '1.25rem',
                                                cursor: 'pointer',
                                                backgroundColor: step.color,
                                                transition: 'all var(--transition-normal)',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'space-between',
                                                minHeight: '140px',
                                                boxShadow: 'var(--shadow-sm)',
                                                position: 'relative',
                                                overflow: 'hidden'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-3px)';
                                                e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                                                e.currentTarget.style.borderColor = step.hoverBorder;
                                                e.currentTarget.style.background = step.color.replace('0.03', '0.07');
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
                                                e.currentTarget.style.borderColor = 'var(--border-color)';
                                                e.currentTarget.style.background = step.color;
                                            }}
                                        >
                                            <div style={{ position: 'relative', zIndex: 2 }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                                                    <span style={{ fontSize: '1.5rem' }}>{step.icon}</span>
                                                    <span
                                                        style={{
                                                            fontSize: '0.7rem',
                                                            fontWeight: '700',
                                                            padding: '0.15rem 0.5rem',
                                                            borderRadius: '50px',
                                                            textTransform: 'uppercase',
                                                            backgroundColor: complete ? 'var(--success-light)' : step.badgeBg,
                                                            color: complete ? 'var(--success)' : step.badgeText
                                                        }}
                                                    >
                                                        {complete ? '✓ Done' : 'Pending'}
                                                    </span>
                                                </div>
                                                <h4 style={{ fontSize: '0.95rem', fontWeight: '700', marginBottom: '0.25rem', color: 'var(--text-primary)' }}>
                                                    {step.title}
                                                </h4>
                                                <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', lineHeight: '1.3' }}>
                                                    {step.desc}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* PERSONAL INFO TAB */}
            {activeTab === 'personal' && (() => {
                const country = data?.employee?.country || personalForm.country || employee?.country || '';
                const isIndia = country.toUpperCase() === 'INDIA';
                return (
                    <div className="card fade-in">
                        <div className="card-title">Personal Information</div>
                        <form onSubmit={handleSavePersonal}>
                            <div className="grid-2">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="first-name">Given Name(first+middle)</label>
                                    <input type="text" id="first-name" className="form-control" value={personalForm.first_name} onChange={(e) => setPersonalForm({ ...personalForm, first_name: e.target.value })} required disabled={isLocked} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="last-name">Last Name</label>
                                    <input type="text" id="last-name" className="form-control" value={personalForm.last_name} onChange={(e) => setPersonalForm({ ...personalForm, last_name: e.target.value })} required disabled={isLocked} />
                                </div>
                            </div>

                            <div className="grid-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="pref-name">Preferred Name</label>
                                    <input type="text" id="pref-name" className="form-control" value={personalForm.preferred_name} onChange={(e) => setPersonalForm({ ...personalForm, preferred_name: e.target.value })} disabled={isLocked} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="dob-input">Date of Birth</label>
                                    <input type="date" id="dob-input" className="form-control" value={personalForm.dob} onChange={(e) => setPersonalForm({ ...personalForm, dob: e.target.value })} disabled={isLocked} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="gender-select">Gender</label>
                                    <select id="gender-select" className="form-control" value={personalForm.gender} onChange={(e) => setPersonalForm({ ...personalForm, gender: e.target.value })} disabled={isLocked}>
                                        <option value="">Select</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>

                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                            </div>

                            <div className="grid-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="marital-select">Marital Status</label>
                                    <select id="marital-select" className="form-control" value={personalForm.marital_status} onChange={(e) => setPersonalForm({ ...personalForm, marital_status: e.target.value })} disabled={isLocked}>
                                        <option value="">Select</option>
                                        <option value="Single">Single</option>
                                        <option value="Married">Married</option>
                                        <option value="Divorced">Divorced</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="cit-input">Citizenship</label>
                                    <input type="text" id="cit-input" className="form-control" value={personalForm.citizenship} onChange={(e) => setPersonalForm({ ...personalForm, citizenship: e.target.value })} disabled={isLocked} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="ssn-input">
                                        {isIndia ? 'Aadhaar Number' : 'Social Security Number (SSN)'}
                                    </label>
                                    <input
                                        type="text"
                                        id="ssn-input"
                                        className="form-control"
                                        placeholder={isIndia ? '12-digit Aadhaar Number (e.g. 1234 5678 9012)' : '000-00-0000'}
                                        maxLength={isIndia ? 14 : 11}
                                        value={personalForm.ssn}
                                        onChange={(e) => setPersonalForm({ ...personalForm, ssn: e.target.value })}
                                        disabled={isLocked}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="grid-2">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="phone-input">Phone Number</label>
                                    <input type="tel" id="phone-input" className="form-control" value={personalForm.phone} onChange={(e) => setPersonalForm({ ...personalForm, phone: e.target.value })} required disabled={isLocked} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="email-display">Personal Email</label>
                                    <input type="email" id="email-display" className="form-control" value={personalForm.personal_email} onChange={(e) => setPersonalForm({ ...personalForm, personal_email: e.target.value })} required disabled={isLocked} />
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="form-label" htmlFor="addr-input">Address Line</label>
                                <input type="text" id="addr-input" className="form-control" value={personalForm.address} onChange={(e) => setPersonalForm({ ...personalForm, address: e.target.value })} required disabled={isLocked} />
                            </div>

                            <div className="grid-4">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="city-input">City</label>
                                    <input type="text" id="city-input" className="form-control" value={personalForm.city} onChange={(e) => setPersonalForm({ ...personalForm, city: e.target.value })} required disabled={isLocked} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="state-input">State</label>
                                    <input type="text" id="state-input" className="form-control" value={personalForm.state} onChange={(e) => setPersonalForm({ ...personalForm, state: e.target.value })} required disabled={isLocked} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="zip-input">ZIP Code</label>
                                    <input type="text" id="zip-input" className="form-control" value={personalForm.zip} onChange={(e) => setPersonalForm({ ...personalForm, zip: e.target.value })} required disabled={isLocked} />
                                </div>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="country-input">Country</label>
                                    <input type="text" id="country-input" className="form-control" value={personalForm.country} onChange={(e) => setPersonalForm({ ...personalForm, country: e.target.value })} required disabled={isLocked} />
                                </div>
                            </div>

                            {!isLocked && <button type="submit" className="btn btn-primary">Save Personal Info</button>}
                        </form>
                    </div>
                );
            })()}

            {/* EMERGENCY CONTACTS TAB */}
            {activeTab === 'contacts' && (
                <div className="card fade-in">
                    <div className="card-title">Emergency Contacts</div>
                    <form onSubmit={handleSaveContacts}>
                        {emergencyContacts.map((contact, idx) => (
                            <div key={idx} style={{ padding: '1rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)', marginBottom: '1rem', backgroundColor: 'var(--bg-secondary)' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                                    <span style={{ fontSize: '0.85rem', fontWeight: 600 }}>Contact #{idx + 1}</span>
                                    {!isLocked && emergencyContacts.length > 1 && (
                                        <button type="button" className="btn btn-danger" style={{ padding: '0.2rem 0.5rem', fontSize: '0.7rem' }} onClick={() => handleRemoveContact(idx)}>
                                            Remove
                                        </button>
                                    )}
                                </div>
                                <div className="grid-2">
                                    <div className="form-group">
                                        <label className="form-label">Full Name</label>
                                        <input type="text" className="form-control" value={contact.name} onChange={(e) => handleContactChange(idx, 'name', e.target.value)} required disabled={isLocked} />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Relationship</label>
                                        <input type="text" className="form-control" value={contact.relationship} onChange={(e) => handleContactChange(idx, 'relationship', e.target.value)} required disabled={isLocked} />
                                    </div>
                                </div>
                                <div className="grid-2">
                                    <div className="form-group">
                                        <label className="form-label">Phone Number</label>
                                        <input type="tel" className="form-control" value={contact.phone} onChange={(e) => handleContactChange(idx, 'phone', e.target.value)} required disabled={isLocked} />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Email</label>
                                        <input type="email" className="form-control" value={contact.email} onChange={(e) => handleContactChange(idx, 'email', e.target.value)} required disabled={isLocked} />
                                    </div>
                                </div>
                                <div className="form-group" style={{ marginTop: '1rem' }}>
                                    <label className="form-label">Address</label>
                                    <input type="text" className="form-control" value={contact.address || ''} onChange={(e) => handleContactChange(idx, 'address', e.target.value)} required disabled={isLocked} />
                                </div>
                            </div>
                        ))}

                        {!isLocked && (
                            <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                                <button type="button" className="btn btn-secondary" onClick={handleAddContact}>+ Add Contact</button>
                                <button type="submit" className="btn btn-primary">Save Contacts</button>
                            </div>
                        )}
                    </form>
                </div>
            )}

            {/* DOCUMENTS UPLOADS TAB (Form I-9 & Onboarding Documents Checklist) */}
            {activeTab === 'documents' && (() => {
                const country = data?.employee?.country || '';
                const isIndia = country.toUpperCase() === 'INDIA';
                const documents = data?.documents || [];
                const requestedDocs = data?.requested_documents || data?.requested_employee_documents || [];
                const hasStateID = documents.some(doc => doc.document_type === 'State ID');
                const hasSSC = documents.some(doc => doc.document_type === 'Social Security Card (SSC)');
                const hasOldCombined = documents.some(doc => doc.document_type === 'Driving License / State ID / SSC');
                const activeOption = selectedIdOption || ((hasStateID || hasSSC) ? 'state_id_ssc' : 'driving_license');
                return (
                    <div className="card fade-in">
                        <div className="card-title">Employee Document Checklists</div>

                        {/* DYNAMIC MANAGEMENT REQUESTED DOCUMENTS (N ITEMS) */}
                        {requestedDocs.length > 0 && (
                            <div
                                style={{
                                    marginBottom: '2rem',
                                    padding: '1.25rem',
                                    backgroundColor: 'rgba(59, 130, 246, 0.04)',
                                    border: '1px solid var(--primary-light, #93c5fd)',
                                    borderLeft: '4px solid var(--primary, #3b82f6)',
                                    borderRadius: 'var(--border-radius-md)',
                                    boxShadow: 'var(--shadow-sm)'
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                                    <span style={{ fontSize: '1.25rem' }}>📋</span>
                                    <h3 style={{ fontSize: '1.05rem', fontWeight: 700, margin: 0, color: 'var(--text-primary)' }}>
                                        Management Requested Documents ({requestedDocs.length})
                                    </h3>
                                </div>
                                <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '1.25rem' }}>
                                    HR or Management has requested the following additional document(s) specifically for your onboarding profile. Please review the instructions and upload each file below.
                                </p>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                    {requestedDocs.map((req, idx) => {
                                        const docTitle = req.document_name || req.document_type || req.title || req.name || `Requested Document #${idx + 1}`;
                                        const docInstruction = req.instructions || req.comments || req.description || req.note || req.reason || '';
                                        return (
                                            <div key={req.id || idx} style={{ backgroundColor: 'var(--bg-primary)', borderRadius: 'var(--border-radius-sm)', padding: '0.5rem' }}>
                                                <UploadField
                                                    documentType={docTitle}
                                                    instruction={docInstruction}
                                                    documentsList={data?.documents || []}
                                                    onUploadSuccess={() => {
                                                        setRequestedDocsSubmitted(false);
                                                        fetchOnboardingData();
                                                    }}
                                                    mandatory={true}
                                                    isLocked={isLocked}
                                                    allowDeleteWhenLocked={true}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {isIndia ? (
                            <>
                                <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '2rem' }}>
                                    Please upload the required verification files according to Indian HR compliance guidelines.
                                </p>

                                {/* 1. Academic Qualification */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>1. Academic Qualification</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your highest academic degree certificate or transcript.</p>
                                    </div>
                                    <UploadField
                                        documentType="Highest Education Qualification (Degree Certificate/Transcript)"
                                        documentsList={data?.documents}
                                        onUploadSuccess={fetchOnboardingData}
                                        mandatory={true}
                                    />
                                </div>

                                {/* 2. Aadhar Card */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>2. Aadhar Card</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload front and back side copy of your Aadhar Card.</p>
                                    </div>
                                    <UploadField
                                        documentType="Aadhar Card"
                                        documentsList={data?.documents}
                                        onUploadSuccess={fetchOnboardingData}
                                        mandatory={true}
                                    />
                                </div>

                                {/* 3. PAN Card */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>3. PAN Card</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload a clear scanned copy of your PAN Card.</p>
                                    </div>
                                    <UploadField
                                        documentType="PAN Card"
                                        documentsList={data?.documents}
                                        onUploadSuccess={fetchOnboardingData}
                                        mandatory={true}
                                    />
                                </div>

                                {/* 4. Passport Size Photo */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>4. Passport Size Photo</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload a recent color passport-size photograph with a clear background.</p>
                                    </div>
                                    <UploadField
                                        documentType="Passport Size Photo"
                                        documentsList={data?.documents}
                                        onUploadSuccess={fetchOnboardingData}
                                        mandatory={true}
                                    />
                                </div>

                                {/* 5. Police Verification */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>5. Police Verification</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your Police Clearance Certificate (PCC) or Character Certificate from local authorities.</p>
                                    </div>
                                    <UploadField
                                        documentType="Police Verification"
                                        documentsList={data?.documents}
                                        onUploadSuccess={fetchOnboardingData}
                                        mandatory={true}
                                        showNotAvailable={true}
                                        notAvailableLabel="I do not have a Police Verification certificate right now"
                                        consentText="I hereby consent and declare that I do not possess a Police Verification certificate at this moment. I agree and commit to submitting the certificate to HR within one month from my joining date."
                                    />
                                </div>

                                {/* 6. Salary Slip of last 3 month */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>6. Salary Slip of last 3 month</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload salary slips from your previous employer for the last three months.</p>
                                    </div>
                                    <UploadField
                                        documentType="Salary Slip of last 3 month"
                                        documentsList={data?.documents}
                                        onUploadSuccess={fetchOnboardingData}
                                        mandatory={true}
                                        showNotAvailable={true}
                                        notAvailableLabel="Not Applicable (Fresh graduate / no previous employment)"
                                    />
                                </div>

                                {/* 7. Medical Checkup Documents */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>7. Medical Checkup Documents</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your fitness certificate or medical checkup documents from a registered medical practitioner.</p>
                                    </div>
                                    <UploadField
                                        documentType="Medical Checkup Documents"
                                        documentsList={data?.documents}
                                        onUploadSuccess={fetchOnboardingData}
                                        mandatory={true}
                                        showNotAvailable={true}
                                        notAvailableLabel="I do not have a Medical Checkup report right now"
                                        consentText="I hereby consent and declare that I do not possess a Medical Checkup report at this moment. I agree and commit to submitting the report to HR within one month from my joining date."
                                    />
                                </div>

                                {/* 8. Signed Offer Letter */}
                                <div>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>8. Signed Offer Letter</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Automatically saved when you electronically sign your offer letter in the Offer Letter tab.</p>
                                    </div>
                                    <UploadField
                                        documentType="Signed Offer Letter"
                                        documentsList={data?.documents}
                                        onUploadSuccess={fetchOnboardingData}
                                        mandatory={false}
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '2rem' }}>
                                    Please upload the required verification files according to US enterprise HR compliance guidelines.
                                </p>

                                {/* 1. Form I-9 */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '1rem' }}>
                                        <div>
                                            <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>1. Form I-9</h4>
                                            <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Employment Eligibility Verification. Download, complete, and upload.</p>
                                        </div>
                                        <a href="/Form_I-9.pdf" download className="btn btn-secondary" style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', textDecoration: 'none', fontWeight: 600 }}>
                                            📥 Download Form I-9
                                        </a>
                                    </div>
                                    <UploadField documentType="Form I-9" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
                                </div>

                                {/* 2. Form W-4 */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '1rem' }}>
                                        <div>
                                            <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>2. Form W-4</h4>
                                            <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Employee's Withholding Certificate. Download, complete, and upload.</p>
                                        </div>
                                        <a href="/Form_W-4.pdf" download className="btn btn-secondary" style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', textDecoration: 'none', fontWeight: 600 }}>
                                            📥 Download Form W-4
                                        </a>
                                    </div>
                                    <UploadField documentType="Form W-4" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
                                </div>

                                {/* 3. Select State */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem', padding: '1rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)', backgroundColor: 'var(--bg-secondary)' }}>
                                    <div style={{ marginBottom: '1rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.25rem 0', color: 'var(--text-primary)' }}>3. Select State</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: '0 0 0.75rem 0' }}>Select your state to download and submit the corresponding state tax withholding form.</p>
                                        <select
                                            value={selectedState}
                                            onChange={(e) => setSelectedState(e.target.value)}
                                            className="form-control"
                                            style={{ maxWidth: '300px', padding: '0.5rem', borderRadius: 'var(--border-radius-sm)' }}
                                            disabled={isLocked}
                                        >
                                            <option value="">-- Choose Your State --</option>
                                            <option value="oregon">Oregon</option>
                                            <option value="arizona">Arizona</option>
                                            <option value="colorado">Colorado</option>
                                        </select>
                                    </div>

                                    {selectedState && (
                                        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1rem', marginTop: '1rem' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '1rem' }}>
                                                <div>
                                                    <h5 style={{ fontSize: '0.9rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>
                                                        {selectedState === 'oregon' && 'Oregon Form OR-W-4'}
                                                        {selectedState === 'arizona' && 'Arizona Form A-4'}
                                                        {selectedState === 'colorado' && 'Colorado Form DR 0004'}
                                                    </h5>
                                                    <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>
                                                        {selectedState === 'oregon' && 'Oregon State withholding allowance certificate.'}
                                                        {selectedState === 'arizona' && 'Arizona State withholding election form.'}
                                                        {selectedState === 'colorado' && 'Colorado State employee withholding certificate.'}
                                                    </p>
                                                </div>
                                                <a
                                                    href={
                                                        selectedState === 'oregon' ? '/Oregon_Form_W-4.pdf' :
                                                            selectedState === 'arizona' ? '/Arizona_Form_A4.pdf' :
                                                                '/Colorado_Form_DR0004.pdf'
                                                    }
                                                    download
                                                    className="btn btn-secondary"
                                                    style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', textDecoration: 'none', fontWeight: 600 }}
                                                >
                                                    📥 Download {selectedState.toUpperCase()} Form
                                                </a>
                                            </div>
                                            <UploadField
                                                documentType={
                                                    selectedState === 'oregon' ? 'Oregon State Tax Form' :
                                                        selectedState === 'arizona' ? 'Arizona State Tax Form' :
                                                            'Colorado State Tax Form'
                                                }
                                                documentsList={data?.documents}
                                                onUploadSuccess={fetchOnboardingData}
                                                mandatory={true}
                                            />
                                        </div>
                                    )}
                                </div>

                                {/* 4. Passport */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>4. Passport</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your valid Passport (bio page & back page).</p>
                                    </div>
                                    <UploadField documentType="Passport" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
                                </div>

                                {/* 5. Visa & EAD */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>5. Visa & EAD</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your valid Visa or Employment Authorization Document (EAD).</p>
                                    </div>
                                    <UploadField documentType="Visa & EAD" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
                                </div>

                                {/* 6. US Identification * */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.75rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>6. US Identification *</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: '0.25rem 0 0.75rem 0' }}>
                                            Choose your identification submission method: either submit a valid Driving License, or submit a State ID along with your Social Security Card (SSC).
                                        </p>
                                    </div>

                                    <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap', padding: '0 0.5rem' }}>
                                        <label style={{
                                            flex: '1 1 200px',
                                            padding: '0.85rem 1rem',
                                            border: activeOption === 'driving_license' ? '2px solid var(--primary)' : '1px solid var(--border-color)',
                                            borderRadius: 'var(--border-radius-md)',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.75rem',
                                            backgroundColor: activeOption === 'driving_license' ? 'rgba(59, 130, 246, 0.04)' : 'var(--bg-secondary)',
                                            transition: 'all 0.2s ease'
                                        }}>
                                            <input
                                                type="radio"
                                                name="id_option"
                                                checked={activeOption === 'driving_license'}
                                                onChange={() => setSelectedIdOption('driving_license')}
                                                style={{ accentColor: 'var(--primary)' }}
                                                disabled={isLocked}
                                            />
                                            <div>
                                                <strong style={{ display: 'block', fontSize: '0.85rem', color: 'var(--text-primary)' }}>Driving License</strong>
                                                <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Upload your valid US Driving License.</span>
                                            </div>
                                        </label>

                                        <label style={{
                                            flex: '1 1 200px',
                                            padding: '0.85rem 1rem',
                                            border: activeOption === 'state_id_ssc' ? '2px solid var(--primary)' : '1px solid var(--border-color)',
                                            borderRadius: 'var(--border-radius-md)',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.75rem',
                                            backgroundColor: activeOption === 'state_id_ssc' ? 'rgba(59, 130, 246, 0.04)' : 'var(--bg-secondary)',
                                            transition: 'all 0.2s ease'
                                        }}>
                                            <input
                                                type="radio"
                                                name="id_option"
                                                checked={activeOption === 'state_id_ssc'}
                                                onChange={() => setSelectedIdOption('state_id_ssc')}
                                                style={{ accentColor: 'var(--primary)' }}
                                                disabled={isLocked}
                                            />
                                            <div>
                                                <strong style={{ display: 'block', fontSize: '0.85rem', color: 'var(--text-primary)' }}>State ID & Social Security Card (SSC)</strong>
                                                <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Upload both your State ID and Social Security Card.</span>
                                            </div>
                                        </label>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                        {activeOption === 'driving_license' ? (
                                            <UploadField
                                                documentType="Driving License"
                                                documentsList={data?.documents}
                                                onUploadSuccess={fetchOnboardingData}
                                                mandatory={true}
                                            />
                                        ) : (
                                            <>
                                                <UploadField
                                                    documentType="State ID"
                                                    documentsList={data?.documents}
                                                    onUploadSuccess={fetchOnboardingData}
                                                    mandatory={true}
                                                />
                                                <UploadField
                                                    documentType="Social Security Card (SSC)"
                                                    documentsList={data?.documents}
                                                    onUploadSuccess={fetchOnboardingData}
                                                    mandatory={true}
                                                />
                                            </>
                                        )}

                                        {hasOldCombined && (
                                            <div style={{ marginTop: '1rem', borderTop: '1px dashed var(--border-color)', paddingTop: '1rem' }}>
                                                <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginBottom: '0.5rem', fontWeight: 600 }}>
                                                    Previously uploaded combined identification document:
                                                </p>
                                                <UploadField
                                                    documentType="Driving License / State ID / SSC"
                                                    documentsList={data?.documents}
                                                    onUploadSuccess={fetchOnboardingData}
                                                    mandatory={false}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* 7. Highest Education Qualification (Degree Certification / Transcript) */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>7. Highest Education Qualification (Degree Certification / Transcript)</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your highest education qualification degree certificate or transcript.</p>
                                    </div>
                                    <UploadField documentType="Highest Education Qualification (Degree Certificate/Transcript)" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
                                </div>

                                {/* 8. Professional Certificate / Licenses */}
                                <div style={{ marginBottom: '2rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1.5rem' }}>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>8. Professional Certificate / Licenses</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload your professional certification or licenses (optional).</p>
                                    </div>
                                    <UploadField documentType="Professional Certificate / Licenses" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={false} />
                                </div>

                                {/* 9. Other */}
                                <div>
                                    <div style={{ padding: '0 0.5rem', marginBottom: '0.5rem' }}>
                                        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: 0, color: 'var(--text-primary)' }}>9. Other</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>Upload any additional supporting documents or records.</p>
                                    </div>
                                    <UploadField documentType="Other Documents" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} />
                                </div>
                            </>
                        )}
                    </div>
                );
            })()}


            {/* OFFER LETTER TAB */}
            {activeTab === 'offer' && (
                <div className="card fade-in">
                    <div className="card-title">Offer Letter Acceptance</div>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
                        Verify and electronically sign your hiring offer letter.
                    </p>

                    <div className="agreements-document-grid">
                        {/* Left side: Pre-signed badge & signature drawer */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                            <div
                                style={{
                                    border: '1px solid var(--border-color)',
                                    borderRadius: 'var(--border-radius-md)',
                                    padding: '1.5rem',
                                    backgroundColor: 'var(--bg-secondary)',
                                    boxShadow: 'var(--shadow-sm)',
                                    fontSize: '0.825rem'
                                }}
                            >
                                <h4 style={{ fontWeight: 'bold', marginBottom: '0.75rem', color: 'var(--primary)' }}>Authorized Representative Signature</h4>
                                <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', marginBottom: '0.5rem' }}>
                                    <span style={{ fontSize: '1.5rem' }}>✍️</span>
                                    <div>
                                        <strong>Neeta Shrikant Sangvikar</strong>
                                        <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>Director HR, Genesis Tech Engineers</div>
                                    </div>
                                </div>
                                <div style={{ fontSize: '0.75rem', color: 'var(--success)', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.25rem', marginTop: '0.5rem' }}>
                                    <span>✓</span> Document pre-signed by Employer
                                </div>
                            </div>

                            {data?.signature_history?.some(h => h.document_type === 'Offer Letter' && h.action === 'SIGN') ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                    <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1.25rem', borderRadius: 'var(--border-radius-sm)', fontSize: '0.85rem' }}>
                                        🚀 <strong>Offer Letter Signed</strong>: You accepted and electronically signed this Offer Letter on {new Date(data.signature_history.find(h => h.document_type === 'Offer Letter' && h.action === 'SIGN').signed_at).toLocaleString()}.
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            style={{ width: '100%', padding: '0.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
                                            onClick={() => handleDownloadPdf(offerLetterBlobUrl, `offer_letter_${(employee?.FirstName || 'employee').toLowerCase()}_${(employee?.LastName || 'signed').toLowerCase()}_signed.pdf`)}
                                        >
                                            📥 Download Signed Offer Letter
                                        </button>

                                    </div>
                                </div>
                            ) : (
                                !isLocked && <SignaturePad onSave={(sig) => handleDocumentSign('Offer Letter', sig)} />
                            )}
                        </div>

                        {/* Right side: The PDF/Base64 Preview from Database */}
                        <div>
                            {offerLetterBlobUrl ? (
                                <div style={{ border: '2px solid #334155', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow-md)', backgroundColor: 'var(--bg-secondary)' }}>
                                    <div className="mobile-helper-banner" style={{
                                        padding: '0.75rem 1rem',
                                        backgroundColor: 'var(--bg-tertiary)',
                                        borderBottom: '1px solid var(--border-color)',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: '0.5rem'
                                    }}>
                                        <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
                                            📱 Reading on Mobile?
                                        </span>
                                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
                                                onClick={() => handleViewPdf(offerLetterBlobUrl, 'offer_letter.pdf')}
                                            >
                                                📂 Open Fullscreen & Zoom
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
                                                onClick={() => handleDownloadPdf(offerLetterBlobUrl, 'offer_letter.pdf')}
                                            >
                                                📥 Download PDF
                                            </button>
                                        </div>
                                    </div>
                                    <iframe
                                        src={`${offerLetterBlobUrl}#toolbar=0&navpanes=0&view=FitH`}
                                        className="document-iframe"
                                        style={{ height: "750px" }}
                                        title="Offer Letter PDF Viewer"
                                    />
                                </div>
                            ) : (
                                <div className="document-text-preview">
                                    {/* Header */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', borderBottom: '2px solid #000000', paddingBottom: '0.75rem', marginBottom: '1.5rem' }}>
                                        {/* Green Logo SVG */}
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', minWidth: '95px' }}>
                                            <svg width="45" height="45" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="50" cy="50" r="38" stroke="#16a34a" strokeWidth="6" strokeDasharray="10 5" />
                                                <circle cx="50" cy="50" r="22" fill="#16a34a" opacity="0.8" />
                                                <path d="M50 10 L56 26 L44 26 Z" fill="#16a34a" />
                                                <path d="M50 90 L56 74 L44 74 Z" fill="#16a34a" />
                                                <path d="M10 50 L26 56 L26 44 Z" fill="#16a34a" />
                                                <path d="M90 50 L74 56 L74 44 Z" fill="#16a34a" />
                                            </svg>
                                            <span style={{ fontSize: '0.6rem', fontWeight: '800', color: '#16a34a', lineHeight: 1.1, marginTop: '0.25rem' }}>GENESIS TECH</span>
                                            <span style={{ fontSize: '0.6rem', fontWeight: '800', color: '#16a34a', lineHeight: 1.0 }}>ENGINEERS</span>
                                            <span style={{ fontSize: '0.35rem', fontWeight: '600', color: '#16a34a', marginTop: '0.1rem', letterSpacing: '0.02em', textTransform: 'uppercase' }}>Making Engineering Sustainable</span>
                                        </div>

                                        {/* Header details */}
                                        <div style={{ flex: 1, textAlign: 'center' }}>
                                            <h2 style={{ fontSize: '1.25rem', fontWeight: '800', color: '#000000', margin: '0 0 0.25rem 0', letterSpacing: '0.02em' }}>GENESIS TECH ENGINEERS PVT. LTD.</h2>
                                            <p style={{ fontSize: '0.55rem', color: '#334155', margin: '0 0 0.25rem 0', fontWeight: '700', lineHeight: 1.3 }}>
                                                REGISTERED ADDRESS : PLOT NO 5, GOKUL SOCIETY, DATTAWADI, SADASHIV PETH, PUNE CITY, PUNE - 411030. MH, INDIA.
                                            </p>
                                            <p style={{ fontSize: '0.55rem', color: '#334155', margin: 0, fontWeight: '700' }}>
                                                GST #: <span style={{ color: '#000000' }}>27AAKCG7985R1ZB</span> &nbsp;|&nbsp; PAN #: <span style={{ color: '#000000' }}>AAKCG7985R</span> &nbsp;|&nbsp; Contact: <span style={{ color: '#000000' }}>+91-8983260210</span>
                                            </p>
                                            <p style={{ fontSize: '0.55rem', color: '#334155', margin: '0.15rem 0 0 0', fontWeight: '700' }}>
                                                Website: <a href="http://www.genesistech.co.in" target="_blank" rel="noreferrer" style={{ color: '#2563eb', textDecoration: 'none' }}>www.genesistech.co.in</a> &nbsp; E-mail: <a href="mailto:contact@genesistech.co.in" style={{ color: '#2563eb', textDecoration: 'none' }}>contact@genesistech.co.in</a>
                                            </p>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', fontSize: '0.8rem', color: '#475569' }}>
                                        <span>Document ID: GTE-OL-{1000 + (employee.id || 1)}</span>
                                        <span>Date: {employee.JoiningDate || '28/7/2026'}</span>
                                    </div>

                                    <h3 style={{ fontSize: '1rem', fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase', marginBottom: '1.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.5rem' }}>
                                        JOB OFFER LETTER
                                    </h3>

                                    <p style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
                                        Dear {employee.FirstName} {employee.LastName},
                                    </p>

                                    <p style={{ marginBottom: '1.25rem' }}>
                                        We are delighted to offer you the role at Genesis Tech Engineers Pvt. Ltd. You are an outstanding applicant, and we believe that your skills and experience make you an excellent addition to the team. Below, you will find more information about the role, compensation, and some of the amazing benefits available to you when you join Genesis Tech Engineers Pvt. Ltd. Please also refer to the enclosed General Terms & Conditions of Employment where you will find further information on your employment, including information on your right to work in India and pre-employment checks.
                                    </p>

                                    <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.25rem', marginBottom: '0.5rem' }}>1. Your Job:</h4>
                                    <ul style={{ listStyleType: 'none', paddingLeft: 0, marginBottom: '1.25rem', display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                                        <li><strong>Role:</strong> {employee.Designation || 'Software Development Engineer'}</li>
                                        <li><strong>Office Location:</strong> DNK SQUARE, 14th Floor, Office 1401, 1406, Airport Road, Sakore Nagar, Viman Nagar, Pune, Maharashtra - 411014</li>
                                        <li><strong>Start Date:</strong> {employee.JoiningDate || '2026-08-08'}</li>
                                        <li><strong>Work Model:</strong> Work from Office</li>
                                        <li><strong>Office timing:</strong> 9.30am - 12.30am</li>
                                        <li><strong>Employee ID:</strong> -</li>
                                    </ul>

                                    <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.25rem', marginBottom: '0.5rem' }}>2. Pay:</h4>
                                    <p style={{ marginBottom: '1.25rem' }}>
                                        Your annual CTC is <strong>{employee.OfferedCTC || 'As agreed'}</strong> which shall be payable monthly in arrears on or about the payroll cut-off of each month directly into your nominated bank account. If your employment commencement date is on or before the payroll cutoff of the month, you will receive your first month's pay on the month's payday of when your employment commences.
                                    </p>

                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', borderTop: '1px dashed #cbd5e1', paddingTop: '1.5rem', marginTop: '2rem' }}>
                                        <p><strong>Employee Sign:</strong> ___________________________</p>
                                        <p><strong>Employee Name:</strong> {employee.FirstName} {employee.LastName}</p>
                                        <p><strong>Date:</strong> ___________________________</p>
                                    </div>

                                    <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                        <p><strong>For: Genesis Tech Engineers Pvt. Ltd.</strong></p>
                                        <div style={{ fontSize: '1rem', fontStyle: 'italic', color: 'var(--primary)', margin: '0.25rem 0' }}>Neeta</div>
                                        <p><strong>Name:</strong> NEETA SHRIKANT SANGVIKAR</p>
                                        <p><strong>Designation:</strong> DIRECTOR HR</p>
                                    </div>

                                    <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', marginTop: '2rem', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
                                        [Page 1 of 1]
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* EMPLOYEE AGREEMENT TAB */}
            {activeTab === 'agreement' && (() => {
                const country = employee?.country || '';
                const isUsa = country.toUpperCase() === 'USA';
                const agreementsList = isUsa ? [
                    { key: 'employment_agreement', title: 'Employment Agreement 1', displayName: 'Employment Agreement', path: '/Employment Agreement 1.pdf', desc: 'Verify and electronically sign your formal Employment Agreement.' },
                    { key: 'confidentiality_nda', title: 'Employee Confidentiality & NDA (1)', displayName: 'Employee Confidentiality & NDA', path: '/Employee Confidentiality & NDA (1).pdf', desc: 'Electronically sign the Corporate Non-Disclosure Agreement.' },
                    { key: 'conflict_of_interest', title: 'Conflict of interest agreement', path: '/Conflict of interest agreement.pdf', desc: 'Sign the Conflict of Interest policy compliance statement.' },
                    { key: '401k_dental_vision_medical', title: '401K Dental Vision Medical', path: '/401K Dental Vision Medical.pdf', desc: 'Acknowledge details of the 401K and healthcare benefit details.' },
                    { key: 'non_solicitation', title: 'Non Solicitation', path: '/Non Solicitation.pdf', desc: 'Sign the Non-Solicitation Agreement.' }
                ] : [
                    { key: 'employee_agreement', title: 'Employee Agreement', path: '/3-Employment Agreement.pdf', desc: 'Verify and electronically sign your formal Employment Agreement.' }
                ];

                const isAgreementSigned = (title) => {
                    return data?.signature_history?.some(h => h.document_type === title && h.action === 'SIGN');
                };

                const getSignatureDate = (title) => {
                    const sig = data?.signature_history?.find(h => h.document_type === title && h.action === 'SIGN');
                    return sig ? new Date(sig.signed_at).toLocaleString() : '';
                };

                const activeAgreement = agreementsList.find(a => a.key === selectedAgreementKey) || agreementsList[0];
                const activeBlobUrl = agreementBlobUrls[activeAgreement?.key] || activeAgreement?.path;

                const signedCount = agreementsList.filter(item => isAgreementSigned(item.title)).length;
                const totalCount = agreementsList.length;
                const progressPercentage = Math.round((signedCount / totalCount) * 100);

                return (
                    <div className="card fade-in">
                        <div className="card-title">Employee Agreement Acceptance</div>
                        <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
                            {isUsa
                                ? "Please review and electronically sign all 5 required agreements to complete your onboarding."
                                : "Verify and electronically sign your formal Employment Agreement."}
                        </p>

                        {/* SLEEK PROGRESS CARD FOR USA */}
                        {isUsa && (
                            <div style={{
                                marginBottom: '1.5rem',
                                padding: '1rem 1.25rem',
                                borderRadius: '8px',
                                background: 'linear-gradient(135deg, rgba(79, 70, 229, 0.04) 0%, rgba(99, 102, 241, 0.04) 100%)',
                                border: '1px solid rgba(79, 70, 229, 0.1)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                                gap: '1rem'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                    <span style={{ fontSize: '1.5rem' }}>📋</span>
                                    <div>
                                        <div style={{ fontSize: '0.875rem', fontWeight: 'bold', color: 'var(--text-primary)' }}>
                                            Employee Agreement Packages Signature Status
                                        </div>
                                        <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '0.15rem' }}>
                                            {signedCount} of {totalCount} signed
                                        </div>
                                    </div>
                                </div>
                                <div style={{ flex: '1 1 200px', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                    <div style={{ flex: 1, height: '8px', backgroundColor: 'rgba(79, 70, 229, 0.1)', borderRadius: '4px', overflow: 'hidden' }}>
                                        <div style={{ width: `${progressPercentage}%`, height: '100%', backgroundColor: 'var(--primary)', transition: 'width 0.4s ease' }} />
                                    </div>
                                    <span style={{ fontSize: '0.875rem', fontWeight: 'bold', color: 'var(--primary)' }}>
                                        {progressPercentage}%
                                    </span>
                                </div>
                            </div>
                        )}

                        {/* HORIZONTAL SELECTOR TABS */}
                        <div className="agreements-horizontal-tabs">
                            {agreementsList.map((item) => {
                                const signed = isAgreementSigned(item.title);
                                const active = selectedAgreementKey === item.key;
                                return (
                                    <div
                                        key={item.key}
                                        onClick={() => setSelectedAgreementKey(item.key)}
                                        className={`agreement-tab-item ${active ? 'active' : ''}`}
                                    >
                                        <div className="agreement-tab-title">{item.displayName || item.title}</div>
                                        <div className="agreement-tab-status">
                                            {signed ? (
                                                <span style={{ color: 'var(--success)', fontWeight: 600 }}>✓ Signed</span>
                                            ) : (
                                                <span style={{ color: '#d97706', fontWeight: 600 }}>⏳ Pending</span>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* CORE VIEW / SIGN FLOW - DUAL COLUMN GRID: INPUTS LEFT, PDF RIGHT */}
                        <div className="agreements-document-grid">
                            {/* Right Column: Signature Signoff area */}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                                <div
                                    style={{
                                        border: '1px solid var(--border-color)',
                                        borderRadius: 'var(--border-radius-md)',
                                        padding: '1.5rem',
                                        backgroundColor: 'var(--bg-secondary)',
                                        boxShadow: 'var(--shadow-sm)',
                                        fontSize: '0.825rem'
                                    }}
                                >
                                    <h4 style={{ fontWeight: 'bold', marginBottom: '0.75rem', color: 'var(--primary)' }}>Authorized Representative Signature</h4>
                                    <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', marginBottom: '0.5rem' }}>
                                        <span style={{ fontSize: '1.5rem' }}>✍️</span>
                                        <div>
                                            <strong>Neeta Shrikant Sangvikar</strong>
                                            <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>Director HR, Genesis Tech Engineers</div>
                                        </div>
                                    </div>
                                    <div style={{ fontSize: '0.75rem', color: 'var(--success)', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.25rem', marginTop: '0.5rem' }}>
                                        <span>✓</span> Document pre-signed by Employer
                                    </div>
                                </div>





                                {selectedAgreementKey === 'conflict_of_interest' && !isAgreementSigned(activeAgreement?.title) && (
                                    <div
                                        style={{
                                            border: '1px solid var(--border-color)',
                                            borderRadius: 'var(--border-radius-md)',
                                            padding: '1.5rem',
                                            backgroundColor: 'var(--bg-secondary)',
                                            boxShadow: 'var(--shadow-sm)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '1rem'
                                        }}
                                    >
                                        <h4 style={{ fontWeight: 'bold', color: 'var(--primary)', margin: 0, fontSize: '0.95rem' }}>Conflict of Interest Info</h4>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', margin: 0 }}>
                                            Please fill out the details below. They will be dynamically updated in your Conflict of Interest PDF.
                                        </p>




                                        {/* A. Outside Employment */}
                                        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem', marginTop: '0.25rem' }}>
                                            <label style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>A. Outside Employment</label>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="outsideEmploymentType"
                                                        value="none"
                                                        checked={employmentForm.outsideEmploymentType === 'none'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, outsideEmploymentType: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    I am not employed by any other employer.
                                                </label>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="outsideEmploymentType"
                                                        value="has_employment"
                                                        checked={employmentForm.outsideEmploymentType === 'has_employment'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, outsideEmploymentType: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    I currently have outside employment.
                                                </label>
                                            </div>
                                        </div>

                                        {employmentForm.outsideEmploymentType === 'has_employment' && (
                                            <div style={{ paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem', borderLeft: '2px solid var(--primary-light)' }}>
                                                <div className="form-group" style={{ margin: 0 }}>
                                                    <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Employer / Business</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={employmentForm.outsideEmployer}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, outsideEmployer: e.target.value })}
                                                        disabled={isLocked}
                                                        style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
                                                    />
                                                </div>
                                                <div className="form-group" style={{ margin: 0 }}>
                                                    <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Nature of Work</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={employmentForm.outsideNature}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, outsideNature: e.target.value })}
                                                        disabled={isLocked}
                                                        style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
                                                    />
                                                </div>
                                                <div className="form-group" style={{ margin: 0 }}>
                                                    <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Hours Worked</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={employmentForm.outsideHours}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, outsideHours: e.target.value })}
                                                        disabled={isLocked}
                                                        style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {/* B. Ownership of Other Businesses */}
                                        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
                                            <label style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>B. Ownership of Other Businesses</label>
                                            <span style={{ fontSize: '0.7rem', display: 'block', marginBottom: '0.4rem', color: 'var(--text-secondary)' }}>Do you own or have an interest in any business?</span>
                                            <div style={{ display: 'flex', gap: '1rem' }}>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="ownershipType"
                                                        value="no"
                                                        checked={employmentForm.ownershipType === 'no'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, ownershipType: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    No
                                                </label>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="ownershipType"
                                                        value="yes"
                                                        checked={employmentForm.ownershipType === 'yes'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, ownershipType: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    Yes
                                                </label>
                                            </div>
                                        </div>

                                        {employmentForm.ownershipType === 'yes' && (
                                            <div className="form-group" style={{ margin: 0, paddingLeft: '1rem', borderLeft: '2px solid var(--primary-light)' }}>
                                                <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>If yes, describe:</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={employmentForm.ownershipDescribe}
                                                    onChange={(e) => setEmploymentForm({ ...employmentForm, ownershipDescribe: e.target.value })}
                                                    disabled={isLocked}
                                                    style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
                                                />
                                            </div>
                                        )}

                                        {/* C. Competing Activities */}
                                        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
                                            <label style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>C. Competing Activities</label>
                                            <span style={{ fontSize: '0.7rem', display: 'block', marginBottom: '0.4rem', color: 'var(--text-secondary)' }}>Are you involved in any competing activities?</span>
                                            <div style={{ display: 'flex', gap: '1rem' }}>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="competingType"
                                                        value="no"
                                                        checked={employmentForm.competingType === 'no'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, competingType: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    No
                                                </label>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="competingType"
                                                        value="yes"
                                                        checked={employmentForm.competingType === 'yes'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, competingType: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    Yes
                                                </label>
                                            </div>
                                        </div>

                                        {employmentForm.competingType === 'yes' && (
                                            <div className="form-group" style={{ margin: 0, paddingLeft: '1rem', borderLeft: '2px solid var(--primary-light)' }}>
                                                <label className="form-label" style={{ fontSize: '0.7rem', fontWeight: 600 }}>If yes, explain:</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={employmentForm.competingDescribe}
                                                    onChange={(e) => setEmploymentForm({ ...employmentForm, competingDescribe: e.target.value })}
                                                    disabled={isLocked}
                                                    style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem' }}
                                                />
                                            </div>
                                        )}

                                        {/* D. Other Potential Conflicts */}
                                        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
                                            <label className="form-label" style={{ fontSize: '0.75rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>D. Other Potential Conflicts</label>
                                            <span style={{ fontSize: '0.7rem', display: 'block', marginBottom: '0.4rem', color: 'var(--text-secondary)' }}>Describe any actual or potential conflict circumstances:</span>
                                            <textarea
                                                className="form-control"
                                                rows="2"
                                                value={employmentForm.otherConflicts}
                                                onChange={(e) => setEmploymentForm({ ...employmentForm, otherConflicts: e.target.value })}
                                                disabled={isLocked}
                                                style={{ padding: '0.4rem 0.65rem', fontSize: '0.85rem', resize: 'vertical' }}
                                                placeholder="None (or details here)"
                                            />
                                        </div>
                                    </div>
                                )}

                                {selectedAgreementKey === '401k_dental_vision_medical' && !isAgreementSigned(activeAgreement?.title) && (
                                    <div
                                        style={{
                                            border: '1px solid var(--border-color)',
                                            borderRadius: 'var(--border-radius-md)',
                                            padding: '1.75rem',
                                            backgroundColor: 'var(--bg-secondary)',
                                            boxShadow: 'var(--shadow-sm)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '1.25rem'
                                        }}
                                    >
                                        <h4 style={{ fontWeight: 'bold', color: 'var(--primary)', margin: 0, fontSize: '1rem', borderBottom: '2px solid var(--primary)', paddingBottom: '0.5rem' }}>
                                            401K Dental Vision Medical Enrollment Form
                                        </h4>

                                        <div style={{ backgroundColor: 'var(--bg-primary)', padding: '0.75rem 1rem', borderRadius: 'var(--border-radius-sm)', borderLeft: '3px solid var(--primary)' }}>
                                            <h5 style={{ fontWeight: 'bold', fontSize: '0.8rem', margin: '0 0 0.25rem 0', color: 'var(--text-primary)' }}>Instructions</h5>
                                            <p style={{ fontSize: '0.72rem', color: 'var(--text-secondary)', margin: 0, lineHeight: 1.4 }}>
                                                Please complete this form to enroll in the Company's employee benefit programs. Enrollment is subject to eligibility requirements, applicable plan documents, insurance carrier rules, and Company policies.
                                            </p>
                                        </div>



                                        {/* Section 1 – Medical Insurance */}
                                        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
                                            <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
                                                Section 1 – Medical Insurance
                                            </label>
                                            <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
                                                Enrolment Election
                                            </span>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginBottom: '0.5rem' }}>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="medicalElection"
                                                        value="enrol"
                                                        checked={employmentForm.medicalElection === 'enrol'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, medicalElection: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    Enrol
                                                </label>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="medicalElection"
                                                        value="waive"
                                                        checked={employmentForm.medicalElection === 'waive'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, medicalElection: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    Waive Coverage
                                                </label>
                                            </div>
                                        </div>

                                        {employmentForm.medicalElection === 'waive' && (
                                            <div style={{ paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.4rem', borderLeft: '2px solid var(--primary-light)' }}>
                                                <span style={{ fontSize: '0.72rem', color: 'var(--text-secondary)' }}>If waiving medical coverage, reason:</span>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                                                    <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                        <input
                                                            type="radio"
                                                            name="medicalWaiveReason"
                                                            value="spouse_plan"
                                                            checked={employmentForm.medicalWaiveReason === 'spouse_plan'}
                                                            onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
                                                            disabled={isLocked}
                                                        />
                                                        Covered under spouse's employer plan
                                                    </label>
                                                    <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                        <input
                                                            type="radio"
                                                            name="medicalWaiveReason"
                                                            value="another_plan"
                                                            checked={employmentForm.medicalWaiveReason === 'another_plan'}
                                                            onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
                                                            disabled={isLocked}
                                                        />
                                                        Covered under another employer plan
                                                    </label>
                                                    <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                        <input
                                                            type="radio"
                                                            name="medicalWaiveReason"
                                                            value="gov_program"
                                                            checked={employmentForm.medicalWaiveReason === 'gov_program'}
                                                            onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
                                                            disabled={isLocked}
                                                        />
                                                        Covered under government program
                                                    </label>
                                                    <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                        <input
                                                            type="radio"
                                                            name="medicalWaiveReason"
                                                            value="other"
                                                            checked={employmentForm.medicalWaiveReason === 'other'}
                                                            onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReason: e.target.value })}
                                                            disabled={isLocked}
                                                        />
                                                        Other:
                                                    </label>
                                                </div>
                                                {employmentForm.medicalWaiveReason === 'other' && (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={employmentForm.medicalWaiveReasonOther}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, medicalWaiveReasonOther: e.target.value })}
                                                        disabled={isLocked}
                                                        placeholder="Specify other reason..."
                                                        style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem', marginTop: '0.2rem' }}
                                                    />
                                                )}
                                            </div>
                                        )}

                                        {/* Section 2 – Dental Insurance */}
                                        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
                                            <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
                                                Section 2 – Dental Insurance
                                            </label>
                                            <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
                                                Enrolment Election
                                            </span>
                                            <div style={{ display: 'flex', gap: '1rem' }}>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="dentalElection"
                                                        value="enrol"
                                                        checked={employmentForm.dentalElection === 'enrol'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, dentalElection: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    Enrol
                                                </label>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="dentalElection"
                                                        value="waive"
                                                        checked={employmentForm.dentalElection === 'waive'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, dentalElection: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    Waive Coverage
                                                </label>
                                            </div>
                                        </div>

                                        {/* Section 3 – Vision Insurance */}
                                        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
                                            <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
                                                Section 3 – Vision Insurance
                                            </label>
                                            <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
                                                Enrolment Election
                                            </span>
                                            <div style={{ display: 'flex', gap: '1rem' }}>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="visionElection"
                                                        value="enrol"
                                                        checked={employmentForm.visionElection === 'enrol'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, visionElection: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    Enrol
                                                </label>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="visionElection"
                                                        value="waive"
                                                        checked={employmentForm.visionElection === 'waive'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, visionElection: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    Waive Coverage
                                                </label>
                                            </div>
                                        </div>

                                        {/* Section 4 – 401(k) Retirement Plan Enrolment */}
                                        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
                                            <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
                                                Section 4 – 401(k) Retirement Plan Enrolment
                                            </label>
                                            <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
                                                Participation Election
                                            </span>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginBottom: '0.65rem' }}>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="retirementElection"
                                                        value="participate"
                                                        checked={employmentForm.retirementElection === 'participate'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, retirementElection: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    I elect to participate in the Company's 401(k) Retirement Plan.
                                                </label>
                                                <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                    <input
                                                        type="radio"
                                                        name="retirementElection"
                                                        value="decline"
                                                        checked={employmentForm.retirementElection === 'decline'}
                                                        onChange={(e) => setEmploymentForm({ ...employmentForm, retirementElection: e.target.value })}
                                                        disabled={isLocked}
                                                    />
                                                    I decline participation at this time.
                                                </label>
                                            </div>

                                            {employmentForm.retirementElection === 'participate' && (
                                                <div style={{ paddingLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.65rem', borderLeft: '2px solid var(--primary-light)', marginBottom: '0.75rem' }}>
                                                    <span style={{ fontSize: '0.72rem', fontWeight: 600, color: 'var(--text-primary)' }}>Employee Contribution</span>
                                                    <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Please deduct the following amount from each eligible pay check:</span>
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                                                        <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                            <input
                                                                type="radio"
                                                                name="retirementContributionType"
                                                                value="percentage"
                                                                checked={employmentForm.retirementContributionType === 'percentage'}
                                                                onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionType: e.target.value })}
                                                                disabled={isLocked}
                                                            />
                                                            % of Eligible Compensation
                                                        </label>
                                                        {employmentForm.retirementContributionType === 'percentage' && (
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={employmentForm.retirementContributionPercent}
                                                                onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionPercent: e.target.value })}
                                                                disabled={isLocked}
                                                                placeholder="%"
                                                                style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem', width: '80px', marginLeft: '1.25rem' }}
                                                            />
                                                        )}
                                                        <label style={{ fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
                                                            <input
                                                                type="radio"
                                                                name="retirementContributionType"
                                                                value="amount"
                                                                checked={employmentForm.retirementContributionType === 'amount'}
                                                                onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionType: e.target.value })}
                                                                disabled={isLocked}
                                                            />
                                                            $ per pay period (if permitted under the Plan)
                                                        </label>
                                                        {employmentForm.retirementContributionType === 'amount' && (
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={employmentForm.retirementContributionAmount}
                                                                onChange={(e) => setEmploymentForm({ ...employmentForm, retirementContributionAmount: e.target.value })}
                                                                disabled={isLocked}
                                                                placeholder="$"
                                                                style={{ padding: '0.3rem 0.5rem', fontSize: '0.8rem', width: '120px', marginLeft: '1.25rem' }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            <div style={{ backgroundColor: 'var(--bg-primary)', padding: '0.75rem', borderRadius: 'var(--border-radius-sm)', border: '1px dashed var(--border-color)', fontSize: '0.7rem', color: 'var(--text-secondary)', lineHeight: 1.4 }}>
                                                <strong style={{ color: 'var(--text-primary)', display: 'block', marginBottom: '0.2rem' }}>Company Matching Contribution</strong>
                                                Genesis Tech Engineers Inc. currently provides a matching contribution of 100% of the Employee's elective deferrals up to a maximum of 2% of the Employee's eligible compensation, subject to the terms of the Company's 401(k) Plan and applicable law.
                                                <div style={{ margin: '0.4rem 0', paddingLeft: '0.5rem', borderLeft: '2px solid var(--primary-light)' }}>
                                                    • Employee contributes 1% → Company contributes 1%<br />
                                                    • Employee contributes 2% → Company contributes 2%<br />
                                                    • Employee contributes 5% → Company contributes 2% (maximum Company match)
                                                </div>
                                                Employee contributions above 2% are permitted (subject to the Plan), but will not receive additional Company matching contributions beyond the 2% maximum.<br />
                                                Company matching contributions are subject to the official Plan Document and may be modified, suspended, or terminated by the Company in accordance with applicable law and the Plan.
                                            </div>
                                        </div>

                                        {/* Section 5 – Beneficiary Designation */}
                                        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
                                            <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
                                                Section 5 – Beneficiary Designation
                                            </label>

                                            {/* Primary Beneficiary */}
                                            <div style={{ marginBottom: '0.75rem', border: '1px solid var(--border-color)', padding: '0.75rem', borderRadius: 'var(--border-radius-sm)', backgroundColor: 'var(--bg-primary)' }}>
                                                <span style={{ fontSize: '0.75rem', fontWeight: 600, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>Primary Beneficiary</span>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                                                    <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
                                                        <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Name:</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={employmentForm.primaryBeneName}
                                                            onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBeneName: e.target.value })}
                                                            disabled={isLocked}
                                                            style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
                                                        />
                                                    </div>
                                                    <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
                                                        <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Relationship:</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={employmentForm.primaryBeneRelationship}
                                                            onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBeneRelationship: e.target.value })}
                                                            disabled={isLocked}
                                                            style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
                                                        />
                                                    </div>
                                                    <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
                                                        <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Date of Birth:</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={employmentForm.primaryBeneDob}
                                                            onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBeneDob: e.target.value })}
                                                            disabled={isLocked}
                                                            style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
                                                        />
                                                    </div>
                                                    <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
                                                        <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Percentage:</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={employmentForm.primaryBenePercent}
                                                            onChange={(e) => setEmploymentForm({ ...employmentForm, primaryBenePercent: e.target.value })}
                                                            disabled={isLocked}
                                                            style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Contingent Beneficiary */}
                                            <div style={{ border: '1px solid var(--border-color)', padding: '0.75rem', borderRadius: 'var(--border-radius-sm)', backgroundColor: 'var(--bg-primary)' }}>
                                                <span style={{ fontSize: '0.75rem', fontWeight: 600, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>Contingent Beneficiary</span>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                                                    <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
                                                        <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Name:</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={employmentForm.contingentBeneName}
                                                            onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBeneName: e.target.value })}
                                                            disabled={isLocked}
                                                            style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
                                                        />
                                                    </div>
                                                    <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
                                                        <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Relationship:</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={employmentForm.contingentBeneRelationship}
                                                            onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBeneRelationship: e.target.value })}
                                                            disabled={isLocked}
                                                            style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
                                                        />
                                                    </div>
                                                    <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
                                                        <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Date of Birth:</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={employmentForm.contingentBeneDob}
                                                            onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBeneDob: e.target.value })}
                                                            disabled={isLocked}
                                                            style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
                                                        />
                                                    </div>
                                                    <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'center' }}>
                                                        <label style={{ fontSize: '0.7rem', fontWeight: 600 }}>Percentage:</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={employmentForm.contingentBenePercent}
                                                            onChange={(e) => setEmploymentForm({ ...employmentForm, contingentBenePercent: e.target.value })}
                                                            disabled={isLocked}
                                                            style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Section 6 – Employee Acknowledgments */}
                                        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
                                            <label style={{ fontSize: '0.8rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem', color: 'var(--primary)' }}>
                                                Section 6 – Employee Acknowledgments
                                            </label>
                                            <span style={{ fontSize: '0.72rem', display: 'block', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '0.4rem' }}>
                                                I acknowledge that:
                                            </span>
                                            <ol style={{ paddingLeft: '1.25rem', margin: 0, fontSize: '0.7rem', color: 'var(--text-secondary)', display: 'flex', flexDirection: 'column', gap: '0.35rem', lineHeight: 1.4 }}>
                                                <li>My eligibility for benefits is subject to the applicable benefit plan documents and Company policies.</li>
                                                <li>Insurance coverage becomes effective only after all eligibility requirements are satisfied and enrollment is approved.</li>
                                                <li>I authorize Genesis Tech Engineers Inc. to deduct any required employee premiums or retirement contributions from my pay check as permitted by law.</li>
                                                <li>I understand that the Company reserves the right to amend, modify, replace, or discontinue any employee benefit plan at any time, subject to applicable law.</li>
                                                <li>I understand that the Company's current 401(k) matching contribution is limited to a maximum of 2% of eligible compensation and that contributions above 2% are not matched by the Company.</li>
                                                <li>I certify that all information provided on this form is accurate and complete.</li>
                                            </ol>
                                        </div>
                                    </div>
                                )}

                                {isAgreementSigned(activeAgreement?.title) ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                        <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1.25rem', borderRadius: 'var(--border-radius-sm)', fontSize: '0.85rem' }}>
                                            🚀 <strong>Agreement Signed</strong>: You accepted and electronically signed this agreement on {getSignatureDate(activeAgreement?.title)}.
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            style={{ width: '100%', padding: '0.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
                                            onClick={() => handleDownloadPdf(activeBlobUrl, `${activeAgreement?.title.toLowerCase().replace(/\s+/g, '_')}_signed.pdf`)}
                                        >
                                            📥 Download Signed {activeAgreement?.displayName || activeAgreement?.title}
                                        </button>
                                    </div>
                                ) : (
                                    !isLocked && <SignaturePad onSave={(sig) => handleDocumentSign(activeAgreement?.title, sig)} />
                                )}
                            </div>

                            <div>
                                {activeBlobUrl ? (
                                    <div style={{ border: '2px solid #334155', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow-md)', backgroundColor: 'var(--bg-secondary)' }}>
                                        <div className="mobile-helper-banner" style={{
                                            padding: '0.75rem 1rem',
                                            backgroundColor: 'var(--bg-tertiary)',
                                            borderBottom: '1px solid var(--border-color)',
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: '0.5rem'
                                        }}>
                                            <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
                                                📱 Reading on Mobile?
                                            </span>
                                            <div style={{ display: 'flex', gap: '0.5rem' }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
                                                    onClick={() => handleViewPdf(activeBlobUrl, `${activeAgreement?.title.toLowerCase().replace(/\s+/g, '_')}.pdf`)}
                                                >
                                                    📂 Open Fullscreen & Zoom
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem', fontWeight: 600 }}
                                                    onClick={() => handleDownloadPdf(activeBlobUrl, `${activeAgreement?.title.toLowerCase().replace(/\s+/g, '_')}.pdf`)}
                                                >
                                                    📥 Download PDF
                                                </button>
                                            </div>
                                        </div>
                                        <iframe
                                            src={`${activeBlobUrl}#toolbar=0&navpanes=0&view=FitH`}
                                            className="document-iframe"
                                            style={{ height: "750px" }}
                                            title={`${activeAgreement?.displayName || activeAgreement?.title} PDF Viewer`}
                                        />
                                    </div>
                                ) : (
                                    selectedAgreementKey !== 'employment_agreement' && selectedAgreementKey !== 'employee_agreement' ? (
                                        <div className="document-text-preview" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '3rem' }}>
                                            <span style={{ fontSize: '3rem', marginBottom: '1.25rem' }}>📄</span>
                                            <h4 style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>{activeAgreement?.displayName || activeAgreement?.title}</h4>
                                            <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', maxWidth: '320px' }}>
                                                This onboarding agreement is available. Please view or download the template PDF using the controls above.
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="document-text-preview">

                                            {/* PAGE 1 HEADER */}
                                            <div style={{ textAlign: 'center', borderBottom: '2px solid #0f172a', paddingBottom: '1rem', marginBottom: '1.5rem' }}>
                                                <h2 style={{ fontSize: '1.3rem', fontWeight: 'bold', margin: '0 0 0.5rem 0' }}>GENESIS TECH ENGINEERS PVT. LTD.</h2>
                                                <p style={{ fontSize: '0.7rem', color: '#475569', margin: 0, lineHeight: 1.4 }}>
                                                    REGISTERED ADDRESS : PLOT NO 5, GOKUL SOCIETY, DATTAWADI, SADASHIV PETH, PUNE CITY, PUNE - 411030. MH, INDIA.<br />
                                                    GST #: 27AAKCG7985R1ZB | PAN # : AAKCG7985R | Contact: +91-8983260210<br />
                                                    Website: www.genesistech.co.in | E-mail: contact@genesistech.co.in
                                                </p>
                                            </div>

                                            <h3 style={{ fontSize: '1rem', fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase', marginBottom: '1.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.5rem' }}>
                                                EMPLOYMENT AGREEMENT TERMS & CONDITIONS
                                            </h3>

                                            <p style={{ fontStyle: 'italic', marginBottom: '1.25rem' }}>
                                                This agreement lays down the terms of employment agreed upon by the employer and employee. Whether stated explicitly in the agreement or not, both the employee and the employer have the duty of mutual confidence and trust, and to make only lawful and reasonable demands on each other.
                                            </p>

                                            <p style={{ marginBottom: '1.5rem' }}>
                                                This EMPLOYMENT AGREEMENT (Hereinafter, the “Agreement”) is entered into on this {formatAgreementJoiningDate(employee?.joining_date || employee?.JoiningDate || employee?.joining_Date || employee?.joiningDate || employee?.joining || employee?.hire_date || employee?.HireDate || employmentForm?.hireDate)}
                                            </p>

                                            <p style={{ fontWeight: 'bold', textAlign: 'center', margin: '1rem 0' }}>BY AND BETWEEN</p>

                                            <p style={{ marginBottom: '1rem' }}>
                                                <strong>Genesis Tech Engineers Pvt. Ltd.</strong>, a private limited company incorporated under the Companies Act, 1956, having its registered office at Plot No 5, Shri Gokul Society, Navi Peth, Sadashiv Peth, Pune, 411030. (hereinafter referred to as the “Company” or “Employer”, which expression shall, unless repugnant to the meaning or context hereof, be deemed to include all permitted successors and assigns),
                                            </p>

                                            <p style={{ fontWeight: 'bold', textAlign: 'center', margin: '1rem 0' }}>AND</p>

                                            <p style={{ marginBottom: '1.5rem' }}>
                                                <strong>{employee.FirstName} {employee.LastName}</strong> (hereinafter referred to as the "Employee", which expression shall, unless repugnant to the meaning or context hereof, be deemed to include all permitted successors and assigns).
                                            </p>

                                            <p style={{ marginBottom: '1rem' }}>
                                                <strong>WHEREAS</strong>, the parties hereto desire to enter into this Agreement to define and set forth the terms and conditions of the employment of the Employee by the Company;
                                            </p>

                                            <p style={{ marginBottom: '1.5rem' }}>
                                                <strong>NOW, THEREFORE</strong>, in consideration of the mutual covenants and agreements set forth below, it is hereby covenanted and agreed by the Company and the Employee as follows:
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>1. Interpretation</h4>
                                            <p style={{ marginBottom: '1rem' }}>In this agreement the following terms shall have the following meanings:</p>
                                            <div style={{ marginLeft: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                                                <p>
                                                    <strong>a) “Confidential Information”</strong>: any trade secret or other information which is confidential or commercially sensitive and which is not in the public domain (other than through the wrongful disclosure by the Employee) and which belongs to any Clientele Company (whether stored or recorded in documentary or electronic form) and which (without limitation) relates to the business methods, management systems, marketing plans, strategic plans, finances, new or maturing business opportunities, marketing activities, processes, inventions, designs or similar of any Clientele Company, or to which any Clientele Company owes a duty of confidentiality to any third party and including in particular [Trade Secrets, Intellectual Property, Business Strategies & Plans, Customer and Supplier Information, Employee Information, Technological Information, Financial Information, Contracts and Agreements, Research and Development like experimental data and innovative concepts.];
                                                </p>
                                                <p>
                                                    <strong>b) “The Employment”</strong>: the employment of the Employee by the Company in accordance with the terms of this agreement;
                                                </p>
                                                <p>
                                                    <strong>c) “Clientele Company”</strong>: Clientele Company means the consumer or client of the Genesis Tech Engineers Pvt. Ltd.
                                                </p>
                                                <p>
                                                    <strong>d) “Termination Date”</strong>: the date on which the Employment ceases.
                                                </p>
                                            </div>

                                            <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
                                                [Page 1 of 7]
                                            </div>

                                            {/* PAGE 2 */}
                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>2. Pre-Employment Checks:</h4>
                                            <p style={{ marginBottom: '1rem' }}>
                                                As part of our commitment to maintaining a professional and secure work environment, Genesis Tech Engineers Pvt Ltd conducts pre-employment checks on all prospective employees. These checks are designed to verify the accuracy of information provided during the hiring process and to ensure compliance with company policies and legal requirements. These may include all or any of the following:
                                            </p>
                                            <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                                <li>
                                                    <strong>Background Verification</strong>: This will include the verification of the identity (Adhar Card, PAN Card, Passport, Driving License, etc.), educational qualifications required for the role, professional certifications and the reference provided by the candidates if any.
                                                </li>
                                                <li>
                                                    <strong>Criminal Conviction Check</strong>: Candidate is required to provide character certificate obtained by the nearest police station where the candidate resides.
                                                </li>
                                                <li>
                                                    <strong>Health Declaration or Health Assessment</strong>: Candidate is required to obtain basic full body checkup and candidate is required to submit the reports to at the time of joining the company.
                                                </li>
                                                <li>
                                                    <strong>Employment History</strong>: Proof of employment history via relieving letter provided by your previous employers if any.
                                                </li>
                                            </ul>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>3. Freedom to work:</h4>
                                            <p style={{ marginBottom: '1rem' }}>
                                                As an employee of Genesis Tech Engineers Pvt. Ltd., you are expected to uphold the values and standards of our organization. If at any time during your employment, it is discovered that you are under any court order, contractual agreement, or other legal obligation that may interfere with or inhibit your ability to perform your duties or fulfill your obligations to the company, Genesis Tech Engineers Pvt. Ltd. reserves the right to immediately terminate your employment without further notice or liability.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>4. Term and Bond Period</h4>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>a.</strong> In consideration of the opportunities provided by Genesis Tech Engineers Pvt. Ltd., the employee agrees to a binding commitment to remain in the employment of the company for a period of 2 years from the date of commencement.
                                            </p>

                                            <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
                                                [Page 2 of 7]
                                            </div>

                                            {/* PAGE 3 */}
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>b.</strong> During this period, the employee acknowledges and agrees that they shall not voluntarily terminate their employment or engage in employment with any other entity without explicit prior consent from Genesis Tech Engineers Pvt. Ltd. Any attempt to do so shall be considered a breach of this agreement.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>c.</strong> This commitment is made with the understanding that specialized training, valuable experience, and confidential information will be provided by the company during this period. In the event of a breach, the employee shall be liable for any damage incurred by the company due to their premature departure. Failure to complete the bond duration will result in compensating the amount equal to the remaining duration of the bond period back to the employer.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                                <strong>d.</strong> This clause is binding and enforceable under the applicable laws governing employment agreements.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>5. Performance of Duties</h4>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>a.</strong> The Employee agrees that during the Employment Period, he/she shall devote his/her full business time to the business affairs of the Company and shall perform the duties assigned to him/her faithfully and efficiently, and shall endeavor, to the best of his/her abilities to achieve the goals and adhere to the parameters set by the Company.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>b.</strong> The Employee shall be responsible for:
                                            </p>
                                            <ul style={{ marginLeft: '2.5rem', marginBottom: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                                <li>You must devote the whole time and attention and abilities to the business of Genesis Tech Engineers unless prevented by illness.</li>
                                                <li>Diligently perform such duties as may from time to time be assigned to you.</li>
                                                <li>Comply with all reasonable and lawful directions given to you by Genesis Tech Engineers and your managers.</li>
                                                <li>Act in good faith and in the best interest of Genesis Tech Engineers and its customers and staff always, including reporting your own wrongdoing and any wrongdoing of any other employee immediately on becoming aware of it.</li>
                                                <li>Promote, Protect, Develop, and extend the business of Genesis Tech Engineers.</li>
                                                <li>Take all reasonable steps in respect of the help and safety of yourself, colleagues and third party.</li>
                                            </ul>
                                            <p style={{ marginBottom: '1rem' }}>
                                                A failure to maintain a professional and responsible standard of conduct / behavior, attendance and performance may result in disciplinary action taken against you under the appropriate employment guidelines.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>6. Compensation</h4>
                                            <p style={{ marginBottom: '1rem' }}>Subject to the following provisions of this Agreement, during the Employment Period, the Employee shall be compensated for his services as follows:</p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>a.</strong> The Employee shall receive an annual salary, payable monthly by the Employer. Subject to such increases from time to time, as determined by the Employer. Such payments shall be subject to such normal statutory deductions by the Employer.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>b.</strong> During the term of this Agreement, the Employee's salary shall be paid by means of bank transfer, cheque, or any other method convenient to the Employer, and consented to by the Employee.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                                <strong>c.</strong> All reasonable expenses arising out of employment shall be reimbursed assuming that the same have been authorized prior to being incurred and with the provision of appropriate receipts.
                                            </p>

                                            <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
                                                [Page 3 of 7]
                                            </div>

                                            {/* PAGE 4 */}
                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>7. Obligations of the Employee</h4>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>a.</strong> Upon execution of agreement, the Employee shall not engage in any sort of theft, fraud, misrepresentation, or any other illegal act neither in the employment space nor outside the premise of employment. If he/she shall do so, the Company shall not be liable for such an act done at his/her own risk.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>b.</strong> The Employee further promises to never engage in any theft of the Employer’s property or attempt to defraud the Employer in any manner.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>c.</strong> The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations and policies of the Company as notified from time to time.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>d.</strong> The Employee shall not take up part-time or full-time employment or consultation with any other party or be involved in any other business during the term of his/her employment with the Company.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>e.</strong> On termination employee shall immediately return to employer all documents, books, material, records, correspondence, papers and information (on whatever media and wherever located) relating to employer business or affairs or relating to employer business contacts, any keys, credit cards, access cards and any other property of employer, which is in your possession or under employee’s control.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>f.</strong> The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations and policies of the Company as notified from time to time, including but not limited to Leave Policy and Sexual Harassment Policy.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                                <strong>g.</strong> The Employer hereby prohibits the Employee from engaging in any sexual harassment and the Employee promises to refrain from any form of sexual harassment during employment in and around the premise of employment. If the Employee violates this term in the agreement, he/she shall be fully responsible for his/her actions and the Employer shall not be held responsible for any illegal acts committed at the discretion of the Employee.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>8. Leave Policy</h4>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>a.</strong> The employee is not entitled to any leave during the probation period with an exception to unforeseen conditions/condition out of control. Refer to the employee internal portal GTELinq for guidelines on leaves during probation period.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>b.</strong> The Employee is entitled to 12 days of paid sick leave (SL) in a year, 11 days of earned leave (EL). In addition, the Employee will be entitled to 10 public holidays mentioned under the Leave Policy of the Employer.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>c.</strong> The leaves earned can be carried forward to a maximum of 45 days over the service period.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>d.</strong> Other than the earned leave the Employee may not carry forward or en-cash any holiday to the next holiday year.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>e.</strong> In the event that the Employee is absent from work due to sickness or injury, he/she will follow the Leave Policy and inform the designated person as soon as possible and will provide regular updates as to his/her recovery and as far as practicable will inform the designated person of the Employer of his/her expected date of return to work.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                                <strong>f.</strong> If the Employee is absent from work due to sickness or injury for more than three consecutive days, he/she must submit to the Employer a self-certification form. If such absence lasts for more than three consecutive days the Employee must obtain a medical certificate from his/her doctor and submit it to the employer.
                                            </p>

                                            <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
                                                [Page 4 of 7]
                                            </div>

                                            {/* PAGE 5 */}
                                            <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                                <strong>g.</strong> For any period of absence due to sickness or injury the Employee will be paid statutory sick pay only, if he/she satisfies the relevant requirements.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>9. Assignment</h4>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>a.</strong> The Employee acknowledges that any work including without limitation inventions, designs, ideas, concepts, drawings, working notes, artistic works that the Employee may individually or jointly conceive or develop during the term of Employment are “works made for hire” and to the fullest extent permitted by law, Employee shall assign, and does hereby assign, to the Employer all of Employee's right, title and interest in and to all Intellectual Property improved, developed, discovered or written in such works.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                                <strong>b.</strong> Employee shall, upon request of the Employer, execute, acknowledge, deliver, and file any and all documents necessary or useful to vest in the Employer all of Employee's right, title and interest in and to all such matters.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>10. Confidentiality</h4>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>a.</strong> The Employee acknowledges that, while performing and fulfilling his/her duties here under, he/she may have access to and be entrusted with confidential information concerning the present and contemplated financial status and activities of the Employer, the disclosure of any of which confidential information to the competitors of the Employer would be highly detrimental to the interests of the Employer.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>b.</strong> The Employee further acknowledges and agrees that the right to maintain the confidentiality of trade secrets, source code, website information, business plans or client information or other confidential or proprietary information, for the purpose of enabling the other party such information constitutes a proprietary right which the Employer is entitled to protect.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>c.</strong> Accordingly, the Employee covenants and agrees with the Employer that he/she will not, under any circumstance during the continuance of this agreement, disclose any such confidential information to any person, firm or corporation, nor shall he/she use the same, except as required in the normal course of his/her engagement hereunder, and even after the termination of employment, he/she shall not disclose or make use of the same or cause any of confidential information to be disclosed in any manner.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                                <strong>d.</strong> The Employer owns any intellectual property created by the Employee during employment, or in relation to a certain field, and he/she shall thereon have all the necessary rights to retain it. After termination of employment, Employee shall not impose any rights on the intellectual property created. Any source code, software or other intellectual property developed, including but not limited to website design or functionality that was created by the employee, during employment under this Agreement, shall belong to the Employer.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>11. Amendment and Termination</h4>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>a.</strong> Employer may terminate your employment without any notice.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '0.5rem' }}>
                                                <strong>b.</strong> The Employee may terminate his/her employment by providing the Employer with at least 2-month(s) advance notice of his/her intention to resign.
                                            </p>
                                            <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                                <strong>c.</strong> The Employee may terminate on the last day of the month in which the date of the Employee’s death occurs; or the date on which the Company gives notice to the Employee if such termination is for Cause or Disability.
                                            </p>

                                            <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
                                                [Page 5 of 7]
                                            </div>

                                            {/* PAGE 6 */}
                                            <p style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                                <strong>d.</strong> For purposes of this Agreement, "Cause" means the Employee's gross misconduct resulting in material damage to the Company, willful insubordination or disobedience, theft, fraud or dishonesty, willful damage or loss of Employer’s property, bribery and habitual lateness or absence, or any other willful and material breach of this Agreement.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>12. Restrictive Covenant</h4>
                                            <p style={{ marginBottom: '1rem' }}>
                                                Following the termination of employment of the Employee by the Employer, with or without cause, or the voluntary withdrawal by the Employee from the Employer, the Employee shall, for a period of three years following the said termination or voluntary withdrawal, refrain from either directly or indirectly soliciting or attempting to solicit the business of any client or customer of the Employer for his own benefit or that of any third person or organization, and shall refrain from either directly or indirectly attempting to obtain the withdrawal from the employment by the Employer of any other Employee of the Employer having regard to the same geographic and temporal restrictions. The Employee shall not directly or indirectly divulge any financial information relating to the Employer or any of its affiliates or clients to any person whatsoever.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>13. Indemnification</h4>
                                            <p style={{ marginBottom: '1rem' }}>
                                                The Employee shall indemnify the employer against any and all expenses, including amounts paid upon judgments, counsel fees, environmental penalties and fines, and amounts paid in settlement (before or after suit is commenced), incurred by the employer in connection with his/her defense or settlement of any claim, action, suit or proceeding in which he/she is made a party or which may be asserted against his/her by reason of his/her employment or the performance of duties in this Agreement. Such indemnification shall be in addition to any other rights to which those indemnified may be entitled under any law, by-law, agreement, or otherwise.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>14. Modification</h4>
                                            <p style={{ marginBottom: '1rem' }}>
                                                Any modification of this Agreement or additional obligation assumed by either party in connection with this Agreement shall be binding only if evidenced in writing signed by each party or an authorized representative of each party.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>15. Severability</h4>
                                            <p style={{ marginBottom: '1rem' }}>
                                                Each paragraph of this agreement shall be and remain separate from and independent of and severable from all and any other paragraphs herein except where otherwise indicated by the context of the agreement. The decision or declaration that one or more of the paragraphs are null and void shall have no effect on the remaining paragraphs of this agreement.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>16. Paragraph headings</h4>
                                            <p style={{ marginBottom: '1rem' }}>
                                                The titles to the paragraphs of this Agreement are solely for the convenience of the parties and shall not be used to explain, modify, simplify, or aid in the interpretation of the provisions of this Agreement.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>17. Applicable Law and Jurisdiction</h4>
                                            <p style={{ marginBottom: '1rem' }}>
                                                This Agreement shall be governed by and construed in accordance with the laws of India. Each party hereby irrevocably submits to the exclusive jurisdiction of the courts of Pune. For the adjudication of any dispute hereunder or in connection herewith.
                                            </p>

                                            <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
                                                [Page 6 of 7]
                                            </div>

                                            {/* PAGE 7 */}
                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>18. Counterparts</h4>
                                            <p style={{ marginBottom: '1.5rem' }}>
                                                The Agreement may be executed in two or more counterparts, any one of which shall be deemed the original without reference to the others.
                                            </p>

                                            <p style={{ marginBottom: '1.5rem' }}>
                                                <strong>IN WITNESS WHEREOF</strong>, the Employee has hereunto set his hand, and the Company has caused these presents to be executed in its name and on its behalf, all as of the day and year first above written.
                                            </p>

                                            <h4 style={{ fontWeight: 'bold', fontSize: '0.9rem', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: '1px solid #cbd5e1', paddingBottom: '0.25rem' }}>Acceptance</h4>
                                            <p style={{ marginBottom: '2rem' }}>
                                                I have carefully read and accepted all the provisions of this Employment agreement terms and conditions of employment.
                                            </p>

                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', borderTop: '1px dashed #cbd5e1', paddingTop: '1.5rem' }}>
                                                <p><strong>Employee Sign:</strong> ___________________________</p>
                                                <p><strong>Employee Name:</strong> {employee.FirstName} {employee.LastName}</p>
                                                <p><strong>Date:</strong> {formatJoiningDateShort(employee?.joining_date || employee?.JoiningDate || employee?.joining_Date || employee?.joiningDate || employee?.joining || employee?.hire_date || employee?.HireDate || employmentForm?.hireDate)}</p>
                                            </div>

                                            <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                                <p><strong>For: Genesis Tech Engineers Pvt. Ltd.</strong></p>
                                                <div style={{ fontSize: '1rem', fontStyle: 'italic', color: 'var(--primary)', margin: '0.25rem 0' }}>Neeta</div>
                                                <p><strong>Name:</strong> NEETA SHRIKANT SANGVIKAR</p>
                                                <p><strong>Designation:</strong> DIRECTOR HR</p>
                                                <p><strong>Date:</strong> {formatJoiningDateShort(employee?.joining_date || employee?.JoiningDate || employee?.joining_Date || employee?.joiningDate || employee?.joining || employee?.hire_date || employee?.HireDate || employmentForm?.hireDate)}</p>
                                            </div>

                                            <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', margin: '2rem 0 0 0', borderTop: '1px dashed #cbd5e1', paddingTop: '0.5rem' }}>
                                                [Page 7 of 7]
                                            </div>

                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* COMPANY POLICIES TAB */}
            {activeTab === 'policies' && (() => {
                const allPoliciesAccepted = genesisPolicies.every(policy => data?.policies?.some(p => p.policy_name === policy.title));
                const activePolicy = genesisPolicies.find(p => p.id === selectedPolicyId);

                // Handle selecting a policy
                const handleSelect = (id) => {
                    setSelectedPolicyId(id);
                    if (id !== 'sign' && !viewedPolicyIds.includes(id)) {
                        setViewedPolicyIds(prev => [...prev, id]);
                    }
                };

                const sidebarItems = [
                    ...genesisPolicies,
                    { id: 'sign', title: 'Acceptance & Sign-off', icon: '✍️' }
                ];

                return (
                    <div className="card fade-in">
                        <div className="card-title" style={{ marginBottom: '1.5rem' }}>Company Policies Review</div>

                        <div className="policies-layout">
                            {/* Left Column: Sidebar List */}
                            <div className="policies-sidebar">
                                {sidebarItems.map((item) => {
                                    const isSelected = selectedPolicyId === item.id;
                                    const isSignTab = item.id === 'sign';
                                    const isChecked = isSignTab
                                        ? allPoliciesAccepted
                                        : (viewedPolicyIds.includes(item.id) || allPoliciesAccepted);

                                    return (
                                        <div
                                            key={item.id}
                                            onClick={() => handleSelect(item.id)}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                padding: '0.85rem 1rem',
                                                borderRadius: '8px',
                                                border: '1px solid var(--border-color)',
                                                backgroundColor: isSelected ? '#0f172a' : 'var(--bg-secondary)',
                                                color: isSelected ? '#ffffff' : 'var(--text-primary)',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                boxShadow: isSelected ? 'var(--shadow-sm)' : 'none'
                                            }}
                                            className={isSelected ? '' : 'policy-sidebar-item-hover'}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                                <span style={{ fontSize: '1.2rem' }}>{item.icon}</span>
                                                <span style={{ fontSize: '0.85rem', fontWeight: isSelected ? '600' : '500' }}>{item.title}</span>
                                            </div>

                                            {/* Checkbox badge */}
                                            <span style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '18px',
                                                height: '18px',
                                                borderRadius: '4px',
                                                backgroundColor: isChecked ? '#10b981' : '#e2e8f0',
                                                color: '#ffffff',
                                                fontSize: '10px',
                                                fontWeight: 'bold',
                                                transition: 'background-color 0.2s'
                                            }}>
                                                {isChecked ? '✓' : ''}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Right Column: Description Panel */}
                            <div className="policies-content">
                                {selectedPolicyId === 'sign' ? (
                                    <div>
                                        <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.5rem', color: 'var(--text-primary)' }}>Acceptance & Sign-off</h3>
                                        <div style={{ borderBottom: '1px solid var(--border-color)', marginBottom: '1.5rem' }}></div>

                                        <p style={{ fontSize: '0.9rem', color: 'var(--text-primary)', marginBottom: '1rem', lineHeight: '1.5' }}>
                                            By drawing or typing your signature below, you certify and confirm that you have read, understood, and agree to abide by all 11 company policies listed on the left:
                                        </p>

                                        <ul style={{ paddingLeft: '1.5rem', fontSize: '0.85rem', color: 'var(--text-secondary)', lineHeight: '1.6', marginBottom: '2rem' }}>
                                            {genesisPolicies.map(p => (
                                                <li key={p.id}>{p.title}</li>
                                            ))}
                                        </ul>

                                        {allPoliciesAccepted ? (
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                                <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1.25rem', borderRadius: 'var(--border-radius-sm)', fontSize: '0.85rem' }}>
                                                    🚀 <strong>Policies Signed & Accepted</strong>: You have read and accepted all company policies. A signed PDF copy has been saved.
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    style={{ width: '100%', padding: '0.75rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
                                                    onClick={handleDownloadPolicies}
                                                >
                                                    📥 Download Signed Policies
                                                </button>
                                            </div>
                                        ) : (
                                            !isLocked && (
                                                <div>
                                                    {viewedPolicyIds.length < genesisPolicies.length ? (
                                                        <div style={{ backgroundColor: 'var(--bg-tertiary)', borderLeft: '4px solid var(--warning)', padding: '1rem', borderRadius: '4px', fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                                                            ⚠️ <strong>Please read all policies</strong>: You must click and review all 11 policies on the left before you can sign. (Currently reviewed: {viewedPolicyIds.length}/11)
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <div style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginBottom: '0.75rem' }}>
                                                                Please draw or type your electronic signature below:
                                                            </div>
                                                            <SignaturePad onSave={handlePolicyAccept} />
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        )}
                                    </div>
                                ) : (
                                    activePolicy && (
                                        <div>
                                            <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.5rem', color: 'var(--text-primary)' }}>{activePolicy.title}</h3>
                                            <div style={{ borderBottom: '1px solid var(--border-color)', marginBottom: '1.5rem' }}></div>
                                            <div style={{ color: 'var(--text-primary)', fontSize: '0.9rem', lineHeight: '1.6' }}>
                                                {activePolicy.content}
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* TAX INFORMATION TAB */}
            {activeTab === 'tax' && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '1.5rem', alignItems: 'start' }} className="fade-in">
                    {/* LEFT SIDE: INPUTS & ACTIONS */}
                    <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                        <div className="card-title">Arizona A-4 Tax Withholdings</div>

                        <form onSubmit={(e) => e.preventDefault()} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                            <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 0: Federal & General State Elections</h4>
                            <div className="grid-2">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="fedTaxSelect">Federal Tax Filing Status</label>
                                    <select id="fedTaxSelect" className="form-control" value={taxForm.federal_tax_status} onChange={(e) => setTaxForm({ ...taxForm, federal_tax_status: e.target.value })} disabled={isLocked}>
                                        <option value="SINGLE">Single or Married Filing Separately</option>
                                        <option value="MARRIED">Married Filing Jointly</option>
                                        <option value="HEAD_OF_HOUSEHOLD">Head of Household</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="fedAllowancesInput">Federal Allowances / Dependents</label>
                                    <input type="number" id="fedAllowancesInput" className="form-control" value={taxForm.federal_allowances} onChange={(e) => setTaxForm({ ...taxForm, federal_allowances: parseInt(e.target.value) || 0 })} min={0} disabled={isLocked} />
                                </div>
                            </div>

                            <div className="grid-2">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="stateTaxSelect">State Filing Status (General)</label>
                                    <select id="stateTaxSelect" className="form-control" value={taxForm.state_tax_status} onChange={(e) => setTaxForm({ ...taxForm, state_tax_status: e.target.value })} disabled={isLocked}>
                                        <option value="SINGLE">Single</option>
                                        <option value="MARRIED">Married</option>
                                        <option value="EXEMPT">Exempt</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="stateAllowancesInput">State Allowances (General)</label>
                                    <input type="number" id="stateAllowancesInput" className="form-control" value={taxForm.state_allowances} onChange={(e) => setTaxForm({ ...taxForm, state_allowances: parseInt(e.target.value) || 0 })} min={0} disabled={isLocked} />
                                </div>
                            </div>

                            <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

                            <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 1: Arizona Form A-4 Personal Information</h4>

                            <div className="form-group">
                                <label className="form-label" htmlFor="taxName">Full Name</label>
                                <input
                                    type="text"
                                    id="taxName"
                                    className="form-control"
                                    value={taxForm.name}
                                    onChange={(e) => setTaxForm({ ...taxForm, name: e.target.value })}
                                    disabled={isLocked}
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label" htmlFor="taxSSN">Social Security Number</label>
                                <input
                                    type="text"
                                    id="taxSSN"
                                    className="form-control"
                                    value={taxForm.ssn}
                                    onChange={(e) => setTaxForm({ ...taxForm, ssn: e.target.value })}
                                    disabled={isLocked}
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label" htmlFor="taxAddress">Home Address</label>
                                <input
                                    type="text"
                                    id="taxAddress"
                                    className="form-control"
                                    value={taxForm.address}
                                    onChange={(e) => setTaxForm({ ...taxForm, address: e.target.value })}
                                    disabled={isLocked}
                                />
                            </div>

                            <div className="grid-2">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="taxCity">City or Town</label>
                                    <input
                                        type="text"
                                        id="taxCity"
                                        className="form-control"
                                        value={taxForm.city}
                                        onChange={(e) => setTaxForm({ ...taxForm, city: e.target.value })}
                                        disabled={isLocked}
                                    />
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '0.5rem' }}>
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="taxState">State</label>
                                        <input
                                            type="text"
                                            id="taxState"
                                            className="form-control"
                                            value={taxForm.state}
                                            onChange={(e) => setTaxForm({ ...taxForm, state: e.target.value })}
                                            maxLength={2}
                                            disabled={isLocked}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="taxZip">ZIP Code</label>
                                        <input
                                            type="text"
                                            id="taxZip"
                                            className="form-control"
                                            value={taxForm.zip}
                                            onChange={(e) => setTaxForm({ ...taxForm, zip: e.target.value })}
                                            disabled={isLocked}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

                            <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 2: Withholding Election</h4>

                            <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem', cursor: 'pointer' }} onClick={() => !isLocked && setTaxForm({ ...taxForm, arizona_box_selection: 1 })}>
                                    <input
                                        type="radio"
                                        id="box1"
                                        name="arizona_box_selection"
                                        checked={taxForm.arizona_box_selection === 1}
                                        onChange={() => { }}
                                        disabled={isLocked}
                                        style={{ marginTop: '0.25rem' }}
                                    />
                                    <label htmlFor="box1" style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer' }}>
                                        <strong>Box 1</strong>: Withhold from gross taxable wages at the percentage checked below (check only one percentage):
                                    </label>
                                </div>

                                {taxForm.arizona_box_selection === 1 && (
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem', paddingLeft: '1.5rem', marginTop: '0.25rem' }}>
                                        {[0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5].map((pct) => (
                                            <label key={pct} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.8rem', cursor: 'pointer' }}>
                                                <input
                                                    type="radio"
                                                    name="arizona_percentage"
                                                    checked={taxForm.arizona_percentage === pct}
                                                    onChange={() => !isLocked && setTaxForm({ ...taxForm, arizona_percentage: pct })}
                                                    disabled={isLocked}
                                                />
                                                {pct}%
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem', cursor: 'pointer' }} onClick={() => !isLocked && setTaxForm({ ...taxForm, arizona_box_selection: 2 })}>
                                    <input
                                        type="radio"
                                        id="box2"
                                        name="arizona_box_selection"
                                        checked={taxForm.arizona_box_selection === 2}
                                        onChange={() => { }}
                                        disabled={isLocked}
                                        style={{ marginTop: '0.25rem' }}
                                    />
                                    <label htmlFor="box2" style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer' }}>
                                        <strong>Box 2</strong>: I elect an Arizona withholding percentage of zero, and I certify that I expect to have no Arizona tax liability for the current taxable year.
                                    </label>
                                </div>
                            </div>

                            <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

                            <h4 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0 0 0.5rem 0', color: 'var(--text-primary)' }}>Part 3: Additional Withholding</h4>

                            <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem', cursor: 'pointer' }} onClick={() => !isLocked && setTaxForm({ ...taxForm, arizona_extra_amount_checked: !taxForm.arizona_extra_amount_checked })}>
                                    <input
                                        type="checkbox"
                                        id="chkExtraWH"
                                        checked={taxForm.arizona_extra_amount_checked}
                                        onChange={() => { }}
                                        disabled={isLocked}
                                        style={{ marginTop: '0.25rem' }}
                                    />
                                    <label htmlFor="chkExtraWH" style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer' }}>
                                        Check this box and enter an extra amount to be withheld from each paycheck
                                    </label>
                                </div>

                                {taxForm.arizona_extra_amount_checked && (
                                    <div className="form-group" style={{ paddingLeft: '1.5rem', marginTop: '0.25rem' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                            <span style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>$</span>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="0.00"
                                                value={taxForm.arizona_extra_amount}
                                                onChange={(e) => setTaxForm({ ...taxForm, arizona_extra_amount: e.target.value })}
                                                min={0}
                                                step="0.01"
                                                disabled={isLocked}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </form>

                        <div style={{ borderBottom: '1px solid var(--border-color)', margin: '0.5rem 0' }}></div>

                        {/* Signature Area */}
                        {data?.tax?.signed_at ? (
                            <div style={{ backgroundColor: 'var(--success-light)', borderLeft: '4px solid var(--success)', padding: '1rem', borderRadius: '4px', fontSize: '0.85rem' }}>
                                ✓ <strong>Arizona Form A-4 Electronically Signed</strong>: Signed on {new Date(data.tax.signed_at).toLocaleString()} from IP {data.tax.ip_address}.
                            </div>
                        ) : (
                            !isLocked && (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                                    <SignaturePad onSave={handleApplySignature} onChange={handleApplySignature} />
                                </div>
                            )
                        )}

                        {/* Actions Panel */}
                        <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                            {pdfPreviewUrl && (
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={downloadPdf}
                                    style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
                                >
                                    📥 Download Form
                                </button>
                            )}
                            {!isLocked && !data?.tax?.signed_at && (
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSaveTaxSubmit}
                                    style={{ flex: 1 }}
                                    disabled={!taxForm.signature}
                                >
                                    ✍️ Save & Sign
                                </button>
                            )}
                        </div>
                    </div>

                    {/* RIGHT SIDE: PDF PREVIEW */}
                    <div className="card" style={{ height: 'calc(100vh - 180px)', minHeight: '600px', display: 'flex', flexDirection: 'column', padding: '0.75rem' }}>
                        <div className="card-title" style={{ padding: '0.5rem 0.5rem 1rem 0.5rem', margin: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>Live Form Preview</span>
                            <span style={{ fontSize: '0.75rem', fontWeight: 'normal', color: 'var(--text-tertiary)' }}>Updates automatically as you type</span>
                        </div>

                        <div style={{ flex: 1, backgroundColor: 'var(--bg-tertiary)', borderRadius: 'var(--border-radius-sm)', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                            {pdfPreviewUrl ? (
                                <iframe
                                    src={`${pdfPreviewUrl}#toolbar=0&navpanes=0`}
                                    title="Arizona A-4 Preview"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 'none', display: 'block' }}
                                />
                            ) : (
                                <div style={{ textAlign: 'center', padding: '2rem' }}>
                                    <Loader message="Loading Arizona A-4 Form template..." size="md" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* BANK DETAILS TAB */}
            {activeTab === 'bank' && (
                <div className="card fade-in">
                    <div className="card-title">Direct Deposit Bank Details</div>

                    {/* Top Information Fields */}
                    <div style={{ marginBottom: '1.5rem' }}>
                        <div className="grid-2">
                            <div className="form-group">
                                <label className="form-label" htmlFor="bankNameSelect">Bank Name</label>
                                <input type="text" id="bankNameSelect" className="form-control" value={bankForm.bank_name} onChange={(e) => setBankForm({ ...bankForm, bank_name: e.target.value })} required disabled={isLocked} />
                            </div>
                            <div className="form-group">
                                <label className="form-label" htmlFor="routingNumberInput">Routing Number / IFSC Code</label>
                                <input type="text" id="routingNumberInput" className="form-control" maxLength={20} value={bankForm.routing_number} onChange={(e) => setBankForm({ ...bankForm, routing_number: e.target.value })} required disabled={isLocked} />
                            </div>
                        </div>
                        <div className="grid-2">
                            <div className="form-group">
                                <label className="form-label" htmlFor="accountNumberInput">Account Number</label>
                                <input type="text" id="accountNumberInput" className="form-control" value={bankForm.account_number} onChange={(e) => setBankForm({ ...bankForm, account_number: e.target.value })} required disabled={isLocked} />
                            </div>
                            <div className="form-group">
                                <label className="form-label" htmlFor="accountTypeSelect">Account Type</label>
                                <select
                                    id="accountTypeSelect"
                                    className="form-control"
                                    value={((employee?.country || data?.employee?.country || personalForm?.country || '').toUpperCase()) === 'INDIA' && bankForm.account_type === 'CHECKING' ? 'SAVINGS' : bankForm.account_type}
                                    onChange={(e) => setBankForm({ ...bankForm, account_type: e.target.value })}
                                    disabled={isLocked}
                                >
                                    {((employee?.country || data?.employee?.country || personalForm?.country || '').toUpperCase()) === 'INDIA' ? (
                                        <>
                                            <option value="SAVINGS">Savings</option>
                                            <option value="CURRENT">Current</option>
                                        </>
                                    ) : (
                                        <>
                                            <option value="CHECKING">Checking</option>
                                            <option value="SAVINGS">Savings</option>
                                        </>
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="form-label" htmlFor="bankBranchAddressInput">Bank Branch Address</label>
                            <input type="text" id="bankBranchAddressInput" className="form-control" value={bankForm.bank_branch_address} onChange={(e) => setBankForm({ ...bankForm, bank_branch_address: e.target.value })} required disabled={isLocked} />
                        </div>
                    </div>

                    {/* Upload Cancelled Cheque / Bank Proof Section */}
                    <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1.5rem', marginBottom: '1.5rem' }}>
                        <h4 style={{ fontSize: '0.9rem', marginBottom: '0.25rem', fontWeight: 'bold', color: 'var(--text-primary)' }}>
                            Upload Cancelled Cheque / Bank Account Proof <span style={{ color: 'var(--danger)', marginLeft: '4px' }}>*</span>
                        </h4>
                        <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '0.75rem' }}>
                            Attach one of the following: Last month Statement, voided check with A/C number stated
                        </p>
                        <UploadField documentType="Void Cheque" documentsList={data?.documents} onUploadSuccess={fetchOnboardingData} mandatory={true} />
                    </div>

                    {/* Single Save Details Button at the Bottom */}
                    {!isLocked && (
                        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1.25rem' }}>
                            <button type="button" onClick={handleSaveBank} className="btn btn-primary" style={{ padding: '0.65rem 1.5rem', fontWeight: 600 }}>
                                Save Bank Details
                            </button>
                        </div>
                    )}
                </div>
            )}

            {/* PROFILE PHOTO TAB */}
            {activeTab === 'photo' && (
                <div className="card fade-in">
                    <div className="card-title">Badge Profile Photo</div>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
                        Upload a high-quality professional Photo.
                    </p>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap', position: 'relative' }}>
                        <div
                            style={{
                                width: '150px',
                                height: '150px',
                                borderRadius: '50%',
                                border: '3px solid var(--border-color)',
                                background: badgePhotoPath ? `url(/EOP_api/${badgePhotoPath}) center/cover no-repeat` : 'var(--bg-tertiary)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'var(--text-tertiary)',
                                fontSize: '0.85rem',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                        >
                            {!badgePhotoPath && 'No Picture'}
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', flex: '1 1 300px' }}>
                            {badgePhotoPath ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                                    <p style={{ fontSize: '0.825rem', color: 'var(--text-secondary)', margin: 0 }}>
                                        Profile photo is uploaded. To upload a different photo, please delete the current photo first.
                                    </p>
                                    <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
                                        <a
                                            href={`/EOP_api/${badgePhotoPath}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-secondary"
                                            style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', fontWeight: 600 }}
                                        >
                                            👁️ View Photo
                                        </a>
                                        {!isLocked && (
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                style={{ padding: '0.45rem 1rem', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem', fontWeight: 600 }}
                                                onClick={handleDeletePhoto}
                                                disabled={uploadingPhoto}
                                            >
                                                🗑️ Delete Photo
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                !isLocked && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                        <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-primary)' }}>
                                            Upload Profile Photo:
                                        </label>
                                        <input type="file" className="form-control" accept="image/*" onChange={handlePhotoUpload} disabled={uploadingPhoto} />
                                        <p style={{ color: 'var(--text-tertiary)', fontSize: '0.7rem', margin: 0 }}>JPG, PNG, WEBP (Max 1MB limit)</p>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* REVIEW & SUBMIT TAB */}
            {activeTab === 'submit' && (
                <div className="card fade-in">
                    <div className="card-title">Review & Submit Onboarding Profile</div>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
                        Before submitting, verify that all sections are complete. Submitting locks your profile and moves it to **Pending HR Review** status.
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '2rem' }}>
                        {effectiveDashboardStats?.checklist && Object.entries(effectiveDashboardStats.checklist).map(([key, complete]) => {
                            const label = key.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase());
                            return (
                                <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.5rem 1rem', border: '1px solid var(--border-color)', borderRadius: '4px' }}>
                                    <span>{label}</span>
                                    <strong style={{ color: complete ? 'var(--success)' : 'var(--danger)' }}>
                                        {complete ? '✓ Ready' : '✗ Required'}
                                    </strong>
                                </div>
                            );
                        })}
                    </div>

                    {(() => {
                        const reqDocsList = data?.requested_documents || data?.requested_employee_documents || [];
                        const pendingOrUploadedReqs = reqDocsList.filter(r => {
                            const s = (r.status || '').toUpperCase();
                            return s !== 'SUBMITTED' && s !== 'COMPLETED' && s !== 'APPROVED';
                        });

                        if (isLocked && (pendingOrUploadedReqs.length === 0 || requestedDocsSubmitted)) {
                            return (
                                <div style={{ textAlign: 'center', padding: '1.5rem', backgroundColor: 'var(--bg-tertiary)', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)' }}>
                                    <span style={{ fontSize: '2rem' }}>🔒</span>
                                    <h4 style={{ margin: '0.5rem 0' }}>Profile Locked</h4>
                                    <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>This profile and all requested documents have been submitted to HR.</p>
                                </div>
                            );
                        }

                        return (
                            <button
                                type="button"
                                className="btn btn-primary"
                                style={{ width: '100%', padding: '0.875rem', fontSize: '1rem', display: 'flex', justifyContent: 'center' }}
                                onClick={() => setShowSubmitConfirm(true)}
                                disabled={effectiveDashboardStats?.completed_steps < effectiveDashboardStats?.total_steps}
                            >
                                {isLocked ? 'Submit Updated Requested Documents' : 'Submit Onboarding Profile'}
                            </button>
                        );
                    })()}
                </div>
            )}

            {showSubmitConfirm && createPortal(
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(15, 23, 42, 0.4)',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                    animation: 'fadeIn var(--transition-fast) forwards'
                }}>
                    <div className="glass-card" style={{
                        width: '460px',
                        maxWidth: '90%',
                        padding: '2.5rem 2rem',
                        borderRadius: 'var(--border-radius-lg)',
                        boxShadow: 'var(--shadow-lg)',
                        backgroundColor: 'var(--bg-secondary)',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                        <div style={{
                            width: '64px',
                            height: '64px',
                            borderRadius: '50%',
                            backgroundColor: 'var(--primary-light)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '2rem',
                            marginBottom: '1.25rem',
                            color: 'var(--primary)'
                        }}>
                            🚀
                        </div>
                        <h3 style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            marginBottom: '0.75rem',
                            fontFamily: 'var(--font-heading)',
                            color: 'var(--text-primary)'
                        }}>
                            Submit Onboarding Profile?
                        </h3>
                        <p style={{
                            color: 'var(--text-secondary)',
                            fontSize: '0.9rem',
                            marginBottom: '2rem',
                            lineHeight: '1.6'
                        }}>
                            Are you sure you want to submit your onboarding profile? This will lock all details for HR review and finalize your submission.
                        </p>
                        <div style={{ display: 'flex', gap: '1rem', width: '100%' }}>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                style={{ flex: 1, padding: '0.75rem 1.25rem', fontSize: '0.9rem' }}
                                onClick={() => setShowSubmitConfirm(false)}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                style={{ flex: 1, padding: '0.75rem 1.25rem', fontSize: '0.9rem' }}
                                onClick={() => {
                                    setShowSubmitConfirm(false);
                                    handleSubmitOnboarding();
                                }}
                            >
                                Yes, Submit
                            </button>
                        </div>
                    </div>
                </div>,
                document.body
            )}

            {submitStatus !== 'idle' && createPortal(
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(15, 23, 42, 0.4)',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                    animation: 'fadeIn var(--transition-fast) forwards'
                }}>
                    <div className="glass-card" style={{
                        width: '460px',
                        maxWidth: '90%',
                        padding: '2.5rem 2rem',
                        borderRadius: 'var(--border-radius-lg)',
                        boxShadow: 'var(--shadow-lg)',
                        backgroundColor: 'var(--bg-secondary)',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                        {submitStatus === 'submitting' && (
                            <>
                                <div className="submit-spinner" />
                                <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.5rem', color: 'var(--text-primary)', fontFamily: 'var(--font-heading)' }}>
                                    Submitting Onboarding
                                </h3>
                                <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: '0 0 1rem 0' }}>
                                    Locking your profile and submitting documents to HR...
                                </p>
                                <div className="submit-loader-progress" style={{ width: '100%' }}>
                                    <div className="submit-loader-progress-bar" />
                                </div>
                            </>
                        )}

                        {submitStatus === 'success' && (
                            <>
                                <div className="submit-success-icon">✓</div>
                                <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.75rem', color: 'var(--success)', fontFamily: 'var(--font-heading)' }}>
                                    Successfully Submitted!
                                </h3>
                                <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '2rem', lineHeight: '1.6' }}>
                                    Your onboarding documents and details have been successfully submitted and locked for HR review.
                                </p>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    style={{ width: '100%', padding: '0.75rem 1.25rem', fontSize: '0.9rem' }}
                                    onClick={() => {
                                        setSubmitStatus('idle');
                                        setActiveTab('dashboard');
                                    }}
                                >
                                    Go to Dashboard
                                </button>
                            </>
                        )}

                        {submitStatus === 'error' && (
                            <>
                                <div className="submit-error-icon">✗</div>
                                <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.75rem', color: 'var(--danger)', fontFamily: 'var(--font-heading)' }}>
                                    Submission Failed
                                </h3>
                                <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '2rem', lineHeight: '1.6' }}>
                                    {submitErrorMessage || 'An unexpected error occurred during submission. Please try again.'}
                                </p>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    style={{ width: '100%', padding: '0.75rem 1.25rem', fontSize: '0.9rem', backgroundColor: 'var(--danger)', borderColor: 'var(--danger)' }}
                                    onClick={() => setSubmitStatus('idle')}
                                >
                                    Dismiss & Retry
                                </button>
                            </>
                        )}
                    </div>
                </div>,
                document.body
            )}

            {/* POPUP MODAL FOR HR-REQUESTED DOCUMENTS */}
            {showRequestedDocsModal && (() => {
                const reqList = data?.requested_documents || data?.requested_employee_documents || [];
                const pendingList = reqList.filter(req => {
                    const rStatus = (req.status || '').toUpperCase();
                    const rName = (req.document_name || req.document_type || req.title || req.name || '').trim();
                    const isUploadedInEmpDocs = data?.documents?.some(d => d.document_type === rName);
                    return rStatus !== 'UPLOADED' && !isUploadedInEmpDocs;
                });

                if (pendingList.length === 0) return null;

                return createPortal(
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(15, 23, 42, 0.55)',
                        backdropFilter: 'blur(8px)',
                        WebkitBackdropFilter: 'blur(8px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 99999,
                        animation: 'fadeIn var(--transition-fast) forwards'
                    }}>
                        <div className="glass-card" style={{
                            width: '520px',
                            maxWidth: '92%',
                            padding: '2.5rem 2rem',
                            borderRadius: 'var(--border-radius-lg)',
                            boxShadow: 'var(--shadow-lg)',
                            backgroundColor: 'var(--bg-secondary)',
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(59, 130, 246, 0.12)',
                                border: '2px solid rgba(59, 130, 246, 0.3)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '2rem',
                                marginBottom: '1.25rem',
                                color: 'var(--primary)'
                            }}>
                                📋
                            </div>

                            <h3 style={{
                                fontSize: '1.4rem',
                                fontWeight: '700',
                                marginBottom: '0.5rem',
                                color: 'var(--text-primary)',
                                fontFamily: 'var(--font-heading)'
                            }}>
                                Action Required: Additional Documents Requested
                            </h3>

                            <p style={{
                                color: 'var(--text-secondary)',
                                fontSize: '0.875rem',
                                marginBottom: '1.5rem',
                                lineHeight: '1.5'
                            }}>
                                Management or HR has specifically requested <strong>{pendingList.length}</strong> additional document(s) for your onboarding profile:
                            </p>

                            <div style={{
                                width: '100%',
                                maxHeight: '190px',
                                overflowY: 'auto',
                                backgroundColor: 'var(--bg-tertiary)',
                                borderRadius: 'var(--border-radius-sm)',
                                border: '1px solid var(--border-color)',
                                padding: '1rem',
                                marginBottom: '1.75rem',
                                textAlign: 'left',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '0.75rem'
                            }}>
                                {pendingList.map((req, idx) => {
                                    const name = req.document_name || req.document_type || req.title || req.name || `Requested Document #${idx + 1}`;
                                    const inst = req.instructions || req.comments || req.description || req.note || req.reason || '';
                                    return (
                                        <div key={req.id || idx} style={{ borderBottom: idx < pendingList.length - 1 ? '1px solid var(--border-color)' : 'none', paddingBottom: '0.5rem' }}>
                                            <div style={{ fontWeight: 700, fontSize: '0.9rem', color: 'var(--primary)' }}>
                                                {idx + 1}. {name}
                                            </div>
                                            {inst && (
                                                <div style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', marginTop: '0.2rem' }}>
                                                    Instructions: {inst}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>

                            <button
                                type="button"
                                className="btn btn-primary"
                                style={{ width: '100%', padding: '0.85rem 1.5rem', fontSize: '0.95rem', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
                                onClick={() => {
                                    setShowRequestedDocsModal(false);
                                    setHasSeenRequestedDocsModal(true);
                                    setActiveTab('documents');
                                }}
                            >
                                Proceed to Documents Page →
                            </button>
                        </div>
                    </div>,
                    document.body
                );
            })()}

            {toast && (
                <div className="toast-container">
                    <NotificationToast
                        message={toast.message}
                        type={toast.type}
                        onClose={() => setToast(null)}
                    />
                </div>
            )}
        </div>
    );
};

export default EmployeeDashboard;
